// THIS FILE IS GENERATED, DO NOT EDIT!
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string | number; output: string | number; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Binary data encoded as a base64 string */
  Base64: { input: any; output: any; }
  /** The BigDecimal value, transported as a string */
  BigDecimal: { input: string | number; output: string; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: any; output: any; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: unknown; output: unknown; }
  /** A JSON object (key-value pairs). Arrays and primitives are rejected. */
  JsonHash: { input: any; output: any; }
};

/** Account held by the user. */
export type Account = {
  readonly __typename?: 'Account';
  /** The display name of the account, without the provider name. May not be the official name of the account. */
  readonly accountName: Scalars['String']['output'];
  /** The custodial account number of the account. */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /** Open account sleeves for the account. Sleeves Orion has stopped reporting are hidden. */
  readonly accountSleeves?: Maybe<ReadonlyArray<AccountSleeve>>;
  /** Whether the account is an IRA or personal account */
  readonly accountType?: Maybe<Scalars['String']['output']>;
  /** Active enrollment task if any */
  readonly activeEnrollmentTask?: Maybe<Task>;
  /**
   * The active Savvy fee schedule on the account's household, if any. Distinct
   * from the Orion-sourced billing fields (e.g. orionFeeSchedule,
   * orionBillFrequency).
   */
  readonly activeFeeSchedule?: Maybe<HouseholdFeeSchedule>;
  /** Active swim request if any */
  readonly activeSwimRequest?: Maybe<SwimRequest>;
  /** Available cash (current balance minus pending trade amounts in Created or Processed status). */
  readonly availableCash: Value;
  /** Available credit amount for loan type of accounts - ie PAL */
  readonly availableCredit?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * Bank and credit-card transactions from MoneyKit (debit/credit). Pending rows
   * are included — they are real activity, unlike investment pre-settlement rows.
   */
  readonly bankingTransactions: ReadonlyArray<BankingTransaction>;
  /** List of beneficiaries for the account */
  readonly beneficiaries: ReadonlyArray<Beneficiary>;
  /**
   * Combined cash and money market balance for the account, sourced from
   * denormalized columns. Null when both columns are unset.
   */
  readonly cashAndMoneyMarket?: Maybe<CashAndMoneyMarket>;
  /** Whether a co manager, if they exist, is an account holder */
  readonly coManagerIsAccountHolder?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the account was created this year */
  readonly createdThisYear: Scalars['Boolean']['output'];
  /** Credit limit amount for loan type of accounts - ie PAL */
  readonly creditLimit?: Maybe<Scalars['BigDecimal']['output']>;
  /** The custody status of the account. */
  readonly custody: AccountCustodyName;
  /** Advisor created name for a managed acccount */
  readonly customName?: Maybe<Scalars['String']['output']>;
  /** Advisor created note for a managed acccount */
  readonly customNote?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this account is enrolled in Direct Indexing (product_type ==
   * direct_index). Used to gate Direct Index Report eligibility.
   */
  readonly directIndexing: Scalars['Boolean']['output'];
  /**
   * Whether to label this account as Direct Indexing: the Savvy product, or
   * sub-advised by Orion Custom Indexing. Display only - use directIndexing for
   * report eligibility.
   */
  readonly directIndexingDisplay: Scalars['Boolean']['output'];
  /** The current balance of the account. */
  readonly displayBalance: Value;
  /** The display name of the account, possibly with the provider name. May not be the official name of the account. */
  readonly displayName: Scalars['String']['output'];
  /**
   * Transactions for the account with pending (pre-settlement) rows and reversed
   * rows superseded by a matching complete row hidden — for the client/advisor
   * portfolio view.
   */
  readonly displayableTransactions?: Maybe<ReadonlyArray<Transaction>>;
  /**
   * Balances for ECI accounts, sourced live from Fidelity; null otherwise. Batched
   * across accounts, so safe to select over an account list (e.g. the picker).
   */
  readonly eciBalances?: Maybe<EciBalances>;
  /**
   * Holdings for ECI accounts, sourced live from Fidelity; null otherwise. Batched
   * across accounts, so safe to select over an account list.
   */
  readonly eciHoldings?: Maybe<EciHoldings>;
  /** Whether Orion Eclipse has a model assigned to the account, which is what makes its trades automated */
  readonly eclipseModelManaged: Scalars['Boolean']['output'];
  /** Whether the account is enrolled in a SWIM (Savvy) strategy based on strategy name */
  readonly enrolledInSwimStrategy: Scalars['Boolean']['output'];
  /** Current enrollment status of the account */
  readonly enrollmentStatus: AccountEnrollmentStatus;
  /** The name of the firm associated with this account */
  readonly firmName?: Maybe<Scalars['String']['output']>;
  /** List of Savvy IDs of the funding destinations for this account */
  readonly fundingDestinations: ReadonlyArray<Scalars['ID']['output']>;
  /** List of Savvy IDs of the funding sources for this account */
  readonly fundingSources: ReadonlyArray<Scalars['ID']['output']>;
  /** Whether the account has multiple accounts */
  readonly hasMultipleAccounts?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the account has mutual funds */
  readonly hasMutualFunds?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to hide this portfolio item from client */
  readonly hiddenFromClient?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to hide this portfolio item from net worth and graph */
  readonly hiddenFromNetWorth?: Maybe<Scalars['Boolean']['output']>;
  /** The primary account holder client profile */
  readonly holder?: Maybe<Client>;
  /** List of holdings for the account */
  readonly holdings: ReadonlyArray<Holding>;
  /** The household this account belongs to (via the primary client). */
  readonly household?: Maybe<Household>;
  /** The Savvy ID of the account. */
  readonly id: Scalars['ID']['output'];
  /** If this is a new transfering account, the type of that transfer */
  readonly initialTransferType?: Maybe<InitialTransferTypeName>;
  /** The interest rate of a loan (on top of SOFR) */
  readonly interestRate?: Maybe<Scalars['BigDecimal']['output']>;
  /** The type of IRA the account is. Present only if account_type is IRA */
  readonly iraType?: Maybe<Scalars['String']['output']>;
  /**
   * True for a live-data ECI account (Fidelity-NFS + advisor enabled). Lets the
   * client tell "not ECI" from "ECI, fetch failed" (isEci && eciBalances == null).
   */
  readonly isEci: Scalars['Boolean']['output'];
  /** The timestamp the account was last updated with information from the source provider. */
  readonly lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** External bank accounts authorized for transfers to/from this Savvy-managed account. Filtered to active authorizations. */
  readonly linkedBankAccounts: ReadonlyArray<LinkedBankAccount>;
  /** The provider of a loan, like a PAL */
  readonly loanProvider?: Maybe<Scalars['String']['output']>;
  /** The last 2-4 alphanumeric characters of an account's official account number. */
  readonly mask?: Maybe<Scalars['String']['output']>;
  /**
   * The display name of the account. May not be the official name of the account.
   * @deprecated Name is ambiguous, use display name or account name instead.
   */
  readonly name: Scalars['String']['output'];
  /** The custodian of a new account, for use with the account confirmation flow */
  readonly newAccountCustodian?: Maybe<Scalars['String']['output']>;
  /** Whether an account is a savvy offered (but not managed) product */
  readonly offeredBySavvy: Scalars['Boolean']['output'];
  /** The official name of the account, provided from a source like Plaid. */
  readonly officialName?: Maybe<Scalars['String']['output']>;
  /** The account start date from Orion. */
  readonly orionAccountStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The billing frequency from Orion. */
  readonly orionBillFrequency?: Maybe<Scalars['String']['output']>;
  /** The bill pay method from Orion. */
  readonly orionBillPayMethod?: Maybe<Scalars['String']['output']>;
  /** The bill style from Orion (Arrear/Advance). */
  readonly orionBillStyle?: Maybe<Scalars['String']['output']>;
  /** The account id from Orion Eclipse. */
  readonly orionCustodialAccountId?: Maybe<Scalars['String']['output']>;
  /** The fee schedule name from Orion. */
  readonly orionFeeSchedule?: Maybe<Scalars['String']['output']>;
  /** Information about the performance of a managed account */
  readonly performance?: Maybe<ReadonlyArray<Performance>>;
  /** Type of personal account */
  readonly personalAccountType?: Maybe<Scalars['String']['output']>;
  /** The portfolio the account belongs to */
  readonly portfolio?: Maybe<Portfolio>;
  /** Whether the primary client is an account holder on this account */
  readonly primaryClientIsAccountHolder?: Maybe<Scalars['Boolean']['output']>;
  /** Specific Savvy product type - either Direct Index or Cash Management */
  readonly productType?: Maybe<AccountProductTypeName>;
  /** The Savvy Provider Account associated with the account */
  readonly providerAccount?: Maybe<ProviderAccount>;
  /** The Savvy ID of the provider account associated with the account */
  readonly providerAccountId?: Maybe<Scalars['ID']['output']>;
  /** The URL for the logo of the provider. */
  readonly providerLogoUrl?: Maybe<Scalars['String']['output']>;
  /** Purpose of this account */
  readonly purpose?: Maybe<Scalars['String']['output']>;
  /** Only present if purpose is other */
  readonly purposeOther?: Maybe<Scalars['String']['output']>;
  /** The recurring adjustment bill end date from Orion. */
  readonly recurringAdjustmentBillEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The recurring adjustment bill schedule name from Orion. */
  readonly recurringAdjustmentBillScheduleName?: Maybe<Scalars['String']['output']>;
  /** The recurring adjustment bill start date from Orion. */
  readonly recurringAdjustmentBillStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Registration type, either individual or joint */
  readonly registrationType?: Maybe<Scalars['String']['output']>;
  /** The registration type of the account when other is selected */
  readonly registrationTypeOther?: Maybe<Scalars['String']['output']>;
  /** The sleeve strategy aggregate name from Eclipse for sleeved accounts */
  readonly sleeveStrategyAggregateName?: Maybe<Scalars['String']['output']>;
  /** The source provider. */
  readonly source?: Maybe<ProviderAccountSource>;
  /** Source of the funds for this Account */
  readonly sourceOfFunds?: Maybe<Scalars['String']['output']>;
  /** Only present if source_of_funds is other */
  readonly sourceOfFundsOther?: Maybe<Scalars['String']['output']>;
  /** The unique account identifier from the source provider. */
  readonly sourceProviderId?: Maybe<Scalars['String']['output']>;
  /** Box folder id for uploading account statements into. */
  readonly statementsBoxFolderId?: Maybe<Scalars['String']['output']>;
  readonly status: AccountStatusName;
  /** The id of the PortfolioStrategy the account is associated with */
  readonly strategyId?: Maybe<Scalars['ID']['output']>;
  /** The name of the strategy the account is associated with */
  readonly strategyName?: Maybe<Scalars['String']['output']>;
  /** The type of strategy the account is associated with */
  readonly strategyType?: Maybe<StrategyTypeName>;
  /** The subtype of the account mainly from Plaid, Orion, and Crypto */
  readonly subtype?: Maybe<AccountSubtypeName>;
  /**
   * Raw, unfiltered transactions for the account, including pending and superseded
   * reversed rows — most callers want displayableTransactions instead.
   */
  readonly transactions?: Maybe<ReadonlyArray<Transaction>>;
  /** Box folder id for uploading account trust documents into. */
  readonly trustDocumentsBoxFolderId?: Maybe<Scalars['String']['output']>;
  readonly type: PortfolioItemTypeName;
  /** Whether a voided check is requested for this account */
  readonly voidedCheckRequested?: Maybe<Scalars['Boolean']['output']>;
  /** Box folder id for uploading account voided checks into. */
  readonly voidedChecksBoxFolderId?: Maybe<Scalars['String']['output']>;
};


/** Account held by the user. */
export type AccountHoldingsArgs = {
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Per-account dividends & interest and tax-withholding totals for a single time
 * period, to complement the distributions/contributions/transfers already on
 * Types::Performance.
 */
export type AccountActivityBreakdown = {
  readonly __typename?: 'AccountActivityBreakdown';
  /** The Savvy account ID */
  readonly accountId: Scalars['ID']['output'];
  /** Total dividend and interest income during this time period. */
  readonly dividendsAndInterest?: Maybe<Scalars['BigDecimal']['output']>;
  /** Total federal tax withheld from distributions during this time period. */
  readonly federalTaxWithheld?: Maybe<Scalars['BigDecimal']['output']>;
  /** Total state tax withheld from distributions during this time period. */
  readonly stateTaxWithheld?: Maybe<Scalars['BigDecimal']['output']>;
  /** Total other (non-federal, non-state) tax withheld during this time period. */
  readonly taxesWithheld?: Maybe<Scalars['BigDecimal']['output']>;
  readonly timePeriod?: Maybe<PerformanceTimePeriodName>;
};

/** Information about an account beneficiary */
export type AccountBeneficiaryInput = {
  readonly contactId: Scalars['ID']['input'];
  readonly percentage: Scalars['Float']['input'];
  readonly type: AccountBeneficiaryTypeName;
};

/** Type of account beneficiary */
export const AccountBeneficiaryTypeName = {
  /** contingent */
  Contingent: 'contingent',
  /** primary */
  Primary: 'primary'
} as const;

export type AccountBeneficiaryTypeName = typeof AccountBeneficiaryTypeName[keyof typeof AccountBeneficiaryTypeName];
/** Information about the account for account opening */
export type AccountConfirmationAccountInfoInput = {
  /** Account holder. Could be the primary client or the co-client. Required only for personal individual accounts */
  readonly accountHolder?: InputMaybe<AccountHolder>;
  /** Name of the destination account */
  readonly accountName?: InputMaybe<Scalars['String']['input']>;
  /** Type of the account */
  readonly accountType: AccountOpeningTypeName;
  /** Beneficiaries to associate with the account */
  readonly beneficiaries: ReadonlyArray<AccountBeneficiaryInput>;
  /** Type of the IRA account. Required if account type is IRA */
  readonly iraType?: InputMaybe<IraTypeName>;
  /** Type of the Personal account. Required if account type is Personal */
  readonly personalAccountType?: InputMaybe<PersonalAccountTypeName>;
  /** Purpose of account. Required if account type is Personal */
  readonly purpose?: InputMaybe<AccountPurposeName>;
  /** Description of the purpose when Other is selected */
  readonly purposeOther?: InputMaybe<Scalars['String']['input']>;
  /** Type of the registration. Required if account type is Personal */
  readonly registrationType?: InputMaybe<RegistrationTypeName>;
  /** Source account for transfer of funds (TOA / ACAT) */
  readonly sourceAccount?: InputMaybe<SourceAccountInput>;
  /** Source of funds for the account. Required if account type is Personal */
  readonly sourceOfFunds?: InputMaybe<SourceOfFundsName>;
  /** Description of the source of funds when Other is selected */
  readonly sourceOfFundsOther?: InputMaybe<Scalars['String']['input']>;
};

/** Address information for account opening */
export type AccountConfirmationAddressInfoInput = {
  /** Address line 1 */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Optional address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** Country */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** State */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** Zip code */
  readonly zip?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Client information for account confirmation. Similar to
 * InputObjects::AccountOpeningInputs::ClientInfoInput, but with less required fields
 */
export type AccountConfirmationClientInfoInput = {
  /** 2 letter country code for client citizenship */
  readonly citizenship: Scalars['String']['input'];
  /** Client date of birth. Format: YYYY-MM-DD */
  readonly dob?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Client email */
  readonly email: Scalars['String']['input'];
  /** Client employer name. Required if employment status is employed */
  readonly employerName?: InputMaybe<Scalars['String']['input']>;
  /** Client employment status */
  readonly employmentStatus?: InputMaybe<EmploymentStatusName>;
  /** Client first name */
  readonly firstName: Scalars['String']['input'];
  /** Client home address */
  readonly homeAddress?: InputMaybe<AccountConfirmationAddressInfoInput>;
  /** Client job title. Only required if employment status is employed */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Client last name */
  readonly lastName: Scalars['String']['input'];
  /** Client legal residence if other than USA */
  readonly legalResidence?: InputMaybe<Scalars['String']['input']>;
  /** Client occupation */
  readonly occupation?: InputMaybe<ClientOccupation>;
  /** Client phone number */
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  /** Client Social Security Number */
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
  /** Savvy user ID. If provided, the existing client will be updated */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for Account. */
export type AccountConnection = {
  readonly __typename?: 'AccountConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AccountEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Account>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** Account consolidation variant: a single source account consolidated into a single destination */
export type AccountConsolidationInput = {
  /** Whether to close the empty source account after consolidation */
  readonly closeSourceAccountAfterConsolidation: Scalars['Boolean']['input'];
  /** Account to consolidate into */
  readonly destinationAccountId: Scalars['ID']['input'];
  /** Account to consolidate from */
  readonly sourceAccountId: Scalars['ID']['input'];
};

export const AccountCustodyName = {
  /** held_away */
  HeldAway: 'held_away',
  /** managed */
  Managed: 'managed',
  /** to_be_managed */
  ToBeManaged: 'to_be_managed',
  /** unmanaged */
  Unmanaged: 'unmanaged'
} as const;

export type AccountCustodyName = typeof AccountCustodyName[keyof typeof AccountCustodyName];
/** An edge in a connection. */
export type AccountEdge = {
  readonly __typename?: 'AccountEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Account>;
};

/** The enrollment status of an account for strategy enrollment */
export const AccountEnrollmentStatus = {
  /** Account has an active enrollment task that is in progress */
  InProgress: 'IN_PROGRESS',
  /** Account is not currently enrolled in a strategy and has no active enrollment task */
  NotEnrolled: 'NOT_ENROLLED',
  /** Account has an active enrollment task that has not been started */
  Pending: 'PENDING'
} as const;

export type AccountEnrollmentStatus = typeof AccountEnrollmentStatus[keyof typeof AccountEnrollmentStatus];
/** A single account row for report pages that list accounts (cover page, appendix, etc.). */
export type AccountEntry = {
  readonly __typename?: 'AccountEntry';
  /** Internal Savvy account ID. */
  readonly accountId: Scalars['ID']['output'];
  /** Orion management style / strategy name (e.g. "Managed"). Null when unavailable. */
  readonly managementStyle?: Maybe<Scalars['String']['output']>;
  /** Current market value of this account, in USD. Null when unavailable. */
  readonly marketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Masked account number in the format XXX-XX####. */
  readonly maskedNumber: Scalars['String']['output'];
  /** Account display name (e.g. "Glenn Cooper - IRA"). */
  readonly name: Scalars['String']['output'];
  /** Human-readable registration type (e.g. "IRA", "Roth IRA", "Individual"). */
  readonly registrationLabel: Scalars['String']['output'];
};

/** Available filter options for accounts */
export type AccountFilterOptions = {
  readonly __typename?: 'AccountFilterOptions';
  /** Available fee schedule options */
  readonly feeSchedules: ReadonlyArray<Scalars['String']['output']>;
  /** Available household options */
  readonly households: ReadonlyArray<HouseholdOption>;
  /** Available primary advisor options */
  readonly primaryAdvisors: ReadonlyArray<PrimaryAdvisor>;
  /** Available strategy names */
  readonly strategies: ReadonlyArray<Scalars['String']['output']>;
};

/**
 * Where one account stands in opening and funding. Every field is non-null except
 * settledAt, which is null until Orion stamps the settle
 */
export type AccountFundingState = {
  readonly __typename?: 'AccountFundingState';
  /** The Savvy ID of the account */
  readonly accountId: Scalars['ID']['output'];
  /**
   * Whether the account holds money, by any route — an ACAT, a journal, or the
   * client's own wire. True when transferState is TRANSFERRED or the balance is
   * positive; the balance leg is load-bearing because Orion leaves
   * last_position_date null on accounts funded for years, classifying them PENDING
   * with money in them
   */
  readonly funded: Scalars['Boolean']['output'];
  /** When Orion stamped the transfer settled. Written once and never cleared, so it is null for every account still in flight */
  readonly settledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Whether the account will never transfer — closed or deleted in Savvy, carrying
   * an Orion cancel date, or classified CANCELLED. Terminal accounts are excluded
   * from the household phase
   */
  readonly terminal: Scalars['Boolean']['output'];
  /** Orion's classification of the transfer */
  readonly transferState: AccountTransferState;
};

/** Type of account holder */
export const AccountHolder = {
  /** co_client */
  CoClient: 'co_client',
  /** joint */
  Joint: 'joint',
  /** primary_client */
  PrimaryClient: 'primary_client'
} as const;

export type AccountHolder = typeof AccountHolder[keyof typeof AccountHolder];
/** Information about account limits that were exceeded */
export type AccountLimitExceeded = {
  readonly __typename?: 'AccountLimitExceeded';
  /** Type of account (Primary Client, Co-Client, Joint) */
  readonly accountType: Scalars['String']['output'];
  /** Accounts of this type */
  readonly accounts: ReadonlyArray<AccountSummary>;
  /** Number of accounts of this type */
  readonly count: Scalars['Int']['output'];
  /** Maximum allowed accounts of this type */
  readonly limit: Scalars['Int']['output'];
};

/** A single beneficiary on an account in a beneficiary update request */
export type AccountMaintenanceBeneficiaryInput = {
  /** Existing contact in the household pool */
  readonly contactId: Scalars['ID']['input'];
  /** Beneficiary percentage (1-100) */
  readonly percentage: Scalars['Int']['input'];
  /** Whether the beneficiary is primary or contingent */
  readonly relationType: BeneficiaryRelationTypeName;
};

/** Account maintenance request data associated with a task */
export type AccountMaintenanceRequest = {
  readonly __typename?: 'AccountMaintenanceRequest';
  /** One entry per account on the request (Add Advisor variant) */
  readonly advisorAccounts: ReadonlyArray<AccountMaintenanceRequestAdvisorAccount>;
  /** Annual income (Add Options and Margin variant) */
  readonly annualIncome?: Maybe<Scalars['Float']['output']>;
  /** Bank account number (Link a Bank variant) */
  readonly bankAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Bank account type (Link a Bank variant) */
  readonly bankAccountType?: Maybe<BankAccountTypeName>;
  /** Name of the bank (Link a Bank variant) */
  readonly bankName?: Maybe<Scalars['String']['output']>;
  /** Names of the bank account owners (Link a Bank variant) */
  readonly bankOwners?: Maybe<Scalars['String']['output']>;
  /** Beneficiaries recorded on the request (Beneficiary Update variant) */
  readonly beneficiaries: ReadonlyArray<AccountMaintenanceRequestBeneficiary>;
  /** Household member who holds the account (Add Advisor variant) */
  readonly clientUser?: Maybe<User>;
  /** Whether to close the source account after consolidation (Account Consolidation variant) */
  readonly closeSourceAccountAfterConsolidation?: Maybe<Scalars['Boolean']['output']>;
  /** Custodial account number (Add Advisor variant) */
  readonly custodialAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Custodian (Add Advisor variant) */
  readonly custodian?: Maybe<CustodianName>;
  /** Whether the account is already managed (Add Advisor variant) */
  readonly existingManagedAccount?: Maybe<Scalars['Boolean']['output']>;
  /** The Savvy ID of the request. */
  readonly id: Scalars['ID']['output'];
  /** Trading experience grid recorded with the request (Add Options and Margin variant) */
  readonly investmentExperience?: Maybe<InvestmentExperience>;
  /** Investment objective (Add Options and Margin variant) */
  readonly investmentObjective?: Maybe<Scalars['String']['output']>;
  /** Requested options level (Add Options and Margin variant) */
  readonly level?: Maybe<Scalars['String']['output']>;
  /** Liquid net worth (Add Options and Margin variant) */
  readonly liquidNetWorth?: Maybe<Scalars['Float']['output']>;
  /** Whether margin is requested (Add Options and Margin variant) */
  readonly margin?: Maybe<Scalars['Boolean']['output']>;
  /** Marital status of the account holder (Add Options and Margin variant) */
  readonly maritalStatus?: Maybe<Scalars['String']['output']>;
  /** Number of dependents (Add Options and Margin variant) */
  readonly numberOfDependents?: Maybe<Scalars['Int']['output']>;
  /** Whether options trading is requested (Add Options and Margin variant) */
  readonly options?: Maybe<Scalars['Boolean']['output']>;
  /** Accounts associated with the request (used by Link a Bank, Account Consolidation) */
  readonly requestAccounts: ReadonlyArray<AccountMaintenanceRequestAccount>;
  /** The variant of the request (e.g. beneficiary_update, account_consolidation) */
  readonly requestType: RequestTypeName;
  /** ABA routing number (Link a Bank variant) */
  readonly routingNumber?: Maybe<Scalars['String']['output']>;
  /** Total net worth (Add Options and Margin variant) */
  readonly totalNetWorth?: Maybe<Scalars['Float']['output']>;
};

/** An account associated with an account maintenance request */
export type AccountMaintenanceRequestAccount = {
  readonly __typename?: 'AccountMaintenanceRequestAccount';
  /** The associated account */
  readonly account?: Maybe<Account>;
  /** The Savvy ID of the join record. */
  readonly id: Scalars['ID']['output'];
  /** Role of the account on the request — source or destination */
  readonly role: AccountRoleName;
};

/** One entry on an Add-Advisor-to-Account request: custodian, account number, holder, and whether it is already managed. */
export type AccountMaintenanceRequestAdvisorAccount = {
  readonly __typename?: 'AccountMaintenanceRequestAdvisorAccount';
  /** Household member (primary or co-client) selected as the account holder */
  readonly clientUser: User;
  /** Account number at the custodian */
  readonly custodialAccountNumber: Scalars['String']['output'];
  /** Custodian — schwab or fidelity */
  readonly custodian: CustodianName;
  /** Whether the account is already managed */
  readonly existingManagedAccount: Scalars['Boolean']['output'];
  /** The Savvy ID of the entry. */
  readonly id: Scalars['ID']['output'];
};

/** A beneficiary recorded on an account inside an account maintenance request */
export type AccountMaintenanceRequestBeneficiary = {
  readonly __typename?: 'AccountMaintenanceRequestBeneficiary';
  /** Account the beneficiary applies to */
  readonly account: Account;
  /** Contact recorded as the beneficiary */
  readonly contact: Contact;
  /** The Savvy ID of the join record. */
  readonly id: Scalars['ID']['output'];
  /** Beneficiary percentage (1-100). Derived from the underlying ContactRelation. */
  readonly percentage?: Maybe<Scalars['Int']['output']>;
  /** Beneficiary relation — primary or contingent. Derived from the underlying ContactRelation. */
  readonly relationType?: Maybe<BeneficiaryRelationTypeName>;
};

/** Account maintenance request — exactly one variant must be set (oneOf). */
export type AccountMaintenanceRequestTaskInput =
  /** Account consolidation variant */
  { readonly accountConsolidation: AccountConsolidationInput; readonly addAdvisorToAccount?: never; readonly addOptionsAndMargin?: never; readonly beneficiaryUpdate?: never; readonly linkABank?: never; }
  |  /** Add advisor to existing account variant */
  { readonly accountConsolidation?: never; readonly addAdvisorToAccount: AddAdvisorToAccountInput; readonly addOptionsAndMargin?: never; readonly beneficiaryUpdate?: never; readonly linkABank?: never; }
  |  /** Add options & margin variant */
  { readonly accountConsolidation?: never; readonly addAdvisorToAccount?: never; readonly addOptionsAndMargin: AddOptionsAndMarginInput; readonly beneficiaryUpdate?: never; readonly linkABank?: never; }
  |  /** Beneficiary update variant */
  { readonly accountConsolidation?: never; readonly addAdvisorToAccount?: never; readonly addOptionsAndMargin?: never; readonly beneficiaryUpdate: BeneficiaryUpdateInput; readonly linkABank?: never; }
  |  /** Link a bank variant */
  { readonly accountConsolidation?: never; readonly addAdvisorToAccount?: never; readonly addOptionsAndMargin?: never; readonly beneficiaryUpdate?: never; readonly linkABank: LinkABankInput; };

/** Type of account being opened */
export const AccountOpeningTypeName = {
  /** ira */
  Ira: 'ira',
  /** personal */
  Personal: 'personal'
} as const;

export type AccountOpeningTypeName = typeof AccountOpeningTypeName[keyof typeof AccountOpeningTypeName];
/** Type of account owner */
export const AccountOwner = {
  /** co_client */
  CoClient: 'co_client',
  /** joint */
  Joint: 'joint',
  /** primary_client */
  PrimaryClient: 'primary_client'
} as const;

export type AccountOwner = typeof AccountOwner[keyof typeof AccountOwner];
/** Per-account block of the Account Performance section: header row + cumulative-return time series. */
export type AccountPerformance = {
  readonly __typename?: 'AccountPerformance';
  /** Savvy account ID. */
  readonly accountId: Scalars['ID']['output'];
  /** Masked account identifier (last digits), when available. */
  readonly accountMask?: Maybe<Scalars['String']['output']>;
  /** Display name for the account. */
  readonly accountName: Scalars['String']['output'];
  /** Full account number, when available on the account record. */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /** Daily cumulative-return points for the account performance line chart. Empty when data is unavailable. */
  readonly cumulativeReturnPoints: ReadonlyArray<ReturnPoint>;
  /** Ending market value as of the report end date, in USD; null when data is unavailable. */
  readonly endingMarketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Per-period total return rows for this account. */
  readonly summaryRows: ReadonlyArray<PeriodReturnRow>;
  /** Strategy / target allocation name shown in the table's Target Name column; falls back to a sensible default when unset. */
  readonly targetName: Scalars['String']['output'];
};

/** Performance breakdown for a specific account within a portfolio performance report. */
export type AccountPerformanceBreakdown = {
  readonly __typename?: 'AccountPerformanceBreakdown';
  /** The Savvy account ID */
  readonly accountId: Scalars['ID']['output'];
  /** The display name of the account */
  readonly accountName?: Maybe<Scalars['String']['output']>;
  /** The custodial account number of the account */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /** Per-sleeve performance breakdowns within this account */
  readonly accountSleeveBreakdowns?: Maybe<ReadonlyArray<SleevePerformanceBreakdown>>;
  /** Asset category breakdown for this account (e.g. Equity, Fixed Income) */
  readonly assetCategoryGrouping?: Maybe<ReadonlyArray<AssetGrouping>>;
  /** Asset class breakdown for this account (e.g. Large Blend, Intermediate Core Bond) — finer grain than category */
  readonly assetClassGrouping?: Maybe<ReadonlyArray<AssetGrouping>>;
  /**
   * Per-account holdings tagged with this account_id. The parent report's
   * `holdings` field is aggregated across accounts and never carries account_id;
   * use this for per-account breakdowns.
   */
  readonly holdings?: Maybe<ReadonlyArray<ReportedHolding>>;
  /** The last 2-4 alphanumeric characters of the account number */
  readonly mask?: Maybe<Scalars['String']['output']>;
  /** Performance data for this account across time periods */
  readonly performanceOverTime: ReadonlyArray<Performance>;
  /** The custodian or provider name (e.g. Fidelity, Charles Schwab) */
  readonly providerName?: Maybe<Scalars['String']['output']>;
  /** The name of the strategy the account is enrolled in */
  readonly strategyName?: Maybe<Scalars['String']['output']>;
  /** The subtype of the account (e.g. Brokerage, IRA) */
  readonly subtype?: Maybe<AccountSubtypeName>;
};

/**
 * One row of the 'Account Performance' table — per-account market value plus MTD,
 * QTD, YTD, and since-inception time-weighted returns.
 */
export type AccountPerformanceRow = {
  readonly __typename?: 'AccountPerformanceRow';
  /** Savvy account ID. */
  readonly accountId: Scalars['ID']['output'];
  /** Display name for the account. */
  readonly accountName: Scalars['String']['output'];
  /** Masked account number (last digits), when available. */
  readonly accountNumberMasked?: Maybe<Scalars['String']['output']>;
  /** Since-inception TWR as a fraction, annualized for windows over one year (Orion parity); null when unavailable. */
  readonly inceptionReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Ending market value as of the report end date, in USD; null when data is unavailable. */
  readonly marketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Month-to-date time-weighted return as a fraction (0.05 = 5%); null when data is unavailable. */
  readonly mtdReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Quarter-to-date time-weighted return as a fraction; null when data is unavailable. */
  readonly qtdReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Trailing one-year time-weighted return as a fraction; null when the account has less than one year of history. */
  readonly rollingOneYearReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date time-weighted return as a fraction; null when data is unavailable. */
  readonly ytdReturn?: Maybe<Scalars['BigDecimal']['output']>;
};

export const AccountProductTypeName = {
  /** cash_management */
  CashManagement: 'cash_management',
  /** direct_index */
  DirectIndex: 'direct_index'
} as const;

export type AccountProductTypeName = typeof AccountProductTypeName[keyof typeof AccountProductTypeName];
/** Purpose of the account */
export const AccountPurposeName = {
  /** general_investing */
  GeneralInvesting: 'general_investing',
  /** investing_for_college */
  InvestingForCollege: 'investing_for_college',
  /** investing_for_estate_planning */
  InvestingForEstatePlanning: 'investing_for_estate_planning',
  /** investing_for_retirement */
  InvestingForRetirement: 'investing_for_retirement',
  /** investing_for_tax_planning */
  InvestingForTaxPlanning: 'investing_for_tax_planning',
  /** investing_of_pooled_assets */
  InvestingOfPooledAssets: 'investing_of_pooled_assets',
  /** other */
  Other: 'other'
} as const;

export type AccountPurposeName = typeof AccountPurposeName[keyof typeof AccountPurposeName];
/** Role of an account on an account maintenance request — source or destination */
export const AccountRoleName = {
  /** destination */
  Destination: 'destination',
  /** source */
  Source: 'source'
} as const;

export type AccountRoleName = typeof AccountRoleName[keyof typeof AccountRoleName];
/** Account setup for an account confirmation task */
export const AccountSetup = {
  /** account_opening */
  AccountOpening: 'account_opening',
  /** account_transfer */
  AccountTransfer: 'account_transfer'
} as const;

export type AccountSetup = typeof AccountSetup[keyof typeof AccountSetup];
/** Account sleeve held by the user. */
export type AccountSleeve = {
  readonly __typename?: 'AccountSleeve';
  /** The account the sleeve is associated with */
  readonly account: Account;
  /** Available cash (sleeve balance minus account pending trade amounts in Created or Processed status). */
  readonly availableCash: Value;
  /** When Orion stopped reporting this sleeve. Null while it is still reported. */
  readonly closedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Advisor created name for a managed acccount sleeve */
  readonly customName?: Maybe<Scalars['String']['output']>;
  /** Advisor created note for a managed acccount sleeve */
  readonly customNote?: Maybe<Scalars['String']['output']>;
  /** Whether this sleeve is enrolled in Direct Indexing. Used to gate Direct Index Report eligibility. */
  readonly directIndexing: Scalars['Boolean']['output'];
  /** The current balance of the account. */
  readonly displayBalance: Value;
  /** The display name of the account, possibly with the provider name. May not be the official name of the account. */
  readonly displayName: Scalars['String']['output'];
  /** List of holdings for the account */
  readonly holdings: ReadonlyArray<Holding>;
  /** The Savvy ID of the account. */
  readonly id: Scalars['ID']['output'];
  /** The timestamp the account was last updated with information from the source provider. */
  readonly lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** The unique account identifier from the source provider. */
  readonly orionAccountId?: Maybe<Scalars['String']['output']>;
  /** Information about the performance of a managed account */
  readonly performance?: Maybe<ReadonlyArray<Performance>>;
  /** The portfolio the account belongs to */
  readonly portfolio?: Maybe<Portfolio>;
  /** The URL for the logo of the provider. */
  readonly providerLogoUrl?: Maybe<Scalars['String']['output']>;
  /** The id of the PortfolioStrategy the account is associated with */
  readonly strategyId?: Maybe<Scalars['ID']['output']>;
  /** The name of the strategy the account is associated with */
  readonly strategyName?: Maybe<Scalars['String']['output']>;
  /** List of transactions for the account */
  readonly transactions?: Maybe<ReadonlyArray<Transaction>>;
};

/**
 * An account's cash as of its latest Orion Connect snapshot (the previous day's
 * close). Money market funds count only for Fidelity NFS accounts.
 */
export type AccountSnapshotCash = {
  readonly __typename?: 'AccountSnapshotCash';
  /** The cash amount, serialized as a decimal string. */
  readonly amount: Scalars['String']['output'];
  /** The date of the Orion snapshot the amount comes from. */
  readonly asOfDate: Scalars['ISO8601Date']['output'];
};

/** Sortable fields for account lists */
export const AccountSortValues = {
  /** Sort by account name */
  AccountName: 'ACCOUNT_NAME',
  /** Sort by account balance */
  Balance: 'BALANCE',
  /** Sort by combined cash and money market amount */
  CashAndMoneyMarketAmount: 'CASH_AND_MONEY_MARKET_AMOUNT',
  /** Sort by combined cash and money market percentage of balance */
  CashAndMoneyMarketPercent: 'CASH_AND_MONEY_MARKET_PERCENT',
  /** Sort by household name */
  HouseholdName: 'HOUSEHOLD_NAME',
  /** Sort by account start date */
  StartDate: 'START_DATE'
} as const;

export type AccountSortValues = typeof AccountSortValues[keyof typeof AccountSortValues];
export const AccountStatusName = {
  /** active */
  Active: 'active',
  /** closed */
  Closed: 'closed',
  /** deleted */
  Deleted: 'deleted',
  /** hidden */
  Hidden: 'hidden',
  /** to_be_opened */
  ToBeOpened: 'to_be_opened'
} as const;

export type AccountStatusName = typeof AccountStatusName[keyof typeof AccountStatusName];
export const AccountSubtypeName = {
  Annuity: 'annuity',
  Auto: 'auto',
  BeneficiaryIra: 'beneficiary_ira',
  Brokerage: 'brokerage',
  Business: 'business',
  CashIsa: 'cash_isa',
  CashManagement: 'cash_management',
  Cd: 'cd',
  Checking: 'checking',
  ColdWallet: 'cold_wallet',
  Commercial: 'commercial',
  CommunityProperty: 'community_property',
  CompanyDaf: 'company_daf',
  Conservatorship: 'conservatorship',
  Construction: 'construction',
  Consumer: 'consumer',
  ContributoryIra: 'contributory_ira',
  ContributoryRoth: 'contributory_roth',
  ConversionRoth: 'conversion_roth',
  Corporate_401k: 'corporate_401k',
  Corporation: 'corporation',
  CreditCard: 'credit_card',
  Custodial: 'custodial',
  CustodialRothContributoryIra: 'custodial_roth_contributory_ira',
  Defined: 'defined',
  DefinedBenefitPlan: 'defined_benefit_plan',
  DefinedContributionPlan: 'defined_contribution_plan',
  DefinedPension: 'defined_pension',
  DonorAdvisedFund: 'donor_advised_fund',
  Ebt: 'ebt',
  EducationIra: 'education_ira',
  EducationSavingsAccount: 'education_savings_account',
  EducationalSavingsAccount: 'educational_savings_account',
  Estate: 'estate',
  Exchange: 'exchange',
  FinancialPlanningFee: 'financial_planning_fee',
  FixedAnnuity: 'fixed_annuity',
  Foundation: 'foundation',
  Gic: 'gic',
  GstExempt: 'gst_exempt',
  Guardianship: 'guardianship',
  HardwareWallet: 'hardware_wallet',
  HealthReimbursementArrangement: 'health_reimbursement_arrangement',
  HealthSavingsAccount: 'health_savings_account',
  HomeEquity: 'home_equity',
  HotWallet: 'hot_wallet',
  Hsa: 'hsa',
  Individual: 'individual',
  InheritedIra: 'inherited_ira',
  InheritedRothIra: 'inherited_roth_ira',
  InvalidType: 'invalid_type',
  Ira: 'ira',
  IraCont: 'ira_cont',
  IraRollover: 'ira_rollover',
  Isa: 'isa',
  Iso: 'iso',
  Joint: 'joint',
  JointTenant: 'joint_tenant',
  Jtwros: 'jtwros',
  Keogh: 'keogh',
  Lif: 'lif',
  LifeInsurance: 'life_insurance',
  LineOfCredit: 'line_of_credit',
  Lira: 'lira',
  Loan: 'loan',
  Lrif: 'lrif',
  Lrsp: 'lrsp',
  MaritalTrust: 'marital_trust',
  MoneyMarket: 'money_market',
  MoneyPurchasePensionPlan: 'money_purchase_pension_plan',
  Mortgage: 'mortgage',
  MutualFund: 'mutual_fund',
  NonCustodialWallet: 'non_custodial_wallet',
  NonProfit: 'non_profit',
  NonTaxableBrokerageAccount: 'non_taxable_brokerage_account',
  Nso: 'nso',
  OptionalRetirementProgram: 'optional_retirement_program',
  Other: 'other',
  OtherAnnuity: 'other_annuity',
  OtherInsurance: 'other_insurance',
  Overdraft: 'overdraft',
  Partnership: 'partnership',
  Paypal: 'paypal',
  PaypalCreditCard: 'paypal_credit_card',
  Pension: 'pension',
  PersonalChoiceRetirementAccount: 'personal_choice_retirement_account',
  Plan401a: 'plan401a',
  Plan401k: 'plan401k',
  Plan403b: 'plan403b',
  Plan457b: 'plan457b',
  Plan529: 'plan529',
  PledgedAssetLine: 'pledged_asset_line',
  Prepaid: 'prepaid',
  Prif: 'prif',
  Private: 'private',
  PrivateEquity: 'private_equity',
  ProfitSharingPlan: 'profit_sharing_plan',
  Public: 'public',
  Qshr: 'qshr',
  Rdsp: 'rdsp',
  RealEstate: 'real_estate',
  Resp: 'resp',
  Retirement: 'retirement',
  RetirementPlan: 'retirement_plan',
  RevocableTrust: 'revocable_trust',
  Rlif: 'rlif',
  Roth: 'roth',
  Roth_401k: 'roth_401k',
  RothIra: 'roth_ira',
  Rrif: 'rrif',
  Rrsp: 'rrsp',
  Rsa: 'rsa',
  Rsu: 'rsu',
  Sarsep: 'sarsep',
  Savings: 'savings',
  SepIra: 'sep_ira',
  Simple: 'simple',
  SimpleIra: 'simple_ira',
  SimplifiedEmployeePensionPlan: 'simplified_employee_pension_plan',
  Sipp: 'sipp',
  SoleAndSeparateProperty: 'sole_and_separate_property',
  Spouse: 'spouse',
  StockPlan: 'stock_plan',
  Student: 'student',
  TaxShelteredAccount: 'tax_sheltered_account',
  TenantsByEntirety: 'tenants_by_entirety',
  TenantsInCommon: 'tenants_in_common',
  Tfsa: 'tfsa',
  TransferOnDeath: 'transfer_on_death',
  Trust: 'trust',
  TrustUnderWill: 'trust_under_will',
  Ugma: 'ugma',
  UniformGiftToMinorsAccount: 'uniform_gift_to_minors_account',
  UniformTransfersToMinorsAccount: 'uniform_transfers_to_minors_account',
  Utma: 'utma',
  VariableAnnuity: 'variable_annuity'
} as const;

export type AccountSubtypeName = typeof AccountSubtypeName[keyof typeof AccountSubtypeName];
/** Summary information for an account */
export type AccountSummary = {
  readonly __typename?: 'AccountSummary';
  /** Account number */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /** Account ID */
  readonly id: Scalars['ID']['output'];
  /** Account name */
  readonly name: Scalars['String']['output'];
};

/** A single row of the 'Accounts Included in this Report' table on page 1 of the PDF. */
export type AccountSummaryRow = {
  readonly __typename?: 'AccountSummaryRow';
  /** Savvy account ID. */
  readonly accountId: Scalars['ID']['output'];
  /** Display name for the account. */
  readonly accountName: Scalars['String']['output'];
  /** Masked account number (last digits), when available. */
  readonly accountNumberMasked?: Maybe<Scalars['String']['output']>;
  /** Registration / account-type label (e.g. "Roth IRA"). */
  readonly accountType?: Maybe<Scalars['String']['output']>;
  /** Custodian display name (e.g. "Schwab"). */
  readonly custodian?: Maybe<Scalars['String']['output']>;
  /** Ending market value as of the report end date, in USD; null when data is unavailable. */
  readonly marketValue?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Information about an account transfer */
export type AccountTransferDatum = {
  readonly __typename?: 'AccountTransferDatum';
  /** The account holder name */
  readonly accountName: Scalars['String']['output'];
  /** The account number */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /** The type of account owner */
  readonly accountOwner: AccountOwner;
  /** The Savvy ID of the account transfer information */
  readonly id: Scalars['ID']['output'];
};

/** Input for account transfer information */
export type AccountTransferDatumInput = {
  /** The account holder name */
  readonly accountName: Scalars['String']['input'];
  /** The account number */
  readonly accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** The type of account owner */
  readonly accountOwner: AccountOwner;
};

/**
 * Orion's view of one account's transfer, mirroring
 * Orion::AccountTransferClassifier::State with UNKNOWN standing in for the
 * unclassified column. It tracks where the custodian has got to, not whether the
 * account holds money — read `funded` for that
 */
export const AccountTransferState = {
  /** The transfer will not complete — Orion cancelled or deactivated the account */
  Cancelled: 'CANCELLED',
  /** Orion has the account at Pending: paperwork is in, the custodian has not taken it yet */
  Pending: 'PENDING',
  /** The custodian has the account and assets are moving */
  SentToCustodian: 'SENT_TO_CUSTODIAN',
  /**
   * Orion reports the account live: a positive balance and a custodial position
   * feed. It says nothing about where the money came from, so an account the
   * client funded by wire reaches this state without any book transfer having run
   */
  Transferred: 'TRANSFERRED',
  /** Orion has not classified the account, or has it on a status that is not a transfer path */
  Unknown: 'UNKNOWN'
} as const;

export type AccountTransferState = typeof AccountTransferState[keyof typeof AccountTransferState];
export const AccountTransferStatus = {
  /** accountcreationandtransfercomplete */
  Accountcreationandtransfercomplete: 'accountcreationandtransfercomplete',
  /** pendingaccountcreationandtransfer */
  Pendingaccountcreationandtransfer: 'pendingaccountcreationandtransfer',
  /** pendingclientdocusignsignature */
  Pendingclientdocusignsignature: 'pendingclientdocusignsignature',
  /** transferpartiallycomplete */
  Transferpartiallycomplete: 'transferpartiallycomplete'
} as const;

export type AccountTransferStatus = typeof AccountTransferStatus[keyof typeof AccountTransferStatus];
/** Types for an account transfer setup */
export const AccountTransferTypeName = {
  /** fidelity_iws_to_fidelity_iws */
  FidelityIwsToFidelityIws: 'fidelity_iws_to_fidelity_iws',
  /** schwab_to_schwab */
  SchwabToSchwab: 'schwab_to_schwab'
} as const;

export type AccountTransferTypeName = typeof AccountTransferTypeName[keyof typeof AccountTransferTypeName];
/**
 * A named group with an aggregate market value — used in Relationship Summary
 * tables (e.g. Taxable Accounts, Retirement Accounts – Tax Deferred).
 */
export type AccountTypeGroup = {
  readonly __typename?: 'AccountTypeGroup';
  /** Row discriminant: "household_total" for the household rollup row, "tax_group" for a tax-treatment sub-group. */
  readonly kind: Scalars['String']['output'];
  /** Display label for this group (e.g. "Taxable Accounts"). */
  readonly label: Scalars['String']['output'];
  /** Total market value across all accounts in this group, in USD. Null when account values are unavailable. */
  readonly marketValue?: Maybe<Scalars['BigDecimal']['output']>;
};

export const AccountTypeName = {
  Credit: 'credit',
  Cryptocurrency: 'cryptocurrency',
  Depository: 'depository',
  EmployerEquity: 'employer_equity',
  FundInvestment: 'fund_investment',
  Insurance: 'insurance',
  Investment: 'investment',
  Loan: 'loan',
  Other: 'other',
  PrivateInvestment: 'private_investment'
} as const;

export type AccountTypeName = typeof AccountTypeName[keyof typeof AccountTypeName];
/** Per-account performance over an arbitrary date range. */
export type AccountWindowPerformance = {
  readonly __typename?: 'AccountWindowPerformance';
  /** Savvy Account id this row belongs to. */
  readonly accountId: Scalars['ID']['output'];
  /** Effective window end. */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Account market value at window end. */
  readonly endValue?: Maybe<Value>;
  /** Effective window start. May differ from the requested start when Orion clamps to the account funded date. */
  readonly startDate: Scalars['ISO8601Date']['output'];
  /** Time-weighted return for the window, as a decimal fraction (0.12 = 12%). */
  readonly twr?: Maybe<Scalars['Float']['output']>;
};

/** Account numbers grouped by signer role for the LPOA layer of the repaper envelope */
export type AccountsInfoInput = {
  /** Account numbers held solely by the co-client (reserved for future co-client-only flow; send [] when unused) */
  readonly coClientAccounts: ReadonlyArray<Scalars['String']['input']>;
  /** Trust account numbers, also listed in primaryClientAccounts, whose second trustee must sign the PBA */
  readonly coTrusteeAccounts?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Account numbers held jointly by primary + co-client */
  readonly jointClientAccounts: ReadonlyArray<Scalars['String']['input']>;
  /** Account numbers held solely by the primary client */
  readonly primaryClientAccounts: ReadonlyArray<Scalars['String']['input']>;
};

/** Autogenerated input type of AcknowledgeAlert */
export type AcknowledgeAlertInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Alert ID to acknowledge */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of AcknowledgeAlert. */
export type AcknowledgeAlertPayload = {
  readonly __typename?: 'AcknowledgeAlertPayload';
  /** The acknowledged alert */
  readonly alert: Alert;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AcknowledgeChimneyPropertyDisclosure */
export type AcknowledgeChimneyPropertyDisclosureInput = {
  /** The ID of the asset the disclosure notice was shown for */
  readonly assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AcknowledgeChimneyPropertyDisclosure. */
export type AcknowledgeChimneyPropertyDisclosurePayload = {
  readonly __typename?: 'AcknowledgeChimneyPropertyDisclosurePayload';
  /** The updated asset */
  readonly asset: Asset;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ActivateServiceCalendarForHousehold */
export type ActivateServiceCalendarForHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ActivateServiceCalendarForHousehold. */
export type ActivateServiceCalendarForHouseholdPayload = {
  readonly __typename?: 'ActivateServiceCalendarForHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** One column of the Portfolio Summary (Simple) Activity Summary table. */
export type ActivityPeriod = {
  readonly __typename?: 'ActivityPeriod';
  /** Portfolio market value at the start of the period, in USD. */
  readonly beginningMarketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive end date of this period. */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Portfolio market value at the end of the period, in USD. */
  readonly endingMarketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Display label for the column header (e.g. "Quarter to Date", "4/1/26 - 5/1/26"). */
  readonly label: Scalars['String']['output'];
  /** Net cash flows (contributions minus withdrawals) during the period, in USD. */
  readonly netAdditions?: Maybe<Scalars['BigDecimal']['output']>;
  /** Market-value change minus net additions: EMV − BMV − net_additions, in USD. */
  readonly netGains?: Maybe<Scalars['BigDecimal']['output']>;
  /** Which period this column represents. */
  readonly period: PortfolioSummarySimplePeriod;
  /**
   * Display time-weighted return as a fraction: annualized for periods over one
   * year (Orion convention), equal to the cumulative return for shorter periods.
   * This is the value shown in the report. Null when unavailable.
   */
  readonly returnAnnualized?: Maybe<Scalars['BigDecimal']['output']>;
  /** Cumulative time-weighted return for the period as a fraction (e.g. 0.0707 = 7.07%). Null when data is unavailable. */
  readonly returnCumulative?: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive start date of this period. Null when inception date is unknown. */
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

/**
 * One row of the 'Activity Summary' table — beginning market value, net cash
 * flows, dividends and interest, bond accrual movement, and time-weighted return
 * for a single reporting period (QTD, YTD, or Since Inception).
 */
export type ActivitySummaryRow = {
  readonly __typename?: 'ActivitySummaryRow';
  /** Market value at the start of the period including bond accrual, in USD; null when data is unavailable. */
  readonly beginningMarketValueWithBondAccrual?: Maybe<Scalars['BigDecimal']['output']>;
  /** Dividends and interest received over the period, in USD; null when data is unavailable. */
  readonly dividendsAndInterest?: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive end date of this period as resolved against the snapshot. */
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Bond accrual balance at the end of the period, in USD; null when not tracked for this household. */
  readonly endingBondAccrual?: Maybe<Scalars['BigDecimal']['output']>;
  /** Market value at the end of the period including bond accrual, in USD; null when data is unavailable. */
  readonly endingMarketValueWithBondAccrual?: Maybe<Scalars['BigDecimal']['output']>;
  /** Change in market value over the period (gain/loss exclusive of cash flows), in USD; null when data is unavailable. */
  readonly marketValueChange?: Maybe<Scalars['BigDecimal']['output']>;
  /** Net contributions over the period (deposits minus withdrawals), in USD; null when data is unavailable. */
  readonly netCashFlows?: Maybe<Scalars['BigDecimal']['output']>;
  /** Reporting period. */
  readonly period: PerformanceReportConsolidatedPeriod;
  /** Inclusive start date of this period as resolved against the snapshot. */
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Time-weighted return over the period as a fraction (0.05 = 5%); null when data is unavailable. */
  readonly timeWeightedReturn?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Deduped touchpoint count for one activity timeline item type */
export type ActivityTimelineContactChannelCount = {
  readonly __typename?: 'ActivityTimelineContactChannelCount';
  /** Number of deduped touchpoints of this type in the window */
  readonly count: Scalars['Int']['output'];
  /** Activity timeline item type the count belongs to */
  readonly type: ItemTypeEnum;
};

/** A contact or beneficiary a household timeline item has been surfaced on */
export type ActivityTimelineContactLink = {
  readonly __typename?: 'ActivityTimelineContactLink';
  /** The contact id */
  readonly contactId: Scalars['ID']['output'];
  /** Polymorphic contact type: CenterOfInfluenceRep or Contact */
  readonly contactType: Scalars['String']['output'];
  /** Display name for the linked contact */
  readonly name: Scalars['String']['output'];
};

/** Client-facing contact on a household over a date window: how much, how recent, through which channels, about what */
export type ActivityTimelineContactSummary = {
  readonly __typename?: 'ActivityTimelineContactSummary';
  /** Per-item-type breakdown, highest count first */
  readonly countsByType: ReadonlyArray<ActivityTimelineContactChannelCount>;
  /** When the most recent touchpoint on record occurred, ignoring startDate; null when there has never been one */
  readonly lastContactAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Topics tagged on the window's notes, most frequent first */
  readonly topTopics: ReadonlyArray<Scalars['String']['output']>;
  /** Total deduped touchpoints in the window */
  readonly totalCount: Scalars['Int']['output'];
};

/** The service occurrence a timeline interaction has been recorded as satisfying */
export type ActivityTimelineServiceOccurrenceLink = {
  readonly __typename?: 'ActivityTimelineServiceOccurrenceLink';
  /** Name of the catalog item that materialized the occurrence */
  readonly itemName: Scalars['String']['output'];
  /** Which occurrence of the cadence this is */
  readonly occurrenceDate: Scalars['ISO8601Date']['output'];
  /** The service the enrollment belongs to. Null for a historical enrollment that carries none */
  readonly serviceName?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AddAdvisorGroupToOrganization */
export type AddAdvisorGroupToOrganizationInput = {
  /** ID of the advisor group to link */
  readonly advisorGroupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization to link the group to */
  readonly organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddAdvisorGroupToOrganization. */
export type AddAdvisorGroupToOrganizationPayload = {
  readonly __typename?: 'AddAdvisorGroupToOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** The organization the group was linked to */
  readonly organization?: Maybe<Organization>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** A single account entry for the Add Advisor variant */
export type AddAdvisorToAccountEntryInput = {
  /** Household member (primary or co-client) selected as the account holder */
  readonly clientUserId: Scalars['ID']['input'];
  /** Account number at the custodian */
  readonly custodialAccountNumber: Scalars['String']['input'];
  /** Custodian — schwab or fidelity */
  readonly custodian: CustodianName;
  /** Whether the account is already managed */
  readonly existingManagedAccount: Scalars['Boolean']['input'];
};

/** Add advisor to existing account variant */
export type AddAdvisorToAccountInput = {
  /** One entry per account the advisor should be added to (at least one) */
  readonly entries: ReadonlyArray<AddAdvisorToAccountEntryInput>;
};

/** Autogenerated input type of AddAdvisorToExistingAdvisorGroup */
export type AddAdvisorToExistingAdvisorGroupInput = {
  /** ID of the advisor group to add the advisor to */
  readonly advisorGroupId: Scalars['ID']['input'];
  /** User ID of the advisor to add */
  readonly advisorUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddAdvisorToExistingAdvisorGroup. */
export type AddAdvisorToExistingAdvisorGroupPayload = {
  readonly __typename?: 'AddAdvisorToExistingAdvisorGroupPayload';
  /** The advisor group the advisor was added to */
  readonly advisorGroup?: Maybe<AdvisorGroup>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddAdvisorsToOrganization */
export type AddAdvisorsToOrganizationInput = {
  /** User IDs of the advisors to add to the organization */
  readonly advisorUserIds: ReadonlyArray<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Legacy identifier for admin/Retool callers. Omit for new callers and MCP; when
   * present alongside organizationName, both must agree or the write is refused.
   */
  readonly organizationId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The organization's current name. Required for MCP callers, where it also
   * serves as the identifier. For legacy callers passing organizationId, verified
   * against the record before the write.
   */
  readonly organizationName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddAdvisorsToOrganization. */
export type AddAdvisorsToOrganizationPayload = {
  readonly __typename?: 'AddAdvisorsToOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors?: Maybe<Scalars['String']['output']>;
  /** The organization the advisors were added to */
  readonly organization?: Maybe<Organization>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddCommentAttachments */
export type AddCommentAttachmentsInput = {
  /** Files to attach, already uploaded to Box by the client. */
  readonly attachments: ReadonlyArray<CommentAttachmentInput>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment to attach the files to */
  readonly commentId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddCommentAttachments. */
export type AddCommentAttachmentsPayload = {
  readonly __typename?: 'AddCommentAttachmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The comment, with its attachments after the add */
  readonly comment: Comment;
};

/** Attributes for adding a family member to a household */
export type AddFamilyMemberInput = {
  /** Street address line 1 */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Street address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth in ISO format */
  readonly dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /**
   * The household this contact depends on, when the dependency is on the household
   * rather than one client. Mutually exclusive with dependentOfUserId
   */
  readonly dependentOfHouseholdId?: InputMaybe<Scalars['ID']['input']>;
  /** The client this contact depends on. Mutually exclusive with dependentOfHouseholdId */
  readonly dependentOfUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Email address */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Entity established date for trusts */
  readonly entityDateEstablished?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Entity date of death for estates */
  readonly entityDateOfDeath?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Tax ID/EIN for entity contacts */
  readonly entityEin?: InputMaybe<Scalars['String']['input']>;
  /** Executor or personal representative for estate entities */
  readonly entityExecutorName?: InputMaybe<Scalars['String']['input']>;
  /** Entity display name for Trust, Organization, or Estate contacts */
  readonly entityName?: InputMaybe<Scalars['String']['input']>;
  /** Organization type (LLC, S-Corp, etc.) */
  readonly entityOrganizationType?: InputMaybe<Scalars['String']['input']>;
  /** Primary contact or role for organization entities */
  readonly entityPrimaryContactRole?: InputMaybe<Scalars['String']['input']>;
  /** Trust type (Revocable, Irrevocable, Testamentary, Other) */
  readonly entityTrustType?: InputMaybe<Scalars['String']['input']>;
  /** Trustee name for trust entities */
  readonly entityTrusteeName?: InputMaybe<Scalars['String']['input']>;
  /** Entity type (trust, organization, estate) */
  readonly entityType?: InputMaybe<Scalars['String']['input']>;
  /** Legal first name */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** Whether this contact is a beneficiary */
  readonly isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether this contact is financially dependent on a client. Advisor context
   * only — it does not feed dependent counts on client intake, account-opening or
   * account-maintenance requests, and does not feed tax projection. Sending this
   * makes dependentOfHouseholdId and dependentOfUserId authoritative: a named
   * target replaces the stored one and an omitted pair clears it. Omit all three
   * to leave the dependency untouched
   */
  readonly isDependent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this contact is a trusted contact */
  readonly isTrustedContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legal last name */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** Legal middle name */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** Preferred nickname */
  readonly nickname?: InputMaybe<Scalars['String']['input']>;
  /** Freeform notes about the contact */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Relationship to the household */
  readonly relation?: InputMaybe<BeneficiaryRelationship>;
  /** Social Security Number */
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
  /** State */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** ZIP / postal code */
  readonly zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of AddFamilyMembers */
export type AddFamilyMembersInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** List of family members to add */
  readonly familyMembers: ReadonlyArray<AddFamilyMemberInput>;
  /** ID of the household to add family members to */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddFamilyMembers. */
export type AddFamilyMembersPayload = {
  readonly __typename?: 'AddFamilyMembersPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of error messages if the operation failed */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** The created family members */
  readonly familyMembers: ReadonlyArray<FamilyMember>;
};

/** Autogenerated input type of AddHouseholdMember */
export type AddHouseholdMemberInput = {
  /** Whether the member can sign client agreements for the household. Defaults to false. */
  readonly canSignClientAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The household to add the member to. */
  readonly householdId: Scalars['ID']['input'];
  /** Whether the member is an account holder on household accounts. Defaults to false. */
  readonly isAccountHolder?: InputMaybe<Scalars['Boolean']['input']>;
  /** The member's role in the household. */
  readonly role: HouseholdMembershipRole;
  /** Free-form description of the member's trustee capacity, if applicable. */
  readonly trusteeCapacity?: InputMaybe<Scalars['String']['input']>;
  /** The user being added as a member. */
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddHouseholdMember. */
export type AddHouseholdMemberPayload = {
  readonly __typename?: 'AddHouseholdMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created household membership. */
  readonly membership: HouseholdMembership;
};

/** Autogenerated input type of AddNotificationAlertMute */
export type AddNotificationAlertMuteInput = {
  /** A specific account to mute; omit for the whole household. */
  readonly accountId?: InputMaybe<Scalars['ID']['input']>;
  /** The alert type to mute (cash_variance or allocation_variance). */
  readonly alertType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The household to mute the alert for. */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddNotificationAlertMute. */
export type AddNotificationAlertMutePayload = {
  readonly __typename?: 'AddNotificationAlertMutePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created mute. */
  readonly mute: NotificationAlertMute;
};

/** Add options & margin variant — reuses the Open New Account options question set */
export type AddOptionsAndMarginInput = {
  /** Annual income */
  readonly annualIncome?: InputMaybe<Scalars['Float']['input']>;
  /** Custodian — schwab or fidelity (drives the options level set) */
  readonly custodian?: InputMaybe<CustodianName>;
  /** Investment experience grid across all instrument categories */
  readonly investmentExperienceGrid?: InputMaybe<InvestmentExperienceGridInput>;
  /** Investment objective */
  readonly investmentObjective?: InputMaybe<Scalars['String']['input']>;
  /** Options level */
  readonly level?: InputMaybe<Scalars['String']['input']>;
  /** Liquid net worth */
  readonly liquidNetWorth?: InputMaybe<Scalars['Float']['input']>;
  /** Whether margin trading is being enabled */
  readonly margin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Marital status */
  readonly maritalStatus?: InputMaybe<Scalars['String']['input']>;
  /** Number of dependents */
  readonly numberOfDependents?: InputMaybe<Scalars['Int']['input']>;
  /** Whether options trading is being enabled */
  readonly options: Scalars['Boolean']['input'];
  /** Total net worth */
  readonly totalNetWorth?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated input type of AddSavvyServiceTemplateToResources */
export type AddSavvyServiceTemplateToResourcesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy service template to clone */
  readonly savvyServiceTemplateId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddSavvyServiceTemplateToResources. */
export type AddSavvyServiceTemplateToResourcesPayload = {
  readonly __typename?: 'AddSavvyServiceTemplateToResourcesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The advisor's own copy of the template, which they can edit, publish and enroll households into */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
};

/** Autogenerated input type of AddSecondaryPortfolio */
export type AddSecondaryPortfolioInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly secondaryPortfolioId: Scalars['ID']['input'];
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddSecondaryPortfolio. */
export type AddSecondaryPortfolioPayload = {
  readonly __typename?: 'AddSecondaryPortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddServiceCatalogItemToGroup */
export type AddServiceCatalogItemToGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Service catalog item group id */
  readonly serviceCatalogItemGroupId: Scalars['ID']['input'];
  /** Service catalog item id */
  readonly serviceCatalogItemId: Scalars['ID']['input'];
  /** Sort order */
  readonly sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of AddServiceCatalogItemToGroup. */
export type AddServiceCatalogItemToGroupPayload = {
  readonly __typename?: 'AddServiceCatalogItemToGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Service catalog item group membership */
  readonly serviceCatalogItemGroupMembership?: Maybe<ServiceCatalogItemGroupMembership>;
};

/** Autogenerated input type of AddSurveyRecipients */
export type AddSurveyRecipientsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Preview only; writes nothing */
  readonly dryRun: Scalars['Boolean']['input'];
  /** Advisor emails; matched case-insensitively after trimming */
  readonly emails: ReadonlyArray<Scalars['String']['input']>;
  /** The survey round */
  readonly roundId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddSurveyRecipients. */
export type AddSurveyRecipientsPayload = {
  readonly __typename?: 'AddSurveyRecipientsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** One result per distinct input email, in input order */
  readonly results: ReadonlyArray<SurveyRecipientResult>;
};

/** Address belonging to a user. */
export type Address = {
  readonly __typename?: 'Address';
  readonly addressLine1: Scalars['String']['output'];
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  readonly addressLine3?: Maybe<Scalars['String']['output']>;
  readonly city: Scalars['String']['output'];
  readonly countryCode: Scalars['String']['output'];
  /** The Savvy ID of the address. */
  readonly id: Scalars['ID']['output'];
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly type: AddressTypeName;
};

export type AddressInput = {
  /** The first line of the address */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the address */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** The country code */
  readonly countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The id of an existing address */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** The postal code */
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The state */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** The type of address */
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

export const AddressTypeName = {
  Office: 'office',
  Other: 'other',
  PrimaryResidence: 'primary_residence',
  SecondaryResidence: 'secondary_residence',
  VacationHome: 'vacation_home'
} as const;

export type AddressTypeName = typeof AddressTypeName[keyof typeof AddressTypeName];
/** A service object that is available to admins for use in the admin dashboard. */
export type AdminServiceObject = {
  readonly __typename?: 'AdminServiceObject';
  readonly args: ReadonlyArray<AdminServiceObjectArg>;
  readonly className: Scalars['String']['output'];
};

/** A service object argument that is available to admins for use in the admin dashboard. */
export type AdminServiceObjectArg = {
  readonly __typename?: 'AdminServiceObjectArg';
  readonly argName: Scalars['String']['output'];
  readonly defaultValue?: Maybe<Scalars['String']['output']>;
  readonly isKeywordArg: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AdoptWealthscapeAccount */
export type AdoptWealthscapeAccountInput = {
  /** Advisor the onboarding task is assigned to */
  readonly advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Account number Fidelity assigned in Wealthscape */
  readonly custodianAccountNumber: Scalars['String']['input'];
  /** Household the account belongs to */
  readonly householdId: Scalars['ID']['input'];
  /** Second household member, required for joint registrations */
  readonly jointOwnerUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Household member who owns the account */
  readonly primaryOwnerUserId: Scalars['ID']['input'];
  /** Why the account was opened by hand; kept in the audit log */
  readonly reason: Scalars['String']['input'];
  /** Registration type, e.g. individual, roth, trust_under_agreement */
  readonly registrationType: Scalars['String']['input'];
};

/** Autogenerated return type of AdoptWealthscapeAccount. */
export type AdoptWealthscapeAccountPayload = {
  readonly __typename?: 'AdoptWealthscapeAccountPayload';
  /** Advisor the onboarding task was assigned to */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Account number recorded */
  readonly custodianAccountNumber?: Maybe<Scalars['String']['output']>;
  /** The account onboarding request created */
  readonly eciAccountOnboardingRequestId?: Maybe<Scalars['ID']['output']>;
  /** User-facing errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Household the account now sits on */
  readonly householdName?: Maybe<Scalars['String']['output']>;
  /** Household member recorded as the joint owner, if any */
  readonly jointOwnerName?: Maybe<Scalars['String']['output']>;
  /** Household member recorded as the owner */
  readonly primaryOwnerName?: Maybe<Scalars['String']['output']>;
  /** Registration type recorded */
  readonly registrationType?: Maybe<Scalars['String']['output']>;
  /** Whether the adoption succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AdvanceEciOnboardingToReadyToSend */
export type AdvanceEciOnboardingToReadyToSendInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household identifier — UUID (preferred) or legacy salesforce_account_id */
  readonly householdPublicId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdvanceEciOnboardingToReadyToSend. */
export type AdvanceEciOnboardingToReadyToSendPayload = {
  readonly __typename?: 'AdvanceEciOnboardingToReadyToSendPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the advance succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AdvanceOnboardingAfterSigning */
export type AdvanceOnboardingAfterSigningInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The blocked staged household to repair. */
  readonly stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdvanceOnboardingAfterSigning. */
export type AdvanceOnboardingAfterSigningPayload = {
  readonly __typename?: 'AdvanceOnboardingAfterSigningPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The staged household after the repair. */
  readonly stagedHousehold: AdvisorOnboardingStagedHousehold;
};

export type Advisor = {
  readonly __typename?: 'Advisor';
  readonly acceptedAiRecommendationsDisclosure?: Maybe<Scalars['Boolean']['output']>;
  /** Available filter options for advisor accounts */
  readonly accountFilterOptions: AccountFilterOptions;
  /** Returns a list of accounts accessible to the current user */
  readonly accounts: AccountConnection;
  readonly adv2bLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is being replaced by advisor_groups. */
  readonly advisorGroup?: Maybe<AdvisorGroup>;
  /** All members of the advisor's advisor groups */
  readonly advisorGroupMembers: ReadonlyArray<Advisor>;
  readonly advisorGroups?: Maybe<ReadonlyArray<AdvisorGroup>>;
  readonly alertSettings?: Maybe<AlertSettings>;
  readonly alerts?: Maybe<ReadonlyArray<Alert>>;
  readonly assignedClients: ReadonlyArray<Client>;
  /** Whether the advisor belongs to at least one Group-type advisor group, which gates creating firm-visible templates */
  readonly belongsToAdvisorGroup: Scalars['Boolean']['output'];
  /** The advisor's bill style */
  readonly billStyle: AdvisorProfileBillStyle;
  /** The advisor's billing frequency */
  readonly billingFrequency: AdvisorProfileBillingFrequency;
  readonly bio: Scalars['String']['output'];
  /** Calendar events for the advisor */
  readonly calendarEvents: CalendarEventConnection;
  readonly calendlyLink?: Maybe<Scalars['String']['output']>;
  /** Whether the advisor can create a team (firm admin with an organization). Gates the Create team affordance in Settings. */
  readonly canCreateTeam: Scalars['Boolean']['output'];
  /** Whether the advisor can edit the organization */
  readonly canEditOrganization?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the advisor is employed under Savvy's RIA (captive) rather than
   * running their own book (owned). Gates onboarding-wizard steps.
   */
  readonly captive: Scalars['Boolean']['output'];
  readonly centerOfInfluenceReps: ReadonlyArray<CenterOfInfluenceRep>;
  /** The Client Service Associate assigned to this advisor */
  readonly clientAssociate?: Maybe<User>;
  /** Salesforce user ID of the assigned Client Service Associate. Temporary addition whilst migrating off Salesforce. */
  readonly clientAssociateSalesforceUserId?: Maybe<Scalars['String']['output']>;
  /**
   * Advisor designations from acts_as_taggable_on(:credentials), e.g. ["CFP®",
   * "CLU®"]. Appended after the advisor's name in reports.
   */
  readonly credentials: ReadonlyArray<Scalars['String']['output']>;
  /** The advisor's DBA (Doing Business As) email address for client-facing communications */
  readonly dbaEmail?: Maybe<Scalars['String']['output']>;
  /** The email address to display to clients (DBA email if set, otherwise primary email) */
  readonly displayEmail: Scalars['String']['output'];
  /** The advisor's fee schedules */
  readonly feeSchedules: ReadonlyArray<FeeSchedule>;
  readonly fidelityMasterAccountNumber: Scalars['String']['output'];
  readonly hasUnreadAlerts?: Maybe<Scalars['Boolean']['output']>;
  /** Households of the advisor that are in the specified lead stage(s) */
  readonly householdsByStage: ReadonlyArray<Household>;
  readonly id: Scalars['ID']['output'];
  readonly mainAdvisorGroup?: Maybe<AdvisorGroup>;
  /** Advisor's full name */
  readonly name: Scalars['String']['output'];
  readonly noteTopics?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Whether the advisor joined as a new advisor or was already here with a book. Null when unclassified. */
  readonly onboardingCohort?: Maybe<AdvisorOnboardingCohort>;
  /** The organization the advisor belongs to */
  readonly organization?: Maybe<Organization>;
  /** Households in an active pipeline stage, lead through onboarding */
  readonly prospectiveHouseholds: ReadonlyArray<Household>;
  readonly prospects: ReadonlyArray<Client>;
  readonly salesforceUserId: Scalars['String']['output'];
  readonly schwabMasterAccountNumber: Scalars['String']['output'];
  readonly serviceCalendarMeetingTypeTemplates?: Maybe<ReadonlyArray<ServiceCalendarMeetingTypeTemplate>>;
  readonly serviceCalendarSettingTemplates?: Maybe<ReadonlyArray<ServiceCalendarSettingTemplate>>;
  /** When true, clients see a Calendly 'Schedule' button for this advisor on the client dashboard. */
  readonly showSchedulingToClients: Scalars['Boolean']['output'];
  /** The Savvy Client Services ops user, always available as a task assignee */
  readonly taskOpsAssignee?: Maybe<User>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly user: User;
  readonly viewAdvisorGroupClients?: Maybe<Scalars['Boolean']['output']>;
  readonly visitedActionCenterAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Ordered stat card keys for the workbench landing page (3-5 items) */
  readonly workbenchStatCardKeys: ReadonlyArray<Scalars['String']['output']>;
  /** When true, stat cards show only the advisor's own households instead of the full practice */
  readonly workbenchStatMyClientsOnly: Scalars['Boolean']['output'];
};


export type AdvisorAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  balanceRange?: InputMaybe<BalanceRangeInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  feeSchedules?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  portfolioMustBePresent?: InputMaybe<Scalars['Boolean']['input']>;
  providerNames?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<AccountSortValues>;
  strategyFilter?: InputMaybe<StrategyFilterInput>;
};


export type AdvisorAdvisorGroupMembersArgs = {
  includeNonAdvisors?: InputMaybe<Scalars['Boolean']['input']>;
  includeSelf?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AdvisorAssignedClientsArgs = {
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ClientSortValues>;
};


export type AdvisorCalendarEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  startsAfter: Scalars['ISO8601DateTime']['input'];
  startsBefore: Scalars['ISO8601DateTime']['input'];
};


export type AdvisorCalendlyLinkArgs = {
  meetingType?: InputMaybe<MeetingTypeName>;
};


export type AdvisorHouseholdsByStageArgs = {
  includeSharedHouseholds?: InputMaybe<Scalars['Boolean']['input']>;
  stages: ReadonlyArray<HouseholdStage>;
};


export type AdvisorProspectsArgs = {
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ClientSortValues>;
};

export type AdvisorActivity = {
  readonly __typename?: 'AdvisorActivity';
  /** URL for the activity call to action */
  readonly actionHref?: Maybe<Scalars['String']['output']>;
  /** Label for the activity call to action */
  readonly actionLabel?: Maybe<Scalars['String']['output']>;
  /** User id for the actor who performed the activity */
  readonly actorId?: Maybe<Scalars['ID']['output']>;
  /** Whether the actor is a client user */
  readonly actorIsClient: Scalars['Boolean']['output'];
  /** Display name for the actor who performed the activity */
  readonly actorName?: Maybe<Scalars['String']['output']>;
  /** Alert type when the activity source is an Alert */
  readonly alertType?: Maybe<Scalars['String']['output']>;
  /** Advisor Activities category */
  readonly category: Scalars['String']['output'];
  /** Short display content, with any withheld counterparty resolved for this reader */
  readonly content: Scalars['String']['output'];
  /** Destination family for advisor click-through */
  readonly destination: Scalars['String']['output'];
  /** Stable event key from the v1 source mapping */
  readonly eventKey: Scalars['String']['output'];
  /** Household associated with this activity, null when the subject is not a household */
  readonly household?: Maybe<Household>;
  /** Stable activity id namespaced by source */
  readonly id: Scalars['ID']['output'];
  /** When this activity occurred */
  readonly occurredAt: Scalars['ISO8601DateTime']['output'];
  /** Subject record id, paired with relationType */
  readonly relationId?: Maybe<Scalars['ID']['output']>;
  /** Subject family this activity is about, such as Household or CenterOfInfluenceRep */
  readonly relationType?: Maybe<Scalars['String']['output']>;
  /** Source family, such as alert or task_activity */
  readonly source: Scalars['String']['output'];
  /** Underlying source record id */
  readonly sourceId: Scalars['ID']['output'];
  /** Underlying source record type */
  readonly sourceType: Scalars['String']['output'];
  /** Name of the related task when this activity links to a task */
  readonly taskName?: Maybe<Scalars['String']['output']>;
  /** Visibility scope applied to this activity row */
  readonly visibilityScope: Scalars['String']['output'];
};

/** The connection type for AdvisorActivity. */
export type AdvisorActivityConnection = {
  readonly __typename?: 'AdvisorActivityConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AdvisorActivityEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<AdvisorActivity>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

export type AdvisorActivityDailyCount = {
  readonly __typename?: 'AdvisorActivityDailyCount';
  /** Number of activities that occurred on this calendar day. */
  readonly count: Scalars['Int']['output'];
  /**
   * Calendar day the activities occurred on, expressed in the advisor's local
   * timezone (see the resolver's `timeZone` argument). Not UTC.
   */
  readonly date: Scalars['ISO8601Date']['output'];
};

/** An edge in a connection. */
export type AdvisorActivityEdge = {
  readonly __typename?: 'AdvisorActivityEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<AdvisorActivity>;
};

/** A calendar event on the advisor's calendar, with its household and openable canvas doc id. */
export type AdvisorCalendarEvent = {
  readonly __typename?: 'AdvisorCalendarEvent';
  /** All participants in the event. */
  readonly calendarEventParticipants: ReadonlyArray<CalendarEventParticipant>;
  /**
   * Id of the requester's canvas document for this event: the meeting_recap doc
   * once the meeting has one, otherwise the meeting_prep doc, or null. At most one
   * of each per event; status is not considered.
   */
  readonly canvasDocumentId?: Maybe<Scalars['ID']['output']>;
  /**
   * Type of the document `canvasDocumentId` points at, so callers can label a
   * recap CTA differently from a prep one. Null whenever `canvasDocumentId` is null.
   */
  readonly canvasDocumentType?: Maybe<CanvasDocumentType>;
  /** The description of the event. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Event end time with timezone. */
  readonly endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The household linked to this event, or null. */
  readonly household?: Maybe<Household>;
  /** The Savvy ID of the calendar event. */
  readonly id: Scalars['ID']['output'];
  /** The location of the event. */
  readonly location?: Maybe<Scalars['String']['output']>;
  /** Video conference or meeting link. */
  readonly meetingLink?: Maybe<Scalars['String']['output']>;
  /**
   * The requester's AI-generated meeting prep document for this event (recap +
   * agenda), or null if no prep has been generated. Independent of any recap doc.
   */
  readonly meetingPrep?: Maybe<MeetingPrep>;
  /** Event start time with timezone. */
  readonly startsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The title/summary of the event. */
  readonly summary?: Maybe<Scalars['String']['output']>;
};

/** A client user with associated profile, household, and address data for admin queries */
export type AdvisorClient = {
  readonly __typename?: 'AdvisorClient';
  /** User addresses */
  readonly addresses?: Maybe<ReadonlyArray<Address>>;
  /** Client profile data with masked SSN */
  readonly clientProfile?: Maybe<Client>;
  /** User creation timestamp */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** User email */
  readonly email: Scalars['String']['output'];
  /** User first name */
  readonly firstName: Scalars['String']['output'];
  /** User full name */
  readonly fullName: Scalars['String']['output'];
  /** Household data */
  readonly household?: Maybe<Household>;
  /** User ID */
  readonly id: Scalars['ID']['output'];
  /** User last name */
  readonly lastName: Scalars['String']['output'];
  /** User middle name */
  readonly middleName?: Maybe<Scalars['String']['output']>;
  /** User phone number */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  /** User preferred name */
  readonly preferredName?: Maybe<Scalars['String']['output']>;
  /** ID of the associated profile */
  readonly profileId?: Maybe<Scalars['ID']['output']>;
  /** User profile picture URL */
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
  /** Type of user profile */
  readonly profileType: Scalars['String']['output'];
  /** User role */
  readonly role: Scalars['String']['output'];
  /** User status */
  readonly status: Scalars['String']['output'];
  /** User last update timestamp */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input type for address data for bulk update */
export type AdvisorClientAddressInput = {
  /** Address line 1 */
  readonly addressLine1: Scalars['String']['input'];
  /** Address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Address line 3 */
  readonly addressLine3?: InputMaybe<Scalars['String']['input']>;
  /** City */
  readonly city: Scalars['String']['input'];
  /** Country code */
  readonly countryCode: Scalars['String']['input'];
  /** Address ID. If the value is null, an address will be created */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** Postal code */
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  /** State */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** Address type */
  readonly typeOf: Scalars['String']['input'];
};

/** Input type for advisor client data for bulk update */
export type AdvisorClientInput = {
  /** Client addresses to update */
  readonly addresses?: InputMaybe<ReadonlyArray<AdvisorClientAddressInput>>;
  /** Client profile data to update */
  readonly clientProfile: AdvisorClientProfileInput;
  /** User first name */
  readonly firstName: Scalars['String']['input'];
  /** Client user ID which is going to be updated */
  readonly id: Scalars['ID']['input'];
  /** User last name */
  readonly lastName: Scalars['String']['input'];
  /** User middle name */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** User phone number */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** User preferred name */
  readonly preferredName?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for client profile data for bulk update */
export type AdvisorClientProfileInput = {
  /** Client date of birth */
  readonly dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Client employer name */
  readonly employerName?: InputMaybe<Scalars['String']['input']>;
  /** Client employment status */
  readonly employmentStatus?: InputMaybe<Scalars['String']['input']>;
  /** Client profile ID */
  readonly id: Scalars['ID']['input'];
  /** Client job title */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Client SSN */
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
};

export const AdvisorDirectedOnboardingSource = {
  /** Off — via the flag default (fallthrough), not targeted */
  DefaultOff: 'DEFAULT_OFF',
  /** On — via the flag default (fallthrough), not targeted */
  DefaultOn: 'DEFAULT_ON',
  /** Off — individually targeted to the false variation */
  ExplicitOff: 'EXPLICIT_OFF',
  /** On — individually targeted to the true variation */
  ExplicitOn: 'EXPLICIT_ON',
  /** Off — the flag is turned off globally */
  FlagOff: 'FLAG_OFF',
  /** Off — via a targeting rule, not individually targeted */
  RuleOff: 'RULE_OFF',
  /** On — via a targeting rule, not individually targeted */
  RuleOn: 'RULE_ON',
  /** Status could not be evaluated (LD error / client not ready) */
  Unavailable: 'UNAVAILABLE',
  /** Unrecognized evaluation reason (e.g. a prerequisite failure this flag should not have) */
  Unexpected: 'UNEXPECTED'
} as const;

export type AdvisorDirectedOnboardingSource = typeof AdvisorDirectedOnboardingSource[keyof typeof AdvisorDirectedOnboardingSource];
export type AdvisorDirectedOnboardingStatus = {
  readonly __typename?: 'AdvisorDirectedOnboardingStatus';
  /**
   * Whether the `advisor-directed-onboarding` LD flag evaluates ON for this
   * advisor. Scope: FE onboarding task-creation + Fee Schedule surfaces only — NOT
   * the backend cockpit / staged-book gate, which is the separate
   * `flag-advisor-onboarding` flag.
   */
  readonly effectiveValue: Scalars['Boolean']['output'];
  /** Why `advisor-directed-onboarding` resolved that way (target vs rule vs fallthrough vs off). */
  readonly source: AdvisorDirectedOnboardingSource;
};

/** A single advisor in the firm-wide directory. */
export type AdvisorDirectoryEntry = {
  readonly __typename?: 'AdvisorDirectoryEntry';
  /** Advisor bio. */
  readonly bio?: Maybe<Scalars['String']['output']>;
  /** Scheduling link for the contact row. */
  readonly calendlyLink?: Maybe<Scalars['String']['output']>;
  /** Join date; powers the recently-joined lens. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Client-facing DBA email; nil falls back to login email. */
  readonly dbaEmail?: Maybe<Scalars['String']['output']>;
  /** The directory entry id (the advisor user id lives on `user`). */
  readonly id: Scalars['ID']['output'];
  /** Directory-facing profile fields. */
  readonly profile: DirectoryProfile;
  /** Team affiliation; null for solo advisors. */
  readonly team?: Maybe<DirectoryTeam>;
  /** Advisor title. */
  readonly title?: Maybe<Scalars['String']['output']>;
  /** Directory-safe user fields. */
  readonly user: DirectoryUser;
};

/** The connection type for AdvisorDirectoryEntry. */
export type AdvisorDirectoryEntryConnection = {
  readonly __typename?: 'AdvisorDirectoryEntryConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AdvisorDirectoryEntryEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<AdvisorDirectoryEntry>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdvisorDirectoryEntryEdge = {
  readonly __typename?: 'AdvisorDirectoryEntryEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<AdvisorDirectoryEntry>;
};

/** Sort order for the advisor directory roster. */
export const AdvisorDirectorySortEnum = {
  /** By first name, then last name (default). */
  Alphabetical: 'ALPHABETICAL',
  /** Longest tenure first (earliest join date). */
  TenureLongestFirst: 'TENURE_LONGEST_FIRST',
  /** Shortest tenure first (most recent join date). */
  TenureShortestFirst: 'TENURE_SHORTEST_FIRST'
} as const;

export type AdvisorDirectorySortEnum = typeof AdvisorDirectorySortEnum[keyof typeof AdvisorDirectorySortEnum];
export type AdvisorGroup = {
  readonly __typename?: 'AdvisorGroup';
  readonly advisors: ReadonlyArray<Advisor>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** When true, ARR is hidden from support-staff team members (assistants and CSAs) */
  readonly hideRevenueFromSupportRoles: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly members: ReadonlyArray<Advisor>;
  readonly name: Scalars['String']['output'];
  readonly organization?: Maybe<Organization>;
  readonly representationType: AdvisorGroupRepresentation;
  /**
   * Whether any advisor-role member of this group has a Dialpad sender — the
   * minimum for a client text to leave the building. False whenever the viewer has
   * text notifications switched off, since the send path is gated on the same flag.
   */
  readonly textMessagingAvailable: Scalars['Boolean']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for AdvisorGroup. */
export type AdvisorGroupConnection = {
  readonly __typename?: 'AdvisorGroupConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AdvisorGroupEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<AdvisorGroup>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdvisorGroupEdge = {
  readonly __typename?: 'AdvisorGroupEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<AdvisorGroup>;
};

/**
 * The fee schedules on an advisor group's client households: won households whose
 * primary advisor is an active member, assigned to the group or unassigned with
 * this as the advisor's home group (their only team, or their individual group
 * when they are on no team), and that the caller can access.
 */
export type AdvisorGroupFeeSchedules = {
  readonly __typename?: 'AdvisorGroupFeeSchedules';
  /** Client households covered by both breakdowns */
  readonly householdCount: Scalars['Int']['output'];
  /** The active fee schedules recorded on the households, grouped by identical terms, most households first */
  readonly householdFeeSchedules: ReadonlyArray<HouseholdFeeScheduleUsage>;
  /** The households' accounts grouped by the fee schedule Orion bills them on, most accounts first */
  readonly orionBillingSchedules: ReadonlyArray<OrionBillingScheduleUsage>;
};

export const AdvisorGroupRepresentation = {
  /** group */
  Group: 'group',
  /** individual */
  Individual: 'individual'
} as const;

export type AdvisorGroupRepresentation = typeof AdvisorGroupRepresentation[keyof typeof AdvisorGroupRepresentation];
export type AdvisorGroupSettingsInput = {
  readonly hideRevenueFromSupportRoles?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An advisor's captured identity profile (voice, per-client tonal override, etc.). */
export type AdvisorIdentityProfile = {
  readonly __typename?: 'AdvisorIdentityProfile';
  /** When extraction last completed */
  readonly extractedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** pending | extracting | review | active | failed | abandoned */
  readonly extractionStatus: Scalars['String']['output'];
  /** Profile ID */
  readonly id: Scalars['ID']['output'];
  /**
   * True when this is the worker-written empty-scan fallback an advisor has never
   * committed (active, source=game, empty traits). The frontend routes this state
   * to a re-scan card / placeholder capture flow instead of treating it as a
   * committed voice.
   */
  readonly isEmptyFallbackPlaceholder: Scalars['Boolean']['output'];
  /** Row type: voice or client_tonal_override */
  readonly kind: Scalars['String']['output'];
  /** Structured voice payload — what SAI drafting consumes */
  readonly payload: VoiceProfilePayload;
  /** Template version of the stored voice_prompt_fragment */
  readonly payloadVersion: Scalars['Int']['output'];
  /** sha256-prefix hash for client_tonal_override; null for voice */
  readonly scopeKey?: Maybe<Scalars['String']['output']>;
  /** scan | game | game_plus_scan | seeded */
  readonly source: Scalars['String']['output'];
  /** Last updated timestamp */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Outcome of a non-destructive book re-upload merge, bucketed per staged household. */
export type AdvisorOnboardingBookMergeSummary = {
  readonly __typename?: 'AdvisorOnboardingBookMergeSummary';
  /** Households created by this upload. */
  readonly created: ReadonlyArray<AdvisorOnboardingStagedHousehold>;
  /** Number of households created by this upload. */
  readonly createdCount: Scalars['Int']['output'];
  /** Households from a prior upload not present in this file; preserved, not deleted. */
  readonly preservedButAbsent: ReadonlyArray<AdvisorOnboardingStagedHousehold>;
  /** Number of prior households absent from this upload. */
  readonly preservedButAbsentCount: Scalars['Int']['output'];
  /** Matched households already promoted (in-flight); left untouched. Read `status` for the current stage. */
  readonly skippedInFlight: ReadonlyArray<AdvisorOnboardingStagedHousehold>;
  /** Number of in-flight households left untouched. */
  readonly skippedInFlightCount: Scalars['Int']['output'];
  /** Matched households with no downstream action yet, updated with the new spreadsheet data. */
  readonly updated: ReadonlyArray<AdvisorOnboardingStagedHousehold>;
  /** Number of households updated by this upload. */
  readonly updatedCount: Scalars['Int']['output'];
};

/** An account shown against a household in the Book Transfer Cockpit. */
export type AdvisorOnboardingCockpitAccount = {
  readonly __typename?: 'AdvisorOnboardingCockpitAccount';
  /** Account owner or label. */
  readonly accountName?: Maybe<Scalars['String']['output']>;
  /** Account type. Null for a same-custodian transfer, which records none. */
  readonly accountType?: Maybe<Scalars['String']['output']>;
  /**
   * Custodian the account is transferring FROM. For a same-custodian transfer that
   * is also where it stays. On an open-only account this is whatever the import
   * row named, not a source of assets — see transferring.
   */
  readonly custodian?: Maybe<Scalars['String']['output']>;
  /** Source-prefixed identifier, unique across account sources. */
  readonly id: Scalars['ID']['output'];
  /** True when ops must handle this account outside IWS auto-open (confirmation leftovers such as SEP, SIMPLE, trust, or 529). */
  readonly needsOps: Scalars['Boolean']['output'];
  /** Account number. */
  readonly number?: Maybe<Scalars['String']['output']>;
  /**
   * False when the account is only being opened at its destination custodian and
   * no assets are arriving, so nothing about it is a transfer.
   */
  readonly transferring: Scalars['Boolean']['output'];
};

/** Whether the advisor joined Savvy as a new advisor or was already here with a book */
export const AdvisorOnboardingCohort = {
  /** existing_advisor */
  ExistingAdvisor: 'existing_advisor',
  /** new_advisor */
  NewAdvisor: 'new_advisor'
} as const;

export type AdvisorOnboardingCohort = typeof AdvisorOnboardingCohort[keyof typeof AdvisorOnboardingCohort];
/** A reviewed name change on one imported record. */
export type AdvisorOnboardingCorrectionChange = {
  readonly __typename?: 'AdvisorOnboardingCorrectionChange';
  /** Reviewed replacement value. */
  readonly afterValue: Scalars['String']['output'];
  /** Value before the correction. */
  readonly beforeValue: Scalars['String']['output'];
  /** Affected record identifier. */
  readonly id: Scalars['ID']['output'];
  /** Affected field label. */
  readonly label: Scalars['String']['output'];
  /** Record shared by changes to its separate name fields. */
  readonly recordId: Scalars['ID']['output'];
  /** Whether this value has an optional Hide control. */
  readonly sensitive: Scalars['Boolean']['output'];
};

export type AdvisorOnboardingCorrectionField = {
  readonly __typename?: 'AdvisorOnboardingCorrectionField';
  /** Imported person selected for this field. */
  readonly clientId: Scalars['ID']['output'];
  /** Registered correction field. */
  readonly field: Scalars['String']['output'];
  /** Correction record identifier. */
  readonly id: Scalars['ID']['output'];
  /** Current editable values for this field. */
  readonly inputs: ReadonlyArray<AdvisorOnboardingCorrectionInput>;
  /** Display label for this field. */
  readonly label: Scalars['String']['output'];
  /** Record selected within the household. */
  readonly recordId: Scalars['ID']['output'];
  /** Person or account associated with the field. */
  readonly recordLabel: Scalars['String']['output'];
};

export type AdvisorOnboardingCorrectionInput = {
  readonly __typename?: 'AdvisorOnboardingCorrectionInput';
  /** Input control used to enter the value. */
  readonly inputType: Scalars['String']['output'];
  /** Input key accepted by the correction service. */
  readonly key: Scalars['String']['output'];
  /** Display label for this field. */
  readonly label: Scalars['String']['output'];
  /** Display labels corresponding to permitted values. */
  readonly optionLabels: ReadonlyArray<Scalars['String']['output']>;
  /** Permitted values for this input. */
  readonly options: ReadonlyArray<Scalars['String']['output']>;
  /** Current input value. */
  readonly value: Scalars['String']['output'];
};

/** An immutable, completed admin correction of imported draft names. */
export type AdvisorOnboardingCorrectionOperation = {
  readonly __typename?: 'AdvisorOnboardingCorrectionOperation';
  /** Admin name recorded at the time of correction. */
  readonly actorLabel: Scalars['String']['output'];
  /** Recorded changes. */
  readonly changes: ReadonlyArray<AdvisorOnboardingCorrectionChange>;
  /** When the correction committed. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Corrected name field. */
  readonly field: Scalars['String']['output'];
  /** Correction identifier. */
  readonly id: Scalars['ID']['output'];
  /** Reason provided by the admin. */
  readonly reason: Scalars['String']['output'];
};

/** An admin-bound review of an imported draft correction, valid for ten minutes. */
export type AdvisorOnboardingCorrectionPreview = {
  readonly __typename?: 'AdvisorOnboardingCorrectionPreview';
  /** Admin who will be recorded for this correction. */
  readonly actorLabel: Scalars['String']['output'];
  /** Every affected imported record. */
  readonly changes: ReadonlyArray<AdvisorOnboardingCorrectionChange>;
  /** Reviewed name field. */
  readonly field: Scalars['String']['output'];
  /** Opaque review token required to apply this exact change. */
  readonly token: Scalars['String']['output'];
};

/** An advisor onboarding enrollment (process root) — the restorable handle backing the intake wizard. */
export type AdvisorOnboardingEnrollment = {
  readonly __typename?: 'AdvisorOnboardingEnrollment';
  /** Wizard resume position. */
  readonly currentStep: Scalars['String']['output'];
  /** Internal enrollment id. */
  readonly id: Scalars['ID']['output'];
  /** Parsed households from the transition spreadsheet. */
  readonly stagedHouseholds: ReadonlyArray<AdvisorOnboardingStagedHousehold>;
  /** Lifecycle state (enrolled / completed). */
  readonly state: Scalars['String']['output'];
  /** Immutable public handle for deeplinks, logs, and wizard resume. */
  readonly uuid: Scalars['ID']['output'];
};

/** Per-advisor onboarding email branding shown on the Personalize screen and reused by the ECI send. */
export type AdvisorOnboardingPersonalization = {
  readonly __typename?: 'AdvisorOnboardingPersonalization';
  /** URL of the uploaded firm logo */
  readonly firmLogoUrl?: Maybe<Scalars['String']['output']>;
  /** Advisor firm name used for onboarding email branding */
  readonly firmName?: Maybe<Scalars['String']['output']>;
  /** Personalization record id */
  readonly id: Scalars['ID']['output'];
  /** Custom welcome message shown to onboarding clients */
  readonly welcomeMessage?: Maybe<Scalars['String']['output']>;
};

/** A staged account parsed into the advisor onboarding book, pre-promotion. */
export type AdvisorOnboardingStagedAccount = {
  readonly __typename?: 'AdvisorOnboardingStagedAccount';
  /** Account owner/label from the spreadsheet. */
  readonly accountName?: Maybe<Scalars['String']['output']>;
  /** Destination-registration stakeholders */
  readonly accountStakeholders: ReadonlyArray<EciAccountOnboardingStakeholder>;
  /** Account type from the spreadsheet. */
  readonly accountType?: Maybe<Scalars['String']['output']>;
  /** Inherited IRA beneficiary shape */
  readonly bdaBeneficiaryKind?: Maybe<EciBdaBeneficiaryKind>;
  /** Beneficiaries */
  readonly beneficiaries: ReadonlyArray<EciAccountBeneficiary>;
  /**
   * Custodian the account is being transferred FROM, as imported from the
   * spreadsheet. Not the destination — see `destination`.
   */
  readonly custodian?: Maybe<Scalars['String']['output']>;
  /** Inherited IRA original-depositor information */
  readonly decedentInformation?: Maybe<EciAccountDecedentInformation>;
  /** Custodian this account is headed TO. fidelity_nfs (the default) is the ECI pipe. */
  readonly destination: EciDestinationCustodian;
  /** SIMPLE IRA employer information */
  readonly employerInformation?: Maybe<EciAccountEmployerInformation>;
  /** Per-field validation errors keyed by camelCase field name. */
  readonly errors: Scalars['JSON']['output'];
  /** Estimated balance being transferred for this account. */
  readonly estimatedBalance?: Maybe<Scalars['BigDecimal']['output']>;
  /** True when the imported account type is an individual transfer-on-death designation. */
  readonly hasTransferOnDeathDesignation: Scalars['Boolean']['output'];
  /** Staging row identifier. */
  readonly id: Scalars['ID']['output'];
  /** Validation errors encountered while staging this account. */
  readonly importErrors: Scalars['JSON']['output'];
  /** Joint owners */
  readonly jointOwners: ReadonlyArray<EciAccountJointOwner>;
  /** Account number from the spreadsheet. */
  readonly number?: Maybe<Scalars['String']['output']>;
  /** Recurring transfers (structured records for subform prefill) */
  readonly recurringTransfers: ReadonlyArray<EciAccountRecurringTransfer>;
  /** ECI registration type serialize value derived from the imported label; null when unrecognized. */
  readonly registrationType?: Maybe<Scalars['String']['output']>;
  /** Standing instructions (full records for subform prefill) */
  readonly standingInstructions: ReadonlyArray<EciAccountStandingInstruction>;
  /** Transfer method for ECI onboarding. */
  readonly transferMethod: EciAccountTransferType;
  /** Legal-entity information, if required by the registration */
  readonly trustInformation?: Maybe<EciAccountTrustInformation>;
  /** ECI subform group derived from the imported account-type label; null when unrecognized. */
  readonly typeGroup?: Maybe<EciAccountTypeGroup>;
};

/** A staged client parsed into the advisor onboarding book, pre-promotion. */
export type AdvisorOnboardingStagedClient = {
  readonly __typename?: 'AdvisorOnboardingStagedClient';
  /** Client date of birth. */
  readonly dob?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Client email address. */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** Per-field validation errors keyed by camelCase field name. */
  readonly errors: Scalars['JSON']['output'];
  /** Client first name. */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** Staging row identifier. */
  readonly id: Scalars['ID']['output'];
  /** Validation errors encountered while staging this client. */
  readonly importErrors: Scalars['JSON']['output'];
  /** Client last name. */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** Client phone number. */
  readonly phone?: Maybe<Scalars['String']['output']>;
  /** Client role within the household (primary or co). */
  readonly role: Scalars['String']['output'];
};

/** A staged household parsed into the advisor onboarding book, pre-promotion. */
export type AdvisorOnboardingStagedHousehold = {
  readonly __typename?: 'AdvisorOnboardingStagedHousehold';
  /** Why the household is blocked, when it is. */
  readonly blockedReason?: Maybe<Scalars['String']['output']>;
  /** Current values for supported draft corrections. */
  readonly correctionFields: ReadonlyArray<AdvisorOnboardingCorrectionField>;
  /** Recent draft corrections; visible to admins and read-only admins. */
  readonly correctionHistory?: Maybe<ReadonlyArray<AdvisorOnboardingCorrectionOperation>>;
  /** Why an admin draft correction is currently unavailable. */
  readonly correctionUnavailableReason?: Maybe<Scalars['String']['output']>;
  /** Household label: the spreadsheet household name, else the promoted household, the primary client, or the external key. */
  readonly displayName: Scalars['String']['output'];
  /**
   * True while the advisor can still edit this household. False once it has been
   * sent to the client — upload-review edits are read-only from then on.
   */
  readonly draft: Scalars['Boolean']['output'];
  /** Parent enrollment uuid — needed to re-promote after contact repairs. */
  readonly enrollmentUuid: Scalars['ID']['output'];
  /** Per-field validation errors keyed by camelCase field name. */
  readonly errors: Scalars['JSON']['output'];
  /** Estimated assets under management. */
  readonly estAum?: Maybe<Scalars['BigDecimal']['output']>;
  /** Stable key derived from the spreadsheet household name. */
  readonly externalKey?: Maybe<Scalars['String']['output']>;
  /** Canonical household id after promotion. Null pre-promotion. */
  readonly householdId?: Maybe<Scalars['ID']['output']>;
  /** Household name from the transition spreadsheet. */
  readonly householdName?: Maybe<Scalars['String']['output']>;
  /** Canonical household public id (uuid) after promotion. Null pre-promotion. */
  readonly householdUuid?: Maybe<Scalars['ID']['output']>;
  /** Staging row identifier. */
  readonly id: Scalars['ID']['output'];
  /** Validation errors encountered while staging this household. */
  readonly importErrors: Scalars['JSON']['output'];
  /** All accounts linked to this household request, including confirmed. For post-confirm detail views. */
  readonly onboardingAccounts: ReadonlyArray<AdvisorOnboardingCockpitAccount>;
  /** Accounts staged for this household. */
  readonly stagedAccounts: ReadonlyArray<AdvisorOnboardingStagedAccount>;
  /** Clients staged for this household. */
  readonly stagedClients: ReadonlyArray<AdvisorOnboardingStagedClient>;
  /** Lifecycle status in the cockpit. */
  readonly status: Scalars['String']['output'];
  /** Immutable public handle for confirm/send deeplinks. */
  readonly uuid: Scalars['ID']['output'];
};

/** The advisor's Ops contact (CSA) shown on the onboarding welcome screen. */
export type AdvisorOpsContact = {
  readonly __typename?: 'AdvisorOpsContact';
  /** Ops contact email */
  readonly email: Scalars['String']['output'];
  /** Ops contact first name */
  readonly firstName: Scalars['String']['output'];
  /** Ops contact full name */
  readonly name: Scalars['String']['output'];
};

/** The advisor's bill style */
export const AdvisorProfileBillStyle = {
  /** advanced */
  Advanced: 'advanced',
  /** arrear */
  Arrear: 'arrear'
} as const;

export type AdvisorProfileBillStyle = typeof AdvisorProfileBillStyle[keyof typeof AdvisorProfileBillStyle];
/** The advisor's billing frequency */
export const AdvisorProfileBillingFrequency = {
  /** monthly */
  Monthly: 'monthly',
  /** quarterly */
  Quarterly: 'quarterly'
} as const;

export type AdvisorProfileBillingFrequency = typeof AdvisorProfileBillingFrequency[keyof typeof AdvisorProfileBillingFrequency];
/**
 * A report schedule visible to the current advisor across every template they can
 * see, with cross-household reach and latest execution status.
 */
export type AdvisorReportSchedule = {
  readonly __typename?: 'AdvisorReportSchedule';
  /** Whether the schedule is currently enabled */
  readonly active: Scalars['Boolean']['output'];
  /** Whether PDFs are uploaded to Box */
  readonly deliverToBox: Scalars['Boolean']['output'];
  /** Whether reports are published to the client portal */
  readonly deliverToPortal: Scalars['Boolean']['output'];
  /** Day of month (1-28) when the schedule fires */
  readonly deliveryDay: Scalars['Int']['output'];
  /** Month (1-12) an annual schedule fires; null means January */
  readonly deliveryMonth?: Maybe<Scalars['Int']['output']>;
  /** Cadence: monthly, quarterly, or annually */
  readonly frequency: Scalars['String']['output'];
  /** Number of households this schedule currently targets */
  readonly householdCount: Scalars['Int']['output'];
  /** Schedule id */
  readonly id: Scalars['ID']['output'];
  /** When the most recent execution was created (enqueued), not necessarily when it finished */
  readonly lastExecutionAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Error message from the most recent execution, if failed */
  readonly lastExecutionError?: Maybe<Scalars['String']['output']>;
  /**
   * Status of the most recent execution, across every household this schedule has
   * ever run for -- not limited to its current target set
   */
  readonly lastExecutionStatus?: Maybe<Scalars['String']['output']>;
  /** When the schedule last fired */
  readonly lastRunAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Next scheduled execution time */
  readonly nextDueAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The saved template this schedule automates */
  readonly savedReportTemplateId: Scalars['ID']['output'];
  /** Saved report template name */
  readonly templateName: Scalars['String']['output'];
};

export type AdvisorSettingsInput = {
  /** The advisor's ADV Part 2B document link, set by onboarding automation when the 2B is finalized. */
  readonly adv2bLink?: InputMaybe<Scalars['String']['input']>;
  readonly alertsOnForAccountOpenedOrFunded?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForAllocationVariance?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForAutoAdvanceBlockedMissingAum?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForBirthdays?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForCashVariance?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForClientEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForClientLogins?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForClientPortalMessageReceived?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForClientSubmittedRiskQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForClientUploadedRequestedFile?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForContributionReceived?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForDocusignOutstanding?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForHubspotLeadCreated?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForLeadEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForNewLeadCampaignStarted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForOnboardingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForOutstandingClientTask?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForOverdueAdvisorTask?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForQuarterlyReportFailed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForQuarterlyReportGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForRmds?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForServiceCalendarDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForServiceCalendarSetup?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForServiceCalendarTaskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForServiceCalendarUpcomingMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForStagnantProspect?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForSubtaskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForSubtaskDueApproaching?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForTransferIn?: InputMaybe<Scalars['Boolean']['input']>;
  readonly birthdayNotificationDaysInAdvance?: InputMaybe<Scalars['Int']['input']>;
  readonly birthdayNotificationsForClients?: InputMaybe<Scalars['Boolean']['input']>;
  readonly birthdayNotificationsForProspects?: InputMaybe<Scalars['Boolean']['input']>;
  readonly cashAllocationThresholdPercentage?: InputMaybe<Scalars['Int']['input']>;
  /** Days a DocuSign envelope may stay outstanding before the advisor is alerted */
  readonly docusignOutstandingThresholdDays?: InputMaybe<Scalars['Int']['input']>;
  readonly minimumAccountValue?: InputMaybe<Scalars['Int']['input']>;
  readonly newLeadCampaignStartedChannelPreference?: InputMaybe<AlertChannel>;
  readonly preferredWeeksBetweenClientEngagement?: InputMaybe<Scalars['Int']['input']>;
  /** When true, clients see a Calendly 'Schedule' button for this advisor on the client dashboard. */
  readonly showSchedulingToClients?: InputMaybe<Scalars['Boolean']['input']>;
  readonly targetAllocationVarianceThresholdPercentage?: InputMaybe<Scalars['Int']['input']>;
  readonly viewAdvisorGroupClients?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ordered array of 3-5 stat card keys for the workbench landing page */
  readonly workbenchStatCardKeys?: InputMaybe<ReadonlyArray<WorkbenchStatKey>>;
  /** When true, stat cards show only the advisor's own households instead of the full practice */
  readonly workbenchStatMyClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A tenure cohort for the advisor directory, derived from the advisor join date. */
export const AdvisorTenureBucketEnum = {
  /** Joined within the last 3 months. */
  Onboarding: 'ONBOARDING',
  /** Joined more than 12 months ago. */
  OverTwelveMonths: 'OVER_TWELVE_MONTHS',
  /** Joined 6 to 12 months ago. */
  SixToTwelveMonths: 'SIX_TO_TWELVE_MONTHS',
  /** Joined 3 to 6 months ago. */
  ThreeToSixMonths: 'THREE_TO_SIX_MONTHS'
} as const;

export type AdvisorTenureBucketEnum = typeof AdvisorTenureBucketEnum[keyof typeof AdvisorTenureBucketEnum];
/**
 * Advisor-tier level of a team member. ASSISTANT/ADVISOR/ADMIN, where ADMIN is an
 * advisor with firm administrative privileges
 * (advisor_profile.can_edit_organization).
 */
export const AdvisorTierLevel = {
  /** Firm admin (role: advisor with can_edit_organization) */
  Admin: 'ADMIN',
  /** Advisor (role: advisor, no org-edit) */
  Advisor: 'ADVISOR',
  /** Assistant (role: assistant) */
  Assistant: 'ASSISTANT'
} as const;

export type AdvisorTierLevel = typeof AdvisorTierLevel[keyof typeof AdvisorTierLevel];
/** A household's advisory agreement draft (MSA or IAA) and whether it can be regenerated. */
export type AdvisoryAgreementDraft = {
  readonly __typename?: 'AdvisoryAgreementDraft';
  /** The household's advisory contract (MSA or IAA). Nil column stamps as the MSA default. */
  readonly agreementType: EciAgreement;
  /**
   * Box preview link for the prefilled draft. Null until the household has an
   * active fee schedule to fill it from, or when Box is unreachable.
   */
  readonly draftUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Name of the household's active fee schedule, which is what the draft's fee
   * rows were filled from. Null when none has been assigned yet.
   */
  readonly feeScheduleName?: Maybe<Scalars['String']['output']>;
  /**
   * Whether any client has signed. Regeneration is refused once true, because the
   * signed copy is built from the draft the client saw.
   */
  readonly signed: Scalars['Boolean']['output'];
};

/** One proposed change to one field of one household record. */
export type AgentProposal = {
  readonly __typename?: 'AgentProposal';
  /** The value the advisor corrected the proposal to. */
  readonly acceptedValue?: Maybe<Scalars['String']['output']>;
  /** The Box file the value was read from. */
  readonly boxFileId?: Maybe<Scalars['String']['output']>;
  /** The Box file version that was read. */
  readonly boxVersionId?: Maybe<Scalars['String']['output']>;
  /** Progress toward creating the new record this proposal belongs to. */
  readonly bundle?: Maybe<AgentProposalBundle>;
  /** Records the proposal may be about when the match is not exact. */
  readonly candidates: ReadonlyArray<AgentProposalCandidate>;
  /** When the decision was recorded. */
  readonly decidedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The user who decided the proposal. */
  readonly decidedByUserId?: Maybe<Scalars['ID']['output']>;
  /** How the decision was made. */
  readonly decidedVia?: Maybe<Scalars['String']['output']>;
  /** The kind of record the proposal changes. */
  readonly entity: Scalars['String']['output'];
  /** The write-registry field the proposal changes. */
  readonly fieldKey: Scalars['String']['output'];
  /** Reasons the proposal needs a closer look; empty means confident. */
  readonly flags: ReadonlyArray<Scalars['String']['output']>;
  /** The proposal identifier. */
  readonly id: Scalars['ID']['output'];
  /** The value on file when the proposal was made. */
  readonly onFileValue?: Maybe<Scalars['String']['output']>;
  /** The page in the original file the value was read from. */
  readonly pageLocator?: Maybe<Scalars['String']['output']>;
  /** The last day of the period the value is about. */
  readonly periodEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The first day of the period the value is about. */
  readonly periodStart?: Maybe<Scalars['ISO8601Date']['output']>;
  /** What produced the proposal. */
  readonly producer: Scalars['String']['output'];
  /** The value read from the source. */
  readonly proposedValue?: Maybe<Scalars['String']['output']>;
  /** The date of the source document. */
  readonly sourceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The kind of source document. */
  readonly sourceKind?: Maybe<Scalars['String']['output']>;
  /** The proposal status. */
  readonly status: Scalars['String']['output'];
  /** Why the proposal reached its status. */
  readonly statusReason?: Maybe<Scalars['String']['output']>;
  /** The record the proposal changes, or the new record it would create. */
  readonly targetKey: Scalars['String']['output'];
};

/** Progress toward creating a new record from its proposals. */
export type AgentProposalBundle = {
  readonly __typename?: 'AgentProposalBundle';
  /** Required fields that have an accepted or corrected value. */
  readonly answered: Scalars['Int']['output'];
  /** Fields the record needs before it can be created. */
  readonly required: Scalars['Int']['output'];
};

/** A record the proposal may be about. */
export type AgentProposalCandidate = {
  readonly __typename?: 'AgentProposalCandidate';
  /** A readable name for the record. */
  readonly label?: Maybe<Scalars['String']['output']>;
  /** The record identifier. */
  readonly recordId: Scalars['ID']['output'];
  /** The record kind. */
  readonly recordType: Scalars['String']['output'];
};

export type Alert = {
  readonly __typename?: 'Alert';
  readonly actorKind: AlertActorKind;
  readonly actorName?: Maybe<Scalars['String']['output']>;
  readonly actorProfilePicUrl?: Maybe<Scalars['String']['output']>;
  readonly actorUserId?: Maybe<Scalars['ID']['output']>;
  readonly actorVerb?: Maybe<Scalars['String']['output']>;
  /** Raw comment body for the inbox snippet, present only when the author supplied one. */
  readonly commentBody?: Maybe<Scalars['String']['output']>;
  /** TaskActivity id of the comment this alert is about, for deep-linking. */
  readonly commentId?: Maybe<Scalars['ID']['output']>;
  readonly content: Scalars['String']['output'];
  /** Dollar amount of the contribution that triggered this alert */
  readonly contributionAmount?: Maybe<Scalars['Float']['output']>;
  /** invest_cash / create_enrollment / no_action, per ContributionAlerts::CreateFromRows */
  readonly contributionClassification?: Maybe<Scalars['String']['output']>;
  /** Full names of the other advisors this contribution alert was also sent to (excludes the viewer). */
  readonly contributionOtherRecipientNames: ReadonlyArray<Scalars['String']['output']>;
  /** When another advisor already handled this contribution */
  readonly contributionResolvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Advisor who handled this contribution, if any */
  readonly contributionResolvedByName?: Maybe<Scalars['String']['output']>;
  /** Task created by whichever advisor handled this contribution */
  readonly contributionResolvedTaskId?: Maybe<Scalars['ID']['output']>;
  /** salesforce_task_id of the resolved task, for click-through */
  readonly contributionResolvedTaskSalesforceId?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Number of alerts this node represents; 1 unless collapsed by group_bulk. */
  readonly groupCount: Scalars['Int']['output'];
  /** The individual alerts a collapsed node stands in for; empty on a normal alert. */
  readonly groupMembers: ReadonlyArray<Alert>;
  /** Summary headline for a collapsed bulk node (e.g. "8 accounts drifted past your cash threshold"); null on a normal alert. */
  readonly groupSummary?: Maybe<Scalars['String']['output']>;
  /** The household this alert resolves to, or null when it resolves none or the viewer cannot read it. */
  readonly household?: Maybe<Household>;
  /** Savvy ID of the household this alert resolves to; null when it resolves none or the viewer cannot read it. */
  readonly householdId?: Maybe<Scalars['ID']['output']>;
  /** Name of the household this alert resolves to; null when it resolves none or the viewer cannot read it. */
  readonly householdName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  /** Whether the recipient has archived, snoozed, or opened this alert. */
  readonly isAcknowledged: Scalars['Boolean']['output'];
  /**
   * The note this alert announces, when it announces one — the recap a
   * meeting-recap alert was raised for. Null for every other type.
   */
  readonly noteId?: Maybe<Scalars['ID']['output']>;
  /** User the alert is addressed to (its "you"); may differ from the viewer. */
  readonly recipientId: Scalars['ID']['output'];
  /** Full name of the alert's recipient. */
  readonly recipientName?: Maybe<Scalars['String']['output']>;
  readonly relatedEntity: AlertEntityItem;
  /**
   * When the alert was archived (status set to removed); null while
   * active/backlogged or for legacy rows removed before this was tracked.
   */
  readonly removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly shortName: AlertShortName;
  readonly snoozedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly status: AlertStatusName;
  readonly subject?: Maybe<Scalars['String']['output']>;
  readonly surfaceAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Calendar event of the alert's target Canvas document (meeting prep/recap), for
   * deep-linking to the meeting. Null unless the viewer is the recipient and the
   * doc is calendar-anchored.
   */
  readonly targetCalendarEventId?: Maybe<Scalars['ID']['output']>;
  /** Recipient-authorized Canvas document target. */
  readonly targetCanvasDocumentId?: Maybe<Scalars['ID']['output']>;
  readonly typeOf: AlertTypeName;
};

export const AlertActorKind = {
  /** advisor */
  Advisor: 'advisor',
  /** client */
  Client: 'client',
  /** savvy_cs */
  SavvyCs: 'savvy_cs',
  /** system */
  System: 'system'
} as const;

export type AlertActorKind = typeof AlertActorKind[keyof typeof AlertActorKind];
export type AlertArchived = {
  /** Seconds from surfacing to this action, for time-to-action. Omitted on a bulk action, or when surface_at is in the future. */
  readonly alertAgeSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Public id of the alert acted on, so a notification clicked and later archived counts once. Omitted on a bulk action. */
  readonly alertId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Public ids of every alert a bulk action covered, so it can be matched to what
   * was delivered. Omitted by clients that predate it.
   */
  readonly alertIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Alert::TypeOf of the alert acted on. Omitted on a bulk action spanning several types. */
  readonly alertType?: InputMaybe<Scalars['String']['input']>;
  /** Number of inbox alerts archived in one action (a collapsed bulk card fans out over several). */
  readonly count: Scalars['Int']['input'];
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  /** Where the action happened — "inbox", "flyout", "archived" or "snoozed". Absent from mobile, which has one surface. */
  readonly surface?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export const AlertChannel = {
  Email: 'email',
  Off: 'off',
  Sms: 'sms'
} as const;

export type AlertChannel = typeof AlertChannel[keyof typeof AlertChannel];
export type AlertClicked = {
  /** Seconds from surfacing to this click, for time-to-action. Omitted when surface_at is in the future. */
  readonly alertAgeSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Public id of the alert acted on, so a notification clicked and later archived counts once. Omitted on a bulk action. */
  readonly alertId?: InputMaybe<Scalars['String']['input']>;
  /** Alert::TypeOf of the clicked alert — e.g. "outstanding_client_task". */
  readonly alertType: Scalars['String']['input'];
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  /** Where the click happened — "inbox", "flyout", "archived" or "snoozed". */
  readonly surface: Scalars['String']['input'];
  /** What the click deep-linked to — e.g. "task", "household", "canvas_document". */
  readonly target?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

/** The connection type for Alert. */
export type AlertConnection = {
  readonly __typename?: 'AlertConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AlertEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Alert>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

export type AlertCountsBy = {
  readonly __typename?: 'AlertCountsBy';
  /** Counts grouped by Action Center filter-chip keys. */
  readonly byType: ReadonlyArray<AlertTypeCount>;
  /** Total active alerts after primary-advisor filtering. */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlertEdge = {
  readonly __typename?: 'AlertEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Alert>;
};

/**
 * Households, Users, Tasks, Sub-tasks, Accounts, contacts, companies, transcripts,
 * and survey rounds classified together as potential entities that can be related
 * to a co-pilot alert.
 */
export type AlertEntityItem = Account | AlertEntityTombstone | CenterOfInfluenceRep | Company | Contact | DialpadCallTranscript | Household | MeetingRecording | StateFiling | Subtask | SurveyRound | Task | TaxEnrollment | User | ZoomMeetingTranscript;

/**
 * Placeholder for an alert's related entity when the server cannot hand back a
 * record for it — the row is gone, or no other member of this union can represent
 * it yet. Carries the stored pointer so a client can render a degraded card and
 * support can trace the alert.
 */
export type AlertEntityTombstone = {
  readonly __typename?: 'AlertEntityTombstone';
  /** The alert's stored `entity_id`, verbatim. */
  readonly entityId: Scalars['ID']['output'];
  /** The alert's stored `entity_type`, verbatim. */
  readonly entityType: Scalars['String']['output'];
};

export type AlertSettings = {
  readonly __typename?: 'AlertSettings';
  readonly alertsOnForAccountOpenedOrFunded: Scalars['Boolean']['output'];
  readonly alertsOnForAllocationVariance: Scalars['Boolean']['output'];
  readonly alertsOnForAutoAdvanceBlockedMissingAum: Scalars['Boolean']['output'];
  readonly alertsOnForBirthdays: Scalars['Boolean']['output'];
  readonly alertsOnForCashVariance: Scalars['Boolean']['output'];
  readonly alertsOnForClientEngagement: Scalars['Boolean']['output'];
  readonly alertsOnForClientLogins: Scalars['Boolean']['output'];
  readonly alertsOnForClientPortalMessageReceived: Scalars['Boolean']['output'];
  readonly alertsOnForClientSubmittedRiskQuestionnaire: Scalars['Boolean']['output'];
  readonly alertsOnForClientUploadedRequestedFile: Scalars['Boolean']['output'];
  readonly alertsOnForContributionReceived: Scalars['Boolean']['output'];
  readonly alertsOnForDocusignOutstanding: Scalars['Boolean']['output'];
  readonly alertsOnForHubspotLeadCreated: Scalars['Boolean']['output'];
  readonly alertsOnForLeadEngagement: Scalars['Boolean']['output'];
  readonly alertsOnForNewLeadCampaignStarted: Scalars['Boolean']['output'];
  readonly alertsOnForOnboardingComplete: Scalars['Boolean']['output'];
  readonly alertsOnForOutstandingClientTask: Scalars['Boolean']['output'];
  readonly alertsOnForOverdueAdvisorTask: Scalars['Boolean']['output'];
  readonly alertsOnForQuarterlyReportFailed: Scalars['Boolean']['output'];
  readonly alertsOnForQuarterlyReportGenerated: Scalars['Boolean']['output'];
  readonly alertsOnForRmds: Scalars['Boolean']['output'];
  readonly alertsOnForServiceCalendarDueDate: Scalars['Boolean']['output'];
  readonly alertsOnForServiceCalendarSetup: Scalars['Boolean']['output'];
  readonly alertsOnForServiceCalendarTaskAssigned: Scalars['Boolean']['output'];
  readonly alertsOnForServiceCalendarUpcomingMeeting: Scalars['Boolean']['output'];
  readonly alertsOnForStagnantProspect: Scalars['Boolean']['output'];
  readonly alertsOnForSubtaskAssigned: Scalars['Boolean']['output'];
  readonly alertsOnForSubtaskDueApproaching: Scalars['Boolean']['output'];
  readonly alertsOnForTaxStatus: Scalars['Boolean']['output'];
  readonly alertsOnForTransferIn: Scalars['Boolean']['output'];
  readonly birthdayNotificationDaysInAdvance: Scalars['Int']['output'];
  readonly birthdayNotificationsForClients: Scalars['Boolean']['output'];
  readonly birthdayNotificationsForProspects: Scalars['Boolean']['output'];
  /** Alert when cash allocation exceeds this percentage */
  readonly cashAllocationThresholdPercentage: Scalars['Float']['output'];
  /** Whether to include money market holdings in cash variance calculations */
  readonly cashVarianceIncludeMoneyMarket: Scalars['Boolean']['output'];
  /** Days a DocuSign envelope may stay outstanding before the advisor is alerted */
  readonly docusignOutstandingThresholdDays: Scalars['Int']['output'];
  /** Master toggle for the legacy advisor-notification emails the advisor receives */
  readonly emailNotificationsEnabled: Scalars['Boolean']['output'];
  readonly minimumAccountValue: Scalars['Int']['output'];
  readonly newLeadCampaignStartedChannelPreference: AlertChannel;
  /**
   * When true, onboarding SMS sends from the advisor's Dialpad number instead of
   * the CSA's. Falls back to the CSA when the advisor has no Dialpad number provisioned.
   */
  readonly onboardingSmsFromAdvisor: Scalars['Boolean']['output'];
  /** Custom sender display name used in onboarding SMS. When blank, falls back to the sender's first name. */
  readonly onboardingSmsSenderName?: Maybe<Scalars['String']['output']>;
  readonly preferredWeeksBetweenClientEngagement: Scalars['Int']['output'];
  /** Master toggle for the legacy Slack notifications the advisor receives */
  readonly slackNotificationsEnabled: Scalars['Boolean']['output'];
  readonly targetAllocationVarianceThresholdPercentage: Scalars['Int']['output'];
  /** Days before the due date to send advisor task notifications (e.g. [0, 3] = day of and 3 days before) */
  readonly taskNotificationDaysInAdvance: ReadonlyArray<Scalars['Int']['output']>;
  /** Alert when total daily transfers exceed this percentage of account value */
  readonly transferInThresholdPercentage: Scalars['Float']['output'];
  /** Days before a service-calendar meeting to send the advisor reminder (0 = day of) */
  readonly upcomingMeetingReminderDaysInAdvance: Scalars['Int']['output'];
};

export type AlertSettingsInput = {
  readonly alertsOnForAccountOpenedOrFunded?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForAllocationVariance?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForAutoAdvanceBlockedMissingAum?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForBirthdays?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForCashVariance?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForClientEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForClientLogins?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForClientPortalMessageReceived?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForClientSubmittedRiskQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForClientUploadedRequestedFile?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForContributionReceived?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForDocusignOutstanding?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForHubspotLeadCreated?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForLeadEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForNewLeadCampaignStarted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForOnboardingComplete?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForOutstandingClientTask?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForOverdueAdvisorTask?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForQuarterlyReportFailed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForQuarterlyReportGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForRmds?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForServiceCalendarDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForServiceCalendarSetup?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForServiceCalendarTaskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForServiceCalendarUpcomingMeeting?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForStagnantProspect?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForSubtaskAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForSubtaskDueApproaching?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForTaxStatus?: InputMaybe<Scalars['Boolean']['input']>;
  readonly alertsOnForTransferIn?: InputMaybe<Scalars['Boolean']['input']>;
  readonly birthdayNotificationDaysInAdvance?: InputMaybe<Scalars['Int']['input']>;
  readonly birthdayNotificationsForClients?: InputMaybe<Scalars['Boolean']['input']>;
  readonly birthdayNotificationsForProspects?: InputMaybe<Scalars['Boolean']['input']>;
  /** Alert when cash allocation exceeds this percentage */
  readonly cashAllocationThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Whether to include money market holdings in cash variance calculations */
  readonly cashVarianceIncludeMoneyMarket?: InputMaybe<Scalars['Boolean']['input']>;
  /** Days a DocuSign envelope may stay outstanding before the advisor is alerted */
  readonly docusignOutstandingThresholdDays?: InputMaybe<Scalars['Int']['input']>;
  /** Master toggle for the legacy advisor-notification emails the advisor receives */
  readonly emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly minimumAccountValue?: InputMaybe<Scalars['Int']['input']>;
  readonly newLeadCampaignStartedChannelPreference?: InputMaybe<AlertChannel>;
  /** When true, onboarding SMS sends from the advisor's Dialpad number instead of the CSA's. */
  readonly onboardingSmsFromAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom sender display name used in onboarding SMS. When blank, falls back to the sender's first name. */
  readonly onboardingSmsSenderName?: InputMaybe<Scalars['String']['input']>;
  readonly preferredWeeksBetweenClientEngagement?: InputMaybe<Scalars['Int']['input']>;
  /** Master toggle for the legacy Slack notifications the advisor receives */
  readonly slackNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly targetAllocationVarianceThresholdPercentage?: InputMaybe<Scalars['Int']['input']>;
  /** Days before the due date to send advisor task notifications */
  readonly taskNotificationDaysInAdvance?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** Alert when total daily transfers exceed this percentage of account value */
  readonly transferInThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Days before a service-calendar meeting to send the advisor reminder */
  readonly upcomingMeetingReminderDaysInAdvance?: InputMaybe<Scalars['Int']['input']>;
};

export const AlertShortName = {
  New: 'New',
  Todo: 'Todo'
} as const;

export type AlertShortName = typeof AlertShortName[keyof typeof AlertShortName];
export type AlertSnoozed = {
  /** Seconds from surfacing to this action, for time-to-action. Omitted on a bulk action, or when surface_at is in the future. */
  readonly alertAgeSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Public id of the alert acted on, so a notification clicked and later archived counts once. Omitted on a bulk action. */
  readonly alertId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Public ids of every alert a bulk action covered, so it can be matched to what
   * was delivered. Omitted by clients that predate it.
   */
  readonly alertIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Alert::TypeOf of the alert acted on. Omitted on a bulk action spanning several types. */
  readonly alertType?: InputMaybe<Scalars['String']['input']>;
  /** Number of inbox alerts snoozed in one action (a collapsed bulk card fans out over several). */
  readonly count: Scalars['Int']['input'];
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  /** Where the action happened — "inbox", "flyout", "archived" or "snoozed". Absent from mobile, which has one surface. */
  readonly surface?: InputMaybe<Scalars['String']['input']>;
  /** When the snoozed alert(s) will resurface, for measuring how far out advisors defer. */
  readonly surfaceAt?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export const AlertStatusName = {
  Active: 'active',
  Backlogged: 'backlogged',
  Deferred: 'deferred',
  Removed: 'removed'
} as const;

export type AlertStatusName = typeof AlertStatusName[keyof typeof AlertStatusName];
export type AlertTypeCount = {
  readonly __typename?: 'AlertTypeCount';
  /** Number of active alerts in this chip group. */
  readonly count: Scalars['Int']['output'];
  /** Filter-chip key (e.g. EngageWithLead, birthdays). */
  readonly key: Scalars['String']['output'];
};

export const AlertTypeName = {
  /** account_confirmation_complete */
  AccountConfirmationComplete: 'account_confirmation_complete',
  /** account_linked_or_aggregation_added */
  AccountLinkedOrAggregationAdded: 'account_linked_or_aggregation_added',
  /** account_opened_or_funded */
  AccountOpenedOrFunded: 'account_opened_or_funded',
  /** account_setup_confirmation_sent */
  AccountSetupConfirmationSent: 'account_setup_confirmation_sent',
  /** advisor_requirements_needed */
  AdvisorRequirementsNeeded: 'advisor_requirements_needed',
  /** allocation_variance */
  AllocationVariance: 'allocation_variance',
  /** auto_advance_blocked_missing_aum */
  AutoAdvanceBlockedMissingAum: 'auto_advance_blocked_missing_aum',
  /** beneficiary_or_ownership_change */
  BeneficiaryOrOwnershipChange: 'beneficiary_or_ownership_change',
  /** birthdays */
  Birthdays: 'birthdays',
  /** call_step_required */
  CallStepRequired: 'call_step_required',
  /** cash_variance */
  CashVariance: 'cash_variance',
  /** center_of_influence_rep_comment_mention */
  CenterOfInfluenceRepCommentMention: 'center_of_influence_rep_comment_mention',
  /** client_completed_task */
  ClientCompletedTask: 'client_completed_task',
  /** client_completed_tax_enrollment */
  ClientCompletedTaxEnrollment: 'client_completed_tax_enrollment',
  /** client_engagement */
  ClientEngagement: 'client_engagement',
  /** client_logins */
  ClientLogins: 'client_logins',
  /** client_portal_message_received */
  ClientPortalMessageReceived: 'client_portal_message_received',
  /** client_signed_documents */
  ClientSignedDocuments: 'client_signed_documents',
  /** client_submitted_risk_questionnaire */
  ClientSubmittedRiskQuestionnaire: 'client_submitted_risk_questionnaire',
  /** client_uploaded_requested_file */
  ClientUploadedRequestedFile: 'client_uploaded_requested_file',
  /** company_comment_mention */
  CompanyCommentMention: 'company_comment_mention',
  /** contact_comment_mention */
  ContactCommentMention: 'contact_comment_mention',
  /** contribution_received */
  ContributionReceived: 'contribution_received',
  /** docusign_outstanding */
  DocusignOutstanding: 'docusign_outstanding',
  /** email_from_lead */
  EmailFromLead: 'email_from_lead',
  /** federal_return_accepted */
  FederalReturnAccepted: 'federal_return_accepted',
  /** federal_return_received */
  FederalReturnReceived: 'federal_return_received',
  /** federal_return_rejected */
  FederalReturnRejected: 'federal_return_rejected',
  /** file_upload_request_sent */
  FileUploadRequestSent: 'file_upload_request_sent',
  /** household_comment_mention */
  HouseholdCommentMention: 'household_comment_mention',
  /** hubspot_lead_created */
  HubspotLeadCreated: 'hubspot_lead_created',
  /** inbound_missed_call */
  InboundMissedCall: 'inbound_missed_call',
  /** intake_invite_reminder_sent */
  IntakeInviteReminderSent: 'intake_invite_reminder_sent',
  /** intake_invite_sent */
  IntakeInviteSent: 'intake_invite_sent',
  /** large_withdrawal_detected */
  LargeWithdrawalDetected: 'large_withdrawal_detected',
  /** meeting_booked_by_client */
  MeetingBookedByClient: 'meeting_booked_by_client',
  /** meeting_canceled_or_rescheduled_by_client */
  MeetingCanceledOrRescheduledByClient: 'meeting_canceled_or_rescheduled_by_client',
  /** meeting_prep_ready */
  MeetingPrepReady: 'meeting_prep_ready',
  /** meeting_recap_ready */
  MeetingRecapReady: 'meeting_recap_ready',
  /** meeting_transcript_needs_household */
  MeetingTranscriptNeedsHousehold: 'meeting_transcript_needs_household',
  /** new_lead_campaign_started */
  NewLeadCampaignStarted: 'new_lead_campaign_started',
  /** onboarding_complete */
  OnboardingComplete: 'onboarding_complete',
  /** onboarding_invite_reminder_sent */
  OnboardingInviteReminderSent: 'onboarding_invite_reminder_sent',
  /** onboarding_invite_sent */
  OnboardingInviteSent: 'onboarding_invite_sent',
  /** outbound_missed_call_reminder */
  OutboundMissedCallReminder: 'outbound_missed_call_reminder',
  /** outstanding_client_task */
  OutstandingClientTask: 'outstanding_client_task',
  /** overdue_advisor_task */
  OverdueAdvisorTask: 'overdue_advisor_task',
  /** pre_review_check_in_sent */
  PreReviewCheckInSent: 'pre_review_check_in_sent',
  /** quarterly_report_failed */
  QuarterlyReportFailed: 'quarterly_report_failed',
  /** quarterly_report_generated */
  QuarterlyReportGenerated: 'quarterly_report_generated',
  /** risk_questionnaire_sent */
  RiskQuestionnaireSent: 'risk_questionnaire_sent',
  /** rmds */
  Rmds: 'rmds',
  /** service_calendar_booking_reminder_sent */
  ServiceCalendarBookingReminderSent: 'service_calendar_booking_reminder_sent',
  /** service_calendar_due_date */
  ServiceCalendarDueDate: 'service_calendar_due_date',
  /** service_calendar_invite_sent */
  ServiceCalendarInviteSent: 'service_calendar_invite_sent',
  /** service_calendar_setup */
  ServiceCalendarSetup: 'service_calendar_setup',
  /** service_calendar_task_assigned */
  ServiceCalendarTaskAssigned: 'service_calendar_task_assigned',
  /** service_calendar_upcoming_meeting */
  ServiceCalendarUpcomingMeeting: 'service_calendar_upcoming_meeting',
  /** sms_from_lead */
  SmsFromLead: 'sms_from_lead',
  /** stagnant_prospect */
  StagnantProspect: 'stagnant_prospect',
  /** state_return_accepted */
  StateReturnAccepted: 'state_return_accepted',
  /** state_return_received */
  StateReturnReceived: 'state_return_received',
  /** state_return_rejected */
  StateReturnRejected: 'state_return_rejected',
  /** subtask_assigned */
  SubtaskAssigned: 'subtask_assigned',
  /** subtask_due_approaching */
  SubtaskDueApproaching: 'subtask_due_approaching',
  /** task_comment_created */
  TaskCommentCreated: 'task_comment_created',
  /** task_comment_mention */
  TaskCommentMention: 'task_comment_mention',
  /** task_created */
  TaskCreated: 'task_created',
  /** task_due_date_changed */
  TaskDueDateChanged: 'task_due_date_changed',
  /** task_reassigned */
  TaskReassigned: 'task_reassigned',
  /** task_status_changed */
  TaskStatusChanged: 'task_status_changed',
  /** tax_filing_late_or_missed_deadline */
  TaxFilingLateOrMissedDeadline: 'tax_filing_late_or_missed_deadline',
  /** tax_filing_ready */
  TaxFilingReady: 'tax_filing_ready',
  /** tax_filing_ready_sent_to_client */
  TaxFilingReadySentToClient: 'tax_filing_ready_sent_to_client',
  /** tax_filing_reminder_to_client */
  TaxFilingReminderToClient: 'tax_filing_reminder_to_client',
  /** transfer_in */
  TransferIn: 'transfer_in',
  /** typeform_survey */
  TypeformSurvey: 'typeform_survey'
} as const;

export type AlertTypeName = typeof AlertTypeName[keyof typeof AlertTypeName];
/** A single (date, asset category) allocation sample for the Allocation Over Time chart. */
export type AllocationOverTimePoint = {
  readonly __typename?: 'AllocationOverTimePoint';
  /** Top-level asset category (e.g. 'Equity', 'Fixed Income', 'Cash & Cash Equivalents', 'Alternatives'). */
  readonly assetCategory: Scalars['String']['output'];
  /** Sample date. */
  readonly date: Scalars['ISO8601Date']['output'];
  /** Market value of this asset category on this date, in USD. Null when unavailable. */
  readonly marketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Share of the portfolio held in this asset category on this date, as a fraction (0.0–1.0). Null when unavailable. */
  readonly percent?: Maybe<Scalars['BigDecimal']['output']>;
};

/** A single asset-category or asset-class slice in a portfolio allocation pie. */
export type AllocationSlice = {
  readonly __typename?: 'AllocationSlice';
  /** Slice display name (e.g. "Equity", "Cash & Cash Equivalents", "US Equity"). */
  readonly name: Scalars['String']['output'];
  /** Slice's share of total portfolio market value, expressed as a fraction (0.0–1.0). */
  readonly percent: Scalars['BigDecimal']['output'];
  /** Dollar value of the slice on the as-of date, in USD. */
  readonly value: Scalars['BigDecimal']['output'];
};

export type AlternativeFund = {
  readonly __typename?: 'AlternativeFund';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly eligibleInvestorLevelStatus?: Maybe<AlternativeFundInvestorStatusName>;
  readonly id: Scalars['ID']['output'];
  readonly investmentManager?: Maybe<Scalars['String']['output']>;
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly lockup?: Maybe<Scalars['String']['output']>;
  readonly managementFee?: Maybe<Scalars['String']['output']>;
  readonly minimumInvestmentSize?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly performanceReturns?: Maybe<Scalars['Float']['output']>;
  readonly performanceReturnsType?: Maybe<AlternativeFundPerformanceReturnsTypeName>;
  readonly provider?: Maybe<AlternativeFundProviderName>;
  readonly status?: Maybe<AlternativeFundStatusName>;
  readonly typeOf?: Maybe<AlternativeFundTypeName>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export const AlternativeFundInvestorStatusName = {
  AccreditedInvestor: 'accredited_investor',
  NonAccredited: 'non_accredited',
  QualifiedClient: 'qualified_client',
  QualifiedPurchaser: 'qualified_purchaser',
  SubAccredited: 'sub_accredited'
} as const;

export type AlternativeFundInvestorStatusName = typeof AlternativeFundInvestorStatusName[keyof typeof AlternativeFundInvestorStatusName];
export const AlternativeFundPerformanceReturnsTypeName = {
  '1Year': '_1_year',
  '5Year': '_5_year',
  Target: 'target'
} as const;

export type AlternativeFundPerformanceReturnsTypeName = typeof AlternativeFundPerformanceReturnsTypeName[keyof typeof AlternativeFundPerformanceReturnsTypeName];
export const AlternativeFundProviderName = {
  Cais: 'cais',
  Equi: 'equi',
  Gridline: 'gridline',
  Icapital: 'icapital'
} as const;

export type AlternativeFundProviderName = typeof AlternativeFundProviderName[keyof typeof AlternativeFundProviderName];
export const AlternativeFundStatusName = {
  Active: 'active',
  Closed: 'closed'
} as const;

export type AlternativeFundStatusName = typeof AlternativeFundStatusName[keyof typeof AlternativeFundStatusName];
export const AlternativeFundTypeName = {
  HedgeFund: 'hedge_fund',
  MultiAsset: 'multi_asset',
  PrivateCredit: 'private_credit',
  PrivateEquity: 'private_equity',
  RealAsset: 'real_asset',
  VentureCapital: 'venture_capital'
} as const;

export type AlternativeFundTypeName = typeof AlternativeFundTypeName[keyof typeof AlternativeFundTypeName];
/** Input for alternative investments purchase task specific data */
export type AlternativeInvestmentsPurchase = {
  /** Whether to enroll in dividend reinvestment plan */
  readonly enrollInDrip?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the fund */
  readonly fundName: Scalars['String']['input'];
  /** The amount to invest */
  readonly investmentAmount: Scalars['Float']['input'];
  /** Investment experience rows for the household */
  readonly investmentExperienceRows: ReadonlyArray<InvestmentExperienceRowInput>;
  /** The investment objective (income_current_yield, appreciation, principal_protection, speculation) */
  readonly investmentObjective: Scalars['String']['input'];
  /** The liquidity preference (very_important, important, somewhat_important, does_not_matter) */
  readonly liquidity: Scalars['String']['input'];
  /** The risk profile (aggressive_speculative, balanced_neutral, conservative_risk_adverse) */
  readonly riskProfile: Scalars['String']['input'];
  /** The source of wealth (employment, inheritance, investment_returns, sale_of_business, real_estate, other) */
  readonly sourceOfWealth: Scalars['String']['input'];
  /** Description when source of wealth is other */
  readonly sourceOfWealthOther?: InputMaybe<Scalars['String']['input']>;
  /** The investment time horizon in years */
  readonly timeHorizon: Scalars['Int']['input'];
};

/** Alternative investments purchase request data associated with a task */
export type AlternativeInvestmentsPurchaseRequest = {
  readonly __typename?: 'AlternativeInvestmentsPurchaseRequest';
  /** Whether enrolled in DRIP */
  readonly enrollInDrip: Scalars['Boolean']['output'];
  /** The name of the fund */
  readonly fundName: Scalars['String']['output'];
  /** The ID of the request */
  readonly id: Scalars['ID']['output'];
  /** The investment amount */
  readonly investmentAmount: Scalars['Float']['output'];
  /** The associated investment experience */
  readonly investmentExperience: InvestmentExperience;
  /** The investment objective */
  readonly investmentObjective: Scalars['String']['output'];
  /** The liquidity preference */
  readonly liquidity: Scalars['String']['output'];
  /** The risk profile */
  readonly riskProfile: Scalars['String']['output'];
  /** The source of wealth */
  readonly sourceOfWealth: Scalars['String']['output'];
  /** Description when source of wealth is other */
  readonly sourceOfWealthOther?: Maybe<Scalars['String']['output']>;
  /** The time horizon in years */
  readonly timeHorizon: Scalars['Int']['output'];
};

/** Which users an announcement targets */
export const AnnouncementAudience = {
  /** advisor */
  Advisor: 'advisor',
  /** all */
  All: 'all',
  /** client */
  Client: 'client'
} as const;

export type AnnouncementAudience = typeof AnnouncementAudience[keyof typeof AnnouncementAudience];
/** An announcement configuration */
export type AnnouncementConfig = {
  readonly __typename?: 'AnnouncementConfig';
  /** The announcement name */
  readonly announcementName: Scalars['String']['output'];
  /** Which users the announcement targets */
  readonly audience: AnnouncementAudience;
  /** Modal badge */
  readonly badge?: Maybe<Scalars['String']['output']>;
  /** Registered code component for bespoke announcements */
  readonly bespokeKey?: Maybe<Scalars['String']['output']>;
  /** Modal body copy */
  readonly body?: Maybe<Scalars['String']['output']>;
  /** Optional call-to-action button label */
  readonly ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Call-to-action link target, as a same-site path or https URL */
  readonly ctaUrl?: Maybe<Scalars['String']['output']>;
  /** When the announcement ends; null for no end */
  readonly expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Banner header. Null for announcements whose copy lives in the client */
  readonly header?: Maybe<Scalars['String']['output']>;
  /** The announcement config ID */
  readonly id: Scalars['ID']['output'];
  /** Alt text for the image; empty when decorative */
  readonly imageAlt?: Maybe<Scalars['String']['output']>;
  /** Optional banner image, as a same-site path or https URL */
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the announcement is a banner or a modal */
  readonly kind: AnnouncementKind;
  /** When the announcement goes live */
  readonly startsAt: Scalars['ISO8601DateTime']['output'];
  /** Banner subheader */
  readonly subheader?: Maybe<Scalars['String']['output']>;
  /** Layout that renders the announcement. Null for legacy rows rendered by name */
  readonly template?: Maybe<AnnouncementTemplate>;
};

/** Why an announcement ended before its scheduled end */
export const AnnouncementEndReason = {
  /** end_now */
  EndNow: 'end_now',
  /** replaced */
  Replaced: 'replaced'
} as const;

export type AnnouncementEndReason = typeof AnnouncementEndReason[keyof typeof AnnouncementEndReason];
/** How an announcement is presented in the Dash */
export const AnnouncementKind = {
  /** banner */
  Banner: 'banner',
  /** modal */
  Modal: 'modal'
} as const;

export type AnnouncementKind = typeof AnnouncementKind[keyof typeof AnnouncementKind];
/** Where an announcement is in its lifecycle */
export const AnnouncementStatus = {
  /** archived */
  Archived: 'archived',
  /** draft */
  Draft: 'draft',
  /** ended */
  Ended: 'ended',
  /** live */
  Live: 'live',
  /** scheduled */
  Scheduled: 'scheduled'
} as const;

export type AnnouncementStatus = typeof AnnouncementStatus[keyof typeof AnnouncementStatus];
/** Which layout renders an announcement */
export const AnnouncementTemplate = {
  /** bespoke */
  Bespoke: 'bespoke',
  /** minimal */
  Minimal: 'minimal',
  /** modal_image */
  ModalImage: 'modal_image',
  /** prominent */
  Prominent: 'prominent'
} as const;

export type AnnouncementTemplate = typeof AnnouncementTemplate[keyof typeof AnnouncementTemplate];
/** Autogenerated input type of ApplyCorrection */
export type ApplyCorrectionInput = {
  /** Admin explicitly reviewed the impact. */
  readonly acknowledged: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Imported household public handle. */
  readonly householdRequestUuid: Scalars['ID']['input'];
  /** Why the correction is needed. */
  readonly reason: Scalars['String']['input'];
  /** Unexpired token for a single correction. */
  readonly token?: InputMaybe<Scalars['String']['input']>;
  /** Unexpired tokens to save as one atomic group. */
  readonly tokens?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** Autogenerated return type of ApplyCorrection. */
export type ApplyCorrectionPayload = {
  readonly __typename?: 'ApplyCorrectionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The saved correction. */
  readonly correction: AdvisorOnboardingCorrectionOperation;
  /** All saved corrections. */
  readonly corrections: ReadonlyArray<AdvisorOnboardingCorrectionOperation>;
};

/** Autogenerated input type of ApproveScheduledReportExecution */
export type ApproveScheduledReportExecutionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ReportScheduleExecution IDs to approve */
  readonly ids: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of ApproveScheduledReportExecution. */
export type ApproveScheduledReportExecutionPayload = {
  readonly __typename?: 'ApproveScheduledReportExecutionPayload';
  /** IDs that were approved and delivered */
  readonly approvedIds: ReadonlyArray<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** One error message per failed id, in the same order as failed_ids */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** IDs that failed to deliver; remain pending_review */
  readonly failedIds: ReadonlyArray<Scalars['ID']['output']>;
};

/** Autogenerated input type of ArchiveHouseholdByPublicId */
export type ArchiveHouseholdByPublicIdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Expected household name */
  readonly householdName: Scalars['String']['input'];
  /** Household UUID */
  readonly householdPublicId: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveHouseholdByPublicId. */
export type ArchiveHouseholdByPublicIdPayload = {
  readonly __typename?: 'ArchiveHouseholdByPublicIdPayload';
  /** Whether this call archived the household */
  readonly changed: Scalars['Boolean']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Verified household name */
  readonly householdName: Scalars['String']['output'];
  /** Verified household UUID */
  readonly householdPublicId: Scalars['ID']['output'];
  /** Resulting household stage */
  readonly stage: Scalars['String']['output'];
  /** Whether the household is archived */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ArchiveHousehold */
export type ArchiveHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to archive */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveHousehold. */
export type ArchiveHouseholdPayload = {
  readonly __typename?: 'ArchiveHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the household stage was updated */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ArchiveServiceCatalogItemGroup */
export type ArchiveServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveServiceCatalogItemGroup. */
export type ArchiveServiceCatalogItemGroupPayload = {
  readonly __typename?: 'ArchiveServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Service catalog item group */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
};

/** Autogenerated input type of ArchiveServiceCatalogItem */
export type ArchiveServiceCatalogItemInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Item ID */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveServiceCatalogItem. */
export type ArchiveServiceCatalogItemPayload = {
  readonly __typename?: 'ArchiveServiceCatalogItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Service catalog item */
  readonly serviceCatalogItem?: Maybe<ServiceCatalogItem>;
};

/** Asset held by the user. */
export type Asset = {
  readonly __typename?: 'Asset';
  /** The asset class of the asset */
  readonly assetClass: AssetClassName;
  /** The asset subclass of the asset */
  readonly assetSubclass?: Maybe<AssetSubclassName>;
  /** Why this property has no Chimney value, so the client can fix its address. Null when connected or opted out. */
  readonly chimneyAddressIssue?: Maybe<ChimneyAddressIssue>;
  /** The street line of the structured address used for the Chimney lookup. */
  readonly chimneyAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Confidence score (0-100) for chimneyValuation. */
  readonly chimneyConfidence?: Maybe<Scalars['Int']['output']>;
  /** Whether the client has not yet been shown the Chimney linking disclosure notice for this asset. */
  readonly chimneyDisclosurePending: Scalars['Boolean']['output'];
  /** When this asset was last synced with Chimney. */
  readonly chimneyLastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Mortgage data Chimney returned, if any. */
  readonly chimneyMortgageData?: Maybe<ChimneyMortgageData>;
  /** Property details Chimney returned, if any. */
  readonly chimneyPropertyDetails?: Maybe<ChimneyPropertyDetails>;
  /** Chimney's estimated value for this property. */
  readonly chimneyValuation?: Maybe<Scalars['BigDecimal']['output']>;
  /** Company name for company equity type assets. */
  readonly companyEquityCompanyName?: Maybe<Scalars['String']['output']>;
  /** Company stock ticker for company equity type assets. */
  readonly companyEquityCompanyTicker?: Maybe<Scalars['String']['output']>;
  /** Company stock price for company equity type assets. */
  readonly companyEquityCurrentPrice?: Maybe<Scalars['BigDecimal']['output']>;
  /** Exercise price for company equity type assets. */
  readonly companyEquityExercisePrice?: Maybe<Scalars['BigDecimal']['output']>;
  /** Grant type for company equity type assets. */
  readonly companyEquityGrantType?: Maybe<Scalars['String']['output']>;
  /** Number of shares issued for company equity type assets. */
  readonly companyEquitySharesIssued?: Maybe<Scalars['BigDecimal']['output']>;
  /** Vesting cliff for company equity type assets. */
  readonly companyEquityVestingCliff?: Maybe<Scalars['BigDecimal']['output']>;
  /** Vesting duration for company equity type assets. */
  readonly companyEquityVestingDuration?: Maybe<Scalars['Int']['output']>;
  /** Vesting rate for company equity type assets. */
  readonly companyEquityVestingRate?: Maybe<Scalars['String']['output']>;
  /** Vesting start date for company equity type assets. */
  readonly companyEquityVestingStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The cost basis of the asset */
  readonly costBasis?: Maybe<Scalars['BigDecimal']['output']>;
  /** Where this asset's data came from, e.g. "manual" or "chimney". */
  readonly dataSource?: Maybe<Scalars['String']['output']>;
  /** The description of the asset. */
  readonly description: Scalars['String']['output'];
  /** Whether to hide this portfolio item from client */
  readonly hiddenFromClient?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to hide this portfolio item from net worth and graph */
  readonly hiddenFromNetWorth?: Maybe<Scalars['Boolean']['output']>;
  /** Daily value history for the asset, forward-filled from each recorded change. */
  readonly historicalValues: ReadonlyArray<HistoricalValue>;
  /** The Savvy ID of the asset. */
  readonly id: Scalars['ID']['output'];
  /** The timestamp the asset was last updated at. */
  readonly lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** The liabilities attached to this asset. */
  readonly liabilities: ReadonlyArray<Liability>;
  /** The asset's value after subtracting any mortgage attached to it. Same basis as historicalValues and net worth. */
  readonly netValue: Value;
  /** Free-form notes about the asset (e.g. account numbers, dates). */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /** The status of the asset. */
  readonly status: AccountStatusName;
  /** The timestamp the asset was last updated with information. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * The asset's gross value, before any mortgage attached to it. Pair it with the
   * mortgage as its own liability; netValue does not.
   */
  readonly value: Value;
};

export const AssetClassName = {
  /** High value collectible items */
  Collectible: 'collectible',
  /** Equity in a company the client works at */
  CompanyEquity: 'company_equity',
  /** Insurance policy the client has */
  InsurancePolicy: 'insurance_policy',
  /** Other types of assets */
  Other: 'other',
  /** Real estate assets */
  RealEstate: 'real_estate',
  /** Vehicles */
  Vehicle: 'vehicle'
} as const;

export type AssetClassName = typeof AssetClassName[keyof typeof AssetClassName];
/** Ending value and per-period returns (QTD / YTD / Inception) for a single asset class. */
export type AssetClassReturn = {
  readonly __typename?: 'AssetClassReturn';
  /** Asset class display name (e.g. "US Equity", "International Developed", "Cash"). */
  readonly assetClass: Scalars['String']['output'];
  /** Since-inception TWR for the benchmark as a fraction; null when no benchmark is configured or data is unavailable. */
  readonly benchmarkInceptionReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Display name of the firm-configured benchmark (e.g. "S&P 500 (Net TR)"); null when no benchmark is configured. */
  readonly benchmarkName?: Maybe<Scalars['String']['output']>;
  /** QTD TWR for the benchmark as a fraction; null when no benchmark is configured or data is unavailable. */
  readonly benchmarkQtdReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** YTD TWR for the benchmark as a fraction; null when no benchmark is configured or data is unavailable. */
  readonly benchmarkYtdReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Ending market value for the asset class on the report end date, in USD. */
  readonly endingValue: Scalars['BigDecimal']['output'];
  /** Since-inception time-weighted return as a fraction (0.05 = 5%); null when data is unavailable. */
  readonly inceptionReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Quarter-to-date time-weighted return as a fraction (0.05 = 5%); null when data is unavailable. */
  readonly qtdReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date time-weighted return as a fraction (0.05 = 5%); null when data is unavailable. */
  readonly ytdReturn?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Asset grouping information. A single group for a categorization of assets */
export type AssetGrouping = {
  readonly __typename?: 'AssetGrouping';
  readonly name: Scalars['String']['output'];
  readonly percent: Scalars['BigDecimal']['output'];
  readonly performanceOverTime?: Maybe<ReadonlyArray<Performance>>;
  readonly targetAllocation?: Maybe<Scalars['BigDecimal']['output']>;
  readonly value: Value;
};

export const AssetSubclassName = {
  Antique: 'antique',
  Art: 'art',
  Boat: 'boat',
  Car: 'car',
  InvestmentProperty: 'investment_property',
  Jewelry: 'jewelry',
  NonResidence: 'non_residence',
  Other: 'other',
  PrimaryResidence: 'primary_residence',
  Residence: 'residence',
  SecondaryResidence: 'secondary_residence'
} as const;

export type AssetSubclassName = typeof AssetSubclassName[keyof typeof AssetSubclassName];
/** Autogenerated input type of AssignAdvisorWealthscapeCredentials */
export type AssignAdvisorWealthscapeCredentialsInput = {
  /** User id of the advisor */
  readonly advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Wealthscape ID; exactly 10 digits */
  readonly portalId: Scalars['String']['input'];
  /** Why this is being set by hand; kept in the audit log */
  readonly reason: Scalars['String']['input'];
  /** Fidelity rep code */
  readonly repCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AssignAdvisorWealthscapeCredentials. */
export type AssignAdvisorWealthscapeCredentialsPayload = {
  readonly __typename?: 'AssignAdvisorWealthscapeCredentialsPayload';
  /** Advisor the id now belongs to */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Wealthscape ID now on file */
  readonly portalId?: Maybe<Scalars['String']['output']>;
  /** Rep code now on file */
  readonly repCode?: Maybe<Scalars['String']['output']>;
  /** Wealthscape ID this overwrote, when it replaced one */
  readonly replacedPortalId?: Maybe<Scalars['String']['output']>;
  /** Wealthscape ID that Fidelity calls made for this advisor now sign with */
  readonly signsAs?: Maybe<Scalars['String']['output']>;
  /** Whether the assignment succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AssignHouseholdFeeSchedule */
export type AssignHouseholdFeeScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Advisor fee schedule to assign (must belong to the household's advisor) */
  readonly feeScheduleId: Scalars['ID']['input'];
  /** Household to assign the fee schedule to */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignHouseholdFeeSchedule. */
export type AssignHouseholdFeeSchedulePayload = {
  readonly __typename?: 'AssignHouseholdFeeSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if the assignment failed */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** The active household fee schedule after assignment */
  readonly householdFeeSchedule?: Maybe<HouseholdFeeSchedule>;
  /** Whether the assignment succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AssignServiceCatalogItemToHousehold */
export type AssignServiceCatalogItemToHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household id */
  readonly householdId: Scalars['ID']['input'];
  /** Service (template) being enrolled into. Optional only for compatibility with web bundles that predate 4C1T-571. */
  readonly serviceCatalogItemGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Service catalog item id */
  readonly serviceCatalogItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignServiceCatalogItemToHousehold. */
export type AssignServiceCatalogItemToHouseholdPayload = {
  readonly __typename?: 'AssignServiceCatalogItemToHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Service catalog item household */
  readonly serviceCatalogItemHousehold?: Maybe<ServiceCatalogItemHousehold>;
};

export type AssignableAdvisor = {
  readonly __typename?: 'AssignableAdvisor';
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /** Advisor's full name */
  readonly name: Scalars['String']['output'];
  /** The advisor's User ID (distinct from this AdvisorProfile's own ID) — for prefilling a task's assignee, which is a User */
  readonly userId?: Maybe<Scalars['ID']['output']>;
};

export type AssignedCampaign = {
  readonly __typename?: 'AssignedCampaign';
  readonly activeAlerts: ReadonlyArray<Alert>;
  readonly id: Scalars['ID']['output'];
  readonly mostRecentAlert?: Maybe<Alert>;
  readonly status: AssignedCampaignStatus;
  readonly user: User;
};

export const AssignedCampaignStatus = {
  /** call_response_required */
  CallResponseRequired: 'call_response_required',
  /** call_step_required */
  CallStepRequired: 'call_step_required',
  /** email_response_required */
  EmailResponseRequired: 'email_response_required',
  /** in_progress */
  InProgress: 'in_progress',
  /** lead_engaged */
  LeadEngaged: 'lead_engaged',
  /** sms_response_required */
  SmsResponseRequired: 'sms_response_required',
  /** stopped */
  Stopped: 'stopped'
} as const;

export type AssignedCampaignStatus = typeof AssignedCampaignStatus[keyof typeof AssignedCampaignStatus];
export type BackgroundMeetingPrepDocumentOpen = {
  /** Id of the opened meeting-prep Canvas document. */
  readonly canvasDocumentId?: InputMaybe<Scalars['String']['input']>;
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export type BackgroundMeetingPrepNotificationClick = {
  /** Id of the meeting-prep Canvas document the notification targets. */
  readonly canvasDocumentId?: InputMaybe<Scalars['String']['input']>;
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

/** Input type for filtering accounts by balance range */
export type BalanceRangeInput = {
  /** Maximum account balance */
  readonly max?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Minimum account balance */
  readonly min?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** Bank account type for a Link a Bank request */
export const BankAccountTypeName = {
  /** checking */
  Checking: 'checking',
  /** savings */
  Savings: 'savings'
} as const;

export type BankAccountTypeName = typeof BankAccountTypeName[keyof typeof BankAccountTypeName];
/** A bank or credit-card transaction persisted from MoneyKit (checking, savings, credit). */
export type BankingTransaction = {
  readonly __typename?: 'BankingTransaction';
  /** Absolute transaction amount. Sign comes from direction. */
  readonly amount: Scalars['BigDecimal']['output'];
  /** ISO currency code for the amount. Null when the provider omitted it. */
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  /** Merchant or memo text from the provider. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Whether money left (debit) or entered (credit) the account. */
  readonly direction: BankingTransactionDirection;
  /** The Savvy ID of the banking transaction. */
  readonly id: Scalars['ID']['output'];
  /** Whether the transaction is still pending at the provider. */
  readonly pending: Scalars['Boolean']['output'];
  /** When the transaction posted or was authorized. */
  readonly transactedAt: Scalars['ISO8601DateTime']['output'];
};

/** MoneyKit banking transaction direction (debit leaves the account, credit enters it). */
export const BankingTransactionDirection = {
  Credit: 'credit',
  Debit: 'debit'
} as const;

export type BankingTransactionDirection = typeof BankingTransactionDirection[keyof typeof BankingTransactionDirection];
/** Autogenerated input type of BeginMfaEnrollment */
export type BeginMfaEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BeginMfaEnrollment. */
export type BeginMfaEnrollmentPayload = {
  readonly __typename?: 'BeginMfaEnrollmentPayload';
  readonly channel?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type BenchmarkComparisonAccountOutcome = {
  readonly __typename?: 'BenchmarkComparisonAccountOutcome';
  /** Savvy account ID requested for the comparison. */
  readonly accountId: Scalars['ID']['output'];
  /** Human-readable Savvy account name. */
  readonly accountName: Scalars['String']['output'];
  /** Inclusive end date the account return actually covers. */
  readonly effectiveEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Inclusive start date the account return actually covers. */
  readonly effectiveStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Account cumulative TWR over its effective window, as a fraction. */
  readonly returnCumulative?: Maybe<Scalars['BigDecimal']['output']>;
  /** included, window_mismatch, or unavailable. */
  readonly status: Scalars['String']['output'];
};

export type BenchmarkComparisonBenchmark = {
  readonly __typename?: 'BenchmarkComparisonBenchmark';
  /** Subject return minus benchmark return. Null unless both returns cover the exact requested window. */
  readonly delta?: Maybe<Scalars['BigDecimal']['output']>;
  /** Human-readable benchmark name from Orion. */
  readonly displayName: Scalars['String']['output'];
  /** Inclusive end date the benchmark return actually covers. */
  readonly effectiveEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Inclusive start date the benchmark return actually covers. */
  readonly effectiveStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Cumulative benchmark TWR over its effective window, as a fraction. */
  readonly returnCumulative?: Maybe<Scalars['BigDecimal']['output']>;
  /** configured when selected from the household Orion setting; fallback when Report Builder defaults were used. */
  readonly selectionProvenance?: Maybe<Scalars['String']['output']>;
  /** exact, window_mismatch, or unavailable. */
  readonly windowStatus: Scalars['String']['output'];
};

export type BenchmarkComparisonResult = {
  readonly __typename?: 'BenchmarkComparisonResult';
  /** One row per requested account. Empty for a household comparison. */
  readonly accountOutcomes: ReadonlyArray<BenchmarkComparisonAccountOutcome>;
  /** How the subject TWR was sourced or combined. */
  readonly aggregationMethod: Scalars['String']['output'];
  /** Compact benchmark summaries; daily series and vendor identifiers are omitted. */
  readonly benchmarks: ReadonlyArray<BenchmarkComparisonBenchmark>;
  /** Explanation of what the comparison includes or why a delta is unavailable. */
  readonly coverageMessage: Scalars['String']['output'];
  /** complete, partial, window_mismatch, or unavailable. */
  readonly coverageStatus: Scalars['String']['output'];
  /** Inclusive comparison end requested by the caller. */
  readonly requestedEndDate: Scalars['ISO8601Date']['output'];
  /** Inclusive comparison start requested by the caller. */
  readonly requestedStartDate: Scalars['ISO8601Date']['output'];
  /** Household, account, or selected-account return being compared. */
  readonly subject: BenchmarkComparisonSubject;
};

export type BenchmarkComparisonSubject = {
  readonly __typename?: 'BenchmarkComparisonSubject';
  /** Human-readable name for the household, account, or selected account group. */
  readonly displayName: Scalars['String']['output'];
  /** Inclusive end date the subject return actually covers. */
  readonly effectiveEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Inclusive start date the subject return actually covers. */
  readonly effectiveStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * Cumulative time-weighted return over the effective window, as a fraction. Null
   * when a comparable subject return is unavailable.
   */
  readonly returnCumulative?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Tracks an async benchmark-data generation job for the Report Builder "Portfolio Performance vs Benchmark" section. */
export type BenchmarkDataGeneration = {
  readonly __typename?: 'BenchmarkDataGeneration';
  /** Present when status is "failed". */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** The ID of the generation record. */
  readonly id: Scalars['ID']['output'];
  /** True when the result is incomplete — some benchmarks or table rows could not be fetched before the deadline. */
  readonly partial: Scalars['Boolean']['output'];
  /** Present when status is "completed". */
  readonly result?: Maybe<ReadonlyArray<BenchmarkSeries>>;
  /** "pending", "processing", "completed", or "failed". */
  readonly status: Scalars['String']['output'];
};

/** A single series in the Performance vs Benchmark chart — the household's portfolio or a Morningstar Target Risk benchmark. */
export type BenchmarkSeries = {
  readonly __typename?: 'BenchmarkSeries';
  /** Human-readable label shown in the chart legend and table (e.g. "Demo Household"). */
  readonly displayName: Scalars['String']['output'];
  /** True for the household's own series; false for benchmark series. */
  readonly isHousehold: Scalars['Boolean']['output'];
  /**
   * Stable machine identifier for the series (e.g. "household",
   * "morningstar_moderately_aggressive_target_risk_tr_usd"). Used for chart
   * styling and table joins.
   */
  readonly key: Scalars['String']['output'];
  /** Daily cumulative-return points spanning the report date range. Empty when data is unavailable. */
  readonly points: ReadonlyArray<ReturnPoint>;
  /** Per-period totals for the table beneath the chart. */
  readonly summaryRows: ReadonlyArray<PeriodReturnRow>;
};

/** The beneficiary of an account. */
export type Beneficiary = {
  readonly __typename?: 'Beneficiary';
  readonly contact: Contact;
  readonly contingent?: Maybe<Scalars['Boolean']['output']>;
  /** The percentage for this contact represented as an Integer */
  readonly percentage?: Maybe<Scalars['Int']['output']>;
};

/** Attributes for creating or updating a beneficiary on an account */
export type BeneficiaryInput = {
  readonly contact: ContactInput;
  readonly contingent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The percentage for this contact represented as an Integer */
  readonly percentage: Scalars['Int']['input'];
};

/** Beneficiary relation type — primary or contingent */
export const BeneficiaryRelationTypeName = {
  /** contingent */
  Contingent: 'contingent',
  /** primary */
  Primary: 'primary'
} as const;

export type BeneficiaryRelationTypeName = typeof BeneficiaryRelationTypeName[keyof typeof BeneficiaryRelationTypeName];
export const BeneficiaryRelationship = {
  /** child */
  Child: 'child',
  /** estate */
  Estate: 'estate',
  /** friend */
  Friend: 'friend',
  /** grandchild */
  Grandchild: 'grandchild',
  /** grandparent */
  Grandparent: 'grandparent',
  /** niece_nephew */
  NieceNephew: 'niece_nephew',
  /** organization */
  Organization: 'organization',
  /** other_individual */
  OtherIndividual: 'other_individual',
  /** parent */
  Parent: 'parent',
  /** sibling */
  Sibling: 'sibling',
  /** spouse */
  Spouse: 'spouse',
  /** trust */
  Trust: 'trust',
  /** uncle_aunt */
  UncleAunt: 'uncle_aunt'
} as const;

export type BeneficiaryRelationship = typeof BeneficiaryRelationship[keyof typeof BeneficiaryRelationship];
/** One account and its beneficiaries within a beneficiary update request */
export type BeneficiaryUpdateAccountInput = {
  /** Account whose beneficiaries are being updated */
  readonly accountId: Scalars['ID']['input'];
  /** Beneficiaries to record on the account */
  readonly beneficiaries: ReadonlyArray<AccountMaintenanceBeneficiaryInput>;
};

/** Beneficiary update variant of account maintenance */
export type BeneficiaryUpdateInput = {
  /** Accounts and their beneficiaries */
  readonly accounts: ReadonlyArray<BeneficiaryUpdateAccountInput>;
};

/** Billing Hold variant: temporarily pause invoicing */
export type BillingHoldInput = {
  /** Affected accounts; empty applies to the entire household */
  readonly accountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Expected resume date */
  readonly expectedResumeDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Hold start date; omitted when the timing is future */
  readonly holdStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Whether the hold starts immediately or on a future date described in the notes */
  readonly holdStartDateTiming?: InputMaybe<ClientBillingDateTimingName>;
  /** Reason for the hold */
  readonly reasonForHold: Scalars['String']['input'];
};

export const BlockedReason = {
  /** awaiting_client_action */
  AwaitingClientAction: 'awaiting_client_action',
  /** coclient_not_generated */
  CoclientNotGenerated: 'coclient_not_generated',
  /** duplicate_household */
  DuplicateHousehold: 'duplicate_household',
  /** envelope_generation_failed */
  EnvelopeGenerationFailed: 'envelope_generation_failed',
  /** missing_account_info */
  MissingAccountInfo: 'missing_account_info',
  /** missing_client_info */
  MissingClientInfo: 'missing_client_info',
  /** signed_loop_bulk */
  SignedLoopBulk: 'signed_loop_bulk',
  /** signed_loop_primary */
  SignedLoopPrimary: 'signed_loop_primary',
  /** two_fa_blocked */
  TwoFaBlocked: 'two_fa_blocked'
} as const;

export type BlockedReason = typeof BlockedReason[keyof typeof BlockedReason];
/**
 * Whether an advisor can receive a book upload, and what is already staged against
 * them. Read-only: lets the admin upload page warn before a file is picked, rather
 * than after the upload has already resolved (and possibly created) an enrollment.
 */
export type BookUploadReadiness = {
  readonly __typename?: 'BookUploadReadiness';
  /** Target advisor display name, for the upload page copy. */
  readonly advisorName: Scalars['String']['output'];
  /** Whether flag-advisor-onboarding is on for the target advisor. False means an upload would be rejected. */
  readonly eligible: Scalars['Boolean']['output'];
  /** Existing enrollment uuid, or null when uploading would create the advisor's first enrollment. */
  readonly enrollmentUuid?: Maybe<Scalars['ID']['output']>;
  /** When the most recent book import was created. */
  readonly latestImportAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Most recent book import id, for linking to its detail view. */
  readonly latestImportId?: Maybe<Scalars['ID']['output']>;
  /** Households already staged against the enrollment. A further upload adds to this book rather than replacing it. */
  readonly stagedHouseholdCount: Scalars['Int']['output'];
};

/** A file in a household's Box Client Uploads folder, annotated with its Extend extraction status */
export type BoxClientUploadStatement = {
  readonly __typename?: 'BoxClientUploadStatement';
  /** Box file id */
  readonly boxDocumentId: Scalars['String']['output'];
  /** extend_extracted_data id when this file has been processed */
  readonly extractedDatumId?: Maybe<Scalars['String']['output']>;
  /** completed, pending, failed, or not_processed */
  readonly extractionStatus: Scalars['String']['output'];
  /** File name as stored in Box */
  readonly fileName: Scalars['String']['output'];
  /** Box content_modified_at timestamp */
  readonly modifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** File size in bytes */
  readonly size?: Maybe<Scalars['Int']['output']>;
};

export type BoxConfiguration = {
  readonly __typename?: 'BoxConfiguration';
  /** The access token used for Box UI Elements. */
  readonly accessToken?: Maybe<Scalars['String']['output']>;
  /**
   * Lifetime of accessToken, in seconds from when Box minted it. Relative rather
   * than absolute so a skewed client clock cannot make an expired token look
   * valid. Null when no token was minted, or when Box did not report a lifetime.
   */
  readonly accessTokenExpiresInSeconds?: Maybe<Scalars['Int']['output']>;
  /** The Root Box folder ID used for initializing the Content Explorer Box UI Element. */
  readonly folderId?: Maybe<Scalars['String']['output']>;
  /** IDs of Box subfolders */
  readonly subfolders?: Maybe<BoxSubfolderIds>;
  /**
   * Set when no token could be minted. NO_FOLDER_CONFIGURED and NO_BOX_ACCOUNT are
   * permanent for this household; BOX_UNREACHABLE is transient and worth retrying.
   */
  readonly unavailableReason?: Maybe<BoxConfigurationUnavailableReasonEnum>;
};

/** Why a Box configuration could not be produced */
export const BoxConfigurationUnavailableReasonEnum = {
  /** BOX_UNREACHABLE */
  BoxUnreachable: 'BOX_UNREACHABLE',
  /** NO_BOX_ACCOUNT */
  NoBoxAccount: 'NO_BOX_ACCOUNT',
  /** NO_FOLDER_CONFIGURED */
  NoFolderConfigured: 'NO_FOLDER_CONFIGURED'
} as const;

export type BoxConfigurationUnavailableReasonEnum = typeof BoxConfigurationUnavailableReasonEnum[keyof typeof BoxConfigurationUnavailableReasonEnum];
export type BoxFileItem = {
  readonly __typename?: 'BoxFileItem';
  readonly createdAt?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly parentPath?: Maybe<Scalars['String']['output']>;
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type BoxFileThumbnail = {
  readonly __typename?: 'BoxFileThumbnail';
  /** box file ID */
  readonly fileId: Scalars['ID']['output'];
  readonly thumbnailData: Scalars['Base64']['output'];
};

export type BoxFolderFileItems = {
  readonly __typename?: 'BoxFolderFileItems';
  readonly files?: Maybe<ReadonlyArray<BoxFileItem>>;
  readonly pathCounts?: Maybe<ReadonlyArray<BoxFolderPathCount>>;
};

export type BoxFolderPathCount = {
  readonly __typename?: 'BoxFolderPathCount';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly path?: Maybe<Scalars['String']['output']>;
};

/** Type of folder to upload to */
export const BoxFolderTypeEnum = {
  /** CLIENT_UPLOADS */
  ClientUploads: 'CLIENT_UPLOADS',
  /** CUSTODIAL_FORMS */
  CustodialForms: 'CUSTODIAL_FORMS',
  /** INVOICES */
  Invoices: 'INVOICES',
  /** QUARTERLY_REPORTS */
  QuarterlyReports: 'QUARTERLY_REPORTS',
  /** REPORTS_FOR_REVIEW */
  ReportsForReview: 'REPORTS_FOR_REVIEW',
  /** TAX_FORMS */
  TaxForms: 'TAX_FORMS'
} as const;

export type BoxFolderTypeEnum = typeof BoxFolderTypeEnum[keyof typeof BoxFolderTypeEnum];
export type BoxMarketingConfiguration = {
  readonly __typename?: 'BoxMarketingConfiguration';
  /** Advisor access token */
  readonly accessToken?: Maybe<Scalars['String']['output']>;
  readonly advisorFiles?: Maybe<BoxFolderFileItems>;
  readonly advisorGroupFiles?: Maybe<BoxFolderFileItems>;
  /** All available tags for box  */
  readonly allTags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly brandMaterialFiles?: Maybe<BoxFolderFileItems>;
  readonly emailTemplatesFiles?: Maybe<BoxFolderFileItems>;
  readonly featuredFiles?: Maybe<BoxFolderFileItems>;
  readonly resourcesFiles?: Maybe<BoxFolderFileItems>;
  readonly socialMediaFiles?: Maybe<BoxFolderFileItems>;
};

export type BoxPickerConfiguration = {
  readonly __typename?: 'BoxPickerConfiguration';
  /** A read-only Box token scoped to this household root. */
  readonly accessToken: Scalars['String']['output'];
  /** The lifetime Box reported when it minted accessToken. */
  readonly accessTokenExpiresInSeconds?: Maybe<Scalars['Int']['output']>;
  /** The household root where the picker starts. */
  readonly folderId: Scalars['String']['output'];
};

export type BoxSubfolderIds = {
  readonly __typename?: 'BoxSubfolderIds';
  /** Folder id for box accounts subfolder */
  readonly accountsBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Folder id for the client-visible Additional Materials subfolder */
  readonly additionalMaterialsBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Folder id for box client uploads subfolder */
  readonly clientUploadsBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Folder id for the private Comment Attachments subfolder */
  readonly commentAttachmentsBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Folder id for box private subfolder */
  readonly privateBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Folder id for box public subfolder */
  readonly publicBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Folder id for attaching files to tasks subfolder */
  readonly taskAttachmentsBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Folder id for the Task Uploads task type subfolder */
  readonly taskUploadsBoxFolderId?: Maybe<Scalars['String']['output']>;
};

/** Detail for the US-registered broker-dealer association disclosure (required when the answer is yes). */
export type BrokerDealerDetailInput = {
  /** CRD number of the broker-dealer firm */
  readonly firmCrdNumber: Scalars['String']['input'];
  /** Name of the broker-dealer firm */
  readonly firmName: Scalars['String']['input'];
  /** Your role at the firm */
  readonly role: Scalars['String']['input'];
  /** Supervisor's contact (email or phone) */
  readonly supervisorContact: Scalars['String']['input'];
  /** Supervisor's name */
  readonly supervisorName: Scalars['String']['input'];
};

export type BrokerageAccountStatement = {
  readonly __typename?: 'BrokerageAccountStatement';
  readonly accountData: Scalars['JSON']['output'];
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  readonly accountType?: Maybe<Scalars['String']['output']>;
  readonly boxDocumentId: Scalars['String']['output'];
  readonly brokerageName?: Maybe<Scalars['String']['output']>;
  readonly classificationData: Scalars['JSON']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly documentClassification?: Maybe<Scalars['String']['output']>;
  readonly fileName: Scalars['String']['output'];
  readonly holdings?: Maybe<Scalars['JSON']['output']>;
  readonly household?: Maybe<Household>;
  readonly id: Scalars['ID']['output'];
  readonly statementDate?: Maybe<Scalars['String']['output']>;
  readonly status: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly uploadingUser: User;
  readonly workflowId: Scalars['String']['output'];
  readonly workflowRunId: Scalars['String']['output'];
};

/** Autogenerated input type of BulkCancelTasks */
export type BulkCancelTasksInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Task IDs to cancel. Only not-yet-started (todo) tasks are eligible; any other status is counted in ineligible_count. */
  readonly ids: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkCancelTasks. */
export type BulkCancelTasksPayload = {
  readonly __typename?: 'BulkCancelTasksPayload';
  /** Number already cancelled (no-op) */
  readonly alreadyCancelledCount: Scalars['Int']['output'];
  /** IDs whose task was already cancelled (no-op) */
  readonly alreadyCancelledIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Number of tasks cancelled by this call */
  readonly cancelledCount: Scalars['Int']['output'];
  /** IDs cancelled by this call */
  readonly cancelledIds: ReadonlyArray<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** IDs whose cancellation raised an error (details in server logs); empty on a clean run */
  readonly failedIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Number whose task is not in a cancellable (todo) status */
  readonly ineligibleCount: Scalars['Int']['output'];
  /** IDs whose task is not in a cancellable (todo) status */
  readonly ineligibleIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Number of ids with no matching task */
  readonly notFoundCount: Scalars['Int']['output'];
  /** IDs with no matching task */
  readonly notFoundIds: ReadonlyArray<Scalars['ID']['output']>;
};

/** Autogenerated input type of BulkCreateOrUpdateHouseholds */
export type BulkCreateOrUpdateHouseholdsInput = {
  /** The ID of the advisor user who owns the households that will be created or updated */
  readonly advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The XLSX file content encoded as base64 to process */
  readonly xlsxFile: Scalars['String']['input'];
};

/** Autogenerated return type of BulkCreateOrUpdateHouseholds. */
export type BulkCreateOrUpdateHouseholdsPayload = {
  readonly __typename?: 'BulkCreateOrUpdateHouseholdsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors that occurred during processing */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** The output XLSX file content encoded as base64 */
  readonly xlsxFile: Scalars['String']['output'];
};

/** Error that occurred during bulk deletion of organization household tags */
export type BulkDeleteOrganizationHouseholdTagsError = {
  readonly __typename?: 'BulkDeleteOrganizationHouseholdTagsError';
  /** The error message */
  readonly message: Scalars['String']['output'];
  /** The ID of the tag that failed to delete */
  readonly tagId: Scalars['ID']['output'];
};

/** Autogenerated input type of BulkDeleteOrganizationHouseholdTags */
export type BulkDeleteOrganizationHouseholdTagsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of the tags to delete */
  readonly ids: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkDeleteOrganizationHouseholdTags. */
export type BulkDeleteOrganizationHouseholdTagsPayload = {
  readonly __typename?: 'BulkDeleteOrganizationHouseholdTagsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The IDs of successfully deleted tags */
  readonly deletedIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Errors that occurred during deletion */
  readonly errors: ReadonlyArray<BulkDeleteOrganizationHouseholdTagsError>;
  /** Whether all deletions were successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of BulkGenerateReports */
export type BulkGenerateReportsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** monthly | quarterly | annually */
  readonly frequency: Scalars['String']['input'];
  /**
   * Households to generate reports for. IDs the current advisor cannot access are
   * silently dropped rather than erroring the whole request.
   */
  readonly householdIds: ReadonlyArray<Scalars['ID']['input']>;
  /** Saved template to render */
  readonly savedReportTemplateId: Scalars['ID']['input'];
};

/** Autogenerated return type of BulkGenerateReports. */
export type BulkGenerateReportsPayload = {
  readonly __typename?: 'BulkGenerateReportsPayload';
  /** Poll bulkReportGenerationJob with this id */
  readonly bulkReportDownloadId: Scalars['ID']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Number of eligible households the job was enqueued for */
  readonly totalHouseholds: Scalars['Int']['output'];
};

/** A bulk import operation for processing files with multiple data records */
export type BulkImport = {
  readonly __typename?: 'BulkImport';
  /**
   * The advisor whose onboarding enrollment this import staged into, so the detail
   * view can link to that advisor's cockpit. Null unless this is an advisor
   * onboarding book import.
   */
  readonly advisorOnboardingAdvisorId?: Maybe<Scalars['ID']['output']>;
  /** Non-destructive re-upload merge outcome. Null unless this is an advisor onboarding book import. */
  readonly advisorOnboardingMergeSummary?: Maybe<AdvisorOnboardingBookMergeSummary>;
  /** Completion percentage of the bulk import */
  readonly completionPercentage: Scalars['Float']['output'];
  /** When the bulk import was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Errors that occurred during the bulk import */
  readonly errors: ReadonlyArray<BulkImportError>;
  /** Whether a file is attached to this bulk import */
  readonly hasFile: Scalars['Boolean']['output'];
  /** The unique identifier for the bulk import */
  readonly id: Scalars['ID']['output'];
  /** The importable ID for the bulk import */
  readonly importableId: Scalars['ID']['output'];
  /** The importable name for the bulk import */
  readonly importableName: Scalars['String']['output'];
  /** The importable type for the bulk import */
  readonly importableType: Scalars['String']['output'];
  /** Progress information for the bulk import */
  readonly progress: BulkImportProgress;
  /** The current status of the bulk import */
  readonly status: Scalars['String']['output'];
  /** When the bulk import was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Display name of the user who initiated this import. Exposed as a scalar (not a
   * User object) so an advisor can read the name of an admin who uploaded on their
   * behalf without failing User authorization. Null for imports created before
   * uploader tracking.
   */
  readonly uploadedByName?: Maybe<Scalars['String']['output']>;
};

/** An error that occurred during bulk import processing */
export type BulkImportError = {
  readonly __typename?: 'BulkImportError';
  /** The type of error that occurred */
  readonly errorType?: Maybe<Scalars['String']['output']>;
  /** The field where the error occurred */
  readonly field?: Maybe<Scalars['String']['output']>;
  /** A formatted error message with context */
  readonly formattedMessage: Scalars['String']['output'];
  /** The unique identifier for the error */
  readonly id: Scalars['ID']['output'];
  /** Whether this is a global import error or item-specific */
  readonly isGlobalError: Scalars['Boolean']['output'];
  /** The error message */
  readonly message: Scalars['String']['output'];
  /** The data for the row where the error occurred */
  readonly rowData?: Maybe<Scalars['JSON']['output']>;
  /** The row number where the error occurred */
  readonly rowNumber?: Maybe<Scalars['Int']['output']>;
  /** The sheet name where the error occurred */
  readonly sheetName?: Maybe<Scalars['String']['output']>;
};

/** Progress information for a bulk import operation */
export type BulkImportProgress = {
  readonly __typename?: 'BulkImportProgress';
  /** Number of items that failed processing */
  readonly failed: Scalars['Int']['output'];
  /** Status of finalization phase (in_progress, completed, or null if not started) */
  readonly finalizationStatus?: Maybe<Scalars['String']['output']>;
  /** Number of items waiting to be processed */
  readonly pending: Scalars['Int']['output'];
  /** Completion percentage (0.0 to 100.0) */
  readonly percentage: Scalars['Float']['output'];
  /** Number of items successfully processed */
  readonly processed: Scalars['Int']['output'];
  /** Number of items currently being processed */
  readonly processing: Scalars['Int']['output'];
  /** Number of items that were skipped */
  readonly skipped: Scalars['Int']['output'];
  /** Total number of items to process */
  readonly total: Scalars['Int']['output'];
};

/** One household that failed to generate in a bulk report generation job */
export type BulkReportGenerationFailure = {
  readonly __typename?: 'BulkReportGenerationFailure';
  /** Error message */
  readonly errorMessage: Scalars['String']['output'];
  /** The household that failed */
  readonly householdId: Scalars['ID']['output'];
  /** Display name of the household */
  readonly householdName: Scalars['String']['output'];
};

/** Tracks a bulk report-generation job — fan-out across households, zip assembly, download. */
export type BulkReportGenerationJob = {
  readonly __typename?: 'BulkReportGenerationJob';
  /** Households successfully generated so far. */
  readonly completedCount: Scalars['Int']['output'];
  /** When the job was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Authenticated download path once the zip is ready. Null until status = completed. */
  readonly downloadUrl?: Maybe<Scalars['String']['output']>;
  /** When the job (and its zip, if any) expires. */
  readonly expiresAt: Scalars['ISO8601DateTime']['output'];
  /** Households that failed so far. */
  readonly failedCount: Scalars['Int']['output'];
  /** Per-household failure details. */
  readonly failures: ReadonlyArray<BulkReportGenerationFailure>;
  /** monthly | quarterly | annually -- same reason as saved_report_template_id. */
  readonly frequency: Scalars['String']['output'];
  /** The record ID. */
  readonly id: Scalars['ID']['output'];
  /**
   * Template this job was generated from -- lets the client retry failed
   * households without depending on form state that does not survive a page reload.
   */
  readonly savedReportTemplateId: Scalars['ID']['output'];
  /** Current status: pending | processing | completed | failed. */
  readonly status: Scalars['String']['output'];
  /** Number of households the job was enqueued for. */
  readonly total: Scalars['Int']['output'];
};

/** Autogenerated input type of BulkUpdateAlerts */
export type BulkUpdateAlertsInput = {
  /** Array of alert IDs to dismiss (set status to removed) */
  readonly alertsToDismiss?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Array of alert IDs to snooze */
  readonly alertsToSnooze?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The time when alerts were snoozed (used for alerts_to_snooze) */
  readonly snoozedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The time when alerts should surface (used for alerts_to_snooze) */
  readonly surfaceAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of BulkUpdateAlerts. */
export type BulkUpdateAlertsPayload = {
  readonly __typename?: 'BulkUpdateAlertsPayload';
  /** The updated alerts */
  readonly alerts: ReadonlyArray<Alert>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of error messages if any updates failed */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Error type for bulk update clients */
export type BulkUpdateClientsError = {
  readonly __typename?: 'BulkUpdateClientsError';
  /** Error message */
  readonly message: Scalars['String']['output'];
  /** User ID */
  readonly userId: Scalars['ID']['output'];
};

/** Autogenerated input type of BulkUpdateClients */
export type BulkUpdateClientsInput = {
  /** The ID of the advisor user who owns the clients that will be updated */
  readonly advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The clients to update */
  readonly clients: ReadonlyArray<AdvisorClientInput>;
};

/** Autogenerated return type of BulkUpdateClients. */
export type BulkUpdateClientsPayload = {
  readonly __typename?: 'BulkUpdateClientsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors that occurred during the update. An error affects 1 client, it does not stop the whole batch */
  readonly errors: ReadonlyArray<BulkUpdateClientsError>;
  /** Whether prospects were included in the update */
  readonly prospectsIncluded: Scalars['Boolean']['output'];
};

/** Error that occurred during bulk update of organization household categories */
export type BulkUpdateOrganizationHouseholdCategoriesError = {
  readonly __typename?: 'BulkUpdateOrganizationHouseholdCategoriesError';
  /** The ID of the category that failed to update */
  readonly categoryId: Scalars['ID']['output'];
  /** The error message */
  readonly message: Scalars['String']['output'];
};

/** Autogenerated input type of BulkUpdateOrganizationHouseholdCategories */
export type BulkUpdateOrganizationHouseholdCategoriesInput = {
  /** The categories to update */
  readonly categories: ReadonlyArray<OrganizationHouseholdCategoryUpdateInput>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BulkUpdateOrganizationHouseholdCategories. */
export type BulkUpdateOrganizationHouseholdCategoriesPayload = {
  readonly __typename?: 'BulkUpdateOrganizationHouseholdCategoriesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors that occurred during the update */
  readonly errors: ReadonlyArray<BulkUpdateOrganizationHouseholdCategoriesError>;
  /** The updated categories */
  readonly organizationHouseholdCategories: ReadonlyArray<OrganizationHouseholdCategory>;
};

/** Autogenerated input type of BulkUpdateTaxEnrollmentsToNotInterested */
export type BulkUpdateTaxEnrollmentsToNotInterestedInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Array of client profile IDs to mark not interested */
  readonly ids: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkUpdateTaxEnrollmentsToNotInterested. */
export type BulkUpdateTaxEnrollmentsToNotInterestedPayload = {
  readonly __typename?: 'BulkUpdateTaxEnrollmentsToNotInterestedPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** errors */
  readonly errors?: Maybe<Scalars['String']['output']>;
  /** IDs that failed to update */
  readonly failedIds: ReadonlyArray<Scalars['ID']['output']>;
  /** IDs that updated */
  readonly successIds: ReadonlyArray<Scalars['ID']['output']>;
};

/** Bulk upload to create LPOA documents in a Docusign envelope */
export type BulkUploadDocumentInput = {
  /** Fifth account number */
  readonly accountFive?: InputMaybe<Scalars['String']['input']>;
  /** Fourth account number */
  readonly accountFour?: InputMaybe<Scalars['String']['input']>;
  /** First account number */
  readonly accountOne: Scalars['String']['input'];
  /** Third account number */
  readonly accountThree?: InputMaybe<Scalars['String']['input']>;
  /** Second account number */
  readonly accountTwo?: InputMaybe<Scalars['String']['input']>;
  /** Name of the advisor */
  readonly advisorName: Scalars['String']['input'];
  /** Custodian (Charles Schwab or Fidelity) */
  readonly custodian: Scalars['String']['input'];
  /** Master account number */
  readonly masterAccount: Scalars['String']['input'];
  /** Email of the primary account holder */
  readonly primaryAccountHolderEmail: Scalars['String']['input'];
  /** First name of the primary account holder */
  readonly primaryAccountHolderFirstName: Scalars['String']['input'];
  /** Last name of the primary account holder */
  readonly primaryAccountHolderLastName: Scalars['String']['input'];
  /** Phone number of the primary account holder */
  readonly primaryAccountHolderPhone?: InputMaybe<Scalars['String']['input']>;
  /** Email of the secondary account holder */
  readonly secondaryAccountHolderEmail?: InputMaybe<Scalars['String']['input']>;
  /** First name of the secondary account holder */
  readonly secondaryAccountHolderFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the secondary account holder */
  readonly secondaryAccountHolderLastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the secondary account holder */
  readonly secondaryAccountHolderPhone?: InputMaybe<Scalars['String']['input']>;
};

/** One failed document in a bulk Box upload */
export type BulkUploadFilesToBoxFailure = {
  readonly __typename?: 'BulkUploadFilesToBoxFailure';
  /** Display name of the document */
  readonly documentName: Scalars['String']['output'];
  /** URL to open the document (for link only) */
  readonly documentUrl: Scalars['String']['output'];
  /** Error message */
  readonly errorMessage: Scalars['String']['output'];
  /** Display name of the household */
  readonly householdName: Scalars['String']['output'];
};

/** Autogenerated input type of BulkUploadFilesToBox */
export type BulkUploadFilesToBoxInput = {
  /** Target Box folder type */
  readonly boxFolderType: BoxFolderTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Documents to upload */
  readonly items: ReadonlyArray<BulkUploadFilesToBoxItemInput>;
};

/** One document to upload in a bulk Box upload */
export type BulkUploadFilesToBoxItemInput = {
  /** Display name of the document */
  readonly documentName: Scalars['String']['input'];
  /** Document download URL */
  readonly documentUrl: Scalars['String']['input'];
  /** Household ID */
  readonly householdId: Scalars['ID']['input'];
  /** Display name of the household (for failure list) */
  readonly householdName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BulkUploadFilesToBox. */
export type BulkUploadFilesToBoxPayload = {
  readonly __typename?: 'BulkUploadFilesToBoxPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if start failed */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** Job ID to poll for status */
  readonly jobId?: Maybe<Scalars['String']['output']>;
};

/** Status of a bulk file upload to Box */
export type BulkUploadFilesToBoxStatus = {
  readonly __typename?: 'BulkUploadFilesToBoxStatus';
  /** Number completed (success) */
  readonly completed: Scalars['Int']['output'];
  /** Number failed */
  readonly failed: Scalars['Int']['output'];
  /** Same as failed */
  readonly failureCount: Scalars['Int']['output'];
  /** List of failed items */
  readonly failures: ReadonlyArray<BulkUploadFilesToBoxFailure>;
  /** pending, processing, completed, or failed */
  readonly status: Scalars['String']['output'];
  /** Same as completed */
  readonly successCount: Scalars['Int']['output'];
  /** Total number of items */
  readonly total: Scalars['Int']['output'];
};

/** Per-day overflow count when limitPerDay caps the response */
export type CalendarDayOverflow = {
  readonly __typename?: 'CalendarDayOverflow';
  /** Number of work items beyond the per-day limit on this date */
  readonly count: Scalars['Int']['output'];
  /** The calendar date with overflowing work items */
  readonly date: Scalars['ISO8601Date']['output'];
};

/** A calendar event from an advisor's calendar */
export type CalendarEvent = {
  readonly __typename?: 'CalendarEvent';
  /** All participants in the event. */
  readonly calendarEventParticipants: ReadonlyArray<CalendarEventParticipant>;
  /**
   * Id of the requester's own canvas document for this event: the meeting_recap
   * doc once the meeting has one, otherwise the meeting_prep doc. Null when
   * neither exists or the doc belongs to another user.
   */
  readonly canvasDocumentId?: Maybe<Scalars['ID']['output']>;
  /**
   * Type of the document `canvasDocumentId` points at, so callers can label a
   * recap CTA differently from a prep one. Null whenever `canvasDocumentId` is null.
   */
  readonly canvasDocumentType?: Maybe<CanvasDocumentType>;
  /** Timestamp when the calendar event was created in Savvy. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of the event. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Event end date (for all-day events). */
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Event end time with timezone (for timed events). */
  readonly endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Households linked to this event via participant matching. */
  readonly households: ReadonlyArray<Household>;
  /** The Savvy ID of the calendar event. */
  readonly id: Scalars['ID']['output'];
  /** Whether the event is an all-day event. */
  readonly isAllDay: Scalars['Boolean']['output'];
  /** The location of the event. */
  readonly location?: Maybe<Scalars['String']['output']>;
  /** Video conference or meeting link. */
  readonly meetingLink?: Maybe<Scalars['String']['output']>;
  /**
   * The Note attached to this CalendarEvent, scoped to the requesting household
   * context. Null when no Note is linked, the Note is out of scope, or the
   * requester is not authorized.
   */
  readonly note?: Maybe<Note>;
  /** Event start date (for all-day events). */
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Event start time with timezone (for timed events). */
  readonly startsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Event status (confirmed, tentative, cancelled). */
  readonly status: Scalars['String']['output'];
  /** The title/summary of the event. */
  readonly summary?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the calendar event was last updated in Savvy. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for CalendarEvent. */
export type CalendarEventConnection = {
  readonly __typename?: 'CalendarEventConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CalendarEventEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<CalendarEvent>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CalendarEventEdge = {
  readonly __typename?: 'CalendarEventEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CalendarEvent>;
};

/** A participant in a calendar event with their response status */
export type CalendarEventParticipant = {
  readonly __typename?: 'CalendarEventParticipant';
  /** Timestamp when the participant was added to the event. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the calendar event participant. */
  readonly id: Scalars['ID']['output'];
  /** Whether this participant is optional. */
  readonly isOptional: Scalars['Boolean']['output'];
  /** Whether this participant is the organizer of the event. */
  readonly isOrganizer: Scalars['Boolean']['output'];
  /** The participant details - either a Participant (external) or User (internal). */
  readonly participant: CalendarEventParticipantPersonUnion;
  /** The participant's response status (needs_action, accepted, declined, tentative). */
  readonly responseStatus: Scalars['String']['output'];
  /** Timestamp when the participant was last updated. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A person participating in a calendar event - either an external Participant or an internal User */
export type CalendarEventParticipantPersonUnion = Participant | PublicParticipantUser | User;

/** The connection type for WorkItem. */
export type CalendarWorkItemConnection = {
  readonly __typename?: 'CalendarWorkItemConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<WorkItemEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<WorkItem>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Per-day overflow counts when limitPerDay is set; empty array when limitPerDay is absent */
  readonly remainingCountPerDay: ReadonlyArray<CalendarDayOverflow>;
  /** Total number of work items matching the query without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** A wizard calibration pick mapped to a voice trait. */
export type CalibrationDerivedTraitInput = {
  /** Which option the advisor picked: A | B | neither. */
  readonly choice: Scalars['String']['input'];
  /** Advisor freeform text, present only when choice is neither. */
  readonly neitherText?: InputMaybe<Scalars['String']['input']>;
  /** Provenance of the value; 'calibration' for capture-flow picks. */
  readonly source: Scalars['String']['input'];
  /** Target trait key: warmth | jargon | numbers | directness | sign_off. */
  readonly trait: Scalars['String']['input'];
  /** Short characterization of the chosen option (or the advisor's freeform 'neither' text). */
  readonly value: Scalars['String']['input'];
};

/** A call log entry representing a call between an advisor and a client */
export type CallLog = {
  readonly __typename?: 'CallLog';
  /** The advisor profile associated with this call log. */
  readonly advisorProfile: Advisor;
  /** The COI associated with this call log, if it is COI-scoped. */
  readonly centerOfInfluenceRep?: Maybe<CenterOfInfluenceRep>;
  /** The client profile associated with this call log, if it is household-scoped. */
  readonly clientProfile?: Maybe<Client>;
  /** The client profile ID associated with this call log, if it is household-scoped. */
  readonly clientProfileId?: Maybe<Scalars['ID']['output']>;
  /** Notes or content from the call. */
  readonly content: Scalars['String']['output'];
  /** Timestamp when the call log was created in Savvy. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The date and time when the call occurred. */
  readonly date: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the call log. */
  readonly id: Scalars['ID']['output'];
  /** The Salesforce task ID associated with this call log. Needed for dual write for now. */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the call log was last updated in Savvy. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of CancelExactTasks */
export type CancelExactTasksInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Exact task IDs and expected names to cancel */
  readonly targets: ReadonlyArray<TaskCancellationTargetInput>;
};

/** Autogenerated return type of CancelExactTasks. */
export type CancelExactTasksPayload = {
  readonly __typename?: 'CancelExactTasksPayload';
  /** Task IDs already cancelled */
  readonly alreadyCancelledIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Task IDs cancelled by this call */
  readonly cancelledIds: ReadonlyArray<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Task IDs whose cancellation failed */
  readonly failedIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Task IDs not in todo status */
  readonly ineligibleIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Task IDs with no matching task */
  readonly notFoundIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Task IDs whose expected name no longer matches */
  readonly staleIds: ReadonlyArray<Scalars['ID']['output']>;
};

/** Autogenerated input type of CancelLinkedBankAccountImport */
export type CancelLinkedBankAccountImportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the LinkedBankAccountImport to cancel */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelLinkedBankAccountImport. */
export type CancelLinkedBankAccountImportPayload = {
  readonly __typename?: 'CancelLinkedBankAccountImportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** The cancelled import record */
  readonly linkedBankAccountImport?: Maybe<LinkedBankAccountImport>;
};

export type CanvasBoxToken = {
  readonly __typename?: 'CanvasBoxToken';
  /**
   * Box token (read-level file access + Box AI) for the Savvy Intelligence canvas
   * agent to read documents server-side. Downscoped to `folderId` only when
   * `advisorWideAccess` is false; when true it reaches every folder the advisor
   * can read in Box. Agent-harness use only — not a general-purpose Box token.
   */
  readonly accessToken: Scalars['String']['output'];
  /**
   * True when the token is NOT locked to `folderId` and instead reads every folder
   * the advisor can reach in Box (flag-gated pilot). The canvas prompt swaps its
   * document-scope guidance on this, so callers must thread it through.
   */
  readonly advisorWideAccess: Scalars['Boolean']['output'];
  /**
   * The household Box folder the token was requested for. Box enforces it as a
   * hard boundary only when `advisorWideAccess` is false; otherwise it is the
   * folder the agent is told to treat as its default.
   */
  readonly folderId: Scalars['String']['output'];
};

export const CanvasDocumentType = {
  /** communication */
  Communication: 'communication',
  /** meeting_client_deliverable */
  MeetingClientDeliverable: 'meeting_client_deliverable',
  /** meeting_prep */
  MeetingPrep: 'meeting_prep',
  /** meeting_recap */
  MeetingRecap: 'meeting_recap',
  /** planning */
  Planning: 'planning'
} as const;

export type CanvasDocumentType = typeof CanvasDocumentType[keyof typeof CanvasDocumentType];
/** A carry-over selection for one standing instruction or recurring transfer. */
export type CarryOverSelectionInput = {
  /** Standing instruction or recurring transfer identifier */
  readonly id: Scalars['ID']['input'];
  /** Whether this record should be carried over to the new account */
  readonly shouldCarryOver: Scalars['Boolean']['input'];
};

/** Combined cash and money market balance for an account. */
export type CashAndMoneyMarket = {
  readonly __typename?: 'CashAndMoneyMarket';
  /** The combined cash and money market amount, serialized as a decimal string. */
  readonly amount: Scalars['String']['output'];
  /** Whether amount came from a stored provider value. When false, amount is a compatibility placeholder. */
  readonly amountKnown: Scalars['Boolean']['output'];
  /** ISO currency code for the amount. */
  readonly currencyCode: Scalars['String']['output'];
  /** The combined cash and money market amount as a percent of the account balance. */
  readonly percent: Scalars['Float']['output'];
  /** Whether percent came from a stored provider value. When false, percent is a compatibility placeholder. */
  readonly percentKnown: Scalars['Boolean']['output'];
};

export type CashReservesPerAccount = {
  readonly __typename?: 'CashReservesPerAccount';
  readonly accountName?: Maybe<Scalars['String']['output']>;
  readonly cashReserves?: Maybe<Scalars['String']['output']>;
};

export type CenterOfInfluenceRep = {
  readonly __typename?: 'CenterOfInfluenceRep';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly clientReferralUrl: Scalars['String']['output'];
  /**
   * Comment indicator for a professional-contacts list row or card, scoped to the
   * viewing user. Batched — safe to request across the whole contacts list.
   */
  readonly commentSummary: CommentSummary;
  readonly company?: Maybe<Company>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly email: Scalars['String']['output'];
  /** Free-text fee or rate this contact charges, e.g. "$250/hr" or "1% AUM". */
  readonly feeRate?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  /**
   * Edges where this contact is the target (who referred this contact). Filter by relationshipType.
   * @deprecated Frozen. Use referrals.
   */
  readonly incomingProfessionalRelationships: ReadonlyArray<ProfessionalRelationship>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly linkedinUrl?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  /**
   * Edges where this contact is the source (households it serves, contacts it referred). Filter by relationshipType.
   * @deprecated Frozen. Use professionalServices and referrals.
   */
  readonly outgoingProfessionalRelationships: ReadonlyArray<ProfessionalRelationship>;
  /**
   * The advisor who owns this contact. A narrow display type rather than Advisor,
   * whose AdvisorPolicy gate would raise for a firm colleague that ContactPolicy admits.
   */
  readonly owner: ContactOwner;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly photoUrl?: Maybe<Scalars['String']['output']>;
  readonly preferredContactMethod?: Maybe<CenterOfInfluenceRepPreferredContactMethod>;
  /** The households and retirement plans this contact serves that the viewer can read, newest first. */
  readonly professionalServices: ReadonlyArray<ProfessionalService>;
  /** Every referral this contact is on, either side, whose other side the viewer can read, newest first. */
  readonly referrals: ReadonlyArray<Referral>;
  readonly referredHouseholds: ReadonlyArray<Household>;
  readonly secondaryEmail?: Maybe<Scalars['String']['output']>;
  readonly secondaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  readonly specialties: ReadonlyArray<CenterOfInfluenceRepSpecialty>;
  /** Two-letter US state code, kept apart from the free-text address so it can be filtered on. */
  readonly state?: Maybe<Scalars['String']['output']>;
  /** The contact's own website, independent of its company's. */
  readonly website?: Maybe<Scalars['String']['output']>;
};

export const CenterOfInfluenceRepPreferredContactMethod = {
  /** email */
  Email: 'email',
  /** mobile */
  Mobile: 'mobile',
  /** other */
  Other: 'other',
  /** phone */
  Phone: 'phone'
} as const;

export type CenterOfInfluenceRepPreferredContactMethod = typeof CenterOfInfluenceRepPreferredContactMethod[keyof typeof CenterOfInfluenceRepPreferredContactMethod];
export const CenterOfInfluenceRepSpecialty = {
  /** coi */
  Coi: 'coi',
  /** estate */
  Estate: 'estate',
  /** insurance */
  Insurance: 'insurance',
  /** legal */
  Legal: 'legal',
  /** mortgage */
  Mortgage: 'mortgage',
  /** other */
  Other: 'other',
  /** tax */
  Tax: 'tax'
} as const;

export type CenterOfInfluenceRepSpecialty = typeof CenterOfInfluenceRepSpecialty[keyof typeof CenterOfInfluenceRepSpecialty];
/** Checkbox filter with operator and boolean value */
export type CheckboxFilterInput = {
  /** Checkbox filter operator */
  readonly operator: CheckboxFilterOperatorEnum;
  /** Filter boolean value */
  readonly value: Scalars['Boolean']['input'];
};

/** Checkbox filter operators */
export const CheckboxFilterOperatorEnum = {
  /** Is the boolean value */
  Is: 'IS',
  /** Is not the boolean value */
  IsNot: 'IS_NOT'
} as const;

export type CheckboxFilterOperatorEnum = typeof CheckboxFilterOperatorEnum[keyof typeof CheckboxFilterOperatorEnum];
/** Why a real-estate property has no Chimney value: it has no structured address, or Chimney could not use the one it has. */
export const ChimneyAddressIssue = {
  /** lookup_failed */
  LookupFailed: 'lookup_failed',
  /** missing */
  Missing: 'missing',
  /** not_found */
  NotFound: 'not_found',
  /** rejected */
  Rejected: 'rejected'
} as const;

export type ChimneyAddressIssue = typeof ChimneyAddressIssue[keyof typeof ChimneyAddressIssue];
/** Mortgage data Chimney (Array) returned for this real-estate asset. */
export type ChimneyMortgageData = {
  readonly __typename?: 'ChimneyMortgageData';
  /** Annual percentage rate, as a fraction (0.0599 = 5.99%). */
  readonly apr?: Maybe<Scalars['BigDecimal']['output']>;
  /** Mortgage lender name. */
  readonly lender?: Maybe<Scalars['String']['output']>;
  /** Original loan amount. */
  readonly loanAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** Monthly payment amount. */
  readonly monthlyPayment?: Maybe<Scalars['BigDecimal']['output']>;
  /** Date the mortgage originated. */
  readonly originationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Expected payoff date. */
  readonly payoffDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Current remaining balance. */
  readonly remainingBalance?: Maybe<Scalars['BigDecimal']['output']>;
  /** Liability type Chimney reported, e.g. mortgage. */
  readonly type?: Maybe<Scalars['String']['output']>;
};

/** Property details Chimney (Array) returned for this real-estate asset. */
export type ChimneyPropertyDetails = {
  readonly __typename?: 'ChimneyPropertyDetails';
  /** Number of bathrooms, may be fractional (e.g. 2.5). */
  readonly bathrooms?: Maybe<Scalars['BigDecimal']['output']>;
  /** Number of bedrooms. */
  readonly bedrooms?: Maybe<Scalars['Int']['output']>;
  /** Whether Chimney reports the property as owner-occupied. */
  readonly isOwnerOccupied?: Maybe<Scalars['Boolean']['output']>;
  /** Chimney property type, e.g. Residential or Commercial. */
  readonly propertyType?: Maybe<Scalars['String']['output']>;
  /** Chimney property type detail, e.g. Single Family. */
  readonly propertyTypeDetail?: Maybe<Scalars['String']['output']>;
  /** Structure square footage. */
  readonly sqft?: Maybe<Scalars['Int']['output']>;
  /** Year the structure was built. */
  readonly yearBuilt?: Maybe<Scalars['Int']['output']>;
};

/** A Chimney (Array) valuation for an address, looked up before the asset is saved. */
export type ChimneyPropertyEstimate = {
  readonly __typename?: 'ChimneyPropertyEstimate';
  /** Confidence score (0-100) for estimatedValue. */
  readonly confidence?: Maybe<Scalars['Int']['output']>;
  /** Estimated value: homeValueEstimate, falling back to marketValue then taxAssesmentTotalValue. */
  readonly estimatedValue?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Autogenerated input type of ClearHouseholdBenchmark */
export type ClearHouseholdBenchmarkInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to update. */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ClearHouseholdBenchmark. */
export type ClearHouseholdBenchmarkPayload = {
  readonly __typename?: 'ClearHouseholdBenchmarkPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the benchmark was cleared. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ClearRedisCacheForBoxFolder */
export type ClearRedisCacheForBoxFolderInput = {
  readonly boxFolderId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ClearRedisCacheForBoxFolder. */
export type ClearRedisCacheForBoxFolderPayload = {
  readonly __typename?: 'ClearRedisCacheForBoxFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the cache was successfully cleared */
  readonly success: Scalars['Boolean']['output'];
};

export type Client = {
  readonly __typename?: 'Client';
  readonly accountSetupTaskId?: Maybe<Scalars['ID']['output']>;
  readonly accounts?: Maybe<ReadonlyArray<Account>>;
  /** The age of the client in years */
  readonly age?: Maybe<Scalars['Int']['output']>;
  /**
   * Every income source annualized and summed, mirroring totalAnnualIncome. Not
   * the client's salary once they record a second source of income.
   */
  readonly annualGrossIncome?: Maybe<Scalars['Float']['output']>;
  readonly assets?: Maybe<ReadonlyArray<Asset>>;
  readonly assignedAdvisor: Advisor;
  readonly boxFolderUrl?: Maybe<Scalars['String']['output']>;
  readonly callLogs?: Maybe<ReadonlyArray<CallLog>>;
  /** Client citizenship */
  readonly citizenship?: Maybe<Scalars['String']['output']>;
  /** Client agreements for this client */
  readonly clientAgreements?: Maybe<ReadonlyArray<ClientAgreement>>;
  readonly clientIntakeData?: Maybe<ClientIntakeData>;
  readonly clientIntakeDataUrl?: Maybe<Scalars['String']['output']>;
  readonly clientPortfolioCsvUrl: Scalars['String']['output'];
  readonly clientProfileId?: Maybe<Scalars['ID']['output']>;
  /** The date the client began working with the advisor, which may predate their Savvy contract */
  readonly clientSince?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly coManagerSsn?: Maybe<Scalars['String']['output']>;
  readonly contacts?: Maybe<ReadonlyArray<Contact>>;
  readonly createdAt: Scalars['ISO8601Date']['output'];
  readonly dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The date the client passed away, if applicable */
  readonly dateOfDeath?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly dialpadEvents?: Maybe<ReadonlyArray<DialpadEvent>>;
  readonly employerName?: Maybe<Scalars['String']['output']>;
  readonly employmentStatus?: Maybe<EmploymentStatusName>;
  /** Whether tax tab is enabled, source of truth is from client's primary advisor */
  readonly enableTaxTab: Scalars['Boolean']['output'];
  readonly feeScheduleLines?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly governmentIds?: Maybe<ReadonlyArray<GovernmentId>>;
  /**
   * The household this client is associated with. Pass id to scope to a specific
   * household the underlying user is a member of (SV-940); falls back to the
   * ClientProfile household otherwise.
   */
  readonly household: Household;
  readonly id: Scalars['ID']['output'];
  /** The client's recurring income sources, in display order */
  readonly incomeSources: ReadonlyArray<ClientIncomeSource>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  /** Client legal residence */
  readonly legalResidence?: Maybe<Scalars['String']['output']>;
  readonly liabilities?: Maybe<ReadonlyArray<Liability>>;
  readonly mostRecentInboundDialpadSms?: Maybe<DialpadEvent>;
  /** The number of post-onboarding tasks remaining for the client household to complete */
  readonly numberOfTodoTasks: Scalars['Int']['output'];
  /** Client occupation */
  readonly occupation?: Maybe<Scalars['String']['output']>;
  /** When the onboarding (IAA) task for this client was created */
  readonly onboardingIaaCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly opportunities?: Maybe<ReadonlyArray<Opportunity>>;
  readonly providerAccounts?: Maybe<ReadonlyArray<ProviderAccount>>;
  /**
   * Every active income source annualized and summed. Null means no income source
   * is recorded; zero means at least one source records zero.
   */
  readonly recordedTotalAnnualIncome?: Maybe<Scalars['BigDecimal']['output']>;
  readonly retirementDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The role of the client in the household (primary or member) */
  readonly role: ClientRole;
  readonly salesforceContactId?: Maybe<Scalars['String']['output']>;
  readonly soloPropEntityName?: Maybe<Scalars['String']['output']>;
  readonly ssn?: Maybe<Scalars['String']['output']>;
  readonly stage?: Maybe<ClientStage>;
  readonly tasks?: Maybe<ReadonlyArray<Task>>;
  /** Tax enrollments for this client */
  readonly taxEnrollments?: Maybe<ReadonlyArray<TaxEnrollment>>;
  /** Tax transcript requests for this client */
  readonly taxTranscriptRequests?: Maybe<ReadonlyArray<TaxTranscriptRequest>>;
  /** client tax transcripts */
  readonly taxTranscripts?: Maybe<ReadonlyArray<TaxTranscript>>;
  /** Every income source annualized and summed. Resolved here so callers never sum decimals in JS. */
  readonly totalAnnualIncome: Scalars['BigDecimal']['output'];
  readonly university?: Maybe<Scalars['String']['output']>;
  readonly user: User;
};


export type ClientAccountSetupTaskIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientAccountsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientAssignedAdvisorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientBoxFolderUrlArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientContactsArgs = {
  isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClientFeeScheduleLinesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientHouseholdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientNumberOfTodoTasksArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type ClientProviderAccountsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * A beneficiary designation on one of the viewer's accounts, as shown in the
 * client portal. Deliberately narrower than Types::Beneficiary: it carries the
 * four display values only, so the SSN and date of birth on the underlying Contact
 * cannot be selected from a client surface.
 */
export type ClientAccountBeneficiary = {
  readonly __typename?: 'ClientAccountBeneficiary';
  /** True for a contingent designation, false for a primary one. */
  readonly contingent: Scalars['Boolean']['output'];
  /** Identifier of the designation edge. */
  readonly id: Scalars['ID']['output'];
  /**
   * The beneficiary's display name, built from whichever name parts are on file.
   * Null when the contact carries neither, which the client surface labels rather
   * than dropping the row - a designation with a tier and a share is the thing the
   * client is being asked to confirm.
   */
  readonly name?: Maybe<Scalars['String']['output']>;
  /**
   * Their relationship as an unlabelled contact-relation value (e.g. "spouse",
   * "niece_nephew"), read from the account owner's own contact record where there
   * is one and otherwise from another member of the same household. Never from a
   * user outside it. Null when none is on record.
   */
  readonly relationship?: Maybe<Scalars['String']['output']>;
  /**
   * The designated share as a whole percent. Shares are per tier, so a primary and
   * a contingent designation can each total 100. Null when no share is on record.
   */
  readonly sharePercent?: Maybe<Scalars['Int']['output']>;
};

/** Client agreement (e.g. IAA) for a client profile. */
export type ClientAgreement = {
  readonly __typename?: 'ClientAgreement';
  /** The type of agreement (e.g. iaa). */
  readonly agreementType: Scalars['String']['output'];
  /** When the agreement was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the client agreement. */
  readonly id: Scalars['ID']['output'];
  /** Box file ID for the signable document. */
  readonly signableDocumentBoxFileId?: Maybe<Scalars['String']['output']>;
  /** Link to the signable document. */
  readonly signableDocumentLink?: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the signature for the client agreement. */
  readonly signatureId?: Maybe<Scalars['ID']['output']>;
  /** Box file ID for the signed document. */
  readonly signedDocumentBoxFileId?: Maybe<Scalars['String']['output']>;
  /** When the agreement was last updated. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Whether cash raising is needed (Final Bill variant) */
export const ClientBillingCashRaisingNeededName = {
  /** no */
  No: 'no',
  /** unsure */
  Unsure: 'unsure',
  /** yes */
  Yes: 'yes'
} as const;

export type ClientBillingCashRaisingNeededName = typeof ClientBillingCashRaisingNeededName[keyof typeof ClientBillingCashRaisingNeededName];
/** Whether a request date takes effect immediately or on a future date described in the notes */
export const ClientBillingDateTimingName = {
  /** future */
  Future: 'future',
  /** immediate */
  Immediate: 'immediate'
} as const;

export type ClientBillingDateTimingName = typeof ClientBillingDateTimingName[keyof typeof ClientBillingDateTimingName];
/** Fee change direction (Fee Schedule Update variant) */
export const ClientBillingFeeChangeTypeName = {
  /** decrease */
  Decrease: 'decrease',
  /** increase */
  Increase: 'increase',
  /** no_change */
  NoChange: 'no_change'
} as const;

export type ClientBillingFeeChangeTypeName = typeof ClientBillingFeeChangeTypeName[keyof typeof ClientBillingFeeChangeTypeName];
/** Client Billing — Other variant: catch-all billing request */
export type ClientBillingOtherInput = {
  /** Description of the request */
  readonly description: Scalars['String']['input'];
  /** Urgency — standard or urgent */
  readonly urgency: ClientBillingUrgencyName;
};

/** Payment cadence (New Financial Planning Client variant) */
export const ClientBillingPaymentCadenceName = {
  /** annual */
  Annual: 'annual',
  /** monthly */
  Monthly: 'monthly',
  /** one_time */
  OneTime: 'one_time',
  /** quarterly */
  Quarterly: 'quarterly',
  /** semi_annual */
  SemiAnnual: 'semi_annual'
} as const;

export type ClientBillingPaymentCadenceName = typeof ClientBillingPaymentCadenceName[keyof typeof ClientBillingPaymentCadenceName];
/** Payment method (New Financial Planning Client variant) */
export const ClientBillingPaymentMethodName = {
  /** advicepay */
  Advicepay: 'advicepay',
  /** deduct */
  Deduct: 'deduct'
} as const;

export type ClientBillingPaymentMethodName = typeof ClientBillingPaymentMethodName[keyof typeof ClientBillingPaymentMethodName];
/** Rebate method (Client Fee Rebate variant) */
export const ClientBillingRebateMethodName = {
  /** credit */
  Credit: 'credit',
  /** direct_payment */
  DirectPayment: 'direct_payment'
} as const;

export type ClientBillingRebateMethodName = typeof ClientBillingRebateMethodName[keyof typeof ClientBillingRebateMethodName];
/** Client billing request data associated with a task */
export type ClientBillingRequest = {
  readonly __typename?: 'ClientBillingRequest';
  /** Whether cash raising is needed (Final Bill variant) */
  readonly cashRaisingNeeded?: Maybe<ClientBillingCashRaisingNeededName>;
  /** Current fee, as entered (Fee Schedule Update variant) */
  readonly currentFee?: Maybe<Scalars['String']['output']>;
  /** Account number for deduct, free text (New Financial Planning Client variant) */
  readonly deductAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Description (Client Billing — Other variant) */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Effective date (Fee Schedule Update, New Financial Planning Client) */
  readonly effectiveDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether the effective date is immediate or a future date described in the notes */
  readonly effectiveDateTiming?: Maybe<ClientBillingDateTimingName>;
  /** Expected resume date (Billing Hold variant) */
  readonly expectedResumeDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Annual fee amount (New Financial Planning Client variant) */
  readonly feeAmount?: Maybe<Scalars['String']['output']>;
  /** Fee change direction (Fee Schedule Update variant) */
  readonly feeChangeType?: Maybe<ClientBillingFeeChangeTypeName>;
  /** Hold start date (Billing Hold variant) */
  readonly holdStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether the hold start date is immediate or a future date described in the notes */
  readonly holdStartDateTiming?: Maybe<ClientBillingDateTimingName>;
  /** Whether a new IAA was confirmed (Fee Schedule Update variant) */
  readonly iaaConfirmed?: Maybe<Scalars['Boolean']['output']>;
  /** The Savvy ID of the request. */
  readonly id: Scalars['ID']['output'];
  /** Last service date (Final Bill variant) */
  readonly lastServiceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether the last service date is immediate or a future date described in the notes */
  readonly lastServiceDateTiming?: Maybe<ClientBillingDateTimingName>;
  /** New fee, as entered (Fee Schedule Update variant) */
  readonly newFee?: Maybe<Scalars['String']['output']>;
  /** Free-text notes for Ops */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /** Payment cadence (New Financial Planning Client variant) */
  readonly paymentCadence?: Maybe<ClientBillingPaymentCadenceName>;
  /** Payment method (New Financial Planning Client variant) */
  readonly paymentMethod?: Maybe<ClientBillingPaymentMethodName>;
  /** Plan name (Corporate Retirement Billing Question variant) */
  readonly planName?: Maybe<Scalars['String']['output']>;
  /** The billing question (Corporate Retirement Billing Question variant) */
  readonly question?: Maybe<Scalars['String']['output']>;
  /** Reason for the rebate (Client Fee Rebate variant) */
  readonly reason?: Maybe<Scalars['String']['output']>;
  /** Reason for the hold (Billing Hold variant) */
  readonly reasonForHold?: Maybe<Scalars['String']['output']>;
  /** Rebate amount (Client Fee Rebate variant) */
  readonly rebateAmount?: Maybe<Scalars['String']['output']>;
  /** Rebate method (Client Fee Rebate variant) */
  readonly rebateMethod?: Maybe<ClientBillingRebateMethodName>;
  /** Recordkeeper (Corporate Retirement Billing Question variant) */
  readonly recordkeeper?: Maybe<Scalars['String']['output']>;
  /** Accounts selected on the request (Fee Schedule Update, Client Fee Rebate, Billing Hold, Final Bill) */
  readonly requestAccounts: ReadonlyArray<ClientBillingRequestAccount>;
  /** The variant of the request (e.g. fee_schedule_update, final_bill) */
  readonly requestType: ClientBillingRequestTypeName;
  /** Responsible party (Client Fee Rebate variant) */
  readonly responsibleParty?: Maybe<ClientBillingResponsiblePartyName>;
  /** Urgency (Corporate Retirement Billing Question, Client Billing — Other) */
  readonly urgency?: Maybe<ClientBillingUrgencyName>;
};

/** An account associated with a client billing request */
export type ClientBillingRequestAccount = {
  readonly __typename?: 'ClientBillingRequestAccount';
  /** The associated account */
  readonly account?: Maybe<Account>;
  /** The Savvy ID of the join record. */
  readonly id: Scalars['ID']['output'];
};

/** Client billing request — exactly one variant must be set (oneOf). */
export type ClientBillingRequestTaskInput =
  /** Billing hold variant */
  { readonly billingHold: BillingHoldInput; readonly clientBillingOther?: never; readonly clientFeeRebate?: never; readonly corporateRetirementBillingQuestion?: never; readonly feeScheduleUpdate?: never; readonly finalBill?: never; readonly newFinancialPlanningClient?: never; }
  |  /** Client billing — other variant */
  { readonly billingHold?: never; readonly clientBillingOther: ClientBillingOtherInput; readonly clientFeeRebate?: never; readonly corporateRetirementBillingQuestion?: never; readonly feeScheduleUpdate?: never; readonly finalBill?: never; readonly newFinancialPlanningClient?: never; }
  |  /** Client fee rebate variant */
  { readonly billingHold?: never; readonly clientBillingOther?: never; readonly clientFeeRebate: ClientFeeRebateInput; readonly corporateRetirementBillingQuestion?: never; readonly feeScheduleUpdate?: never; readonly finalBill?: never; readonly newFinancialPlanningClient?: never; }
  |  /** Corporate retirement plan billing question variant */
  { readonly billingHold?: never; readonly clientBillingOther?: never; readonly clientFeeRebate?: never; readonly corporateRetirementBillingQuestion: CorporateRetirementBillingQuestionInput; readonly feeScheduleUpdate?: never; readonly finalBill?: never; readonly newFinancialPlanningClient?: never; }
  |  /** Fee schedule update variant */
  { readonly billingHold?: never; readonly clientBillingOther?: never; readonly clientFeeRebate?: never; readonly corporateRetirementBillingQuestion?: never; readonly feeScheduleUpdate: FeeScheduleUpdateInput; readonly finalBill?: never; readonly newFinancialPlanningClient?: never; }
  |  /** Final bill variant */
  { readonly billingHold?: never; readonly clientBillingOther?: never; readonly clientFeeRebate?: never; readonly corporateRetirementBillingQuestion?: never; readonly feeScheduleUpdate?: never; readonly finalBill: FinalBillInput; readonly newFinancialPlanningClient?: never; }
  |  /** New financial planning client variant */
  { readonly billingHold?: never; readonly clientBillingOther?: never; readonly clientFeeRebate?: never; readonly corporateRetirementBillingQuestion?: never; readonly feeScheduleUpdate?: never; readonly finalBill?: never; readonly newFinancialPlanningClient: NewFinancialPlanningClientInput; };

/** The variant of a client billing request */
export const ClientBillingRequestTypeName = {
  /** billing_hold */
  BillingHold: 'billing_hold',
  /** client_billing_other */
  ClientBillingOther: 'client_billing_other',
  /** client_fee_rebate */
  ClientFeeRebate: 'client_fee_rebate',
  /** corporate_retirement_billing_question */
  CorporateRetirementBillingQuestion: 'corporate_retirement_billing_question',
  /** fee_schedule_update */
  FeeScheduleUpdate: 'fee_schedule_update',
  /** final_bill */
  FinalBill: 'final_bill',
  /** new_financial_planning_client */
  NewFinancialPlanningClient: 'new_financial_planning_client'
} as const;

export type ClientBillingRequestTypeName = typeof ClientBillingRequestTypeName[keyof typeof ClientBillingRequestTypeName];
/** Responsible party (Client Fee Rebate variant) */
export const ClientBillingResponsiblePartyName = {
  /** advisor */
  Advisor: 'advisor',
  /** other */
  Other: 'other',
  /** savvy */
  Savvy: 'savvy'
} as const;

export type ClientBillingResponsiblePartyName = typeof ClientBillingResponsiblePartyName[keyof typeof ClientBillingResponsiblePartyName];
/** Urgency of a client billing request */
export const ClientBillingUrgencyName = {
  /** standard */
  Standard: 'standard',
  /** urgent */
  Urgent: 'urgent'
} as const;

export type ClientBillingUrgencyName = typeof ClientBillingUrgencyName[keyof typeof ClientBillingUrgencyName];
/** The connection type for Client. */
export type ClientConnection = {
  readonly __typename?: 'ClientConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ClientEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Client>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ClientEdge = {
  readonly __typename?: 'ClientEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Client>;
};

/** Client Fee Rebate variant: issue a fee rebate to a client */
export type ClientFeeRebateInput = {
  /** Affected accounts */
  readonly accountIds: ReadonlyArray<Scalars['ID']['input']>;
  /** Notes for Ops */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** Reason for the rebate */
  readonly reason: Scalars['String']['input'];
  /** Rebate amount */
  readonly rebateAmount: Scalars['Float']['input'];
  /** Rebate method — credit or direct_payment */
  readonly rebateMethod: ClientBillingRebateMethodName;
  /** Responsible party — advisor, savvy, or other */
  readonly responsibleParty: ClientBillingResponsiblePartyName;
};

/** One recurring income source belonging to a client */
export type ClientIncomeSource = {
  readonly __typename?: 'ClientIncomeSource';
  /** The amount paid per `frequency` period. */
  readonly amount: Scalars['BigDecimal']['output'];
  /** `amount` normalized to a yearly figure. */
  readonly annualizedAmount: Scalars['BigDecimal']['output'];
  /** Employer street address line 1, for the employment types. */
  readonly employerAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Employer street address line 2 (suite, unit). */
  readonly employerAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Employer city. */
  readonly employerCity?: Maybe<Scalars['String']['output']>;
  /** Employer, for the employment types only. */
  readonly employerName?: Maybe<Scalars['String']['output']>;
  /** Employer ZIP code. */
  readonly employerPostalCode?: Maybe<Scalars['String']['output']>;
  /** Employer state, as a two-letter code. */
  readonly employerState?: Maybe<Scalars['String']['output']>;
  /** How often `amount` is paid. */
  readonly frequency: IncomeFrequency;
  /** The Savvy ID of the income source. */
  readonly id: Scalars['ID']['output'];
  /** The kind of income this row represents. */
  readonly incomeSourceType: IncomeSourceType;
  /** Display order within the client's income sources. */
  readonly position: Scalars['Int']['output'];
  /** Job title for the employment types; a short descriptor for rental/other. */
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type ClientIncomeSourceInput = {
  /** Amount paid per frequency period */
  readonly amount: Scalars['BigDecimal']['input'];
  /** Employer street address line 1 */
  readonly employerAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Employer street address line 2 */
  readonly employerAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Employer city */
  readonly employerCity?: InputMaybe<Scalars['String']['input']>;
  /** Employer, for the employment types */
  readonly employerName?: InputMaybe<Scalars['String']['input']>;
  /** Employer ZIP code */
  readonly employerPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Employer state, two-letter code */
  readonly employerState?: InputMaybe<Scalars['String']['input']>;
  /** How often the amount is paid */
  readonly frequency: IncomeFrequency;
  /** Existing row to update. Omit to create a new row. */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of income */
  readonly incomeSourceType: IncomeSourceType;
  /** Job title, or a descriptor for rental/other */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Client info change request data associated with a task */
export type ClientInfoChangeRequest = {
  readonly __typename?: 'ClientInfoChangeRequest';
  /** Primary street address */
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  /** Secondary street address */
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  /** Box file ID for supporting documentation */
  readonly boxFileId?: Maybe<Scalars['String']['output']>;
  /** The type of change: change_name or change_address */
  readonly changeType: Scalars['String']['output'];
  /** City */
  readonly city?: Maybe<Scalars['String']['output']>;
  /** New first name */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** The ID of the client info change request */
  readonly id: Scalars['ID']['output'];
  /** New last name */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** Primary mailing address */
  readonly mailingAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Secondary mailing address */
  readonly mailingAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Mailing city */
  readonly mailingCity?: Maybe<Scalars['String']['output']>;
  /** Mailing state */
  readonly mailingState?: Maybe<Scalars['String']['output']>;
  /** Mailing ZIP code */
  readonly mailingZipCode?: Maybe<Scalars['String']['output']>;
  /** Reason for name change */
  readonly reason?: Maybe<Scalars['String']['output']>;
  /** State */
  readonly state?: Maybe<Scalars['String']['output']>;
  /** ZIP code */
  readonly zipCode?: Maybe<Scalars['String']['output']>;
};

/** Input for client info change request task specific data */
export type ClientInfoChangeRequestInput = {
  /** Primary street address */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Secondary street address */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Box file ID for supporting documentation */
  readonly boxFileId?: InputMaybe<Scalars['String']['input']>;
  /** Type of change: change_address or change_name */
  readonly changeType: Scalars['String']['input'];
  /** City */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** New first name */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** New last name */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** Primary mailing address */
  readonly mailingAddressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Secondary mailing address */
  readonly mailingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  /** Mailing city */
  readonly mailingCity?: InputMaybe<Scalars['String']['input']>;
  /** Mailing state */
  readonly mailingState?: InputMaybe<Scalars['String']['input']>;
  /** Mailing ZIP code */
  readonly mailingZipCode?: InputMaybe<Scalars['String']['input']>;
  /** Reason for name change */
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  /** State */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** ZIP code */
  readonly zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Client data entereted during intake flow. */
export type ClientIntakeData = {
  readonly __typename?: 'ClientIntakeData';
  /** The Savvy ID of the client intake data. */
  readonly id: Scalars['ID']['output'];
  /** JSON Blob of all the data entered by client. */
  readonly intakeData: Scalars['JSON']['output'];
};

export const ClientOccupation = {
  /** accounting_professional */
  AccountingProfessional: 'accounting_professional',
  /** business_owner */
  BusinessOwner: 'business_owner',
  /** clerical */
  Clerical: 'clerical',
  /** consultant */
  Consultant: 'consultant',
  /** educator */
  Educator: 'educator',
  /** executive */
  Executive: 'executive',
  /** financial_services */
  FinancialServices: 'financial_services',
  /** foreign_government */
  ForeignGovernment: 'foreign_government',
  /** it_professional */
  ItProfessional: 'it_professional',
  /** legal_professional */
  LegalProfessional: 'legal_professional',
  /** medical_professional */
  MedicalProfessional: 'medical_professional',
  /** military */
  Military: 'military',
  /** other */
  Other: 'other',
  /** other_professional */
  OtherProfessional: 'other_professional',
  /** sales_marketing */
  SalesMarketing: 'sales_marketing',
  /** trade_service */
  TradeService: 'trade_service',
  /** us_government */
  UsGovernment: 'us_government'
} as const;

export type ClientOccupation = typeof ClientOccupation[keyof typeof ClientOccupation];
/** Onboarding context (primary/co clients, accounts, setup type) consumed synchronously by createRepaperEnvelope. */
export type ClientOnboardingInput = {
  /** Type of account setup (account_opening only for bulk repaper) */
  readonly accountSetupType: AccountSetup;
  /** Destination accounts to confirm */
  readonly accountsInfo: ReadonlyArray<AccountConfirmationAccountInfoInput>;
  /** Optional co-client information */
  readonly coClient?: InputMaybe<AccountConfirmationClientInfoInput>;
  /** Destination custodian for the account confirmation task */
  readonly destinationCustodian?: InputMaybe<DestinationCustodian>;
  /** Primary client information */
  readonly primaryClient: AccountConfirmationClientInfoInput;
};

/**
 * The comparison index a client-portal return figure is measured against, and that
 * index's own return over the same window. Sourced from Orion; never derived from
 * the household's own numbers. Present only when Orion measured from the start
 * date asked for — it clamps to the index's own inception for windows that predate
 * it — so this is always safe to place beside a return over the same window.
 */
export type ClientPortalBenchmarkComparison = {
  readonly __typename?: 'ClientPortalBenchmarkComparison';
  /** Window end (inclusive) the return covers. */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /**
   * The index's cumulative return at each reading across [startDate, endDate], for
   * charting it as a line. Null when not asked for, or when Orion served the
   * summary figures but no per-day readings — an absent series means "do not draw
   * this line", never "the line is flat at zero". Requesting it costs a wider
   * Orion response, so callers that only need the summary figures should leave it
   * out. The household's own line is a separate read,
   * clientPortalPortfolioReturnSeries, so an index Orion cannot serve does not
   * take it down too.
   */
  readonly indexSeries?: Maybe<ReadonlyArray<ClientPortalReturnSeriesPoint>>;
  /** The index's own name as Orion reports it, e.g. "Morningstar Moderate Target Risk TR USD". */
  readonly label: Scalars['String']['output'];
  /**
   * The index's annualized time-weighted return over [startDate, endDate], as a
   * fraction; equals the cumulative return for windows of a year or less. Carries
   * no advisory fee, as with returnCumulative.
   */
  readonly returnAnnualized?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * The index's cumulative time-weighted return over [startDate, endDate], as a
   * fraction (0.05 = 5%). Null when Orion has no figure. An index carries no
   * advisory fee, so this is not net of fees the way a household TWR is — do not
   * present it as like-for-like outperformance.
   */
  readonly returnCumulative?: Maybe<Scalars['BigDecimal']['output']>;
  /** Window start (inclusive) the return covers. */
  readonly startDate: Scalars['ISO8601Date']['output'];
};

/**
 * Optional client-portal nav surfaces an organization can hide from its clients.
 * Core surfaces (Home, Your team, Tasks, Investments, Net worth, Account) are
 * never hideable.
 */
export const ClientPortalHideableSurface = {
  /** documents */
  Documents: 'documents',
  /** planning */
  Planning: 'planning',
  /** tax */
  Tax: 'tax'
} as const;

export type ClientPortalHideableSurface = typeof ClientPortalHideableSurface[keyof typeof ClientPortalHideableSurface];
/** A message from the advisor to the client that is shown in the client portal, and sent via email. */
export type ClientPortalMessage = {
  readonly __typename?: 'ClientPortalMessage';
  readonly coClientHasRead: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly primaryClientHasRead: Scalars['Boolean']['output'];
  readonly status: ClientPortalMessageStatusName;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export const ClientPortalMessageStatusName = {
  Active: 'active',
  Hidden: 'hidden'
} as const;

export type ClientPortalMessageStatusName = typeof ClientPortalMessageStatusName[keyof typeof ClientPortalMessageStatusName];
/**
 * One reading on a client-portal return series: the cumulative time-weighted
 * return from the window start through this date. Readings are already cumulated,
 * so a chart plots them directly without compounding per-day factors itself.
 */
export type ClientPortalReturnSeriesPoint = {
  readonly __typename?: 'ClientPortalReturnSeriesPoint';
  /** The date this reading measures through. */
  readonly date: Scalars['ISO8601Date']['output'];
  /** Cumulative time-weighted return from the window start through `date`, as a fraction (0.05 = 5%). */
  readonly returnCumulative: Scalars['BigDecimal']['output'];
};

/** An outside specialist who serves the viewer's household, as shown in the client portal. */
export type ClientProfessionalContact = {
  readonly __typename?: 'ClientProfessionalContact';
  /** Contact email address. */
  readonly email: Scalars['String']['output'];
  /** Name of the firm they work for. Null when no firm is linked. */
  readonly firm?: Maybe<Scalars['String']['output']>;
  /** Identifier of the relationship edge. */
  readonly id: Scalars['ID']['output'];
  /** City and state of the linked firm. Null when no firm is linked or the firm has no city on record. */
  readonly location?: Maybe<Scalars['String']['output']>;
  /** The specialist's name. */
  readonly name: Scalars['String']['output'];
  /** Contact phone number, falling back to their mobile. */
  readonly phone?: Maybe<Scalars['String']['output']>;
  /**
   * Their role toward the household. Null when the advisor has not recorded one,
   * in which case the card falls back to the specialty tags.
   */
  readonly role?: Maybe<ProfessionalRelationshipRole>;
  /**
   * When the relationship began, backing the "Working with you since {year}" line.
   * The advisor-entered referral date when there is one, otherwise the date the
   * relationship was recorded — the same rule the advisor Households served column already reads.
   */
  readonly since: Scalars['ISO8601Date']['output'];
  /** Specialty tags for the category label on the card. */
  readonly specialties: ReadonlyArray<CenterOfInfluenceRepSpecialty>;
};

export type ClientProfileInput = {
  /** 2 letter ISO country code for client citizenship */
  readonly citizenship?: InputMaybe<Scalars['String']['input']>;
  /** The date the client began working with the advisor, which may predate their Savvy contract */
  readonly clientSince?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The date of birth */
  readonly dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The date the client passed away, if applicable */
  readonly dateOfDeath?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The social security number */
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
};

/** Client review presentation request data associated with a task */
export type ClientReviewPresentationRequest = {
  readonly __typename?: 'ClientReviewPresentationRequest';
  /** The ID of the client review presentation request */
  readonly id: Scalars['ID']['output'];
  /** The requested slides for the presentation */
  readonly requestedSlides: ReadonlyArray<Scalars['String']['output']>;
};

/** Client role within a household */
export const ClientRole = {
  /** Co-client/member */
  Member: 'MEMBER',
  /** Primary client */
  Primary: 'PRIMARY'
} as const;

export type ClientRole = typeof ClientRole[keyof typeof ClientRole];
/** Sortable fields for client lists */
export const ClientSortValues = {
  AnnualRevenue: 'ANNUAL_REVENUE',
  LastContactDate: 'LAST_CONTACT_DATE',
  LastModifiedDate: 'LAST_MODIFIED_DATE',
  Name: 'NAME',
  OutstandingServiceCalendarItemsCount: 'OUTSTANDING_SERVICE_CALENDAR_ITEMS_COUNT',
  OwnerName: 'OWNER_NAME',
  SavvyAum: 'SAVVY_AUM'
} as const;

export type ClientSortValues = typeof ClientSortValues[keyof typeof ClientSortValues];
export const ClientStage = {
  AccountSetupFlow: 'account_setup_flow',
  FullyOnboarded: 'fully_onboarded',
  IntakeFlow: 'intake_flow',
  OnboardingFlow: 'onboarding_flow',
  PostIntakeWaitingArea: 'post_intake_waiting_area',
  PostOnboardingWaitingArea: 'post_onboarding_waiting_area'
} as const;

export type ClientStage = typeof ClientStage[keyof typeof ClientStage];
/** A client task email that a task-creation form can preview. */
export const ClientTaskEmailKind = {
  AccountSetup: 'account_setup',
  ClientOther: 'client_other',
  FileUpload: 'file_upload',
  InitialIntakeForm: 'initial_intake_form',
  PreReviewCheckIn: 'pre_review_check_in'
} as const;

export type ClientTaskEmailKind = typeof ClientTaskEmailKind[keyof typeof ClientTaskEmailKind];
/** Autogenerated input type of CloseEciRemediationSubtask */
export type CloseEciRemediationSubtaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The remediation Subtask to close. */
  readonly subtaskId: Scalars['ID']['input'];
};

/** Autogenerated return type of CloseEciRemediationSubtask. */
export type CloseEciRemediationSubtaskPayload = {
  readonly __typename?: 'CloseEciRemediationSubtaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the subtask was closed */
  readonly success: Scalars['Boolean']['output'];
};

export type CoClientFromIntakeDataInput = {
  /** The primary address line 1 of the co-client */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The primary address line 2 of the co-client */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The annual gross income of the co-client */
  readonly annualGrossIncome?: InputMaybe<Scalars['Int']['input']>;
  /** The city of the co-client */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** The country code of the co-client */
  readonly countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The date of birth of the co-client (ISO format) */
  readonly dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the co-client */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** The employer name of the co-client */
  readonly employerName?: InputMaybe<Scalars['String']['input']>;
  /** The employment status of the co-client */
  readonly employmentStatus?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the co-client */
  readonly firstName: Scalars['String']['input'];
  /** The job title of the co-client */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the co-client */
  readonly lastName: Scalars['String']['input'];
  /** The phone number of the co-client */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the co-client */
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The retirement date of the co-client (ISO format) */
  readonly retirementDate?: InputMaybe<Scalars['String']['input']>;
  /** The SSN of the co-client */
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
  /** The state of the co-client */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** The university/college attended by the co-client */
  readonly university?: InputMaybe<Scalars['String']['input']>;
};

/** An internal-team comment on a Savvy subject */
export type Comment = {
  readonly __typename?: 'Comment';
  /** Files attached to this comment, in upload order. Empty on a tombstoned comment. */
  readonly attachments: ReadonlyArray<CommentAttachment>;
  /** The user who wrote the comment. */
  readonly author: User;
  /** Display label for the author's role, e.g. "Advisor". */
  readonly authorRoleLabel: Scalars['String']['output'];
  /** Whether the current user may delete this comment. */
  readonly canDelete: Scalars['Boolean']['output'];
  /** Whether the current user may edit this comment. */
  readonly canEdit: Scalars['Boolean']['output'];
  /** Plain text with @Full Name mention syntax. Empty string on a tombstoned comment. */
  readonly content: Scalars['String']['output'];
  /** When the comment was posted. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** When the comment was tombstoned, null if live. */
  readonly deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the comment was last edited, null if never. */
  readonly editedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The Savvy ID of the comment. */
  readonly id: Scalars['ID']['output'];
  /** Reactions grouped by emoji, most-reacted first. */
  readonly reactions: ReadonlyArray<CommentReactionSummary>;
  /** Replies to this comment, oldest first. Always empty on a reply — threading is capped at one level. */
  readonly replies: ReadonlyArray<Comment>;
  /** Optional one-line header for the thread. Only ever set on a thread's root comment, and null on a tombstoned one. */
  readonly subject?: Maybe<Scalars['String']['output']>;
  /** Whether this comment is newer than the current user's read watermark. Always false for their own comments. */
  readonly unread: Scalars['Boolean']['output'];
};

/** A file attached to a comment */
export type CommentAttachment = {
  readonly __typename?: 'CommentAttachment';
  /** The Box file id of the advisor-only copy, in the private Comment Attachments folder. */
  readonly boxFileId: Scalars['String']['output'];
  /** File size in bytes, as reported by the browser at upload time. Null on rows written before it was recorded. */
  readonly byteSize?: Maybe<Scalars['Int']['output']>;
  /** Display filename, prefixed with the thread subject when the root comment has one. */
  readonly filename: Scalars['String']['output'];
  /** The Savvy ID of the attachment. */
  readonly id: Scalars['ID']['output'];
  /** Whether a copy of this file is also filed under the client-visible Additional Materials folder. */
  readonly syncedToBox: Scalars['Boolean']['output'];
};

/** A file to attach to a comment, already uploaded to the private Comment Attachments folder by the client. */
export type CommentAttachmentInput = {
  /** The Box file id of the already-uploaded file. */
  readonly boxFileId: Scalars['String']['input'];
  /** File size in bytes, for the size label on the attachment chip. */
  readonly byteSize?: InputMaybe<Scalars['Int']['input']>;
  /** Display filename, prefixed with the thread subject when the root comment has one. */
  readonly filename: Scalars['String']['input'];
};

/** A subject's comment thread, newest top-level comment first */
export type CommentFeed = {
  readonly __typename?: 'CommentFeed';
  /**
   * Whether the current user may post on this subject. False for a viewer who can
   * read the thread but not write to it — a read_only_admin, or an archived
   * household — so the client can omit the composer rather than offer a write that
   * will be denied.
   */
  readonly canComment: Scalars['Boolean']['output'];
  /** Top-level comments, newest first, each carrying its replies */
  readonly comments: ReadonlyArray<Comment>;
  /**
   * True when older top-level comments exist beyond the fetch cap. The single
   * fetch is also the search index, so the UI has to say so rather than report "no
   * matches" for messages that exist.
   */
  readonly truncated: Scalars['Boolean']['output'];
  /** Comments on this subject the current user has not seen, excluding their own */
  readonly unreadCount: Scalars['Int']['output'];
};

/** A comment @mention candidate */
export type CommentMentionCandidate = {
  readonly __typename?: 'CommentMentionCandidate';
  /** User full name, the form stored in comment bodies as @Full Name */
  readonly fullName: Scalars['String']['output'];
  /** User id */
  readonly id: Scalars['ID']['output'];
  /** User profile picture URL */
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
  /** Display label for the candidate's role, matching Comment.authorRoleLabel */
  readonly roleLabel: Scalars['String']['output'];
};

/** Aggregated reactions of one emoji on a comment */
export type CommentReactionSummary = {
  readonly __typename?: 'CommentReactionSummary';
  /** How many users reacted with this emoji */
  readonly count: Scalars['Int']['output'];
  /** The emoji reacted with */
  readonly emoji: Scalars['String']['output'];
  /** Whether the current user is one of them */
  readonly mine: Scalars['Boolean']['output'];
};

export type CommentSent = {
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  /** Id of the task the comment was posted on. No comment body is sent. */
  readonly taskId: Scalars['String']['input'];
  readonly urlQueryParams: Scalars['JSON']['input'];
};

/** Comment indicator summary for a list row, scoped to the viewing user */
export type CommentSummary = {
  readonly __typename?: 'CommentSummary';
  /**
   * One of none|inactive|active. Three states, not the task column's four: comment
   * mentions do raise Alert rows, but this indicator is watermark-driven so it
   * clears when the viewer opens the thread, where the task column's
   * active_mention persists until the alert is dismissed.
   */
  readonly state: Scalars['String']['output'];
  /** Total comments on the subject */
  readonly totalCount: Scalars['Int']['output'];
  /** Comments the viewer has not seen, excluding the viewer's own */
  readonly unreadCount: Scalars['Int']['output'];
};

/** A company that a center of influence representative works for */
export type Company = {
  readonly __typename?: 'Company';
  /** The first line of the company address */
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  /** The second line of the company address */
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  /** The professional contacts at this company that the current user can read */
  readonly centerOfInfluenceReps: ReadonlyArray<CenterOfInfluenceRep>;
  /** The number of professional contacts linked to this company that the current user can read */
  readonly centerOfInfluenceRepsCount: Scalars['Int']['output'];
  /** The city of the company address */
  readonly city?: Maybe<Scalars['String']['output']>;
  /** Comment indicator for a businesses-list row, scoped to the viewing user. Batched — safe to request across the whole list */
  readonly commentSummary: CommentSummary;
  /** The country code of the company address */
  readonly countryCode?: Maybe<Scalars['String']['output']>;
  /** When the company was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of the company */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The distinct households served by this company's readable contacts that the current user can read */
  readonly householdsServed: ReadonlyArray<CompanyHouseholdServed>;
  /** The number of distinct households served by this company's readable contacts */
  readonly householdsServedCount: Scalars['Int']['output'];
  /** The ID of the company */
  readonly id: Scalars['ID']['output'];
  /** The URL of the company's logo */
  readonly logoUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the company */
  readonly name: Scalars['String']['output'];
  /**
   * The organization that owns this company. Null when the viewer reaches this
   * company through a contact it can read rather than through its own organization.
   */
  readonly organization?: Maybe<Organization>;
  /** The phone number of the company */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The postal code of the company address */
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  /** The number of readable households referred in by, or referred out to, this company's readable contacts */
  readonly referralsCount: Scalars['Int']['output'];
  /** The distinct specialties present across every contact at this company, readable or not */
  readonly specialties: ReadonlyArray<CenterOfInfluenceRepSpecialty>;
  /** The state of the company address */
  readonly state?: Maybe<Scalars['String']['output']>;
  /** The website of the company */
  readonly website?: Maybe<Scalars['String']['output']>;
};

/** One household served by a company, deduplicated across every readable contact at that company that serves it */
export type CompanyHouseholdServed = {
  readonly __typename?: 'CompanyHouseholdServed';
  /** Every readable contact at this company serving this household, ordered by name */
  readonly contacts: ReadonlyArray<CenterOfInfluenceRep>;
  /** The household served */
  readonly household: Household;
  /** Stable key for the row, formatted "<companyId>:<householdId>" */
  readonly id: Scalars['ID']['output'];
  /** The role recorded on the earliest serves edge; later edges may carry a different one */
  readonly role?: Maybe<ProfessionalRelationshipRole>;
  /** When the earliest serves edge to this household was created */
  readonly since: Scalars['ISO8601DateTime']['output'];
};

/**
 * Backend-computed performance for an arbitrary comparison window. Resolves an
 * Orion quickDate (MTD/QTD/YTD/PriorMonth/...) or a startDate/endDate pair via
 * Orion /Reporting/Scope on demand.
 */
export type ComparisonPerformanceSummary = {
  readonly __typename?: 'ComparisonPerformanceSummary';
  /** Portfolio market value at window start. */
  readonly beginningMarketValue?: Maybe<Value>;
  /** Total contributions in the window. */
  readonly contributions?: Maybe<Value>;
  /** Total distributions in the window. */
  readonly distributions?: Maybe<Value>;
  /** Total dividends and interest received in the window. */
  readonly dividendsAndInterest?: Maybe<Value>;
  /** The effective window end. */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Portfolio market value at window end. */
  readonly endingMarketValue?: Maybe<Value>;
  /** Net gains in the window (end - start - (contributions - distributions)). */
  readonly netGains?: Maybe<Value>;
  /** The effective window start. May differ from the requested start by a day if Orion snaps to the nearest valuation date. */
  readonly startDate: Scalars['ISO8601Date']['output'];
  /** Inbound account transfers (Merge In + Journal In) folded into contributions, signed positive. Null when unavailable. */
  readonly transfersIn?: Maybe<Value>;
  /** Outbound account transfers (Merge Out + Journal Out) folded into distributions, signed negative. Null when unavailable. */
  readonly transfersOut?: Maybe<Value>;
  /** Time-weighted return for the window, as a decimal fraction (0.12 = 12%). Computed by Orion. */
  readonly twr?: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of CompleteGoogleOAuthFlow */
export type CompleteGoogleOAuthFlowInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The code obtained from the OAuth2 redirect */
  readonly code: Scalars['String']['input'];
};

/** Autogenerated return type of CompleteGoogleOAuthFlow. */
export type CompleteGoogleOAuthFlowPayload = {
  readonly __typename?: 'CompleteGoogleOAuthFlowPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
  readonly user?: Maybe<User>;
};

/** Autogenerated input type of CompleteSchwabOauthConnect */
export type CompleteSchwabOauthConnectInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The authorization code returned by the Schwab OAuth2 redirect */
  readonly code: Scalars['String']['input'];
  /** The signed `state` query param Schwab echoed back, naming the app and the admin who started the flow */
  readonly state: Scalars['String']['input'];
};

/** Autogenerated return type of CompleteSchwabOauthConnect. */
export type CompleteSchwabOauthConnectPayload = {
  readonly __typename?: 'CompleteSchwabOauthConnectPayload';
  /** The Schwab OAuth app the state resolved to */
  readonly app: SchwabOauthApp;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the Schwab OAuth connection was persisted */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CompleteServiceOccurrence */
export type CompleteServiceOccurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Typed occurrence id, as returned by householdServiceOccurrences */
  readonly id: Scalars['ID']['input'];
  /** The occurrence's `revision` as read. The write is refused when the row has changed since */
  readonly revision: Scalars['String']['input'];
};

/** Autogenerated return type of CompleteServiceOccurrence. */
export type CompleteServiceOccurrencePayload = {
  readonly __typename?: 'CompleteServiceOccurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The occurrence after the write, or null once it no longer belongs to the household stream */
  readonly occurrence?: Maybe<HouseholdServiceOccurrence>;
};

/** Autogenerated input type of ConfirmAccounts */
export type ConfirmAccountsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Free-text notes for Client Services, stored on the confirmation task ops works from. */
  readonly opsInstructions?: InputMaybe<Scalars['String']['input']>;
  /** The staged accounts to confirm. */
  readonly stagedAccountIds: ReadonlyArray<Scalars['ID']['input']>;
  /** The staged household whose accounts are being confirmed. */
  readonly stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfirmAccounts. */
export type ConfirmAccountsPayload = {
  readonly __typename?: 'ConfirmAccountsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred. */
  readonly errors?: Maybe<ReadonlyArray<MutationError>>;
  /** The staged household after confirmation. */
  readonly stagedHousehold?: Maybe<AdvisorOnboardingStagedHousehold>;
  /** Whether the operation succeeded. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ConfirmLinkedBankAccountImport */
export type ConfirmLinkedBankAccountImportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the LinkedBankAccountImport to confirm */
  readonly id: Scalars['ID']['input'];
  /** Authorization IDs the operator chose to KEEP from the delete-review list; pruned from to_soft_delete before apply. */
  readonly keepAuthorizationIds?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
};

/** Autogenerated return type of ConfirmLinkedBankAccountImport. */
export type ConfirmLinkedBankAccountImportPayload = {
  readonly __typename?: 'ConfirmLinkedBankAccountImportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** The applied import record */
  readonly linkedBankAccountImport?: Maybe<LinkedBankAccountImport>;
};

/** Autogenerated input type of ConfirmPortfolio */
export type ConfirmPortfolioInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the portfolio to confirm */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfirmPortfolio. */
export type ConfirmPortfolioPayload = {
  readonly __typename?: 'ConfirmPortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors encountered while confirming the portfolio */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** The confirmed portfolio, if the update succeeds */
  readonly portfolio?: Maybe<Portfolio>;
};

/** The advisor note held by a household's current account-confirmation task, and the id of the task that owns it */
export type ConfirmationInstructions = {
  readonly __typename?: 'ConfirmationInstructions';
  /** The note itself, as stored. May be editor HTML or legacy plain text. */
  readonly instructions?: Maybe<Scalars['String']['output']>;
  /** The confirmation task that owns the note. Link the reader here to edit it. */
  readonly taskId: Scalars['ID']['output'];
};

export type Contact = {
  readonly __typename?: 'Contact';
  readonly dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isBeneficiary?: Maybe<Scalars['Boolean']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly nickname?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly relation?: Maybe<Scalars['String']['output']>;
  readonly ssn?: Maybe<Scalars['String']['output']>;
};

/** Whether a contact is a household contact, a professional, or both. Each contact is in at most one */
export const ContactCategory = {
  /** Both a household contact and a professional */
  Both: 'BOTH',
  /** A household contact that is not also a professional */
  Household: 'HOUSEHOLD',
  /** A professional that is not also a household contact */
  Professional: 'PROFESSIONAL'
} as const;

export type ContactCategory = typeof ContactCategory[keyof typeof ContactCategory];
/** One choice in a contacts directory filter */
export type ContactFilterOption = {
  readonly __typename?: 'ContactFilterOption';
  /** The value the contacts query takes for this choice */
  readonly id: Scalars['ID']['output'];
  /** What the filter menu shows */
  readonly name: Scalars['String']['output'];
};

/** The company and advisor choices for the contacts directory filters */
export type ContactFilterOptions = {
  readonly __typename?: 'ContactFilterOptions';
  /** Owners of the professionals the caller may list */
  readonly advisors: ReadonlyArray<ContactFilterOption>;
  /** Companies of contacts the caller may list, narrowed to the ones the caller may read */
  readonly companies: ReadonlyArray<ContactFilterOption>;
};

/** One household a contact is linked to, and what they are to it */
export type ContactHouseholdLink = {
  readonly __typename?: 'ContactHouseholdLink';
  /**
   * The household this contact depends on, when the dependency is on the household
   * rather than one client. Mutually exclusive with dependentOfUserId
   */
  readonly dependentOfHouseholdId?: Maybe<Scalars['ID']['output']>;
  /** The client this contact depends on. Mutually exclusive with dependentOfHouseholdId */
  readonly dependentOfUserId?: Maybe<Scalars['ID']['output']>;
  /** The linked household */
  readonly household: Household;
  /** ID of the linked household */
  readonly householdId: Scalars['ID']['output'];
  /** Name of the linked household */
  readonly householdName?: Maybe<Scalars['String']['output']>;
  /** Public identifier of the linked household, for building a household route */
  readonly householdPublicId?: Maybe<Scalars['String']['output']>;
  /** Whether this contact is a beneficiary of this household */
  readonly isBeneficiary?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this contact is a dependent of this household */
  readonly isDependent: Scalars['Boolean']['output'];
  /** Whether the contact is a member of this household */
  readonly isMember: Scalars['Boolean']['output'];
  /** Whether this contact is a trusted contact of this household */
  readonly isTrustedContact?: Maybe<Scalars['Boolean']['output']>;
  /** The professional's role toward this household, when it serves it */
  readonly professionalRole?: Maybe<ProfessionalRelationshipRole>;
  /**
   * Relationship to this household. Free text, and writers disagree, so an
   * unwritten relationship comes back as null or an empty string
   */
  readonly relation?: Maybe<Scalars['String']['output']>;
  /** Whether the professional contact serves this household */
  readonly serves: Scalars['Boolean']['output'];
};

/** Attributes for using a contact as an input */
export type ContactInput = {
  readonly dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly relation?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The advisor who owns a professional contact, as the contact surfaces render
 * them: a name, a photo, and the AdvisorProfile id that the edit gate and the
 * update mutation key off.
 */
export type ContactOwner = {
  readonly __typename?: 'ContactOwner';
  /** First name; null when the profile has no user */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** The owning AdvisorProfile id, the value editProfessionalContact takes as ownerAdvisorProfileId. */
  readonly id: Scalars['ID']['output'];
  /** Last name; null when the profile has no user */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** Photo URL; null falls back to initials */
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
};

/** A contact the caller may read, with the households it is linked to and its roles */
export type ContactRecord = {
  readonly __typename?: 'ContactRecord';
  /** Single-line address */
  readonly address?: Maybe<Scalars['String']['output']>;
  /**
   * Comment indicator for a contacts-directory row, scoped to the viewing user.
   * Batched — safe to request across the whole page
   */
  readonly commentSummary: CommentSummary;
  /** The company this contact works for */
  readonly company?: Maybe<Company>;
  /** Free-text description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Legal name, else name, business name, firm name, nickname or email. Null when the record has none */
  readonly displayName?: Maybe<Scalars['String']['output']>;
  /** Email address */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** Legal first name */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** Households this contact is linked to or serves, narrowed to the ones the caller may read. Empty when there are none */
  readonly households: ReadonlyArray<ContactHouseholdLink>;
  /** Unique identifier for the contact */
  readonly id: Scalars['ID']['output'];
  /**
   * Edges this contact is the target of, narrowed to the ones whose source the
   * caller may read. Unbatched per contact: select on a single contact, not the list
   * @deprecated Frozen. Use referrals.
   */
  readonly incomingProfessionalRelationships: ReadonlyArray<ProfessionalRelationship>;
  /**
   * Whether this contact is a beneficiary. Per-person today, not per-household: a
   * contact linked to two households reads the same on both. Moves onto the edge
   * with the household-contact edge model
   */
  readonly isBeneficiary?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this contact is a dependent. Per-person today, not per-household: a
   * contact linked to two households reads the same on both. Moves onto the edge
   * with the household-contact edge model
   */
  readonly isDependent?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this contact is attached to a household. Can be true alongside isProfessional */
  readonly isHouseholdContact: Scalars['Boolean']['output'];
  /** Whether this contact acts in a professional capacity. Can be true alongside isHouseholdContact */
  readonly isProfessional: Scalars['Boolean']['output'];
  /**
   * Whether this contact is a trusted contact. Per-person today, not
   * per-household: a contact linked to two households reads the same on both.
   * Moves onto the edge with the household-contact edge model
   */
  readonly isTrustedContact?: Maybe<Scalars['Boolean']['output']>;
  /** Legal last name */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** Legal middle name */
  readonly middleName?: Maybe<Scalars['String']['output']>;
  /** Preferred nickname */
  readonly nickname?: Maybe<Scalars['String']['output']>;
  /**
   * Edges this contact is the source of, narrowed to the ones whose target the
   * caller may read. Unbatched per contact: select on a single contact, not the list
   * @deprecated Frozen. Use referrals.
   */
  readonly outgoingProfessionalRelationships: ReadonlyArray<ProfessionalRelationship>;
  /** The advisor who owns this professional contact. Null for other contacts */
  readonly owner?: Maybe<ContactOwner>;
  /** Phone number */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Photo URL; null falls back to initials */
  readonly photoUrl?: Maybe<Scalars['String']['output']>;
  /** Public id of the professional contact page. Null when the contact has no such page */
  readonly professionalPublicId?: Maybe<Scalars['ID']['output']>;
  /** Every referral this contact is on, either side, whose other side the caller may read, newest first */
  readonly referrals: ReadonlyArray<Referral>;
  /** Distinct households this contact referred, by referral source or referral edge, counting only the ones the caller may read */
  readonly referredHouseholdCount: Scalars['Int']['output'];
  /** Professional specialties */
  readonly specialties: ReadonlyArray<CenterOfInfluenceRepSpecialty>;
};

/** One page of the contacts directory, with the total the filters match */
export type ContactRecordPage = {
  readonly __typename?: 'ContactRecordPage';
  /** The contacts on this page */
  readonly nodes: ReadonlyArray<ContactRecord>;
  /** How many contacts match the filters across every page */
  readonly totalCount: Scalars['Int']['output'];
};

export const ContactRelationTypeName = {
  Beneficiary: 'beneficiary',
  ClientAssociate: 'client_associate',
  Contact: 'contact',
  ContingentBeneficiary: 'contingent_beneficiary',
  FamilyMember: 'family_member',
  FinancialOfferingProviderContact: 'financial_offering_provider_contact',
  Trustee: 'trustee'
} as const;

export type ContactRelationTypeName = typeof ContactRelationTypeName[keyof typeof ContactRelationTypeName];
/** A role flag the contacts directory can be filtered by */
export const ContactRole = {
  /** Marked as a beneficiary */
  Beneficiary: 'BENEFICIARY',
  /** Marked as a dependent */
  Dependent: 'DEPENDENT',
  /** Marked as a trusted contact */
  TrustedContact: 'TRUSTED_CONTACT'
} as const;

export type ContactRole = typeof ContactRole[keyof typeof ContactRole];
/** Fields the contacts directory can be sorted by */
export const ContactSortField = {
  /** How many households the caller may read the contact is linked to */
  Households: 'HOUSEHOLDS',
  /** First name, then last name */
  Name: 'NAME',
  /** How many of the contact's comments the caller has not seen, excluding their own */
  UnreadComments: 'UNREAD_COMMENTS'
} as const;

export type ContactSortField = typeof ContactSortField[keyof typeof ContactSortField];
/** One parsed row from the CSA-uploaded contribution spreadsheet */
export type ContributionUploadRowInput = {
  /** Account number from the sheet, matched against Account#account_number */
  readonly accountNumber: Scalars['String']['input'];
  /** Contribution amount from the sheet */
  readonly contributionAmount: Scalars['Float']['input'];
  /** Whether the sheet lists a Model for this account */
  readonly modelPresent: Scalars['Boolean']['input'];
  /** Client/household display name from the sheet, used only to disambiguate a duplicate account number */
  readonly name: Scalars['String']['input'];
};

/** Per-row outcome of a contribution alert upload */
export type ContributionUploadRowResult = {
  readonly __typename?: 'ContributionUploadRowResult';
  /** Account number from the sheet */
  readonly accountNumber: Scalars['String']['output'];
  /** invest_cash / create_enrollment / no_action, when resolved */
  readonly classification?: Maybe<Scalars['String']['output']>;
  /** Why the row failed to resolve, when unresolved */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** Client/household display name from the sheet */
  readonly name: Scalars['String']['output'];
  /** Whether the row matched a real Account */
  readonly resolved: Scalars['Boolean']['output'];
};

/** Corporate Retirement Plan Billing Question variant */
export type CorporateRetirementBillingQuestionInput = {
  /** Plan name */
  readonly planName: Scalars['String']['input'];
  /** The billing question */
  readonly question: Scalars['String']['input'];
  /** Recordkeeper */
  readonly recordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Urgency — standard or urgent */
  readonly urgency: ClientBillingUrgencyName;
};

/** Corporate Retirement — Other variant */
export type CorporateRetirementOtherInput = {
  /** Description */
  readonly description: Scalars['String']['input'];
  /** Plan name */
  readonly planName?: InputMaybe<Scalars['String']['input']>;
  /** Urgency — standard or urgent */
  readonly urgency: CorporateRetirementPlanUrgencyName;
};

/** Analysis period (Prospecting Trend Analysis variant) */
export const CorporateRetirementPlanAnalysisPeriodName = {
  /** custom */
  Custom: 'custom',
  /** five_year */
  FiveYear: 'five_year',
  /** prior_vs_current */
  PriorVsCurrent: 'prior_vs_current',
  /** three_year */
  ThreeYear: 'three_year'
} as const;

export type CorporateRetirementPlanAnalysisPeriodName = typeof CorporateRetirementPlanAnalysisPeriodName[keyof typeof CorporateRetirementPlanAnalysisPeriodName];
/** Onboarding type (Retirement Plan Onboarding variant) */
export const CorporateRetirementPlanOnboardingTypeName = {
  /** new_plan */
  NewPlan: 'new_plan',
  /** recordkeeper_change */
  RecordkeeperChange: 'recordkeeper_change'
} as const;

export type CorporateRetirementPlanOnboardingTypeName = typeof CorporateRetirementPlanOnboardingTypeName[keyof typeof CorporateRetirementPlanOnboardingTypeName];
/** Corporate retirement plan request data associated with a task */
export type CorporateRetirementPlanRequest = {
  readonly __typename?: 'CorporateRetirementPlanRequest';
  /** Analysis period (Prospecting Trend Analysis variant) */
  readonly analysisPeriod?: Maybe<CorporateRetirementPlanAnalysisPeriodName>;
  /** Current fee structure (Proposal Generator variant) */
  readonly currentFeeStructure?: Maybe<Scalars['String']['output']>;
  /** Current recordkeeper (Onboarding, Proposal Generator) */
  readonly currentRecordkeeper?: Maybe<Scalars['String']['output']>;
  /** Custom analysis period end (Prospecting Trend Analysis variant) */
  readonly customPeriodEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Custom analysis period start (Prospecting Trend Analysis variant) */
  readonly customPeriodStart?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Description (Corporate Retirement — Other variant) */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Estimated plan AUM (Onboarding, Proposal Generator) */
  readonly estimatedPlanAum?: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the request. */
  readonly id: Scalars['ID']['output'];
  /** Metrics to highlight (Prospecting Trend Analysis variant) */
  readonly metricsToHighlight?: Maybe<Scalars['String']['output']>;
  /** New recordkeeper (Onboarding variant) */
  readonly newRecordkeeper?: Maybe<Scalars['String']['output']>;
  /** Free-text notes (Retirement Plan Onboarding) */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /** Number of participants (Onboarding, Proposal Generator) */
  readonly numberOfParticipants?: Maybe<Scalars['Int']['output']>;
  /** Onboarding type — new plan or recordkeeper change (Onboarding variant) */
  readonly onboardingType?: Maybe<CorporateRetirementPlanOnboardingTypeName>;
  /** Plan effective date (Onboarding variant) */
  readonly planEffectiveDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Plan name (household name when a household is selected, else free text) */
  readonly planName?: Maybe<Scalars['String']['output']>;
  /** Plan sponsor contact email (Onboarding variant) */
  readonly planSponsorContactEmail?: Maybe<Scalars['String']['output']>;
  /** Plan sponsor contact name (Onboarding variant) */
  readonly planSponsorContactName?: Maybe<Scalars['String']['output']>;
  /** Plan sponsor meeting date (Plan Review variant) */
  readonly planSponsorMeetingDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Prospect meeting date (Proposal Generator variant) */
  readonly prospectMeetingDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Prospect / plan name (Proposal Generator variant) */
  readonly prospectName?: Maybe<Scalars['String']['output']>;
  /** Recordkeeper (Plan Review, Prospecting Trend Analysis) */
  readonly recordkeeper?: Maybe<Scalars['String']['output']>;
  /** Review kinds selected on the request (Plan Review variant) */
  readonly requestReviewTypes: ReadonlyArray<CorporateRetirementPlanRequestReview>;
  /** The variant of the request (e.g. plan_review, retirement_plan_onboarding) */
  readonly requestType: CorporateRetirementPlanRequestTypeName;
  /** Specific angles to address (Proposal Generator variant) */
  readonly specificAngles?: Maybe<Scalars['String']['output']>;
  /** Specific focus areas (Plan Review variant) */
  readonly specificFocusAreas?: Maybe<Scalars['String']['output']>;
  /** Target delivery date (Plan Review, Proposal Generator) */
  readonly targetDeliveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Urgency (Corporate Retirement — Other variant) */
  readonly urgency?: Maybe<CorporateRetirementPlanUrgencyName>;
};

/** A review kind associated with a Plan Review request */
export type CorporateRetirementPlanRequestReview = {
  readonly __typename?: 'CorporateRetirementPlanRequestReview';
  /** The Savvy ID of the join record. */
  readonly id: Scalars['ID']['output'];
  /** The selected review kind */
  readonly reviewType: CorporateRetirementPlanReviewTypeName;
};

/** Corporate retirement plan request — exactly one variant must be set (oneOf). */
export type CorporateRetirementPlanRequestTaskInput =
  /** Corporate Retirement — Other variant */
  { readonly corporateRetirementOther: CorporateRetirementOtherInput; readonly planReview?: never; readonly prospectingTrendAnalysis?: never; readonly retirementPlanOnboarding?: never; readonly retirementPlanProposal?: never; }
  |  /** Plan Review variant */
  { readonly corporateRetirementOther?: never; readonly planReview: PlanReviewInput; readonly prospectingTrendAnalysis?: never; readonly retirementPlanOnboarding?: never; readonly retirementPlanProposal?: never; }
  |  /** Prospecting Trend Analysis variant */
  { readonly corporateRetirementOther?: never; readonly planReview?: never; readonly prospectingTrendAnalysis: ProspectingTrendAnalysisInput; readonly retirementPlanOnboarding?: never; readonly retirementPlanProposal?: never; }
  |  /** Retirement Plan Onboarding variant */
  { readonly corporateRetirementOther?: never; readonly planReview?: never; readonly prospectingTrendAnalysis?: never; readonly retirementPlanOnboarding: RetirementPlanOnboardingInput; readonly retirementPlanProposal?: never; }
  |  /** Retirement Plan Proposal Generator variant */
  { readonly corporateRetirementOther?: never; readonly planReview?: never; readonly prospectingTrendAnalysis?: never; readonly retirementPlanOnboarding?: never; readonly retirementPlanProposal: RetirementPlanProposalInput; };

/** The variant of a corporate retirement plan request */
export const CorporateRetirementPlanRequestTypeName = {
  /** corporate_retirement_other */
  CorporateRetirementOther: 'corporate_retirement_other',
  /** plan_review */
  PlanReview: 'plan_review',
  /** prospecting_trend_analysis */
  ProspectingTrendAnalysis: 'prospecting_trend_analysis',
  /** retirement_plan_onboarding */
  RetirementPlanOnboarding: 'retirement_plan_onboarding',
  /** retirement_plan_proposal */
  RetirementPlanProposal: 'retirement_plan_proposal'
} as const;

export type CorporateRetirementPlanRequestTypeName = typeof CorporateRetirementPlanRequestTypeName[keyof typeof CorporateRetirementPlanRequestTypeName];
/** A review kind selected on a Plan Review request */
export const CorporateRetirementPlanReviewTypeName = {
  /** fee_benchmarking */
  FeeBenchmarking: 'fee_benchmarking',
  /** full_report */
  FullReport: 'full_report',
  /** investment_review */
  InvestmentReview: 'investment_review',
  /** plan_health */
  PlanHealth: 'plan_health'
} as const;

export type CorporateRetirementPlanReviewTypeName = typeof CorporateRetirementPlanReviewTypeName[keyof typeof CorporateRetirementPlanReviewTypeName];
/** Urgency (Corporate Retirement — Other variant) */
export const CorporateRetirementPlanUrgencyName = {
  /** standard */
  Standard: 'standard',
  /** urgent */
  Urgent: 'urgent'
} as const;

export type CorporateRetirementPlanUrgencyName = typeof CorporateRetirementPlanUrgencyName[keyof typeof CorporateRetirementPlanUrgencyName];
/** Autogenerated input type of CorrectClientIdentityDetails */
export type CorrectClientIdentityDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Client user ID */
  readonly clientUserId: Scalars['ID']['input'];
  /** New primary email */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Expected current primary email */
  readonly expectedEmail: Scalars['String']['input'];
  /** New legal first name */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** New legal last name */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** New preferred name */
  readonly preferredName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CorrectClientIdentityDetails. */
export type CorrectClientIdentityDetailsPayload = {
  readonly __typename?: 'CorrectClientIdentityDetailsPayload';
  /** Whether this call changed the client */
  readonly changed: Scalars['Boolean']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the requested identity details are in effect */
  readonly success: Scalars['Boolean']['output'];
  /** Client with the resulting identity details */
  readonly user: User;
};

export type CostBasisLot = {
  readonly __typename?: 'CostBasisLot';
  readonly acquiredDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly costBasisPerUnit?: Maybe<Scalars['BigDecimal']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly gainLoss?: Maybe<Scalars['BigDecimal']['output']>;
  readonly gainLossPercent?: Maybe<Scalars['BigDecimal']['output']>;
  readonly holdingId: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isLongTerm?: Maybe<Scalars['Boolean']['output']>;
  readonly marketValue?: Maybe<Scalars['BigDecimal']['output']>;
  readonly marketValueAsOfDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly totalCostBasis?: Maybe<Scalars['BigDecimal']['output']>;
  readonly units?: Maybe<Scalars['BigDecimal']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of CreateAccountConfirmationTask */
export type CreateAccountConfirmationTaskInput = {
  /** Type of account setup */
  readonly accountSetupType: AccountSetup;
  /** Account transfer information for the household */
  readonly accountTransferData?: InputMaybe<ReadonlyArray<AccountTransferDatumInput>>;
  /** Type of account transfer */
  readonly accountTransferType?: InputMaybe<AccountTransferTypeName>;
  /** Accounts information */
  readonly accountsInfo: ReadonlyArray<AccountConfirmationAccountInfoInput>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional co-client information. Creates a new one if the household did not
   * have one. If not provided, the co-client will be deleted if it exists.
   */
  readonly coClient?: InputMaybe<AccountConfirmationClientInfoInput>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Destination custodian */
  readonly destinationCustodian?: InputMaybe<DestinationCustodian>;
  /** Serialized form state for wizard-based draft tasks; cleared on canonicalization */
  readonly draftPayload?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Advisor fee schedule to assign to the household. Its tiers fill the IAA, so
   * without one no agreement is generated at confirmation.
   */
  readonly feeScheduleId?: InputMaybe<Scalars['ID']['input']>;
  /** Household ID to which the task will be associated */
  readonly householdId: Scalars['ID']['input'];
  /** If the client is subject to any restrictive covenants */
  readonly nonSolicit: Scalars['Boolean']['input'];
  /** Primary client information */
  readonly primaryClient: AccountConfirmationClientInfoInput;
  /** Save the task as a draft without applying account confirmation side effects */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Additional information for the task */
  readonly taskDescription?: InputMaybe<Scalars['String']['input']>;
  /** Whether to send an email upon task creation */
  readonly taskNotifyUponCreation: Scalars['Boolean']['input'];
};

/** Autogenerated return type of CreateAccountConfirmationTask. */
export type CreateAccountConfirmationTaskPayload = {
  readonly __typename?: 'CreateAccountConfirmationTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created Savvy task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateAccount */
export type CreateAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly currencyCode?: InputMaybe<Scalars['String']['input']>;
  readonly currentBalance: Scalars['BigDecimal']['input'];
  readonly hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly source?: InputMaybe<PlanningAccountSource>;
  readonly sourceProviderId?: InputMaybe<Scalars['String']['input']>;
  readonly status?: InputMaybe<AccountStatusName>;
  readonly subtype?: InputMaybe<AccountSubtypeName>;
  readonly type: AccountTypeName;
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of CreateAccountMaintenanceTask */
export type CreateAccountMaintenanceTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the account maintenance request */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  readonly taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  /** The input for account maintenance task specific data */
  readonly typeSpecificInput?: InputMaybe<AccountMaintenanceRequestTaskInput>;
};

/** Autogenerated return type of CreateAccountMaintenanceTask. */
export type CreateAccountMaintenanceTaskPayload = {
  readonly __typename?: 'CreateAccountMaintenanceTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated return type of CreateAccount. */
export type CreateAccountPayload = {
  readonly __typename?: 'CreateAccountPayload';
  readonly account: Account;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateAddress */
export type CreateAddressInput = {
  /** The first line of the address */
  readonly addressLine1: Scalars['String']['input'];
  /** The second line of the address */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city of address */
  readonly city: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The country code of address, usually two letters */
  readonly countryCode: Scalars['String']['input'];
  /** The postal code */
  readonly postalCode: Scalars['String']['input'];
  /** The state of address */
  readonly state: Scalars['String']['input'];
  /** One of these types: primary, vacation, office, secondary, other */
  readonly type: AddressTypeName;
  /** The ID of the user to create the address for */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateAddress. */
export type CreateAddressPayload = {
  readonly __typename?: 'CreateAddressPayload';
  /** Returns the created address */
  readonly address: Address;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateAdvisorGroup */
export type CreateAdvisorGroupInput = {
  /** User IDs of advisors to add as members */
  readonly advisorUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the advisor group */
  readonly name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateAdvisorGroup. */
export type CreateAdvisorGroupPayload = {
  readonly __typename?: 'CreateAdvisorGroupPayload';
  /** The created advisor group */
  readonly advisorGroup?: Maybe<AdvisorGroup>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateAdvisor */
export type CreateAdvisorInput = {
  readonly bio?: InputMaybe<Scalars['String']['input']>;
  readonly calendlyLink?: InputMaybe<Scalars['String']['input']>;
  /** Whether the advisor is employed under Savvy's RIA (captive) rather than running their own book (owned). Defaults to owned. */
  readonly captive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to create an Orion representative for assistant role */
  readonly createAssistantOrionRepresentative?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dialpadUserId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly fidelityMasterAccountNumber?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  /** Name for the advisor's personal organization. Defaults to their full name; must be unique. */
  readonly organizationName?: InputMaybe<Scalars['String']['input']>;
  /** Dialpad phone number for the advisor */
  readonly phoneNumber: Scalars['String']['input'];
  readonly role?: InputMaybe<CreateAdvisorUserRole>;
  readonly schwabMasterAccountNumber?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateAdvisor. */
export type CreateAdvisorPayload = {
  readonly __typename?: 'CreateAdvisorPayload';
  readonly advisor?: Maybe<PublicAdvisor>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateAdvisorRequest */
export type CreateAdvisorRequestInput = {
  /** form filled out from feedback */
  readonly body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAdvisorRequest. */
export type CreateAdvisorRequestPayload = {
  readonly __typename?: 'CreateAdvisorRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** success of the request */
  readonly success: Scalars['Boolean']['output'];
};

/** User roles allowed for advisor creation */
export const CreateAdvisorUserRole = {
  Advisor: 'advisor',
  Assistant: 'assistant',
  Csa: 'csa'
} as const;

export type CreateAdvisorUserRole = typeof CreateAdvisorUserRole[keyof typeof CreateAdvisorUserRole];
/** Autogenerated input type of CreateAlert */
export type CreateAlertInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly content: Scalars['String']['input'];
  readonly entityId: Scalars['ID']['input'];
  readonly entityType: Scalars['String']['input'];
  readonly status: AlertStatusName;
  readonly typeOf: AlertTypeName;
};

/** Autogenerated return type of CreateAlert. */
export type CreateAlertPayload = {
  readonly __typename?: 'CreateAlertPayload';
  readonly alert: Alert;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateAlternativeInvestmentsPurchaseTask */
export type CreateAlternativeInvestmentsPurchaseTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the alternative investments purchase request */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Savvy fund variant input, sent instead of typeSpecificInput */
  readonly savvySubscriptionInput?: InputMaybe<SavvyAlternativesSubscription>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
  /** The input for alternative investments purchase task specific data */
  readonly typeSpecificInput?: InputMaybe<AlternativeInvestmentsPurchase>;
};

/** Autogenerated return type of CreateAlternativeInvestmentsPurchaseTask. */
export type CreateAlternativeInvestmentsPurchaseTaskPayload = {
  readonly __typename?: 'CreateAlternativeInvestmentsPurchaseTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateAsset */
export type CreateAssetInput = {
  readonly assetClass: AssetClassName;
  readonly assetSubclass?: InputMaybe<AssetSubclassName>;
  readonly chimneyAddressCity?: InputMaybe<Scalars['String']['input']>;
  readonly chimneyAddressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly chimneyAddressState?: InputMaybe<Scalars['String']['input']>;
  readonly chimneyAddressZip?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyEquityCompanyName?: InputMaybe<Scalars['String']['input']>;
  readonly companyEquityCompanyTicker?: InputMaybe<Scalars['String']['input']>;
  readonly companyEquityCurrentPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly companyEquityExercisePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly companyEquityGrantType?: InputMaybe<Scalars['String']['input']>;
  readonly companyEquitySharesIssued?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly companyEquityVestingCliff?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly companyEquityVestingDuration?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly companyEquityVestingRate?: InputMaybe<Scalars['String']['input']>;
  readonly companyEquityVestingStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly costBasis?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly currencyCode: Scalars['String']['input'];
  readonly currentValue: Scalars['BigDecimal']['input'];
  readonly description: Scalars['String']['input'];
  readonly hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateAsset. */
export type CreateAssetPayload = {
  readonly __typename?: 'CreateAssetPayload';
  readonly asset: Asset;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateBulkImport */
export type CreateBulkImportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Base64 file content (file-based importers only) */
  readonly fileContent?: InputMaybe<Scalars['String']['input']>;
  /** File name (file-based importers only) */
  readonly fileName?: InputMaybe<Scalars['String']['input']>;
  /** The type of import to perform */
  readonly importType: Scalars['String']['input'];
  /** The ID of the object being imported to */
  readonly importableId: Scalars['ID']['input'];
  /** The type of object being imported */
  readonly importableType: Scalars['String']['input'];
  /** Importer-specific options */
  readonly options?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of CreateBulkImport. */
export type CreateBulkImportPayload = {
  readonly __typename?: 'CreateBulkImportPayload';
  /** The created bulk import */
  readonly bulkImport?: Maybe<BulkImport>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
};

export const CreateCenterOfInfluenceRepError = {
  EmailAlreadyExists: 'email_already_exists'
} as const;

export type CreateCenterOfInfluenceRepError = typeof CreateCenterOfInfluenceRepError[keyof typeof CreateCenterOfInfluenceRepError];
/** Autogenerated input type of CreateCenterOfInfluenceRep */
export type CreateCenterOfInfluenceRepInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company this rep works for */
  readonly companyId?: InputMaybe<Scalars['ID']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  /** Free-text fee or rate this contact charges, e.g. "$250/hr" or "1% AUM". */
  readonly feeRate?: InputMaybe<Scalars['String']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly ownerAdvisorProfileId: Scalars['Int']['input'];
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly photoUrl?: InputMaybe<Scalars['String']['input']>;
  readonly preferredContactMethod?: InputMaybe<CenterOfInfluenceRepPreferredContactMethod>;
  readonly secondaryEmail?: InputMaybe<Scalars['String']['input']>;
  readonly secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly specialties?: InputMaybe<ReadonlyArray<CenterOfInfluenceRepSpecialty>>;
  /** Two-letter US state code. */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** The contact's own website, independent of its company's. */
  readonly website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCenterOfInfluenceRep. */
export type CreateCenterOfInfluenceRepPayload = {
  readonly __typename?: 'CreateCenterOfInfluenceRepPayload';
  readonly centerOfInfluenceRep?: Maybe<CenterOfInfluenceRep>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly softError?: Maybe<CreateCenterOfInfluenceRepError>;
};

/** Autogenerated input type of CreateClientBillingTask */
export type CreateClientBillingTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the client billing request */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
  /** The input for client billing task specific data */
  readonly typeSpecificInput?: InputMaybe<ClientBillingRequestTaskInput>;
};

/** Autogenerated return type of CreateClientBillingTask. */
export type CreateClientBillingTaskPayload = {
  readonly __typename?: 'CreateClientBillingTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateClientInfoChangeTask */
export type CreateClientInfoChangeTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the client info change request */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  readonly taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  /** The input for client info change request task specific data */
  readonly typeSpecificInput?: InputMaybe<ClientInfoChangeRequestInput>;
};

/** Autogenerated return type of CreateClientInfoChangeTask. */
export type CreateClientInfoChangeTaskPayload = {
  readonly __typename?: 'CreateClientInfoChangeTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateClientOpportunity */
export type CreateClientOpportunityInput = {
  readonly arr?: InputMaybe<Scalars['Int']['input']>;
  readonly aum: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly clientProfileId: Scalars['ID']['input'];
  readonly description: Scalars['String']['input'];
  readonly expectedCloseDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Next steps for opportunity */
  readonly nextSteps?: InputMaybe<Scalars['String']['input']>;
  /** Due date for next steps */
  readonly nextStepsDueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly probabilityOfClosing?: InputMaybe<ProbabilityOfClosing>;
  /** The Salesforce Account ID identifying the household this opportunity belongs to */
  readonly salesforceAccountId: Scalars['String']['input'];
  /** Initial opportunity status */
  readonly status: OpportunityStatus;
};

/** Autogenerated return type of CreateClientOpportunity. */
export type CreateClientOpportunityPayload = {
  readonly __typename?: 'CreateClientOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly opportunity?: Maybe<Opportunity>;
};

/** Autogenerated input type of CreateClientPortalMessage */
export type CreateClientPortalMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly message: Scalars['String']['input'];
  readonly salesforceAccountId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateClientPortalMessage. */
export type CreateClientPortalMessagePayload = {
  readonly __typename?: 'CreateClientPortalMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientPortalMessage?: Maybe<ClientPortalMessage>;
};

/** Autogenerated input type of CreateCoClientFromIntakeData */
export type CreateCoClientFromIntakeDataInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The co-client data from intake */
  readonly coClientData: CoClientFromIntakeDataInput;
  /** The ID of the household */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCoClientFromIntakeData. */
export type CreateCoClientFromIntakeDataPayload = {
  readonly __typename?: 'CreateCoClientFromIntakeDataPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created co-client profile */
  readonly coClient?: Maybe<Client>;
  /** Any errors that occurred */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateCoClientUser */
export type CreateCoClientUserInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly coManagerEmail: Scalars['String']['input'];
  readonly primaryUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCoClientUser. */
export type CreateCoClientUserPayload = {
  readonly __typename?: 'CreateCoClientUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user: User;
};

/** Autogenerated input type of CreateCoiCallLog */
export type CreateCoiCallLogInput = {
  /** Center of influence rep identifier */
  readonly centerOfInfluenceRepId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Notes or content from the call */
  readonly content: Scalars['String']['input'];
  /** The date and time when the call occurred */
  readonly date: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CreateCoiCallLog. */
export type CreateCoiCallLogPayload = {
  readonly __typename?: 'CreateCoiCallLogPayload';
  /** The created call log */
  readonly callLog: CallLog;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCoiMeeting */
export type CreateCoiMeetingInput = {
  /** Center of influence rep identifier */
  readonly centerOfInfluenceRepId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Duration of the meeting in minutes (optional) */
  readonly durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Meeting notes or summary (optional) */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** The date and time when the meeting took place (ISO8601) */
  readonly occurredAt: Scalars['ISO8601DateTime']['input'];
  /** Title or subject of the meeting */
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCoiMeeting. */
export type CreateCoiMeetingPayload = {
  readonly __typename?: 'CreateCoiMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created Meeting */
  readonly meeting: Meeting;
};

/** Autogenerated input type of CreateComment */
export type CreateCommentInput = {
  /**
   * Files to attach, already uploaded to Box by the client. Attaching to a comment
   * that already exists goes through addCommentAttachments.
   */
  readonly attachments?: InputMaybe<ReadonlyArray<CommentAttachmentInput>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Plain text, may contain @Full Name mentions */
  readonly content: Scalars['String']['input'];
  /** Users to notify, validated against the subject's own mention candidates. @Full Name text in `content` is never parsed. */
  readonly mentionedUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Reply to this comment. Rejected when that comment is itself a reply — threading is capped at one level. */
  readonly parentCommentId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the subject being commented on */
  readonly relationId: Scalars['ID']['input'];
  /** Subject type, e.g. "Household" */
  readonly relationType: Scalars['String']['input'];
  /** Optional one-line thread header. Only valid on a thread root — rejected alongside parentCommentId. */
  readonly subject?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateComment. */
export type CreateCommentPayload = {
  readonly __typename?: 'CreateCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The comment that was created */
  readonly comment: Comment;
};

/** Autogenerated input type of CreateCompanyCallLog */
export type CreateCompanyCallLogInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company identifier */
  readonly companyId: Scalars['ID']['input'];
  /** Notes or content from the call */
  readonly content: Scalars['String']['input'];
  /** The date and time when the call occurred */
  readonly date: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CreateCompanyCallLog. */
export type CreateCompanyCallLogPayload = {
  readonly __typename?: 'CreateCompanyCallLogPayload';
  /** The created call log */
  readonly callLog: CallLog;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Errors for creating a company */
export const CreateCompanyError = {
  /** name_already_exists */
  NameAlreadyExists: 'name_already_exists',
  /** validation_error */
  ValidationError: 'validation_error'
} as const;

export type CreateCompanyError = typeof CreateCompanyError[keyof typeof CreateCompanyError];
/** Autogenerated input type of CreateCompany */
export type CreateCompanyInput = {
  /** The first line of the company address */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the company address */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city of the company address */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The country code of the company address */
  readonly countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The description of the company */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the company's logo */
  readonly logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** The name of the company */
  readonly name: Scalars['String']['input'];
  /** The organization that will own this company */
  readonly organizationId: Scalars['ID']['input'];
  /** The phone number of the company */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the company address */
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The state of the company address */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** The website of the company */
  readonly website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateCompanyMeeting */
export type CreateCompanyMeetingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company identifier */
  readonly companyId: Scalars['ID']['input'];
  /** Duration of the meeting in minutes (optional) */
  readonly durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Meeting notes or summary (optional) */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** The date and time when the meeting took place (ISO8601) */
  readonly occurredAt: Scalars['ISO8601DateTime']['input'];
  /** Title or subject of the meeting */
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCompanyMeeting. */
export type CreateCompanyMeetingPayload = {
  readonly __typename?: 'CreateCompanyMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created Meeting */
  readonly meeting: Meeting;
};

/** Autogenerated return type of CreateCompany. */
export type CreateCompanyPayload = {
  readonly __typename?: 'CreateCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created company */
  readonly company?: Maybe<Company>;
  /** Error encountered during creation */
  readonly softError?: Maybe<CreateCompanyError>;
};

/** Autogenerated input type of CreateConquestPlanFromData */
export type CreateConquestPlanFromDataInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Frontend-built Conquest IntegrationPlanData payload (camelCase) */
  readonly data: Scalars['JSON']['input'];
  /** Household ID to create the financial plan for */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateConquestPlanFromData. */
export type CreateConquestPlanFromDataPayload = {
  readonly __typename?: 'CreateConquestPlanFromDataPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Conquest advisor URL for the created plan */
  readonly conquestPlanUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateContactCallLog */
export type CreateContactCallLogInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household contact identifier */
  readonly contactId: Scalars['ID']['input'];
  /** Notes or content from the call */
  readonly content: Scalars['String']['input'];
  /** The date and time when the call occurred */
  readonly date: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CreateContactCallLog. */
export type CreateContactCallLogPayload = {
  readonly __typename?: 'CreateContactCallLogPayload';
  /** The created call log */
  readonly callLog: CallLog;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateContact */
export type CreateContactInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** Relation of the contact */
  readonly relation?: InputMaybe<BeneficiaryRelationship>;
};

/** Autogenerated input type of CreateContactMeeting */
export type CreateContactMeetingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household contact identifier */
  readonly contactId: Scalars['ID']['input'];
  /** Duration of the meeting in minutes (optional) */
  readonly durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Meeting notes or summary (optional) */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** The date and time when the meeting took place (ISO8601) */
  readonly occurredAt: Scalars['ISO8601DateTime']['input'];
  /** Title or subject of the meeting */
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateContactMeeting. */
export type CreateContactMeetingPayload = {
  readonly __typename?: 'CreateContactMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created Meeting */
  readonly meeting: Meeting;
};

/** Autogenerated return type of CreateContact. */
export type CreateContactPayload = {
  readonly __typename?: 'CreateContactPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contact?: Maybe<Contact>;
};

/** Autogenerated input type of CreateContributionAlertsFromUpload */
export type CreateContributionAlertsFromUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Parsed rows from the uploaded contribution sheet */
  readonly rows: ReadonlyArray<ContributionUploadRowInput>;
};

/** Autogenerated return type of CreateContributionAlertsFromUpload. */
export type CreateContributionAlertsFromUploadPayload = {
  readonly __typename?: 'CreateContributionAlertsFromUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Per-row resolution/classification outcome, in the same order as the input rows */
  readonly results: ReadonlyArray<ContributionUploadRowResult>;
};

/** Autogenerated input type of CreateCorporateRetirementPlanTask */
export type CreateCorporateRetirementPlanTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the corporate retirement plan request */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
  /** The input for corporate retirement plan task specific data */
  readonly typeSpecificInput?: InputMaybe<CorporateRetirementPlanRequestTaskInput>;
};

/** Autogenerated return type of CreateCorporateRetirementPlanTask. */
export type CreateCorporateRetirementPlanTaskPayload = {
  readonly __typename?: 'CreateCorporateRetirementPlanTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateDataExport */
export type CreateDataExportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Column IDs to include in the export */
  readonly columnIds: ReadonlyArray<Scalars['String']['input']>;
  /** Column filters */
  readonly filters?: InputMaybe<ReadonlyArray<ExportFilterInput>>;
  /** Export format: csv, json, xlsx */
  readonly format: Scalars['String']['input'];
  /** Global search query */
  readonly globalFilter?: InputMaybe<Scalars['String']['input']>;
  /** The resource to export (e.g., "households") */
  readonly resourceType: Scalars['String']['input'];
  /** Sort specifications */
  readonly sorting?: InputMaybe<ReadonlyArray<ExportSortInput>>;
};

/** Autogenerated return type of CreateDataExport. */
export type CreateDataExportPayload = {
  readonly __typename?: 'CreateDataExportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created export record */
  readonly dataExport?: Maybe<DataExport>;
  /** Errors that occurred during the export */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateDocumentSignatureForTask */
export type CreateDocumentSignatureForTaskInput = {
  /** A list of attestations that the user has agreed to prior to signing the document, usually by checking boxes. */
  readonly attestations?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly taskId: Scalars['ID']['input'];
  /** The user input value we want to attach as the signature, usually the client's name. */
  readonly value: Scalars['String']['input'];
};

/** Autogenerated return type of CreateDocumentSignatureForTask. */
export type CreateDocumentSignatureForTaskPayload = {
  readonly __typename?: 'CreateDocumentSignatureForTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly signatureId: Scalars['ID']['output'];
  readonly signedDocumentLink?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateDocusignLpoaEnvelopeBulkUpload */
export type CreateDocusignLpoaEnvelopeBulkUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Array of documents to process */
  readonly documents: ReadonlyArray<BulkUploadDocumentInput>;
  /** Name of the household */
  readonly householdName: Scalars['String']['input'];
};

/** Autogenerated return type of CreateDocusignLpoaEnvelopeBulkUpload. */
export type CreateDocusignLpoaEnvelopeBulkUploadPayload = {
  readonly __typename?: 'CreateDocusignLpoaEnvelopeBulkUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors if unsuccessful */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Non-critical error message */
  readonly softError?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateEciAccountOnboardingRequest */
export type CreateEciAccountOnboardingRequestInput = {
  /** User ID of the household client who owns the account */
  readonly accountHolderId: Scalars['ID']['input'];
  /** Open only or open and transfer */
  readonly accountIntent: EciAccountIntent;
  /** Account type to open */
  readonly accountType: EciAccountType;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Existing unsubmitted new-account draft to edit instead of creating another task */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Household UUID or legacy public identifier */
  readonly householdPublicId: Scalars['ID']['input'];
  /** Registration to open */
  readonly registrationType: EciRegistrationType;
  /** Required for open-and-transfer. Omitted amount defaults to zero for a new draft. */
  readonly transferFundingSource?: InputMaybe<EciTransferFundingSourceInput>;
};

/** Autogenerated return type of CreateEciAccountOnboardingRequest. */
export type CreateEciAccountOnboardingRequestPayload = {
  readonly __typename?: 'CreateEciAccountOnboardingRequestPayload';
  /** Created ECI account request ID */
  readonly accountOnboardingRequestId: Scalars['ID']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Created draft account-onboarding task ID */
  readonly taskId: Scalars['ID']['output'];
};

/** Autogenerated input type of CreateEciCustodianFormsSigningLink */
export type CreateEciCustodianFormsSigningLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** One of the envelopes in custodianFormsToSign */
  readonly envelopeId: Scalars['String']['input'];
  /** Where DocuSign sends the client back; must be on this app */
  readonly returnUrl: Scalars['String']['input'];
};

/** Autogenerated return type of CreateEciCustodianFormsSigningLink. */
export type CreateEciCustodianFormsSigningLinkPayload = {
  readonly __typename?: 'CreateEciCustodianFormsSigningLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The DocuSign signing URL to send the browser to */
  readonly url: Scalars['String']['output'];
};

/** Autogenerated input type of CreateEnrollment */
export type CreateEnrollmentInput = {
  /**
   * Admin-only: resolve the enrollment for this advisor instead of the caller, so
   * an admin can upload a book on the advisor's behalf. Omit for advisor self-serve.
   */
  readonly advisorId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateEnrollment. */
export type CreateEnrollmentPayload = {
  readonly __typename?: 'CreateEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The active or newly created enrollment. */
  readonly enrollment: AdvisorOnboardingEnrollment;
};

/** Autogenerated input type of CreateFeeScheduleForAdvisor */
export type CreateFeeScheduleForAdvisorInput = {
  /** The advisor profile ID; must match the household owner in organization mode */
  readonly advisorProfileId: Scalars['ID']['input'];
  /** The type of amount for the fee schedule */
  readonly amountType?: InputMaybe<FeeScheduleAmountTypes>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the fee schedule */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The type of fee schedule */
  readonly feeType: FeeScheduleFeeTypes;
  /** The flat fee amount for the fee schedule */
  readonly flatFeeAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The household UUID */
  readonly householdId?: InputMaybe<Scalars['String']['input']>;
  /** The minimum fee for the fee schedule */
  readonly minimumFee?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The name of the fee schedule */
  readonly name: Scalars['String']['input'];
  /** The tiers for the fee schedule */
  readonly tiers?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of CreateFeeScheduleForAdvisor. */
export type CreateFeeScheduleForAdvisorPayload = {
  readonly __typename?: 'CreateFeeScheduleForAdvisorPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if not successful */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** The fee schedule */
  readonly feeSchedule?: Maybe<FeeSchedule>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateFileUploadTask */
export type CreateFileUploadTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving as draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating it with active status */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  readonly taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateFileUploadTask. */
export type CreateFileUploadTaskPayload = {
  readonly __typename?: 'CreateFileUploadTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateFinancialOffering */
export type CreateFinancialOfferingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional card description (<= 150 chars); placeholder used if omitted */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Offering name */
  readonly name: Scalars['String']['input'];
  /** Offering type; determines which section the card appears in */
  readonly type: FinancialOfferingTypeName;
};

/** Autogenerated return type of CreateFinancialOffering. */
export type CreateFinancialOfferingPayload = {
  readonly __typename?: 'CreateFinancialOfferingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created offering */
  readonly financialOffering?: Maybe<FinancialOffering>;
};

/** Autogenerated input type of CreateFinancialPlan */
export type CreateFinancialPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household ID to create the financial plan for */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFinancialPlan. */
export type CreateFinancialPlanPayload = {
  readonly __typename?: 'CreateFinancialPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created financial plan */
  readonly financialPlan?: Maybe<FinancialPlan>;
};

/** Autogenerated input type of CreateGoal */
export type CreateGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly name: Scalars['String']['input'];
  readonly percentFunded?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly salesforceAccountId: Scalars['String']['input'];
  readonly startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly status: GoalStatusName;
  readonly targetUsd?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly type: GoalTypeName;
};

/** Autogenerated return type of CreateGoal. */
export type CreateGoalPayload = {
  readonly __typename?: 'CreateGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly goal: Goal;
};

/** Autogenerated input type of CreateHouseholdReferral */
export type CreateHouseholdReferralInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The household that was referred */
  readonly referredHouseholdId: Scalars['ID']['input'];
  /** The month the referral happened */
  readonly referredOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The household that made the referral */
  readonly referrerHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateHouseholdReferral. */
export type CreateHouseholdReferralPayload = {
  readonly __typename?: 'CreateHouseholdReferralPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The recorded referral */
  readonly referral?: Maybe<HouseholdReferral>;
};

/** Autogenerated input type of CreateLiability */
export type CreateLiabilityInput = {
  readonly acquiredAt: Scalars['ISO8601Date']['input'];
  readonly annualInterestPercent?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly assetId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly currencyCode: Scalars['String']['input'];
  readonly currentBalance: Scalars['BigDecimal']['input'];
  readonly hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly originalBalance: Scalars['BigDecimal']['input'];
  readonly providerName?: InputMaybe<Scalars['String']['input']>;
  readonly timeToMaturity?: InputMaybe<Scalars['Int']['input']>;
  readonly type: LiabilityTypeName;
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateLiability. */
export type CreateLiabilityPayload = {
  readonly __typename?: 'CreateLiabilityPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly liability: Liability;
};

/** Autogenerated input type of CreateManualOnboardingTask */
export type CreateManualOnboardingTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
};

/** Autogenerated return type of CreateManualOnboardingTask. */
export type CreateManualOnboardingTaskPayload = {
  readonly __typename?: 'CreateManualOnboardingTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ID of the Salesforce task for the primary client */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created onboarding tasks */
  readonly tasks?: Maybe<ReadonlyArray<Task>>;
};

/** Autogenerated input type of CreateMeetingAgendaTemplate */
export type CreateMeetingAgendaTemplateInput = {
  /** The agenda outline */
  readonly body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When to use this template */
  readonly description: Scalars['String']['input'];
  /** Defaults to meeting_agenda */
  readonly templateType?: InputMaybe<MeetingAgendaTemplateType>;
  /** The template title */
  readonly title: Scalars['String']['input'];
  /** private (creator only) or firm-wide */
  readonly visibility: MeetingAgendaTemplateVisibility;
};

/** Autogenerated return type of CreateMeetingAgendaTemplate. */
export type CreateMeetingAgendaTemplatePayload = {
  readonly __typename?: 'CreateMeetingAgendaTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created template */
  readonly meetingAgendaTemplate?: Maybe<MeetingAgendaTemplate>;
};

/** Autogenerated input type of CreateMeeting */
export type CreateMeetingInput = {
  /**
   * IDs of advisor profiles who attended the meeting; must be the household's
   * primary advisor or an advisor with edit access to the household
   */
  readonly advisorAttendeeIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** IDs of client profiles who attended the meeting; at least one is required */
  readonly attendeeIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Duration of the meeting in minutes (optional) */
  readonly durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** The Savvy household ID to associate the meeting with */
  readonly householdId: Scalars['ID']['input'];
  /** Meeting notes or summary (optional) */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** The date and time when the meeting took place (ISO8601) */
  readonly occurredAt: Scalars['ISO8601DateTime']['input'];
  /** Title or subject of the meeting */
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateMeeting. */
export type CreateMeetingPayload = {
  readonly __typename?: 'CreateMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if the operation failed */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** The created Meeting */
  readonly meeting?: Maybe<Meeting>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateMoneyMovementRequestTask */
export type CreateMoneyMovementRequestTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating the money movement request */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
  /** The input for money movement request task specific data */
  readonly typeSpecificInput: MoneyMovementRequestTaskInput;
};

/** Autogenerated return type of CreateMoneyMovementRequestTask. */
export type CreateMoneyMovementRequestTaskPayload = {
  readonly __typename?: 'CreateMoneyMovementRequestTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateNfsAuditExport */
export type CreateNfsAuditExportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** "request" or "response" */
  readonly direction?: InputMaybe<NfsAuditDirection>;
  /** "eap" or "esg" */
  readonly gateway?: InputMaybe<NfsAuditGateway>;
  /** Fidelity operation name (e.g. AccountSetup) */
  readonly operation?: InputMaybe<NfsAuditOperation>;
  /** Inclusive lower bound on recorded_at */
  readonly recordedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Inclusive upper bound on recorded_at */
  readonly recordedBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Full-text match over body content and tracking ID */
  readonly text?: InputMaybe<Scalars['String']['input']>;
  /** Filter by exact Fidelity tracking ID */
  readonly trackingId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateNfsAuditExport. */
export type CreateNfsAuditExportPayload = {
  readonly __typename?: 'CreateNfsAuditExportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created export record; poll status, then download */
  readonly dataExport?: Maybe<DataExport>;
  /** Errors that occurred creating the export */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateNoteForContact */
export type CreateNoteForContactInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy ID of the household Contact to attach the Note to. */
  readonly contactId: Scalars['ID']['input'];
  /** The Note body content (HTML produced by the editor). */
  readonly content: Scalars['String']['input'];
  /** Optional title. Defaults to the contact's name, or "Contact note" when the contact has none. */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of topic tags to apply via acts_as_taggable_on. */
  readonly topics?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** Autogenerated return type of CreateNoteForContact. */
export type CreateNoteForContactPayload = {
  readonly __typename?: 'CreateNoteForContactPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created Contact-attached Note. */
  readonly note: Note;
};

/** Autogenerated input type of CreateNoteForDialpadCall */
export type CreateNoteForDialpadCallInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Note body content (HTML produced by the editor). */
  readonly content: Scalars['String']['input'];
  /** The Savvy ID of the DialpadCall to attach the Note to. */
  readonly dialpadCallId: Scalars['ID']['input'];
  /** Optional title. Defaults to "Call with <contact name>" (falling back to the number) when omitted. */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of topic tags to apply via acts_as_taggable_on. */
  readonly topics?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** Autogenerated return type of CreateNoteForDialpadCall. */
export type CreateNoteForDialpadCallPayload = {
  readonly __typename?: 'CreateNoteForDialpadCallPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created DialpadCall-attached Note. */
  readonly note: Note;
};

/** Autogenerated input type of CreateNoteForEvent */
export type CreateNoteForEventInput = {
  /** The Savvy ID of the CalendarEvent to attach the Note to. */
  readonly calendarEventId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Note body content (HTML produced by the editor). */
  readonly content: Scalars['String']['input'];
  /** Optional title. Defaults to the CalendarEvent summary, or "Meeting note" when both are blank. */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of topic tags to apply via acts_as_taggable_on. */
  readonly topics?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** Autogenerated return type of CreateNoteForEvent. */
export type CreateNoteForEventPayload = {
  readonly __typename?: 'CreateNoteForEventPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created CalendarEvent-attached Note. */
  readonly note: Note;
};

/** Autogenerated input type of CreateNote */
export type CreateNoteInput = {
  /** Center of influence rep identifier. Mutually exclusive with householdIds/salesforceAccountId(s)/companyId. */
  readonly centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Company identifier. Mutually exclusive with householdIds/salesforceAccountId(s)/centerOfInfluenceRepId. */
  readonly companyId?: InputMaybe<Scalars['ID']['input']>;
  readonly content: Scalars['String']['input'];
  /**
   * Household identifiers (UUID, salesforce_account_id, or numeric primary key).
   * Mutually exclusive with
   * centerOfInfluenceRepId/companyId/salesforceAccountId(s).
   */
  readonly householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** @deprecated Use householdIds instead */
  readonly salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use householdIds instead */
  readonly salesforceAccountIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly title: Scalars['String']['input'];
  readonly topics?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** Autogenerated return type of CreateNote. */
export type CreateNotePayload = {
  readonly __typename?: 'CreateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** Autogenerated input type of CreateOnboardingTask */
export type CreateOnboardingTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Fee schedule ID */
  readonly feeScheduleId: Scalars['ID']['input'];
  /** Whether to add calendly scheduling */
  readonly hasCalendlyScheduling: Scalars['Boolean']['input'];
  /** Household ID to which the task will be associated */
  readonly householdId: Scalars['String']['input'];
  /** Household ID to which the task will be associated */
  readonly householdSavvyId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to send reminders */
  readonly sendReminders: Scalars['Boolean']['input'];
  /** Description of the task */
  readonly taskDescription?: InputMaybe<Scalars['String']['input']>;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  readonly taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateOnboardingTask. */
export type CreateOnboardingTaskPayload = {
  readonly __typename?: 'CreateOnboardingTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if not successful */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** Salesforce task ID */
  readonly salesforceTaskId?: Maybe<Scalars['ID']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateOpenNewAccountTask */
export type CreateOpenNewAccountTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating the open new account request */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
  /** The input for open new account request task specific data; required when not saving as draft */
  readonly typeSpecificInput?: InputMaybe<OpenNewAccountRequestInput>;
};

/** Autogenerated return type of CreateOpenNewAccountTask. */
export type CreateOpenNewAccountTaskPayload = {
  readonly __typename?: 'CreateOpenNewAccountTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateOrUpdateCallLog */
export type CreateOrUpdateCallLogInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Notes or content from the call */
  readonly content: Scalars['String']['input'];
  /** The date and time when the call occurred */
  readonly date: Scalars['ISO8601DateTime']['input'];
  /** The Salesforce Account ID to identify the household */
  readonly salesforceAccountId: Scalars['String']['input'];
  /** The Salesforce task ID associated with this call log */
  readonly salesforceTaskId?: InputMaybe<Scalars['String']['input']>;
  /** The Salesforce Contact ID */
  readonly whoId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateOrUpdateCallLog. */
export type CreateOrUpdateCallLogPayload = {
  readonly __typename?: 'CreateOrUpdateCallLogPayload';
  /** The created or updated CallLog */
  readonly callLog?: Maybe<CallLog>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if the operation failed */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateOrUpdateServiceCalendarSettings */
export type CreateOrUpdateServiceCalendarSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly householdSalesforceId: Scalars['String']['input'];
  readonly updatedServiceCalendarSettingInputs: ReadonlyArray<UpdateServiceCalendarWithAdvisorSettingsInput>;
};

/** Autogenerated return type of CreateOrUpdateServiceCalendarSettings. */
export type CreateOrUpdateServiceCalendarSettingsPayload = {
  readonly __typename?: 'CreateOrUpdateServiceCalendarSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly serviceCalendarSettings: ReadonlyArray<ServiceCalendarSetting>;
};

export type CreateOrganizationBrandingInput = {
  /** Custom intro for onboarding emails */
  readonly customOnboardingEmailIntro?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the organization */
  readonly displayName?: InputMaybe<Scalars['String']['input']>;
  /** Contact email for the organization */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Base64 encoded logo image for Cloudinary upload */
  readonly logoBase64?: InputMaybe<Scalars['String']['input']>;
  /** Contact phone number for the organization */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Short display name for the organization */
  readonly shortDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show Calendly link in emails */
  readonly showCalendlyLinkInEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of CreateOrganizationBrandingRow */
export type CreateOrganizationBrandingRowInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization to create branding for */
  readonly organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateOrganizationBrandingRow. */
export type CreateOrganizationBrandingRowPayload = {
  readonly __typename?: 'CreateOrganizationBrandingRowPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** The organization branding row */
  readonly organizationBranding?: Maybe<OrganizationBranding>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateOrganizationHouseholdCategory */
export type CreateOrganizationHouseholdCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly emoji?: InputMaybe<Scalars['String']['input']>;
  readonly hexColorCode?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOrganizationHouseholdCategory. */
export type CreateOrganizationHouseholdCategoryPayload = {
  readonly __typename?: 'CreateOrganizationHouseholdCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly organizationHouseholdCategory?: Maybe<OrganizationHouseholdCategory>;
};

/** Autogenerated input type of CreateOrganizationHouseholdTag */
export type CreateOrganizationHouseholdTagInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /**
   * For manual tags only: households to apply this tag to immediately. Ignored for
   * smart tags (which are evaluated by the rule).
   */
  readonly householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly isSmart?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly organizationHouseholdCategoryId: Scalars['ID']['input'];
  readonly ruleJson?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of CreateOrganizationHouseholdTag. */
export type CreateOrganizationHouseholdTagPayload = {
  readonly __typename?: 'CreateOrganizationHouseholdTagPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly organizationHouseholdTag?: Maybe<OrganizationHouseholdTag>;
};

/** Autogenerated input type of CreateOrganization */
export type CreateOrganizationInput = {
  /** IDs of advisors to add to the organization */
  readonly advisorUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the organization */
  readonly name: Scalars['String']['input'];
  /** Branding configuration for the organization */
  readonly organizationBranding?: InputMaybe<CreateOrganizationBrandingInput>;
};

/** Autogenerated return type of CreateOrganization. */
export type CreateOrganizationPayload = {
  readonly __typename?: 'CreateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly organization?: Maybe<Organization>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateOtherInvestmentTask */
export type CreateOtherInvestmentTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the other-investment request */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The base task input */
  readonly taskInput: CreateTaskInput;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  readonly taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  /** Other-investment specific data (task_type, account_ids) */
  readonly typeSpecificInput?: InputMaybe<OtherInvestmentTaskInput>;
};

/** Autogenerated return type of CreateOtherInvestmentTask. */
export type CreateOtherInvestmentTaskPayload = {
  readonly __typename?: 'CreateOtherInvestmentTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The ID of the created task */
  readonly taskId?: Maybe<Scalars['String']['output']>;
  /** Immutable public handle of the created task. What the link arguments take. */
  readonly taskUuid?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreatePlaidLinkToken */
export type CreatePlaidLinkTokenInput = {
  readonly accountFilters?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly products?: InputMaybe<ReadonlyArray<PlaidProduct>>;
  readonly providerAccountId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreatePlaidLinkToken. */
export type CreatePlaidLinkTokenPayload = {
  readonly __typename?: 'CreatePlaidLinkTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly linkToken: Scalars['String']['output'];
};

/** Autogenerated input type of CreatePlanFinancialSnapshot */
export type CreatePlanFinancialSnapshotInput = {
  /** Snapshot as-of date */
  readonly asOfDate: Scalars['ISO8601Date']['input'];
  /** Plan assets stored as integer cents */
  readonly assetsCents?: InputMaybe<Scalars['BigInt']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Number of participants */
  readonly participantCount?: InputMaybe<Scalars['Int']['input']>;
  /** Quarter period (e.g. 2026-Q1) */
  readonly period: Scalars['String']['input'];
  /** The plan to record a snapshot for */
  readonly retirementPlanId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePlanFinancialSnapshot. */
export type CreatePlanFinancialSnapshotPayload = {
  readonly __typename?: 'CreatePlanFinancialSnapshotPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created snapshot */
  readonly planFinancialSnapshot?: Maybe<PlanFinancialSnapshot>;
};

/** Autogenerated input type of CreatePlan */
export type CreatePlanInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The household to create a plan for. */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePlan. */
export type CreatePlanPayload = {
  readonly __typename?: 'CreatePlanPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The stored plan with Savvy metadata. */
  readonly plan: PlanningPlan;
};

/** Autogenerated input type of CreateProfessionalService */
export type CreateProfessionalServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The professional contact's public id */
  readonly contactId: Scalars['ID']['input'];
  /** The household served. Exactly one of householdId and retirementPlanId. */
  readonly householdId?: InputMaybe<Scalars['ID']['input']>;
  /** Category of contact, for a retirement plan */
  readonly retirementPlanContactGroup?: InputMaybe<ProfessionalRelationshipContactGroup>;
  /** Whether the contact is active, for a retirement plan */
  readonly retirementPlanContactStatus?: InputMaybe<ProfessionalRelationshipContactStatus>;
  /** The retirement plan served */
  readonly retirementPlanId?: InputMaybe<Scalars['ID']['input']>;
  /** The professional's role, e.g. CPA */
  readonly role?: InputMaybe<Scalars['String']['input']>;
  /** The month the professional started serving it */
  readonly startedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of CreateProfessionalService. */
export type CreateProfessionalServicePayload = {
  readonly __typename?: 'CreateProfessionalServicePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The recorded service */
  readonly professionalService?: Maybe<ProfessionalService>;
};

export const CreateProspectOpportunityError = {
  BoxSetupError: 'box_setup_error',
  CoClientEmailAlreadyExists: 'co_client_email_already_exists',
  EmailAlreadyExists: 'email_already_exists',
  EstimatedAumRequired: 'estimated_aum_required',
  HouseholdNameAlreadyExistsForExistingClient: 'household_name_already_exists_for_existing_client',
  HouseholdStageError: 'household_stage_error',
  ProspectAlreadyExistsWithoutAdvisor: 'prospect_already_exists_without_advisor',
  SalesforceSetupError: 'salesforce_setup_error',
  UserNotCreated: 'user_not_created'
} as const;

export type CreateProspectOpportunityError = typeof CreateProspectOpportunityError[keyof typeof CreateProspectOpportunityError];
/** Autogenerated input type of CreateProspectOpportunity */
export type CreateProspectOpportunityInput = {
  /** The ID of the AdvisorGroup that should own this prospect or null if none */
  readonly advisorGroupAccess?: InputMaybe<Scalars['ID']['input']>;
  /** The lead source category. Must be one of Query.leadSources */
  readonly advisorLeadSource: Scalars['String']['input'];
  /** The dependent lead source detail. Must be one of the details the chosen category offers; dropped when it is not. */
  readonly advisorLeadSourceDetail?: InputMaybe<Scalars['String']['input']>;
  readonly advisorSalesforceId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly coClientEmail?: InputMaybe<Scalars['String']['input']>;
  readonly coClientFirstName?: InputMaybe<Scalars['String']['input']>;
  readonly coClientLastName?: InputMaybe<Scalars['String']['input']>;
  readonly coClientPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly createViaAsyncWorker?: InputMaybe<Scalars['Boolean']['input']>;
  readonly email: Scalars['String']['input'];
  /** Advisor estimated ARR */
  readonly estimatedArr?: InputMaybe<Scalars['Int']['input']>;
  /** Advisor estimated AUM */
  readonly estimatedAum: Scalars['Int']['input'];
  /** advisor estimated time of closing opportunity */
  readonly expectedCloseDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Primary client first name */
  readonly firstName: Scalars['String']['input'];
  readonly householdName?: InputMaybe<Scalars['String']['input']>;
  /** Prospect opportunities will map to household stage not opportunity stage */
  readonly householdStage: Scalars['String']['input'];
  /** Primary client last name */
  readonly lastName: Scalars['String']['input'];
  /** Next steps an advisor will take for this opportunity */
  readonly nextSteps?: InputMaybe<Scalars['String']['input']>;
  /** advisor selected next steps due date */
  readonly nextStepsDueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly probabilityOfClosing?: InputMaybe<ProbabilityOfClosing>;
  /** The ID of the User that referred this prospect */
  readonly referralSourceId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of the referral source (User or CenterOfInfluenceRep); required when referral_source_id is set */
  readonly referralSourceType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateProspectOpportunity. */
export type CreateProspectOpportunityPayload = {
  readonly __typename?: 'CreateProspectOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created household; null when soft_error is set. Select `{ id name … }` for the fields you need. */
  readonly household?: Maybe<Household>;
  /** The ID of the created opportunity */
  readonly opportunityId?: Maybe<Scalars['ID']['output']>;
  /** The error that occurred if the opportunity was not created */
  readonly softError?: Maybe<CreateProspectOpportunityError>;
};

/** Autogenerated input type of CreateProviderAccount */
export type CreateProviderAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly coinbaseCode?: InputMaybe<Scalars['String']['input']>;
  readonly coinbaseProApiKey?: InputMaybe<Scalars['String']['input']>;
  readonly coinbaseProPassphrase?: InputMaybe<Scalars['String']['input']>;
  readonly coinbaseProSecret?: InputMaybe<Scalars['String']['input']>;
  readonly plaidPublicToken?: InputMaybe<Scalars['String']['input']>;
  readonly source: ProviderAccountSource;
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateProviderAccount. */
export type CreateProviderAccountPayload = {
  readonly __typename?: 'CreateProviderAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly providerAccount: ProviderAccount;
};

/** Autogenerated input type of CreateReferral */
export type CreateReferralInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Notes on the referral */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** The referred professional contact's public id */
  readonly referredContactId?: InputMaybe<Scalars['ID']['input']>;
  /** The referred household contact, by contact id */
  readonly referredHouseholdContactId?: InputMaybe<Scalars['ID']['input']>;
  /** The referred household */
  readonly referredHouseholdId?: InputMaybe<Scalars['ID']['input']>;
  /** The month the referral happened */
  readonly referredOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The referring professional contact's public id */
  readonly referrerContactId?: InputMaybe<Scalars['ID']['input']>;
  /** The referring household contact, by contact id */
  readonly referrerHouseholdContactId?: InputMaybe<Scalars['ID']['input']>;
  /** The referring household */
  readonly referrerHouseholdId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateReferral. */
export type CreateReferralPayload = {
  readonly __typename?: 'CreateReferralPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The recorded referral */
  readonly referral?: Maybe<Referral>;
};

/** Autogenerated input type of CreateRepaperEnvelope */
export type CreateRepaperEnvelopeInput = {
  /** Account numbers grouped by signer role */
  readonly accounts: AccountsInfoInput;
  /** Advisor whose master account number is required for the destination custodian */
  readonly advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Primary/co clients, accounts, account setup. Optional during HAWK-108→109 rollout. */
  readonly clientOnboarding?: InputMaybe<ClientOnboardingInput>;
  /** Destination custodian */
  readonly custodian: Custodian;
  /** Fee schedule attached to the household. Optional during HAWK-108→109 rollout. */
  readonly feeScheduleId?: InputMaybe<Scalars['ID']['input']>;
  /** Pre-filled app PDFs with signer-tab metadata */
  readonly formDocuments: ReadonlyArray<FormDocumentInput>;
  /** Household to attach the envelope to */
  readonly householdId: Scalars['ID']['input'];
  /** Whether the household is subject to restrictive covenants. Optional during HAWK-108→109 rollout. */
  readonly nonSolicit?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateRepaperEnvelope. */
export type CreateRepaperEnvelopePayload = {
  readonly __typename?: 'CreateRepaperEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if enqueue failed (e.g. kill switch flipped, advisor missing master account). */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** Whether the envelope creation was successfully enqueued (not whether DocuSign accepted it — see polling). */
  readonly success: Scalars['Boolean']['output'];
  /** Tracking ID for the enqueued envelope creation job — FE polls envelope status keyed by this. */
  readonly trackingId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateReportSchedule */
export type CreateReportScheduleInput = {
  /** Defaults to true */
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Upload generated PDFs to Box */
  readonly deliverToBox: Scalars['Boolean']['input'];
  /** Publish generated reports to the client portal */
  readonly deliverToPortal: Scalars['Boolean']['input'];
  /** Day of month (1-28) */
  readonly deliveryDay: Scalars['Int']['input'];
  /** Month (1-12) for annual schedules; null uses January */
  readonly deliveryMonth?: InputMaybe<Scalars['Int']['input']>;
  /** monthly | quarterly | annually */
  readonly frequency: Scalars['String']['input'];
  /**
   * Custom PDF filename pattern; supports {template_name}, {household_name},
   * {date}, {quarter}, {year}, {month}. Null uses the default pattern
   */
  readonly pdfFilenamePattern?: InputMaybe<Scalars['String']['input']>;
  /** Require advisor approval before delivering generated reports; defaults to false */
  readonly requireReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Saved template to automate */
  readonly savedReportTemplateId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateReportSchedule. */
export type CreateReportSchedulePayload = {
  readonly __typename?: 'CreateReportSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created schedule */
  readonly reportSchedule: ReportSchedule;
};

/** Autogenerated input type of CreateRetirementPlan */
export type CreateRetirementPlanInput = {
  /** Sponsor address(es) */
  readonly address?: InputMaybe<Scalars['String']['input']>;
  /** Advisory effective date */
  readonly advisoryEffectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Advisory type (e.g. 3(38)) */
  readonly advisoryType?: InputMaybe<Scalars['String']['input']>;
  /** Annual fee stored as integer cents */
  readonly annualFeeCents?: InputMaybe<Scalars['BigInt']['input']>;
  /** Billing method (e.g. 'Sponsor pays fee directly to Advisor') */
  readonly billingMethod?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the person who signed the contract */
  readonly contractSignedBy?: InputMaybe<Scalars['String']['input']>;
  /** Date the contract was signed */
  readonly contractSignedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Corporate structure (e.g. PLLC, LLC, S-Corp) */
  readonly corporateStructure?: InputMaybe<Scalars['String']['input']>;
  /** Employer Identification Number */
  readonly ein?: InputMaybe<Scalars['String']['input']>;
  /** Fee source */
  readonly feeSource?: InputMaybe<Scalars['String']['input']>;
  /** Fee structure */
  readonly feeStructure?: InputMaybe<Scalars['String']['input']>;
  /** Fiduciary type (e.g. 3(21), 3(38)) */
  readonly fiduciaryType?: InputMaybe<Scalars['String']['input']>;
  /** Optional linked household */
  readonly householdId?: InputMaybe<Scalars['ID']['input']>;
  /** Plan name */
  readonly name: Scalars['String']['input'];
  /** Organization this plan belongs to */
  readonly organizationId: Scalars['ID']['input'];
  /** Plan owners/partners */
  readonly owners?: InputMaybe<Scalars['String']['input']>;
  /** Parent company name */
  readonly parentCompany?: InputMaybe<Scalars['String']['input']>;
  /** Plan inception date */
  readonly planInceptionDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Unique plan identifier (e.g. PLAN-0421) */
  readonly planNumber: Scalars['String']['input'];
  /** Plan type (e.g. 401(k), 403(b)) */
  readonly planType?: InputMaybe<Scalars['String']['input']>;
  /** Plan year end date */
  readonly planYearEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Prior employers whose service counts toward eligibility */
  readonly predecessorService?: InputMaybe<Scalars['String']['input']>;
  /** Recordkeeper name */
  readonly recordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Plan ID at recordkeeper */
  readonly recordkeeperPlanId?: InputMaybe<Scalars['String']['input']>;
  /** Service type */
  readonly serviceType?: InputMaybe<Scalars['String']['input']>;
  /** TPA name */
  readonly tpa?: InputMaybe<Scalars['String']['input']>;
  /** Sponsor's website */
  readonly website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateRetirementPlanMilestone */
export type CreateRetirementPlanMilestoneInput = {
  /** Category: regulatory | plan_change | committee_meeting | other | invoice | education | email */
  readonly category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Due date */
  readonly dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Advisor profile ID of the team member logging this */
  readonly loggedById?: InputMaybe<Scalars['ID']['input']>;
  /** Milestone name */
  readonly name: Scalars['String']['input'];
  /** Free-text notes */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** The plan to add a milestone to */
  readonly retirementPlanId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateRetirementPlanMilestone. */
export type CreateRetirementPlanMilestonePayload = {
  readonly __typename?: 'CreateRetirementPlanMilestonePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created milestone */
  readonly retirementPlanMilestone?: Maybe<RetirementPlanMilestone>;
};

/** Autogenerated input type of CreateRetirementPlanNote */
export type CreateRetirementPlanNoteInput = {
  /** Note body text */
  readonly body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date the note applies to */
  readonly notedOn: Scalars['ISO8601Date']['input'];
  /** The plan to add a note to */
  readonly retirementPlanId: Scalars['ID']['input'];
  /** Optional note title */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateRetirementPlanNote. */
export type CreateRetirementPlanNotePayload = {
  readonly __typename?: 'CreateRetirementPlanNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created note */
  readonly retirementPlanNote?: Maybe<RetirementPlanNote>;
};

/** Autogenerated input type of CreateRetirementPlanParticipantLog */
export type CreateRetirementPlanParticipantLogInput = {
  /** Follow-up action item */
  readonly actionItem?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Type: education_meeting | enrollment_question | loan_question | distribution_request | follow_up | call | zoom | email */
  readonly interactionType: Scalars['String']['input'];
  /** Advisor profile ID of the team member logging this */
  readonly loggedById?: InputMaybe<Scalars['ID']['input']>;
  /** Date of the interaction */
  readonly loggedOn: Scalars['ISO8601Date']['input'];
  /** Free-text notes */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** Participant email address */
  readonly participantEmail?: InputMaybe<Scalars['String']['input']>;
  /** Participant full name */
  readonly participantName: Scalars['String']['input'];
  /** Participant phone number */
  readonly participantPhone?: InputMaybe<Scalars['String']['input']>;
  /** The plan to log the interaction on */
  readonly retirementPlanId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateRetirementPlanParticipantLog. */
export type CreateRetirementPlanParticipantLogPayload = {
  readonly __typename?: 'CreateRetirementPlanParticipantLogPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created log entry */
  readonly retirementPlanParticipantLog?: Maybe<RetirementPlanParticipantLog>;
};

/** Autogenerated return type of CreateRetirementPlan. */
export type CreateRetirementPlanPayload = {
  readonly __typename?: 'CreateRetirementPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created retirement plan */
  readonly retirementPlan?: Maybe<RetirementPlan>;
};

/** Autogenerated input type of CreateRetirementPlanProjectFromTemplate */
export type CreateRetirementPlanProjectFromTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Project name */
  readonly name: Scalars['String']['input'];
  /** The plan to create the project on */
  readonly retirementPlanId: Scalars['ID']['input'];
  /** Anchor date to compute each row's due date from the template's day offsets */
  readonly startDate: Scalars['ISO8601Date']['input'];
  /** The template to instantiate, if any. Omit to create a blank project with no rows. */
  readonly templateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateRetirementPlanProjectFromTemplate. */
export type CreateRetirementPlanProjectFromTemplatePayload = {
  readonly __typename?: 'CreateRetirementPlanProjectFromTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created project */
  readonly retirementPlanProject?: Maybe<RetirementPlanProject>;
};

/** Autogenerated input type of CreateRetirementPlanProject */
export type CreateRetirementPlanProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Project description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Project name */
  readonly name: Scalars['String']['input'];
  /** The plan to add a project to */
  readonly retirementPlanId: Scalars['ID']['input'];
  /** Project status */
  readonly status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateRetirementPlanProject. */
export type CreateRetirementPlanProjectPayload = {
  readonly __typename?: 'CreateRetirementPlanProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created project */
  readonly retirementPlanProject?: Maybe<RetirementPlanProject>;
};

/** Autogenerated input type of CreateRetirementPlanProjectRow */
export type CreateRetirementPlanProjectRowInput = {
  /** Advisor from the plan organization assigned to this row */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When this row is due */
  readonly dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Row name */
  readonly name: Scalars['String']['input'];
  /** Free-text notes */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** Zero-based ordering of this row within the project */
  readonly position: Scalars['Int']['input'];
  /** The organization responsible for this row */
  readonly responsibleOrg?: InputMaybe<Scalars['String']['input']>;
  /** The project to add a row to */
  readonly retirementPlanProjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateRetirementPlanProjectRow. */
export type CreateRetirementPlanProjectRowPayload = {
  readonly __typename?: 'CreateRetirementPlanProjectRowPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created row */
  readonly retirementPlanProjectRow?: Maybe<RetirementPlanProjectRow>;
};

/** Autogenerated input type of CreateRetirementPlanProjectTemplate */
export type CreateRetirementPlanProjectTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Template description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Template name */
  readonly name: Scalars['String']['input'];
  /** Organization to create the template for (required for admins; defaults to the current advisor's organization) */
  readonly organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Ordered steps for this template */
  readonly steps?: InputMaybe<ReadonlyArray<RetirementPlanProjectTemplateStepInput>>;
};

/** Autogenerated return type of CreateRetirementPlanProjectTemplate. */
export type CreateRetirementPlanProjectTemplatePayload = {
  readonly __typename?: 'CreateRetirementPlanProjectTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created template */
  readonly retirementPlanProjectTemplate?: Maybe<RetirementPlanProjectTemplate>;
};

/** Autogenerated input type of CreateRiskQuestionnaire */
export type CreateRiskQuestionnaireInput = {
  readonly answers: ReadonlyArray<RiskQuestionnaireAnswerInput>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly householdId: Scalars['Int']['input'];
  readonly userId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateRiskQuestionnaire. */
export type CreateRiskQuestionnairePayload = {
  readonly __typename?: 'CreateRiskQuestionnairePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly riskQuestionnaire?: Maybe<RiskQuestionnaire>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateServiceCalendarMeetingTypeTemplate */
export type CreateServiceCalendarMeetingTypeTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly expectedQuarter: ServiceCalendarMeetingExpectedQuarter;
  readonly sendAutomatedMeetingReminderUnit?: InputMaybe<ServiceCalendarMeetingDateUnit>;
  readonly sendAutomatedMeetingReminderValue?: InputMaybe<Scalars['Int']['input']>;
  readonly sendAutomatedMeetingUnit?: InputMaybe<ServiceCalendarMeetingDateUnit>;
  readonly sendAutomatedMeetingValue?: InputMaybe<Scalars['Int']['input']>;
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateServiceCalendarMeetingTypeTemplate. */
export type CreateServiceCalendarMeetingTypeTemplatePayload = {
  readonly __typename?: 'CreateServiceCalendarMeetingTypeTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly serviceCalendarMeetingTypeTemplate?: Maybe<ServiceCalendarMeetingTypeTemplate>;
};

/** Autogenerated input type of CreateServiceCalendarMeetings */
export type CreateServiceCalendarMeetingsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly expectedQuarter: ServiceCalendarMeetingExpectedQuarter;
  readonly householdId: Scalars['Int']['input'];
  readonly sendAutomatedMeetingReminderUnit?: InputMaybe<ServiceCalendarMeetingDateUnit>;
  readonly sendAutomatedMeetingReminderValue?: InputMaybe<Scalars['Int']['input']>;
  readonly sendAutomatedMeetingUnit?: InputMaybe<ServiceCalendarMeetingDateUnit>;
  readonly sendAutomatedMeetingValue?: InputMaybe<Scalars['Int']['input']>;
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateServiceCalendarMeetings. */
export type CreateServiceCalendarMeetingsPayload = {
  readonly __typename?: 'CreateServiceCalendarMeetingsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly serviceCalendarMeeting?: Maybe<ServiceCalendarMeeting>;
};

/** Autogenerated input type of CreateServiceCalendarSettingTemplate */
export type CreateServiceCalendarSettingTemplateInput = {
  /** Whether the template is active */
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Q1 flag */
  readonly q1?: InputMaybe<Scalars['Boolean']['input']>;
  /** Q2 flag */
  readonly q2?: InputMaybe<Scalars['Boolean']['input']>;
  /** Q3 flag */
  readonly q3?: InputMaybe<Scalars['Boolean']['input']>;
  /** Q4 flag */
  readonly q4?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the template is required */
  readonly required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Template title */
  readonly title: Scalars['String']['input'];
  /** Type of template */
  readonly typeOf: Scalars['String']['input'];
};

/** Autogenerated return type of CreateServiceCalendarSettingTemplate. */
export type CreateServiceCalendarSettingTemplatePayload = {
  readonly __typename?: 'CreateServiceCalendarSettingTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly serviceCalendarSettingTemplate?: Maybe<ServiceCalendarSettingTemplate>;
};

/** Autogenerated input type of CreateServiceCatalogItemGroup */
export type CreateServiceCatalogItemGroupInput = {
  /** Editors of a team service. An empty or omitted list means everyone in the owning scope can edit. */
  readonly acl?: InputMaybe<ReadonlyArray<ServiceCatalogItemGroupAclInput>>;
  /** Advisor group id (legacy scope). Exactly one of advisorGroupId / organizationId is accepted. */
  readonly advisorGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Attributes */
  readonly attributes: ServiceCatalogItemGroupAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Organization id (org scope). Exactly one of advisorGroupId / organizationId is accepted. */
  readonly organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Who can see and run this service. Omitted creates it team-visible. */
  readonly visibility?: InputMaybe<ServiceCatalogItemGroupVisibility>;
};

/** Autogenerated return type of CreateServiceCatalogItemGroup. */
export type CreateServiceCatalogItemGroupPayload = {
  readonly __typename?: 'CreateServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Service catalog item group */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
};

/** Autogenerated input type of CreateServiceCatalogItemHouseholdOverride */
export type CreateServiceCatalogItemHouseholdOverrideInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Is skipped */
  readonly isSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Override date */
  readonly overrideDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Override dtstart */
  readonly overrideDtstart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Override email body */
  readonly overrideEmailBody?: InputMaybe<Scalars['String']['input']>;
  /** Override email subject */
  readonly overrideEmailSubject?: InputMaybe<Scalars['String']['input']>;
  /** Override rrule */
  readonly overrideRrule?: InputMaybe<Scalars['String']['input']>;
  /** Service catalog item household id */
  readonly serviceCatalogItemHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateServiceCatalogItemHouseholdOverride. */
export type CreateServiceCatalogItemHouseholdOverridePayload = {
  readonly __typename?: 'CreateServiceCatalogItemHouseholdOverridePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Service catalog item household override */
  readonly serviceCatalogItemHouseholdOverride?: Maybe<ServiceCatalogItemHouseholdOverride>;
};

/** Autogenerated input type of CreateServiceCatalogItem */
export type CreateServiceCatalogItemInput = {
  /** Owning advisor group ID (legacy scope) */
  readonly advisorGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Item attributes */
  readonly attributes: ServiceCatalogItemAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Owning organization ID (org scope) */
  readonly organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateServiceCatalogItem. */
export type CreateServiceCatalogItemPayload = {
  readonly __typename?: 'CreateServiceCatalogItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created item */
  readonly serviceCatalogItem?: Maybe<ServiceCatalogItem>;
};

/** Autogenerated input type of CreateSimpleTask */
export type CreateSimpleTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving as draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating it with active status */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  readonly taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of task (simple tasks only) */
  readonly type: SimpleTaskTypeName;
};

/** Autogenerated return type of CreateSimpleTask. */
export type CreateSimpleTaskPayload = {
  readonly __typename?: 'CreateSimpleTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateSubtask */
export type CreateSubtaskInput = {
  /** When the parent is a recurring task, also add this sub-task to the template and every future occurrence. */
  readonly applyToFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the user to assign the sub-task to. */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the sub-task. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** When the sub-task is due. */
  readonly dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /**
   * Calendar days before the parent task due date. When the parent is recurring,
   * each occurrence re-computes the sub-task due date.
   */
  readonly dueDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the sub-task. */
  readonly name: Scalars['String']['input'];
  /** The status of the sub-task. Defaults to "todo". */
  readonly status?: InputMaybe<SubtaskStatus>;
  /** The Savvy ID of the parent task. */
  readonly taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSubtask. */
export type CreateSubtaskPayload = {
  readonly __typename?: 'CreateSubtaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created sub-task. */
  readonly subtask?: Maybe<Subtask>;
};

/** Autogenerated input type of CreateSurveyRound */
export type CreateSurveyRoundInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Unique ops-facing name, e.g. "2026 Q4 – Group B" */
  readonly label: Scalars['String']['input'];
  /** The Typeform form ID the round delivers */
  readonly typeformFormId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateSurveyRound. */
export type CreateSurveyRoundPayload = {
  readonly __typename?: 'CreateSurveyRoundPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created round */
  readonly surveyRound: SurveyRoundReport;
};

/** Autogenerated input type of CreateSwimRequestTask */
export type CreateSwimRequestTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating the SWIM request */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
  /** The input for swim request task specific data */
  readonly typeSpecificInput: SwimRequestTaskInput;
};

/** Autogenerated return type of CreateSwimRequestTask. */
export type CreateSwimRequestTaskPayload = {
  readonly __typename?: 'CreateSwimRequestTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ID of the Salesforce task */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The ID of the task */
  readonly taskId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateTaskActivityEvent */
export type CreateTaskActivityEventInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly salesforceTaskId?: InputMaybe<Scalars['String']['input']>;
  readonly taskId?: InputMaybe<Scalars['ID']['input']>;
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTaskActivityEvent. */
export type CreateTaskActivityEventPayload = {
  readonly __typename?: 'CreateTaskActivityEventPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
  readonly taskActivity: TaskActivity;
};

/** Autogenerated input type of CreateTaskComment */
export type CreateTaskCommentInput = {
  readonly attachments?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly content: Scalars['String']['input'];
  readonly mentionedUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly salesforceAccountId: Scalars['String']['input'];
  readonly salesforceTaskId?: InputMaybe<Scalars['String']['input']>;
  readonly taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateTaskComment. */
export type CreateTaskCommentPayload = {
  readonly __typename?: 'CreateTaskCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment: TaskActivity;
};

/** Autogenerated input type of CreateTaskDictationToken */
export type CreateTaskDictationTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateTaskDictationToken. */
export type CreateTaskDictationTokenPayload = {
  readonly __typename?: 'CreateTaskDictationTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Maximum dictation session duration */
  readonly maxDurationSeconds: Scalars['Int']['output'];
  /** Temporary streaming credential */
  readonly token: Scalars['String']['output'];
  /** Streaming WebSocket endpoint */
  readonly websocketUrl: Scalars['String']['output'];
};

/** Autogenerated input type of CreateTaskFromEmail */
export type CreateTaskFromEmailInput = {
  /** ID of the assignee for the task */
  readonly assigneeId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the email message whose thread the task is linked to */
  readonly emailMessageId: Scalars['ID']['input'];
  /** ID of the household to create a task for */
  readonly householdId: Scalars['ID']['input'];
  /** The advisor-typed name for the task */
  readonly name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTaskFromEmail. */
export type CreateTaskFromEmailPayload = {
  readonly __typename?: 'CreateTaskFromEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if not successful */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateTaskFromNote */
export type CreateTaskFromNoteInput = {
  /** ID of the assignee for the task */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the household to create a task for */
  readonly householdId: Scalars['ID']['input'];
  /** ID of the note to create a task from */
  readonly noteId: Scalars['ID']['input'];
  /** Deprecated, unused */
  readonly salesforceTaskId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateTaskFromNote. */
export type CreateTaskFromNotePayload = {
  readonly __typename?: 'CreateTaskFromNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if not successful */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Input that will be applied to the task object in tasks table */
export type CreateTaskInput = {
  /** Whether to include the calendly scheduling step in a client task */
  readonly addCalendlyScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user that the task is assigned to */
  readonly assigneeId: Scalars['ID']['input'];
  /** The link to the box folder that the task is associated with */
  readonly boxFolderId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The client user the task is for; omitted for client-less (prospect) tasks such
   * as Corporate Retirement Plan prospect variants
   */
  readonly clientId?: InputMaybe<Scalars['ID']['input']>;
  /** Who receives the task-completed client email; falls back to every household account holder when unset */
  readonly completedEmailRecipients?: InputMaybe<TaskCompletedEmailRecipients>;
  /** The description of the task */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Serialized form state for wizard-based draft tasks; cleared on canonicalization */
  readonly draftPayload?: InputMaybe<Scalars['String']['input']>;
  /** When the task is due */
  readonly dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Whether to notify the client when the task is created */
  readonly notifyClientUponCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to send a client email reminder when the task is due */
  readonly sendClientEmailReminders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to email the client when the task completes; falls back to the organization default when unset */
  readonly sendEmailWhenCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to send a SMS reminder when the task is created */
  readonly smsClientUponCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** The status of the task. Default: Todo */
  readonly status: TaskStatus;
  /** Other tasks to link this one to, created atomically with the task. */
  readonly taskLinks?: InputMaybe<ReadonlyArray<TaskLinkInput>>;
  /** The title of the task */
  readonly title: Scalars['String']['input'];
};

/** Optional metadata overrides for task creation */
export type CreateTaskMetadataInput = {
  /** Override default assignee */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** Override default box folder */
  readonly boxFolderId?: InputMaybe<Scalars['String']['input']>;
  /** Override default description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Override default due date */
  readonly dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Override default status (Todo) */
  readonly status?: InputMaybe<TaskStatus>;
  /** Override default title */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateTaskWorkItem */
export type CreateTaskWorkItemInput = {
  /** The user that the task is assigned to — pass null to create unassigned */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** Files already uploaded to the Box folder, recorded so a reopened draft can list them. Omit to leave existing rows alone */
  readonly attachments?: InputMaybe<ReadonlyArray<TaskAttachmentInput>>;
  /** Box folder ID for file attachments */
  readonly boxFolderId?: InputMaybe<Scalars['String']['input']>;
  /** IDs of client profiles to associate with the work item */
  readonly clientIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The household member the task is addressed to, as a user ID. Defaults to the household's primary client */
  readonly clientUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Serialized form state, so reopening a draft restores the form it was saved from. Ignored unless saving as draft */
  readonly draftPayload?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving as draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** When the task is due */
  readonly dueDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** IDs of households to associate with the work item */
  readonly householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Additional instructions for the task */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  /** The name of the task */
  readonly name: Scalars['String']['input'];
  /** Task priority level. Defaults to NULL if not provided */
  readonly priority?: InputMaybe<TaskPriority>;
  /** Optional recurrence configuration */
  readonly recurrence?: InputMaybe<RecurrenceInput>;
  /** When present, link the created task to this retirement plan project step in the same transaction */
  readonly retirementPlanProjectRowId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating it with todo status */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional list of subtasks to create atomically with the task. */
  readonly subtasks?: InputMaybe<ReadonlyArray<SubtaskCreationInput>>;
  /** Other tasks to link this one to, created atomically with the task. */
  readonly taskLinks?: InputMaybe<ReadonlyArray<TaskLinkInput>>;
  /** When present, accept and link the originating task suggestion to the created task in the same transaction */
  readonly taskSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  /** Task type. Defaults to General — the advisor-facing catch-all. Pass Other for Ops queue tasks. */
  readonly typeOf?: InputMaybe<TaskTypeName>;
};

/** Autogenerated return type of CreateTaskWorkItem. */
export type CreateTaskWorkItemPayload = {
  readonly __typename?: 'CreateTaskWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateTaskWorkflowTemplate */
export type CreateTaskWorkflowTemplateInput = {
  /** Editors for a team workflow. Empty means everyone in the group can edit. */
  readonly acl?: InputMaybe<ReadonlyArray<WorkflowTemplateAclInput>>;
  /** Advisor to assign the workflow to. Must be an advisor in your firm. */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Workflow description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Workflow name */
  readonly name: Scalars['String']['input'];
  /** The Savvy template this workflow is cloned from, if any. */
  readonly parentTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** Schedule anchor: launch_date or due_date */
  readonly schedule: TaskWorkflowTemplateSchedule;
  /** Subtasks, each with an optional day offset */
  readonly subtasks?: InputMaybe<ReadonlyArray<SubtaskCreationInput>>;
  /** Visibility: private or firm */
  readonly visibility: TaskWorkflowTemplateVisibility;
};

/** Autogenerated return type of CreateTaskWorkflowTemplate. */
export type CreateTaskWorkflowTemplatePayload = {
  readonly __typename?: 'CreateTaskWorkflowTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created workflow */
  readonly taskWorkflowTemplate?: Maybe<TaskWorkflowTemplate>;
};

/** Autogenerated input type of CreateTaxEnrollment */
export type CreateTaxEnrollmentInput = {
  /** Client who will pay the price */
  readonly billableClientId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Enum type about enrollment */
  readonly enrollmentType: TaxEnrollmentTypeName;
  /** Whether this is a late filing */
  readonly lateFiling?: InputMaybe<Scalars['Boolean']['input']>;
  /** Client who will be filed jointly, will not be charged */
  readonly nonBillableClientId?: InputMaybe<Scalars['ID']['input']>;
  /** Price to charge billable client */
  readonly price?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Tax year for this enrollment */
  readonly taxYear: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateTaxEnrollment. */
export type CreateTaxEnrollmentPayload = {
  readonly __typename?: 'CreateTaxEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** errors */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** success boolean */
  readonly success: Scalars['Boolean']['output'];
  /** object */
  readonly taxEnrollment?: Maybe<TaxEnrollment>;
};

/** Autogenerated input type of CreateTeam */
export type CreateTeamInput = {
  /** User IDs of same-firm advisors to seed as members (the creator is always added) */
  readonly advisorUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Team name, unique within the firm */
  readonly name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTeam. */
export type CreateTeamPayload = {
  readonly __typename?: 'CreateTeamPayload';
  /** The created team */
  readonly advisorGroup?: Maybe<AdvisorGroup>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateTradingTask */
export type CreateTradingTaskInput = {
  /** The client for whom the task is being created */
  readonly clientId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft instead of creating the trading request */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Other tasks to link this one to, written atomically with the task */
  readonly taskLinks?: InputMaybe<ReadonlyArray<TaskLinkInput>>;
  /** Optional task metadata overrides */
  readonly taskMetadata?: InputMaybe<CreateTaskMetadataInput>;
  /** Trading-specific information */
  readonly tradingRequestInput: TradingRequestInput;
};

/** Autogenerated return type of CreateTradingTask. */
export type CreateTradingTaskPayload = {
  readonly __typename?: 'CreateTradingTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ID of the task */
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateTransferOfAssetsTask */
export type CreateTransferOfAssetsTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Creation form route to use when reopening a saved draft */
  readonly creationFormRoute?: InputMaybe<Scalars['String']['input']>;
  /** Existing draft task ID to update when saving or publishing a draft */
  readonly draftTaskId?: InputMaybe<Scalars['ID']['input']>;
  /** Save the task as a draft without creating the transfer of assets request */
  readonly saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The input for the task */
  readonly taskInput: CreateTaskInput;
  /** The input for transfer of assets task specific data */
  readonly typeSpecificInput?: InputMaybe<TransferOfAssetsInput>;
};

/** Autogenerated return type of CreateTransferOfAssetsTask. */
export type CreateTransferOfAssetsTaskPayload = {
  readonly __typename?: 'CreateTransferOfAssetsTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The created task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of CreateUserContact */
export type CreateUserContactInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth in YYYY-MM-DD format */
  readonly dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Email of the contact */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the contact */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the contact is a beneficiary */
  readonly isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name of the contact */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the contact */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Relation of the contact */
  readonly relation?: InputMaybe<BeneficiaryRelationship>;
  /** SSN of the contact */
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user */
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateUserContact. */
export type CreateUserContactPayload = {
  readonly __typename?: 'CreateUserContactPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contact?: Maybe<Contact>;
};

/** Autogenerated input type of CreateUserForHouseholdMember */
export type CreateUserForHouseholdMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email for the new user. Must be unique. */
  readonly email: Scalars['String']['input'];
  /** First name. */
  readonly firstName: Scalars['String']['input'];
  /**
   * The household the new user will be added to. Used only for authorization — the
   * caller must be the household's advisor. No ClientProfile#household link is created.
   */
  readonly householdId: Scalars['ID']['input'];
  /** Last name. */
  readonly lastName: Scalars['String']['input'];
  /** Optional phone number. */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateUserForHouseholdMember. */
export type CreateUserForHouseholdMemberPayload = {
  readonly __typename?: 'CreateUserForHouseholdMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * The created User, returned as a lookup-minimal type (the advisor has no
   * HouseholdMembership edge to this user yet, so Models::User read-auth would fail).
   */
  readonly user: UserLookupResult;
};

/** Details about a specific CSA review condition */
export type CsaReviewCondition = {
  readonly __typename?: 'CsaReviewCondition';
  /** Accounts that triggered this condition */
  readonly accounts: ReadonlyArray<AccountSummary>;
  /** Account limits that were exceeded */
  readonly limitsExceeded: ReadonlyArray<AccountLimitExceeded>;
  /** Whether this condition is triggered */
  readonly triggered: Scalars['Boolean']['output'];
  /** Unsupported accounts that triggered this condition */
  readonly unsupportedAccounts: ReadonlyArray<UnsupportedAccount>;
};

/** CSA review conditions for a household */
export type CsaReviewConditions = {
  readonly __typename?: 'CsaReviewConditions';
  /** Multiple source accounts condition details */
  readonly multipleSourceAccounts: CsaReviewCondition;
  /** Mutual funds condition details */
  readonly mutualFunds: CsaReviewCondition;
  /** Whether CSA review is needed */
  readonly needsReview: Scalars['Boolean']['output'];
  /** Transfer account limits condition details */
  readonly transferAccountLimits: CsaReviewCondition;
  /** Unsupported account types condition details */
  readonly unsupportedAccountTypes: CsaReviewCondition;
};

/** The current user */
export type CurrentUser = {
  readonly __typename?: 'CurrentUser';
  /** Announcement configs that are currently active and not dismissed by the current user */
  readonly activeAnnouncements: ReadonlyArray<AnnouncementConfig>;
  /** The current advisor's own directory entry for self-edit; null until first save (or for non-advisors). */
  readonly advisorDirectory?: Maybe<AdvisorDirectoryEntry>;
  /** Whether the signed-in person may use the announcements CMS editor */
  readonly canEditAnnouncements: Scalars['Boolean']['output'];
  /**
   * Whether in-person meeting recording is enabled for the current advisor.
   * Resolved server-side: the same flag also gates the recording mutations, so a
   * client that ignores this cannot reach the feature anyway. Read by query, not
   * streamed — flipping the flag takes effect on the next refetch.
   */
  readonly flagInPersonMeetingRecording: Scalars['Boolean']['output'];
  /**
   * Whether the mobile app offers natural-language task creation. False for
   * non-advisors. A rollout control for that entry point only: the freeform routes
   * behind it are the web app's own, and reachable there without it.
   */
  readonly flagTasksNaturalLanguageCreationMobile: Scalars['Boolean']['output'];
  /**
   * Advisors in the current advisor's group, excluding themselves. What the
   * recording flow offers as "who else is in the room": each one named is
   * described to the transcription request so their turns can be attributed to
   * them. Empty for non-advisors and for an advisor who has no group.
   */
  readonly meetingRecordingGroupAdvisors: ReadonlyArray<MeetingRecordingParticipant>;
  /**
   * Whether the current advisor has a voice enrollment clip on file. False for
   * non-advisors, and false again once a clip passes its retention limit and is destroyed.
   * @deprecated Voice enrollment no longer affects anything. Transcription identifies the advisor from the room they declared, not from a stored clip. Kept so app builds that still query it keep working.
   */
  readonly meetingRecordingVoiceEnrolled: Scalars['Boolean']['output'];
  readonly salesforceAccessToken?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<User>;
};

/** Name of the custodian */
export const Custodian = {
  /** fidelity */
  Fidelity: 'fidelity',
  /** schwab */
  Schwab: 'schwab'
} as const;

export type Custodian = typeof Custodian[keyof typeof Custodian];
/** Custodian for an Add Advisor To Existing Account request */
export const CustodianName = {
  /** fidelity */
  Fidelity: 'fidelity',
  /** goldman_sachs */
  GoldmanSachs: 'goldman_sachs',
  /** schwab */
  Schwab: 'schwab'
} as const;

export type CustodianName = typeof CustodianName[keyof typeof CustodianName];
/** A data export job */
export type DataExport = {
  readonly __typename?: 'DataExport';
  /** When the export was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** URL to download the exported file */
  readonly downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Error message if export failed */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** When the export expires and will be deleted */
  readonly expiresAt: Scalars['ISO8601DateTime']['output'];
  /** Name of the exported file */
  readonly filename: Scalars['String']['output'];
  /** Export format (csv, json, xlsx) */
  readonly format: Scalars['String']['output'];
  /** Unique identifier for the export */
  readonly id: Scalars['ID']['output'];
  /** The type of resource being exported */
  readonly resourceType: Scalars['String']['output'];
  /** Number of rows exported */
  readonly rowCount?: Maybe<Scalars['Int']['output']>;
  /** Export status (pending, processing, completed, failed) */
  readonly status: Scalars['String']['output'];
};

/** Date/datetime/time filter with operator and value(s) */
export type DateFilterInput = {
  /** End date/time for between operator */
  readonly end?: InputMaybe<Scalars['String']['input']>;
  /** Date filter operator */
  readonly operator: DateFilterOperatorEnum;
  /** Start date/time for between operator */
  readonly start?: InputMaybe<Scalars['String']['input']>;
  /** Filter value (not required for isEmpty operator) */
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Date/datetime/time filter operators */
export const DateFilterOperatorEnum = {
  /** After the date */
  After: 'AFTER',
  /** Before the date */
  Before: 'BEFORE',
  /** Between start and end dates */
  Between: 'BETWEEN',
  /** Equal to date */
  Eq: 'EQ',
  /** Field is empty or null */
  IsEmpty: 'IS_EMPTY'
} as const;

export type DateFilterOperatorEnum = typeof DateFilterOperatorEnum[keyof typeof DateFilterOperatorEnum];
/** An arbitrary date range with ISO-8601 (YYYY-MM-DD) start and end dates, both inclusive. */
export type DateRangeInput = {
  /** Window end (inclusive). */
  readonly endDate: Scalars['ISO8601Date']['input'];
  /** Window start (inclusive). */
  readonly startDate: Scalars['ISO8601Date']['input'];
};

export type DcaAccountConfig = {
  readonly __typename?: 'DcaAccountConfig';
  readonly accountName?: Maybe<Scalars['String']['output']>;
  readonly dcaAmount?: Maybe<Scalars['String']['output']>;
  readonly dcaCadenceEvery?: Maybe<Scalars['String']['output']>;
  readonly dcaCadenceUnit?: Maybe<Scalars['String']['output']>;
};

/** Per-account DCA configuration for a swim request */
export type DcaAccountConfigInput = {
  /** Account name, matching the included accounts string format */
  readonly accountName: Scalars['String']['input'];
  /** Per-installment DCA amount */
  readonly dcaAmount?: InputMaybe<Scalars['String']['input']>;
  /** The N in "every N units" */
  readonly dcaCadenceEvery?: InputMaybe<Scalars['String']['input']>;
  /** Cadence unit: days, weeks, months, or years */
  readonly dcaCadenceUnit?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DecideProposals */
export type DecideProposalsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** One decision per proposal. */
  readonly decisions: ReadonlyArray<ProposalDecisionInput>;
  /** The household the proposals belong to. */
  readonly householdId: Scalars['ID']['input'];
  /** A caller-generated key; resubmitting it returns the recorded decisions. */
  readonly idempotencyKey: Scalars['String']['input'];
};

/** Autogenerated return type of DecideProposals. */
export type DecideProposalsPayload = {
  readonly __typename?: 'DecideProposalsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The decided proposals. */
  readonly proposals: ReadonlyArray<AgentProposal>;
};

/** Autogenerated input type of DeleteAccount */
export type DeleteAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAccount. */
export type DeleteAccountPayload = {
  readonly __typename?: 'DeleteAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteAddress */
export type DeleteAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAddress. */
export type DeleteAddressPayload = {
  readonly __typename?: 'DeleteAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteAsset */
export type DeleteAssetInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAsset. */
export type DeleteAssetPayload = {
  readonly __typename?: 'DeleteAssetPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteCallLog */
export type DeleteCallLogInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the CallLog to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCallLog. */
export type DeleteCallLogPayload = {
  readonly __typename?: 'DeleteCallLogPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the deletion was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Errors for deleting a center of influence representative */
export const DeleteCenterOfInfluenceRepError = {
  /** not_found */
  NotFound: 'not_found'
} as const;

export type DeleteCenterOfInfluenceRepError = typeof DeleteCenterOfInfluenceRepError[keyof typeof DeleteCenterOfInfluenceRepError];
/** Autogenerated input type of DeleteCenterOfInfluenceRep */
export type DeleteCenterOfInfluenceRepInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the center of influence rep to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCenterOfInfluenceRep. */
export type DeleteCenterOfInfluenceRepPayload = {
  readonly __typename?: 'DeleteCenterOfInfluenceRepPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error encountered during deletion */
  readonly softError?: Maybe<DeleteCenterOfInfluenceRepError>;
  /** Whether the deletion was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteClientOpportunity */
export type DeleteClientOpportunityInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opportunity ID to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteClientOpportunity. */
export type DeleteClientOpportunityPayload = {
  readonly __typename?: 'DeleteClientOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns successful deletion */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteCoClient */
export type DeleteCoClientInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCoClient. */
export type DeleteCoClientPayload = {
  readonly __typename?: 'DeleteCoClientPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of error messages if the operation failed */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Returns successful deletion */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteCommentAttachment */
export type DeleteCommentAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The attachment to delete */
  readonly commentAttachmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCommentAttachment. */
export type DeleteCommentAttachmentPayload = {
  readonly __typename?: 'DeleteCommentAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the delete succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteComment */
export type DeleteCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment to delete */
  readonly commentId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteComment. */
export type DeleteCommentPayload = {
  readonly __typename?: 'DeleteCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The tombstoned comment when it had replies, null when the row was removed outright */
  readonly comment?: Maybe<Comment>;
  /** Whether the delete succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Errors for deleting a company */
export const DeleteCompanyError = {
  /** not_found */
  NotFound: 'not_found'
} as const;

export type DeleteCompanyError = typeof DeleteCompanyError[keyof typeof DeleteCompanyError];
/** Autogenerated input type of DeleteCompany */
export type DeleteCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the company to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCompany. */
export type DeleteCompanyPayload = {
  readonly __typename?: 'DeleteCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error encountered during deletion */
  readonly softError?: Maybe<DeleteCompanyError>;
  /** Whether the deletion was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteDialpadCall */
export type DeleteDialpadCallInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the DialpadCall to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDialpadCall. */
export type DeleteDialpadCallPayload = {
  readonly __typename?: 'DeleteDialpadCallPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the deletion was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteFamilyMember */
export type DeleteFamilyMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly householdId: Scalars['ID']['input'];
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFamilyMember. */
export type DeleteFamilyMemberPayload = {
  readonly __typename?: 'DeleteFamilyMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns successful deletion */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteFeeSchedule */
export type DeleteFeeScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the fee schedule to delete */
  readonly feeScheduleId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFeeSchedule. */
export type DeleteFeeSchedulePayload = {
  readonly __typename?: 'DeleteFeeSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if deleting was not successful */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** The fee schedule that was deleted */
  readonly feeSchedule?: Maybe<FeeSchedule>;
  /** Whether the fee schedule was deleted */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteFinancialOffering */
export type DeleteFinancialOfferingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Offering id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFinancialOffering. */
export type DeleteFinancialOfferingPayload = {
  readonly __typename?: 'DeleteFinancialOfferingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The deleted offering */
  readonly financialOffering?: Maybe<FinancialOffering>;
};

/** Autogenerated input type of DeleteFinancialPlan */
export type DeleteFinancialPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household ID whose plan should be deleted */
  readonly householdId: Scalars['ID']['input'];
  /** Also delete the household's seeded source records (dev seed reset; non-production only) */
  readonly wipeRecords?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of DeleteFinancialPlan. */
export type DeleteFinancialPlanPayload = {
  readonly __typename?: 'DeleteFinancialPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether any plan or record was cleared */
  readonly deleted: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteFinancialPlanReportFile */
export type DeleteFinancialPlanReportFileInput = {
  /** Box file ID of the financial plan report to delete */
  readonly boxFileId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household ID that owns the financial plan report */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFinancialPlanReportFile. */
export type DeleteFinancialPlanReportFilePayload = {
  readonly __typename?: 'DeleteFinancialPlanReportFilePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the file was deleted successfully */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteGoal */
export type DeleteGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteGoal. */
export type DeleteGoalPayload = {
  readonly __typename?: 'DeleteGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteHousehold */
export type DeleteHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to set as inactive */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteHousehold. */
export type DeleteHouseholdPayload = {
  readonly __typename?: 'DeleteHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the household was set to inactive */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteHouseholdReferral */
export type DeleteHouseholdReferralInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The referral id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteHouseholdReferral. */
export type DeleteHouseholdReferralPayload = {
  readonly __typename?: 'DeleteHouseholdReferralPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The id of the removed referral */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteLiability */
export type DeleteLiabilityInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteLiability. */
export type DeleteLiabilityPayload = {
  readonly __typename?: 'DeleteLiabilityPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteMeetingAgendaTemplate */
export type DeleteMeetingAgendaTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The template ID */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteMeetingAgendaTemplate. */
export type DeleteMeetingAgendaTemplatePayload = {
  readonly __typename?: 'DeleteMeetingAgendaTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the template was deleted */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteMeetingRecording */
export type DeleteMeetingRecordingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The recording to discard. */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteMeetingRecording. */
export type DeleteMeetingRecordingPayload = {
  readonly __typename?: 'DeleteMeetingRecordingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** True once the recording is discarded. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteNote */
export type DeleteNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteNote. */
export type DeleteNotePayload = {
  readonly __typename?: 'DeleteNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteOrganizationHouseholdCategory */
export type DeleteOrganizationHouseholdCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteOrganizationHouseholdCategory. */
export type DeleteOrganizationHouseholdCategoryPayload = {
  readonly __typename?: 'DeleteOrganizationHouseholdCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeletePlanFinancialSnapshot */
export type DeletePlanFinancialSnapshotInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Snapshot ID to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePlanFinancialSnapshot. */
export type DeletePlanFinancialSnapshotPayload = {
  readonly __typename?: 'DeletePlanFinancialSnapshotPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** ID of the deleted snapshot */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteProfessionalService */
export type DeleteProfessionalServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The professional service id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProfessionalService. */
export type DeleteProfessionalServicePayload = {
  readonly __typename?: 'DeleteProfessionalServicePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The id of the removed service */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteProspectOpportunity */
export type DeleteProspectOpportunityInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Opportunity ID to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProspectOpportunity. */
export type DeleteProspectOpportunityPayload = {
  readonly __typename?: 'DeleteProspectOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns successful deletion */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteProviderAccount */
export type DeleteProviderAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProviderAccount. */
export type DeleteProviderAccountPayload = {
  readonly __typename?: 'DeleteProviderAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteReferral */
export type DeleteReferralInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The referral id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteReferral. */
export type DeleteReferralPayload = {
  readonly __typename?: 'DeleteReferralPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The id of the removed referral */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteReportSchedule */
export type DeleteReportScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Schedule to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteReportSchedule. */
export type DeleteReportSchedulePayload = {
  readonly __typename?: 'DeleteReportSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted schedule */
  readonly deletedId: Scalars['ID']['output'];
};

/** Autogenerated input type of DeleteReportTemplate */
export type DeleteReportTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the template to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteReportTemplate. */
export type DeleteReportTemplatePayload = {
  readonly __typename?: 'DeleteReportTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted template */
  readonly deletedId: Scalars['ID']['output'];
};

/** Autogenerated input type of DeleteRetirementPlan */
export type DeleteRetirementPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Retirement plan ID to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated input type of DeleteRetirementPlanMilestone */
export type DeleteRetirementPlanMilestoneInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Milestone ID to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanMilestone. */
export type DeleteRetirementPlanMilestonePayload = {
  readonly __typename?: 'DeleteRetirementPlanMilestonePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** ID of the deleted milestone */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteRetirementPlanNote */
export type DeleteRetirementPlanNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Note ID to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanNote. */
export type DeleteRetirementPlanNotePayload = {
  readonly __typename?: 'DeleteRetirementPlanNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** ID of the deleted note */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteRetirementPlanParticipantLog */
export type DeleteRetirementPlanParticipantLogInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Log entry ID to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanParticipantLog. */
export type DeleteRetirementPlanParticipantLogPayload = {
  readonly __typename?: 'DeleteRetirementPlanParticipantLogPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** ID of the deleted log entry */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of DeleteRetirementPlan. */
export type DeleteRetirementPlanPayload = {
  readonly __typename?: 'DeleteRetirementPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** ID of the deleted retirement plan */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteRetirementPlanProject */
export type DeleteRetirementPlanProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Project ID to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanProject. */
export type DeleteRetirementPlanProjectPayload = {
  readonly __typename?: 'DeleteRetirementPlanProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** ID of the deleted project */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteRetirementPlanProjectRow */
export type DeleteRetirementPlanProjectRowInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Row ID to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanProjectRow. */
export type DeleteRetirementPlanProjectRowPayload = {
  readonly __typename?: 'DeleteRetirementPlanProjectRowPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** ID of the deleted row */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteRetirementPlanProjectTemplate */
export type DeleteRetirementPlanProjectTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Template ID to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRetirementPlanProjectTemplate. */
export type DeleteRetirementPlanProjectTemplatePayload = {
  readonly __typename?: 'DeleteRetirementPlanProjectTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** ID of the deleted template */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteServiceCalendarMeeting */
export type DeleteServiceCalendarMeetingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the meeting to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteServiceCalendarMeeting. */
export type DeleteServiceCalendarMeetingPayload = {
  readonly __typename?: 'DeleteServiceCalendarMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteServiceCalendarMeetingTypeTemplate */
export type DeleteServiceCalendarMeetingTypeTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the meeting type template to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteServiceCalendarMeetingTypeTemplate. */
export type DeleteServiceCalendarMeetingTypeTemplatePayload = {
  readonly __typename?: 'DeleteServiceCalendarMeetingTypeTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteServiceCalendarSettingTemplate */
export type DeleteServiceCalendarSettingTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the template to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteServiceCalendarSettingTemplate. */
export type DeleteServiceCalendarSettingTemplatePayload = {
  readonly __typename?: 'DeleteServiceCalendarSettingTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteServiceCatalogItemHouseholdOverride */
export type DeleteServiceCatalogItemHouseholdOverrideInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteServiceCatalogItemHouseholdOverride. */
export type DeleteServiceCatalogItemHouseholdOverridePayload = {
  readonly __typename?: 'DeleteServiceCatalogItemHouseholdOverridePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Deleted override id */
  readonly deletedOverrideId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteSubtask */
export type DeleteSubtaskInput = {
  /** When the parent is a recurring task, also delete the matching sub-task from the template and every future occurrence. */
  readonly applyToFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy ID of the sub-task to delete. */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteSubtask. */
export type DeleteSubtaskPayload = {
  readonly __typename?: 'DeleteSubtaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted sub-task. */
  readonly deletedId: Scalars['ID']['output'];
  /** The parent task. Returned so clients can refresh derived counts. Its status is NOT mutated by this mutation. */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of DeleteTaskComment */
export type DeleteTaskCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly taskActivityId: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteTaskComment. */
export type DeleteTaskCommentPayload = {
  readonly __typename?: 'DeleteTaskCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTask */
export type DeleteTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Only meaningful when the deleted task is the main (template) task of a
   * recurring series. When true, also remove the future-dated open occurrences
   * (instance_date > the template's instance_date). When false/omitted, the
   * recurrence is ended and the siblings are unlinked but kept as standalone
   * tasks. Ignored for non-template occurrences (which delete only that task) and
   * for non-recurring tasks.
   */
  readonly removeUpcomingOccurrences?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Salesforce task ID */
  readonly salesforceTaskId: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteTask. */
export type DeleteTaskPayload = {
  readonly __typename?: 'DeleteTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTaskWorkflowTemplate */
export type DeleteTaskWorkflowTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The workflow task to delete */
  readonly taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTaskWorkflowTemplate. */
export type DeleteTaskWorkflowTemplatePayload = {
  readonly __typename?: 'DeleteTaskWorkflowTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted workflow task */
  readonly deletedTaskId?: Maybe<Scalars['ID']['output']>;
  /** Whether the deletion succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteTaxEnrollment */
export type DeleteTaxEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of Tax Enrollment to delete */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTaxEnrollment. */
export type DeleteTaxEnrollmentPayload = {
  readonly __typename?: 'DeleteTaxEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Returns successful deletion */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteUserContact */
export type DeleteUserContactInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the contact to delete */
  readonly id: Scalars['ID']['input'];
  /** The ID of the user whose contact to delete */
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteUserContact. */
export type DeleteUserContactPayload = {
  readonly __typename?: 'DeleteUserContactPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the contact was deleted successfully */
  readonly success: Scalars['Boolean']['output'];
};

export const DemoProspectResetterError = {
  ResetFailed: 'reset_failed'
} as const;

export type DemoProspectResetterError = typeof DemoProspectResetterError[keyof typeof DemoProspectResetterError];
/** Shape of the demo book to build. Every field is optional; omitted fields keep the seed defaults. */
export type DemoReseedOptions = {
  /** Advisor-role members on a GROUP practice. Clamps to the roster. */
  readonly groupAdvisors?: InputMaybe<Scalars['Int']['input']>;
  /** CSA members on a GROUP practice. Clamps to the roster. */
  readonly groupCsas?: InputMaybe<Scalars['Int']['input']>;
  /** Investment-manager members on a GROUP practice. Clamps to the roster. */
  readonly groupInvestmentManagers?: InputMaybe<Scalars['Int']['input']>;
  /** Junior-advisor members on a GROUP practice. Clamps to the roster. */
  readonly groupJuniorAdvisors?: InputMaybe<Scalars['Int']['input']>;
  /** Marketing-staff members on a GROUP practice. Clamps to the roster. */
  readonly groupMarketingStaff?: InputMaybe<Scalars['Int']['input']>;
  /** Top of the per-household AUM range, in dollars. */
  readonly householdAumHigh?: InputMaybe<Scalars['Int']['input']>;
  /** Bottom of the per-household AUM range, in dollars. */
  readonly householdAumLow?: InputMaybe<Scalars['Int']['input']>;
  /** How many households to build. */
  readonly households?: InputMaybe<Scalars['Int']['input']>;
  /** Share of the won book on Savvy's managed platform, 0 to 100. */
  readonly managedPercent?: InputMaybe<Scalars['Int']['input']>;
  /** Password given to every seeded user. Omit to use the environment default. */
  readonly password?: InputMaybe<Scalars['String']['input']>;
  /** SOLO for a single advisor, GROUP for a team. */
  readonly practiceType?: InputMaybe<DemoReseedPractice>;
  /** Sign-in email for the book's anchor advisor. */
  readonly primaryAdvisorEmail?: InputMaybe<Scalars['String']['input']>;
  /** First name shown for the book's anchor advisor. */
  readonly primaryAdvisorFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name shown for the book's anchor advisor. */
  readonly primaryAdvisorLastName?: InputMaybe<Scalars['String']['input']>;
  /** Location shown for the book's anchor advisor. */
  readonly primaryAdvisorLocation?: InputMaybe<Scalars['String']['input']>;
  /** Upper bound on tasks per serviced household. */
  readonly tasksPerHousehold?: InputMaybe<Scalars['Int']['input']>;
  /** How many ultra-high-net-worth households to add. Their balances ignore the AUM range. */
  readonly uhnwClients?: InputMaybe<Scalars['Int']['input']>;
};

/** Whether the demo advisor practises alone or as part of a team. */
export const DemoReseedPractice = {
  /** A team, so operational work routes to a client service associate. */
  Group: 'GROUP',
  /** One advisor holding the whole book. */
  Solo: 'SOLO'
} as const;

export type DemoReseedPractice = typeof DemoReseedPractice[keyof typeof DemoReseedPractice];
/** One wipe-and-reload of a demo environment. */
export type DemoReseedRun = {
  readonly __typename?: 'DemoReseedRun';
  /** Digest of the seeded content, present once the reseed succeeds. Identical parameters give an identical digest. */
  readonly contentDigest?: Maybe<Scalars['String']['output']>;
  /** The demo database this reseed targeted. */
  readonly databaseName: Scalars['String']['output'];
  /** Why the reseed failed, when it did. */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** When the reseed stopped, whether it succeeded or failed. */
  readonly finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Poll demoReseedRun with this id for progress. */
  readonly id: Scalars['ID']['output'];
  /** When the reseed began. */
  readonly startedAt: Scalars['ISO8601DateTime']['output'];
  /** Whether the reseed is running, has succeeded, or failed. */
  readonly status: DemoReseedRunStatus;
};

/** Lifecycle of a demo environment reseed. */
export const DemoReseedRunStatus = {
  /** failed */
  Failed: 'FAILED',
  /** queued */
  Queued: 'QUEUED',
  /** running */
  Running: 'RUNNING',
  /** succeeded */
  Succeeded: 'SUCCEEDED'
} as const;

export type DemoReseedRunStatus = typeof DemoReseedRunStatus[keyof typeof DemoReseedRunStatus];
/** Destination custodian for an account confirmation task */
export const DestinationCustodian = {
  /** fidelity_iws */
  FidelityIws: 'fidelity_iws',
  /** goldman_sachs */
  GoldmanSachs: 'goldman_sachs',
  /** schwab */
  Schwab: 'schwab'
} as const;

export type DestinationCustodian = typeof DestinationCustodian[keyof typeof DestinationCustodian];
export type Detail = {
  readonly __typename?: 'Detail';
  /** Short description for a link/resource row */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Cloudinary icon image for a link/resource row */
  readonly iconUrl?: Maybe<Scalars['String']['output']>;
  /** Savvy ID */
  readonly id: Scalars['ID']['output'];
  readonly label: Scalars['String']['output'];
  /** Whether a link/resource row opens in a new tab (false navigates the current window) */
  readonly opensInNewTab: Scalars['Boolean']['output'];
  /** Order for quick links */
  readonly quickLinkOrder?: Maybe<Scalars['Int']['output']>;
  /** Type of the key fact */
  readonly type?: Maybe<DetailTypeName>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

export const DetailTypeName = {
  Fee: 'fee',
  KeyFact: 'key_fact',
  Link: 'link'
} as const;

export type DetailTypeName = typeof DetailTypeName[keyof typeof DetailTypeName];
/** A Dialpad phone call */
export type DialpadCall = {
  readonly __typename?: 'DialpadCall';
  /** Record created timestamp. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** When call ended. */
  readonly dateEnded?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When call started. */
  readonly dateStarted: Scalars['ISO8601DateTime']['output'];
  /** Call direction (inbound/outbound). */
  readonly direction: Scalars['String']['output'];
  /** Duration of the call in seconds. */
  readonly duration: Scalars['Int']['output'];
  /** External phone number (E.164 format). */
  readonly externalNumber: Scalars['String']['output'];
  /** The Savvy ID of the call. */
  readonly id: Scalars['ID']['output'];
  /** Internal phone number (E.164 format). */
  readonly internalNumber: Scalars['String']['output'];
  /**
   * The Note attached to this DialpadCall, scoped to the requesting household
   * context. Null when no Note exists, the per-advisor flag is off, the request
   * lacks household scope, the call is on the legacy track (dialpad_calls.notes
   * populated), or the requester is not authorized to read the Note per NotePolicy.
   */
  readonly note?: Maybe<Note>;
  /** Notes associated with the call (legacy column, populated by SF backfill). */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /** Call state. */
  readonly state: Scalars['String']['output'];
  /** Call transcription text. */
  readonly transcriptionText?: Maybe<Scalars['String']['output']>;
  /** Link to voicemail recording if available. */
  readonly voicemailShareLink?: Maybe<Scalars['String']['output']>;
  /** Whether the call was recorded. */
  readonly wasRecorded: Scalars['Boolean']['output'];
};

export type DialpadCallApi = {
  readonly __typename?: 'DialpadCallApi';
  readonly callId: Scalars['String']['output'];
  /** The contact that was spoken to */
  readonly contact?: Maybe<DialpadContact>;
  readonly dateEnded?: Maybe<Scalars['String']['output']>;
  readonly dateStarted?: Maybe<Scalars['String']['output']>;
  readonly duration?: Maybe<Scalars['Float']['output']>;
  /** The Savvy Dialpad user on the call */
  readonly target?: Maybe<DialpadContact>;
};

/** Transcript of a Dialpad phone call. */
export type DialpadCallTranscript = {
  readonly __typename?: 'DialpadCallTranscript';
  /**
   * The other party's name from the advisor's Dialpad contact book; null when
   * Dialpad supplied none or the DialpadCall row is missing.
   */
  readonly contactName?: Maybe<Scalars['String']['output']>;
  /** The Dialpad-side call identifier (used by the dialpadTranscript(dialpadCallId) resolver to fetch the body). */
  readonly dialpadCallId: Scalars['String']['output'];
  /** The Savvy ID of the matching DialpadCall record. */
  readonly dialpadCallRecordId?: Maybe<Scalars['ID']['output']>;
  /** Whether the advisor placed or received the call; null when the DialpadCall row is missing. */
  readonly direction?: Maybe<DialpadDirection>;
  /** Connected talk time in whole minutes; null for a call that never connected or whose DialpadCall row is missing. */
  readonly durationMinutes?: Maybe<Scalars['Int']['output']>;
  /** A bounded plain-text excerpt from the start of the transcript, skipping Dialpad "moment" markers. */
  readonly excerpt?: Maybe<Scalars['String']['output']>;
  /** The other party's number in E.164; null when the DialpadCall row is missing. */
  readonly externalNumber?: Maybe<Scalars['String']['output']>;
  /** When the transcript was fetched from Dialpad. */
  readonly fetchedAt: Scalars['ISO8601DateTime']['output'];
  /** Name of the household this transcript belongs to. */
  readonly householdName?: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the transcript record. */
  readonly id: Scalars['ID']['output'];
  /** When the call started, falling back to when the row was created. */
  readonly startedAt: Scalars['ISO8601DateTime']['output'];
  /** Transcript ingestion status: available or unavailable. */
  readonly status: Scalars['String']['output'];
};

/** Person involved in a Dialpad call. */
export type DialpadContact = {
  readonly __typename?: 'DialpadContact';
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  /** Name of the contact */
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  /** Type of contact */
  readonly type?: Maybe<Scalars['String']['output']>;
};

export const DialpadDirection = {
  /** inbound */
  Inbound: 'inbound',
  /** outbound */
  Outbound: 'outbound'
} as const;

export type DialpadDirection = typeof DialpadDirection[keyof typeof DialpadDirection];
export type DialpadEvent = {
  readonly __typename?: 'DialpadEvent';
  /** Dialpad sms tex or calls transcription_text */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the event was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Timestamp when the call ended/sms sent */
  readonly dateEnded?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** External Dialpad service identifier for this event */
  readonly dialpadId: Scalars['BigInt']['output'];
  /** Direction of the call (inbound or outbound) will be our source of truth instead of is_inbound */
  readonly direction?: Maybe<DialpadDirection>;
  /** Duration of the call in seconds */
  readonly duration?: Maybe<Scalars['Int']['output']>;
  /** Type of dialpad event: call_connected, call_missed, or sms_delivered */
  readonly event: Scalars['String']['output'];
  /** Internal system identifier for the dialpad event */
  readonly id: Scalars['ID']['output'];
  /** Indicates whether the call was inbound or outbound */
  readonly isInbound: Scalars['Boolean']['output'];
};

/** A Dialpad SMS message */
export type DialpadSms = {
  readonly __typename?: 'DialpadSms';
  /** Message content. */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** Record created timestamp. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Dialpad message ID. */
  readonly dialpadMessageId: Scalars['BigInt']['output'];
  /** Message direction (inbound/outbound). */
  readonly direction: Scalars['String']['output'];
  /** From phone number (E.164 format). */
  readonly fromNumber: Scalars['String']['output'];
  /** The Savvy ID of the SMS. */
  readonly id: Scalars['ID']['output'];
  /** Whether this is an MMS message. */
  readonly isMms: Scalars['Boolean']['output'];
  /** Message delivery result. */
  readonly messageDeliveryResult?: Maybe<Scalars['String']['output']>;
  /** Message delivery status. */
  readonly messageStatus?: Maybe<Scalars['String']['output']>;
  /** When message was sent. */
  readonly sentAt: Scalars['ISO8601DateTime']['output'];
  /** To phone number (E.164 format). */
  readonly toNumber: Scalars['String']['output'];
};

/** A group of Dialpad SMS messages */
export type DialpadSmsGroup = {
  readonly __typename?: 'DialpadSmsGroup';
  /** When the conversation started. */
  readonly conversationStartedAt: Scalars['ISO8601DateTime']['output'];
  /** Record created timestamp. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the SMS. */
  readonly id: Scalars['ID']['output'];
  /** The messages in the group. */
  readonly messages: ReadonlyArray<DialpadSms>;
};

export type DialpadTranscript = {
  readonly __typename?: 'DialpadTranscript';
  readonly callId: Scalars['String']['output'];
  /** The lines of the call transcript */
  readonly lines?: Maybe<ReadonlyArray<DialpadTranscriptLine>>;
};

/** Transcript line of a Dialpad call. */
export type DialpadTranscriptLine = {
  readonly __typename?: 'DialpadTranscriptLine';
  readonly contactId?: Maybe<Scalars['String']['output']>;
  /** Content of the speech */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** Name of the speaker */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Time of the transcript */
  readonly time?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Type of transcript line: transcript or moment */
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly userId?: Maybe<Scalars['String']['output']>;
};

export type DialpadTranscriptReadResult = {
  readonly __typename?: 'DialpadTranscriptReadResult';
  /** When the associated call started. */
  readonly callStartedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Opaque cursor for the final turn in this page. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When Savvy last persisted this transcript response. */
  readonly fetchedAt: Scalars['ISO8601DateTime']['output'];
  /** Whether another page of stored speech turns exists. */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** Transcript source. Always dialpad for this capability. */
  readonly source: Scalars['String']['output'];
  /** Persisted transcript status: available or unavailable. */
  readonly status: Scalars['String']['output'];
  /** Total stored speech-turn count before paging. */
  readonly totalCount: Scalars['Int']['output'];
  /** Stored speech turns in source order. Dialpad moment rows are excluded. */
  readonly turns: ReadonlyArray<DialpadTranscriptReadTurn>;
};

export type DialpadTranscriptReadTurn = {
  readonly __typename?: 'DialpadTranscriptReadTurn';
  /** Speaker name stored by Dialpad, when available. */
  readonly speaker?: Maybe<Scalars['String']['output']>;
  /** Verbatim text of one stored spoken turn. */
  readonly text: Scalars['String']['output'];
};

/** A digital story/presentation for a Conquest financial plan */
export type DigitalStory = {
  readonly __typename?: 'DigitalStory';
  /** When the story was created */
  readonly createTime: Scalars['ISO8601DateTime']['output'];
  /** The story description */
  readonly description: Scalars['String']['output'];
  /** The Conquest story ID */
  readonly id: Scalars['ID']['output'];
  /** Story metadata (e.g. category) */
  readonly metadata?: Maybe<Scalars['JSON']['output']>;
  /** The story name */
  readonly name: Scalars['String']['output'];
  /** The Conquest plan ID */
  readonly planId: Scalars['Int']['output'];
  /** The story status */
  readonly status: DigitalStoryStatus;
  /** When the story was last updated */
  readonly updateTime: Scalars['ISO8601DateTime']['output'];
  /** The advisor URL for the story in Conquest */
  readonly url: Scalars['String']['output'];
};

/** Status of a Conquest digital story/presentation */
export const DigitalStoryStatus = {
  /** DRAFT */
  Draft: 'DRAFT',
  /** PUBLISHED */
  Published: 'PUBLISHED'
} as const;

export type DigitalStoryStatus = typeof DigitalStoryStatus[keyof typeof DigitalStoryStatus];
/** Detail for the director / 10%+ shareholder disclosure (required when the answer is yes). */
export type DirectorOrShareholderDetailInput = {
  /** Name of the public company */
  readonly companyName: Scalars['String']['input'];
  /** Family member's name (if the affiliation is a household member) */
  readonly familyMemberName?: InputMaybe<Scalars['String']['input']>;
  /** Role/title at the company (e.g. Director, Officer) */
  readonly roleTitle: Scalars['String']['input'];
  /** Ticker symbol of the public company */
  readonly tickerSymbol: Scalars['String']['input'];
};

/** A canonical spoken-language tag from the advisor directory taxonomy. */
export type DirectoryLanguage = {
  readonly __typename?: 'DirectoryLanguage';
  /** Stable identifier. */
  readonly id: Scalars['ID']['output'];
  /** Canonical slug (lower_snake_case). */
  readonly key: Scalars['String']['output'];
  /** Human-readable label. */
  readonly label: Scalars['String']['output'];
};

/** The directory-facing profile fields for an advisor. Whitelisted — never exposes intake_answers or source. */
export type DirectoryProfile = {
  readonly __typename?: 'DirectoryProfile';
  /** Whether the advisor is listed in the directory. False means the advisor deactivated their listing. */
  readonly active: Scalars['Boolean']['output'];
  /** Coarse computed band, e.g. "$50M–$100M". Null unless opted in. */
  readonly aumBand?: Maybe<Scalars['String']['output']>;
  /** Whether the advisor opted to show their AUM band. */
  readonly aumShareOptIn: Scalars['Boolean']['output'];
  /** City. */
  readonly city?: Maybe<Scalars['String']['output']>;
  /** Designations, e.g. ["CFP®", "CLU®"]. */
  readonly credentials: ReadonlyArray<Scalars['String']['output']>;
  /** Canonical spoken-language tags. */
  readonly languages: ReadonlyArray<DirectoryLanguage>;
  /** LinkedIn profile URL (stored only, never fetched server-side). */
  readonly linkedinUrl?: Maybe<Scalars['String']['output']>;
  /** Prior firm. */
  readonly priorFirm?: Maybe<Scalars['String']['output']>;
  /** Canonical specialty tags. */
  readonly specialties: ReadonlyArray<DirectorySpecialty>;
  /** State. */
  readonly state?: Maybe<Scalars['String']['output']>;
  /** Years of experience. */
  readonly yearsExperience?: Maybe<Scalars['Int']['output']>;
};

/** Savvy Intelligence draft: a suggested bio + specialties from intake answers. */
export type DirectoryProfileDraft = {
  readonly __typename?: 'DirectoryProfileDraft';
  /** Drafted bio; null on failure. */
  readonly bio?: Maybe<Scalars['String']['output']>;
  /** Canonical credentials extracted from the intake answers. */
  readonly credentials: ReadonlyArray<Scalars['String']['output']>;
  /** False when generation failed; the FE falls back to manual entry. */
  readonly generated: Scalars['Boolean']['output'];
  /** Suggested canonical specialties. */
  readonly specialties: ReadonlyArray<DirectorySpecialty>;
};

/** A canonical advisor specialty tag from the directory taxonomy. */
export type DirectorySpecialty = {
  readonly __typename?: 'DirectorySpecialty';
  /** Stable identifier. */
  readonly id: Scalars['ID']['output'];
  /** Canonical slug (lower_snake_case). */
  readonly key: Scalars['String']['output'];
  /** Human-readable label. */
  readonly label: Scalars['String']['output'];
};

/** An advisor group / team affiliation surfaced in the directory. */
export type DirectoryTeam = {
  readonly __typename?: 'DirectoryTeam';
  /** The advisor group id. */
  readonly id: Scalars['ID']['output'];
  /** Team display name. */
  readonly name: Scalars['String']['output'];
};

/** Directory-safe subset of an advisor User. No book-level fields. */
export type DirectoryUser = {
  readonly __typename?: 'DirectoryUser';
  /** Contact email. */
  readonly email: Scalars['String']['output'];
  /** First name. */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** Display name (first + last). */
  readonly fullName: Scalars['String']['output'];
  /** The advisor user id. */
  readonly id: Scalars['ID']['output'];
  /** Last name. */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** Contact phone in E.164. */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Photo URL; null falls back to Avatar initials. */
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DiscardServiceCatalogItemGroupChanges */
export type DiscardServiceCatalogItemGroupChangesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DiscardServiceCatalogItemGroupChanges. */
export type DiscardServiceCatalogItemGroupChangesPayload = {
  readonly __typename?: 'DiscardServiceCatalogItemGroupChangesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The service, back on its published version */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
};

/** Autogenerated input type of DismissAllInboxAlerts */
export type DismissAllInboxAlertsInput = {
  /** Optional alert-type filter, matching the inbox query */
  readonly alertTypes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional primary-advisor filter, matching the inbox query */
  readonly primaryAdvisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** The advisor whose inbox is being cleared */
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of DismissAllInboxAlerts. */
export type DismissAllInboxAlertsPayload = {
  readonly __typename?: 'DismissAllInboxAlertsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Number of alerts archived */
  readonly dismissedCount: Scalars['Int']['output'];
  /** IDs of the alerts that were archived */
  readonly dismissedIds: ReadonlyArray<Scalars['ID']['output']>;
};

/** Autogenerated input type of DismissAnnouncement */
export type DismissAnnouncementInput = {
  /** The ID of the announcement config to dismiss */
  readonly announcementConfigId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DismissAnnouncement. */
export type DismissAnnouncementPayload = {
  readonly __typename?: 'DismissAnnouncementPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the announcement was dismissed successfully */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DismissOnboardingHousehold */
export type DismissOnboardingHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The staged household to dismiss. */
  readonly stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of DismissOnboardingHousehold. */
export type DismissOnboardingHouseholdPayload = {
  readonly __typename?: 'DismissOnboardingHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the household was dismissed. */
  readonly success: Scalars['Boolean']['output'];
};

/** Coarse status bucket used by the DocuSign tracker UI to group rows. */
export const DocusignEnvelopeStatusFilter = {
  /** Sent but signer has not opened yet */
  Awaiting: 'AWAITING',
  /** All required signers have signed */
  Completed: 'COMPLETED',
  /** A signer declined to sign */
  Declined: 'DECLINED',
  /** Signer opened the envelope but has not signed yet */
  Opened: 'OPENED',
  /** Envelope was voided by the sender */
  Voided: 'VOIDED'
} as const;

export type DocusignEnvelopeStatusFilter = typeof DocusignEnvelopeStatusFilter[keyof typeof DocusignEnvelopeStatusFilter];
/**
 * DocuSign envelope status. UI renders "delivered" as "Opened" since DocuSign uses
 * "delivered" to mean the signer opened the envelope.
 */
export const DocusignEnvelopeStatusName = {
  /** completed */
  Completed: 'completed',
  /** created */
  Created: 'created',
  /** declined */
  Declined: 'declined',
  /** delivered */
  Delivered: 'delivered',
  /** expired */
  Expired: 'expired',
  /** failed */
  Failed: 'failed',
  /** sent */
  Sent: 'sent',
  /** signed */
  Signed: 'signed',
  /** voided */
  Voided: 'voided'
} as const;

export type DocusignEnvelopeStatusName = typeof DocusignEnvelopeStatusName[keyof typeof DocusignEnvelopeStatusName];
/** A DocuSign recipient with their name and email information. */
export type DocusignRecipient = {
  readonly __typename?: 'DocusignRecipient';
  /** The email address of the recipient. */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** The full name of the recipient. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for this recipient. */
  readonly recipientId?: Maybe<Scalars['String']['output']>;
  /** The role name assigned to this recipient. */
  readonly roleName?: Maybe<Scalars['String']['output']>;
  /** The current status of this recipient. */
  readonly status?: Maybe<Scalars['String']['output']>;
};

/** A DocuSign envelope row in the tracker, with derived status, attention flags, and household/advisor metadata. */
export type DocusignTrackerEnvelope = {
  readonly __typename?: 'DocusignTrackerEnvelope';
  /** Human-readable reason for needs_attention. */
  readonly attentionReason?: Maybe<Scalars['String']['output']>;
  /** Sort key: 0 = none, 1 = opened-not-signed, 2 = sent-not-opened, 3 = declined. */
  readonly attentionSeverity: Scalars['Int']['output'];
  /** Email of the primary client. */
  readonly clientEmail?: Maybe<Scalars['String']['output']>;
  /** Display name of the household. */
  readonly clientName: Scalars['String']['output'];
  /** Latest signer signed_at when status is completed. */
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Custodian copied from the underlying onboarding_task_data row, if present. */
  readonly custodian?: Maybe<Scalars['String']['output']>;
  /** Whole days since the envelope was completed. */
  readonly daysSinceCompleted?: Maybe<Scalars['Int']['output']>;
  /** Whole days since the envelope was last opened (DocuSign "delivered"). */
  readonly daysSinceOpened?: Maybe<Scalars['Int']['output']>;
  /** Whole days since the envelope was sent. */
  readonly daysSinceSent?: Maybe<Scalars['Int']['output']>;
  /** When a signer declined the envelope. */
  readonly declinedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Reason captured on the envelope-declined webhook. */
  readonly declinedReason?: Maybe<Scalars['String']['output']>;
  /** Deep link into DocuSign for the envelope (sandbox URL when environment is dev). */
  readonly docusignEnvelopeUrl: Scalars['String']['output'];
  /** DocuSign envelope ID (also used as the GraphQL row identity). */
  readonly envelopeId: Scalars['String']['output'];
  /** When the envelope expires (from DocuSign expireDateTime). Present only for external envelopes. */
  readonly expireAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the envelope has a co-signer. */
  readonly hasCoClient: Scalars['Boolean']['output'];
  /**
   * Public-facing UUID for the resolved household, suitable for linking to
   * /advisor/dashboard/client/<uuid>. Null when the envelope has no resolved
   * household (e.g. unknown signer email).
   */
  readonly householdUuid?: Maybe<Scalars['String']['output']>;
  /** When a reminder was last sent for this envelope. */
  readonly lastReminderSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** True when the envelope is stalled or declined and warrants advisor follow-up. */
  readonly needsAttention: Scalars['Boolean']['output'];
  /** When the next reminder may be sent (24h after last_reminder_sent_at, or null if not throttled). */
  readonly nextReminderAvailableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Latest time any signer opened the envelope (DocuSign "delivered"). */
  readonly openedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * When the envelope first became "sent" — captured on first sync and never
   * overwritten, so it survives Resend events. Falls back to sent_at on envelopes
   * synced before this column existed.
   */
  readonly originallySentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Display name of the household primary advisor (if assigned). */
  readonly primaryAdvisorName?: Maybe<Scalars['String']['output']>;
  /**
   * True when the resend-reminder mutation is supported for this envelope. False
   * for external envelopes (DocusignExternalEnvelope) where no OnboardingTaskDatum exists.
   */
  readonly resendable: Scalars['Boolean']['output'];
  /**
   * When the envelope was most recently sent. DocuSign overwrites this on every
   * Resend, so it reflects the *last* send not the original — see
   * `originally_sent_at` for the original.
   */
  readonly sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Derived envelope status. UI renders "delivered" as "Opened". */
  readonly status: DocusignEnvelopeStatusName;
  /**
   * The envelope email subject — what DocuSign shows in the signing email (e.g.
   * "Complete with Docusign: Schwab LPOA"). Captured from webhook payloads.
   */
  readonly subject?: Maybe<Scalars['String']['output']>;
  /** When the envelope was voided. */
  readonly voidedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Reason captured on the envelope-voided webhook. */
  readonly voidedReason?: Maybe<Scalars['String']['output']>;
  /**
   * True when the envelope has been Resent at least once since it was first sent.
   * Drives the "Resent" sub-caption in the tracker. Linear: 4C1T-57.
   */
  readonly wasResent: Scalars['Boolean']['output'];
};

/**
 * Audience scope for the DocuSign tracker. MINE = households the current user can
 * read; ORG = all households in the current user organization (requires
 * can_edit_organization).
 */
export const DocusignTrackerScope = {
  /** The current user's households (default) */
  Mine: 'MINE',
  /** Org-wide (requires advisor_profile.can_edit_organization) */
  Org: 'ORG'
} as const;

export type DocusignTrackerScope = typeof DocusignTrackerScope[keyof typeof DocusignTrackerScope];
/** Autogenerated input type of DownloadBoxFileUrl */
export type DownloadBoxFileUrlInput = {
  readonly boxFileId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dimensions?: InputMaybe<Scalars['String']['input']>;
  readonly fileFormat: Scalars['String']['input'];
};

/** Autogenerated return type of DownloadBoxFileUrl. */
export type DownloadBoxFileUrlPayload = {
  readonly __typename?: 'DownloadBoxFileUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly fileName: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

/** Autogenerated input type of DuplicateServiceCatalogItemGroup */
export type DuplicateServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the source group to duplicate */
  readonly id: Scalars['ID']['input'];
  /** Name for the new copy */
  readonly name: Scalars['String']['input'];
};

/** Autogenerated return type of DuplicateServiceCatalogItemGroup. */
export type DuplicateServiceCatalogItemGroupPayload = {
  readonly __typename?: 'DuplicateServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Duplicated service catalog item group */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
};

/** A beneficiary on an ECI account onboarding. */
export type EciAccountBeneficiary = {
  readonly __typename?: 'EciAccountBeneficiary';
  /** Person's date of birth or trust's date */
  readonly dateOfBirthOrTrustDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** primary or contingent */
  readonly designation?: Maybe<Scalars['String']['output']>;
  /** Beneficiary first name */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** person or trust */
  readonly kind?: Maybe<Scalars['String']['output']>;
  /** Beneficiary last name */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** Beneficiary middle name */
  readonly middleName?: Maybe<Scalars['String']['output']>;
  /** Whether this beneficiary designation is per stirpes */
  readonly perStirpes?: Maybe<Scalars['Boolean']['output']>;
  /** Allocation percentage */
  readonly percentage?: Maybe<Scalars['Float']['output']>;
  /** Relationship to the account owner */
  readonly relationship?: Maybe<Scalars['String']['output']>;
  /** Full beneficiary tax ID, for subform prefill */
  readonly taxId?: Maybe<Scalars['String']['output']>;
  /** Trust or entity name, when the beneficiary is a trust/entity */
  readonly trustEntityName?: Maybe<Scalars['String']['output']>;
};

/** Original-depositor information on an inherited ECI account onboarding request. */
export type EciAccountDecedentInformation = {
  readonly __typename?: 'EciAccountDecedentInformation';
  /** Original depositor NFS account number */
  readonly bdaParentAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Citizenship country code */
  readonly citizenshipCountryCode?: Maybe<Scalars['String']['output']>;
  /** Date of birth */
  readonly dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Date of death */
  readonly dateOfDeath?: Maybe<Scalars['ISO8601Date']['output']>;
  /** First name */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** Last name */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** Middle name */
  readonly middleName?: Maybe<Scalars['String']['output']>;
  /** Full tax ID for subform prefill */
  readonly taxId?: Maybe<Scalars['String']['output']>;
};

/** SIMPLE IRA employer information on an ECI account onboarding. */
export type EciAccountEmployerInformation = {
  readonly __typename?: 'EciAccountEmployerInformation';
  /** Employer legal name */
  readonly entityName: Scalars['String']['output'];
  /** Full employer EIN, for subform prefill */
  readonly taxId: Scalars['String']['output'];
};

/** A funding source for an ECI account onboarding. */
export type EciAccountFundingSource = {
  readonly __typename?: 'EciAccountFundingSource';
  /** Source account number for editing the draft */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /** Funding amount, in cents */
  readonly amountCents?: Maybe<Scalars['BigInt']['output']>;
  /** Optional description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Delivering-firm DTC snapshot. */
  readonly firmDtcNumber?: Maybe<Scalars['String']['output']>;
  /** Entered or selected delivering-firm name. */
  readonly firmName?: Maybe<Scalars['String']['output']>;
  /** Linked directory row when its name and DTC agree with the snapshots. */
  readonly selectedCustodianDetail?: Maybe<EciCustodianDetail>;
  /** Funding source type (ach, wire, account_transfer, check, rollover, other) */
  readonly sourceType?: Maybe<Scalars['String']['output']>;
};

/** Whether an ECI account is transferring assets in or only being opened. */
export const EciAccountIntent = {
  /** open_and_transfer */
  OpenAndTransfer: 'open_and_transfer',
  /** open_only */
  OpenOnly: 'open_only'
} as const;

export type EciAccountIntent = typeof EciAccountIntent[keyof typeof EciAccountIntent];
/** A joint owner on an ECI account onboarding. */
export type EciAccountJointOwner = {
  readonly __typename?: 'EciAccountJointOwner';
  /** Joint owner full name */
  readonly fullName?: Maybe<Scalars['String']['output']>;
  /** Ownership percentage for tenants in common */
  readonly ownershipPercentage?: Maybe<Scalars['Float']['output']>;
  /** Relationship to the primary owner (`self` designates the primary owner) */
  readonly relationshipToPrimary?: Maybe<EciOwnerRelationship>;
};

/** An ECI account onboarding request and its sidecars. */
export type EciAccountOnboarding = {
  readonly __typename?: 'EciAccountOnboarding';
  /** Whether the account is transferring assets in or only being opened. An open_only account files no Transfer of Assets. */
  readonly accountIntent: EciAccountIntent;
  /** Full source account number (single source only) */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /** Masked account number (*** + last 3) */
  readonly accountNumberMasked?: Maybe<Scalars['String']['output']>;
  /** Destination-registration stakeholders */
  readonly accountStakeholders: ReadonlyArray<EciAccountOnboardingStakeholder>;
  /** Account type (brokerage or ira) */
  readonly accountType: Scalars['String']['output'];
  /** Inherited IRA beneficiary shape */
  readonly bdaBeneficiaryKind?: Maybe<EciBdaBeneficiaryKind>;
  /** Beneficiaries */
  readonly beneficiaries: ReadonlyArray<EciAccountBeneficiary>;
  /** Persisted Fidelity NFS account status; null before account creation begins */
  readonly custodianAccountStatus?: Maybe<Scalars['String']['output']>;
  /** Inherited IRA original-depositor information */
  readonly decedentInformation?: Maybe<EciAccountDecedentInformation>;
  /** Custodian this account is headed TO. fidelity_nfs (the default) is the ECI pipe. */
  readonly destination: EciDestinationCustodian;
  /** SIMPLE IRA employer information */
  readonly employerInformation?: Maybe<EciAccountEmployerInformation>;
  /** Funding sources */
  readonly fundingSources: ReadonlyArray<EciAccountFundingSource>;
  /** True when the imported account type is an individual transfer-on-death designation. */
  readonly hasTransferOnDeathDesignation: Scalars['Boolean']['output'];
  /** Joint owners */
  readonly jointOwners: ReadonlyArray<EciAccountJointOwner>;
  /** Linked bank standing instructions for this onboarding request */
  readonly linkedBankAccounts: ReadonlyArray<EciLinkedBankAccount>;
  /**
   * Account owner(s): all destination-registration stakeholders (owners, trustees,
   * grantors) deduped and joined, or nil when none are recorded
   */
  readonly ownerName?: Maybe<Scalars['String']['output']>;
  /** Selected account owner user IDs */
  readonly ownerUserIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Pre-generated Fidelity account number, if reserved */
  readonly pregeneratedAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Account purpose required by Schwab / Fidelity-IWS opening envelopes */
  readonly purpose?: Maybe<AccountPurposeName>;
  /** Free-text purpose when purpose is other */
  readonly purposeOther?: Maybe<Scalars['String']['output']>;
  /** Whether enough info exists to transfer this account */
  readonly readinessStatus: EciAccountReadinessStatus;
  /** Recurring transfer and journal standing instructions for this onboarding request */
  readonly recurringTransferInstructions: ReadonlyArray<Scalars['String']['output']>;
  /** Recurring transfers (structured records for subform prefill) */
  readonly recurringTransfers: ReadonlyArray<EciAccountRecurringTransfer>;
  /** Registration type (individual, joint_*, trust_*, traditional, roth, rollover) */
  readonly registrationType: Scalars['String']['output'];
  /** Account request identifier for explicit submission */
  readonly requestId: Scalars['ID']['output'];
  /** Savvy account ID of the source account being transferred */
  readonly sourceAccountId?: Maybe<Scalars['ID']['output']>;
  /** Source account official name (e.g. "Joint Brokerage") */
  readonly sourceAccountName?: Maybe<Scalars['String']['output']>;
  /** Masked name of the source account */
  readonly sourceAccountNameMasked?: Maybe<Scalars['String']['output']>;
  /** Source account type */
  readonly sourceAccountType?: Maybe<Scalars['String']['output']>;
  /** Source accounts that fund this onboarding request */
  readonly sourceAccounts: ReadonlyArray<EciSourceAccount>;
  /** Custodian of the source (transferred-from) account */
  readonly sourceCustodian?: Maybe<Scalars['String']['output']>;
  /** Source account net assets, in cents */
  readonly sourceNetAssetsCents?: Maybe<Scalars['BigInt']['output']>;
  /** Source of funds required by Schwab / Fidelity-IWS opening envelopes */
  readonly sourceOfFunds?: Maybe<SourceOfFundsName>;
  /** Free-text source of funds when source_of_funds is other */
  readonly sourceOfFundsOther?: Maybe<Scalars['String']['output']>;
  /** Standing instructions (full records for subform prefill) */
  readonly standingInstructions: ReadonlyArray<EciAccountStandingInstruction>;
  /** When the account onboarding was started */
  readonly startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the account onboarding was submitted */
  readonly submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** How the account transfers */
  readonly transferType: EciAccountTransferType;
  /** Legal-entity information, if required by the registration */
  readonly trustInformation?: Maybe<EciAccountTrustInformation>;
  /** Account grouping for the subform and panel sort */
  readonly typeGroup: EciAccountTypeGroup;
};

/** A household user with a destination-registration role on an ECI account onboarding request. */
export type EciAccountOnboardingStakeholder = {
  readonly __typename?: 'EciAccountOnboardingStakeholder';
  /** Owner display name captured for the destination registration */
  readonly fullName?: Maybe<Scalars['String']['output']>;
  /** Destination-registration role */
  readonly role: EciAccountStakeholderRole;
  /** Household user assigned this role */
  readonly user: User;
};

/** Whether an ECI account onboarding has enough info to transfer the account. */
export const EciAccountReadinessStatus = {
  /** missing_details */
  MissingDetails: 'missing_details',
  /** ready */
  Ready: 'ready'
} as const;

export type EciAccountReadinessStatus = typeof EciAccountReadinessStatus[keyof typeof EciAccountReadinessStatus];
/**
 * A recurring transfer on an ECI account onboarding, exposed structurally for
 * subform prefill (cf. EciAccountOnboarding.recurringTransferInstructions, which
 * is display text).
 */
export type EciAccountRecurringTransfer = {
  readonly __typename?: 'EciAccountRecurringTransfer';
  /** Transfer amount, in cents */
  readonly amountCents?: Maybe<Scalars['BigInt']['output']>;
  /** Day of month for monthly+ frequencies (1-31) */
  readonly dayOfMonth?: Maybe<Scalars['Int']['output']>;
  /** Day of week for weekly frequency (0=Sunday … 6=Saturday) */
  readonly dayOfWeek?: Maybe<Scalars['Int']['output']>;
  /** Frequency (daily, weekly, monthly, quarterly, semi_annually, annually) */
  readonly frequency?: Maybe<Scalars['String']['output']>;
  /** Source standing instruction id (deposits) */
  readonly fromStandingInstructionId?: Maybe<Scalars['ID']['output']>;
  /** Recurring transfer identifier */
  readonly id: Scalars['ID']['output'];
  /** Transfer kind (deposit, withdrawal, transfer) */
  readonly kind?: Maybe<Scalars['String']['output']>;
  /** Whether this recurring transfer should be carried over to the new account (advisors deselect stale ones) */
  readonly shouldCarryOver: Scalars['Boolean']['output'];
  /** Recurring transfer status */
  readonly status?: Maybe<Scalars['String']['output']>;
  /** Destination standing instruction id (withdrawals) */
  readonly toStandingInstructionId?: Maybe<Scalars['ID']['output']>;
};

/** An account registration currently supported by Fidelity NFS onboarding. */
export type EciAccountRegistrationOption = {
  readonly __typename?: 'EciAccountRegistrationOption';
  /** Account type to open */
  readonly accountType: EciAccountType;
  /** Supported registration */
  readonly registrationType: EciRegistrationType;
};

/** A destination-registration role on an ECI account onboarding request. */
export const EciAccountStakeholderRole = {
  /** estate_fiduciary */
  EstateFiduciary: 'estate_fiduciary',
  /** grantor */
  Grantor: 'grantor',
  /** joint_owner */
  JointOwner: 'joint_owner',
  /** primary_owner */
  PrimaryOwner: 'primary_owner',
  /** trustee */
  Trustee: 'trustee'
} as const;

export type EciAccountStakeholderRole = typeof EciAccountStakeholderRole[keyof typeof EciAccountStakeholderRole];
/**
 * A standing instruction on an ECI account onboarding, with every field needed to
 * prefill the Standing Instructions subform (bank account number masked to the
 * last 4 digits). Unlike EciLinkedBankAccount this is not method-filtered and
 * exposes the full record.
 */
export type EciAccountStandingInstruction = {
  readonly __typename?: 'EciAccountStandingInstruction';
  /** Bank account type (checking or savings), ACH only */
  readonly bankAccountType?: Maybe<Scalars['String']['output']>;
  /** Bank name */
  readonly bankName?: Maybe<Scalars['String']['output']>;
  /** Check memo */
  readonly checkMemo?: Maybe<Scalars['String']['output']>;
  /** For-further-credit account number (wire) */
  readonly ffcAccountNumber?: Maybe<Scalars['String']['output']>;
  /** For-further-credit name (wire) */
  readonly ffcName?: Maybe<Scalars['String']['output']>;
  /** Fidelity standing instruction identifier, if registered */
  readonly fidelityId?: Maybe<Scalars['String']['output']>;
  /** Standing instruction identifier */
  readonly id: Scalars['ID']['output'];
  /** Bank account number, masked to the last 4 digits (never the full value) */
  readonly maskedAccountNumber: Scalars['String']['output'];
  /** Disbursement method (ach, wire, check) */
  readonly methodType?: Maybe<Scalars['String']['output']>;
  /** Party type (first_party or third_party) */
  readonly partyType?: Maybe<Scalars['String']['output']>;
  /** Payee address line 1 */
  readonly payeeAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Payee address line 2 */
  readonly payeeAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Payee city */
  readonly payeeCity?: Maybe<Scalars['String']['output']>;
  /** Payee country (ISO code) */
  readonly payeeCountryCode?: Maybe<Scalars['String']['output']>;
  /** Payee name */
  readonly payeeName?: Maybe<Scalars['String']['output']>;
  /** Payee postal code */
  readonly payeePostalCode?: Maybe<Scalars['String']['output']>;
  /** Payee state */
  readonly payeeState?: Maybe<Scalars['String']['output']>;
  /** Bank routing number (public bank identifier) */
  readonly routingNumber?: Maybe<Scalars['String']['output']>;
  /** Whether this standing instruction should be carried over to the new account (advisors deselect stale ones) */
  readonly shouldCarryOver: Scalars['Boolean']['output'];
  /** Standing instruction status */
  readonly status?: Maybe<Scalars['String']['output']>;
  /** Check stub information */
  readonly stubInformation?: Maybe<Scalars['String']['output']>;
};

/** How an ECI account onboarding request transfers. */
export const EciAccountTransferType = {
  /** consolidate */
  Consolidate: 'consolidate',
  /** transfer_as_is */
  TransferAsIs: 'transfer_as_is'
} as const;

export type EciAccountTransferType = typeof EciAccountTransferType[keyof typeof EciAccountTransferType];
/** Trust legal information on an ECI account onboarding. */
export type EciAccountTrustInformation = {
  readonly __typename?: 'EciAccountTrustInformation';
  /** Trust is an accredited investor */
  readonly accreditedInvestor?: Maybe<Scalars['Boolean']['output']>;
  /** Country the trust was organized in (ISO code) */
  readonly countryOfOrganizationCode?: Maybe<Scalars['String']['output']>;
  /** Trust entity name */
  readonly entityName?: Maybe<Scalars['String']['output']>;
  /** Home address line 1 */
  readonly homeAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Home address line 2 */
  readonly homeAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Home city */
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  /** Home country (ISO code) */
  readonly homeCountryCode?: Maybe<Scalars['String']['output']>;
  /** Home postal code */
  readonly homePostalCode?: Maybe<Scalars['String']['output']>;
  /** Home state */
  readonly homeState?: Maybe<Scalars['String']['output']>;
  /** Mailing address line 1 */
  readonly mailingAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Mailing address line 2 */
  readonly mailingAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Mailing address matches the home address */
  readonly mailingAddressSameAsHome?: Maybe<Scalars['Boolean']['output']>;
  /** Mailing city */
  readonly mailingCity?: Maybe<Scalars['String']['output']>;
  /** Mailing country (ISO code) */
  readonly mailingCountryCode?: Maybe<Scalars['String']['output']>;
  /** Mailing postal code */
  readonly mailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Mailing state */
  readonly mailingState?: Maybe<Scalars['String']['output']>;
  /** Trust is a registered broker-dealer */
  readonly registeredBrokerDealer?: Maybe<Scalars['Boolean']['output']>;
  /** Trust is a registered investment advisor */
  readonly registeredInvestmentAdvisor?: Maybe<Scalars['Boolean']['output']>;
  /** Trust is a registered investment company */
  readonly registeredInvestmentCompany?: Maybe<Scalars['Boolean']['output']>;
  /** Full trust tax ID, for subform prefill */
  readonly taxId?: Maybe<Scalars['String']['output']>;
  /** Tax ID type */
  readonly taxIdType?: Maybe<EciTrustTaxIdType>;
  /** Date the trust was established */
  readonly trustDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Trust revocability */
  readonly trustRevocability?: Maybe<EciTrustRevocability>;
  /** Trust type */
  readonly trustType?: Maybe<EciTrustType>;
};

/** ECI account type. Supported combinations are validated when creating a request. */
export const EciAccountType = {
  /** brokerage */
  Brokerage: 'brokerage',
  /** ira */
  Ira: 'ira'
} as const;

export type EciAccountType = typeof EciAccountType[keyof typeof EciAccountType];
/** Account grouping used to pick the per-type subform and order the accounts panel. */
export const EciAccountTypeGroup = {
  /** individual_brokerage */
  IndividualBrokerage: 'individual_brokerage',
  /** ira */
  Ira: 'ira',
  /** joint_brokerage */
  JointBrokerage: 'joint_brokerage',
  /** other */
  Other: 'other',
  /** trust */
  Trust: 'trust'
} as const;

export type EciAccountTypeGroup = typeof EciAccountTypeGroup[keyof typeof EciAccountTypeGroup];
/** The client's assigned advisor, shown in the custodian-transfer flow. */
export type EciAdvisor = {
  readonly __typename?: 'EciAdvisor';
  /** Advisor email */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** Advisor first name */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** Advisor last name */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** Advisor profile picture URL */
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
};

/** Advisory contract a household signs during onboarding — MSA or IAA */
export const EciAgreement = {
  /** eci_msa */
  EciMsa: 'eci_msa',
  /** iaa */
  Iaa: 'iaa'
} as const;

export type EciAgreement = typeof EciAgreement[keyof typeof EciAgreement];
/** Balances for an ECI account, sourced live from Fidelity. */
export type EciBalances = {
  readonly __typename?: 'EciBalances';
  /** Freshness of the balances (ISO-8601). */
  readonly asOf?: Maybe<Scalars['String']['output']>;
  /** Cash available to withdraw. */
  readonly availableCash?: Maybe<Scalars['Float']['output']>;
  /** Cash buying power. */
  readonly buyingPower?: Maybe<Scalars['Float']['output']>;
  /** Total account value (cash + securities). */
  readonly netWorth?: Maybe<Scalars['Float']['output']>;
  /** Settled cash available to trade. */
  readonly settledCash?: Maybe<Scalars['Float']['output']>;
};

/** Beneficiary or entity shape for an inherited IRA registration. */
export const EciBdaBeneficiaryKind = {
  /** entity */
  Entity: 'entity',
  /** estate_administrator */
  EstateAdministrator: 'estate_administrator',
  /** estate_executor */
  EstateExecutor: 'estate_executor',
  /** estate_personal_representative */
  EstatePersonalRepresentative: 'estate_personal_representative',
  /** non_spouse */
  NonSpouse: 'non_spouse',
  /** spouse */
  Spouse: 'spouse',
  /** trust */
  Trust: 'trust'
} as const;

export type EciBdaBeneficiaryKind = typeof EciBdaBeneficiaryKind[keyof typeof EciBdaBeneficiaryKind];
/** A single beneficiary on an ECI account onboarding request */
export type EciBeneficiaryInput = {
  /** Person's date of birth or trust's date; a beneficiary needs a tax ID or a date of birth / trust date */
  readonly dateOfBirthOrTrustDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** primary or contingent */
  readonly designation: Scalars['String']['input'];
  /** Beneficiary first name */
  readonly firstName: Scalars['String']['input'];
  /** person or trust */
  readonly kind: Scalars['String']['input'];
  /** Beneficiary last name */
  readonly lastName: Scalars['String']['input'];
  /** Beneficiary middle name */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** Whether this designation is per stirpes */
  readonly perStirpes: Scalars['Boolean']['input'];
  /** Allocation percentage (0-100) */
  readonly percentage: Scalars['Float']['input'];
  /** Relationship to the account owner */
  readonly relationship: Scalars['String']['input'];
  /** Beneficiary SSN or TIN; a beneficiary needs a tax ID or a date of birth / trust date */
  readonly taxId?: InputMaybe<Scalars['String']['input']>;
  /** Trust or entity name, when the beneficiary is a trust/entity */
  readonly trustEntityName?: InputMaybe<Scalars['String']['input']>;
};

/** Detail for the US-registered broker-dealer association disclosure (present when the answer is yes). */
export type EciBrokerDealerDisclosureDetail = {
  readonly __typename?: 'EciBrokerDealerDisclosureDetail';
  /** CRD number of the broker-dealer firm */
  readonly firmCrdNumber: Scalars['String']['output'];
  /** Name of the broker-dealer firm */
  readonly firmName: Scalars['String']['output'];
  /** Your role at the firm */
  readonly role: Scalars['String']['output'];
  /** Supervisor's contact (email or phone) */
  readonly supervisorContact: Scalars['String']['output'];
  /** Supervisor's name */
  readonly supervisorName: Scalars['String']['output'];
};

/** ECI client citizenship & tax-status answers (read view). */
export type EciCitizenshipTaxStatus = {
  readonly __typename?: 'EciCitizenshipTaxStatus';
  /** Alien registration number (A-Number / USCIS number) */
  readonly alienId?: Maybe<Scalars['String']['output']>;
  /** Countries of citizenship (ISO-3166-1 alpha-2) */
  readonly citizenshipCodes: ReadonlyArray<Scalars['String']['output']>;
  /** Whether claiming tax treaty benefits */
  readonly claimingTreatyBenefits: Scalars['Boolean']['output'];
  /** Country of tax residence (ISO-3166-1 alpha-2, W-8BEN path) */
  readonly countryOfTaxResidence?: Maybe<Scalars['String']['output']>;
  /** Foreign tax identification number (W-8BEN path) */
  readonly foreignTaxId?: Maybe<Scalars['String']['output']>;
  /** Tax treaty article and paragraph */
  readonly treatyArticleParagraph?: Maybe<Scalars['String']['output']>;
  /** Tax treaty country (ISO-3166-1 alpha-2) */
  readonly treatyCountryCode?: Maybe<Scalars['String']['output']>;
  /** Tax treaty rate of withholding */
  readonly treatyWithholdingRate?: Maybe<Scalars['String']['output']>;
  /** US citizenship status: citizen, permanent_resident, or non_citizen */
  readonly usCitizenshipStatus?: Maybe<Scalars['String']['output']>;
  /** Whether the applicant is a U.S. resident */
  readonly usTaxResident: Scalars['Boolean']['output'];
  /** Whether the W-9 certification was acknowledged */
  readonly w9Certification: Scalars['Boolean']['output'];
};

/**
 * Canonical citizenship & tax status for one owner.
 * Eci::UpdateCitizenshipTaxStatus replaces the whole slice, so send every required
 * field back — not only the edited ones.
 */
export type EciCitizenshipTaxStatusInput = {
  /** Alien registration number (A-Number / USCIS number) for permanent residents and non-citizens */
  readonly alienId?: InputMaybe<Scalars['String']['input']>;
  /** Countries of citizenship (ISO-3166-1 alpha-2) */
  readonly citizenshipCodes: ReadonlyArray<Scalars['String']['input']>;
  /** Whether claiming tax treaty benefits (W-8BEN path) */
  readonly claimingTreatyBenefits: Scalars['Boolean']['input'];
  /** Country of tax residence (ISO-3166-1 alpha-2, W-8BEN path) */
  readonly countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  /** Foreign tax identification number (W-8BEN path) */
  readonly foreignTaxId?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty article and paragraph */
  readonly treatyArticleParagraph?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty country (ISO-3166-1 alpha-2) */
  readonly treatyCountryCode?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty rate of withholding */
  readonly treatyWithholdingRate?: InputMaybe<Scalars['String']['input']>;
  /** US citizenship status: one of citizen, permanent_resident, non_citizen */
  readonly usCitizenshipStatus?: InputMaybe<Scalars['String']['input']>;
  /** Whether the applicant is a U.S. resident */
  readonly usTaxResident: Scalars['Boolean']['input'];
  /** Whether the W-9 certification was acknowledged (U.S. path) */
  readonly w9Certification: Scalars['Boolean']['input'];
};

/** An ECI custodian-transfer client onboarding request and its sidecars, read by the magic-link holder. */
export type EciClientOnboarding = {
  readonly __typename?: 'EciClientOnboarding';
  /**
   * Account onboarding requests this client owns. Scoped to the owner, like the
   * documents: a joint applicant sees the joint accounts, not their spouse's
   * individual ones.
   */
  readonly accountOnboardingRequests: ReadonlyArray<EciAccountOnboarding>;
  /** The household's assigned advisor (null when none is assigned) */
  readonly advisor?: Maybe<EciAdvisor>;
  /** The household's advisory contract (MSA or IAA). Nil column stamps as the MSA default. */
  readonly agreementType: EciAgreement;
  /** Citizenship & tax-status sidecar */
  readonly citizenshipTaxStatus?: Maybe<EciCitizenshipTaxStatus>;
  /** Resume cursor — the furthest step the client has reached. */
  readonly currentStep: EciCurrentStep;
  /** Fidelity customer sequence number (1 or 2) */
  readonly custSeqNbr: Scalars['Int']['output'];
  /**
   * IAA households only: the custodian DocuSign envelopes this client still has to
   * sign after the IAA. Empty until flag-iaa-docusign-custodian-forms is on for the advisor.
   */
  readonly custodianFormsToSign: ReadonlyArray<EciCustodianFormToSign>;
  /** Advisor-composed invite message, echoed on the landing page. Null for requests not sent from the cockpit. */
  readonly emailBody?: Maybe<Scalars['String']['output']>;
  /** Financial profile sidecar */
  readonly financialProfile?: Maybe<EciFinancialProfile>;
  /**
   * Identity fields the client must confirm before proceeding (any of: last_name,
   * ssn, date_of_birth) — only those we hold on file.
   */
  readonly identityVerificationFields: ReadonlyArray<Scalars['String']['output']>;
  /**
   * IAA households only: this client's same-custodian LPOA transfers, the accounts
   * whose LPOA forms they sign. Empty for MSA households.
   */
  readonly lpoaTransfers: ReadonlyArray<EciLpoaTransfer>;
  /** Whether every account in this household request opens without a transfer */
  readonly openOnly: Scalars['Boolean']['output'];
  /** Personal information sidecar */
  readonly personalInformation?: Maybe<EciPersonalInformation>;
  /** Regulatory disclosure sidecar */
  readonly regulatoryDisclosure?: Maybe<EciRegulatoryDisclosure>;
  /** Documents the client must review/sign — the household agreement plus any disclosures and account-opening forms. */
  readonly requiredEciOnboardingDocuments: ReadonlyArray<EciOnboardingDocument>;
  /** Applicant role (primary or joint_owner) */
  readonly role: Scalars['String']['output'];
  /** When the request was submitted (null while in progress) */
  readonly submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether this client declined to provide a trusted contact */
  readonly trustedContactOptedOut?: Maybe<Scalars['Boolean']['output']>;
  /** Trusted contacts supplied by this client */
  readonly trustedContacts: ReadonlyArray<EciTrustedContact>;
};

/** Resume cursor for an ECI client onboarding request — the furthest step the client has reached */
export const EciCurrentStep = {
  /** citizenship */
  Citizenship: 'citizenship',
  /** done */
  Done: 'done',
  /** financial_profile */
  FinancialProfile: 'financial_profile',
  /** personal_information */
  PersonalInformation: 'personal_information',
  /** regulatory_disclosures */
  RegulatoryDisclosures: 'regulatory_disclosures',
  /** signature */
  Signature: 'signature',
  /** trusted_contact */
  TrustedContact: 'trusted_contact'
} as const;

export type EciCurrentStep = typeof EciCurrentStep[keyof typeof EciCurrentStep];
/** A local delivering-custodian directory entry. */
export type EciCustodianDetail = {
  readonly __typename?: 'EciCustodianDetail';
  /** Transfer address. */
  readonly address?: Maybe<Scalars['String']['output']>;
  /** Transfer address city. */
  readonly city?: Maybe<Scalars['String']['output']>;
  /** Canonical delivering-firm name. */
  readonly custodianName?: Maybe<Scalars['String']['output']>;
  /** Delivering-firm DTC number. */
  readonly dtc?: Maybe<Scalars['String']['output']>;
  /** Local directory ID. */
  readonly id: Scalars['ID']['output'];
  /** Transfer address state. */
  readonly state?: Maybe<Scalars['String']['output']>;
  /** Transfer address postal code. */
  readonly zipCode?: Maybe<Scalars['String']['output']>;
};

/** A custodian DocuSign envelope the client still has to sign, after the IAA. */
export type EciCustodianFormToSign = {
  readonly __typename?: 'EciCustodianFormToSign';
  /** The custodian the forms are for, e.g. Fidelity or Charles Schwab */
  readonly custodianName: Scalars['String']['output'];
  /** The DocuSign envelope to open for signing */
  readonly envelopeId: Scalars['String']['output'];
};

/** Original depositor details on an inherited IRA, as consumed by Eci::BuildAccountSetupRequest. */
export type EciDecedentInput = {
  /** Inherited beneficiary or entity shape */
  readonly bdaBeneficiaryKind: EciBdaBeneficiaryKind;
  /** Original depositor's NFS account number */
  readonly bdaParentAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Original depositor citizenship country */
  readonly citizenshipCountryCode: Scalars['String']['input'];
  /** Original depositor date of birth */
  readonly dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Original depositor date of death */
  readonly dateOfDeath?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Original depositor first name */
  readonly firstName: Scalars['String']['input'];
  /** Inherited Traditional or Inherited Roth registration */
  readonly inheritedIraType: EciInheritedIraType;
  /** Original depositor last name */
  readonly lastName: Scalars['String']['input'];
  /** Original depositor middle name */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** Original depositor tax ID */
  readonly taxId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Where an ECI account onboarding request is headed. fidelity_nfs is the ECI pipe;
 * everything else routes through the custodian account-opening paperwork instead.
 */
export const EciDestinationCustodian = {
  /** fidelity_iws */
  FidelityIws: 'fidelity_iws',
  /** fidelity_nfs */
  FidelityNfs: 'fidelity_nfs',
  /** goldman_sachs */
  GoldmanSachs: 'goldman_sachs',
  /** schwab */
  Schwab: 'schwab'
} as const;

export type EciDestinationCustodian = typeof EciDestinationCustodian[keyof typeof EciDestinationCustodian];
/** Detail for the director / 10%+ shareholder disclosure (present when the answer is yes). */
export type EciDirectorOrShareholderDisclosureDetail = {
  readonly __typename?: 'EciDirectorOrShareholderDisclosureDetail';
  /** Name of the public company */
  readonly companyName: Scalars['String']['output'];
  /** Family member's name (present when the affiliation is a household member) */
  readonly familyMemberName?: Maybe<Scalars['String']['output']>;
  /** Role held at the public company */
  readonly roleTitle: Scalars['String']['output'];
  /** Ticker symbol of the public company */
  readonly tickerSymbol: Scalars['String']['output'];
};

/** SIMPLE IRA employer information, as consumed by Eci::BuildAccountSetupRequest. */
export type EciEmployerInput = {
  /** Employer legal name */
  readonly entityName: Scalars['String']['input'];
  /** Employer EIN */
  readonly taxId: Scalars['String']['input'];
};

/** ECI client financial-profile sidecar (read view). */
export type EciFinancialProfile = {
  readonly __typename?: 'EciFinancialProfile';
  /** Annual household income, in cents */
  readonly annualIncomeCents: Scalars['BigInt']['output'];
  /** Investing experience level */
  readonly investingExperience: Scalars['String']['output'];
  /** Investment objective */
  readonly investmentObjective: Scalars['String']['output'];
  /** Liquid net worth, in cents */
  readonly liquidNetWorthCents?: Maybe<Scalars['BigInt']['output']>;
  /** Liquidity needs */
  readonly liquidityNeeds?: Maybe<Scalars['String']['output']>;
  /** Risk tolerance */
  readonly riskTolerance: Scalars['String']['output'];
  /** Investment time horizon */
  readonly timeHorizon: Scalars['String']['output'];
  /** Total net worth, in cents */
  readonly totalNetWorthCents: Scalars['BigInt']['output'];
};

/** Holdings for an ECI account, sourced live from Fidelity. */
export type EciHoldings = {
  readonly __typename?: 'EciHoldings';
  /** Freshness of the holdings (prior-day close under the current entitlement). */
  readonly asOf?: Maybe<Scalars['String']['output']>;
  /** The holdings. */
  readonly positions: ReadonlyArray<FidelityPosition>;
};

/** Inherited Traditional or Inherited Roth registration type. */
export const EciInheritedIraType = {
  /** roth */
  Roth: 'roth',
  /** traditional */
  Traditional: 'traditional'
} as const;

export type EciInheritedIraType = typeof EciInheritedIraType[keyof typeof EciInheritedIraType];
/** Joint account registration type chosen on the owner sub-form (JTWROS, TIC, TBE, or community property). */
export const EciJointAccountType = {
  /** community_property */
  CommunityProperty: 'community_property',
  /** jtwros */
  Jtwros: 'jtwros',
  /** tbe */
  Tbe: 'tbe',
  /** tic */
  Tic: 'tic'
} as const;

export type EciJointAccountType = typeof EciJointAccountType[keyof typeof EciJointAccountType];
/** Joint/TIC ownership details for the request. */
export type EciJointOwnershipInput = {
  /** JTWROS, TIC, TBE, or community property; sets the request registration type */
  readonly jointAccountType: EciJointAccountType;
  /** The complete owner set (exactly two), exactly one primary (`self`) */
  readonly owners: ReadonlyArray<EciOwnerInput>;
};

/** A linked bank account, sourced from the ECI standing-instruction snapshot. */
export type EciLinkedBankAccount = {
  readonly __typename?: 'EciLinkedBankAccount';
  /** Masked bank account number (**** + last 4). */
  readonly accountNumberMasked: Scalars['String']['output'];
  /** Name of the bank. */
  readonly bankName?: Maybe<Scalars['String']['output']>;
};

/**
 * An account that stays with its custodian and moves under the advisor through a
 * same-custodian LPOA. It opens no new account, so it has no account onboarding request.
 */
export type EciLpoaTransfer = {
  readonly __typename?: 'EciLpoaTransfer';
  /** The account name the advisor entered at Account Confirmation */
  readonly accountName?: Maybe<Scalars['String']['output']>;
  /** Last four digits of the account number */
  readonly accountNumberLast4?: Maybe<Scalars['String']['output']>;
  /** The custodian that holds the account, before and after the transfer */
  readonly custodianName?: Maybe<Scalars['String']['output']>;
  /** Account id */
  readonly id: Scalars['ID']['output'];
};

export type EciNewAccountOwner = {
  readonly __typename?: 'EciNewAccountOwner';
  /** Account owner display name */
  readonly fullName: Scalars['String']['output'];
  /** Whether the owner has a matching signed ECI MSA */
  readonly hasSignedMsa: Scalars['Boolean']['output'];
  /** Account owner user ID */
  readonly id: Scalars['ID']['output'];
};

/**
 * A document the ECI onboarding requires — an agreement (MSA), a disclosure, or a
 * per-account asset-transfer form (IRA Application, Transfer of Assets) — with its
 * category, display label, optional account id, and a preview link.
 */
export type EciOnboardingDocument = {
  readonly __typename?: 'EciOnboardingDocument';
  /** Account onboarding request id for per-account forms (null for household-level) */
  readonly accountId?: Maybe<Scalars['ID']['output']>;
  /** agreement | disclosure | account_application | asset_transfer_form */
  readonly category: Scalars['String']['output'];
  /** DocumentTemplate value, e.g. eci_premiere_select_ira_application */
  readonly documentType: Scalars['String']['output'];
  /** Box preview link for reviewing the document (null when unavailable) */
  readonly documentUrl?: Maybe<Scalars['String']['output']>;
  /** Human-readable, mobile-friendly label */
  readonly label: Scalars['String']['output'];
};

/** A single joint/TIC owner: a household member plus their ownership details. */
export type EciOwnerInput = {
  /** User ID of the household member who is an owner */
  readonly householdMemberId: Scalars['ID']['input'];
  /** Ownership percentage (TIC only); must total 100% across owners */
  readonly ownershipPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Relationship to the primary owner; `self` designates the primary owner */
  readonly relationshipToPrimary: EciOwnerRelationship;
};

/** A joint/TIC owner's relationship to the primary owner (`self` designates the primary owner). */
export const EciOwnerRelationship = {
  /** business_partner */
  BusinessPartner: 'business_partner',
  /** child */
  Child: 'child',
  /** domestic_partner */
  DomesticPartner: 'domestic_partner',
  /** other */
  Other: 'other',
  /** parent */
  Parent: 'parent',
  /** self */
  Self: 'self',
  /** sibling */
  Sibling: 'sibling',
  /** spouse */
  Spouse: 'spouse'
} as const;

export type EciOwnerRelationship = typeof EciOwnerRelationship[keyof typeof EciOwnerRelationship];
/** ECI client personal-information sidecar (read view). */
export type EciPersonalInformation = {
  readonly __typename?: 'EciPersonalInformation';
  /** Date of birth */
  readonly dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Email address */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** Employer name */
  readonly employerName?: Maybe<Scalars['String']['output']>;
  /** Employment status */
  readonly employmentStatus?: Maybe<Scalars['String']['output']>;
  /** Home address line 1 */
  readonly homeAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Home address line 2 */
  readonly homeAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Home city */
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  /** Home country code (ISO-3166-1 alpha-2) */
  readonly homeCountryCode?: Maybe<Scalars['String']['output']>;
  /** Home postal code */
  readonly homePostalCode?: Maybe<Scalars['String']['output']>;
  /** Home state */
  readonly homeState?: Maybe<Scalars['String']['output']>;
  /** Whether the client confirmed information accuracy */
  readonly infoAccuracyConfirmed: Scalars['Boolean']['output'];
  /** Job title */
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  /** Legal first name */
  readonly legalFirstName?: Maybe<Scalars['String']['output']>;
  /** Legal last name */
  readonly legalLastName?: Maybe<Scalars['String']['output']>;
  /** Legal middle name */
  readonly legalMiddleName?: Maybe<Scalars['String']['output']>;
  /** Additional legal residence when other than the United States */
  readonly legalResidence?: Maybe<Scalars['String']['output']>;
  /** Mailing address line 1 */
  readonly mailingAddressLine1?: Maybe<Scalars['String']['output']>;
  /** Mailing address line 2 */
  readonly mailingAddressLine2?: Maybe<Scalars['String']['output']>;
  /** Whether the mailing address matches home */
  readonly mailingAddressSameAsHome: Scalars['Boolean']['output'];
  /** Mailing city */
  readonly mailingCity?: Maybe<Scalars['String']['output']>;
  /** Mailing country code (ISO-3166-1 alpha-2) */
  readonly mailingCountryCode?: Maybe<Scalars['String']['output']>;
  /** Mailing postal code */
  readonly mailingPostalCode?: Maybe<Scalars['String']['output']>;
  /** Mailing state */
  readonly mailingState?: Maybe<Scalars['String']['output']>;
  /** Occupation category for custodian opening envelopes */
  readonly occupation?: Maybe<ClientOccupation>;
  /** Phone number (E.164) */
  readonly phone?: Maybe<Scalars['String']['output']>;
  /** Full SSN */
  readonly ssn?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of SSN (masked) */
  readonly ssnLast4?: Maybe<Scalars['String']['output']>;
  /** Name suffix */
  readonly suffix?: Maybe<Scalars['String']['output']>;
};

/**
 * Canonical personal information for one owner. Eci::UpdatePersonalInformation
 * replaces the whole slice, so send every required field back — not only the edited ones.
 */
export type EciPersonalInformationInput = {
  /** Date of birth (ISO 8601) */
  readonly dateOfBirth: Scalars['ISO8601Date']['input'];
  /** Email address */
  readonly email: Scalars['String']['input'];
  /** Employer name (required by model when employment_status is employed or self_employed) */
  readonly employerName?: InputMaybe<Scalars['String']['input']>;
  /** One of: employed, self_employed, student, homemaker, retired, non_employed */
  readonly employmentStatus: Scalars['String']['input'];
  /** Legal first name */
  readonly firstName: Scalars['String']['input'];
  /** Home address */
  readonly homeAddress: StrictAddressInput;
  /** Job title (required by model when employment_status is employed or self_employed) */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Legal last name */
  readonly lastName: Scalars['String']['input'];
  /** Additional legal residence when other than the United States */
  readonly legalResidence?: InputMaybe<Scalars['String']['input']>;
  /** Mailing address; required when mailingAddressSameAsHome is false */
  readonly mailingAddress?: InputMaybe<StrictAddressInput>;
  /** Whether the mailing address is the same as home; when true, home is copied into mailing */
  readonly mailingAddressSameAsHome: Scalars['Boolean']['input'];
  /** Legal middle name */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** Occupation category for custodian opening envelopes */
  readonly occupation: ClientOccupation;
  /** Phone number; accepts formatted US input or E.164. Stored as E.164. */
  readonly phoneNumber: Scalars['String']['input'];
  /** SSN; XXX-XX-XXXX format */
  readonly ssn: Scalars['String']['input'];
  /** Suffix */
  readonly suffix?: InputMaybe<Scalars['String']['input']>;
};

/** ECI registration type. Supported combinations are validated when creating a request. */
export const EciRegistrationType = {
  /** individual */
  Individual: 'individual',
  /** inherited */
  Inherited: 'inherited',
  /** inherited_roth */
  InheritedRoth: 'inherited_roth',
  /** inherited_traditional */
  InheritedTraditional: 'inherited_traditional',
  /** joint_community_property */
  JointCommunityProperty: 'joint_community_property',
  /** joint_tenants_by_entirety */
  JointTenantsByEntirety: 'joint_tenants_by_entirety',
  /** joint_tenants_in_common */
  JointTenantsInCommon: 'joint_tenants_in_common',
  /** joint_tenants_with_rights_of_survivorship */
  JointTenantsWithRightsOfSurvivorship: 'joint_tenants_with_rights_of_survivorship',
  /** rollover */
  Rollover: 'rollover',
  /** roth */
  Roth: 'roth',
  /** sep */
  Sep: 'sep',
  /** simple */
  Simple: 'simple',
  /** tod_individual */
  TodIndividual: 'tod_individual',
  /** tod_joint */
  TodJoint: 'tod_joint',
  /** tod_tenants_by_entirety */
  TodTenantsByEntirety: 'tod_tenants_by_entirety',
  /** traditional */
  Traditional: 'traditional',
  /** trust_under_agreement */
  TrustUnderAgreement: 'trust_under_agreement',
  /** trust_under_will */
  TrustUnderWill: 'trust_under_will'
} as const;

export type EciRegistrationType = typeof EciRegistrationType[keyof typeof EciRegistrationType];
/** ECI client regulatory-disclosure answers (read view). */
export type EciRegulatoryDisclosure = {
  readonly __typename?: 'EciRegulatoryDisclosure';
  /** Is an accredited investor */
  readonly accreditedInvestor: Scalars['Boolean']['output'];
  /** Associated with a US registered broker-dealer */
  readonly brokerDealerAssociated: Scalars['Boolean']['output'];
  /** Detail when broker_dealer_associated is true */
  readonly brokerDealerDetail?: Maybe<EciBrokerDealerDisclosureDetail>;
  /** Self or household member is a director / 10%+ shareholder / executive officer of a public company */
  readonly directorOr10pctShareholder: Scalars['Boolean']['output'];
  /** Detail when director_or_10pct_shareholder is true */
  readonly directorOrShareholderDetail?: Maybe<EciDirectorOrShareholderDisclosureDetail>;
  /** Self or household member is registered with / employed by a FINRA member firm */
  readonly finraMemberFirmAssociated: Scalars['Boolean']['output'];
  /** Associated with a US registered investment advisor */
  readonly registeredInvestmentAdvisorAssociated: Scalars['Boolean']['output'];
  /** Self or immediate family is a senior political figure */
  readonly seniorPoliticalFigure: Scalars['Boolean']['output'];
  /** Detail when senior_political_figure is true */
  readonly seniorPoliticalFigureDetail?: Maybe<EciSeniorPoliticalFigureDisclosureDetail>;
};

/**
 * The editable canonical field set + current values for a remediation subtask.
 * Both the account and TOA resubmit forms read their slice of this shape;
 * remediationType selects the variant.
 */
export type EciRemediationEditableFields = {
  readonly __typename?: 'EciRemediationEditableFields';
  /** The account onboarding request whose canonical data feeds both forms. */
  readonly accountOnboarding: EciAccountOnboarding;
  /** Owners/stakeholders on the request with their canonical PII + citizenship/tax. */
  readonly owners: ReadonlyArray<EciRemediationOwner>;
  /** Which failure branch this subtask remediates; drives the form variant. */
  readonly remediationType: EciRemediationType;
  /**
   * The account_transfer funding source for the TOA form (delivering-firm account
   * number/DTC/firm). Null when the request has no account-transfer source.
   */
  readonly transferFundingSource?: Maybe<EciRemediationFundingSource>;
};

/**
 * The account-transfer funding source for a TOA remediation, carrying the
 * delivering-firm details the TOA resubmit form edits. CSA-only surface —
 * reachable only through the admin/advisor/CSA-gated remediation resolver, never
 * the client MagicLink path.
 */
export type EciRemediationFundingSource = {
  readonly __typename?: 'EciRemediationFundingSource';
  /** Delivering-firm account number (decrypted). */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /** Transfer amount, in cents. */
  readonly amountCents?: Maybe<Scalars['BigInt']['output']>;
  /** DTC number of the delivering firm. */
  readonly firmDtcNumber?: Maybe<Scalars['String']['output']>;
  /** Name of the delivering firm. */
  readonly firmName?: Maybe<Scalars['String']['output']>;
  /** Funding source type (account_transfer for this surface). */
  readonly sourceType?: Maybe<Scalars['String']['output']>;
};

/**
 * An owner/stakeholder on a remediation request, with their canonical PII and
 * citizenship/tax sidecars for resubmit-form prefill.
 */
export type EciRemediationOwner = {
  readonly __typename?: 'EciRemediationOwner';
  /** Canonical citizenship & tax status for this owner; null when not captured. */
  readonly citizenshipTaxStatus?: Maybe<EciCitizenshipTaxStatus>;
  /** Canonical PII for this owner; null when the owner has no linked personal-information record. */
  readonly personalInformation?: Maybe<EciPersonalInformation>;
  /** Destination-registration role (e.g. primary_owner, joint owner, trustee). */
  readonly role: Scalars['String']['output'];
  /** Household user these edits apply to; pass back as ResubmitEciRemediationInput.owners.ownerUserId. */
  readonly userId: Scalars['ID']['output'];
};

/** Edits to one owner on the request. Both slices are optional so a resubmit can carry only the one that changed. */
export type EciRemediationOwnerInput = {
  /** Replacement citizenship & tax status for this owner */
  readonly citizenshipTaxStatus?: InputMaybe<EciCitizenshipTaxStatusInput>;
  /** User ID of the owner/stakeholder these edits apply to */
  readonly ownerUserId: Scalars['ID']['input'];
  /** Replacement personal information for this owner */
  readonly personalInformation?: InputMaybe<EciPersonalInformationInput>;
};

/**
 * Which failure branch a remediation subtask addresses — either a terminal
 * Fidelity response or a request Savvy could not build; drives the resubmit form variant.
 */
export const EciRemediationType = {
  /** account_build_error */
  AccountBuildError: 'account_build_error',
  /** account_setup_error */
  AccountSetupError: 'account_setup_error',
  /** account_validate_error */
  AccountValidateError: 'account_validate_error',
  /** toa_build_error */
  ToaBuildError: 'toa_build_error',
  /** toa_error */
  ToaError: 'toa_error',
  /** toa_nigo */
  ToaNigo: 'toa_nigo'
} as const;

export type EciRemediationType = typeof EciRemediationType[keyof typeof EciRemediationType];
/** Detail for the senior-political-figure disclosure (present when the answer is yes). */
export type EciSeniorPoliticalFigureDisclosureDetail = {
  readonly __typename?: 'EciSeniorPoliticalFigureDisclosureDetail';
  /** ISO-3166-1 alpha-2 country code */
  readonly countryCode: Scalars['String']['output'];
  /** Family member name (optional; only when applicable) */
  readonly familyMemberName?: Maybe<Scalars['String']['output']>;
  /** Office / position held */
  readonly officePosition: Scalars['String']['output'];
  /** Relationship to the senior political figure (self, spouse, parent, child, sibling) */
  readonly relationship?: Maybe<Scalars['String']['output']>;
};

/** A consolidated source account funding an ECI onboarding request, from the eci funding-source snapshot. */
export type EciSourceAccount = {
  readonly __typename?: 'EciSourceAccount';
  /** Masked account number (**** + last 4) */
  readonly accountNumberMasked?: Maybe<Scalars['String']['output']>;
  /** Source account type */
  readonly accountType?: Maybe<Scalars['String']['output']>;
  /** Source account net assets, in cents */
  readonly netAssetsCents?: Maybe<Scalars['BigInt']['output']>;
};

/** Delivering-firm details on the account_transfer funding source, as consumed by Eci::BuildTransferOfAssetsRequest. */
export type EciTransferFundingSourceInput = {
  /** Account number at the delivering firm */
  readonly accountNumber: Scalars['String']['input'];
  /** Expected transfer amount in cents. Omit to preserve the current amount; sending null does not zero it. */
  readonly amountCents?: InputMaybe<Scalars['Int']['input']>;
  /** Delivering firm DTC number. May be blank — the account number is then passed through unformatted. */
  readonly firmDtcNumber?: InputMaybe<Scalars['String']['input']>;
  /** Delivering firm name */
  readonly firmName: Scalars['String']['input'];
};

/**
 * Canonical trust legal information. Eci::SaveTrustDetails replaces the whole
 * slice, so send every required field back — not only the edited ones.
 */
export type EciTrustDetailsInput = {
  /** Whether the entity is an accredited investor */
  readonly accreditedInvestor: Scalars['Boolean']['input'];
  /** ISO country code where the trust was organized */
  readonly countryOfOrganizationCode: Scalars['String']['input'];
  /** Full legal name of the trust entity */
  readonly entityName: Scalars['String']['input'];
  /** Household users acting as grantors */
  readonly grantorUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Trust home address */
  readonly homeAddress: StrictAddressInput;
  /** Mailing address; required when mailingAddressSameAsHome is false */
  readonly mailingAddress?: InputMaybe<StrictAddressInput>;
  /** Whether the mailing address is the same as home; when true, home is copied into mailing */
  readonly mailingAddressSameAsHome: Scalars['Boolean']['input'];
  /** Whether the entity is a registered broker-dealer */
  readonly registeredBrokerDealer: Scalars['Boolean']['input'];
  /** Whether the entity is a registered investment advisor */
  readonly registeredInvestmentAdvisor: Scalars['Boolean']['input'];
  /** Whether the entity is a registered investment company */
  readonly registeredInvestmentCompany: Scalars['Boolean']['input'];
  /** Tax ID number */
  readonly taxId: Scalars['String']['input'];
  /** Tax ID type */
  readonly taxIdType: EciTrustTaxIdType;
  /** Date the trust was established (ISO 8601) */
  readonly trustDate: Scalars['ISO8601Date']['input'];
  /** Trust revocability */
  readonly trustRevocability: EciTrustRevocability;
  /** Trust type */
  readonly trustType: EciTrustType;
  /** Household users acting as trustees */
  readonly trusteeUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** Whether an ECI trust is revocable or irrevocable. */
export const EciTrustRevocability = {
  /** irrevocable */
  Irrevocable: 'irrevocable',
  /** revocable */
  Revocable: 'revocable'
} as const;

export type EciTrustRevocability = typeof EciTrustRevocability[keyof typeof EciTrustRevocability];
/** Tax ID type for an ECI trust account. */
export const EciTrustTaxIdType = {
  /** ein */
  Ein: 'ein',
  /** ssn */
  Ssn: 'ssn'
} as const;

export type EciTrustTaxIdType = typeof EciTrustTaxIdType[keyof typeof EciTrustTaxIdType];
/** Legal basis under which an ECI trust was created. */
export const EciTrustType = {
  /** under_agreement */
  UnderAgreement: 'under_agreement',
  /** under_will */
  UnderWill: 'under_will'
} as const;

export type EciTrustType = typeof EciTrustType[keyof typeof EciTrustType];
/** A trusted contact supplied by an ECI client. */
export type EciTrustedContact = {
  readonly __typename?: 'EciTrustedContact';
  /** Trusted contact address line 1 */
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  /** Trusted contact address line 2 */
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  /** Trusted contact city */
  readonly city?: Maybe<Scalars['String']['output']>;
  /** Trusted contact country code */
  readonly countryCode?: Maybe<Scalars['String']['output']>;
  /** Trusted contact date of birth, held as evidence for the FINRA 4512 age requirement. Not sent to Fidelity. */
  readonly dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Trusted contact email address */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** Trusted contact first name */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** Trusted contact last name */
  readonly lastName: Scalars['String']['output'];
  /** Trusted contact middle name */
  readonly middleName?: Maybe<Scalars['String']['output']>;
  /** Trusted contact primary phone number in E.164 format */
  readonly phone?: Maybe<Scalars['String']['output']>;
  /** Trusted contact postal code */
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  /** Fidelity relationship code describing the contact's relationship to the holder */
  readonly relationshipToHolder?: Maybe<EciTrustedContactRelationship>;
  /** Trusted contact secondary phone number in E.164 format */
  readonly secondaryPhone?: Maybe<Scalars['String']['output']>;
  /** Trusted contact state or province */
  readonly state?: Maybe<Scalars['String']['output']>;
  /** Whether this is the primary or secondary trusted contact */
  readonly tcpType: Scalars['String']['output'];
};

/** Optional address fields for an ECI trusted contact */
export type EciTrustedContactAddressInput = {
  /** Address line 1 */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** Country code */
  readonly country?: InputMaybe<Scalars['String']['input']>;
  /** State or province */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** Postal code */
  readonly zip?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One account holder in a household ECI onboarding, with the trusted contacts
 * recorded for them. The advisor-facing counterpart to
 * EciClientOnboarding.trustedContacts, which only the magic-link holder can read.
 * FINRA 4512 asks per holder, so a joint household has two of these.
 */
export type EciTrustedContactHolder = {
  readonly __typename?: 'EciTrustedContactHolder';
  /** Fidelity customer sequence number (1 or 2) */
  readonly custSeqNbr: Scalars['Int']['output'];
  /** False once the holder has submitted their onboarding — the underlying save refuses after that point. */
  readonly editable: Scalars['Boolean']['output'];
  /**
   * The holder's name, for labelling their section of the form. Null when neither
   * the linked user nor the personal-information sidecar carries a name yet.
   */
  readonly fullName?: Maybe<Scalars['String']['output']>;
  /** Client onboarding request id. Pass back as SaveEciTrustedContactsForHolderInput.eciClientOnboardingRequestId. */
  readonly id: Scalars['ID']['output'];
  /** Applicant role (primary or joint_owner) */
  readonly role: Scalars['String']['output'];
  /** Whether this holder declined to name a trusted contact. Null before the question has been answered. */
  readonly trustedContactOptedOut?: Maybe<Scalars['Boolean']['output']>;
  /** Trusted contacts recorded for this holder, primary first. Empty when none have been captured. */
  readonly trustedContacts: ReadonlyArray<EciTrustedContact>;
};

/** A trusted contact supplied by an ECI client */
export type EciTrustedContactInput = {
  /** Optional trusted contact address */
  readonly address?: InputMaybe<EciTrustedContactAddressInput>;
  /** Trusted contact date of birth; must be at least 18 years ago */
  readonly dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Trusted contact email address */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact first name */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact last name */
  readonly lastName: Scalars['String']['input'];
  /** Trusted contact middle name */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact primary phone number in E.164 format */
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  /** Fidelity relationship code describing the contact's relationship to the holder */
  readonly relationshipToHolder?: InputMaybe<EciTrustedContactRelationship>;
  /** Trusted contact secondary phone number in E.164 format */
  readonly secondaryPhone?: InputMaybe<Scalars['String']['input']>;
};

/** A trusted contact's relationship to the account holder, using Fidelity's relationship code */
export const EciTrustedContactRelationship = {
  /** AUUN */
  Auun: 'AUUN',
  /** BROT */
  Brot: 'BROT',
  /** DAUT */
  Daut: 'DAUT',
  /** FRND */
  Frnd: 'FRND',
  /** FTHR */
  Fthr: 'FTHR',
  /** GRDD */
  Grdd: 'GRDD',
  /** GRDF */
  Grdf: 'GRDF',
  /** GRDM */
  Grdm: 'GRDM',
  /** GRDS */
  Grds: 'GRDS',
  /** MTHR */
  Mthr: 'MTHR',
  /** NENI */
  Neni: 'NENI',
  /** NHBR */
  Nhbr: 'NHBR',
  /** OTHR */
  Othr: 'OTHR',
  /** SON */
  Son: 'SON',
  /** SPS */
  Sps: 'SPS',
  /** SSTR */
  Sstr: 'SSTR'
} as const;

export type EciTrustedContactRelationship = typeof EciTrustedContactRelationship[keyof typeof EciTrustedContactRelationship];
export const EditCenterOfInfluenceRepError = {
  EmailAlreadyExists: 'email_already_exists',
  NotFound: 'not_found',
  ValidationError: 'validation_error'
} as const;

export type EditCenterOfInfluenceRepError = typeof EditCenterOfInfluenceRepError[keyof typeof EditCenterOfInfluenceRepError];
/** Autogenerated input type of EditCenterOfInfluenceRep */
export type EditCenterOfInfluenceRepInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The company this rep works for */
  readonly companyId?: InputMaybe<Scalars['ID']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  /** Free-text fee or rate this contact charges, e.g. "$250/hr" or "1% AUM". */
  readonly feeRate?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly ownerAdvisorProfileId?: InputMaybe<Scalars['Int']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly photoUrl?: InputMaybe<Scalars['String']['input']>;
  readonly preferredContactMethod?: InputMaybe<CenterOfInfluenceRepPreferredContactMethod>;
  readonly secondaryEmail?: InputMaybe<Scalars['String']['input']>;
  readonly secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly specialties?: InputMaybe<ReadonlyArray<CenterOfInfluenceRepSpecialty>>;
  /** Two-letter US state code. Ignored on a legacy professional contact not yet moved to contacts. */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /**
   * The contact's own website, independent of its company's. Ignored on a legacy
   * professional contact not yet moved to contacts.
   */
  readonly website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditCenterOfInfluenceRep. */
export type EditCenterOfInfluenceRepPayload = {
  readonly __typename?: 'EditCenterOfInfluenceRepPayload';
  readonly centerOfInfluenceRep?: Maybe<CenterOfInfluenceRep>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly softError?: Maybe<EditCenterOfInfluenceRepError>;
};

/** Errors for editing a company */
export const EditCompanyError = {
  /** name_already_exists */
  NameAlreadyExists: 'name_already_exists',
  /** not_found */
  NotFound: 'not_found',
  /** validation_error */
  ValidationError: 'validation_error'
} as const;

export type EditCompanyError = typeof EditCompanyError[keyof typeof EditCompanyError];
/** Autogenerated input type of EditCompany */
export type EditCompanyInput = {
  /** The first line of the company address */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** The second line of the company address */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The city of the company address */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The country code of the company address */
  readonly countryCode?: InputMaybe<Scalars['String']['input']>;
  /** The description of the company */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the company to edit */
  readonly id: Scalars['ID']['input'];
  /** The URL of the company's logo */
  readonly logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** The name of the company */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the company */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The postal code of the company address */
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  /** The state of the company address */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** The website of the company */
  readonly website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditCompany. */
export type EditCompanyPayload = {
  readonly __typename?: 'EditCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The edited company */
  readonly company?: Maybe<Company>;
  /** Error encountered during edit */
  readonly softError?: Maybe<EditCompanyError>;
};

/** An announcement as the CMS editor sees it, with its lifecycle */
export type EditorAnnouncement = {
  readonly __typename?: 'EditorAnnouncement';
  /** The announcement name */
  readonly announcementName: Scalars['String']['output'];
  /** When it was archived */
  readonly archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Which users the announcement targets */
  readonly audience: AnnouncementAudience;
  /** Modal badge */
  readonly badge?: Maybe<Scalars['String']['output']>;
  /** Registered code component for bespoke announcements */
  readonly bespokeKey?: Maybe<Scalars['String']['output']>;
  /** Modal body copy */
  readonly body?: Maybe<Scalars['String']['output']>;
  /** Who created it */
  readonly createdByName?: Maybe<Scalars['String']['output']>;
  /** Optional call-to-action button label */
  readonly ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Call-to-action link target, as a same-site path or https URL */
  readonly ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Why it ended early */
  readonly endReason?: Maybe<AnnouncementEndReason>;
  /** When it actually ended */
  readonly endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When it was ended before its scheduled end */
  readonly endedEarlyAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the announcement ends; null for no end */
  readonly expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Banner header. Null for announcements whose copy lives in the client */
  readonly header?: Maybe<Scalars['String']['output']>;
  /** The announcement config ID */
  readonly id: Scalars['ID']['output'];
  /** Alt text for the image; empty when decorative */
  readonly imageAlt?: Maybe<Scalars['String']['output']>;
  /** Optional banner image, as a same-site path or https URL */
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the announcement is a banner or a modal */
  readonly kind: AnnouncementKind;
  /** Optimistic-lock version to send back on update */
  readonly lockVersion: Scalars['Int']['output'];
  /** When it was first published */
  readonly publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The banner that replaced it */
  readonly replacedBy?: Maybe<EditorAnnouncement>;
  /** When the announcement goes live */
  readonly startsAt: Scalars['ISO8601DateTime']['output'];
  /** Derived lifecycle status */
  readonly status: AnnouncementStatus;
  /** Banner subheader */
  readonly subheader?: Maybe<Scalars['String']['output']>;
  /** Layout that renders the announcement. Null for legacy rows rendered by name */
  readonly template?: Maybe<AnnouncementTemplate>;
  /** When it actually went live */
  readonly wentLiveAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ElementImpression = {
  /** The name of the element that was viewed - e.g. "create_task_modal" */
  readonly elementName: Scalars['String']['input'];
  /** The type of element that was viewed - e.g. "drawer" or "dialog" */
  readonly elementType: Scalars['String']['input'];
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export type ElementViewDuration = {
  /** The duration of the element view in milliseconds */
  readonly duration: Scalars['Int']['input'];
  /** The name of the item that was clicked or touched - e.g. "create_prospect_button" */
  readonly elementName: Scalars['String']['input'];
  /** The type of element that was viewed - e.g. "drawer" or "dialog" */
  readonly elementType: Scalars['String']['input'];
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export const Email = {
  Confirmation: 'confirmation',
  CreatePassword: 'create_password',
  ResetPassword: 'reset_password'
} as const;

export type Email = typeof Email[keyof typeof Email];
/** Name of the custodian */
export const EmailDirection = {
  /** inbound */
  Inbound: 'inbound',
  /** outbound */
  Outbound: 'outbound'
} as const;

export type EmailDirection = typeof EmailDirection[keyof typeof EmailDirection];
/** An email message associated with a household */
export type EmailMessage = {
  readonly __typename?: 'EmailMessage';
  /** The direction of the email message (incoming or outgoing). */
  readonly direction: EmailDirection;
  /** Earlier messages in the same thread (newest first), scoped to the in-context household or contact. */
  readonly earlierThreadMessages: ReadonlyArray<EmailMessage>;
  /** The HTML body of the email message. */
  readonly htmlBody?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the email message. */
  readonly id: Scalars['ID']['output'];
  /** The timestamp when the email was sent. */
  readonly internalDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The mailbox this email message belongs to. */
  readonly mailbox?: Maybe<Mailbox>;
  /** The original email addresses associated with the email message. */
  readonly originalEmailAddresses?: Maybe<OriginalEmailAddresses>;
  /** The plain text body of the email message. */
  readonly plainTextBody?: Maybe<Scalars['String']['output']>;
  /** A snippet of the email message content. */
  readonly snippet?: Maybe<Scalars['String']['output']>;
  /** The subject of the email message. */
  readonly subject?: Maybe<Scalars['String']['output']>;
  /** Number of earlier messages in the same thread, scoped to the in-context household or contact. */
  readonly threadMessageCount: Scalars['Int']['output'];
};

/** A rendered email preview: the inlined HTML body plus the sender and subject. */
export type EmailPreview = {
  readonly __typename?: 'EmailPreview';
  /** Server-rendered, inlined HTML body for the preview iframe. */
  readonly body: Scalars['String']['output'];
  /** CC recipients the send path adds to the message, in header order. Empty when the email copies nobody. */
  readonly ccRecipients: ReadonlyArray<EmailPreviewRecipient>;
  /** Sender as it appears in the inbox (display name, or address when unnamed). */
  readonly from: Scalars['String']['output'];
  /**
   * Reply-To address the client would reply to. Null when the email carries none,
   * or when it would only repeat the From address.
   */
  readonly replyTo?: Maybe<Scalars['String']['output']>;
  /** Email subject line. */
  readonly subject: Scalars['String']['output'];
};

/** A CC recipient carried on the previewed email. */
export type EmailPreviewRecipient = {
  readonly __typename?: 'EmailPreviewRecipient';
  /** Recipient email address. */
  readonly email: Scalars['String']['output'];
  /** Recipient display name; null when the address carries none. */
  readonly name?: Maybe<Scalars['String']['output']>;
};

/** Rendered preview of a Service Calendar v2 catalog email template */
export type EmailTemplatePreview = {
  readonly __typename?: 'EmailTemplatePreview';
  /** Configured template CC users added to every send; empty when none is configured (inactive users are dropped). */
  readonly ccRecipients: ReadonlyArray<EmailTemplatePreviewRecipient>;
  /**
   * From-line email: the sender's DBA email when Mailgun can DKIM-sign its domain,
   * else the organization's own verified sending address, else
   * "client-service@savvywealth.com".
   */
  readonly fromEmail: Scalars['String']['output'];
  /**
   * From-line display name: the full name of the sender — the configured template
   * sender when one is set and active, else the advisor the preview is branded from.
   */
  readonly fromName: Scalars['String']['output'];
  /**
   * Full MJML-rendered HTML body of the email. Always rendered; valid merge tags
   * are substituted and any unknown token is left verbatim.
   */
  readonly html: Scalars['String']['output'];
  /** Non-blocking warning naming any unknown {placeholder} token(s); null when all tags are valid. The preview always renders. */
  readonly placeholderError?: Maybe<Scalars['String']['output']>;
  /** Reply-To address: the sender's DBA email, else their login address. Null when it would repeat the From address. */
  readonly replyTo?: Maybe<Scalars['String']['output']>;
  /** Subject after merge-field substitution; unknown tokens are left verbatim. */
  readonly subject: Scalars['String']['output'];
};

/** A CC recipient the Service Calendar v2 send path adds to every message */
export type EmailTemplatePreviewRecipient = {
  readonly __typename?: 'EmailTemplatePreviewRecipient';
  /** The recipient's email address. */
  readonly email: Scalars['String']['output'];
  /** The recipient's display name. */
  readonly name: Scalars['String']['output'];
};

/** A household-scoped email semantic-search hit, reported from the thread's latest household-visible message. */
export type EmailThreadSemanticSearchHit = {
  readonly __typename?: 'EmailThreadSemanticSearchHit';
  /** CC email address(es) of that message. */
  readonly cc: ReadonlyArray<Scalars['String']['output']>;
  /** Whether that message was inbound (received) or outbound (sent). */
  readonly direction: EmailDirection;
  /** Sender email address(es) of that message. */
  readonly from: ReadonlyArray<Scalars['String']['output']>;
  /** Latest household-visible EmailMessage id for the matched thread (fetch handle). */
  readonly id: Scalars['ID']['output'];
  /** internalDate of that message. */
  readonly internalDate: Scalars['ISO8601DateTime']['output'];
  /**
   * Cosine similarity to the query (higher = closer match); the query-time re-rank
   * similarity when re-rank runs, else the nearest-neighbor similarity.
   */
  readonly score: Scalars['Float']['output'];
  /** Snippet of that message. */
  readonly snippet?: Maybe<Scalars['String']['output']>;
  /** Subject of that message. */
  readonly subject?: Maybe<Scalars['String']['output']>;
  /** Recipient (To) email address(es) of that message. */
  readonly to: ReadonlyArray<Scalars['String']['output']>;
};

export const EmploymentStatusName = {
  Employed: 'employed',
  Homemaker: 'homemaker',
  NonEmployed: 'non_employed',
  Retired: 'retired',
  SelfEmployed: 'self_employed',
  Student: 'student'
} as const;

export type EmploymentStatusName = typeof EmploymentStatusName[keyof typeof EmploymentStatusName];
/** Autogenerated input type of EndSurveyRound */
export type EndSurveyRoundInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The survey round */
  readonly roundId: Scalars['ID']['input'];
};

/** Autogenerated return type of EndSurveyRound. */
export type EndSurveyRoundPayload = {
  readonly __typename?: 'EndSurveyRoundPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ended round */
  readonly surveyRound: SurveyRoundReport;
};

/** Autogenerated input type of EnrollAdvisorVoice */
export type EnrollAdvisorVoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Base64-encoded .m4a of 2-10 seconds of the advisor speaking */
  readonly clipBase64: Scalars['String']['input'];
  /** Clip length in milliseconds; must be 2000-10000 */
  readonly durationMs: Scalars['Int']['input'];
  /** Version of the disclosure the advisor accepted; must be current */
  readonly policyVersion: Scalars['String']['input'];
};

/** Autogenerated return type of EnrollAdvisorVoice. */
export type EnrollAdvisorVoicePayload = {
  readonly __typename?: 'EnrollAdvisorVoicePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the clip was stored */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of EnrollHouseholdsInServiceCatalogItemGroup */
export type EnrollHouseholdsInServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Households to enroll: at least one, at most 25 per call. Duplicates are
   * collapsed; every id must exist and be reachable, or the whole call is refused.
   * At most 200 enrollments (households x the service's active items), so past 8
   * items it is the enrollment cap that binds, not the household one
   */
  readonly householdIds: ReadonlyArray<Scalars['ID']['input']>;
  /** The service (template) to enroll into */
  readonly serviceCatalogItemGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnrollHouseholdsInServiceCatalogItemGroup. */
export type EnrollHouseholdsInServiceCatalogItemGroupPayload = {
  readonly __typename?: 'EnrollHouseholdsInServiceCatalogItemGroupPayload';
  /**
   * Households refused because they are already enrolled in a *different* service;
   * nothing changed for them. Distinct from `skippedHouseholdCount`, which counts
   * households already on this one
   */
  readonly blockedHouseholdCount: Scalars['Int']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Households newly enrolled on at least one item */
  readonly enrolledHouseholdCount: Scalars['Int']['output'];
  /** Households whose enrollment attempt rolled back; the enrollments they already had are unchanged */
  readonly failedHouseholdCount: Scalars['Int']['output'];
  /** Per-household outcome, in the order the households were given */
  readonly results: ReadonlyArray<ServiceCatalogEnrollmentResult>;
  /** Households already enrolled on every item of **this** service; nothing changed for them */
  readonly skippedHouseholdCount: Scalars['Int']['output'];
};

/**
 * A household enrolled in a service, as the service editor's enrolled-households
 * dialog renders it. Scalars rather than Models::Household: a service shared
 * across an advisor group can enroll a household whose read policy denies this
 * viewer, and a denied object raises rather than nulling the field, which would
 * fail the whole editor query
 */
export type EnrolledHousehold = {
  readonly __typename?: 'EnrolledHousehold';
  /**
   * Whether at least one of the household's enrollments names this service on its
   * foreign key. False when every one is listed only because this is its item's
   * sole live service, which the household's service detail page does not read
   */
  readonly attributedToService: Scalars['Boolean']['output'];
  /** The enrolled household */
  readonly householdId: Scalars['ID']['output'];
  /** The household's public id, which household routes take; null when the household has neither a Salesforce id nor a uuid */
  readonly householdPublicId?: Maybe<Scalars['String']['output']>;
  /** The household's display name, which the dialog lists and searches */
  readonly name: Scalars['String']['output'];
  /** Months this household's dates on the service are pushed out by; 0 is on time */
  readonly offsetMonths: Scalars['Int']['output'];
};

/** An item in the activity timeline */
export type Entries = {
  readonly __typename?: 'Entries';
  /** Whether entries exist newer than this page. Null unless newerThan was supplied. */
  readonly hasMoreNewer?: Maybe<Scalars['Boolean']['output']>;
  /** Whether entries exist older than this page. Null unless olderThan was supplied. */
  readonly hasMoreOlder?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if there is a next page. Describes offset paging only — read hasMoreOlder/hasMoreNewer for a positioned page. */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /**
   * Indicates if there is a previous page. Describes offset paging only — read
   * hasMoreOlder/hasMoreNewer for a positioned page.
   */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** List of activity timeline entries */
  readonly nodes: ReadonlyArray<Entry>;
  /** Current page number */
  readonly page: Scalars['Int']['output'];
  /** Number of entries per page */
  readonly perPage: Scalars['Int']['output'];
  /** Total number of activity timeline entries */
  readonly totalCount: Scalars['Int']['output'];
  /**
   * Total number of pages. Describes offset paging only; meaningless for a
   * positioned page, which is always page 1 of the whole set.
   */
  readonly totalPages: Scalars['Int']['output'];
  /** How far ahead, in days, calendar events surface in the Upcoming section */
  readonly upcomingEventHorizonDays: Scalars['Int']['output'];
};

/** An item in the activity timeline */
export type Entry = {
  readonly __typename?: 'Entry';
  /** Unique identifier for the activity timeline item */
  readonly id: Scalars['ID']['output'];
  /** Whether the entry is pinned to the top of this household timeline */
  readonly isPinned: Scalars['Boolean']['output'];
  /** Polymorphic payload */
  readonly item: ItemTypeUnion;
  /** Contacts and beneficiaries this item has been surfaced on */
  readonly linkedContacts: ReadonlyArray<ActivityTimelineContactLink>;
  /** The service occurrence this interaction has been recorded as satisfying, if any */
  readonly linkedServiceOccurrence?: Maybe<ActivityTimelineServiceOccurrenceLink>;
  /** Timestamp when the activity occurred */
  readonly occurredAt: Scalars['ISO8601DateTime']['output'];
  /** Type of activity timeline item */
  readonly type: ItemTypeEnum;
};

/** An exact position in the activity timeline, taken from an entry the caller already holds. */
export type EntryPositionInput = {
  /** ID of the entry at this position. */
  readonly id: Scalars['ID']['input'];
  /**
   * occurredAt of the entry at this position. Only consulted if that entry has
   * since been deleted: ISO8601DateTime serializes at second precision, so a
   * round-tripped value cannot be compared against stored microseconds and the
   * resolver reads the real sort key by id instead.
   */
  readonly occurredAt: Scalars['ISO8601DateTime']['input'];
};

/** One account row in the "Accounts Included in this Report" header section of the Estimated Cash Flow report. */
export type EstimatedCashFlowAccount = {
  readonly __typename?: 'EstimatedCashFlowAccount';
  /** Savvy account ID. */
  readonly accountId: Scalars['ID']['output'];
  /** Display name of the account (Account#display_name). */
  readonly accountName: Scalars['String']['output'];
  /** Last digits of the account number, or full number when no mask is stored. */
  readonly accountNumberMasked?: Maybe<Scalars['String']['output']>;
  /** Humanized account subtype (e.g. "Roth IRA"); falls back to coarse type_of. */
  readonly accountType?: Maybe<Scalars['String']['output']>;
  /** Custodian / firm name when known. */
  readonly custodian?: Maybe<Scalars['String']['output']>;
  /** Stable identifier for the row. */
  readonly id: Scalars['ID']['output'];
  /** Humanized custody label (e.g. "Managed Account", "Held Away"). */
  readonly managementStrategy?: Maybe<Scalars['String']['output']>;
  /** Sum of the account's active holdings' institution_value as of the report's end_date. */
  readonly marketValue: HoldingsSummaryMoney;
};

/**
 * Native Estimated Cash Flow report (HAWK-34) — replaces the Orion-generated
 * Estimated Income PDF. Aggregates the household’s active holdings by asset class
 * and projects an annualized income figure from the trailing 12 months of dividend
 * / interest / income transactions in Postgres.
 */
export type EstimatedCashFlowReport = {
  readonly __typename?: 'EstimatedCashFlowReport';
  /** "Accounts Included in this Report" — every scoped account with its current market value. */
  readonly accounts: ReadonlyArray<EstimatedCashFlowAccount>;
  /** Period end date; doubles as the snapshot date for the holdings rollup. */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Stable identifier for this report scope (household or account selection + period). */
  readonly id: Scalars['ID']['output'];
  /** Inclusive number of days between start_date and end_date. */
  readonly periodDays: Scalars['Int']['output'];
  /** One row per asset class with active holdings. */
  readonly rows: ReadonlyArray<EstimatedCashFlowRow>;
  /** Display-only period start date supplied by the caller. */
  readonly startDate: Scalars['ISO8601Date']['output'];
  /** Sum of cost_basis across rows; amount is null if any row lacks cost basis. */
  readonly totalCostBasis: HoldingsSummaryMoney;
  /**
   * Portfolio-weighted current yield: total_estimated_annual_income /
   * total_market_value. Null when total_market_value is zero.
   */
  readonly totalCurrentYield?: Maybe<Scalars['BigDecimal']['output']>;
  /** Sum of estimated_annual_income across rows. */
  readonly totalEstimatedAnnualIncome: HoldingsSummaryMoney;
  /** Sum of market_value across rows. */
  readonly totalMarketValue: HoldingsSummaryMoney;
};

/** A single asset-class row in the native Estimated Cash Flow report. */
export type EstimatedCashFlowRow = {
  readonly __typename?: 'EstimatedCashFlowRow';
  /** Asset class label from Security#type_of (e.g. 'equity', 'fixed_income', 'cash'). */
  readonly assetClass: Scalars['String']['output'];
  /** Sum of cost_basis across holdings in this class; amount is null if any holding lacks cost basis. */
  readonly costBasis: HoldingsSummaryMoney;
  /** ISO currency code for the row. */
  readonly currencyCode: Scalars['String']['output'];
  /** estimated_annual_income / market_value as a decimal (e.g. 0.0122 for 1.22%). Null when market_value is zero. */
  readonly currentYield?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * Trailing-12-month sum of dividend / interest / income transactions for
   * holdings in this class, taken as the annualized estimate.
   */
  readonly estimatedAnnualIncome: HoldingsSummaryMoney;
  /** Stable identifier for the row (asset class label). */
  readonly id: Scalars['ID']['output'];
  /** Sum of institution_value across holdings in this class. */
  readonly marketValue: HoldingsSummaryMoney;
};

/** One asset-class row of the 'Estimated Income' table — cost basis, market value, estimated annual income, and current yield. */
export type EstimatedIncomeRow = {
  readonly __typename?: 'EstimatedIncomeRow';
  /** Asset class display name (e.g. "US Equity", "International Developed", "Cash"). */
  readonly assetClass: Scalars['String']['output'];
  /** Aggregate cost basis for the asset class; amount is null when any holding lacks cost basis. */
  readonly costBasis: HoldingsSummaryMoney;
  /**
   * Yield = estimated_annual_income / market_value, expressed as a fraction (0.05
   * = 5%); null when market value is zero or income is unavailable.
   */
  readonly currentYield?: Maybe<Scalars['BigDecimal']['output']>;
  /** Aggregate forward-looking annualized income for the asset class; amount is null when Orion does not provide it. */
  readonly estimatedAnnualIncome: HoldingsSummaryMoney;
  /** Aggregate market value for the asset class on the report end date. */
  readonly marketValue: HoldingsSummaryMoney;
};

/** Autogenerated input type of ExcludeStagedHouseholdsFromBatch */
export type ExcludeStagedHouseholdsFromBatchInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * EciHouseholdOnboardingRequest ids to wipe from the batch. The cockpit surfaces
   * these ids post-HAWK-656; only unpromoted rows are destroyed, a live/promoted
   * request is never touched.
   */
  readonly stagedHouseholdIds: ReadonlyArray<Scalars['ID']['input']>;
  /** The enrollment's uuid. */
  readonly uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of ExcludeStagedHouseholdsFromBatch. */
export type ExcludeStagedHouseholdsFromBatchPayload = {
  readonly __typename?: 'ExcludeStagedHouseholdsFromBatchPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enrollment after exclusions. */
  readonly enrollment?: Maybe<AdvisorOnboardingEnrollment>;
  /** Any errors that occurred. */
  readonly errors?: Maybe<ReadonlyArray<MutationError>>;
  /** Whether the operation succeeded. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ExpirePublishedReport */
export type ExpirePublishedReportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the published report to expire. */
  readonly publishedReportId: Scalars['ID']['input'];
};

/** Autogenerated return type of ExpirePublishedReport. */
export type ExpirePublishedReportPayload = {
  readonly __typename?: 'ExpirePublishedReportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The report after expiry. */
  readonly publishedReport: PublishedReportSummary;
};

/** A column filter in TanStack Table format */
export type ExportFilterInput = {
  /** Column ID */
  readonly id: Scalars['String']['input'];
  /** Filter value object (operator + value(s)) */
  readonly value: FilterValueInput;
};

/** Service calendar v1 export payload for an advisor */
export type ExportPayload = {
  readonly __typename?: 'ExportPayload';
  readonly advisorFirstName: Scalars['String']['output'];
  readonly advisorLastName: Scalars['String']['output'];
  readonly households: ReadonlyArray<HouseholdExport>;
};

/** A sort specification in TanStack Table format */
export type ExportSortInput = {
  /** Whether to sort descending */
  readonly desc: Scalars['Boolean']['input'];
  /** Column ID */
  readonly id: Scalars['String']['input'];
};

export type ExtendExtractedDatum = {
  readonly __typename?: 'ExtendExtractedDatum';
  readonly accountData: Scalars['JSON']['output'];
  readonly boxDocumentId: Scalars['String']['output'];
  readonly classificationData: Scalars['JSON']['output'];
  readonly classificationDataType?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly documentClassification?: Maybe<Scalars['String']['output']>;
  readonly fileName: Scalars['String']['output'];
  readonly holdingsData?: Maybe<Scalars['JSON']['output']>;
  readonly household?: Maybe<Household>;
  readonly id: Scalars['ID']['output'];
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly uploadingUser?: Maybe<User>;
  readonly workflowId: Scalars['String']['output'];
  readonly workflowRunId: Scalars['String']['output'];
};

/** Autogenerated input type of ExtractBoxClientUploadStatements */
export type ExtractBoxClientUploadStatementsInput = {
  /** Box file ids to extract */
  readonly boxDocumentIds: ReadonlyArray<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household the files belong to */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ExtractBoxClientUploadStatements. */
export type ExtractBoxClientUploadStatementsPayload = {
  readonly __typename?: 'ExtractBoxClientUploadStatementsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Fixed user-facing message when some files could not be processed */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** Files that could not be sent to Extend */
  readonly failedCount: Scalars['Int']['output'];
  /** Files not sent to Extend: already extracted, not in the household folder, or already in progress */
  readonly skippedCount: Scalars['Int']['output'];
  /** Files newly sent to Extend */
  readonly triggeredCount: Scalars['Int']['output'];
};

/** A family member associated with a household */
export type FamilyMember = {
  readonly __typename?: 'FamilyMember';
  /** Street address line 1 */
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  /** Street address line 2 */
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  /** Calculated age based on date of birth */
  readonly age?: Maybe<Scalars['String']['output']>;
  /** City */
  readonly city?: Maybe<Scalars['String']['output']>;
  /** Date of birth in ISO format */
  readonly dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * The household this contact depends on, when the dependency is on the household
   * rather than one client. Mutually exclusive with dependentOfUserId
   */
  readonly dependentOfHouseholdId?: Maybe<Scalars['ID']['output']>;
  /** The client this contact depends on. Mutually exclusive with dependentOfHouseholdId */
  readonly dependentOfUserId?: Maybe<Scalars['ID']['output']>;
  /** Email address */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** Entity establishment date */
  readonly entityDateEstablished?: Maybe<Scalars['String']['output']>;
  /** Entity date of death */
  readonly entityDateOfDeath?: Maybe<Scalars['String']['output']>;
  /** Entity EIN for entity relations */
  readonly entityEin?: Maybe<Scalars['String']['output']>;
  /** Executor name for estate entities */
  readonly entityExecutorName?: Maybe<Scalars['String']['output']>;
  /** Entity name for entity relations */
  readonly entityName?: Maybe<Scalars['String']['output']>;
  /** Organization type for organization entities */
  readonly entityOrganizationType?: Maybe<Scalars['String']['output']>;
  /** Primary contact role for organization entities */
  readonly entityPrimaryContactRole?: Maybe<Scalars['String']['output']>;
  /** Trust type for trust entities */
  readonly entityTrustType?: Maybe<Scalars['String']['output']>;
  /** Trustee name for trust entities */
  readonly entityTrusteeName?: Maybe<Scalars['String']['output']>;
  /** Entity type for entity relations */
  readonly entityType?: Maybe<Scalars['String']['output']>;
  /** Legal first name */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the family member */
  readonly id: Scalars['ID']['output'];
  /** Whether this contact is a beneficiary */
  readonly isBeneficiary?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this contact is financially dependent on a client. Advisor context
   * only — it does not feed dependent counts on client intake, account-opening or
   * account-maintenance requests, and does not feed tax projection
   */
  readonly isDependent?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this contact is a trusted contact */
  readonly isTrustedContact?: Maybe<Scalars['Boolean']['output']>;
  /** Legal last name */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** Legal middle name */
  readonly middleName?: Maybe<Scalars['String']['output']>;
  /** Preferred nickname */
  readonly nickname?: Maybe<Scalars['String']['output']>;
  /** Freeform notes about the contact */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /** Phone number */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Relationship to the household */
  readonly relation?: Maybe<Scalars['String']['output']>;
  /** Social Security Number */
  readonly ssn?: Maybe<Scalars['String']['output']>;
  /** State */
  readonly state?: Maybe<Scalars['String']['output']>;
  /** ZIP / postal code */
  readonly zipCode?: Maybe<Scalars['String']['output']>;
};

/** A fee schedule option for an advisor to choose from for their clients */
export type FeeSchedule = {
  readonly __typename?: 'FeeSchedule';
  /** The advisor profile for the fee schedule */
  readonly advisorProfile: Advisor;
  /** The type of amount for the fee schedule */
  readonly amountType?: Maybe<FeeScheduleAmountTypes>;
  /** The description of the fee schedule */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The type of fee schedule */
  readonly feeType: FeeScheduleFeeTypes;
  /** The flat fee amount for the fee schedule */
  readonly flatFeeAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** The ID of the fee schedule */
  readonly id: Scalars['ID']['output'];
  /** The minimum fee for the fee schedule */
  readonly minimumFee?: Maybe<Scalars['BigDecimal']['output']>;
  /** The name of the fee schedule */
  readonly name: Scalars['String']['output'];
  /** The tiers for the fee schedule */
  readonly tiers?: Maybe<Scalars['JSON']['output']>;
};

/** Name of the fee schedule amount types */
export const FeeScheduleAmountTypes = {
  /** dollar */
  Dollar: 'dollar',
  /** percentage */
  Percentage: 'percentage'
} as const;

export type FeeScheduleAmountTypes = typeof FeeScheduleAmountTypes[keyof typeof FeeScheduleAmountTypes];
/** Name of the fee schedule fee types */
export const FeeScheduleFeeTypes = {
  /** flat */
  Flat: 'flat',
  /** linear */
  Linear: 'linear',
  /** tiered */
  Tiered: 'tiered'
} as const;

export type FeeScheduleFeeTypes = typeof FeeScheduleFeeTypes[keyof typeof FeeScheduleFeeTypes];
/** Fee Schedule Update variant: change a client's advisory fee structure */
export type FeeScheduleUpdateInput = {
  /** Accounts affected; empty applies to all household accounts */
  readonly accountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Current fee, as entered (e.g. "0.75%" or "$5,000/yr") */
  readonly currentFee?: InputMaybe<Scalars['String']['input']>;
  /** Effective date of the fee change; omitted when the timing is future */
  readonly effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Whether the fee change is immediate or on a future date described in the notes */
  readonly effectiveDateTiming?: InputMaybe<ClientBillingDateTimingName>;
  /** Fee change direction — increase, decrease, or no_change */
  readonly feeChangeType: ClientBillingFeeChangeTypeName;
  /** Confirmation a new IAA was initiated (required when fee is increasing) */
  readonly iaaConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** New fee, as entered */
  readonly newFee: Scalars['String']['input'];
  /** Notes for Ops */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of FetchPlaidAccounts */
export type FetchPlaidAccountsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of FetchPlaidAccounts. */
export type FetchPlaidAccountsPayload = {
  readonly __typename?: 'FetchPlaidAccountsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** A single Fidelity position (holding) shown in the trade ticket. */
export type FidelityPosition = {
  readonly __typename?: 'FidelityPosition';
  /** Average cost per share (for cost basis = avgCostPerShare × quantity). */
  readonly avgCostPerShare?: Maybe<Scalars['Float']['output']>;
  /** Today's market-value change vs prior close, in dollars. Null under CLOSE pricing. */
  readonly dayChange?: Maybe<Scalars['Float']['output']>;
  /** Today's market-value change vs prior close, as a percent. Null under CLOSE pricing. */
  readonly dayChangePct?: Maybe<Scalars['Float']['output']>;
  /** Security description. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Market value (prior-day close under the current entitlement). */
  readonly marketValue?: Maybe<Scalars['Float']['output']>;
  /** Per-share price. Recent (DELAYED/REAL_TIME) mark when entitled, else prior-day close. */
  readonly price?: Maybe<Scalars['Float']['output']>;
  /** Fidelity pricing method for `price` and `market_value`: CLOSE, DELAYED, or REAL_TIME. */
  readonly priceType?: Maybe<Scalars['String']['output']>;
  /** Shares held. */
  readonly quantity?: Maybe<Scalars['Float']['output']>;
  /** Ticker/symbol (falls back to CUSIP when the symbol is absent). */
  readonly symbol?: Maybe<Scalars['String']['output']>;
  /** Unrealized gain/loss vs cost basis. */
  readonly unrealizedGainLoss?: Maybe<Scalars['Float']['output']>;
};

/** Filter value discriminated union using oneOf directive */
export type FilterValueInput =
  /** Checkbox filter value */
  { readonly checkbox: CheckboxFilterInput; readonly date?: never; readonly number?: never; readonly select?: never; readonly text?: never; }
  |  /** Date/datetime/time filter value */
  { readonly checkbox?: never; readonly date: DateFilterInput; readonly number?: never; readonly select?: never; readonly text?: never; }
  |  /** Number/currency filter value */
  { readonly checkbox?: never; readonly date?: never; readonly number: NumberFilterInput; readonly select?: never; readonly text?: never; }
  |  /** Select/tag filter value */
  { readonly checkbox?: never; readonly date?: never; readonly number?: never; readonly select: SelectFilterInput; readonly text?: never; }
  |  /** Text filter value */
  { readonly checkbox?: never; readonly date?: never; readonly number?: never; readonly select?: never; readonly text: TextFilterInput; };

/** Final Bill variant: process the final invoice for a departing client */
export type FinalBillInput = {
  /** Accounts to bill */
  readonly accountIds: ReadonlyArray<Scalars['ID']['input']>;
  /** Whether cash raising is needed — yes, no, or unsure */
  readonly cashRaisingNeeded: ClientBillingCashRaisingNeededName;
  /** Last service date; omitted when the timing is future */
  readonly lastServiceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Whether the last service date is immediate or a future date described in the notes */
  readonly lastServiceDateTiming?: InputMaybe<ClientBillingDateTimingName>;
  /** Notes for Ops */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of FinalizeMeetingRecordingUpload */
export type FinalizeMeetingRecordingUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The recording returned by requestMeetingRecordingUpload */
  readonly meetingRecordingId: Scalars['ID']['input'];
  /**
   * Which segment finished uploading. Omitted for a recording captured as one
   * file. The recording only advances out of pending_upload once every declared
   * part has landed.
   */
  readonly partIndex?: InputMaybe<Scalars['Int']['input']>;
  /** The key the bytes were PUT to. Must be the key this recording was granted. */
  readonly s3Key: Scalars['String']['input'];
};

/** Autogenerated return type of FinalizeMeetingRecordingUpload. */
export type FinalizeMeetingRecordingUploadPayload = {
  readonly __typename?: 'FinalizeMeetingRecordingUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the recording is now marked uploaded */
  readonly success: Scalars['Boolean']['output'];
};

export type FinancialOffering = {
  readonly __typename?: 'FinancialOffering';
  /** Editable rich-text body (sanitized HTML); when set, overrides the in-code default blocks. */
  readonly bodyHtml?: Maybe<Scalars['String']['output']>;
  /** Description of the financial offering. */
  readonly description: Scalars['String']['output'];
  /** The display order of the financial offering. */
  readonly displayOrder?: Maybe<Scalars['Int']['output']>;
  /** Optional note shown beneath the Fee structure section. */
  readonly feeStructureDescription?: Maybe<Scalars['String']['output']>;
  /** Fees for the financial offering. */
  readonly fees?: Maybe<ReadonlyArray<Detail>>;
  /** Savvy ID of financial offering */
  readonly id: Scalars['ID']['output'];
  /** Other facts of the financial offering. */
  readonly keyFacts?: Maybe<ReadonlyArray<Detail>>;
  /** Optional note shown beneath the Key facts section. */
  readonly keyFactsDescription?: Maybe<Scalars['String']['output']>;
  /** Links of the financial offering. */
  readonly links?: Maybe<ReadonlyArray<Detail>>;
  /** Optimistic-locking token; pass back to updateFinancialOffering to detect concurrent edits. */
  readonly lockVersion: Scalars['Int']['output'];
  /** Long description of the financial offering. */
  readonly longDescription?: Maybe<Scalars['String']['output']>;
  /** The name of the financial offering. */
  readonly name: Scalars['String']['output'];
  /** Providers of the financial offering. */
  readonly providers?: Maybe<ReadonlyArray<FinancialOfferingProvider>>;
  /** Quick links from the financial offering and its providers, ordered by quick_link_order. */
  readonly quickLinks?: Maybe<ReadonlyArray<Detail>>;
  /** The status of the financial offering. */
  readonly status: FinancialOfferingStatus;
  /** True when the offering name is coupled to behavioral UI and must stay read-only. */
  readonly systemManaged: Scalars['Boolean']['output'];
  /** The type or category of financial offering. */
  readonly type: FinancialOfferingTypeName;
};

/**
 * A fee or key-fact row on a financial offering. Omit `id` to create a new row;
 * existing rows absent from the payload are deleted.
 */
export type FinancialOfferingDetailInput = {
  /** Detail id of an existing row; omit to create a new one */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** Row label (required) */
  readonly label: Scalars['String']['input'];
  /** Row value */
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A link/document row on a financial offering. Omit `id` to create a new row;
 * existing rows absent from the payload are deleted.
 */
export type FinancialOfferingLinkInput = {
  /** Optional short description shown beside the link in the Resources table */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Optional Cloudinary-hosted icon image shown beside the link; must be an app Cloudinary asset URL */
  readonly iconUrl?: InputMaybe<Scalars['String']['input']>;
  /** Detail id of an existing link; omit to create a new one */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** Link label (required) */
  readonly label: Scalars['String']['input'];
  /**
   * Whether the link opens in a new tab; omitted or true keeps the default new-tab
   * behavior, false navigates the current window
   */
  readonly opensInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  /** When set, marks this link as a quick link at the given order; must be unique among the offering's links */
  readonly quickLinkOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Link URL — must be a valid http(s) URL */
  readonly value: Scalars['String']['input'];
};

export type FinancialOfferingProvider = {
  readonly __typename?: 'FinancialOfferingProvider';
  /** Editable "Contacts" blurb; when set, overrides the in-code default. */
  readonly contactText?: Maybe<Scalars['String']['output']>;
  /** Contacts of the financial offering provider. */
  readonly contacts?: Maybe<ReadonlyArray<Contact>>;
  /** The description of the financial offering provider. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Savvy ID of financial offering provider */
  readonly id: Scalars['ID']['output'];
  /** Links related to the financial offering provider. */
  readonly links?: Maybe<ReadonlyArray<Detail>>;
  /** The url for the logo of the financial offering provider. */
  readonly logo?: Maybe<Scalars['String']['output']>;
  /** The name of the financial offering provider. */
  readonly name: Scalars['String']['output'];
  /** True when the provider name is coupled to behavioral UI and must stay read-only. */
  readonly systemManaged: Scalars['Boolean']['output'];
};

/** Editable copy for a provider section on the offering. */
export type FinancialOfferingProviderInput = {
  /** Editable "Contacts" blurb; overrides the in-code default */
  readonly contactText?: InputMaybe<Scalars['String']['input']>;
  /** Provider description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Provider id; omit/null to create a new section. Existing providers not present in the payload are removed. */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** Full set of provider resource links; nil leaves them untouched */
  readonly links?: InputMaybe<ReadonlyArray<FinancialOfferingLinkInput>>;
  /** Provider logo URL */
  readonly logo?: InputMaybe<Scalars['String']['input']>;
  /** Provider name (section title); required for new sections, rejected on system-managed providers */
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export const FinancialOfferingStatus = {
  /** Active offering shown in app */
  Active: 'active',
  /** Hidden financial offering not visible to users */
  Hidden: 'hidden'
} as const;

export type FinancialOfferingStatus = typeof FinancialOfferingStatus[keyof typeof FinancialOfferingStatus];
export const FinancialOfferingTypeName = {
  AdditionalPartners: 'AdditionalPartners',
  Alternatives: 'Alternatives',
  Banking: 'Banking',
  CashManagement: 'CashManagement',
  InvestmentResearch: 'InvestmentResearch',
  Planning: 'Planning',
  ProtectionAndRetirement: 'ProtectionAndRetirement',
  PublicInvesting: 'PublicInvesting',
  Swim: 'SWIM'
} as const;

export type FinancialOfferingTypeName = typeof FinancialOfferingTypeName[keyof typeof FinancialOfferingTypeName];
/** A financial plan for a household */
export type FinancialPlan = {
  readonly __typename?: 'FinancialPlan';
  /** The Conquest plan ID */
  readonly conquestPlanId: Scalars['String']['output'];
  /** The URL of the Conquest plan */
  readonly conquestPlanUrl: Scalars['String']['output'];
  /** The URL of the Conquest plan story for advisors */
  readonly conquestStoryAdvisorUrl?: Maybe<Scalars['String']['output']>;
  /** The URL of the Conquest plan story for clients */
  readonly conquestStoryClientUrl?: Maybe<Scalars['String']['output']>;
  /** The Conquest plan story ID */
  readonly conquestStoryId?: Maybe<Scalars['String']['output']>;
  /** Whether the Conquest plan story has been published to the client */
  readonly conquestStoryPublished: Scalars['Boolean']['output'];
  /** When the financial plan was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The plan presentations/stories from Conquest */
  readonly digitalStories: ReadonlyArray<DigitalStory>;
  /** The household associated with the financial plan */
  readonly household: Household;
  /** The Savvy ID of the financial plan */
  readonly id: Scalars['ID']['output'];
  /** When the financial plan was last updated in Conquest */
  readonly lastUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether this plan belongs to the legacy Conquest experience */
  readonly legacy: Scalars['Boolean']['output'];
  /** When the financial plan was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FinancialPlanningBoxFolderData = {
  readonly __typename?: 'FinancialPlanningBoxFolderData';
  /** The access token used for Box UI Elements. */
  readonly accessToken?: Maybe<Scalars['String']['output']>;
  /** The ID of the most recently uploaded file in the financial plan report folder */
  readonly financialPlanReportFileId?: Maybe<Scalars['String']['output']>;
  /** The upload date of the most recently uploaded file in the financial plan report folder */
  readonly financialPlanReportFileUploadDate?: Maybe<Scalars['String']['output']>;
  /** The ID of the financial plan report folder */
  readonly financialPlanReportFolderId?: Maybe<Scalars['String']['output']>;
};

export type FinancialRecommendation = {
  readonly __typename?: 'FinancialRecommendation';
  readonly category: Scalars['String']['output'];
  readonly recommendation: Scalars['String']['output'];
};

/** The soonest occurrence of a bookable service that is still unbooked after its invite went out */
export type FirmServiceCalendarAwaitingBooking = {
  readonly __typename?: 'FirmServiceCalendarAwaitingBooking';
  /**
   * When this occurrence was last emailed to the client, so the row can say a
   * reminder already went out without holding it in page state
   */
  readonly lastReminderSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Which occurrence of the cadence is unbooked */
  readonly occurrenceDate: Scalars['ISO8601Date']['output'];
  /**
   * Typed occurrence id — "task-123" or "occurrence-456". Carries no revision
   * token: the row action reads a fresh one from householdServiceOccurrences at click time
   */
  readonly occurrenceId: Scalars['ID']['output'];
  /** Reminders the forward campaign was frozen with. Null on a legacy or Task-shaped row */
  readonly remindersPlanned?: Maybe<Scalars['Int']['output']>;
  /** Planned reminders of a forward campaign that were delivered. Null on a legacy or Task-shaped row */
  readonly remindersSent?: Maybe<Scalars['Int']['output']>;
  /** This occurrence's status, the same derivation householdServiceOccurrences uses */
  readonly status: OccurrenceStatus;
};

/** Where one enrolled service stands on getting its bookable meeting on the calendar */
export const FirmServiceCalendarBookingState = {
  /**
   * An occurrence is unbooked and its invite has already gone out, so the client
   * has been asked and has not booked. This is the only state that asks the advisor to act
   */
  AwaitingBooking: 'AWAITING_BOOKING',
  /** Every materialized occurrence of every bookable item is booked */
  Booked: 'BOOKED',
  /**
   * Nothing here can be booked: the service has no event item carrying a Calendly
   * link, or it has one and the generation horizon has not reached its next occurrence yet
   */
  NothingToSchedule: 'NOTHING_TO_SCHEDULE',
  /**
   * An occurrence is unbooked but no invite has gone out yet — it materialized
   * ahead of its lead time. Nobody is late; there is simply nothing to report.
   * Distinguished from BOOKED because collapsing the two claimed a booking that
   * had never been asked for
   */
  NotYetInvited: 'NOT_YET_INVITED'
} as const;

export type FirmServiceCalendarBookingState = typeof FirmServiceCalendarBookingState[keyof typeof FirmServiceCalendarBookingState];
/** One household row of the firm service calendar, rolled up across every service it is enrolled in */
export type FirmServiceCalendarRow = {
  readonly __typename?: 'FirmServiceCalendarRow';
  /** Primary advisor first name */
  readonly advisorFirstName?: Maybe<Scalars['String']['output']>;
  /** Primary advisor last name */
  readonly advisorLastName?: Maybe<Scalars['String']['output']>;
  /** Primary advisor profile picture URL */
  readonly advisorProfilePicUrl?: Maybe<Scalars['String']['output']>;
  /** How many enrolled services a client can book. Zero renders the Scheduled column as a dash */
  readonly bookableMeetingCount: Scalars['Int']['output'];
  /** Whether the soonest occurrence falls in the calendar month of the viewing advisor's today */
  readonly dueThisMonth: Scalars['Boolean']['output'];
  /** Whether the soonest occurrence falls within seven days of the viewing advisor's today */
  readonly dueThisWeek: Scalars['Boolean']['output'];
  /** Every live service this household is enrolled in. Empty for a household that is not enrolled */
  readonly enrolledServices: ReadonlyArray<FirmServiceCalendarService>;
  /** Opaque public household identifier the household route takes */
  readonly householdPublicId: Scalars['String']['output'];
  /** Household id */
  readonly id: Scalars['ID']['output'];
  /** Last contact timestamp */
  readonly lastContactAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** How many bookable services hold an unbooked occurrence whose invite has gone out */
  readonly meetingsAwaitingBooking: Scalars['Int']['output'];
  /** Household name */
  readonly name: Scalars['String']['output'];
  /** The soonest occurrence date across every enrolled service */
  readonly nextOccurrenceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Name of the service holding the soonest occurrence across every enrolled service */
  readonly nextServiceName?: Maybe<Scalars['String']['output']>;
  /** Display-only household tags, scoped to the tags the viewer's organization owns */
  readonly tags: ReadonlyArray<ServiceScheduleTag>;
};

/** One enrolled service on a firm service calendar row, with its own next date and booking state */
export type FirmServiceCalendarService = {
  readonly __typename?: 'FirmServiceCalendarService';
  /**
   * The occurrence to chase: unbooked, with its invite already out. Null covers
   * three unrelated situations — everything booked, nothing invited yet, nothing
   * materialized — so read `bookingState` to tell a booking from a client who has
   * not been asked. This field carries the occurrence a reminder would target; it
   * is not a booking signal
   */
  readonly awaitingBooking?: Maybe<FirmServiceCalendarAwaitingBooking>;
  /**
   * True when any enrolled item is an event carrying a Calendly link — the only
   * shape a client can book. A newsletter event with no link is never bookable
   */
  readonly bookable: Scalars['Boolean']['output'];
  /**
   * Where this service stands on getting its bookable meeting booked. Derived
   * server-side so the column renders a state instead of inferring one from an absent value
   */
  readonly bookingState: FirmServiceCalendarBookingState;
  /** Colour key for the service identity chip (4C1T-570) */
  readonly colorKey: Scalars['String']['output'];
  /** Icon key for the service identity chip (4C1T-570) */
  readonly iconKey: Scalars['String']['output'];
  /**
   * Identifies this service on this household. Scoped to the household because two
   * households enrolled in the same service carry different dates and booking
   * states, and a client cache keyed on the service alone would collapse them into one
   */
  readonly id: Scalars['ID']['output'];
  /** One entry per enrolled item — "task" or "event" — so a child row can read "1 task · 1 event" without a second query */
  readonly itemTypes: ReadonlyArray<Scalars['String']['output']>;
  /** Service name */
  readonly name: Scalars['String']['output'];
  /**
   * Soonest materialized occurrence of this service from today on. Null when
   * nothing is materialized ahead, which is what the generation horizon looks like from the list
   */
  readonly nextOccurrenceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * The service itself, unscoped by household. `id` deliberately carries the
   * household, so it cannot be used to group rows by service or passed to a
   * mutation that takes a serviceCatalogItemGroupId — this is that id
   */
  readonly serviceId: Scalars['ID']['output'];
  /**
   * The soonest unbooked occurrence's status while bookingState is NOT_YET_INVITED
   * — scheduled, or booking_canceled for a booking cancelled before its invite
   * window. Null in every other state
   */
  readonly unbookedStatus?: Maybe<OccurrenceStatus>;
};

/** An advisor in the current firm who can be seeded into a new team */
export type FirmTeamCandidate = {
  readonly __typename?: 'FirmTeamCandidate';
  /** The advisor's first name */
  readonly firstName?: Maybe<Scalars['String']['output']>;
  /** The advisor user id (pass as advisorUserIds) */
  readonly id: Scalars['ID']['output'];
  /** The advisor's last name */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** The advisor's profile picture URL */
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
};

/** A single task display item that is not part of a multi-household service-item group */
export type FlatTaskOccurrence = {
  readonly __typename?: 'FlatTaskOccurrence';
  /** The underlying task id */
  readonly id: Scalars['ID']['output'];
  /** The task this display item represents */
  readonly task: Task;
};

/** The kyc status from footprint. */
export const FootprintStatus = {
  /** error */
  Error: 'error',
  /** fail */
  Fail: 'fail',
  /** incomplete */
  Incomplete: 'incomplete',
  /** manual_review */
  ManualReview: 'manual_review',
  /** none */
  None: 'none',
  /** pass */
  Pass: 'pass'
} as const;

export type FootprintStatus = typeof FootprintStatus[keyof typeof FootprintStatus];
/** A pre-filled IWS/Schwab app PDF (uploaded to S3 via RequestRepaperPdfUploadUrls) plus its DocuSign signer tabs */
export type FormDocumentInput = {
  /** DEPRECATED — legacy inline base64 PDF. Ignored by the backend; removed after the HAWK-70 FE rollout. */
  readonly base64Pdf?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the document in the DocuSign envelope */
  readonly documentName: Scalars['String']['input'];
  /** Stable form identifier (e.g. fidelity-iws-personal, schwab-app13582) */
  readonly formId: Scalars['String']['input'];
  /** S3 key from requestRepaperPdfUploadUrls. Required at runtime — flag-gated until FE migration completes. */
  readonly s3Key?: InputMaybe<Scalars['String']['input']>;
  /** Signer tabs to bind to this document via anchor strings */
  readonly signerTabs: ReadonlyArray<SignerTabInput>;
};

/** A document template the ECI Form Center can manage */
export type FormTemplate = {
  readonly __typename?: 'FormTemplate';
  /** Box folder holding the template */
  readonly boxFolderId: Scalars['String']['output'];
  /** Filename prefix the code looks the template up by */
  readonly boxNamePrefix: Scalars['String']['output'];
  /** agreement, disclosure, account_application or asset_transfer_form */
  readonly category: Scalars['String']['output'];
  /** Human-readable template name */
  readonly displayName: Scalars['String']['output'];
  /** DocumentTemplate value, e.g. eci_msa */
  readonly key: Scalars['String']['output'];
  /** Signed once per SIMPLE employer plan rather than per account */
  readonly planLevel: Scalars['Boolean']['output'];
};

/** One ECI template, and the Box file serving it today */
export type FormTemplateDetail = {
  readonly __typename?: 'FormTemplateDetail';
  /** Box file serving this template today */
  readonly boxFileId?: Maybe<Scalars['String']['output']>;
  /** Version number Box serves today */
  readonly boxVersion?: Maybe<Scalars['String']['output']>;
  /** Human-readable template name */
  readonly displayName: Scalars['String']['output'];
  /** DocumentTemplate value, e.g. eci_msa */
  readonly key: Scalars['String']['output'];
  /** Which code path fills it: FillableFormSpec, PrefillAgreement, PrefillToa */
  readonly prefillPath?: Maybe<Scalars['String']['output']>;
  /** Embeddable Box link for rendering the blank template */
  readonly previewUrl?: Maybe<Scalars['String']['output']>;
  /** Field names this template's mapper writes, so a replacement file has to carry them */
  readonly requiredFields: ReadonlyArray<Scalars['String']['output']>;
  /** prefillable, static or missing */
  readonly status: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateAllQuarterlyReports */
export type GenerateAllQuarterlyReportsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of household IDs to generate reports for. If not provided, generates for all eligible households. */
  readonly householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** Autogenerated return type of GenerateAllQuarterlyReports. */
export type GenerateAllQuarterlyReportsPayload = {
  readonly __typename?: 'GenerateAllQuarterlyReportsPayload';
  /** Sidekiq batch ID for tracking */
  readonly batchId?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Number of households enqueued for processing */
  readonly enqueuedCount?: Maybe<Scalars['Int']['output']>;
  /** Status message */
  readonly message?: Maybe<Scalars['String']['output']>;
  /** Whether the batch was successfully enqueued */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of GenerateCoClientTask */
export type GenerateCoClientTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The blocked staged household to repair. */
  readonly stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateCoClientTask. */
export type GenerateCoClientTaskPayload = {
  readonly __typename?: 'GenerateCoClientTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The staged household after the repair. */
  readonly stagedHousehold: AdvisorOnboardingStagedHousehold;
};

/** Autogenerated input type of GenerateDirectoryProfileDraft */
export type GenerateDirectoryProfileDraftInput = {
  /** Free-text about the practice / approach. */
  readonly aboutPractice?: InputMaybe<Scalars['String']['input']>;
  /** Free-text about the advisor's background / story. */
  readonly background?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Free-text describing the advisor's typical clients. */
  readonly clientTypes?: InputMaybe<Scalars['String']['input']>;
  /** Free-text designations / organizations the advisor listed. */
  readonly credentials?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** An existing bio to refine rather than copy verbatim. */
  readonly currentBio?: InputMaybe<Scalars['String']['input']>;
  /** Three or four topics the advisor wants to be known for. */
  readonly topics?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Years of experience. */
  readonly yearsExperience?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of GenerateInvestmentProposal */
export type GenerateInvestmentProposalInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household this proposal is for, used to auto-advance its pipeline stage. */
  readonly householdId?: InputMaybe<Scalars['ID']['input']>;
  readonly newFileName?: InputMaybe<Scalars['String']['input']>;
  readonly replacementData: InvestmentProposalReplacementData;
  readonly selectedCharts?: InputMaybe<ReadonlyArray<InvestmentProposalCharts>>;
};

/** Autogenerated return type of GenerateInvestmentProposal. */
export type GenerateInvestmentProposalPayload = {
  readonly __typename?: 'GenerateInvestmentProposalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly presentationDownloadAsPdfUrl: Scalars['String']['output'];
  readonly presentationId: Scalars['String']['output'];
  readonly presentationUrl: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateOrionReport */
export type GenerateOrionReportInput = {
  /**
   * Savvy Account ID. Provide exactly one of household_id, account_id, or
   * account_sleeve_id. Use account_id for reports that run at the Orion Account
   * entity level on a parent account (e.g. Direct Index Report on a
   * single-strategy account).
   */
  readonly accountId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Savvy AccountSleeve ID. Provide exactly one of household_id, account_id, or
   * account_sleeve_id. Use account_sleeve_id when the Direct Indexing strategy
   * lives in a sleeve of a multi-strategy account.
   */
  readonly accountSleeveId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** End date (inclusive). Required if start_date is provided. */
  readonly endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Orion Household ID. Provide exactly one of household_id, account_id, or account_sleeve_id. */
  readonly householdId?: InputMaybe<Scalars['String']['input']>;
  /**
   * [DEPRECATED] Quick date period. Valid values: "past_month", "last_quarter",
   * "past_year". Use start_date and end_date instead. If start_date/end_date are
   * also provided, explicit dates take precedence and quick_date is ignored.
   * @deprecated Use start_date and end_date instead. This argument will be removed in a future version.
   */
  readonly quickDate?: InputMaybe<Scalars['String']['input']>;
  /** Which Orion report to generate */
  readonly reportId: Scalars['String']['input'];
  /**
   * Start date (inclusive). Required if end_date is provided. For "from inception"
   * reports, use 1900-01-01 or the household's creation date.
   */
  readonly startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of GenerateOrionReport. */
export type GenerateOrionReportPayload = {
  readonly __typename?: 'GenerateOrionReportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * URL to download the report
   * @deprecated Use orionReportGeneration.downloadUrl for async report generation. This field returns a placeholder in async mode.
   */
  readonly downloadUrl: Scalars['String']['output'];
  /** The async report generation record (only populated when async flag is enabled) */
  readonly orionReportGeneration?: Maybe<OrionReportGeneration>;
};

/** Autogenerated input type of GeneratePortfolioInsights */
export type GeneratePortfolioInsightsInput = {
  readonly accountId: Scalars['ID']['input'];
  readonly clientId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GeneratePortfolioInsights. */
export type GeneratePortfolioInsightsPayload = {
  readonly __typename?: 'GeneratePortfolioInsightsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly insights: ReadonlyArray<Scalars['String']['output']>;
};

/** Autogenerated input type of GenerateSalesforceAccessToken */
export type GenerateSalesforceAccessTokenInput = {
  readonly authorizationCode?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GenerateSalesforceAccessToken. */
export type GenerateSalesforceAccessTokenPayload = {
  readonly __typename?: 'GenerateSalesforceAccessTokenPayload';
  readonly accessToken: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GenerateServiceEmailDraft */
export type GenerateServiceEmailDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the service calendar event (e.g. "Annual review"). */
  readonly eventName: Scalars['String']['input'];
};

/** Autogenerated input type of GetOrCreateAprilToken */
export type GetOrCreateAprilTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GetOrCreateAprilToken. */
export type GetOrCreateAprilTokenPayload = {
  readonly __typename?: 'GetOrCreateAprilTokenPayload';
  /** access token */
  readonly accessToken: Scalars['String']['output'];
  /** auth code */
  readonly authCode: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** errors */
  readonly error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GetOrCreateHouseholdMemberAprilFilingToken */
export type GetOrCreateHouseholdMemberAprilFilingTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** client user_id we are requesting april token for */
  readonly clientUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of GetOrCreateHouseholdMemberAprilFilingToken. */
export type GetOrCreateHouseholdMemberAprilFilingTokenPayload = {
  readonly __typename?: 'GetOrCreateHouseholdMemberAprilFilingTokenPayload';
  /** access token */
  readonly accessToken: Scalars['String']['output'];
  /** auth code */
  readonly authCode: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** errors */
  readonly error?: Maybe<Scalars['String']['output']>;
};

export type Goal = {
  readonly __typename?: 'Goal';
  /** Description of the goal, as well as any client-facing advisor notes. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The goal end date. */
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** A goal's Savvy ID. */
  readonly id: Scalars['ID']['output'];
  /** The name of the goal. */
  readonly name: Scalars['String']['output'];
  /** The percent a goal is funded. */
  readonly percentFunded?: Maybe<Scalars['Int']['output']>;
  /** The goal start date. */
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The status of the goal. */
  readonly status: GoalStatusName;
  /** The target dollar amount for the goal. */
  readonly targetUsd?: Maybe<Scalars['BigDecimal']['output']>;
  /** The type of goal. */
  readonly type: GoalTypeName;
};

export const GoalStatusName = {
  AtRisk: 'at_risk',
  Completed: 'completed',
  OffTrack: 'off_track',
  OnTrack: 'on_track'
} as const;

export type GoalStatusName = typeof GoalStatusName[keyof typeof GoalStatusName];
export const GoalTypeName = {
  Education: 'education',
  Other: 'other',
  Planning: 'planning',
  Purchase: 'purchase',
  Retirement: 'retirement'
} as const;

export type GoalTypeName = typeof GoalTypeName[keyof typeof GoalTypeName];
export type GovernmentId = {
  readonly __typename?: 'GovernmentId';
  readonly expirationDate?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly idNumber?: Maybe<Scalars['String']['output']>;
  readonly issueDate?: Maybe<Scalars['String']['output']>;
  readonly issuingAuthority?: Maybe<Scalars['String']['output']>;
  readonly typeOf?: Maybe<Scalars['String']['output']>;
};

/** A single product line in the Group Performance table (per-holding returns grouped by asset category). */
export type GroupPerformanceRow = {
  readonly __typename?: 'GroupPerformanceRow';
  /** Top-level asset category this row groups under (e.g. 'Equity'). Null when Orion does not categorize the holding. */
  readonly assetCategory?: Maybe<Scalars['String']['output']>;
  /** Date the position was opened (Orion inception date). Null when unavailable. */
  readonly inceptionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Inception-to-date (all-time) time-weighted return as a fraction (e.g. 0.0490 = 4.90%). Null when unavailable. */
  readonly inceptionToDateReturn?: Maybe<Scalars['Float']['output']>;
  /** Market value of the position as of the report date, in USD. Null when unavailable. */
  readonly marketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Product / security display name. */
  readonly name: Scalars['String']['output'];
  /** Trailing one-year time-weighted return as a fraction. Null when the position has under one year of history. */
  readonly oneYearReturn?: Maybe<Scalars['Float']['output']>;
  /** Ticker symbol; null for cash or untickered securities. */
  readonly ticker?: Maybe<Scalars['String']['output']>;
  /** Year-to-date time-weighted return as a fraction. Null when unavailable. */
  readonly yearToDateReturn?: Maybe<Scalars['Float']['output']>;
};

/** Asset-category subtotal row in the Group Performance table. */
export type GroupPerformanceTotal = {
  readonly __typename?: 'GroupPerformanceTotal';
  /** Asset category this subtotal covers (e.g. 'Equity'). */
  readonly assetCategory: Scalars['String']['output'];
  /** Inception-to-date category TWR as a fraction. Null when unavailable. */
  readonly inceptionToDateReturn?: Maybe<Scalars['Float']['output']>;
  /** Total market value of the asset category, in USD. Null when unavailable. */
  readonly marketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Trailing one-year category TWR as a fraction. Null when unavailable. */
  readonly oneYearReturn?: Maybe<Scalars['Float']['output']>;
  /** Year-to-date category TWR as a fraction. Null when unavailable. */
  readonly yearToDateReturn?: Maybe<Scalars['Float']['output']>;
};

/** Monetary value at a point in time. */
export type HistoricalValue = {
  readonly __typename?: 'HistoricalValue';
  /** The date in time. */
  readonly date: Scalars['ISO8601Date']['output'];
  /** The monetary value at a point in time. */
  readonly value: Value;
};

/** Holding held by the user in an account. */
export type Holding = {
  readonly __typename?: 'Holding';
  /** The Savvy ID of the account associated with the holding */
  readonly accountId?: Maybe<Scalars['ID']['output']>;
  /** The total stored cost basis of this entire holding. */
  readonly costBasis?: Maybe<Scalars['BigDecimal']['output']>;
  /** Stored Orion cost basis lot detail when available. The rows do not prove that every lot is present. */
  readonly costBasisLots?: Maybe<ReadonlyArray<CostBasisLot>>;
  /** When the holding was added. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The currency for monetary values on this holding and its cost basis lots. */
  readonly currencyCode?: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the holding. */
  readonly id: Scalars['ID']['output'];
  /** The timestamp the holding was last updated with information from the source provider. */
  readonly lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** The quantity held of the security in this holding */
  readonly quantity?: Maybe<Scalars['BigDecimal']['output']>;
  /** The Savvy ID of the security associated with the holding */
  readonly security?: Maybe<Security>;
  /** The latest value of this holding of the associated security */
  readonly value?: Maybe<Scalars['BigDecimal']['output']>;
};

/**
 * Native holdings summary report — replaces the Orion-generated PDF (HAWK-23).
 * Sourced from the Orion Connect snapshot pipeline; only Connect-tracked
 * households are supported. When a householdId is supplied, non-Orion accounts are
 * filtered out silently to match the legacy Holdings Report's behavior. When
 * accountIds are supplied, the resolver raises if any requested account is not Orion-sourced.
 */
export type HoldingsSummary = {
  readonly __typename?: 'HoldingsSummary';
  /**
   * One row per account in scope, used to render the "Appendix – Summary of
   * Accounts" page. Ordered by management_strategy (Managed first, then
   * Unmanaged), then by account_name.
   */
  readonly accountSummaries: ReadonlyArray<HoldingsSummaryAccount>;
  /**
   * Full name of the household's assigned advisor, for the report header ("Your
   * Financial Advisor is {advisorName}"). Null when the household has no advisor.
   */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /**
   * Effective end date for the report — the date of the snapshot actually
   * rendered. Orion may snap a requested date to a nearby trading day (weekend /
   * holiday / future), so this can differ from `requestedEndDate`.
   */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Stable identifier for this report scope (household or account selection). */
  readonly id: Scalars['ID']['output'];
  /**
   * The exact `endDate` the caller supplied, before any Orion snapping. Compare to
   * `endDate` to detect when Orion returned data for a different day than was requested.
   */
  readonly requestedEndDate: Scalars['ISO8601Date']['output'];
  /** One row per active holding across the requested scope. */
  readonly rows: ReadonlyArray<HoldingsSummaryRow>;
  /**
   * Start of the reporting period the caller supplied. Captured for header display
   * ("For the date range of {startDate} to {endDate}"); does not influence which
   * snapshot is read.
   */
  readonly startDate: Scalars['ISO8601Date']['output'];
  /** Sum of cost_basis across rows; amount is null if any row lacks cost_basis. */
  readonly totalCostBasis: HoldingsSummaryMoney;
  /** Sum of estimated_income across rows; amount is null if any row lacks estimated_income. */
  readonly totalEstimatedIncome: HoldingsSummaryMoney;
  /** Sum of market_value across rows. */
  readonly totalMarketValue: HoldingsSummaryMoney;
  /** total_market_value minus total_cost_basis; amount is null if total_cost_basis amount is null. */
  readonly totalUnrealizedGainLoss: HoldingsSummaryMoney;
};

/** One row in the "Appendix – Summary of Accounts" section of the Holdings Summary report. */
export type HoldingsSummaryAccount = {
  readonly __typename?: 'HoldingsSummaryAccount';
  /** Savvy account ID. */
  readonly accountId: Scalars['ID']['output'];
  /** Display name of the account (Account#display_name). */
  readonly accountName: Scalars['String']['output'];
  /** Masked account number (Orion-style "XXX-XX####"); null when no mask is stored. */
  readonly accountNumberMasked?: Maybe<Scalars['String']['output']>;
  /** Humanized account subtype (e.g. "Roth IRA"); falls back to coarse type_of. */
  readonly accountType?: Maybe<Scalars['String']['output']>;
  /** Custodian / firm name when known. */
  readonly custodian?: Maybe<Scalars['String']['output']>;
  /**
   * Per-asset-class all-time TWR for this account, from Orion's Verbose endpoint.
   * Drives the Orion-matching "Since Inception" on the asset-class /
   * sub-asset-class subtotal rows. Empty when the Verbose fetch was unavailable
   * (subtotals then fall back to a weighted average).
   */
  readonly groupReturns: ReadonlyArray<HoldingsSummaryGroupReturn>;
  /** Stable identifier for the row. */
  readonly id: Scalars['ID']['output'];
  /** Humanized custody label (e.g. "Managed", "Unmanaged"). Drives the Appendix sub-grouping. */
  readonly managementStrategy?: Maybe<Scalars['String']['output']>;
  /** Sum of the account's holdings at the report's end_date. */
  readonly marketValue: HoldingsSummaryMoney;
};

/**
 * All-time time-weighted return for one asset-class grouping within an account,
 * sourced from Orion's /Reporting/Performance/Verbose endpoint (the same figure
 * Orion's Holdings Report prints on its asset-class / sub-asset-class subtotal
 * rows). Lets the report render Orion-matching group "Since Inception" instead of
 * a market-value-weighted average of per-holding returns, which does not equal the
 * group-level return.
 */
export type HoldingsSummaryGroupReturn = {
  readonly __typename?: 'HoldingsSummaryGroupReturn';
  /**
   * Which subtotal level this applies to: "asset_class" (Orion Asset Category,
   * e.g. Equity) or "sub_asset_class" (Orion Asset Class, e.g. US Equity).
   */
  readonly level: Scalars['String']['output'];
  /** The asset-class / sub-asset-class name, matching the holdings rows' grouping label. */
  readonly name: Scalars['String']['output'];
  /** All-time TWR as a decimal fraction (0.2113 = 21.13%); null when Orion has none. */
  readonly sinceInception?: Maybe<Scalars['Float']['output']>;
};

/** Monetary value used by native report payloads. */
export type HoldingsSummaryMoney = {
  readonly __typename?: 'HoldingsSummaryMoney';
  /** Numerical amount; null when no underlying data is available. */
  readonly amount?: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency code for the amount. */
  readonly currencyCode: Scalars['String']['output'];
};

/**
 * A single holding line in the native Holdings Summary report. Most consumers only
 * ever see currently-held positions, but a consumer that opted into retaining sold
 * positions may include a row with zero quantity/market_value representing a
 * position sold during the reporting period, not a data gap.
 */
export type HoldingsSummaryRow = {
  readonly __typename?: 'HoldingsSummaryRow';
  /** Savvy account ID this holding belongs to. */
  readonly accountId: Scalars['ID']['output'];
  /** Masked account identifier (last digits), when available. */
  readonly accountMask?: Maybe<Scalars['String']['output']>;
  /** Display name of the account. */
  readonly accountName: Scalars['String']['output'];
  /** Full account number, when available on the account record. */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Top-level asset category from Orion (e.g. 'Equity', 'Cash & Cash
   * Equivalents'). Drives the primary template grouping; null when Orion does not
   * categorize the holding.
   */
  readonly assetClass?: Maybe<Scalars['String']['output']>;
  /** Coarse asset type from Orion's product type (e.g. equity, etf, bond, cash). Always present. */
  readonly assetType: Scalars['String']['output'];
  /** Total cost basis for the position; null when not tracked. */
  readonly costBasis?: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency code for the row. */
  readonly currencyCode: Scalars['String']['output'];
  /** Annualized current yield as a decimal (e.g. 0.025 for 2.5%); null when not provided by Orion. */
  readonly currentYield?: Maybe<Scalars['BigDecimal']['output']>;
  /** Annualized estimated income for the position; null when not provided by Orion. */
  readonly estimatedIncome?: Maybe<HoldingsSummaryMoney>;
  /** Market value as of the report date, sourced from the Orion snapshot for that as-of-date. */
  readonly marketValue: HoldingsSummaryMoney;
  /** Security name; falls back to ticker when name isn't set. */
  readonly name: Scalars['String']['output'];
  /** Date the position was opened (Orion 'inception date' for the holding); null when Orion does not provide it. */
  readonly openDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** This row's market_value divided by total_market_value across the report scope. 0 when total is 0. */
  readonly percentOfPortfolio: Scalars['BigDecimal']['output'];
  /** Latest close price per unit; null when not available. */
  readonly pricePerUnit?: Maybe<Scalars['BigDecimal']['output']>;
  /** Current quantity held. */
  readonly quantity: Scalars['BigDecimal']['output'];
  /** Savvy security ID for this row, when the Orion product has a matching local security record. */
  readonly securityId?: Maybe<Scalars['ID']['output']>;
  /**
   * TWR since position opened: annualized for multi-year periods, cumulative for
   * sub-year (Orion annualize:true). Decimal, e.g. 0.2171. Null when unavailable.
   */
  readonly sinceInceptionReturn?: Maybe<Scalars['Float']['output']>;
  /**
   * Sub-asset class within asset_class (e.g. 'US Equity', 'International
   * Developed', 'Cash'). Drives the second-level template grouping; null when
   * Orion does not provide it.
   */
  readonly subAssetClass?: Maybe<Scalars['String']['output']>;
  /** Ticker symbol (e.g. AAPL); may be null for cash or untickered securities. */
  readonly ticker?: Maybe<Scalars['String']['output']>;
  /** market_value.amount minus cost_basis; null if either is null. */
  readonly unrealizedGainLoss?: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date time-weighted return, as a decimal (e.g. 0.0783 for 7.83%). Null when Orion has no YTD TWR for the position. */
  readonly ytdReturn?: Maybe<Scalars['Float']['output']>;
};

export type Household = {
  readonly __typename?: 'Household';
  /** Advisor access permissions for this household */
  readonly accessPermissions?: Maybe<ReadonlyArray<Permission>>;
  /** The latest open account confirmation task for this household */
  readonly accountConfirmationTask?: Maybe<Task>;
  /**
   * Whether the monthly account-connection reminder email is disabled for this
   * household -- true if the advisor silenced it, or if no preference has been set
   */
  readonly accountConnectionReminderDisabled: Scalars['Boolean']['output'];
  /** Number of accounts associated with this household */
  readonly accountCount: Scalars['Int']['output'];
  /** Account transfer information for this household */
  readonly accountTransferData: ReadonlyArray<AccountTransferDatum>;
  /** Accounts associated with this household */
  readonly accounts?: Maybe<ReadonlyArray<Account>>;
  /** Box subfolder ID for account documents; null until the household is linked to Box. */
  readonly accountsBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Whether this household is an accredited investor */
  readonly accreditedInvestor: Scalars['Boolean']['output'];
  /** The rationale for why this household is an accredited investor */
  readonly accreditedInvestorRationale?: Maybe<Scalars['String']['output']>;
  readonly adviceOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The advisor for this household */
  readonly advisor?: Maybe<Advisor>;
  readonly advisorAnnualRevenue?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * The advisor for this household, name only. Null when the viewer is outside
   * that advisor's organization and shares no advisor group with them.
   */
  readonly advisorDisplay?: Maybe<HouseholdAdvisor>;
  readonly advisorLeadSource?: Maybe<Scalars['String']['output']>;
  /**
   * Freeform detail supplied by the advisor to describe an "Other" lead source
   * (e.g. "Podcast interview"). Only meaningful when advisor_lead_source is "Other".
   */
  readonly advisorLeadSourceDetail?: Maybe<Scalars['String']['output']>;
  /** The advisors assigned to this household */
  readonly assignedAdvisors: ReadonlyArray<Advisor>;
  /** The bio for this household */
  readonly bio?: Maybe<Scalars['String']['output']>;
  /**
   * Book-transfer onboarding cockpit row for this household, when the household is
   * in an advisor onboarding enrollment and has not been dismissed.
   */
  readonly bookOnboardingCockpit?: Maybe<OnboardingCockpitRow>;
  /**
   * Root Box folder for this household. Used to scope the canvas agent's document
   * access; null until the household is linked to Box.
   */
  readonly boxFolderId?: Maybe<Scalars['String']['output']>;
  readonly clientPortalMessage?: Maybe<ClientPortalMessage>;
  readonly clientReviewDueThisQuarter: Scalars['Boolean']['output'];
  /** Box subfolder ID for client-upload documents; null until the household is linked to Box. */
  readonly clientUploadsBoxFolderId?: Maybe<Scalars['String']['output']>;
  readonly coClient?: Maybe<Client>;
  /** The onboarding status for the co-client */
  readonly coClientOnboardingStatus?: Maybe<OnboardingTaskDatum>;
  /**
   * Comment indicator for a Clients-list row, scoped to the viewing user. Batched
   * — safe to request across a page of households.
   */
  readonly commentSummary: CommentSummary;
  /** The date this household signed the contract */
  readonly contractSignatureDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Creation date for this household */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** CSA review conditions for this household */
  readonly csaReviewConditions?: Maybe<CsaReviewConditions>;
  /** Whether this household is enrolled in custodial 1099 reports */
  readonly custodial1099Enrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in custom indexing reports */
  readonly customIndexingReportEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is a demo */
  readonly demo: Scalars['Boolean']['output'];
  /** The reason this household was disqualified */
  readonly disqualifiedReason?: Maybe<Scalars['String']['output']>;
  /** Whether prospect tax is enabled for this household */
  readonly enableProspectTax: Scalars['Boolean']['output'];
  /** The family info for this household */
  readonly familyInfo?: Maybe<Scalars['String']['output']>;
  /** One contact linked to this household, by contact ID. Null when the contact is not linked to it */
  readonly familyMember?: Maybe<FamilyMember>;
  /** Family members associated with this household */
  readonly familyMembers: ReadonlyArray<FamilyMember>;
  /** The fee schedule for this household */
  readonly feeSchedule?: Maybe<Scalars['String']['output']>;
  readonly firmAnnualRevenue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether this household has an active (unsubmitted, non-cancelled) ECI custodian-transfer onboarding request */
  readonly hasActiveEciOnboarding: Scalars['Boolean']['output'];
  /**
   * False when this household has no primary_client_profile of its own and the
   * primaryClient field is resolved via the owner-role HouseholdMembership
   * (cross-household reuse).
   */
  readonly hasOwnPrimaryClient: Scalars['Boolean']['output'];
  /**
   * Optional client-portal nav surfaces the household's organization has hidden
   * from clients. Resolved from the primary advisor's organization preferences.
   * Empty means every optional surface is shown.
   */
  readonly hiddenPortalSurfaces: ReadonlyArray<ClientPortalHideableSurface>;
  /** The lead funnel stage of this household */
  readonly householdStage?: Maybe<HouseholdStage>;
  /** Household tags for this household */
  readonly householdTags?: Maybe<ReadonlyArray<HouseholdTag>>;
  readonly id: Scalars['ID']['output'];
  /** Whether this household is enrolled in income reports */
  readonly incomeReportsEnrolled: Scalars['Boolean']['output'];
  /**
   * Frozen edges targeting this household.
   * @deprecated Use professionalServices.
   */
  readonly incomingProfessionalRelationships: ReadonlyArray<ProfessionalRelationship>;
  /** Investment experience records for this household */
  readonly investmentExperiences: ReadonlyArray<InvestmentExperience>;
  /** Whether this household is enrolled in invoice reports */
  readonly invoicesEnrolled: Scalars['Boolean']['output'];
  /** The last assigned campaign for this household */
  readonly lastAssignedCampaign?: Maybe<AssignedCampaign>;
  readonly lastContactAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly leadResponseDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * External bank accounts authorized for transfers to/from any of this
   * household's Savvy-managed accounts. Union across the household.
   */
  readonly linkedBankAccounts: ReadonlyArray<LinkedBankAccount>;
  /** The reason this household was lost */
  readonly lossReason?: Maybe<Scalars['String']['output']>;
  /** Second drill-down of the traffic source (e.g. campaign, keyword, or landing page), synced from HubSpot. Read-only. */
  readonly marketingDetail?: Maybe<Scalars['String']['output']>;
  /** First drill-down of the traffic source (e.g. platform / search engine), synced from HubSpot. Read-only. */
  readonly marketingSource?: Maybe<Scalars['String']['output']>;
  /** Channel the lead first came from, synced from HubSpot Original Traffic Source (e.g. "Paid Social"). Read-only. */
  readonly marketingTrafficSource?: Maybe<Scalars['String']['output']>;
  /** Household memberships scoping member users to their role in this household */
  readonly memberships: ReadonlyArray<HouseholdMembership>;
  readonly name: Scalars['String']['output'];
  /**
   * The soonest upcoming service obligation for this household: the earliest due
   * date across pending Service Catalog v2 tasks and incomplete service-calendar
   * meetings, on or before the end of next quarter (overdue items included). Null
   * when none. Read this under flag-service-calendar-v2.
   */
  readonly nextServiceItemDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly nextUpcomingMeetings: ReadonlyArray<ServiceCalendarMeeting>;
  /** If the client is subject to any restrictive covenants */
  readonly nonSolicit?: Maybe<Scalars['Boolean']['output']>;
  /** The onboarding status for this household */
  readonly onboardingStatus?: Maybe<OnboardingTaskDatum>;
  /** Opportunities clients in this household have */
  readonly opportunities?: Maybe<ReadonlyArray<Opportunity>>;
  /** Organization household categories for this household */
  readonly organizationHouseholdCategories?: Maybe<ReadonlyArray<OrganizationHouseholdCategory>>;
  /** Organization household tags for this household */
  readonly organizationHouseholdTags?: Maybe<ReadonlyArray<OrganizationHouseholdTag>>;
  readonly orionHouseholdId?: Maybe<Scalars['Int']['output']>;
  /** History of Orion quarterly report generations for this household */
  readonly orionQuarterlyReportGenerations: ReadonlyArray<OrionQuarterlyReportGeneration>;
  readonly outstandingServiceCalendarItemCount?: Maybe<Scalars['Int']['output']>;
  readonly outstandingServiceCalendarItems: ReadonlyArray<ServiceCalendarItem>;
  /**
   * Count of pending Service Catalog (SC v2) tasks for this household due on or
   * before the end of the current quarter (overdue items included). Null when the
   * household has no Service Catalog assignments at all — render that as "Not set
   * up", distinct from 0, which means "assigned, nothing due". The v2 equivalent
   * of outstandingServiceCalendarItemCount — read this when the viewer is on
   * flag-service-calendar-v2.
   */
  readonly outstandingServiceCatalogTaskCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The people the household page lists for this household: its primary and
   * co-client, then family and other contacts by the page's familyMembers rule.
   * Readable by whoever may open the household page, archived households included,
   * and by the household's own clients
   */
  readonly people: HouseholdPeople;
  /** Whether this household is enrolled in performance report allocations reports */
  readonly performanceReportAllocationsEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in performance report consolidated reports */
  readonly performanceReportConsolidatedEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in performance report integrated reports */
  readonly performanceReportIntegratedEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in performance report sectors reports */
  readonly performanceReportSectorsEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in performance report unified reports */
  readonly performanceReportUnifiedEnrolled: Scalars['Boolean']['output'];
  readonly personalPortfolio?: Maybe<Portfolio>;
  /** Whether this household is enrolled in portfolio review portfolio group reports */
  readonly portfolioReviewPortfolioGroupEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in portfolio summary cash flows reports */
  readonly portfolioSummaryCashFlowsEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in portfolio summary comprehensive reports */
  readonly portfolioSummaryComprehensiveEnrolled: Scalars['Boolean']['output'];
  readonly portfolios: ReadonlyArray<Portfolio>;
  /**
   * The household primary client_profile, falling back to the
   * HouseholdMembership(owner) user's existing ClientProfile when the household
   * has no primary_client of its own (SV-940 cross-household reuse).
   */
  readonly primaryClient: Client;
  /**
   * State on the primary client's primary-residence address, resolved through the
   * same slot as primaryClient. Null when there is no primary client or no
   * primary-residence address.
   */
  readonly primaryClientState?: Maybe<Scalars['String']['output']>;
  /** Box subfolder ID for advisor-only ("private") household documents; null until the household is linked to Box. */
  readonly privateBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** The professional contacts serving this household that the viewer can read, newest first */
  readonly professionalServices: ReadonlyArray<ProfessionalService>;
  /** The prospect data for this household */
  readonly prospectData?: Maybe<ProspectDatum>;
  /** Box subfolder ID for client-visible ("public") household documents; null until the household is linked to Box. */
  readonly publicBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Whether this household is a qualified client */
  readonly qualifiedClient: Scalars['Boolean']['output'];
  /** The rationale for why this household is a qualified client */
  readonly qualifiedClientRationale?: Maybe<Scalars['String']['output']>;
  /** Whether this household is a qualified purchaser */
  readonly qualifiedPurchaser: Scalars['Boolean']['output'];
  /**
   * When an advisor last attested qualified purchaser status on one of this
   * household's Savvy Growth Opportunities Fund enrollments
   */
  readonly qualifiedPurchaserAttestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The rationale for why this household is a qualified purchaser */
  readonly qualifiedPurchaserRationale?: Maybe<Scalars['String']['output']>;
  /** Whether this household is enrolled in quarterly reports (long) */
  readonly quarterlyReportsLongEnrolled: Scalars['Boolean']['output'];
  /** Whether this household is enrolled in quarterly reports (short) */
  readonly quarterlyReportsShortEnrolled: Scalars['Boolean']['output'];
  /** The ID of the entity that referred this household */
  readonly referralEntityId?: Maybe<Scalars['ID']['output']>;
  /** The type of the entity that referred this household (User or CenterOfInfluenceRep) */
  readonly referralEntityType?: Maybe<Scalars['String']['output']>;
  /** Households this household referred to the firm that the viewer can read, newest first */
  readonly referralsMade: ReadonlyArray<HouseholdReferral>;
  readonly salesforceAccountId?: Maybe<Scalars['String']['output']>;
  readonly savvyAum?: Maybe<Scalars['BigDecimal']['output']>;
  readonly serviceCalendarItemsDueNextQuarter: ReadonlyArray<ServiceCalendarItem>;
  readonly serviceCalendarSettings: ReadonlyArray<ServiceCalendarSetting>;
  /** Box subfolder ID for task-attachment documents; null until the household is linked to Box. */
  readonly taskAttachmentsBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Box subfolder ID for task-upload documents; null until the household is linked to Box. */
  readonly taskUploadsBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Tasks created for this household */
  readonly tasks: ReadonlyArray<Task>;
  /** Which tax enrollment banner to show, if any */
  readonly taxEnrollmentBannerStatus: TaxEnrollmentBannerStatus;
  /** Tax enrollments for this household */
  readonly taxEnrollments?: Maybe<ReadonlyArray<TaxEnrollment>>;
  /** Last update date for this household */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly users: ReadonlyArray<User>;
  /** Public-facing UUID for this household; preferred over salesforce_account_id for new code */
  readonly uuid: Scalars['String']['output'];
  /** The current viewer's membership in this household, if any (null for advisors without a membership) */
  readonly viewerMembership?: Maybe<HouseholdMembership>;
};


export type HouseholdAccountConfirmationTaskArgs = {
  taskId?: InputMaybe<Scalars['ID']['input']>;
};


export type HouseholdAccountsArgs = {
  source?: InputMaybe<ProviderAccountSource>;
};


export type HouseholdAssignedAdvisorsArgs = {
  advisorRoleOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HouseholdFamilyMemberArgs = {
  contactId: Scalars['ID']['input'];
};

export type HouseholdAccessAuditResult = {
  readonly __typename?: 'HouseholdAccessAuditResult';
  readonly advisorName: Scalars['String']['output'];
  readonly advisorUserId: Scalars['ID']['output'];
  readonly boxAccess: Scalars['Boolean']['output'];
  readonly householdId: Scalars['ID']['output'];
  readonly householdName: Scalars['String']['output'];
  readonly salesforceAccess: Scalars['Boolean']['output'];
  readonly savvyPermissions: Scalars['Boolean']['output'];
};

export const HouseholdAccessLevel = {
  /** Edit access level */
  Edit: 'EDIT',
  /** No access level */
  NoAccess: 'NO_ACCESS'
} as const;

export type HouseholdAccessLevel = typeof HouseholdAccessLevel[keyof typeof HouseholdAccessLevel];
/** A household's advisor, name only, for surfaces that label a household with who runs it */
export type HouseholdAdvisor = {
  readonly __typename?: 'HouseholdAdvisor';
  /** The advisor profile id */
  readonly id: Scalars['ID']['output'];
  /** The advisor's full name */
  readonly name: Scalars['String']['output'];
};

/** A household's proposals and the count still waiting for a decision. */
export type HouseholdAgentProposals = {
  readonly __typename?: 'HouseholdAgentProposals';
  /** Proposals waiting for an advisor decision. */
  readonly pendingCount: Scalars['Int']['output'];
  /** The proposals, oldest first. */
  readonly proposals: ReadonlyArray<AgentProposal>;
  /** When Savvy started waiting to push accepted plan values to the planning engine. */
  readonly syncPendingSince?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Household-level cash available to invest, summed across the household's Eclipse-linked (managed) accounts. */
export type HouseholdAvailableToInvest = {
  readonly __typename?: 'HouseholdAvailableToInvest';
  /**
   * Sum of free_cash_available (cash available minus pending Savvy-initiated
   * trades) across Eclipse-linked accounts. Null only when Eclipse is unreachable;
   * 0 when the household has no Eclipse-linked accounts.
   */
  readonly availableToInvest?: Maybe<Value>;
  /** ok, no_eclipse_accounts, or orion_unreachable. available_to_invest is null only when orion_unreachable. */
  readonly readStatus: Scalars['String']['output'];
};

/**
 * A blended benchmark available in Orion (e.g. "60% Russell 3000 / 40% BBG US
 * Agg"), selectable in the Report Builder benchmark picker.
 */
export type HouseholdBenchmarkBlend = {
  readonly __typename?: 'HouseholdBenchmarkBlend';
  /** Human-readable blend name shown in the picker (Orion's benchmark name). */
  readonly label: Scalars['String']['output'];
  /** Orion benchmark key to persist on the household, e.g. "5_B". */
  readonly value: Scalars['String']['output'];
};

/** The connection type for Household. */
export type HouseholdConnection = {
  readonly __typename?: 'HouseholdConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<HouseholdEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Household>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Aggregate total advisor annual revenue */
  readonly totalAdvisorAnnualRevenue?: Maybe<Scalars['BigInt']['output']>;
  /** Total number of households */
  readonly totalCount: Scalars['Int']['output'];
  /** Aggregate total Savvy AUM */
  readonly totalSavvyAum?: Maybe<Scalars['BigInt']['output']>;
};

/** A household contact on one side of a referral, with only what the referral pages render. */
export type HouseholdContactReferralParticipant = {
  readonly __typename?: 'HouseholdContactReferralParticipant';
  /** The contact id, which the contact page is keyed on. */
  readonly id: Scalars['ID']['output'];
  /** The contact's name. */
  readonly name: Scalars['String']['output'];
};

/** An edge in a connection. */
export type HouseholdEdge = {
  readonly __typename?: 'HouseholdEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Household>;
};

/** One service a household is enrolled in, resolved through the enrollment's own service foreign key */
export type HouseholdEnrolledService = {
  readonly __typename?: 'HouseholdEnrolledService';
  /** Colour key for the service identity chip (4C1T-570) */
  readonly colorKey: Scalars['String']['output'];
  /** Long-form description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Icon key for the service identity chip (4C1T-570) */
  readonly iconKey: Scalars['String']['output'];
  /** The service id. A card links to the service with it */
  readonly id: Scalars['ID']['output'];
  /** One entry per enrolled item — "task" or "event" — so a card can count them itself and read "1 task · 1 event" */
  readonly itemTypes: ReadonlyArray<Scalars['String']['output']>;
  /** Service name */
  readonly name: Scalars['String']['output'];
  /**
   * True when every one of the household's enrollments in this service is paused,
   * which is how unenrolling is recorded. A service with some items still live
   * reads as not paused
   */
  readonly paused: Scalars['Boolean']['output'];
};

/** Household-scoped service calendar v1 export data */
export type HouseholdExport = {
  readonly __typename?: 'HouseholdExport';
  readonly householdId: Scalars['ID']['output'];
  readonly householdName: Scalars['String']['output'];
  readonly householdStage: Scalars['String']['output'];
  readonly meetings: ReadonlyArray<MeetingInstance>;
  readonly primaryClientName?: Maybe<Scalars['String']['output']>;
  readonly serviceItems: ReadonlyArray<ServiceItemInstance>;
};

/** A fee schedule for a household, saved on onboarding task creation */
export type HouseholdFeeSchedule = {
  readonly __typename?: 'HouseholdFeeSchedule';
  /** Whether the fee schedule is active on household */
  readonly active: Scalars['Boolean']['output'];
  /** The type of amount for the fee schedule - percentage or dollar */
  readonly amountType?: Maybe<FeeScheduleAmountTypes>;
  /** The description of the fee schedule */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The type of fee schedule - flat, tiered, or linear */
  readonly feeType: FeeScheduleFeeTypes;
  /** The flat fee amount for the fee schedule */
  readonly flatFeeAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** associated with household */
  readonly householdId: Scalars['ID']['output'];
  /** household fee schedule id */
  readonly id: Scalars['ID']['output'];
  /** The minimum fee for the fee schedule */
  readonly minimumFee?: Maybe<Scalars['BigDecimal']['output']>;
  /** The name of the fee schedule */
  readonly name: Scalars['String']['output'];
  /** The tiers for the fee schedule */
  readonly tiers?: Maybe<Scalars['JSON']['output']>;
};

/** One set of fee schedule terms recorded on households, and how many households carry it */
export type HouseholdFeeScheduleUsage = {
  readonly __typename?: 'HouseholdFeeScheduleUsage';
  /** The type of amount for the fee schedule - percentage or dollar */
  readonly amountType?: Maybe<FeeScheduleAmountTypes>;
  /** The type of fee schedule - flat, tiered, or linear */
  readonly feeType: FeeScheduleFeeTypes;
  /** The flat fee amount for the fee schedule */
  readonly flatFeeAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** Households whose active fee schedule has exactly these terms */
  readonly householdCount: Scalars['Int']['output'];
  /** The minimum fee for the fee schedule */
  readonly minimumFee?: Maybe<Scalars['BigDecimal']['output']>;
  /** The fee schedule name */
  readonly name: Scalars['String']['output'];
  /** The tiers for the fee schedule */
  readonly tiers?: Maybe<Scalars['JSON']['output']>;
};

/**
 * How far a household has got in opening and funding its managed accounts, derived
 * by Orion::HouseholdTransferSettlement. Never derived from clientStage, which is
 * advanced by a human action and sits stale on thousands of long-funded households
 */
export const HouseholdFundingPhase = {
  /** No account is on a transfer path yet — none is Orion-connected. A brand-new household lands here, not in TRANSFERRING */
  AwaitingAccountOpening: 'AWAITING_ACCOUNT_OPENING',
  /** Every account on a transfer path has funded */
  Funded: 'FUNDED',
  /**
   * Every account on a transfer path is terminal — closed, deleted, or cancelled.
   * A book that died before funding and a client who has since closed everything
   * both land here. Deliberately distinct from AWAITING_ACCOUNT_OPENING so a
   * surface cannot promise to open accounts for a household that has none coming
   */
  NoActiveAccounts: 'NO_ACTIVE_ACCOUNTS',
  /**
   * Something has funded and something is still in flight. The common case for an
   * established household that has just opened one more account, and it also
   * covers a household whose funded accounts have all since closed, so surfaces
   * should treat it as funded-with-a-transfer rather than as a transferring client
   */
  PartiallyFunded: 'PARTIALLY_FUNDED',
  /**
   * Accounts are on a transfer path and nothing has ever funded for this household
   * — a first transfer, so a surface can show day-one treatment without hiding an
   * established client's own history. Funding by any route counts, so an account
   * the client wired money into leaves this phase
   */
  Transferring: 'TRANSFERRING'
} as const;

export type HouseholdFundingPhase = typeof HouseholdFundingPhase[keyof typeof HouseholdFundingPhase];
/**
 * Whether a household is still opening and funding its managed accounts, at both
 * the household and the per-account level, so each surface can pick the level it needs
 */
export type HouseholdFundingState = {
  readonly __typename?: 'HouseholdFundingState';
  /**
   * Every account on a transfer path, including terminal ones. Accounts on an
   * Orion status that is not a transfer path are absent entirely. Empty for a
   * household with no Orion-connected accounts
   */
  readonly accounts: ReadonlyArray<AccountFundingState>;
  /** The Savvy ID of the household */
  readonly householdId: Scalars['ID']['output'];
  /** The household rollup */
  readonly phase: HouseholdFundingPhase;
};

/**
 * A short, durable statement of what has actually been discussed with a household,
 * written by a model and saved once per household
 */
export type HouseholdKeepInMind = {
  readonly __typename?: 'HouseholdKeepInMind';
  /** When the text last changed. A no-op rewrite holds this steady, so a vote cast against it stays attached */
  readonly generatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Zero to three items. Empty means nothing has been written yet — the section mounts on this and polls */
  readonly items: ReadonlyArray<HouseholdKeepInMindItem>;
  /** A rewrite is running. This is what the section polls on, so the frontend never re-derives the freshness comparison */
  readonly refreshing: Scalars['Boolean']['output'];
};

/** Why an advisor marked a "Keep in mind" item unhelpful */
export const HouseholdKeepInMindIssueTypeEnum = {
  /** The claim rests on something untrue */
  IncorrectAssumptions: 'INCORRECT_ASSUMPTIONS',
  /** The claim is factually wrong */
  IncorrectInformation: 'INCORRECT_INFORMATION',
  /** True, but not worth surfacing */
  NotRelevant: 'NOT_RELEVANT',
  /** Something else, described in the comment */
  Other: 'OTHER',
  /** The claim was true and no longer is */
  OutdatedInformation: 'OUTDATED_INFORMATION',
  /** Too general to act on */
  TooVague: 'TOO_VAGUE'
} as const;

export type HouseholdKeepInMindIssueTypeEnum = typeof HouseholdKeepInMindIssueTypeEnum[keyof typeof HouseholdKeepInMindIssueTypeEnum];
/** One short, durable statement about what has actually been discussed with a household */
export type HouseholdKeepInMindItem = {
  readonly __typename?: 'HouseholdKeepInMindItem';
  /** One or two sentences. Null only on the priorities item, when there is not enough recent client contact to fill it */
  readonly body?: Maybe<Scalars['String']['output']>;
  /** Stored rather than inferred, so the section can pin the fixed item first without matching on title text */
  readonly kind: HouseholdKeepInMindItemKindEnum;
  /** The current user's vote on this item at the row's current generation, so a pinned thumb survives a reload */
  readonly myVote?: Maybe<HouseholdKeepInMindVoteEnum>;
  /** Always null on the priorities item — its heading is a frontend constant, so the model cannot reword it */
  readonly title?: Maybe<Scalars['String']['output']>;
};

/** Which kind of "Keep in mind" item this is */
export const HouseholdKeepInMindItemKindEnum = {
  /** The fixed first item: what the household is trying to do with their money */
  Priorities: 'PRIORITIES',
  /** A running theme the model titled itself */
  Theme: 'THEME'
} as const;

export type HouseholdKeepInMindItemKindEnum = typeof HouseholdKeepInMindItemKindEnum[keyof typeof HouseholdKeepInMindItemKindEnum];
/** Advisor feedback on one "Keep in mind" item */
export const HouseholdKeepInMindVoteEnum = {
  /** The item was not useful */
  Down: 'DOWN',
  /** The item was useful */
  Up: 'UP'
} as const;

export type HouseholdKeepInMindVoteEnum = typeof HouseholdKeepInMindVoteEnum[keyof typeof HouseholdKeepInMindVoteEnum];
/** Field that matched a household search query, used to explain why a result appeared */
export const HouseholdMatchField = {
  /** CLIENT_NAME */
  ClientName: 'CLIENT_NAME',
  /** EMAIL */
  Email: 'EMAIL',
  /** HOUSEHOLD_NAME */
  HouseholdName: 'HOUSEHOLD_NAME',
  /** PHONE */
  Phone: 'PHONE',
  /** SECONDARY_EMAIL */
  SecondaryEmail: 'SECONDARY_EMAIL',
  /** SECONDARY_PHONE */
  SecondaryPhone: 'SECONDARY_PHONE'
} as const;

export type HouseholdMatchField = typeof HouseholdMatchField[keyof typeof HouseholdMatchField];
/**
 * Explains why a household search result matched the query — which field, the
 * matched value, and (for member fields) the owning client
 */
export type HouseholdMatchInfo = {
  readonly __typename?: 'HouseholdMatchInfo';
  /** The owning client's display name; null when the matched field is HOUSEHOLD_NAME */
  readonly context?: Maybe<Scalars['String']['output']>;
  /** Which field the query matched */
  readonly field: HouseholdMatchField;
  /** The matched value (e.g. household name, client name, email, phone) */
  readonly value: Scalars['String']['output'];
};

/** Represents a user's role-scoped membership in a household. */
export type HouseholdMembership = {
  readonly __typename?: 'HouseholdMembership';
  /** Whether this member can sign client agreements for the household. */
  readonly canSignClientAgreement: Scalars['Boolean']['output'];
  /**
   * The underlying ClientProfile if the member user is a client. Lets advisor
   * surfaces source the same PII (employment, SSN, DOB, addresses) via memberships
   * instead of household.client_profiles.
   */
  readonly clientProfile?: Maybe<Client>;
  /** When the membership was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The ID of the household. */
  readonly householdId: Scalars['ID']['output'];
  /** The ID of the household membership. */
  readonly id: Scalars['ID']['output'];
  /** Whether this member is an account holder on household accounts. */
  readonly isAccountHolder: Scalars['Boolean']['output'];
  /** The role the user holds in the household. */
  readonly role: HouseholdMembershipRole;
  /** Free-form description of the member's trustee capacity, if applicable. */
  readonly trusteeCapacity?: Maybe<Scalars['String']['output']>;
  /** The member user (minimal info for advisor roster UI). */
  readonly user: UserLookupResult;
  /** The ID of the member user. */
  readonly userId: Scalars['ID']['output'];
};

/** The role a user plays within a household they are a member of. */
export const HouseholdMembershipRole = {
  /** authorized_viewer */
  AuthorizedViewer: 'authorized_viewer',
  /** beneficiary */
  Beneficiary: 'beneficiary',
  /** co_owner */
  CoOwner: 'co_owner',
  /** co_trustee */
  CoTrustee: 'co_trustee',
  /** owner */
  Owner: 'owner',
  /** trustee */
  Trustee: 'trustee'
} as const;

export type HouseholdMembershipRole = typeof HouseholdMembershipRole[keyof typeof HouseholdMembershipRole];
/** Simplified household data for filter options */
export type HouseholdOption = {
  readonly __typename?: 'HouseholdOption';
  /** Household ID */
  readonly id: Scalars['ID']['output'];
  /** Household name */
  readonly name: Scalars['String']['output'];
};

/** The people the household page lists for one household: its clients, then its family and other contacts */
export type HouseholdPeople = {
  readonly __typename?: 'HouseholdPeople';
  /** The household page's co-client, if the household has one */
  readonly coClient?: Maybe<Client>;
  /**
   * Family and other contacts, by the household page's familyMembers rule. That
   * rule also takes every contact recorded against the primary client in person,
   * so for a client who owns more than one household it lists their home
   * household's contacts too, as the page does
   */
  readonly familyMembers: ReadonlyArray<FamilyMember>;
  /**
   * The household page's primary client. Null when the household resolves no
   * primary client profile, such as a lead with no clients yet, where the page
   * itself would fail
   */
  readonly primaryClient?: Maybe<Client>;
};

/** A household one household referred to the firm */
export type HouseholdReferral = {
  readonly __typename?: 'HouseholdReferral';
  /** The household that was referred */
  readonly household: Household;
  /** The referral id */
  readonly id: Scalars['ID']['output'];
  /** The month the referral happened, when known */
  readonly referredOn?: Maybe<Scalars['ISO8601Date']['output']>;
};

/**
 * How much work unenrolling one household from this service would be, in the same
 * unit the unenroll mutation budgets against. Scalars rather than
 * Models::Household: the caller already holds the id, and a denied read policy
 * would raise rather than null the field, failing the whole query
 */
export type HouseholdRemovableAssignments = {
  readonly __typename?: 'HouseholdRemovableAssignments';
  /**
   * Assignment rows unenrolling this household from this service would pause.
   * Counts what the service owns — rows naming it, plus unattributed rows on an
   * item no other live service lists — including rows on items since removed from
   * the service or since archived, which is exactly why a caller cannot derive
   * this from the items it can see
   */
  readonly count: Scalars['Int']['output'];
  /** The household this count is for */
  readonly householdId: Scalars['ID']['output'];
};

/** A report schedule as it applies to a specific household, with latest execution status. */
export type HouseholdReportSchedule = {
  readonly __typename?: 'HouseholdReportSchedule';
  /** Whether the schedule is currently enabled */
  readonly active: Scalars['Boolean']['output'];
  /** Whether PDFs are uploaded to Box */
  readonly deliverToBox: Scalars['Boolean']['output'];
  /** Whether reports are published to the client portal */
  readonly deliverToPortal: Scalars['Boolean']['output'];
  /** Day of month (1-28) when the schedule fires */
  readonly deliveryDay: Scalars['Int']['output'];
  /** Month (1-12) an annual schedule fires; null means January */
  readonly deliveryMonth?: Maybe<Scalars['Int']['output']>;
  /** Cadence: monthly, quarterly, or annually */
  readonly frequency: Scalars['String']['output'];
  /** Schedule id */
  readonly id: Scalars['ID']['output'];
  /** When the most recent execution ran */
  readonly lastExecutionAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Error message from the most recent execution, if failed */
  readonly lastExecutionError?: Maybe<Scalars['String']['output']>;
  /** Status of the most recent execution for this household */
  readonly lastExecutionStatus?: Maybe<Scalars['String']['output']>;
  /** When the schedule last fired */
  readonly lastRunAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Next scheduled execution time */
  readonly nextDueAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Saved report template name */
  readonly templateName: Scalars['String']['output'];
};

/** The connection type for Household. */
export type HouseholdSearchConnection = {
  readonly __typename?: 'HouseholdSearchConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<HouseholdSearchEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Household>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** Edge wrapping a Household search result with match attribution explaining why it appeared */
export type HouseholdSearchEdge = {
  readonly __typename?: 'HouseholdSearchEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /**
   * Per-field match attributions ordered by field priority then score descending;
   * empty when the result has no attribution (e.g. recent-households fallback).
   */
  readonly matchInfos: ReadonlyArray<HouseholdMatchInfo>;
  /** The item at the end of the edge. */
  readonly node?: Maybe<Household>;
};

/** A single service occurrence for one household, in either the Task or the occurrence shape */
export type HouseholdServiceOccurrence = {
  readonly __typename?: 'HouseholdServiceOccurrence';
  /** AfterPrevious cadence in days. Mutually exclusive with a recurrence pattern */
  readonly afterPreviousOffsetDays?: Maybe<Scalars['Int']['output']>;
  /** Whether the enrollment is paused. Null when the enrollment is gone */
  readonly assignmentPaused?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Structured cadence, for the specific readout. Null on an item predating
   * presets, which still recurs — read the carriers below
   */
  readonly cadencePreset?: Maybe<Scalars['JSON']['output']>;
  /**
   * The item's booking link. `MeetingBooking` carries cancel/reschedule/join URLs
   * for an EXISTING booking, and no link to make one
   */
  readonly calendlyLink?: Maybe<Scalars['String']['output']>;
  /** Scheduling link safe to hand a client. Null when none can be given yet. */
  readonly clientSchedulingUrl?: Maybe<Scalars['String']['output']>;
  /** When the invite is due to go out, from this occurrence's snapshot */
  readonly computedSendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Body from this occurrence's own frozen snapshot */
  readonly emailBody?: Maybe<Scalars['String']['output']>;
  /** Days before the occurrence date that the email is due to go out */
  readonly emailLeadTimeDays: Scalars['Int']['output'];
  /** Subject from this occurrence's own frozen snapshot */
  readonly emailSubject?: Maybe<Scalars['String']['output']>;
  /** True when an advisor reworded this occurrence alone, so a later template edit will not reach it */
  readonly hasOwnEmailCopy: Scalars['Boolean']['output'];
  /**
   * Typed occurrence id — "task-123" or "occurrence-456". The two tables'
   * sequences are independent, so a bare integer would be ambiguous
   */
  readonly id: Scalars['ID']['output'];
  /** Long-form description of the catalog item — `itemName`'s sibling, and not the service's own description */
  readonly itemDescription?: Maybe<Scalars['String']['output']>;
  /** Name of the catalog item that materialized this occurrence */
  readonly itemName: Scalars['String']['output'];
  /** task or event */
  readonly itemType: Scalars['String']['output'];
  /**
   * When this occurrence alone was last emailed to the client. The enrolment field
   * of the same name is one timestamp for every occurrence of the item, so it
   * reads as reminded on occurrences that never were
   */
  readonly lastReminderSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The timeline interaction recorded as having satisfied this occurrence, if any */
  readonly linkedInteraction?: Maybe<ServiceOccurrenceInteractionLink>;
  /** Calendly tracking. In the occurrence shape this row IS the booking */
  readonly meetingBooking?: Maybe<MeetingBooking>;
  /** Which occurrence of the cadence this is */
  readonly occurrenceDate: Scalars['ISO8601Date']['output'];
  /** First day an open occurrence reads overdue: the day after its last planned reminder, else after its date */
  readonly overdueOn: Scalars['ISO8601Date']['output'];
  /**
   * Who owes this occurrence: the task's assignee, else the item's default
   * assignee, else the household's advisor. Null when none of the three is set
   */
  readonly ownerName?: Maybe<Scalars['String']['output']>;
  /** RRULE recurrence pattern id, when the item recurs on a pattern rather than after the prior item */
  readonly recurrencePatternId?: Maybe<Scalars['ID']['output']>;
  /** Reminders the forward campaign was frozen with. Null on a legacy or Task-shaped row */
  readonly remindersPlanned?: Maybe<Scalars['Int']['output']>;
  /** Planned reminders of a forward campaign that were delivered. Null on a legacy or Task-shaped row */
  readonly remindersSent?: Maybe<Scalars['Int']['output']>;
  /**
   * Opaque concurrency token. Echo it back to an occurrence-scoped mutation and
   * the write is refused if the row has changed since
   */
  readonly revision?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the item dispatches email when due. False means `computedSendAt` here
   * describes mail SendDueEmailsJob consumes without delivering
   */
  readonly sendNotification: Scalars['Boolean']['output'];
  /** The enrollment this came from. Null once that enrollment is gone — a past occurrence outlives it */
  readonly serviceCatalogItemHouseholdId?: Maybe<Scalars['ID']['output']>;
  /** The service's icon key. Null when the enrollment carries no service */
  readonly serviceIconKey?: Maybe<Scalars['String']['output']>;
  /** Id of the service the enrollment belongs to. Null for a historical enrollment that carries none */
  readonly serviceId?: Maybe<Scalars['ID']['output']>;
  /** The service the enrollment belongs to. Null for a historical enrollment that carries none */
  readonly serviceName?: Maybe<Scalars['String']['output']>;
  /** Derived server-side and never re-derived by the client */
  readonly status: OccurrenceStatus;
  /** When the row's status last moved */
  readonly statusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export const HouseholdStage = {
  Commitment: 'commitment',
  Discovery: 'discovery',
  Disqualified: 'disqualified',
  Inactive: 'inactive',
  Lead: 'lead',
  Lost: 'lost',
  OnHold: 'on_hold',
  Onboarding: 'onboarding',
  Proposal: 'proposal',
  Prospecting: 'prospecting',
  Won: 'won'
} as const;

export type HouseholdStage = typeof HouseholdStage[keyof typeof HouseholdStage];
export type HouseholdTag = {
  readonly __typename?: 'HouseholdTag';
  readonly household: Household;
  readonly id: Scalars['ID']['output'];
  readonly organizationHouseholdCategory: OrganizationHouseholdCategory;
  readonly organizationHouseholdTag: OrganizationHouseholdTag;
};

/** Autogenerated input type of HouseholdWorkflowCreationBackfiller */
export type HouseholdWorkflowCreationBackfillerInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly daysToBackfill?: InputMaybe<Scalars['Int']['input']>;
  readonly householdId: Scalars['ID']['input'];
};

export type ImageReplacement = {
  /** Text in the template that identifies the placeholder image to be replaced. */
  readonly placeholder: Scalars['String']['input'];
  /** The base64 encoded image data to replace the placeholder with. */
  readonly replaceWithImageBase64: Scalars['String']['input'];
};

/** Autogenerated input type of ImpersonateUser */
export type ImpersonateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of ImpersonateUser. */
export type ImpersonateUserPayload = {
  readonly __typename?: 'ImpersonateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly currentUser: User;
  readonly trueUser: User;
};

/** A single CRM contact destined for the primary/co-client/related slot. */
export type ImportClientSummary = {
  readonly __typename?: 'ImportClientSummary';
  /** ISO-8601 date string, when present. */
  readonly dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Principal WB email, or first listed. */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** WB contact first name. */
  readonly firstName: Scalars['String']['output'];
  /** WB contact last name. */
  readonly lastName: Scalars['String']['output'];
  /** Principal WB phone, or first listed. */
  readonly phone?: Maybe<Scalars['String']['output']>;
  /** primary | co-client | household_member */
  readonly role: Scalars['String']['output'];
  /** Validation note that would prevent or weaken import (e.g. 'missing email'). */
  readonly warning?: Maybe<Scalars['String']['output']>;
};

/** One CRM household (or ungrouped contact) destined for import. */
export type ImportHouseholdSummary = {
  readonly __typename?: 'ImportHouseholdSummary';
  /** Members that will become Pinetree primary/co-client (max 2). */
  readonly clientCount: Scalars['Int']['output'];
  /** Per-client breakdown for the primary/co-client/related slots. */
  readonly clients: ReadonlyArray<ImportClientSummary>;
  /** Names of all members in this CRM group. */
  readonly memberNames: ReadonlyArray<Scalars['String']['output']>;
  /** CRM household name (or derived contact name for ungrouped). */
  readonly name: Scalars['String']['output'];
  /** Members beyond the first 2 that will land as related_contacts. */
  readonly relatedContactCount: Scalars['Int']['output'];
  /** Stable key used by household_actions, e.g. "wb:household:42" or "wb:contact:99". */
  readonly stagingKey: Scalars['String']['output'];
  /** Auto-suggested Pinetree household to map to (null = no match). */
  readonly suggestedMatch?: Maybe<ImportMatchSuggestion>;
  /** CRM tags collected across all members of this household. */
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
  /** Household-level validation warnings that may block or weaken import. */
  readonly warnings: ReadonlyArray<Scalars['String']['output']>;
};

/** Suggested mapping from a CRM household to an existing Pinetree household. */
export type ImportMatchSuggestion = {
  readonly __typename?: 'ImportMatchSuggestion';
  /** high | medium */
  readonly confidence: Scalars['String']['output'];
  /** The Pinetree Household ID we believe matches. */
  readonly householdId: Scalars['ID']['output'];
  /** Display name of the matched Pinetree household. */
  readonly householdName: Scalars['String']['output'];
};

/** How often a client income source pays out. Recurring cadences only. */
export const IncomeFrequency = {
  /** 1 payment a year */
  Annually: 'ANNUALLY',
  /** 26 payments a year */
  Biweekly: 'BIWEEKLY',
  /** 12 payments a year */
  Monthly: 'MONTHLY',
  /** 4 payments a year */
  Quarterly: 'QUARTERLY',
  /** 2 payments a year */
  SemiAnnually: 'SEMI_ANNUALLY',
  /** 24 payments a year */
  SemiMonthly: 'SEMI_MONTHLY',
  /** 52 payments a year */
  Weekly: 'WEEKLY'
} as const;

export type IncomeFrequency = typeof IncomeFrequency[keyof typeof IncomeFrequency];
/** The kind of recurring income a client income source represents */
export const IncomeSourceType = {
  /** 1099 contract work */
  Contract_1099: 'CONTRACT_1099',
  /** Any other recurring income, e.g. a pension or annuity */
  Other: 'OTHER',
  /** Rental property income */
  Rental: 'RENTAL',
  /** Self-employment or business ownership */
  SelfEmployment: 'SELF_EMPLOYMENT',
  /** W-2 employment */
  W2Employment: 'W2_EMPLOYMENT'
} as const;

export type IncomeSourceType = typeof IncomeSourceType[keyof typeof IncomeSourceType];
export const InitialTransferTypeName = {
  Acat: 'acat',
  Lpoa: 'lpoa'
} as const;

export type InitialTransferTypeName = typeof InitialTransferTypeName[keyof typeof InitialTransferTypeName];
/** A single intake question and the advisor's free-text answer. */
export type IntakeAnswerInput = {
  /** The advisor's free-text answer. */
  readonly answer: Scalars['String']['input'];
  /** The question text as shown to the advisor. */
  readonly question: Scalars['String']['input'];
};

/** One question and answer from Allocate's investing entity intake questionnaire. */
export type IntakeRow = {
  readonly __typename?: 'IntakeRow';
  /** The question, exactly as worded in the questionnaire. */
  readonly label: Scalars['String']['output'];
  /** The answer, or null when the question does not apply. */
  readonly value?: Maybe<Scalars['String']['output']>;
};

export const InternalAdminAction = {
  /** Backfill Conquest financial plans for an advisor */
  BackfillConquestPlans: 'BackfillConquestPlans',
  /** Create household and users from Salesforce account id */
  CreateHouseholdAndUsersFromSalesforceAccountWorker: 'CreateHouseholdAndUsersFromSalesforceAccountWorker'
} as const;

export type InternalAdminAction = typeof InternalAdminAction[keyof typeof InternalAdminAction];
/** Investment experience data for a household */
export type InvestmentExperience = {
  readonly __typename?: 'InvestmentExperience';
  /** The ID of the investment experience */
  readonly id: Scalars['ID']['output'];
  /** The experience rows */
  readonly investmentExperienceRows: ReadonlyArray<InvestmentExperienceRow>;
  /** The variant of the experience (general or alternative) */
  readonly variant: Scalars['String']['output'];
};

/** Investment experience data for a single instrument category */
export type InvestmentExperienceCategoryInput = {
  /** Average dollar amount per transaction */
  readonly avgDollarPerTransaction?: InputMaybe<Scalars['Float']['input']>;
  /** Average number of trades per year */
  readonly avgTradesPerYear?: InputMaybe<Scalars['Int']['input']>;
  /** Number of years trading this instrument */
  readonly yearsTrading?: InputMaybe<Scalars['Int']['input']>;
};

/** Investment experience grid across all instrument categories */
export type InvestmentExperienceGridInput = {
  /** Bonds trading experience */
  readonly bonds?: InputMaybe<InvestmentExperienceCategoryInput>;
  /** Commodities trading experience */
  readonly commodities?: InputMaybe<InvestmentExperienceCategoryInput>;
  /** Options trading experience */
  readonly optionsTrading?: InputMaybe<InvestmentExperienceCategoryInput>;
  /** Other financial instruments experience */
  readonly otherFinancialInstruments?: InputMaybe<InvestmentExperienceCategoryInput>;
  /** Stock trading experience */
  readonly stockTrading?: InputMaybe<InvestmentExperienceCategoryInput>;
};

/** A single row of investment experience data */
export type InvestmentExperienceRow = {
  readonly __typename?: 'InvestmentExperienceRow';
  /** Average dollar amount per transaction */
  readonly avgDollarAmount?: Maybe<Scalars['Float']['output']>;
  /** Average trades per year */
  readonly avgTradesPerYear?: Maybe<Scalars['Int']['output']>;
  /** The ID of the investment experience row */
  readonly id: Scalars['ID']['output'];
  /** The instrument name */
  readonly instrument: Scalars['String']['output'];
  /** Percentage of holdings */
  readonly pctOfHoldings?: Maybe<Scalars['Float']['output']>;
  /** Years of experience */
  readonly years?: Maybe<Scalars['Int']['output']>;
};

/** Input for a single investment experience row */
export type InvestmentExperienceRowInput = {
  /** The instrument name (e.g., stocks, bonds, options_and_futures, real_estate, private_equity_and_hedge_fund, other) */
  readonly instrument: Scalars['String']['input'];
  /** Percentage of holdings for this instrument */
  readonly pctOfHoldings?: InputMaybe<Scalars['Float']['input']>;
  /** Years of experience with this instrument */
  readonly years?: InputMaybe<Scalars['Int']['input']>;
};

export const InvestmentObjectiveName = {
  AggressiveGrowth: 'aggressive_growth',
  Conservative: 'conservative',
  Growth: 'growth',
  GrowthAndIncome: 'growth_and_income',
  Income: 'income'
} as const;

export type InvestmentObjectiveName = typeof InvestmentObjectiveName[keyof typeof InvestmentObjectiveName];
export const InvestmentProposalCharts = {
  /** Asset_Class_Exposure */
  AssetClassExposure: 'Asset_Class_Exposure',
  /** Client_Top_Holdings */
  ClientTopHoldings: 'Client_Top_Holdings',
  /** Cumulative_And_Periodic_Returns */
  CumulativeAndPeriodicReturns: 'Cumulative_And_Periodic_Returns',
  /** Expense_Ratio */
  ExpenseRatio: 'Expense_Ratio',
  /** Key_Metrics */
  KeyMetrics: 'Key_Metrics',
  /** Max_Drawdown */
  MaxDrawdown: 'Max_Drawdown',
  /** Portfolio_Yield */
  PortfolioYield: 'Portfolio_Yield',
  /** Region_Exposure */
  RegionExposure: 'Region_Exposure',
  /** Sector_Exposure */
  SectorExposure: 'Sector_Exposure',
  /** Top_Holdings */
  TopHoldings: 'Top_Holdings'
} as const;

export type InvestmentProposalCharts = typeof InvestmentProposalCharts[keyof typeof InvestmentProposalCharts];
/** An Orion Connect trading model explicitly enabled for investment proposals by advisor group */
export type InvestmentProposalOrionModel = {
  readonly __typename?: 'InvestmentProposalOrionModel';
  /** The Savvy advisor group that grants access to this model */
  readonly advisorGroupId: Scalars['ID']['output'];
  /** The Savvy advisor group name that grants access to this model */
  readonly advisorGroupName: Scalars['String']['output'];
  /** The Orion model display name */
  readonly name: Scalars['String']['output'];
  /** The Orion Connect Trading Model id */
  readonly orionConnectModelId: Scalars['String']['output'];
};

export type InvestmentProposalReplacementData = {
  /** An array of image replacement data. */
  readonly imageReplacements: ReadonlyArray<ImageReplacement>;
  /** An array of text replacement data. */
  readonly textReplacements: ReadonlyArray<TextReplacement>;
};

/** Investment proposal request data associated with a task */
export type InvestmentProposalRequest = {
  readonly __typename?: 'InvestmentProposalRequest';
  /** URL to the account statements */
  readonly accountStatementsUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the investment proposal request */
  readonly id: Scalars['ID']['output'];
  /** The type of investment proposal request */
  readonly requestType: InvestmentProposalRequestTypeName;
  /** The target model and allocation information */
  readonly targetModelAndAllocation: Scalars['String']['output'];
};

/** The type of investment proposal request */
export const InvestmentProposalRequestTypeName = {
  /** current_vs_target_portfolio */
  CurrentVsTargetPortfolio: 'current_vs_target_portfolio',
  /** target_portfolio_only */
  TargetPortfolioOnly: 'target_portfolio_only'
} as const;

export type InvestmentProposalRequestTypeName = typeof InvestmentProposalRequestTypeName[keyof typeof InvestmentProposalRequestTypeName];
/** A household member the ECI onboarding invite is addressed to. */
export type InviteRecipient = {
  readonly __typename?: 'InviteRecipient';
  /**
   * Whether this member can be selected for a resend: false once they have
   * submitted, and false when there is no email to send to.
   */
  readonly canResend: Scalars['Boolean']['output'];
  /** Where the invite is mailed. Null when the client has no user or no email. */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** The client onboarding request id — pass this back to resend. */
  readonly id: Scalars['ID']['output'];
  /** Client display name, from intake data when present. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Applicant role (primary or joint_owner). */
  readonly role: Scalars['String']['output'];
  /** Whether this client already submitted their intake. */
  readonly submitted: Scalars['Boolean']['output'];
};

/**
 * Native Invoice (Fee Review) report — replaces the Orion-generated Client Invoice
 * PDF (HAWK-32). Bill header and footer (invoice number, period, totals) come from
 * Orion via /Billing/Bills; per-account rows come from Orion's authoritative bill
 * line items (/Billing/BillGenerator/BillItems).
 */
export type InvoiceFeeReview = {
  readonly __typename?: 'InvoiceFeeReview';
  /** Display name of the household's primary advisor (Orion representative). Null when unknown. */
  readonly financialAdvisorName?: Maybe<Scalars['String']['output']>;
  /** Household display name shown in the report header. */
  readonly householdName: Scalars['String']['output'];
  /** Stable identifier for this report (household + bill id). */
  readonly id: Scalars['ID']['output'];
  /** Invoice date (the bill's calcDate). */
  readonly invoiceDate: Scalars['ISO8601Date']['output'];
  /** Orion's invoiceNumber for this bill (e.g. "16178-109264"). */
  readonly invoiceNumber: Scalars['String']['output'];
  /** End of the bill's billing period. */
  readonly periodEnd: Scalars['ISO8601Date']['output'];
  /** Start of the bill's billing period. */
  readonly periodStart: Scalars['ISO8601Date']['output'];
  /** One row per billable account on this bill. */
  readonly rows: ReadonlyArray<InvoiceFeeReviewRow>;
  /** Footnotes shown beneath the rows (e.g. indirect "paid by another account" instructions). Empty when none. */
  readonly specialInstructions: ReadonlyArray<Scalars['String']['output']>;
  /** Sum of adjustments on the bill (Orion adjustments field). */
  readonly totalAdjustments: InvoiceFeeReviewMoney;
  /** Authoritative bill total from Orion's initialAmount. */
  readonly totalAdvisoryFee: InvoiceFeeReviewMoney;
  /** The report footer's Total Billed Market Value — the sum of this bill's own-account rows. */
  readonly totalBilledValue: InvoiceFeeReviewMoney;
  /** Net total fee after adjustments — Orion balanceDue. */
  readonly totalFee: InvoiceFeeReviewMoney;
};

/**
 * A single adjustment line under a per-account row on the Invoice (Fee Review)
 * report — e.g. "Client Payment ($24.05) Paid date 04/14/25". Sourced from Orion's
 * bill-account-item adjustment ledger.
 */
export type InvoiceFeeReviewAdjustment = {
  readonly __typename?: 'InvoiceFeeReviewAdjustment';
  /** Signed change amount for this adjustment. */
  readonly amount: InvoiceFeeReviewMoney;
  /** Date the adjustment occurred. Null when Orion did not supply one. */
  readonly date?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Display label for the adjustment (e.g. "Client Payment"). */
  readonly label: Scalars['String']['output'];
};

/** One selectable Orion bill (invoice) for a household — populates the Invoice (Fee Review) report's invoice/quarter picker. */
export type InvoiceFeeReviewBillOption = {
  readonly __typename?: 'InvoiceFeeReviewBillOption';
  /** Orion bill id (pass as `billId` to the invoiceFeeReview query). */
  readonly id: Scalars['ID']['output'];
  /** Human-readable bill label, e.g. "1/1/2026–3/31/2026 (Renewal)". */
  readonly label: Scalars['String']['output'];
  /** End of the bill's billing period; null when unparseable. */
  readonly periodEnd?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Monetary value used by the Invoice (Fee Review) report. */
export type InvoiceFeeReviewMoney = {
  readonly __typename?: 'InvoiceFeeReviewMoney';
  /** Numerical amount; null when no underlying data is available. */
  readonly amount?: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency code for the amount. */
  readonly currencyCode: Scalars['String']['output'];
};

/** A single per-account row in the Invoice (Fee Review) report. */
export type InvoiceFeeReviewRow = {
  readonly __typename?: 'InvoiceFeeReviewRow';
  /** Savvy account ID this row belongs to. */
  readonly accountId: Scalars['ID']['output'];
  /** Masked account identifier (last digits), shown as e.g. "XXX-XX4792". */
  readonly accountMask?: Maybe<Scalars['String']['output']>;
  /** Net per-account adjustment applied to this bill (Orion appliedAdjustment). Zero when none. */
  readonly adjustment: InvoiceFeeReviewMoney;
  /** Itemized adjustment ledger for this account (e.g. "Client Payment" with a paid date). Empty when none. */
  readonly adjustmentLines: ReadonlyArray<InvoiceFeeReviewAdjustment>;
  /** This account's advisory fee for the period — Orion's authoritative bill line-item initialAmount. */
  readonly advisoryFee: InvoiceFeeReviewMoney;
  /** Annual advisory-fee rate as a decimal (e.g. 0.014 for 1.40%). Authoritative — Orion's bill line-item feePercent. */
  readonly annualFeeRate: Scalars['BigDecimal']['output'];
  /** Billing frequency for the account (e.g. "Monthly", "Quarterly"). */
  readonly billCycle: Scalars['String']['output'];
  /** Authoritative billed market value for this account from Orion's bill line item (totalMarketValue). */
  readonly billedValue: InvoiceFeeReviewMoney;
  /** Custodian name from Orion (e.g. "Fidelity"). */
  readonly custodian?: Maybe<Scalars['String']['output']>;
  /** Days this account was billed for (Orion daysInCycle; e.g. 6 or 5 on a partial period). */
  readonly daysInCycle: Scalars['Int']['output'];
  /** Denominator used for prorating the annual fee (Orion daysInYear, typically 365). */
  readonly daysInYear: Scalars['Int']['output'];
  /** How the fee is paid (e.g. "Direct", "Indirect"). */
  readonly payMethod?: Maybe<Scalars['String']['output']>;
  /** End of this account's billed period (Orion endDate). */
  readonly periodEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Start of this account's billed period (Orion startDate). Can differ per account on a partial cycle. */
  readonly periodStart?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Display name of the account / registration (e.g. "Glenn Cooper - TODI"). */
  readonly registrationName: Scalars['String']['output'];
  /** Account registration type (e.g. "Individual", "Roth IRA", "Trust"). */
  readonly registrationType?: Maybe<Scalars['String']['output']>;
  /** Management style / strategy name (e.g. "Managed Account"). */
  readonly strategy?: Maybe<Scalars['String']['output']>;
  /** advisory_fee minus adjustment. */
  readonly totalFee: InvoiceFeeReviewMoney;
};

/** Type of IRA account */
export const IraTypeName = {
  /** contributory_ira */
  ContributoryIra: 'contributory_ira',
  /** inherited_ira */
  InheritedIra: 'inherited_ira',
  /** rollover_ira */
  RolloverIra: 'rollover_ira',
  /** roth_contributory */
  RothContributory: 'roth_contributory',
  /** sep_ira */
  SepIra: 'sep_ira',
  /** simple */
  Simple: 'simple'
} as const;

export type IraTypeName = typeof IraTypeName[keyof typeof IraTypeName];
/** Enumeration of activity timeline item types */
export const ItemTypeEnum = {
  /** CalendarEvent */
  CalendarEvent: 'CalendarEvent',
  /** CallLog */
  CallLog: 'CallLog',
  /** DialpadCall */
  DialpadCall: 'DialpadCall',
  /** DialpadCallTranscript */
  DialpadCallTranscript: 'DialpadCallTranscript',
  /** DialpadSms */
  DialpadSms: 'DialpadSms',
  /** DialpadSmsGroup */
  DialpadSmsGroup: 'DialpadSmsGroup',
  /** EmailMessage */
  EmailMessage: 'EmailMessage',
  /** Meeting */
  Meeting: 'Meeting',
  /** MeetingSummary */
  MeetingSummary: 'MeetingSummary',
  /** Note */
  Note: 'Note',
  /** SmsLog */
  SmsLog: 'SmsLog',
  /** Task */
  Task: 'Task',
  /** ZoomMeetingTranscript */
  ZoomMeetingTranscript: 'ZoomMeetingTranscript'
} as const;

export type ItemTypeEnum = typeof ItemTypeEnum[keyof typeof ItemTypeEnum];
/**
 * A unified activity timeline item representing calendar events, dialpad calls,
 * dialpad SMS, tasks, notes, and logged meetings for a household
 */
export type ItemTypeUnion = CalendarEvent | CallLog | DialpadCall | DialpadCallTranscript | DialpadSms | DialpadSmsGroup | EmailMessage | Meeting | MeetingSummary | Note | SmsLog | Task | ZoomMeetingTranscript;

/** A field relevant to KYC readiness validation */
export const KycField = {
  /** address_city */
  AddressCity: 'address_city',
  /** address_country */
  AddressCountry: 'address_country',
  /** address_line1 */
  AddressLine1: 'address_line1',
  /** address_state */
  AddressState: 'address_state',
  /** address_zip */
  AddressZip: 'address_zip',
  /** country_code */
  CountryCode: 'country_code',
  /** date_of_birth */
  DateOfBirth: 'date_of_birth',
  /** email */
  Email: 'email',
  /** first_name */
  FirstName: 'first_name',
  /** last_name */
  LastName: 'last_name',
  /** phone_number */
  PhoneNumber: 'phone_number',
  /** primary_residence */
  PrimaryResidence: 'primary_residence',
  /** ssn */
  Ssn: 'ssn'
} as const;

export type KycField = typeof KycField[keyof typeof KycField];
/** Autogenerated input type of LaunchTaskWorkflowTemplate */
export type LaunchTaskWorkflowTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Launch date (launch_date schedule) or target due date (due_date schedule) */
  readonly dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The households to launch the workflow into */
  readonly householdIds: ReadonlyArray<Scalars['ID']['input']>;
  /** Schedule anchor for this run: launch_date or due_date (overrides the template default) */
  readonly schedule: TaskWorkflowTemplateSchedule;
  /** The workflow task to launch */
  readonly taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of LaunchTaskWorkflowTemplate. */
export type LaunchTaskWorkflowTemplatePayload = {
  readonly __typename?: 'LaunchTaskWorkflowTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The launched tasks, one per household */
  readonly tasks?: Maybe<ReadonlyArray<Task>>;
};

/** A lead source category and the detail options that depend on it */
export type LeadSourceOption = {
  readonly __typename?: 'LeadSourceOption';
  /**
   * Detail options scoped to this category, as persisted to
   * households.advisor_lead_source_detail. Empty when the category has no
   * dependent detail
   */
  readonly details: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the logged-out sign-up form offers this category */
  readonly offeredAtSignUp: Scalars['Boolean']['output'];
  /** The category, as persisted to households.advisor_lead_source */
  readonly value: Scalars['String']['output'];
};

/** Liability held by the user. */
export type Liability = {
  readonly __typename?: 'Liability';
  /** The date on which the user acquired the liability. */
  readonly acquiredAt: Scalars['ISO8601Date']['output'];
  /** Annual interest in percentage */
  readonly annualInterestPercent?: Maybe<Scalars['BigDecimal']['output']>;
  /** The current balance of the liability. */
  readonly currentBalance: Value;
  /** Whether to hide this portfolio item from client */
  readonly hiddenFromClient?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to hide this portfolio item from net worth and graph */
  readonly hiddenFromNetWorth?: Maybe<Scalars['Boolean']['output']>;
  /** Daily balance history for the liability, forward-filled from each recorded change. */
  readonly historicalValues: ReadonlyArray<HistoricalValue>;
  /** The Savvy ID of the liability. */
  readonly id: Scalars['ID']['output'];
  /** The timestamp the liability was last updated at. */
  readonly lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** The name of the liability. */
  readonly name: Scalars['String']['output'];
  /** The original balance of the liability. */
  readonly originalBalance: Value;
  /** The name of the provider of the liability. */
  readonly providerName?: Maybe<Scalars['String']['output']>;
  /** The status of the liability. */
  readonly status: AccountStatusName;
  /** Length of time until maturity */
  readonly timeToMaturity?: Maybe<Scalars['Int']['output']>;
  /** Time unit for time_to_maturity */
  readonly timeToMaturityUnit?: Maybe<Scalars['String']['output']>;
  /** The type of liability */
  readonly type: PortfolioItemTypeName;
  /** The timestamp the liability was last updated with information. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export const LiabilityTypeName = {
  Auto: 'auto',
  Commercial: 'commercial',
  Consumer: 'consumer',
  General: 'general',
  HomeEquity: 'home_equity',
  LineOfCredit: 'line_of_credit',
  Mortgage: 'mortgage',
  Other: 'other',
  Student: 'student'
} as const;

export type LiabilityTypeName = typeof LiabilityTypeName[keyof typeof LiabilityTypeName];
/** Link a bank variant: link an external bank account to one or more managed accounts */
export type LinkABankInput = {
  /** Managed accounts to which the bank should be linked */
  readonly accountIds: ReadonlyArray<Scalars['ID']['input']>;
  /** Bank account number */
  readonly bankAccountNumber: Scalars['String']['input'];
  /** Bank account type — checking or savings */
  readonly bankAccountType: BankAccountTypeName;
  /** Name of the bank */
  readonly bankName: Scalars['String']['input'];
  /** Names of the bank account owners */
  readonly bankOwners: Scalars['String']['input'];
  /** ABA routing number */
  readonly routingNumber: Scalars['String']['input'];
};

/** Autogenerated input type of LinkInteractionToServiceOccurrence */
export type LinkInteractionToServiceOccurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Typed occurrence id, as returned by householdServiceOccurrences */
  readonly occurrenceId: Scalars['ID']['input'];
  /** The occurrence's `revision` as read. The write is refused when the row has changed since */
  readonly revision: Scalars['String']['input'];
  /** The interaction id */
  readonly timelineItemId: Scalars['ID']['input'];
  /** The interaction type: CalendarEvent, Meeting, DialpadCall or CallLog */
  readonly timelineItemType: ItemTypeEnum;
};

/** Autogenerated return type of LinkInteractionToServiceOccurrence. */
export type LinkInteractionToServiceOccurrencePayload = {
  readonly __typename?: 'LinkInteractionToServiceOccurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The occurrence after the write, or null once it no longer belongs to the household stream */
  readonly occurrence?: Maybe<HouseholdServiceOccurrence>;
};

/** Autogenerated input type of LinkProfessionalContactToHousehold */
export type LinkProfessionalContactToHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the household */
  readonly householdId: Scalars['ID']['input'];
  /** Whether the contact is a beneficiary of the household */
  readonly isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the contact is a dependent of the household */
  readonly isDependent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the contact is a trusted contact of the household */
  readonly isTrustedContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Public id of the professional contact */
  readonly professionalPublicId: Scalars['ID']['input'];
  /** Relationship to the household */
  readonly relation?: InputMaybe<BeneficiaryRelationship>;
};

/** Autogenerated return type of LinkProfessionalContactToHousehold. */
export type LinkProfessionalContactToHouseholdPayload = {
  readonly __typename?: 'LinkProfessionalContactToHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the link was not made. Empty on success */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
};

/** Autogenerated input type of LinkTask */
export type LinkTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Public id of the other task. */
  readonly linkedTaskUuid: Scalars['String']['input'];
  /** How the task named by taskUuid relates to the other task. */
  readonly relationship: TaskLinkRelationship;
  /** Existing link to rewrite. Omit to create one. */
  readonly taskLinkId?: InputMaybe<Scalars['ID']['input']>;
  /** Public id of the task the link is being edited from. The result is labelled from this side. */
  readonly taskUuid: Scalars['String']['input'];
};

/** Autogenerated return type of LinkTask. */
export type LinkTaskPayload = {
  readonly __typename?: 'LinkTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The written link, labelled from the taskUuid side. */
  readonly taskLink: TaskLink;
};

/** Autogenerated input type of LinkTimelineItemToContact */
export type LinkTimelineItemToContactInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The contact id */
  readonly contactId: Scalars['ID']['input'];
  /** Polymorphic contact type: CenterOfInfluenceRep or Contact */
  readonly contactType: Scalars['String']['input'];
  /** The timeline item id */
  readonly timelineItemId: Scalars['ID']['input'];
  /** The timeline item type */
  readonly timelineItemType: ItemTypeEnum;
};

/** Autogenerated return type of LinkTimelineItemToContact. */
export type LinkTimelineItemToContactPayload = {
  readonly __typename?: 'LinkTimelineItemToContactPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** True when the item is linked to the contact */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of LinkTranscript */
export type LinkTranscriptInput = {
  /** Professional contact to link the transcript to. Mutually exclusive with householdId. */
  readonly centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household to attach the transcript to. Mutually exclusive with centerOfInfluenceRepId. */
  readonly householdId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the transcript to link. */
  readonly transcriptId: Scalars['ID']['input'];
  /**
   * Which transcript class transcriptId names — the same value as the alert entity's __typename.
   * Both tables are bigserial, so an id alone is ambiguous. Defaults to ZoomMeetingTranscript.
   */
  readonly transcriptKind?: InputMaybe<TranscriptKind>;
};

/** Autogenerated return type of LinkTranscript. */
export type LinkTranscriptPayload = {
  readonly __typename?: 'LinkTranscriptPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * ID of the linked transcript. Differs from the input when a natively-matched
   * row already existed and the placeholder converged onto it.
   */
  readonly transcriptId: Scalars['ID']['output'];
};

/** An external bank account that one or more Savvy-managed accounts can transfer to/from. */
export type LinkedBankAccount = {
  readonly __typename?: 'LinkedBankAccount';
  /** Full (decrypted) bank account number. Gated to the owning advisor / admin by this type's read policies. */
  readonly accountNumber: Scalars['String']['output'];
  /**
   * Type of bank account (Checking, Savings, BusinessChecking, BusinessSavings).
   * Null for partial (advisor-sourced) rows not yet enriched.
   */
  readonly accountType?: Maybe<Scalars['String']['output']>;
  /** Name of the bank. */
  readonly bankName: Scalars['String']['output'];
  /** When this bank account was first added to Savvy. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the linked bank account. */
  readonly id: Scalars['ID']['output'];
  /** Masked bank account number with only the last 4 digits visible. */
  readonly maskedAccountNumber: Scalars['String']['output'];
  /** Name(s) on the bank account registration. */
  readonly registrationName: Scalars['String']['output'];
  /** ABA routing number. Null for partial (advisor-sourced) rows not yet enriched. */
  readonly routingNumber?: Maybe<Scalars['String']['output']>;
};

/** A run of the Linked Bank Accounts seed-tool importer (admin-only). Tracks one CSV/XLSX upload through preview and confirm. */
export type LinkedBankAccountImport = {
  readonly __typename?: 'LinkedBankAccountImport';
  /** When applying completed successfully */
  readonly appliedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the operator confirmed the diff and applying began */
  readonly confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the import was uploaded */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The custodian (schwab or fidelity) */
  readonly custodian: Scalars['String']['output'];
  /** Error message if the import failed during parsing or applying */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the linked bank account import */
  readonly id: Scalars['ID']['output'];
  /** JSON diff payload populated when status is awaiting_confirmation; buckets: to_create, to_soft_delete, unchanged, skipped */
  readonly previewDiff?: Maybe<Scalars['JSON']['output']>;
  /** The lifecycle state: pending, parsing, awaiting_confirmation, applying, completed, failed, cancelled */
  readonly status: Scalars['String']['output'];
  /** The user that uploaded the import */
  readonly uploadedBy: User;
};

export const LinkedBankAccountImportDocType = {
  /** advisor */
  Advisor: 'advisor',
  /** savvy_wide */
  SavvyWide: 'savvy_wide',
  /** schwab_api */
  SchwabApi: 'schwab_api'
} as const;

export type LinkedBankAccountImportDocType = typeof LinkedBankAccountImportDocType[keyof typeof LinkedBankAccountImportDocType];
/** Autogenerated input type of LogTaskAttachment */
export type LogTaskAttachmentInput = {
  /** One of "added" or "removed". */
  readonly action: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The human-readable file name to render on the timeline. */
  readonly filename: Scalars['String']['input'];
  /** The Savvy task ID. */
  readonly taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of LogTaskAttachment. */
export type LogTaskAttachmentPayload = {
  readonly __typename?: 'LogTaskAttachmentPayload';
  /** The TaskActivity row written for this event. */
  readonly activity?: Maybe<TaskActivity>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the activity row was written. */
  readonly success: Scalars['Boolean']['output'];
};

/** A mailbox associated with an advisor */
export type Mailbox = {
  readonly __typename?: 'Mailbox';
  /** The email address of the mailbox. */
  readonly email: Scalars['String']['output'];
  /** The unique identifier of the mailbox. */
  readonly id: Scalars['ID']['output'];
};

export type MailgunMessage = {
  readonly __typename?: 'MailgunMessage';
  readonly deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly failedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly from: Scalars['String']['output'];
  readonly mailgunMessageId: Scalars['String']['output'];
  readonly recipient: Scalars['String']['output'];
  readonly sender: Scalars['String']['output'];
  readonly status: MailgunMessageStatus;
  readonly subject: Scalars['String']['output'];
  readonly to: Scalars['String']['output'];
};

export const MailgunMessageStatus = {
  Delivered: 'delivered',
  Failed: 'failed',
  Opened: 'opened'
} as const;

export type MailgunMessageStatus = typeof MailgunMessageStatus[keyof typeof MailgunMessageStatus];
/** Autogenerated input type of MarkAdvisorRequirementsDone */
export type MarkAdvisorRequirementsDoneInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy ID of the advisor-blocked task to mark done. */
  readonly taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkAdvisorRequirementsDone. */
export type MarkAdvisorRequirementsDonePayload = {
  readonly __typename?: 'MarkAdvisorRequirementsDonePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The task after the sub_status has been moved to reviewed_ready_for_work. */
  readonly task: Task;
};

/** Autogenerated input type of MarkCommentsSeen */
export type MarkCommentsSeenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The newest comment id the client displayed. The watermark clamps to this, so a
   * comment that arrived while the tab sat open is not marked read without ever
   * having been shown.
   */
  readonly newestRenderedCommentId: Scalars['ID']['input'];
  /** ID of the subject whose comments were seen */
  readonly relationId: Scalars['ID']['input'];
  /** Subject type, e.g. "Household" */
  readonly relationType: Scalars['String']['input'];
};

/** Autogenerated return type of MarkCommentsSeen. */
export type MarkCommentsSeenPayload = {
  readonly __typename?: 'MarkCommentsSeenPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * True when the call was accepted, whether the watermark moved or already
   * covered the request. Failures surface as errors, not as false.
   */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MarkHouseholdComplete */
export type MarkHouseholdCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The staged household to mark complete. */
  readonly stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkHouseholdComplete. */
export type MarkHouseholdCompletePayload = {
  readonly __typename?: 'MarkHouseholdCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred. */
  readonly errors?: Maybe<ReadonlyArray<MutationError>>;
  /** Whether the household was marked complete. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MarkServiceCatalogItemHouseholdDone */
export type MarkServiceCatalogItemHouseholdDoneInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Assignment id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkServiceCatalogItemHouseholdDone. */
export type MarkServiceCatalogItemHouseholdDonePayload = {
  readonly __typename?: 'MarkServiceCatalogItemHouseholdDonePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated assignment */
  readonly serviceCatalogItemHousehold: ServiceCatalogItemHousehold;
};

/** Autogenerated input type of MarkServiceCatalogItemHouseholdSkipped */
export type MarkServiceCatalogItemHouseholdSkippedInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Assignment id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkServiceCatalogItemHouseholdSkipped. */
export type MarkServiceCatalogItemHouseholdSkippedPayload = {
  readonly __typename?: 'MarkServiceCatalogItemHouseholdSkippedPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created or updated skip override */
  readonly serviceCatalogItemHouseholdOverride: ServiceCatalogItemHouseholdOverride;
};

/** Autogenerated input type of MarkTaskCommentsSeen */
export type MarkTaskCommentsSeenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkTaskCommentsSeen. */
export type MarkTaskCommentsSeenPayload = {
  readonly __typename?: 'MarkTaskCommentsSeenPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** A single point in a portfolio market-value / net-additions time series. */
export type MarketValuePoint = {
  readonly __typename?: 'MarketValuePoint';
  /** Valuation date. */
  readonly date: Scalars['ISO8601Date']['output'];
  /** Ending market value on this date, in USD. */
  readonly marketValue: Scalars['BigDecimal']['output'];
  /**
   * Cumulative net amount invested as of this date, in USD; null when the snapshot
   * did not record contributions for this point.
   */
  readonly netInvested?: Maybe<Scalars['BigDecimal']['output']>;
};

/** A manually logged meeting between an advisor and either household members or a center of influence rep */
export type Meeting = {
  readonly __typename?: 'Meeting';
  /** Users recorded as attendees for this meeting. */
  readonly attendees: ReadonlyArray<User>;
  /** Timestamp when this meeting record was created in Savvy. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Duration of the meeting in minutes. */
  readonly durationMinutes?: Maybe<Scalars['Int']['output']>;
  /** The Savvy ID of the meeting. */
  readonly id: Scalars['ID']['output'];
  /** Notes or summary from the meeting. */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /** The date and time when the meeting took place. */
  readonly occurredAt: Scalars['ISO8601DateTime']['output'];
  /** The title or subject of the meeting. */
  readonly title: Scalars['String']['output'];
};

/** A meeting agenda template an advisor authors for Savvy Intelligence to use during meeting prep */
export type MeetingAgendaTemplate = {
  readonly __typename?: 'MeetingAgendaTemplate';
  /** ID of the advisor profile that created the template */
  readonly advisorProfileId: Scalars['ID']['output'];
  /** The agenda outline the advisor authored */
  readonly body: Scalars['String']['output'];
  /** When the template was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** When to use this template; the primary AI-selection signal */
  readonly description: Scalars['String']['output'];
  /** The ID of the meeting agenda template */
  readonly id: Scalars['ID']['output'];
  /** Avatar URL of the advisor who last edited the template */
  readonly lastEditedByAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** Display name of the advisor who last edited the template */
  readonly lastEditedByName: Scalars['String']['output'];
  /** The kind of template: meeting_agenda shapes a prep agenda, meeting_recap shapes a meeting summary */
  readonly templateType: MeetingAgendaTemplateType;
  /** The template title; also a signal for AI selection */
  readonly title: Scalars['String']['output'];
  /** When the template was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Whether the current advisor may edit/delete this template: the creator of a
   * private template, or a co-owning member of a group a firm template is shared to
   */
  readonly viewerCanManage: Scalars['Boolean']['output'];
  /** Who can see the template: private (creator only) or firm-wide */
  readonly visibility: MeetingAgendaTemplateVisibility;
};

/** The connection type for MeetingAgendaTemplate. */
export type MeetingAgendaTemplateConnection = {
  readonly __typename?: 'MeetingAgendaTemplateConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<MeetingAgendaTemplateEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<MeetingAgendaTemplate>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MeetingAgendaTemplateEdge = {
  readonly __typename?: 'MeetingAgendaTemplateEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<MeetingAgendaTemplate>;
};

/** The kind of template: meeting_agenda shapes a prep agenda, meeting_recap shapes a meeting summary */
export const MeetingAgendaTemplateType = {
  /** meeting_agenda */
  MeetingAgenda: 'meeting_agenda',
  /** meeting_recap */
  MeetingRecap: 'meeting_recap'
} as const;

export type MeetingAgendaTemplateType = typeof MeetingAgendaTemplateType[keyof typeof MeetingAgendaTemplateType];
/** Visibility of a meeting agenda template: private (creator only) or firm-wide */
export const MeetingAgendaTemplateVisibility = {
  /** firm */
  Firm: 'firm',
  /** private */
  Private: 'private'
} as const;

export type MeetingAgendaTemplateVisibility = typeof MeetingAgendaTemplateVisibility[keyof typeof MeetingAgendaTemplateVisibility];
/** Calendly booking tracking for a Service Calendar v2 meeting occurrence */
export type MeetingBooking = {
  readonly __typename?: 'MeetingBooking';
  /** When the client booked the meeting via Calendly. Nil until a booking is received. */
  readonly bookedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Calendly cancellation URL captured at booking time */
  readonly calendlyCancelUrl?: Maybe<Scalars['String']['output']>;
  /** Calendly's URI for the invitee on the currently booked event */
  readonly calendlyInviteeUri?: Maybe<Scalars['String']['output']>;
  /** Calendly reschedule URL captured at booking time */
  readonly calendlyRescheduleUrl?: Maybe<Scalars['String']['output']>;
  /** Calendly's URI for the currently booked event. A reschedule replaces it — not a booking history. */
  readonly calendlyScheduledEventUri?: Maybe<Scalars['String']['output']>;
  /** When the client canceled the meeting via Calendly. Set on invitee.canceled; cleared on a fresh booking. */
  readonly canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The planned days whose reminder was handed to the mailer. Null on a legacy
   * row, where the same column holds days before the meeting
   */
  readonly deliveredReminderDays?: Maybe<ReadonlyArray<Scalars['Int']['output']>>;
  /** The occurrence moment — the same column the schedule page and send crons order by */
  readonly dueAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The row ID */
  readonly id: Scalars['ID']['output'];
  /**
   * Conferencing join URL, set only when the event type has a provider. Not
   * cleared on cancel — suppress it when canceledAt is set
   */
  readonly meetingJoinUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Calendly location type as sent — zoom, physical, custom, and so on. A plain
   * string, so an unrecognised type still reads back.
   */
  readonly meetingLocationType?: Maybe<Scalars['String']['output']>;
  /** The meeting's name, taken from its catalog item */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Which occurrence of the cadence this row is */
  readonly occurrenceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * Days after the first email that a forward reminder goes out, frozen when the
   * row was created. Null on a legacy row, whose reminders count back from the meeting
   */
  readonly plannedReminderDays?: Maybe<ReadonlyArray<Scalars['Int']['output']>>;
  /**
   * The planned days the reminder job has claimed. A claim precedes delivery and
   * also covers a disarmed row, so it is not proof of a send. Null on a legacy
   * row, where the same column holds days before the meeting
   */
  readonly remindedDays?: Maybe<ReadonlyArray<Scalars['Int']['output']>>;
  /** The same token householdServiceOccurrences returns as this row's revision, to echo back to an occurrence-scoped mutation */
  readonly revision: Scalars['String']['output'];
  /** The catalog item that materialized this meeting */
  readonly sourceCatalogItem?: Maybe<ServiceCatalogItem>;
  /**
   * Calendly scheduling link carrying this row's utm_term tracking. Hand clients
   * this one, never the catalog item's untracked link.
   */
  readonly trackedUrl: Scalars['String']['output'];
  /** Households this meeting is for */
  readonly workItemHouseholds: ReadonlyArray<Household>;
};

/** Historical service calendar v1 meeting instance for export */
export type MeetingInstance = {
  readonly __typename?: 'MeetingInstance';
  readonly dueDate: Scalars['ISO8601DateTime']['output'];
  readonly meetingDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly status: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
};

/** The AI-generated meeting prep document for a calendar event (recap + agenda). */
export type MeetingPrep = {
  readonly __typename?: 'MeetingPrep';
  /** The meeting agenda as sanitized HTML, or null if absent. */
  readonly agendaHtml?: Maybe<Scalars['String']['output']>;
  /** The since-last-meeting recap section, or null if absent. */
  readonly recap?: Maybe<MeetingPrepRecap>;
};

/** A single recap bullet from a meeting prep document. */
export type MeetingPrepBullet = {
  readonly __typename?: 'MeetingPrepBullet';
  /** The bullet text. */
  readonly text: Scalars['String']['output'];
};

/** The "since last meeting" recap section of a meeting prep document. */
export type MeetingPrepRecap = {
  readonly __typename?: 'MeetingPrepRecap';
  /** A paragraph summarizing account performance since the last meeting. */
  readonly accountPerformance: Scalars['String']['output'];
  /** Bullets describing what changed since the last meeting. */
  readonly whatsChanged: ReadonlyArray<MeetingPrepBullet>;
  /** Bullets worth keeping in mind for this meeting. */
  readonly worthKeepingInMind: ReadonlyArray<MeetingPrepBullet>;
};

/** An in-person meeting recording and where it has got to. */
export type MeetingRecording = {
  readonly __typename?: 'MeetingRecording';
  /** False while the recording is waiting to be linked to a household. */
  readonly attached: Scalars['Boolean']['output'];
  /** The recorded client's name, or 'Client' when the profile carries no user */
  readonly clientName: Scalars['String']['output'];
  /** When the recording was opened */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Captured audio length */
  readonly durationSeconds: Scalars['Int']['output'];
  /**
   * The opening ~200 characters of what was said, for identifying an unattached
   * recording in the inbox. Same budget the Zoom and Dialpad cards use, so the
   * three cannot truncate differently.
   */
  readonly excerpt?: Maybe<Scalars['String']['output']>;
  /** Why the pipeline stopped, when it did. Terminal — the audio is deleted, so there is nothing to retry. */
  readonly failureReason?: Maybe<Scalars['String']['output']>;
  /** Household the recording belongs to, once it has one */
  readonly householdId?: Maybe<Scalars['ID']['output']>;
  /** The Savvy ID of the recording */
  readonly id: Scalars['ID']['output'];
  /** Recap title, from the generated summary. Null until the recap exists. */
  readonly meetingName?: Maybe<Scalars['String']['output']>;
  /** The recap Note to open. Null until the pipeline reaches `summarized`. */
  readonly noteId?: Maybe<Scalars['ID']['output']>;
  /** Where the pipeline has got to. `summarized` means the recap Note exists. */
  readonly status: MeetingRecordingStatus;
  /**
   * What was said, once speaker resolution has run — empty before that. Read by
   * the screen that shows a recording still waiting to be filed, which has no
   * recap note to read it from.
   */
  readonly transcript: ReadonlyArray<MeetingTranscriptLine>;
  /** True when the recording cap ended the recording rather than the advisor */
  readonly truncatedAtCap: Scalars['Boolean']['output'];
};

/** An advisor in the recorder's group who has a voice enrollment on file */
export type MeetingRecordingParticipant = {
  readonly __typename?: 'MeetingRecordingParticipant';
  /** Pass this back as requestMeetingRecordingUpload advisorProfileIds */
  readonly advisorProfileId: Scalars['ID']['output'];
  /** Display name for the picker */
  readonly name: Scalars['String']['output'];
};

/**
 * Where an in-person meeting recording has got to in the pipeline. `failed` is
 * terminal — the audio is gone by then, so there is nothing to retry.
 */
export const MeetingRecordingStatus = {
  /** failed */
  Failed: 'failed',
  /** pending_upload */
  PendingUpload: 'pending_upload',
  /** resolved */
  Resolved: 'resolved',
  /** summarized */
  Summarized: 'summarized',
  /** transcribed */
  Transcribed: 'transcribed',
  /** transcribing */
  Transcribing: 'transcribing',
  /** uploaded */
  Uploaded: 'uploaded'
} as const;

export type MeetingRecordingStatus = typeof MeetingRecordingStatus[keyof typeof MeetingRecordingStatus];
/** Presigned S3 PUT URL grant for uploading one in-person meeting recording, plus the MeetingRecording row it belongs to. */
export type MeetingRecordingUploadGrant = {
  readonly __typename?: 'MeetingRecordingUploadGrant';
  /**
   * When this presigned URL stops accepting uploads. A recording whose window
   * lapses is retried from the local file on next launch.
   */
  readonly expiresAt: Scalars['ISO8601DateTime']['output'];
  /** The MeetingRecording this upload belongs to. Pass it back to finalizeMeetingRecordingUpload. */
  readonly meetingRecordingId: Scalars['ID']['output'];
  /**
   * S3 object key. Pass it back to finalizeMeetingRecordingUpload so the server
   * can confirm the bytes landed where it expected.
   */
  readonly s3Key: Scalars['String']['output'];
  /** Presigned S3 PUT URL for the .aac bytes (15 min TTL). */
  readonly uploadUrl: Scalars['String']['output'];
};

export type MeetingSummary = {
  readonly __typename?: 'MeetingSummary';
  /** The Savvy ID of the meeting summary. */
  readonly id: Scalars['ID']['output'];
  /** End time */
  readonly meetingEndTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The name of the meeting. */
  readonly meetingName?: Maybe<Scalars['String']['output']>;
  /** Start time */
  readonly meetingStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The note backing this meeting summary, when one exists. */
  readonly note?: Maybe<Note>;
  /** Where the last requested regeneration got to; null when none has been requested. Poll this after regenerateMeetingSummary. */
  readonly regenerationStatus?: Maybe<MeetingSummaryRegenerationStatus>;
  /** The source of the meeting summary (e.g. "zoom", "dialpad", "savvy"). */
  readonly source: Scalars['String']['output'];
};

/** Why an advisor marked a Savvy meeting summary unhelpful */
export const MeetingSummaryIssueTypeEnum = {
  /** The summary missed something that was discussed */
  IncompleteResponse: 'INCOMPLETE_RESPONSE',
  /** Something in the summary is wrong */
  IncorrectInformation: 'INCORRECT_INFORMATION',
  /** The summary dwells on what did not matter */
  NotRelevant: 'NOT_RELEVANT',
  /** Something else, described in the comment */
  Other: 'OTHER',
  /** Too general to be useful */
  TooVague: 'TOO_VAGUE'
} as const;

export type MeetingSummaryIssueTypeEnum = typeof MeetingSummaryIssueTypeEnum[keyof typeof MeetingSummaryIssueTypeEnum];
/** Where an advisor-requested recap regeneration has got to. Absent means none has been requested */
export const MeetingSummaryRegenerationStatus = {
  /** failed */
  Failed: 'failed',
  /** queued */
  Queued: 'queued',
  /** running */
  Running: 'running',
  /** succeeded */
  Succeeded: 'succeeded'
} as const;

export type MeetingSummaryRegenerationStatus = typeof MeetingSummaryRegenerationStatus[keyof typeof MeetingSummaryRegenerationStatus];
/** Advisor feedback on a Savvy meeting summary */
export const MeetingSummaryVoteEnum = {
  /** The summary was not useful */
  Down: 'DOWN',
  /** The summary was useful */
  Up: 'UP'
} as const;

export type MeetingSummaryVoteEnum = typeof MeetingSummaryVoteEnum[keyof typeof MeetingSummaryVoteEnum];
/** One spoken line of an in-person meeting transcript. */
export type MeetingTranscriptLine = {
  readonly __typename?: 'MeetingTranscriptLine';
  /** Who spoke, resolved from the advisor's enrolled voice where possible. */
  readonly speaker: Scalars['String']['output'];
  /** What was said. */
  readonly text: Scalars['String']['output'];
};

export const MeetingTypeName = {
  ClientReview: 'client_review',
  IntakeReview: 'intake_review',
  IntroCall: 'intro_call',
  ManagementAgreementKickoff: 'management_agreement_kickoff',
  OnboardingReview: 'onboarding_review'
} as const;

export type MeetingTypeName = typeof MeetingTypeName[keyof typeof MeetingTypeName];
/** Autogenerated input type of MergeOrganizationHouseholdTags */
export type MergeOrganizationHouseholdTagsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly organizationHouseholdCategoryId: Scalars['ID']['input'];
  readonly organizationHouseholdTagIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of MergeOrganizationHouseholdTags. */
export type MergeOrganizationHouseholdTagsPayload = {
  readonly __typename?: 'MergeOrganizationHouseholdTagsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly organizationHouseholdTag?: Maybe<OrganizationHouseholdTag>;
};

export type MoneyMovementRequest = {
  readonly __typename?: 'MoneyMovementRequest';
  readonly additionalInformation?: Maybe<MoneyMovementRequestAdditionalInformation>;
  readonly amount: Scalars['String']['output'];
  /** Whether the wire converts currency. Only meaningful when wire_type is international. */
  readonly convertingFunds?: Maybe<Scalars['Boolean']['output']>;
  readonly fromAccount?: Maybe<MoneyMovementRequestAccount>;
  /**
   * Total that must leave the account — the typed amount grossed up when the
   * advisor entered a Net figure. Derived, not stored.
   */
  readonly grossAmount?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly itemVersion?: Maybe<Scalars['Int']['output']>;
  /** What the client receives after withholding. Derived, not stored. */
  readonly netAmount?: Maybe<Scalars['String']['output']>;
  readonly securities?: Maybe<Scalars['String']['output']>;
  readonly toAccount?: Maybe<MoneyMovementRequestAccount>;
  readonly transferType: Scalars['String']['output'];
  /** Domestic vs. international, when transfer_type is Wire. */
  readonly wireType?: Maybe<MoneyMovementWireType>;
  /** Gross minus net. Derived, not stored. */
  readonly withheldAmount?: Maybe<Scalars['String']['output']>;
};

export type MoneyMovementRequestAccount = {
  readonly __typename?: 'MoneyMovementRequestAccount';
  readonly accountDetails: MoneyMovementRequestAccountDetails;
  /**
   * The linked LinkedBankAccount when transferAccountType is the LinkedBank branch
   * and an existing account was selected (accountDetails.kind == "existing").
   * Surfaces the full account number, unmasked, for the task panel. Null for a
   * newly-entered or not-yet-appearing bank, and for the SavvyManaged and
   * EnterManually branches.
   */
  readonly linkedBankAccount?: Maybe<LinkedBankAccount>;
  /**
   * The linked Savvy-managed Account when transferAccountType is the Savvy-managed
   * branch. Surfaces mask, account_number, subtype so the task panel can
   * distinguish two same-holder accounts. Null for LinkedBank and EnterManually branches.
   */
  readonly savvyManagedAccount?: Maybe<Account>;
  readonly transferAccountType: Scalars['String']['output'];
};

export type MoneyMovementRequestAccountDetails = {
  readonly __typename?: 'MoneyMovementRequestAccountDetails';
  readonly abaTransitRoutingNumber?: Maybe<Scalars['String']['output']>;
  readonly accountName?: Maybe<Scalars['String']['output']>;
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  readonly accountType?: Maybe<Scalars['String']['output']>;
  readonly additionalInstructions?: Maybe<Scalars['String']['output']>;
  readonly addressRecipientName?: Maybe<Scalars['String']['output']>;
  readonly bankAbaNumber?: Maybe<Scalars['String']['output']>;
  readonly bankAccountNumber?: Maybe<Scalars['String']['output']>;
  readonly bankAccountType?: Maybe<Scalars['String']['output']>;
  readonly bankName?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly country?: Maybe<Scalars['String']['output']>;
  readonly grossOrNet?: Maybe<Scalars['String']['output']>;
  readonly holderName?: Maybe<Scalars['String']['output']>;
  /** Savvy id of the selected account, for the branches that reference one. */
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly kind?: Maybe<Scalars['String']['output']>;
  readonly maskedAccountNumber?: Maybe<Scalars['String']['output']>;
  readonly memo?: Maybe<Scalars['String']['output']>;
  readonly newBank?: Maybe<MoneyMovementRequestNewLinkedBank>;
  readonly otherFinancialInstitutionName?: Maybe<Scalars['String']['output']>;
  readonly payeeName?: Maybe<Scalars['String']['output']>;
  readonly recipientName?: Maybe<Scalars['String']['output']>;
  readonly referenceName?: Maybe<Scalars['String']['output']>;
  readonly registrationName?: Maybe<Scalars['String']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  readonly stateWithholdingPercent?: Maybe<Scalars['String']['output']>;
  readonly streetAddress?: Maybe<Scalars['String']['output']>;
  readonly taxWithholdingInstructions?: Maybe<Scalars['String']['output']>;
  readonly withholdingPercent?: Maybe<Scalars['String']['output']>;
  readonly zipCode?: Maybe<Scalars['String']['output']>;
};

export type MoneyMovementRequestAdditionalInformation = {
  readonly __typename?: 'MoneyMovementRequestAdditionalInformation';
  readonly additionalDetails?: Maybe<Scalars['String']['output']>;
  readonly clientInstructionType: Scalars['String']['output'];
  readonly shortfallCoverage?: Maybe<Scalars['String']['output']>;
  readonly tradeDetails?: Maybe<Scalars['String']['output']>;
  readonly tradeNeeded: Scalars['String']['output'];
};

export type MoneyMovementRequestNewLinkedBank = {
  readonly __typename?: 'MoneyMovementRequestNewLinkedBank';
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  readonly accountType?: Maybe<Scalars['String']['output']>;
  readonly bankName?: Maybe<Scalars['String']['output']>;
  readonly bankOwners?: Maybe<Scalars['String']['output']>;
  readonly routingNumber?: Maybe<Scalars['String']['output']>;
};

/** Input for money movement task specific data */
export type MoneyMovementRequestTaskInput = {
  readonly additionalInformation: Scalars['JSON']['input'];
  readonly amount: Scalars['BigDecimal']['input'];
  /** Whether the wire converts currency — only meaningful when wire_type is international */
  readonly convertingFunds?: InputMaybe<Scalars['Boolean']['input']>;
  readonly fromAccount: Scalars['JSON']['input'];
  /**
   * Optional new-bank info — when present, the mutation also creates an Account
   * Maintenance "Link a bank" task so ops can establish the linkage at the custodian.
   */
  readonly linkABank?: InputMaybe<LinkABankInput>;
  readonly securities?: InputMaybe<Scalars['String']['input']>;
  readonly toAccount: Scalars['JSON']['input'];
  readonly transferType: Scalars['String']['input'];
  /** Domestic vs. international, when transfer_type is Wire */
  readonly wireType?: InputMaybe<MoneyMovementWireType>;
};

/** Domestic vs. international selector for a money-movement Wire transfer */
export const MoneyMovementWireType = {
  /** domestic */
  Domestic: 'domestic',
  /** international */
  International: 'international'
} as const;

export type MoneyMovementWireType = typeof MoneyMovementWireType[keyof typeof MoneyMovementWireType];
/** Checking, savings, or unknown. Unknown means the institution type is not checking or savings. */
export const MoneykitBankDetailsAccountType = {
  /** Checking account. */
  Checking: 'CHECKING',
  /** Savings account. */
  Savings: 'SAVINGS',
  /** Not checking or savings. Callers must not guess a type. */
  Unknown: 'UNKNOWN'
} as const;

export type MoneykitBankDetailsAccountType = typeof MoneykitBankDetailsAccountType[keyof typeof MoneykitBankDetailsAccountType];
/** Bank fields for one account on an exchanged MoneyKit link. Prefill only; nothing is saved. */
export type MoneykitBankDetailsPrefill = {
  readonly __typename?: 'MoneykitBankDetailsPrefill';
  /** MoneyKit account id, so callers can tell rows on the same link apart. */
  readonly accountId: Scalars['String']['output'];
  /** Full account number. Null when numbers are not available. */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /** Checking, savings, or unknown. */
  readonly accountType: MoneykitBankDetailsAccountType;
  /** Institution display name. Null when MoneyKit did not return one. */
  readonly bankName?: Maybe<Scalars['String']['output']>;
  /** True only when both routing number and account number are present. */
  readonly numbersAvailable: Scalars['Boolean']['output'];
  /** Owner names joined with " & ". Empty when identity has no names. */
  readonly registeredTo: Scalars['String']['output'];
  /** ABA routing number. Null when numbers are not available. */
  readonly routingNumber?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MoneykitCreateLinkSession */
export type MoneykitCreateLinkSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Existing MoneyKit ProviderAccount id; presence flips this to a re-link session. */
  readonly providerAccountId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Why this session is created; defaults to AGGREGATION. STANDING_INSTRUCTIONS
   * requires flag-moneykit-link-session-prefill-enabled.
   */
  readonly purpose?: InputMaybe<MoneykitLinkSessionPurpose>;
  /** Override the configured redirect URI (sandbox / preview URLs). */
  readonly redirectUri?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-on-behalf: target user id; defaults to current user. */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of MoneykitCreateLinkSession. */
export type MoneykitCreateLinkSessionPayload = {
  readonly __typename?: 'MoneykitCreateLinkSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** JWT for the @moneykit/connect SDK */
  readonly linkSessionToken: Scalars['String']['output'];
};

/** Autogenerated input type of MoneykitExchangeLinkToken */
export type MoneykitExchangeLinkTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Short-lived token returned by @moneykit/connect on link success. */
  readonly exchangeToken: Scalars['String']['input'];
  /** When present, the named Plaid ProviderAccount is marked DEPRECATED after the MoneyKit PA is created. */
  readonly replacingProviderAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Advisor-on-behalf: target user id; defaults to current user. */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of MoneykitExchangeLinkToken. */
export type MoneykitExchangeLinkTokenPayload = {
  readonly __typename?: 'MoneykitExchangeLinkTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Institution display name (may be nil if MoneyKit has not finished link enrichment) */
  readonly institutionName?: Maybe<Scalars['String']['output']>;
  /** The MoneyKit link_id (also stored on the ProviderAccount) */
  readonly linkId: Scalars['String']['output'];
  /** The newly-created MoneyKit ProviderAccount */
  readonly providerAccount: ProviderAccount;
};

/** Autogenerated input type of MoneykitFetchBankDetailsPrefill */
export type MoneykitFetchBankDetailsPrefillInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Exchanged MoneyKit ProviderAccount. */
  readonly providerAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of MoneykitFetchBankDetailsPrefill. */
export type MoneykitFetchBankDetailsPrefillPayload = {
  readonly __typename?: 'MoneykitFetchBankDetailsPrefillPayload';
  /** One row per account on the link. Empty when prefill is off or numbers were declined. */
  readonly accounts: ReadonlyArray<MoneykitBankDetailsPrefill>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Why a MoneyKit link session is being created; the server maps this to MoneyKit products. */
export const MoneykitLinkSessionPurpose = {
  /** AGGREGATION */
  Aggregation: 'AGGREGATION',
  /** STANDING_INSTRUCTIONS */
  StandingInstructions: 'STANDING_INSTRUCTIONS'
} as const;

export type MoneykitLinkSessionPurpose = typeof MoneykitLinkSessionPurpose[keyof typeof MoneykitLinkSessionPurpose];
/** Autogenerated input type of MoneykitRefreshLink */
export type MoneykitRefreshLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** MoneyKit ProviderAccount to refresh. */
  readonly providerAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of MoneykitRefreshLink. */
export type MoneykitRefreshLinkPayload = {
  readonly __typename?: 'MoneykitRefreshLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The refreshed ProviderAccount (now in LOADING). */
  readonly providerAccount: ProviderAccount;
};

/** A calendar month that has activity in a household timeline (powers the month-rail navigator) */
export type Month = {
  readonly __typename?: 'Month';
  /** Number of deduped timeline entries in this month */
  readonly count: Scalars['Int']['output'];
  /** Month number, 1-12 (UTC) */
  readonly month: Scalars['Int']['output'];
  /** Calendar year (UTC) */
  readonly year: Scalars['Int']['output'];
};

/** Autogenerated input type of MoveClientToAdvisor */
export type MoveClientToAdvisorInput = {
  readonly advisorGroupId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly clientUserId: Scalars['String']['input'];
  readonly newAdvisorUserId: Scalars['String']['input'];
};

/** Autogenerated return type of MoveClientToAdvisor. */
export type MoveClientToAdvisorPayload = {
  readonly __typename?: 'MoveClientToAdvisorPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/**
 * A professional contact 4C1T-725 has moved into `contacts`, for the release that
 * cannot yet render one as a full CenterOfInfluenceRep. Exposes the public id, so
 * a client links to the same detail page it always did, plus the fields a client
 * already selects on the CenterOfInfluenceRep branch of the same union. Retired
 * once the facade lands.
 */
export type MovedProfessionalContact = {
  readonly __typename?: 'MovedProfessionalContact';
  /** The company this contact works for. */
  readonly company?: Maybe<Company>;
  /** The contact's primary email. */
  readonly email: Scalars['String']['output'];
  /** The public id — `coi_public_id`, the same number the legacy node exposed. */
  readonly id: Scalars['ID']['output'];
  /** The contact's job title. */
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  /** The contact's name. */
  readonly name: Scalars['String']['output'];
  /** The contact's primary phone number. */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The contact's avatar. */
  readonly photoUrl?: Maybe<Scalars['String']['output']>;
  /** The households and retirement plans this contact serves that the viewer can read, newest first. */
  readonly professionalServices: ReadonlyArray<ProfessionalService>;
  /** Every referral this contact is on, either side, whose other side the viewer can read, newest first. */
  readonly referrals: ReadonlyArray<Referral>;
  /** Specialties, empty rather than null on a row whose specialties were cleared. */
  readonly specialties: ReadonlyArray<CenterOfInfluenceRepSpecialty>;
  /** Two-letter US state code, kept apart from the contact's free-text address. */
  readonly state?: Maybe<Scalars['String']['output']>;
};

/** Who needs telling that the MSA changed, and who was left out */
export type MsaNoticeAudience = {
  readonly __typename?: 'MsaNoticeAudience';
  /** Box version of the live MSA template */
  readonly currentVersion: Scalars['String']['output'];
  /** Households deliberately left out, with reasons */
  readonly excluded: ReadonlyArray<MsaNoticeExclusion>;
  /** Number of households needing the notice */
  readonly householdCount: Scalars['Int']['output'];
  /** Households that need the notice */
  readonly households: ReadonlyArray<MsaNoticeHousehold>;
  /** Distinct email addresses across the audience */
  readonly recipientCount: Scalars['Int']['output'];
};

/** A household deliberately left out of the notice, with the reason */
export type MsaNoticeExclusion = {
  readonly __typename?: 'MsaNoticeExclusion';
  /** Household, absent when the request was never promoted */
  readonly householdId?: Maybe<Scalars['ID']['output']>;
  /** Household display name */
  readonly name: Scalars['String']['output'];
  /** Why this household is not in the audience */
  readonly reason: Scalars['String']['output'];
  /** EciHouseholdOnboardingRequest id */
  readonly requestId: Scalars['ID']['output'];
};

/** A household that signed an earlier MSA version and needs the notice */
export type MsaNoticeHousehold = {
  readonly __typename?: 'MsaNoticeHousehold';
  /** Advisor of record, for the pre-send heads-up */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /** The notice's CTA target for this household — its folder in the client portal */
  readonly documentsUrl?: Maybe<Scalars['String']['output']>;
  /** False when an owner has still not signed */
  readonly fullySigned: Scalars['Boolean']['output'];
  /** Household the notice concerns */
  readonly householdId: Scalars['ID']['output'];
  /** Household display name */
  readonly name: Scalars['String']['output'];
  /** When this household was first confirmed notified about the current version. Null means nobody on it has been. */
  readonly notifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Clients on this household confirmed notified about the current version */
  readonly notifiedCount: Scalars['Int']['output'];
  /** Everyone eligible to receive this household notice */
  readonly recipients: ReadonlyArray<MsaNoticeRecipient>;
  /** EciHouseholdOnboardingRequest id */
  readonly requestId: Scalars['ID']['output'];
  /**
   * Distinct template versions across this household's signed agreements. More
   * than one means the owners signed either side of an upload.
   */
  readonly signedVersions: ReadonlyArray<Scalars['String']['output']>;
};

/** One eligible email recipient for the MSA-change notice */
export type MsaNoticeRecipient = {
  readonly __typename?: 'MsaNoticeRecipient';
  /** Address the notice is delivered to */
  readonly email: Scalars['String']['output'];
  /** Recipient full name */
  readonly name: Scalars['String']['output'];
  /** User the notice is addressed to */
  readonly userId: Scalars['ID']['output'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  /** Mark an alert as acknowledged by its recipient, hiding it from the Canvas review section. */
  readonly acknowledgeAlert?: Maybe<AcknowledgeAlertPayload>;
  /** Marks the Chimney property-linking disclosure notice as shown for an asset */
  readonly acknowledgeChimneyPropertyDisclosure?: Maybe<AcknowledgeChimneyPropertyDisclosurePayload>;
  readonly activateServiceCalendarForHousehold?: Maybe<ActivateServiceCalendarForHouseholdPayload>;
  /** Link an advisor group and its members to an organization */
  readonly addAdvisorGroupToOrganization?: Maybe<AddAdvisorGroupToOrganizationPayload>;
  /** Add an advisor to an existing advisor group */
  readonly addAdvisorToExistingAdvisorGroup?: Maybe<AddAdvisorToExistingAdvisorGroupPayload>;
  /** Add advisors to an organization */
  readonly addAdvisorsToOrganization?: Maybe<AddAdvisorsToOrganizationPayload>;
  /**
   * Attach more files to your own comment, for a file remembered after it was
   * posted. createComment carries the first batch; this carries every one after it.
   */
  readonly addCommentAttachments?: Maybe<AddCommentAttachmentsPayload>;
  /** Add family members to a household */
  readonly addFamilyMembers?: Maybe<AddFamilyMembersPayload>;
  /** Advisor-only: add a user to a household with the given role. */
  readonly addHouseholdMember?: Maybe<AddHouseholdMemberPayload>;
  /** Mute a cash/allocation alert for one account or a whole household. */
  readonly addNotificationAlertMute?: Maybe<AddNotificationAlertMutePayload>;
  /**
   * Clone the published version of a Savvy service template into the advisor's own
   * services: the copy lands in their main advisor group and organization as a
   * draft they can edit, publish and enroll households into, with the template's
   * email sender, CC list, default assignees and Calendly links dropped, and
   * carries none of the template's unpublished changes. Advisor-only, refused for
   * a template that has never been published, and the copy records the template it
   * came from so the catalog can mark it added.
   */
  readonly addSavvyServiceTemplateToResources?: Maybe<AddSavvyServiceTemplateToResourcesPayload>;
  readonly addSecondaryPortfolio?: Maybe<AddSecondaryPortfolioPayload>;
  /** Add a service catalog item to a group */
  readonly addServiceCatalogItemToGroup?: Maybe<AddServiceCatalogItemToGroupPayload>;
  /** Admin/CSA sends a survey round to advisor emails, or previews it */
  readonly addSurveyRecipients?: Maybe<AddSurveyRecipientsPayload>;
  /** Admin: record an account already opened by hand in Fidelity Wealthscape onto an ECI household onboarding request. */
  readonly adoptWealthscapeAccount?: Maybe<AdoptWealthscapeAccountPayload>;
  /**
   * Advance the advisor onboarding status from confirm_account to ready_to_send at
   * the Confirm->Email boundary, writing only the cockpit status (no commit side effects).
   */
  readonly advanceEciOnboardingToReadyToSend?: Maybe<AdvanceEciOnboardingToReadyToSendPayload>;
  /** Repair a household stuck in the DocuSign signed loop by advancing past the completed signing (HAWK-444). */
  readonly advanceOnboardingAfterSigning?: Maybe<AdvanceOnboardingAfterSigningPayload>;
  /** Save a reviewed admin draft correction. */
  readonly applyAdvisorOnboardingCorrection?: Maybe<ApplyCorrectionPayload>;
  /** Approve pending-review scheduled report executions, delivering each */
  readonly approveScheduledReportExecution?: Maybe<ApproveScheduledReportExecutionPayload>;
  /** Archive a client household: set stage to inactive */
  readonly archiveHousehold?: Maybe<ArchiveHouseholdPayload>;
  /** Archive one client household after verifying its public identifier and name */
  readonly archiveHouseholdByPublicId?: Maybe<ArchiveHouseholdByPublicIdPayload>;
  /** Archive a service catalog item */
  readonly archiveServiceCatalogItem?: Maybe<ArchiveServiceCatalogItemPayload>;
  /** Archive a service catalog item group */
  readonly archiveServiceCatalogItemGroup?: Maybe<ArchiveServiceCatalogItemGroupPayload>;
  /** Admin: set an advisor's Fidelity Wealthscape ID and rep code by hand. */
  readonly assignAdvisorWealthscapeCredentials?: Maybe<AssignAdvisorWealthscapeCredentialsPayload>;
  /** Assign an advisor fee schedule to a household during confirm-accounts */
  readonly assignHouseholdFeeSchedule?: Maybe<AssignHouseholdFeeSchedulePayload>;
  /** Assign a service catalog item to a household */
  readonly assignServiceCatalogItemToHousehold?: Maybe<AssignServiceCatalogItemToHouseholdPayload>;
  readonly beginMfaEnrollment?: Maybe<BeginMfaEnrollmentPayload>;
  /** Cancel not-yet-started (todo) tasks in bulk by id */
  readonly bulkCancelTasks?: Maybe<BulkCancelTasksPayload>;
  /** Admin tool to bulk create or update households from an XLSX file */
  readonly bulkCreateOrUpdateHouseholds?: Maybe<BulkCreateOrUpdateHouseholdsPayload>;
  /** Bulk delete organization household tags */
  readonly bulkDeleteOrganizationHouseholdTags?: Maybe<BulkDeleteOrganizationHouseholdTagsPayload>;
  /** Kick off bulk PDF generation for the current advisor across the given households */
  readonly bulkGenerateReports?: Maybe<BulkGenerateReportsPayload>;
  readonly bulkUpdateAlerts?: Maybe<BulkUpdateAlertsPayload>;
  /** Admin tool to bulk update advisor clients */
  readonly bulkUpdateClients?: Maybe<BulkUpdateClientsPayload>;
  /** Bulk update organization household categories */
  readonly bulkUpdateOrganizationHouseholdCategories?: Maybe<BulkUpdateOrganizationHouseholdCategoriesPayload>;
  /** Bulk update endpoint to  mark client tax enrollment type */
  readonly bulkUpdateTaxEnrollmentsToNotInterested?: Maybe<BulkUpdateTaxEnrollmentsToNotInterestedPayload>;
  /** Start async bulk upload of documents to Box; poll bulkUploadFilesToBoxStatus for progress */
  readonly bulkUploadFilesToBox?: Maybe<BulkUploadFilesToBoxPayload>;
  /** Cancel an exact bounded set of todo tasks after verifying their names */
  readonly cancelExactTasks?: Maybe<CancelExactTasksPayload>;
  /** Admin: cancel a Linked Bank Accounts import that has not been applied yet */
  readonly cancelLinkedBankAccountImport?: Maybe<CancelLinkedBankAccountImportPayload>;
  /** Remove the Orion benchmark for a household. */
  readonly clearHouseholdBenchmark?: Maybe<ClearHouseholdBenchmarkPayload>;
  /** Clears Redis cache for a specified Box folder for Marketing Center */
  readonly clearRedisCacheForBoxFolder?: Maybe<ClearRedisCacheForBoxFolderPayload>;
  /** Close a remediation subtask the CSA resolved outside Savvy. */
  readonly closeEciRemediationSubtask?: Maybe<CloseEciRemediationSubtaskPayload>;
  readonly completeGoogleOAuthFlow?: Maybe<CompleteGoogleOAuthFlowPayload>;
  /** Complete the Schwab OAuth connect flow and persist the shared client tokens (admin only) */
  readonly completeSchwabOauthConnect?: Maybe<CompleteSchwabOauthConnectPayload>;
  /** Mark one service occurrence as done */
  readonly completeServiceOccurrence?: Maybe<CompleteServiceOccurrencePayload>;
  /** Confirm selected staged accounts for a promoted onboarding household and advance it to ready_to_send. */
  readonly confirmAdvisorOnboardingAccounts?: Maybe<ConfirmAccountsPayload>;
  /** Admin: confirm a previewed Linked Bank Accounts import — applies the diff in a single transaction */
  readonly confirmLinkedBankAccountImport?: Maybe<ConfirmLinkedBankAccountImportPayload>;
  /** Confirm a portfolio's investment policy */
  readonly confirmPortfolio?: Maybe<ConfirmPortfolioPayload>;
  /** Correct the identity details of one verified client */
  readonly correctClientIdentityDetails?: Maybe<CorrectClientIdentityDetailsPayload>;
  readonly createAccount?: Maybe<CreateAccountPayload>;
  /** Create an account confirmation task */
  readonly createAccountConfirmationTask?: Maybe<CreateAccountConfirmationTaskPayload>;
  /** Create an account maintenance task */
  readonly createAccountMaintenanceTask?: Maybe<CreateAccountMaintenanceTaskPayload>;
  readonly createAddress?: Maybe<CreateAddressPayload>;
  readonly createAdvisor?: Maybe<CreateAdvisorPayload>;
  /** Create an advisor group (team) and provision its Box/Wrike folders */
  readonly createAdvisorGroup?: Maybe<CreateAdvisorGroupPayload>;
  /** Create a new advisor onboarding enrollment (process root) for the intake wizard. */
  readonly createAdvisorOnboardingEnrollment?: Maybe<CreateEnrollmentPayload>;
  /** Giving feedback as admin or advisor */
  readonly createAdvisorRequest?: Maybe<CreateAdvisorRequestPayload>;
  readonly createAlert?: Maybe<CreateAlertPayload>;
  /** Create an alternative investments purchase task */
  readonly createAlternativeInvestmentsPurchaseTask?: Maybe<CreateAlternativeInvestmentsPurchaseTaskPayload>;
  readonly createAsset?: Maybe<CreateAssetPayload>;
  /** Create a bulk import operation for processing files with multiple data records */
  readonly createBulkImport?: Maybe<CreateBulkImportPayload>;
  readonly createCenterOfInfluenceRep?: Maybe<CreateCenterOfInfluenceRepPayload>;
  /** Create a client billing task */
  readonly createClientBillingTask?: Maybe<CreateClientBillingTaskPayload>;
  /** Create a client info change task */
  readonly createClientInfoChangeTask?: Maybe<CreateClientInfoChangeTaskPayload>;
  readonly createClientOpportunity?: Maybe<CreateClientOpportunityPayload>;
  readonly createClientPortalMessage?: Maybe<CreateClientPortalMessagePayload>;
  readonly createCoClientFromIntakeData?: Maybe<CreateCoClientFromIntakeDataPayload>;
  readonly createCoClientUser?: Maybe<CreateCoClientUserPayload>;
  /** Log a call with a center of influence rep */
  readonly createCoiCallLog?: Maybe<CreateCoiCallLogPayload>;
  /** Create a new Meeting log for a center of influence rep */
  readonly createCoiMeeting?: Maybe<CreateCoiMeetingPayload>;
  /**
   * Post an internal-team comment on a subject, or a reply to an existing comment.
   * Mentions are stored as @Full Name text and notify nobody.
   */
  readonly createComment?: Maybe<CreateCommentPayload>;
  /** Create a company */
  readonly createCompany?: Maybe<CreateCompanyPayload>;
  /** Log a call with a company */
  readonly createCompanyCallLog?: Maybe<CreateCompanyCallLogPayload>;
  /** Create a new Meeting log for a company */
  readonly createCompanyMeeting?: Maybe<CreateCompanyMeetingPayload>;
  /** Create a Conquest plan for a household from a frontend-built Conquest-shaped payload */
  readonly createConquestPlanFromData?: Maybe<CreateConquestPlanFromDataPayload>;
  readonly createContact?: Maybe<CreateContactPayload>;
  /** Log a call with a household contact */
  readonly createContactCallLog?: Maybe<CreateContactCallLogPayload>;
  /** Create a new Meeting log for a household contact */
  readonly createContactMeeting?: Maybe<CreateContactMeetingPayload>;
  /** Resolve, classify, and dispatch ContributionReceived alerts from a CSA-uploaded contribution sheet */
  readonly createContributionAlertsFromUpload?: Maybe<CreateContributionAlertsFromUploadPayload>;
  /** Create a corporate retirement plan task */
  readonly createCorporateRetirementPlanTask?: Maybe<CreateCorporateRetirementPlanTaskPayload>;
  /** Create a data export */
  readonly createDataExport?: Maybe<CreateDataExportPayload>;
  readonly createDocumentSignatureForTask?: Maybe<CreateDocumentSignatureForTaskPayload>;
  readonly createDocusignLpoaEnvelopeBulkUpload?: Maybe<CreateDocusignLpoaEnvelopeBulkUploadPayload>;
  /** Create a draft Fidelity NFS account request from form input. */
  readonly createEciAccountOnboardingRequest?: Maybe<CreateEciAccountOnboardingRequestPayload>;
  /**
   * Open DocuSign embedded signing for one of an IAA client's custodian envelopes.
   * Authenticated via MagicLink authorization header.
   */
  readonly createEciCustodianFormsSigningLink?: Maybe<CreateEciCustodianFormsSigningLinkPayload>;
  /** Create a fee schedule for an advisor */
  readonly createFeeScheduleForAdvisor?: Maybe<CreateFeeScheduleForAdvisorPayload>;
  /** Create a file upload task for a client */
  readonly createFileUploadTask?: Maybe<CreateFileUploadTaskPayload>;
  /** Admin-only: create a new Financial Offering shell (name + type) to fill in via the offering editor */
  readonly createFinancialOffering?: Maybe<CreateFinancialOfferingPayload>;
  /** Create a financial plan for a household */
  readonly createFinancialPlan?: Maybe<CreateFinancialPlanPayload>;
  readonly createGoal?: Maybe<CreateGoalPayload>;
  /** Record that one household referred another to the firm */
  readonly createHouseholdReferral?: Maybe<CreateHouseholdReferralPayload>;
  readonly createLiability?: Maybe<CreateLiabilityPayload>;
  /** Create manual onboarding task(s) for a client/household */
  readonly createManualOnboardingTask?: Maybe<CreateManualOnboardingTaskPayload>;
  /** Create a new Meeting log for a household */
  readonly createMeeting?: Maybe<CreateMeetingPayload>;
  /** Create a meeting agenda template */
  readonly createMeetingAgendaTemplate?: Maybe<CreateMeetingAgendaTemplatePayload>;
  /** Create a money movement request task */
  readonly createMoneyMovementRequestTask?: Maybe<CreateMoneyMovementRequestTaskPayload>;
  /** Create an NFS audit regulator export bundle. Admin-only. */
  readonly createNfsAuditExport?: Maybe<CreateNfsAuditExportPayload>;
  readonly createNote?: Maybe<CreateNotePayload>;
  /** Create a Note attached to a household Contact. */
  readonly createNoteForContact?: Maybe<CreateNoteForContactPayload>;
  /** Create a Note attached to a DialpadCall. */
  readonly createNoteForDialpadCall?: Maybe<CreateNoteForDialpadCallPayload>;
  /** Create a Note attached to a CalendarEvent. */
  readonly createNoteForEvent?: Maybe<CreateNoteForEventPayload>;
  /** Create onboarding task */
  readonly createOnboardingTask?: Maybe<CreateOnboardingTaskPayload>;
  /** Create an open new account task */
  readonly createOpenNewAccountTask?: Maybe<CreateOpenNewAccountTaskPayload>;
  /** Create or update a CallLog from a Salesforce task */
  readonly createOrUpdateCallLog?: Maybe<CreateOrUpdateCallLogPayload>;
  readonly createOrUpdateServiceCalendarSettings?: Maybe<CreateOrUpdateServiceCalendarSettingsPayload>;
  /** Create a new organization */
  readonly createOrganization?: Maybe<CreateOrganizationPayload>;
  /** Create an empty organization branding row for an organization */
  readonly createOrganizationBranding?: Maybe<CreateOrganizationBrandingRowPayload>;
  /** Create an organization household category */
  readonly createOrganizationHouseholdCategory?: Maybe<CreateOrganizationHouseholdCategoryPayload>;
  /** Create an organization household tag */
  readonly createOrganizationHouseholdTag?: Maybe<CreateOrganizationHouseholdTagPayload>;
  /** Create an other-investment task with structured sidecar data */
  readonly createOtherInvestmentTask?: Maybe<CreateOtherInvestmentTaskPayload>;
  /** @deprecated Use refreshProviderAccount or moneykitCreateLinkSession instead. Plaid-based account linking is being removed. */
  readonly createPlaidLinkToken?: Maybe<CreatePlaidLinkTokenPayload>;
  /** Create a new financial plan from current household records and return its stored inputs */
  readonly createPlan?: Maybe<CreatePlanPayload>;
  /** Add a quarterly financial snapshot to a retirement plan (gated behind retirementPlans flag) */
  readonly createPlanFinancialSnapshot?: Maybe<CreatePlanFinancialSnapshotPayload>;
  /** Record a professional contact serving a household or a retirement plan */
  readonly createProfessionalService?: Maybe<CreateProfessionalServicePayload>;
  /** New create an opportunity for a client not in Savvy system */
  readonly createProspectOpportunity?: Maybe<CreateProspectOpportunityPayload>;
  readonly createProviderAccount?: Maybe<CreateProviderAccountPayload>;
  /** Record who referred whom */
  readonly createReferral?: Maybe<CreateReferralPayload>;
  /** Create a draft DocuSign envelope (LPOA + pre-filled IWS/Schwab app PDFs) for the Erik-Midas repaper flow */
  readonly createRepaperEnvelope?: Maybe<CreateRepaperEnvelopePayload>;
  /** Create an automated delivery schedule for a saved report template */
  readonly createReportSchedule?: Maybe<CreateReportSchedulePayload>;
  /** Create a new retirement plan (gated behind retirementPlans flag) */
  readonly createRetirementPlan?: Maybe<CreateRetirementPlanPayload>;
  /** Create a compliance milestone on a retirement plan */
  readonly createRetirementPlanMilestone?: Maybe<CreateRetirementPlanMilestonePayload>;
  /** Add a note to a retirement plan */
  readonly createRetirementPlanNote?: Maybe<CreateRetirementPlanNotePayload>;
  /** Create a participant interaction log entry on a retirement plan */
  readonly createRetirementPlanParticipantLog?: Maybe<CreateRetirementPlanParticipantLogPayload>;
  /** Create a special project on a retirement plan */
  readonly createRetirementPlanProject?: Maybe<CreateRetirementPlanProjectPayload>;
  /** Create a retirement plan project by instantiating a project template */
  readonly createRetirementPlanProjectFromTemplate?: Maybe<CreateRetirementPlanProjectFromTemplatePayload>;
  /** Add a row to a retirement plan project */
  readonly createRetirementPlanProjectRow?: Maybe<CreateRetirementPlanProjectRowPayload>;
  /** Create a retirement plan project template for the current advisor's organization */
  readonly createRetirementPlanProjectTemplate?: Maybe<CreateRetirementPlanProjectTemplatePayload>;
  readonly createRiskQuestionnaire?: Maybe<CreateRiskQuestionnairePayload>;
  /** Creates a new service calendar meeting type template */
  readonly createServiceCalendarMeetingTypeTemplate?: Maybe<CreateServiceCalendarMeetingTypeTemplatePayload>;
  /** Creates new recurring service calendar meetings and a meeting type */
  readonly createServiceCalendarMeetings?: Maybe<CreateServiceCalendarMeetingsPayload>;
  /** Creates a new service calendar setting template */
  readonly createServiceCalendarSettingTemplates?: Maybe<CreateServiceCalendarSettingTemplatePayload>;
  /** Create a service catalog item */
  readonly createServiceCatalogItem?: Maybe<CreateServiceCatalogItemPayload>;
  /** Create a service catalog item group */
  readonly createServiceCatalogItemGroup?: Maybe<CreateServiceCatalogItemGroupPayload>;
  /** Create a per-assignment override */
  readonly createServiceCatalogItemHouseholdOverride?: Maybe<CreateServiceCatalogItemHouseholdOverridePayload>;
  /** Create a task with minimal required input */
  readonly createSimpleTask?: Maybe<CreateSimpleTaskPayload>;
  /** Create a sub-task on a parent task */
  readonly createSubtask?: Maybe<CreateSubtaskPayload>;
  /** Admin/CSA creates a survey round for a Typeform form */
  readonly createSurveyRound?: Maybe<CreateSurveyRoundPayload>;
  /** Create a swim request task */
  readonly createSwimRequestTask?: Maybe<CreateSwimRequestTaskPayload>;
  readonly createTaskActivityEvent?: Maybe<CreateTaskActivityEventPayload>;
  readonly createTaskComment?: Maybe<CreateTaskCommentPayload>;
  /** Start live task dictation */
  readonly createTaskDictationToken?: Maybe<CreateTaskDictationTokenPayload>;
  /** Create a task linked to an email message */
  readonly createTaskFromEmail?: Maybe<CreateTaskFromEmailPayload>;
  /** Create a task from a note */
  readonly createTaskFromNote?: Maybe<CreateTaskFromNotePayload>;
  /** Create a task and its associated work item in a single operation */
  readonly createTaskWorkItem?: Maybe<CreateTaskWorkItemPayload>;
  /** Create a reusable workflow template */
  readonly createTaskWorkflowTemplate?: Maybe<CreateTaskWorkflowTemplatePayload>;
  /** Create a tax enrollment */
  readonly createTaxEnrollment?: Maybe<CreateTaxEnrollmentPayload>;
  /** Self-serve: a firm admin creates a team in their firm and seeds same-firm members */
  readonly createTeam?: Maybe<CreateTeamPayload>;
  /** Create a trading task with associated trading request and quick trades */
  readonly createTradingTask?: Maybe<CreateTradingTaskPayload>;
  /** Create a transfer of assets task */
  readonly createTransferOfAssetsTask?: Maybe<CreateTransferOfAssetsTaskPayload>;
  /** Create a contact for a user */
  readonly createUserContact?: Maybe<CreateUserContactPayload>;
  /** Advisor-only: create a new User for the Add Household Member dialog when no existing match is found. */
  readonly createUserForHouseholdMember?: Maybe<CreateUserForHouseholdMemberPayload>;
  /** Record advisor decisions on agent proposals */
  readonly decideAgentProposals?: Maybe<DecideProposalsPayload>;
  readonly deleteAccount?: Maybe<DeleteAccountPayload>;
  readonly deleteAddress?: Maybe<DeleteAddressPayload>;
  readonly deleteAsset?: Maybe<DeleteAssetPayload>;
  /** Soft delete a CallLog */
  readonly deleteCallLog?: Maybe<DeleteCallLogPayload>;
  /** Delete a center of influence representative by ID */
  readonly deleteCenterOfInfluenceRep?: Maybe<DeleteCenterOfInfluenceRepPayload>;
  /** Delete an opportunity belonging to a client household */
  readonly deleteClientOpportunity?: Maybe<DeleteClientOpportunityPayload>;
  /** Delete a co-client from a household */
  readonly deleteCoClient?: Maybe<DeleteCoClientPayload>;
  /** Delete your own comment. A comment carrying replies is tombstoned instead of removed so its replies stay reachable. */
  readonly deleteComment?: Maybe<DeleteCommentPayload>;
  /**
   * Delete one file attached to your own comment. Savvy removes the Box file
   * itself as well — both the private copy and the client-visible one under
   * Additional Materials when the attachment was filed for the client.
   */
  readonly deleteCommentAttachment?: Maybe<DeleteCommentAttachmentPayload>;
  /** Delete a company */
  readonly deleteCompany?: Maybe<DeleteCompanyPayload>;
  /** Soft delete a DialpadCall */
  readonly deleteDialpadCall?: Maybe<DeleteDialpadCallPayload>;
  readonly deleteFamilyMember?: Maybe<DeleteFamilyMemberPayload>;
  /** Delete a fee schedule */
  readonly deleteFeeSchedule?: Maybe<DeleteFeeSchedulePayload>;
  /** Admin-only: delete a Financial Offering card (soft delete — the offering is hidden, not destroyed) */
  readonly deleteFinancialOffering?: Maybe<DeleteFinancialOfferingPayload>;
  /** Archive and delete a household financial plan (dev/reset) */
  readonly deleteFinancialPlan?: Maybe<DeleteFinancialPlanPayload>;
  /** Delete a financial plan report PDF from Box */
  readonly deleteFinancialPlanReportFile?: Maybe<DeleteFinancialPlanReportFilePayload>;
  readonly deleteGoal?: Maybe<DeleteGoalPayload>;
  /** Delete a household from the database and Salesforce. (@deprecated) */
  readonly deleteHousehold?: Maybe<DeleteHouseholdPayload>;
  /** Remove a referral from one household to another */
  readonly deleteHouseholdReferral?: Maybe<DeleteHouseholdReferralPayload>;
  readonly deleteLiability?: Maybe<DeleteLiabilityPayload>;
  /** Delete a meeting agenda template */
  readonly deleteMeetingAgendaTemplate?: Maybe<DeleteMeetingAgendaTemplatePayload>;
  /** Discard an in-person recording that was never linked to a household or contact */
  readonly deleteMeetingRecording?: Maybe<DeleteMeetingRecordingPayload>;
  readonly deleteNote?: Maybe<DeleteNotePayload>;
  /** Delete an organization household category */
  readonly deleteOrganizationHouseholdCategory?: Maybe<DeleteOrganizationHouseholdCategoryPayload>;
  /** Delete a quarterly financial snapshot */
  readonly deletePlanFinancialSnapshot?: Maybe<DeletePlanFinancialSnapshotPayload>;
  /** Remove a professional service */
  readonly deleteProfessionalService?: Maybe<DeleteProfessionalServicePayload>;
  /** Delete the household and all associated data for a prospect opportunity */
  readonly deleteProspectOpportunity?: Maybe<DeleteProspectOpportunityPayload>;
  readonly deleteProviderAccount?: Maybe<DeleteProviderAccountPayload>;
  /** Remove a referral */
  readonly deleteReferral?: Maybe<DeleteReferralPayload>;
  /** Delete an automated delivery schedule */
  readonly deleteReportSchedule?: Maybe<DeleteReportSchedulePayload>;
  /** Delete a saved report template */
  readonly deleteReportTemplate?: Maybe<DeleteReportTemplatePayload>;
  /** Delete a retirement plan and all of its associated data (gated behind retirementPlans flag) */
  readonly deleteRetirementPlan?: Maybe<DeleteRetirementPlanPayload>;
  /** Delete a retirement plan milestone */
  readonly deleteRetirementPlanMilestone?: Maybe<DeleteRetirementPlanMilestonePayload>;
  /** Delete a retirement plan note */
  readonly deleteRetirementPlanNote?: Maybe<DeleteRetirementPlanNotePayload>;
  /** Delete a participant interaction log entry */
  readonly deleteRetirementPlanParticipantLog?: Maybe<DeleteRetirementPlanParticipantLogPayload>;
  /** Delete a retirement plan project */
  readonly deleteRetirementPlanProject?: Maybe<DeleteRetirementPlanProjectPayload>;
  /** Delete a retirement plan project row */
  readonly deleteRetirementPlanProjectRow?: Maybe<DeleteRetirementPlanProjectRowPayload>;
  /** Delete a retirement plan project template */
  readonly deleteRetirementPlanProjectTemplate?: Maybe<DeleteRetirementPlanProjectTemplatePayload>;
  /** Deletes a service calendar meeting */
  readonly deleteServiceCalendarMeeting?: Maybe<DeleteServiceCalendarMeetingPayload>;
  /** Deletes a service calendar meeting type template */
  readonly deleteServiceCalendarMeetingTypeTemplate?: Maybe<DeleteServiceCalendarMeetingTypeTemplatePayload>;
  /** Deletes a service calendar setting template */
  readonly deleteServiceCalendarSettingTemplates?: Maybe<DeleteServiceCalendarSettingTemplatePayload>;
  /** Delete a per-assignment override */
  readonly deleteServiceCatalogItemHouseholdOverride?: Maybe<DeleteServiceCatalogItemHouseholdOverridePayload>;
  /** Delete a sub-task. Hard delete. Never mutates parent task status. */
  readonly deleteSubtask?: Maybe<DeleteSubtaskPayload>;
  /** Delete a task by its Salesforce task ID */
  readonly deleteTask?: Maybe<DeleteTaskPayload>;
  readonly deleteTaskComment?: Maybe<DeleteTaskCommentPayload>;
  /** Delete a workflow template */
  readonly deleteTaskWorkflowTemplate?: Maybe<DeleteTaskWorkflowTemplatePayload>;
  /** Delete a tax enrollment */
  readonly deleteTaxEnrollment?: Maybe<DeleteTaxEnrollmentPayload>;
  /** Delete a contact for a user */
  readonly deleteUserContact?: Maybe<DeleteUserContactPayload>;
  /** Discard a service catalog item group's unpublished changes and return it to its published version */
  readonly discardServiceCatalogItemGroupChanges?: Maybe<DiscardServiceCatalogItemGroupChangesPayload>;
  readonly dismissAllInboxAlerts?: Maybe<DismissAllInboxAlertsPayload>;
  /** Mark an announcement as dismissed for the current user */
  readonly dismissAnnouncement?: Maybe<DismissAnnouncementPayload>;
  /** Dismiss a completed onboarding household from the cockpit. */
  readonly dismissOnboardingHousehold?: Maybe<DismissOnboardingHouseholdPayload>;
  readonly downloadBoxFileUrl?: Maybe<DownloadBoxFileUrlPayload>;
  /** Duplicate a service catalog item group under a new name */
  readonly duplicateServiceCatalogItemGroup?: Maybe<DuplicateServiceCatalogItemGroupPayload>;
  /** Admin: bring every affected household onto the live MSA and tell them */
  readonly eciSendMsaNotice?: Maybe<SendMsaNoticePayload>;
  readonly editCenterOfInfluenceRep?: Maybe<EditCenterOfInfluenceRepPayload>;
  /** Edit a company */
  readonly editCompany?: Maybe<EditCompanyPayload>;
  /** Admin/CSA ends a survey round */
  readonly endSurveyRound?: Maybe<EndSurveyRoundPayload>;
  /** Store the current advisor's voice enrollment clip with its consent record */
  readonly enrollAdvisorVoice?: Maybe<EnrollAdvisorVoicePayload>;
  /**
   * Enroll households in every active item of one service, transactionally per
   * household: a household lands on all of the active items or on none. Idempotent
   * — a household already active on every item comes back ALREADY_ENROLLED. A
   * household already enrolled in a *different* service comes back
   * BLOCKED_BY_OTHER_SERVICE with that service named, and nothing is written for
   * it: v3 allows one service per household. Duplicate ids are collapsed, and
   * `results` is in the order the ids were given.
   */
  readonly enrollHouseholdsInServiceCatalogItemGroup?: Maybe<EnrollHouseholdsInServiceCatalogItemGroupPayload>;
  /** Remove staged households excluded during advisor book upload review */
  readonly excludeAdvisorOnboardingStagedHouseholdsFromBatch?: Maybe<ExcludeStagedHouseholdsFromBatchPayload>;
  /** Immediately expire a published report link */
  readonly expirePublishedReport?: Maybe<ExpirePublishedReportPayload>;
  /** Trigger Extend extraction for selected Box Client Uploads files (on-demand; already-extracted files skipped) */
  readonly extractBoxClientUploadStatements?: Maybe<ExtractBoxClientUploadStatementsPayload>;
  readonly fetchPlaidAccounts?: Maybe<FetchPlaidAccountsPayload>;
  /** Confirm a meeting recording's audio finished uploading */
  readonly finalizeMeetingRecordingUpload?: Maybe<FinalizeMeetingRecordingUploadPayload>;
  /** Admin: Trigger generation of Orion quarterly reports for all eligible households or specific household IDs */
  readonly generateAllQuarterlyReports?: Maybe<GenerateAllQuarterlyReportsPayload>;
  /** Generate the missing co-client onboarding task for a blocked household (HAWK-446). */
  readonly generateCoClientTask?: Maybe<GenerateCoClientTaskPayload>;
  /** Draft a directory bio + suggested specialties from intake answers */
  readonly generateDirectoryProfileDraft: DirectoryProfileDraft;
  readonly generateInvestmentProposal?: Maybe<GenerateInvestmentProposalPayload>;
  /** Generate an Orion report and return a download URL */
  readonly generateOrionReport?: Maybe<GenerateOrionReportPayload>;
  readonly generatePortfolioInsights?: Maybe<GeneratePortfolioInsightsPayload>;
  readonly generateSalesforceAccessToken?: Maybe<GenerateSalesforceAccessTokenPayload>;
  /** Draft an email subject + body for a service calendar event using AI */
  readonly generateServiceEmailDraft: ServiceEmailDraft;
  /** Client user fetch for april tokens */
  readonly getOrCreateAprilToken?: Maybe<GetOrCreateAprilTokenPayload>;
  /** Endpoint for users to request their or someone in their households token */
  readonly getOrCreateHouseholdMemberAprilFilingToken?: Maybe<GetOrCreateHouseholdMemberAprilFilingTokenPayload>;
  readonly householdWorkflowCreationBackfiller: Scalars['Boolean']['output'];
  readonly impersonateUser?: Maybe<ImpersonateUserPayload>;
  /** Launch a workflow into a household */
  readonly launchTaskWorkflowTemplate?: Maybe<LaunchTaskWorkflowTemplatePayload>;
  /** Record a timeline interaction as having satisfied one service occurrence */
  readonly linkInteractionToServiceOccurrence?: Maybe<LinkInteractionToServiceOccurrencePayload>;
  /** Add an existing professional contact to a household */
  readonly linkProfessionalContactToHousehold?: Maybe<LinkProfessionalContactToHouseholdPayload>;
  /** Create a link between two tasks, or rewrite an existing one */
  readonly linkTask?: Maybe<LinkTaskPayload>;
  /** Link a household timeline item to a contact (CenterOfInfluenceRep or Contact) */
  readonly linkTimelineItemToContact?: Maybe<LinkTimelineItemToContactPayload>;
  /** Attach an unattached Zoom transcript to a household or a professional contact. */
  readonly linkTranscript?: Maybe<LinkTranscriptPayload>;
  /** Log a task-level file attachment event (added / removed) on the audit-log timeline */
  readonly logTaskAttachment?: Maybe<LogTaskAttachmentPayload>;
  /** Clear an advisor-blocked sub_status on a task by marking advisor requirements as done. */
  readonly markAdvisorRequirementsDone?: Maybe<MarkAdvisorRequirementsDonePayload>;
  /** Advance the caller's read watermark on a subject. */
  readonly markCommentsSeen?: Maybe<MarkCommentsSeenPayload>;
  /** Admin-only: force an in_progress or blocked onboarding household to complete (HAWK-583). */
  readonly markOnboardingHouseholdComplete?: Maybe<MarkHouseholdCompletePayload>;
  /** Stamp last_completed_at = now on an assignment */
  readonly markServiceCatalogItemHouseholdDone?: Maybe<MarkServiceCatalogItemHouseholdDonePayload>;
  /** Skip the next occurrence of an assignment */
  readonly markServiceCatalogItemHouseholdSkipped?: Maybe<MarkServiceCatalogItemHouseholdSkippedPayload>;
  readonly markTaskCommentsSeen?: Maybe<MarkTaskCommentsSeenPayload>;
  /** Merge multiple organization household tags into a new one */
  readonly mergeOrganizationHouseholdTags?: Maybe<MergeOrganizationHouseholdTagsPayload>;
  /** Create a MoneyKit Connect link session (new link or re-link) and return its session token */
  readonly moneykitCreateLinkSession?: Maybe<MoneykitCreateLinkSessionPayload>;
  /** Exchange a MoneyKit Connect exchange_token for a persisted MONEYKIT ProviderAccount */
  readonly moneykitExchangeLinkToken?: Maybe<MoneykitExchangeLinkTokenPayload>;
  /** Return bank-details prefill for an exchanged MoneyKit link. Does not persist. */
  readonly moneykitFetchBankDetailsPrefill?: Maybe<MoneykitFetchBankDetailsPrefillPayload>;
  /** Refresh an existing MoneyKit-backed ProviderAccount after a re-authentication flow */
  readonly moneykitRefreshLink?: Maybe<MoneykitRefreshLinkPayload>;
  readonly moveClientToAdvisor?: Maybe<MoveClientToAdvisorPayload>;
  /** Stops Chimney from enriching or refreshing an asset's property data */
  readonly optOutOfChimneyPropertyLink?: Maybe<OptOutOfChimneyPropertyLinkPayload>;
  /** Review a correction to an imported draft. */
  readonly previewAdvisorOnboardingCorrection?: Maybe<PreviewCorrectionPayload>;
  readonly processOnboardedClient?: Maybe<ProcessOnboardedClientPayload>;
  /** Promote staged households in an advisor onboarding enrollment into canonical households. */
  readonly promoteAdvisorOnboardingEnrollment?: Maybe<PromoteEnrollmentPayload>;
  /**
   * Promote a service into a globally-available Savvy service template (admin
   * only). Flips the service itself into the catalog rather than copying it — an
   * admin curates the catalog and never runs a book, so there is no personal
   * library to preserve; advisors take their own copy with
   * addSavvyServiceTemplateToResources. Refused unless an admin authored the
   * service, and, outside development, unless it lives in the Savvy organization.
   * A service that is already a Savvy template is refused.
   */
  readonly promoteToSavvyServiceTemplate?: Maybe<PromoteToSavvyServiceTemplatePayload>;
  /** Promote a workflow template into a globally-available Savvy template (admin only) */
  readonly promoteToSavvyTemplate?: Maybe<PromoteToSavvyTemplatePayload>;
  /** Provision one advisor into Conquest (creates their Conquest user so they can launch Conquest from the Dash) */
  readonly provisionConquestUser?: Maybe<ProvisionConquestUserPayload>;
  /** Publish an existing draft task */
  readonly publishDraftTask?: Maybe<PublishDraftTaskPayload>;
  /** Publish or unpublish a financial plan */
  readonly publishFinancialPlan?: Maybe<PublishFinancialPlanPayload>;
  /** Atomically publish canonical meeting-prep content */
  readonly publishMeetingPrepOperation?: Maybe<PublishMeetingPrepOperationPayload>;
  /** Publish a Report Builder snapshot to a household client portal */
  readonly publishReport?: Maybe<PublishReportPayload>;
  /** Publish a service catalog item group and materialize tasks for enrolled households */
  readonly publishServiceCatalogItemGroup?: Maybe<PublishServiceCatalogItemGroupPayload>;
  /** Reassign one household to an active advisor after verifying the expected assignment details */
  readonly reassignHouseholdAdvisor?: Maybe<ReassignHouseholdAdvisorPayload>;
  /** Re-evaluate the current user's client_profile.stage against their task statuses and advance it if behind */
  readonly reconcileClientProfileStage?: Maybe<ReconcileClientProfileStagePayload>;
  /** Refresh any (Plaid or MoneyKit) ProviderAccount via the Aggregator dispatcher; returns a fresh vendor-agnostic link token */
  readonly refreshProviderAccount?: Maybe<RefreshProviderAccountPayload>;
  /** Rebuild an Account Confirmation's advisory agreement draft and queue its custodian forms again (admin only). */
  readonly regenerateAccountConfirmationDocuments?: Maybe<RegenerateAccountConfirmationDocumentsPayload>;
  /**
   * Rebuild a household's prefilled advisory agreement (MSA or IAA) from its
   * current accounts, custodian and fee schedule (HAWK-1180).
   */
  readonly regenerateAdvisoryAgreementDraft?: Maybe<RegenerateAgreementDraftPayload>;
  /** Queue a regeneration of a Savvy meeting summary from a different recap template */
  readonly regenerateMeetingSummary?: Maybe<RegenerateMeetingSummaryPayload>;
  /** Rebuild an Account Confirmation task's advisory agreement and custodian forms, kicking a fresh DocuSign envelope */
  readonly regenerateOnboardingDocusignEnvelope?: Maybe<RegenerateOnboardingDocusignEnvelopePayload>;
  /** Refresh email_content snapshots on pending tasks for a catalog item */
  readonly regenerateStaleServiceCatalogTasks?: Maybe<RegenerateStaleServiceCatalogTasksPayload>;
  /** Register a mobile device push token for the current user */
  readonly registerPushToken?: Maybe<RegisterPushTokenPayload>;
  /** Re-issue a household's DocuSign envelope recipients with their current phone to clear a 2FA block (HAWK-447). */
  readonly reissueEnvelopeWithCurrentPhone?: Maybe<ReissueEnvelopeWithCurrentPhonePayload>;
  /** Reject pending-review scheduled report executions, discarding each */
  readonly rejectScheduledReportExecution?: Maybe<RejectScheduledReportExecutionPayload>;
  /** Release an awaiting-ops household to ready_to_send once the CSA has prepared its custodian paperwork (HAWK-1031). */
  readonly releaseAdvisorOnboardingToSend?: Maybe<ReleaseOnboardingToSendPayload>;
  /** Re-link the correct signed DocuSign envelope to a household stuck in the bulk signed loop (HAWK-445). */
  readonly relinkSignedEnvelope?: Maybe<RelinkSignedEnvelopePayload>;
  /** Remove an advisor from an advisor group (deactivates membership and revokes shared household access) */
  readonly removeAdvisorFromAdvisorGroup?: Maybe<RemoveAdvisorFromAdvisorGroupPayload>;
  /** Remove a staged co-client from a staged household, leaving the household and primary intact. */
  readonly removeAdvisorOnboardingStagedCoClient?: Maybe<RemoveStagedCoClientPayload>;
  /** Remove a staged household row, cascading to its staged clients and accounts. */
  readonly removeAdvisorOnboardingStagedHousehold?: Maybe<RemoveStagedHouseholdPayload>;
  /** Remove advisors from an organization */
  readonly removeAdvisorsFromOrganization?: Maybe<RemoveAdvisorsFromOrganizationPayload>;
  /**
   * Remove a user from a household, for anyone who can manage the household. If
   * the removed membership was the user's active household, clears
   * active_household_id.
   */
  readonly removeHouseholdMember?: Maybe<RemoveHouseholdMemberPayload>;
  /** Remove a scoped alert mute. */
  readonly removeNotificationAlertMute?: Maybe<RemoveNotificationAlertMutePayload>;
  /** Admin-only: soft-delete a confirm_account onboarding household from the cockpit (HAWK-972). */
  readonly removeOnboardingHousehold?: Maybe<RemoveOnboardingHouseholdPayload>;
  /** Remove a planning input and its manual Savvy source, refresh db facts, and update the same Conquest plan. */
  readonly removePlanInput?: Maybe<RemovePlanInputPayload>;
  /** Turn a professional contact back into a plain contact */
  readonly removeProfessionalDetails?: Maybe<RemoveProfessionalDetailsPayload>;
  /** Remove a secondary portfolio from a household (admin only) */
  readonly removeSecondaryPortfolio?: Maybe<RemoveSecondaryPortfolioPayload>;
  /** Remove a service catalog item from a group */
  readonly removeServiceCatalogItemFromGroup?: Maybe<RemoveServiceCatalogItemFromGroupPayload>;
  /** Remove recurrence from a task */
  readonly removeTaskRecurrence?: Maybe<RemoveTaskRecurrencePayload>;
  readonly renewInvite?: Maybe<RenewInvitePayload>;
  /** Persist drag-drop ordering for a household's service assignments */
  readonly reorderServiceCatalogItemHouseholds?: Maybe<ReorderServiceCatalogItemHouseholdsPayload>;
  /**
   * Move a sub-task to a new 1-indexed position within its parent. Other sub-tasks
   * shift to make room. Never mutates parent task status.
   */
  readonly reorderSubtask?: Maybe<ReorderSubtaskPayload>;
  /** Issue a presigned S3 PUT URL for one segment of a segmented meeting recording */
  readonly requestMeetingRecordingPartUpload?: Maybe<RequestMeetingRecordingPartUploadPayload>;
  /** Create a MeetingRecording and issue a presigned S3 PUT URL for its audio */
  readonly requestMeetingRecordingUpload?: Maybe<RequestMeetingRecordingUploadPayload>;
  /** Client POST for fetching past 7 years of tax history */
  readonly requestPastTranscriptsFromApril?: Maybe<RequestPastTranscriptsFromAprilPayload>;
  /** Request a read-only admin account for a Savvy staff email address */
  readonly requestReadOnlyAdminAccount?: Maybe<RequestReadOnlyAdminAccountPayload>;
  /**
   * Issue presigned S3 PUT URLs for repaper PDF uploads (HAWK-70). FE PUTs PDFs to
   * S3 then passes s3_keys to createRepaperEnvelope.
   */
  readonly requestRepaperPdfUploadUrls?: Maybe<RequestRepaperPdfUploadUrlsPayload>;
  /** Move a missed meeting occurrence to a new date */
  readonly rescheduleServiceOccurrence?: Maybe<RescheduleServiceOccurrencePayload>;
  /** Wipe this demo environment and rebuild it from the given shape. */
  readonly reseedDemoEnvironment?: Maybe<ReseedDemoEnvironmentPayload>;
  /**
   * Resend the ECI onboarding invite for an awaiting-client household: rotates
   * each unsubmitted client magic link and re-emails, reusing the original
   * message/settings.
   */
  readonly resendAdvisorOnboarding?: Maybe<ResendOnboardingInvitePayload>;
  /** Resend the DocuSign signing notification email for an in-flight envelope */
  readonly resendDocusignEnvelope?: Maybe<ResendDocusignEnvelopePayload>;
  /**
   * Email the client a fresh ECI onboarding link from the expired-link page.
   * Authorized by possession of the expired MagicLink token in the authorization
   * header; always sends to the address on file.
   */
  readonly resendEciOnboardingLink?: Maybe<ResendEciOnboardingLinkPayload>;
  readonly resendEmail?: Maybe<ResendEmailPayload>;
  readonly resendOtp?: Maybe<ResendOtpPayload>;
  /** Send the reminder email for a service assignment and stamp last_reminder_sent_at */
  readonly resendServiceCatalogReminder?: Maybe<ResendServiceCatalogReminderPayload>;
  /** Resend one occurrence's invite, using that occurrence's own snapshot */
  readonly resendServiceOccurrenceReminder?: Maybe<ResendServiceOccurrenceReminderPayload>;
  readonly resetClientIntakeData?: Maybe<ResetClientIntakeDataPayload>;
  readonly resetDemoHousehold?: Maybe<ResetDemoHouseholdPayload>;
  /** Reset all catalog notification routing overrides for a user. */
  readonly resetNotificationRouting?: Maybe<ResetNotificationRoutingPayload>;
  readonly resetPassword?: Maybe<ResetPasswordPayload>;
  readonly resetServiceCalendar?: Maybe<ResetServiceCalendarPayload>;
  /** Revert one occurrence's email to the household's copy, or the template's */
  readonly resetServiceOccurrenceEmail?: Maybe<ResetServiceOccurrenceEmailPayload>;
  /** Reset all v6 task notification routing overrides for the current user. */
  readonly resetTaskNotificationRouting?: Maybe<ResetTaskNotificationRoutingPayload>;
  /** Mark a ContributionReceived alert's group resolved once the advisor creates the SWIM/invest-cash task from it */
  readonly resolveContributionAlert?: Maybe<ResolveContributionAlertPayload>;
  /** Records an advisor's response to their survey notification */
  readonly respondToSurvey?: Maybe<RespondToSurveyPayload>;
  /**
   * Write a CSA's corrections back to the canonical ECI tables and re-drive the
   * Fidelity pipeline for a remediation subtask, atomically.
   */
  readonly resubmitEciRemediation?: Maybe<ResubmitEciRemediationPayload>;
  /** Retry a safely retryable failed document import */
  readonly retryPlanImport?: Maybe<RetryPlanImportPayload>;
  /**
   * Run an admin enabled service object. Note that all positional arguments should
   * be given in the order they are expected in the service object. Keyword
   * arguments should be passed after positional arguments and just need the
   * 'keywordArgKey' variable specified
   */
  readonly runAdminServiceObject?: Maybe<RunAdminServiceObjectPayload>;
  readonly runInternalAdminAction?: Maybe<RunInternalAdminActionPayload>;
  /** Upsert purpose and source of funds for a non-NFS ECI account onboarding request. */
  readonly saveEciAccountPurposeAndSourceOfFunds?: Maybe<SaveEciAccountPurposeAndSourceOfFundsPayload>;
  /** Replace all beneficiaries for an ECI account onboarding request. */
  readonly saveEciBeneficiaries?: Maybe<SaveEciBeneficiariesPayload>;
  /** Upsert inherited IRA original-depositor information for an ECI account onboarding request. */
  readonly saveEciDecedentDetails?: Maybe<SaveEciDecedentDetailsPayload>;
  /** Upsert SIMPLE IRA employer information for an ECI account onboarding request. */
  readonly saveEciEmployerDetails?: Maybe<SaveEciEmployerDetailsPayload>;
  /** Upsert joint/TIC owner details for an ECI account onboarding request. */
  readonly saveEciJointOwnerDetails?: Maybe<SaveEciJointOwnerDetailsPayload>;
  /** Save manually entered delivering firm details. */
  readonly saveEciManualDeliveringCustodian?: Maybe<SaveEciManualDeliveringCustodianPayload>;
  /** Upsert trust legal information for an ECI account onboarding request. */
  readonly saveEciTrustDetails?: Maybe<SaveEciTrustDetailsPayload>;
  /** Replace trusted contacts for an ECI client onboarding request. Authenticated via MagicLink authorization header. */
  readonly saveEciTrustedContacts?: Maybe<SaveEciTrustedContactsPayload>;
  /** Advisor-facing: replace the trusted contacts recorded for one ECI account holder. */
  readonly saveEciTrustedContactsForHolder?: Maybe<SaveEciTrustedContactsForHolderPayload>;
  /** Record the current user's thumb on one "Keep in mind" item */
  readonly saveHouseholdKeepInMindVote?: Maybe<SaveHouseholdKeepInMindVotePayload>;
  /** Record the current user's thumb on a Savvy meeting summary */
  readonly saveMeetingSummaryVote?: Maybe<SaveMeetingSummaryVotePayload>;
  /** Save a report builder configuration as a named template */
  readonly saveReportTemplate?: Maybe<SaveReportTemplatePayload>;
  /** Snapshot a project's current rows into a new, reusable project template */
  readonly saveRetirementPlanProjectAsTemplate?: Maybe<SaveRetirementPlanProjectAsTemplatePayload>;
  /**
   * Create or update a service and its full ordered item list in one transaction.
   * `items` is the complete list in display order: an entry with a null `id` is
   * created, one carrying an `id` is updated, and a persisted item the list leaves
   * out is detached from the service, pausing that item's household assignments.
   * Nothing is written unless the whole list saves — a failure on any item leaves
   * the service, its items and its memberships exactly as they were.
   */
  readonly saveServiceCatalogItemGroup?: Maybe<SaveServiceCatalogItemGroupPayload>;
  /** Schedule a native PDF report for async background generation */
  readonly scheduleNativeReport?: Maybe<ScheduleNativeReportPayload>;
  /** Select a local delivering custodian. */
  readonly selectEciDeliveringCustodian?: Maybe<SelectEciDeliveringCustodianPayload>;
  /** Send ECI onboarding invites for a ready-to-send staged household and advance it to awaiting_client. */
  readonly sendAdvisorOnboarding?: Maybe<SendOnboardingPayload>;
  /**
   * Send the existing ECI onboarding magic link for an awaiting-client household
   * to the Savvy Ops mailbox without rotating the token or changing
   * status/reminders.
   */
  readonly sendAdvisorOnboardingInviteToOps?: Maybe<SendOnboardingInviteToOpsPayload>;
  /** Sends a client booking email */
  readonly sendClientBookingEmail?: Maybe<SendClientBookingEmailPayload>;
  readonly sendClientWelcomeEmail?: Maybe<SendClientWelcomeEmailPayload>;
  readonly sendCreatePasswordEmail?: Maybe<SendCreatePasswordEmailPayload>;
  /** Send an email via Gmail on behalf of the authenticated advisor */
  readonly sendEmailMessage?: Maybe<SendEmailMessagePayload>;
  readonly sendFileShareEmail?: Maybe<SendFileShareEmailPayload>;
  /** Send onboarding to client, will also update the onboarding task status */
  readonly sendOnboardingToClient?: Maybe<SendOnboardingToClientPayload>;
  /** Sends a password-reset email to a client user who has already set a password */
  readonly sendPasswordResetEmail?: Maybe<SendPasswordResetEmailPayload>;
  /** Flip a draft repaper envelope to sent — kicks off DocuSign signing routing */
  readonly sendRepaperEnvelope?: Maybe<SendRepaperEnvelopePayload>;
  readonly sendSignOnboardingDocumentsReminder?: Maybe<SendSignOnboardingDocumentsReminderPayload>;
  readonly sendTaskEmail?: Maybe<SendTaskEmailPayload>;
  /** Enable or disable the account-connection reminder email for a household */
  readonly setAccountConnectionReminderPreference?: Maybe<SetAccountConnectionReminderPreferencePayload>;
  /** Pin or unpin an activity timeline entry for its household */
  readonly setActivityEntryPinned?: Maybe<SetActivityEntryPinnedPayload>;
  /** Internal-admin: set an advisor-tier team member's level (assistant/advisor/admin). */
  readonly setAdvisorTierLevel?: Maybe<SetAdvisorTierLevelPayload>;
  /** Internal-admin: set one advisor-tier team member's level after verifying their identity */
  readonly setAdvisorTierLevelByIdentity?: Maybe<SetAdvisorTierLevelByIdentityPayload>;
  /** Replace a client's full set of recurring income sources */
  readonly setClientIncomeSources?: Maybe<SetClientIncomeSourcesPayload>;
  readonly setContactAccountRelation?: Maybe<SetContactAccountRelationPayload>;
  /** Set a contact's membership, relationship and professional role for one household */
  readonly setContactHouseholdConnection?: Maybe<SetContactHouseholdConnectionPayload>;
  readonly setGovernmentId?: Maybe<SetGovernmentIdPayload>;
  /** Set the Orion benchmark for a household. */
  readonly setHouseholdBenchmark?: Maybe<SetHouseholdBenchmarkPayload>;
  /**
   * Store how many months one enrolled household's dates on a service are pushed
   * out by, or put it back on time with 0: each of its fixed-date occurrences
   * lands that many months after the on-time one. Refused past the service's
   * maxScheduleOffsetMonths, unless the value is the one already stored, and
   * refused when lowering it would move the household's next meeting onto a date
   * that has passed. Rematerializes that household's future occurrences on the
   * service's fixed-date items.
   */
  readonly setHouseholdScheduleOffset?: Maybe<SetHouseholdScheduleOffsetPayload>;
  /** Shift the next occurrence of an assignment to a specific future date */
  readonly setServiceCatalogItemHouseholdNextOccurrence?: Maybe<SetServiceCatalogItemHouseholdNextOccurrencePayload>;
  /** Reword one occurrence's email, leaving every other occurrence alone */
  readonly setServiceOccurrenceEmail?: Maybe<SetServiceOccurrenceEmailPayload>;
  /** Admin: replace the Savvy Portfolio Finance loan-length options */
  readonly setSwimLoanLengthOptions?: Maybe<SetSwimLoanLengthOptionsPayload>;
  /** Admin: replace the SWIM enrollment strategies and their fees */
  readonly setSwimStrategies?: Maybe<SetSwimStrategiesPayload>;
  /** Set or update recurrence on a task */
  readonly setTaskRecurrence?: Maybe<SetTaskRecurrencePayload>;
  /** Transactionally create an organization, its advisor group, memberships, org link, and optional branding */
  readonly setUpAdvisorOrganization?: Maybe<SetUpAdvisorOrganizationPayload>;
  readonly setupTaskReminders?: Maybe<SetupTaskRemindersPayload>;
  /** Share a household with an advisor group */
  readonly shareHouseholdWithAdvisorGroup?: Maybe<ShareHouseholdWithAdvisorGroupPayload>;
  /** Surface an already-published report in the client portal */
  readonly sharePublishedReport?: Maybe<SharePublishedReportPayload>;
  /** Grant another organization access to a retirement plan */
  readonly shareRetirementPlanWithOrganization?: Maybe<ShareRetirementPlanWithOrganizationPayload>;
  /** Sign a tax addendum agreement for the current client user */
  readonly signTaxAddendum?: Maybe<SignTaxAddendumPayload>;
  readonly signUpForSavvy?: Maybe<SignUpForSavvyPayload>;
  /** Mark one service occurrence as not happening */
  readonly skipServiceOccurrence?: Maybe<SkipServiceOccurrencePayload>;
  /**
   * Move a co-client out of a shared household into a new household under the same
   * advisor. Ops-invoked via Goalie or (once the UI ships) advisor-invoked;
   * identity verification and preflight branching happen at the mutation and
   * service layers.
   */
  readonly splitHousehold?: Maybe<SplitHouseholdPayload>;
  /** Start an async job to fetch Portfolio Performance vs Benchmark data for a household */
  readonly startBenchmarkDataGeneration?: Maybe<StartBenchmarkDataGenerationPayload>;
  /** Start client onboarding for selected new accounts or a custodian upgrade. */
  readonly startEciClientOnboarding?: Maybe<StartEciClientOnboardingPayload>;
  /** Start document enrichment for an existing financial plan */
  readonly startPlanImport?: Maybe<StartPlanImportPayload>;
  /**
   * Admin: pull Schwab AS Standing Authorizations over the API for the whole firm
   * into the Linked Bank Accounts pipeline. Takes no arguments; every
   * Schwab-custodied account is paired with its primary advisor's master account.
   */
  readonly startSchwabApiImport?: Maybe<StartSchwabApiImportPayload>;
  /** Endpoint to stop impersonation */
  readonly stopImpersonatingUser?: Maybe<StopImpersonatingUserPayload>;
  /** Revoke one or more organizations' shared access to a retirement plan */
  readonly stopSharingRetirementPlanOrganizations?: Maybe<StopSharingRetirementPlanOrganizationsPayload>;
  /**
   * Terminal cockpit ECI book-onboarding submit: publishes the promoted draft
   * graph, activates account-onboarding tasks, and sends client invites.
   */
  readonly submitEciAccountOnboarding?: Maybe<SubmitEciAccountOnboardingPayload>;
  /**
   * Submit ECI client onboarding: creates a Signature and linked ClientAgreement
   * for the MSA, and ClientAgreement-only records for each acknowledged
   * disclosure, then marks the request submitted. Authenticated via MagicLink
   * authorization header.
   */
  readonly submitEciClientOnboarding?: Maybe<SubmitEciClientOnboardingPayload>;
  /** Submit new ECI accounts for clients with a previously signed MSA */
  readonly submitNewEciAccounts?: Maybe<SubmitNewEciAccountsPayload>;
  /** Switch the viewer's active household. Viewer must be a member of the target household or its advisor. */
  readonly switchActiveHousehold?: Maybe<SwitchActiveHouseholdPayload>;
  /** Sync the selected accounts to transfer to ECI; creates tasks for newly-selected accounts and cancels deselected ones. */
  readonly syncEciAccountOnboardingRequestSelection?: Maybe<SyncEciAccountOnboardingRequestSelectionPayload>;
  /** Sync Orion data */
  readonly syncOrionData?: Maybe<SyncOrionDataPayload>;
  /** Queue an Orion data sync for one household after verifying its public identifier and name */
  readonly syncOrionDataByPublicId?: Maybe<SyncOrionDataByPublicIdPayload>;
  /** Mark which prefilled standing instructions / recurring transfers carry over to the new ECI account. */
  readonly syncStandingInstructionSelections?: Maybe<SyncStandingInstructionSelectionsPayload>;
  /** Add or remove your reaction of one emoji on a comment. */
  readonly toggleCommentReaction?: Maybe<ToggleCommentReactionPayload>;
  readonly trackEvent?: Maybe<TrackEventPayload>;
  /** Unarchive a client household: restore stage from inactive to won */
  readonly unarchiveHousehold?: Maybe<UnarchiveHouseholdPayload>;
  /** Unarchive a service catalog item group */
  readonly unarchiveServiceCatalogItemGroup?: Maybe<UnarchiveServiceCatalogItemGroupPayload>;
  /** Soft-unassign a service catalog item from a household */
  readonly unassignServiceCatalogItemFromHousehold?: Maybe<UnassignServiceCatalogItemFromHouseholdPayload>;
  /**
   * Pause the enrollments one service owns for each household, transactionally per
   * household. An enrollment is this service's when it carries this service's id,
   * or carries none and is on an item no other live service lists, so a household
   * on a second service keeps that one's schedule and its materialized
   * occurrences. An archived service still accepts unenrollment. Duplicate ids are
   * collapsed, and `results` is in the order the ids were given.
   */
  readonly unenrollHouseholdsFromServiceCatalogItemGroup?: Maybe<UnenrollHouseholdsFromServiceCatalogItemGroupPayload>;
  /** Detach a household co-client without destroying their user record */
  readonly unlinkHouseholdCoClient?: Maybe<UnlinkHouseholdCoClientPayload>;
  /** Remove the interaction recorded against a service occurrence */
  readonly unlinkInteractionFromServiceOccurrence?: Maybe<UnlinkInteractionFromServiceOccurrencePayload>;
  /** Clear a household's Orion connection (admin only) */
  readonly unlinkOrionHousehold?: Maybe<UnlinkOrionHouseholdPayload>;
  /** Remove a link between two tasks */
  readonly unlinkTask?: Maybe<UnlinkTaskPayload>;
  /** Remove a link between a household timeline item and a contact */
  readonly unlinkTimelineItemFromContact?: Maybe<UnlinkTimelineItemFromContactPayload>;
  /** Remove a mobile device push token for the current user */
  readonly unregisterPushToken?: Maybe<UnregisterPushTokenPayload>;
  readonly updateAccount?: Maybe<UpdateAccountPayload>;
  /** Update an account sleeve */
  readonly updateAccountSleeve?: Maybe<UpdateAccountSleevePayload>;
  readonly updateAccountTransferDatum?: Maybe<UpdateAccountTransferDatumPayload>;
  readonly updateActionCenterVisited?: Maybe<UpdateActionCenterVisitedPayload>;
  readonly updateAddress?: Maybe<UpdateAddressPayload>;
  readonly updateAdvisorAiDisclosureAcceptance?: Maybe<UpdateAdvisorAiDisclosureAcceptancePayload>;
  /** @deprecated Use update_advisor_settings instead */
  readonly updateAdvisorAlertSettings?: Maybe<UpdateAdvisorAlertSettingsPayload>;
  /** Set whether an advisor is employed under Savvy's RIA (captive) or runs their own book (owned) */
  readonly updateAdvisorCaptiveStatus?: Maybe<UpdateAdvisorCaptiveStatusPayload>;
  readonly updateAdvisorCsa?: Maybe<UpdateAdvisorCsaPayload>;
  /** Update the current advisor's own directory profile */
  readonly updateAdvisorDirectoryProfile: AdvisorDirectoryEntry;
  /** Update group-level display settings such as hiding ARR from support staff (assistants and CSAs) */
  readonly updateAdvisorGroupSettings?: Maybe<UpdateAdvisorGroupSettingsPayload>;
  /** Set whether an advisor is a new advisor or an existing one, which gates the contract their clients sign */
  readonly updateAdvisorOnboardingCohort?: Maybe<UpdateAdvisorOnboardingCohortPayload>;
  /** Advance the advisor onboarding enrollment wizard step for deeplink resume. */
  readonly updateAdvisorOnboardingEnrollment?: Maybe<UpdateEnrollmentPayload>;
  /** Admin-only: set the destination custodian on a staged, not-yet-confirmed onboarding account (HAWK-923). */
  readonly updateAdvisorOnboardingStagedAccountDestination?: Maybe<UpdateStagedAccountDestinationPayload>;
  /** Edit a staged client field and re-run per-field validation. */
  readonly updateAdvisorOnboardingStagedClient?: Maybe<UpdateStagedClientPayload>;
  /** Edit a staged household field and re-run per-field validation. */
  readonly updateAdvisorOnboardingStagedHousehold?: Maybe<UpdateStagedHouseholdPayload>;
  /** @deprecated Use update_advisor_settings instead */
  readonly updateAdvisorProfile?: Maybe<UpdateAdvisorProfilePayload>;
  readonly updateAdvisorSettings?: Maybe<UpdateAdvisorSettingsPayload>;
  readonly updateAlert?: Maybe<UpdateAlertPayload>;
  readonly updateAsset?: Maybe<UpdateAssetPayload>;
  readonly updateClientDetails?: Maybe<UpdateClientDetailsPayload>;
  readonly updateClientEmploymentDetails?: Maybe<UpdateClientEmploymentDetailsPayload>;
  readonly updateClientIntakeData?: Maybe<UpdateClientIntakeDataPayload>;
  readonly updateClientPortalMessage?: Maybe<UpdateClientPortalMessagePayload>;
  readonly updateClientProfile?: Maybe<UpdateClientProfilePayload>;
  /** Update client details and roles in a single transaction */
  readonly updateClients?: Maybe<UpdateClientsPayload>;
  /** Edit your own comment. Stamps editedAt so the UI can render "(edited)". */
  readonly updateComment?: Maybe<UpdateCommentPayload>;
  /**
   * File a copy of an attachment under the household's client-visible Additional
   * Materials folder, or remove that copy. Savvy makes the Box copy and records
   * its id in the same call, so the id stored and the object it names are written
   * by the same actor.
   */
  readonly updateCommentAttachmentSync?: Maybe<UpdateCommentAttachmentSyncPayload>;
  readonly updateContact?: Maybe<UpdateContactPayload>;
  /** Update notes for a DialpadCall */
  readonly updateDialpadCallNotes?: Maybe<UpdateDialpadCallNotesPayload>;
  /** Update content for a DialpadEvent */
  readonly updateDialpadEventContent?: Maybe<UpdateDialpadEventContentPayload>;
  /**
   * Upsert the citizenship & tax-status fields on the personal-information row for
   * an ECI client onboarding request. Authenticated via MagicLink authorization header.
   */
  readonly updateEciCitizenshipTaxStatus?: Maybe<UpdateEciCitizenshipTaxStatusPayload>;
  /**
   * Move the resume cursor for an ECI client onboarding request as the client
   * advances. Authenticated via MagicLink authorization header.
   */
  readonly updateEciCurrentStep?: Maybe<UpdateEciCurrentStepPayload>;
  /**
   * Upsert the financial profile sidecar for an ECI client onboarding request.
   * Authenticated via MagicLink authorization header.
   */
  readonly updateEciFinancialProfile?: Maybe<UpdateEciFinancialProfilePayload>;
  /**
   * Upsert the personal information sidecar for an ECI client onboarding request.
   * Authenticated via MagicLink authorization header.
   */
  readonly updateEciPersonalInformation?: Maybe<UpdateEciPersonalInformationPayload>;
  /**
   * Upsert the regulatory-disclosures header and detail rows for an ECI client
   * onboarding request. Authenticated via MagicLink authorization header.
   */
  readonly updateEciRegulatoryDisclosure?: Maybe<UpdateEciRegulatoryDisclosurePayload>;
  /** Update a family member in a household */
  readonly updateFamilyMember?: Maybe<UpdateFamilyMemberPayload>;
  /** Update a fee schedule */
  readonly updateFeeSchedule?: Maybe<UpdateFeeSchedulePayload>;
  /** Admin-only: atomically update a Financial Offering and its fees, key facts, links, and provider copy */
  readonly updateFinancialOffering?: Maybe<UpdateFinancialOfferingPayload>;
  readonly updateGoal?: Maybe<UpdateGoalPayload>;
  /** Update attributes of a household */
  readonly updateHousehold?: Maybe<UpdateHouseholdPayload>;
  /** Update household permissions */
  readonly updateHouseholdAccess?: Maybe<UpdateHouseholdAccessPayload>;
  /** Advisor-only: update a household membership's role and/or flags. */
  readonly updateHouseholdMember?: Maybe<UpdateHouseholdMemberPayload>;
  /** Change the month one household referred another to the firm */
  readonly updateHouseholdReferral?: Maybe<UpdateHouseholdReferralPayload>;
  /** Update tags for a household */
  readonly updateHouseholdTags?: Maybe<UpdateHouseholdTagsPayload>;
  readonly updateLiability?: Maybe<UpdateLiabilityPayload>;
  /** Update a meeting agenda template */
  readonly updateMeetingAgendaTemplate?: Maybe<UpdateMeetingAgendaTemplatePayload>;
  readonly updateNote?: Maybe<UpdateNotePayload>;
  /** Set one catalog notification destination for a user. */
  readonly updateNotificationRoute?: Maybe<UpdateNotificationRoutePayload>;
  /** Update the current advisor's onboarding personalization (welcome message, firm name, firm logo) */
  readonly updateOnboardingPersonalization?: Maybe<UpdateOnboardingPersonalizationPayload>;
  /** Update the data for an onboarding task */
  readonly updateOnboardingTaskData?: Maybe<UpdateOnboardingTaskDataPayload>;
  readonly updateOpportunity?: Maybe<UpdateOpportunityPayload>;
  /** Update organization branding including logo upload to Cloudinary */
  readonly updateOrganizationBranding?: Maybe<UpdateOrganizationBrandingPayload>;
  /** Update an organization household category */
  readonly updateOrganizationHouseholdCategory?: Maybe<UpdateOrganizationHouseholdCategoryPayload>;
  /** Update an organization household tag */
  readonly updateOrganizationHouseholdTag?: Maybe<UpdateOrganizationHouseholdTagPayload>;
  /** Replace the set of households a manual tag is applied to (smart tags are rule-driven and rejected). */
  readonly updateOrganizationHouseholdTagHouseholds?: Maybe<UpdateOrganizationHouseholdTagHouseholdsPayload>;
  /** Update firm-setup settings on the current user's organization, such as whether Organization Branding is available */
  readonly updateOrganizationSettings?: Maybe<UpdateOrganizationSettingsPayload>;
  /** Update the current user organization's ops paperwork instructions message */
  readonly updateOrganizationTaskInstructions?: Maybe<UpdateOrganizationTaskInstructionsPayload>;
  /** Update Orion report enrollments for multiple households */
  readonly updateOrionReportEnrollments?: Maybe<UpdateOrionReportEnrollmentsPayload>;
  /**
   * Save supported edits to Savvy, refresh Savvy-owned facts, replace the engine
   * inputs, and return stored engine data. Takes the WHOLE plan: current Savvy
   * records are rediscovered, while omitted plan-only choices are not retained in
   * the saved draft. Savvy records are not deleted. Read the plan first and send it all back.
   */
  readonly updatePlan?: Maybe<UpdatePlanPayload>;
  /** Update fields on a quarterly financial snapshot (patch semantics) */
  readonly updatePlanFinancialSnapshot?: Maybe<UpdatePlanFinancialSnapshotPayload>;
  /** Update a portfolio's investment details */
  readonly updatePortfolio?: Maybe<UpdatePortfolioPayload>;
  /** Update a portfolio strategy's name */
  readonly updatePortfolioStrategy?: Maybe<UpdatePortfolioStrategyPayload>;
  /** Edit a professional service */
  readonly updateProfessionalService?: Maybe<UpdateProfessionalServicePayload>;
  /** Update an opportunity for a prospect opportunity */
  readonly updateProspectOpportunity?: Maybe<UpdateProspectOpportunityPayload>;
  readonly updateProviderAccount?: Maybe<UpdateProviderAccountPayload>;
  /** Edit a referral */
  readonly updateReferral?: Maybe<UpdateReferralPayload>;
  /** Update an automated delivery schedule */
  readonly updateReportSchedule?: Maybe<UpdateReportSchedulePayload>;
  /** Update an existing saved report template */
  readonly updateReportTemplate?: Maybe<UpdateReportTemplatePayload>;
  /** Update an existing retirement plan (gated behind retirementPlans flag) */
  readonly updateRetirementPlan?: Maybe<UpdateRetirementPlanPayload>;
  /** Create or update plan design details (upserts the single design record for the plan) */
  readonly updateRetirementPlanDesign?: Maybe<UpdateRetirementPlanDesignPayload>;
  /** Update fields on a retirement plan milestone (patch semantics) */
  readonly updateRetirementPlanMilestone?: Maybe<UpdateRetirementPlanMilestonePayload>;
  /** Update a retirement plan note (patch semantics) */
  readonly updateRetirementPlanNote?: Maybe<UpdateRetirementPlanNotePayload>;
  /** Update a participant interaction log entry (patch semantics) */
  readonly updateRetirementPlanParticipantLog?: Maybe<UpdateRetirementPlanParticipantLogPayload>;
  /** Update a retirement plan project (patch semantics) */
  readonly updateRetirementPlanProject?: Maybe<UpdateRetirementPlanProjectPayload>;
  /** Update a retirement plan project row (patch semantics) */
  readonly updateRetirementPlanProjectRow?: Maybe<UpdateRetirementPlanProjectRowPayload>;
  /** Update a retirement plan project template (patch semantics; steps, when provided, replace the existing set) */
  readonly updateRetirementPlanProjectTemplate?: Maybe<UpdateRetirementPlanProjectTemplatePayload>;
  /** Re-sync a project's source template so its steps match the project's current rows */
  readonly updateRetirementPlanProjectTemplateFromProject?: Maybe<UpdateRetirementPlanProjectTemplateFromProjectPayload>;
  /** Update an RMD */
  readonly updateRmd?: Maybe<UpdateRmdPayload>;
  readonly updateServiceCalendarItem?: Maybe<UpdateServiceCalendarItemPayload>;
  readonly updateServiceCalendarMeeting?: Maybe<UpdateServiceCalendarMeetingPayload>;
  readonly updateServiceCalendarSettingTemplates?: Maybe<UpdateServiceCalendarSettingTemplatesPayload>;
  readonly updateServiceCalendarSettings?: Maybe<UpdateServiceCalendarSettingsPayload>;
  /** Update a service catalog item */
  readonly updateServiceCatalogItem?: Maybe<UpdateServiceCatalogItemPayload>;
  /** Update a service catalog item group */
  readonly updateServiceCatalogItemGroup?: Maybe<UpdateServiceCatalogItemGroupPayload>;
  /** Update a per-assignment override */
  readonly updateServiceCatalogItemHouseholdOverride?: Maybe<UpdateServiceCatalogItemHouseholdOverridePayload>;
  /** Update simple tasks */
  readonly updateSimpleTask?: Maybe<UpdateSimpleTaskPayload>;
  /** Update a sub-task. Never mutates parent task status. */
  readonly updateSubtask?: Maybe<UpdateSubtaskPayload>;
  readonly updateTask?: Maybe<UpdateTaskPayload>;
  readonly updateTaskComment?: Maybe<UpdateTaskCommentPayload>;
  /** Upsert one v6 task notification routing cell for the current user. */
  readonly updateTaskNotificationRoute?: Maybe<UpdateTaskNotificationRoutePayload>;
  readonly updateTaskSuggestion?: Maybe<UpdateTaskSuggestionPayload>;
  /** Update a task and its associated work item records in a single operation */
  readonly updateTaskWorkItem?: Maybe<UpdateTaskWorkItemPayload>;
  /** Update a workflow template */
  readonly updateTaskWorkflowTemplate?: Maybe<UpdateTaskWorkflowTemplatePayload>;
  /** Update a tax enrollment */
  readonly updateTaxEnrollment?: Maybe<UpdateTaxEnrollmentPayload>;
  readonly updateUser?: Maybe<UpdateUserPayload>;
  /** Update a contact for a user */
  readonly updateUserContact?: Maybe<UpdateUserContactPayload>;
  /** Push filing data into april */
  readonly updateUserDataInAprilFiling?: Maybe<UpdateUserDataInAprilFilingPayload>;
  readonly updateUserSecurityAttribute?: Maybe<UpdateUserSecurityAttributePayload>;
  /** Admin: replace an ECI template with a new Box version, gated on the field contract the code requires */
  readonly uploadEciFormTemplate?: Maybe<UploadEciFormTemplatePayload>;
  /** Upload file to Box folder */
  readonly uploadFileToBox?: Maybe<UploadToBoxResult>;
  /** Admin: upload a custodian CSV/XLSX for the Linked Bank Accounts seed tool — enqueues background parsing */
  readonly uploadLinkedBankAccountImport?: Maybe<UploadLinkedBankAccountImportPayload>;
  /** Upsert saved view/preferences values for the current user */
  readonly upsertUserSavedViews?: Maybe<UpsertUserSavedViewsPayload>;
  /** Validate advisor-entered tickers against Orion before adding to a blended investment proposal target. */
  readonly validateInvestmentProposalTickers?: Maybe<ValidateInvestmentProposalTickersPayload>;
  /**
   * Verify the client's identity (last name / SSN / DOB) against the values on
   * file before they proceed through ECI onboarding. Authenticated via MagicLink
   * authorization header.
   */
  readonly verifyEciOnboardingIdentity?: Maybe<VerifyEciOnboardingIdentityPayload>;
  /** Commit a captured Voice Profile */
  readonly voiceProfileCommit?: Maybe<VoiceProfileCommitPayload>;
  /** Remove an example from the voice profile */
  readonly voiceProfileRemoveExample?: Maybe<VoiceProfileRemoveExamplePayload>;
  /** Re-run voice extraction */
  readonly voiceProfileRerunCapture?: Maybe<VoiceProfileRerunCapturePayload>;
  /** Persist the display-only generated voice sample */
  readonly voiceProfileSetSample?: Maybe<VoiceProfileSetSamplePayload>;
  /** Void an in-flight DocuSign envelope */
  readonly voidDocusignEnvelope?: Maybe<VoidDocusignEnvelopePayload>;
  /** Preview a Wealthbox API import for an advisor — mutation to guarantee POST transport and prevent access_token URL exposure */
  readonly wealthboxImportPreview?: Maybe<WealthboxImportPreviewMutationPayload>;
};


export type MutationAcknowledgeAlertArgs = {
  input: AcknowledgeAlertInput;
};


export type MutationAcknowledgeChimneyPropertyDisclosureArgs = {
  input: AcknowledgeChimneyPropertyDisclosureInput;
};


export type MutationActivateServiceCalendarForHouseholdArgs = {
  input: ActivateServiceCalendarForHouseholdInput;
};


export type MutationAddAdvisorGroupToOrganizationArgs = {
  input: AddAdvisorGroupToOrganizationInput;
};


export type MutationAddAdvisorToExistingAdvisorGroupArgs = {
  input: AddAdvisorToExistingAdvisorGroupInput;
};


export type MutationAddAdvisorsToOrganizationArgs = {
  input: AddAdvisorsToOrganizationInput;
};


export type MutationAddCommentAttachmentsArgs = {
  input: AddCommentAttachmentsInput;
};


export type MutationAddFamilyMembersArgs = {
  input: AddFamilyMembersInput;
};


export type MutationAddHouseholdMemberArgs = {
  input: AddHouseholdMemberInput;
};


export type MutationAddNotificationAlertMuteArgs = {
  input: AddNotificationAlertMuteInput;
};


export type MutationAddSavvyServiceTemplateToResourcesArgs = {
  input: AddSavvyServiceTemplateToResourcesInput;
};


export type MutationAddSecondaryPortfolioArgs = {
  input: AddSecondaryPortfolioInput;
};


export type MutationAddServiceCatalogItemToGroupArgs = {
  input: AddServiceCatalogItemToGroupInput;
};


export type MutationAddSurveyRecipientsArgs = {
  input: AddSurveyRecipientsInput;
};


export type MutationAdoptWealthscapeAccountArgs = {
  input: AdoptWealthscapeAccountInput;
};


export type MutationAdvanceEciOnboardingToReadyToSendArgs = {
  input: AdvanceEciOnboardingToReadyToSendInput;
};


export type MutationAdvanceOnboardingAfterSigningArgs = {
  input: AdvanceOnboardingAfterSigningInput;
};


export type MutationApplyAdvisorOnboardingCorrectionArgs = {
  input: ApplyCorrectionInput;
};


export type MutationApproveScheduledReportExecutionArgs = {
  input: ApproveScheduledReportExecutionInput;
};


export type MutationArchiveHouseholdArgs = {
  input: ArchiveHouseholdInput;
};


export type MutationArchiveHouseholdByPublicIdArgs = {
  input: ArchiveHouseholdByPublicIdInput;
};


export type MutationArchiveServiceCatalogItemArgs = {
  input: ArchiveServiceCatalogItemInput;
};


export type MutationArchiveServiceCatalogItemGroupArgs = {
  input: ArchiveServiceCatalogItemGroupInput;
};


export type MutationAssignAdvisorWealthscapeCredentialsArgs = {
  input: AssignAdvisorWealthscapeCredentialsInput;
};


export type MutationAssignHouseholdFeeScheduleArgs = {
  input: AssignHouseholdFeeScheduleInput;
};


export type MutationAssignServiceCatalogItemToHouseholdArgs = {
  input: AssignServiceCatalogItemToHouseholdInput;
};


export type MutationBeginMfaEnrollmentArgs = {
  input: BeginMfaEnrollmentInput;
};


export type MutationBulkCancelTasksArgs = {
  input: BulkCancelTasksInput;
};


export type MutationBulkCreateOrUpdateHouseholdsArgs = {
  input: BulkCreateOrUpdateHouseholdsInput;
};


export type MutationBulkDeleteOrganizationHouseholdTagsArgs = {
  input: BulkDeleteOrganizationHouseholdTagsInput;
};


export type MutationBulkGenerateReportsArgs = {
  input: BulkGenerateReportsInput;
};


export type MutationBulkUpdateAlertsArgs = {
  input: BulkUpdateAlertsInput;
};


export type MutationBulkUpdateClientsArgs = {
  input: BulkUpdateClientsInput;
};


export type MutationBulkUpdateOrganizationHouseholdCategoriesArgs = {
  input: BulkUpdateOrganizationHouseholdCategoriesInput;
};


export type MutationBulkUpdateTaxEnrollmentsToNotInterestedArgs = {
  input: BulkUpdateTaxEnrollmentsToNotInterestedInput;
};


export type MutationBulkUploadFilesToBoxArgs = {
  input: BulkUploadFilesToBoxInput;
};


export type MutationCancelExactTasksArgs = {
  input: CancelExactTasksInput;
};


export type MutationCancelLinkedBankAccountImportArgs = {
  input: CancelLinkedBankAccountImportInput;
};


export type MutationClearHouseholdBenchmarkArgs = {
  input: ClearHouseholdBenchmarkInput;
};


export type MutationClearRedisCacheForBoxFolderArgs = {
  input: ClearRedisCacheForBoxFolderInput;
};


export type MutationCloseEciRemediationSubtaskArgs = {
  input: CloseEciRemediationSubtaskInput;
};


export type MutationCompleteGoogleOAuthFlowArgs = {
  input: CompleteGoogleOAuthFlowInput;
};


export type MutationCompleteSchwabOauthConnectArgs = {
  input: CompleteSchwabOauthConnectInput;
};


export type MutationCompleteServiceOccurrenceArgs = {
  input: CompleteServiceOccurrenceInput;
};


export type MutationConfirmAdvisorOnboardingAccountsArgs = {
  input: ConfirmAccountsInput;
};


export type MutationConfirmLinkedBankAccountImportArgs = {
  input: ConfirmLinkedBankAccountImportInput;
};


export type MutationConfirmPortfolioArgs = {
  input: ConfirmPortfolioInput;
};


export type MutationCorrectClientIdentityDetailsArgs = {
  input: CorrectClientIdentityDetailsInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateAccountConfirmationTaskArgs = {
  input: CreateAccountConfirmationTaskInput;
};


export type MutationCreateAccountMaintenanceTaskArgs = {
  input: CreateAccountMaintenanceTaskInput;
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateAdvisorArgs = {
  input: CreateAdvisorInput;
};


export type MutationCreateAdvisorGroupArgs = {
  input: CreateAdvisorGroupInput;
};


export type MutationCreateAdvisorOnboardingEnrollmentArgs = {
  input: CreateEnrollmentInput;
};


export type MutationCreateAdvisorRequestArgs = {
  input: CreateAdvisorRequestInput;
};


export type MutationCreateAlertArgs = {
  input: CreateAlertInput;
};


export type MutationCreateAlternativeInvestmentsPurchaseTaskArgs = {
  input: CreateAlternativeInvestmentsPurchaseTaskInput;
};


export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};


export type MutationCreateBulkImportArgs = {
  input: CreateBulkImportInput;
};


export type MutationCreateCenterOfInfluenceRepArgs = {
  input: CreateCenterOfInfluenceRepInput;
};


export type MutationCreateClientBillingTaskArgs = {
  input: CreateClientBillingTaskInput;
};


export type MutationCreateClientInfoChangeTaskArgs = {
  input: CreateClientInfoChangeTaskInput;
};


export type MutationCreateClientOpportunityArgs = {
  input: CreateClientOpportunityInput;
};


export type MutationCreateClientPortalMessageArgs = {
  input: CreateClientPortalMessageInput;
};


export type MutationCreateCoClientFromIntakeDataArgs = {
  input: CreateCoClientFromIntakeDataInput;
};


export type MutationCreateCoClientUserArgs = {
  input: CreateCoClientUserInput;
};


export type MutationCreateCoiCallLogArgs = {
  input: CreateCoiCallLogInput;
};


export type MutationCreateCoiMeetingArgs = {
  input: CreateCoiMeetingInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCompanyCallLogArgs = {
  input: CreateCompanyCallLogInput;
};


export type MutationCreateCompanyMeetingArgs = {
  input: CreateCompanyMeetingInput;
};


export type MutationCreateConquestPlanFromDataArgs = {
  input: CreateConquestPlanFromDataInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateContactCallLogArgs = {
  input: CreateContactCallLogInput;
};


export type MutationCreateContactMeetingArgs = {
  input: CreateContactMeetingInput;
};


export type MutationCreateContributionAlertsFromUploadArgs = {
  input: CreateContributionAlertsFromUploadInput;
};


export type MutationCreateCorporateRetirementPlanTaskArgs = {
  input: CreateCorporateRetirementPlanTaskInput;
};


export type MutationCreateDataExportArgs = {
  input: CreateDataExportInput;
};


export type MutationCreateDocumentSignatureForTaskArgs = {
  input: CreateDocumentSignatureForTaskInput;
};


export type MutationCreateDocusignLpoaEnvelopeBulkUploadArgs = {
  input: CreateDocusignLpoaEnvelopeBulkUploadInput;
};


export type MutationCreateEciAccountOnboardingRequestArgs = {
  input: CreateEciAccountOnboardingRequestInput;
};


export type MutationCreateEciCustodianFormsSigningLinkArgs = {
  input: CreateEciCustodianFormsSigningLinkInput;
};


export type MutationCreateFeeScheduleForAdvisorArgs = {
  input: CreateFeeScheduleForAdvisorInput;
};


export type MutationCreateFileUploadTaskArgs = {
  input: CreateFileUploadTaskInput;
};


export type MutationCreateFinancialOfferingArgs = {
  input: CreateFinancialOfferingInput;
};


export type MutationCreateFinancialPlanArgs = {
  input: CreateFinancialPlanInput;
};


export type MutationCreateGoalArgs = {
  input: CreateGoalInput;
};


export type MutationCreateHouseholdReferralArgs = {
  input: CreateHouseholdReferralInput;
};


export type MutationCreateLiabilityArgs = {
  input: CreateLiabilityInput;
};


export type MutationCreateManualOnboardingTaskArgs = {
  input: CreateManualOnboardingTaskInput;
};


export type MutationCreateMeetingArgs = {
  input: CreateMeetingInput;
};


export type MutationCreateMeetingAgendaTemplateArgs = {
  input: CreateMeetingAgendaTemplateInput;
};


export type MutationCreateMoneyMovementRequestTaskArgs = {
  input: CreateMoneyMovementRequestTaskInput;
};


export type MutationCreateNfsAuditExportArgs = {
  input: CreateNfsAuditExportInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationCreateNoteForContactArgs = {
  input: CreateNoteForContactInput;
};


export type MutationCreateNoteForDialpadCallArgs = {
  input: CreateNoteForDialpadCallInput;
};


export type MutationCreateNoteForEventArgs = {
  input: CreateNoteForEventInput;
};


export type MutationCreateOnboardingTaskArgs = {
  input: CreateOnboardingTaskInput;
};


export type MutationCreateOpenNewAccountTaskArgs = {
  input: CreateOpenNewAccountTaskInput;
};


export type MutationCreateOrUpdateCallLogArgs = {
  input: CreateOrUpdateCallLogInput;
};


export type MutationCreateOrUpdateServiceCalendarSettingsArgs = {
  input: CreateOrUpdateServiceCalendarSettingsInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationBrandingArgs = {
  input: CreateOrganizationBrandingRowInput;
};


export type MutationCreateOrganizationHouseholdCategoryArgs = {
  input: CreateOrganizationHouseholdCategoryInput;
};


export type MutationCreateOrganizationHouseholdTagArgs = {
  input: CreateOrganizationHouseholdTagInput;
};


export type MutationCreateOtherInvestmentTaskArgs = {
  input: CreateOtherInvestmentTaskInput;
};


export type MutationCreatePlaidLinkTokenArgs = {
  input: CreatePlaidLinkTokenInput;
};


export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};


export type MutationCreatePlanFinancialSnapshotArgs = {
  input: CreatePlanFinancialSnapshotInput;
};


export type MutationCreateProfessionalServiceArgs = {
  input: CreateProfessionalServiceInput;
};


export type MutationCreateProspectOpportunityArgs = {
  input: CreateProspectOpportunityInput;
};


export type MutationCreateProviderAccountArgs = {
  input: CreateProviderAccountInput;
};


export type MutationCreateReferralArgs = {
  input: CreateReferralInput;
};


export type MutationCreateRepaperEnvelopeArgs = {
  input: CreateRepaperEnvelopeInput;
};


export type MutationCreateReportScheduleArgs = {
  input: CreateReportScheduleInput;
};


export type MutationCreateRetirementPlanArgs = {
  input: CreateRetirementPlanInput;
};


export type MutationCreateRetirementPlanMilestoneArgs = {
  input: CreateRetirementPlanMilestoneInput;
};


export type MutationCreateRetirementPlanNoteArgs = {
  input: CreateRetirementPlanNoteInput;
};


export type MutationCreateRetirementPlanParticipantLogArgs = {
  input: CreateRetirementPlanParticipantLogInput;
};


export type MutationCreateRetirementPlanProjectArgs = {
  input: CreateRetirementPlanProjectInput;
};


export type MutationCreateRetirementPlanProjectFromTemplateArgs = {
  input: CreateRetirementPlanProjectFromTemplateInput;
};


export type MutationCreateRetirementPlanProjectRowArgs = {
  input: CreateRetirementPlanProjectRowInput;
};


export type MutationCreateRetirementPlanProjectTemplateArgs = {
  input: CreateRetirementPlanProjectTemplateInput;
};


export type MutationCreateRiskQuestionnaireArgs = {
  input: CreateRiskQuestionnaireInput;
};


export type MutationCreateServiceCalendarMeetingTypeTemplateArgs = {
  input: CreateServiceCalendarMeetingTypeTemplateInput;
};


export type MutationCreateServiceCalendarMeetingsArgs = {
  input: CreateServiceCalendarMeetingsInput;
};


export type MutationCreateServiceCalendarSettingTemplatesArgs = {
  input: CreateServiceCalendarSettingTemplateInput;
};


export type MutationCreateServiceCatalogItemArgs = {
  input: CreateServiceCatalogItemInput;
};


export type MutationCreateServiceCatalogItemGroupArgs = {
  input: CreateServiceCatalogItemGroupInput;
};


export type MutationCreateServiceCatalogItemHouseholdOverrideArgs = {
  input: CreateServiceCatalogItemHouseholdOverrideInput;
};


export type MutationCreateSimpleTaskArgs = {
  input: CreateSimpleTaskInput;
};


export type MutationCreateSubtaskArgs = {
  input: CreateSubtaskInput;
};


export type MutationCreateSurveyRoundArgs = {
  input: CreateSurveyRoundInput;
};


export type MutationCreateSwimRequestTaskArgs = {
  input: CreateSwimRequestTaskInput;
};


export type MutationCreateTaskActivityEventArgs = {
  input: CreateTaskActivityEventInput;
};


export type MutationCreateTaskCommentArgs = {
  input: CreateTaskCommentInput;
};


export type MutationCreateTaskDictationTokenArgs = {
  input: CreateTaskDictationTokenInput;
};


export type MutationCreateTaskFromEmailArgs = {
  input: CreateTaskFromEmailInput;
};


export type MutationCreateTaskFromNoteArgs = {
  input: CreateTaskFromNoteInput;
};


export type MutationCreateTaskWorkItemArgs = {
  input: CreateTaskWorkItemInput;
};


export type MutationCreateTaskWorkflowTemplateArgs = {
  input: CreateTaskWorkflowTemplateInput;
};


export type MutationCreateTaxEnrollmentArgs = {
  input: CreateTaxEnrollmentInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTradingTaskArgs = {
  input: CreateTradingTaskInput;
};


export type MutationCreateTransferOfAssetsTaskArgs = {
  input: CreateTransferOfAssetsTaskInput;
};


export type MutationCreateUserContactArgs = {
  input: CreateUserContactInput;
};


export type MutationCreateUserForHouseholdMemberArgs = {
  input: CreateUserForHouseholdMemberInput;
};


export type MutationDecideAgentProposalsArgs = {
  input: DecideProposalsInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteAddressArgs = {
  input: DeleteAddressInput;
};


export type MutationDeleteAssetArgs = {
  input: DeleteAssetInput;
};


export type MutationDeleteCallLogArgs = {
  input: DeleteCallLogInput;
};


export type MutationDeleteCenterOfInfluenceRepArgs = {
  input: DeleteCenterOfInfluenceRepInput;
};


export type MutationDeleteClientOpportunityArgs = {
  input: DeleteClientOpportunityInput;
};


export type MutationDeleteCoClientArgs = {
  input: DeleteCoClientInput;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationDeleteCommentAttachmentArgs = {
  input: DeleteCommentAttachmentInput;
};


export type MutationDeleteCompanyArgs = {
  input: DeleteCompanyInput;
};


export type MutationDeleteDialpadCallArgs = {
  input: DeleteDialpadCallInput;
};


export type MutationDeleteFamilyMemberArgs = {
  input: DeleteFamilyMemberInput;
};


export type MutationDeleteFeeScheduleArgs = {
  input: DeleteFeeScheduleInput;
};


export type MutationDeleteFinancialOfferingArgs = {
  input: DeleteFinancialOfferingInput;
};


export type MutationDeleteFinancialPlanArgs = {
  input: DeleteFinancialPlanInput;
};


export type MutationDeleteFinancialPlanReportFileArgs = {
  input: DeleteFinancialPlanReportFileInput;
};


export type MutationDeleteGoalArgs = {
  input: DeleteGoalInput;
};


export type MutationDeleteHouseholdArgs = {
  input: DeleteHouseholdInput;
};


export type MutationDeleteHouseholdReferralArgs = {
  input: DeleteHouseholdReferralInput;
};


export type MutationDeleteLiabilityArgs = {
  input: DeleteLiabilityInput;
};


export type MutationDeleteMeetingAgendaTemplateArgs = {
  input: DeleteMeetingAgendaTemplateInput;
};


export type MutationDeleteMeetingRecordingArgs = {
  input: DeleteMeetingRecordingInput;
};


export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput;
};


export type MutationDeleteOrganizationHouseholdCategoryArgs = {
  input: DeleteOrganizationHouseholdCategoryInput;
};


export type MutationDeletePlanFinancialSnapshotArgs = {
  input: DeletePlanFinancialSnapshotInput;
};


export type MutationDeleteProfessionalServiceArgs = {
  input: DeleteProfessionalServiceInput;
};


export type MutationDeleteProspectOpportunityArgs = {
  input: DeleteProspectOpportunityInput;
};


export type MutationDeleteProviderAccountArgs = {
  input: DeleteProviderAccountInput;
};


export type MutationDeleteReferralArgs = {
  input: DeleteReferralInput;
};


export type MutationDeleteReportScheduleArgs = {
  input: DeleteReportScheduleInput;
};


export type MutationDeleteReportTemplateArgs = {
  input: DeleteReportTemplateInput;
};


export type MutationDeleteRetirementPlanArgs = {
  input: DeleteRetirementPlanInput;
};


export type MutationDeleteRetirementPlanMilestoneArgs = {
  input: DeleteRetirementPlanMilestoneInput;
};


export type MutationDeleteRetirementPlanNoteArgs = {
  input: DeleteRetirementPlanNoteInput;
};


export type MutationDeleteRetirementPlanParticipantLogArgs = {
  input: DeleteRetirementPlanParticipantLogInput;
};


export type MutationDeleteRetirementPlanProjectArgs = {
  input: DeleteRetirementPlanProjectInput;
};


export type MutationDeleteRetirementPlanProjectRowArgs = {
  input: DeleteRetirementPlanProjectRowInput;
};


export type MutationDeleteRetirementPlanProjectTemplateArgs = {
  input: DeleteRetirementPlanProjectTemplateInput;
};


export type MutationDeleteServiceCalendarMeetingArgs = {
  input: DeleteServiceCalendarMeetingInput;
};


export type MutationDeleteServiceCalendarMeetingTypeTemplateArgs = {
  input: DeleteServiceCalendarMeetingTypeTemplateInput;
};


export type MutationDeleteServiceCalendarSettingTemplatesArgs = {
  input: DeleteServiceCalendarSettingTemplateInput;
};


export type MutationDeleteServiceCatalogItemHouseholdOverrideArgs = {
  input: DeleteServiceCatalogItemHouseholdOverrideInput;
};


export type MutationDeleteSubtaskArgs = {
  input: DeleteSubtaskInput;
};


export type MutationDeleteTaskArgs = {
  input: DeleteTaskInput;
};


export type MutationDeleteTaskCommentArgs = {
  input: DeleteTaskCommentInput;
};


export type MutationDeleteTaskWorkflowTemplateArgs = {
  input: DeleteTaskWorkflowTemplateInput;
};


export type MutationDeleteTaxEnrollmentArgs = {
  input: DeleteTaxEnrollmentInput;
};


export type MutationDeleteUserContactArgs = {
  input: DeleteUserContactInput;
};


export type MutationDiscardServiceCatalogItemGroupChangesArgs = {
  input: DiscardServiceCatalogItemGroupChangesInput;
};


export type MutationDismissAllInboxAlertsArgs = {
  input: DismissAllInboxAlertsInput;
};


export type MutationDismissAnnouncementArgs = {
  input: DismissAnnouncementInput;
};


export type MutationDismissOnboardingHouseholdArgs = {
  input: DismissOnboardingHouseholdInput;
};


export type MutationDownloadBoxFileUrlArgs = {
  input: DownloadBoxFileUrlInput;
};


export type MutationDuplicateServiceCatalogItemGroupArgs = {
  input: DuplicateServiceCatalogItemGroupInput;
};


export type MutationEciSendMsaNoticeArgs = {
  input: SendMsaNoticeInput;
};


export type MutationEditCenterOfInfluenceRepArgs = {
  input: EditCenterOfInfluenceRepInput;
};


export type MutationEditCompanyArgs = {
  input: EditCompanyInput;
};


export type MutationEndSurveyRoundArgs = {
  input: EndSurveyRoundInput;
};


export type MutationEnrollAdvisorVoiceArgs = {
  input: EnrollAdvisorVoiceInput;
};


export type MutationEnrollHouseholdsInServiceCatalogItemGroupArgs = {
  input: EnrollHouseholdsInServiceCatalogItemGroupInput;
};


export type MutationExcludeAdvisorOnboardingStagedHouseholdsFromBatchArgs = {
  input: ExcludeStagedHouseholdsFromBatchInput;
};


export type MutationExpirePublishedReportArgs = {
  input: ExpirePublishedReportInput;
};


export type MutationExtractBoxClientUploadStatementsArgs = {
  input: ExtractBoxClientUploadStatementsInput;
};


export type MutationFetchPlaidAccountsArgs = {
  input: FetchPlaidAccountsInput;
};


export type MutationFinalizeMeetingRecordingUploadArgs = {
  input: FinalizeMeetingRecordingUploadInput;
};


export type MutationGenerateAllQuarterlyReportsArgs = {
  input: GenerateAllQuarterlyReportsInput;
};


export type MutationGenerateCoClientTaskArgs = {
  input: GenerateCoClientTaskInput;
};


export type MutationGenerateDirectoryProfileDraftArgs = {
  input: GenerateDirectoryProfileDraftInput;
};


export type MutationGenerateInvestmentProposalArgs = {
  input: GenerateInvestmentProposalInput;
};


export type MutationGenerateOrionReportArgs = {
  input: GenerateOrionReportInput;
};


export type MutationGeneratePortfolioInsightsArgs = {
  input: GeneratePortfolioInsightsInput;
};


export type MutationGenerateSalesforceAccessTokenArgs = {
  input: GenerateSalesforceAccessTokenInput;
};


export type MutationGenerateServiceEmailDraftArgs = {
  input: GenerateServiceEmailDraftInput;
};


export type MutationGetOrCreateAprilTokenArgs = {
  input: GetOrCreateAprilTokenInput;
};


export type MutationGetOrCreateHouseholdMemberAprilFilingTokenArgs = {
  input: GetOrCreateHouseholdMemberAprilFilingTokenInput;
};


export type MutationHouseholdWorkflowCreationBackfillerArgs = {
  input: HouseholdWorkflowCreationBackfillerInput;
};


export type MutationImpersonateUserArgs = {
  input: ImpersonateUserInput;
};


export type MutationLaunchTaskWorkflowTemplateArgs = {
  input: LaunchTaskWorkflowTemplateInput;
};


export type MutationLinkInteractionToServiceOccurrenceArgs = {
  input: LinkInteractionToServiceOccurrenceInput;
};


export type MutationLinkProfessionalContactToHouseholdArgs = {
  input: LinkProfessionalContactToHouseholdInput;
};


export type MutationLinkTaskArgs = {
  input: LinkTaskInput;
};


export type MutationLinkTimelineItemToContactArgs = {
  input: LinkTimelineItemToContactInput;
};


export type MutationLinkTranscriptArgs = {
  input: LinkTranscriptInput;
};


export type MutationLogTaskAttachmentArgs = {
  input: LogTaskAttachmentInput;
};


export type MutationMarkAdvisorRequirementsDoneArgs = {
  input: MarkAdvisorRequirementsDoneInput;
};


export type MutationMarkCommentsSeenArgs = {
  input: MarkCommentsSeenInput;
};


export type MutationMarkOnboardingHouseholdCompleteArgs = {
  input: MarkHouseholdCompleteInput;
};


export type MutationMarkServiceCatalogItemHouseholdDoneArgs = {
  input: MarkServiceCatalogItemHouseholdDoneInput;
};


export type MutationMarkServiceCatalogItemHouseholdSkippedArgs = {
  input: MarkServiceCatalogItemHouseholdSkippedInput;
};


export type MutationMarkTaskCommentsSeenArgs = {
  input: MarkTaskCommentsSeenInput;
};


export type MutationMergeOrganizationHouseholdTagsArgs = {
  input: MergeOrganizationHouseholdTagsInput;
};


export type MutationMoneykitCreateLinkSessionArgs = {
  input: MoneykitCreateLinkSessionInput;
};


export type MutationMoneykitExchangeLinkTokenArgs = {
  input: MoneykitExchangeLinkTokenInput;
};


export type MutationMoneykitFetchBankDetailsPrefillArgs = {
  input: MoneykitFetchBankDetailsPrefillInput;
};


export type MutationMoneykitRefreshLinkArgs = {
  input: MoneykitRefreshLinkInput;
};


export type MutationMoveClientToAdvisorArgs = {
  input: MoveClientToAdvisorInput;
};


export type MutationOptOutOfChimneyPropertyLinkArgs = {
  input: OptOutOfChimneyPropertyLinkInput;
};


export type MutationPreviewAdvisorOnboardingCorrectionArgs = {
  input: PreviewCorrectionInput;
};


export type MutationProcessOnboardedClientArgs = {
  input: ProcessOnboardedClientInput;
};


export type MutationPromoteAdvisorOnboardingEnrollmentArgs = {
  input: PromoteEnrollmentInput;
};


export type MutationPromoteToSavvyServiceTemplateArgs = {
  input: PromoteToSavvyServiceTemplateInput;
};


export type MutationPromoteToSavvyTemplateArgs = {
  input: PromoteToSavvyTemplateInput;
};


export type MutationProvisionConquestUserArgs = {
  input: ProvisionConquestUserInput;
};


export type MutationPublishDraftTaskArgs = {
  input: PublishDraftTaskInput;
};


export type MutationPublishFinancialPlanArgs = {
  input: PublishFinancialPlanInput;
};


export type MutationPublishMeetingPrepOperationArgs = {
  input: PublishMeetingPrepOperationInput;
};


export type MutationPublishReportArgs = {
  input: PublishReportInput;
};


export type MutationPublishServiceCatalogItemGroupArgs = {
  input: PublishServiceCatalogItemGroupInput;
};


export type MutationReassignHouseholdAdvisorArgs = {
  input: ReassignHouseholdAdvisorInput;
};


export type MutationReconcileClientProfileStageArgs = {
  input: ReconcileClientProfileStageInput;
};


export type MutationRefreshProviderAccountArgs = {
  input: RefreshProviderAccountInput;
};


export type MutationRegenerateAccountConfirmationDocumentsArgs = {
  input: RegenerateAccountConfirmationDocumentsInput;
};


export type MutationRegenerateAdvisoryAgreementDraftArgs = {
  input: RegenerateAgreementDraftInput;
};


export type MutationRegenerateMeetingSummaryArgs = {
  input: RegenerateMeetingSummaryInput;
};


export type MutationRegenerateOnboardingDocusignEnvelopeArgs = {
  input: RegenerateOnboardingDocusignEnvelopeInput;
};


export type MutationRegenerateStaleServiceCatalogTasksArgs = {
  input: RegenerateStaleServiceCatalogTasksInput;
};


export type MutationRegisterPushTokenArgs = {
  input: RegisterPushTokenInput;
};


export type MutationReissueEnvelopeWithCurrentPhoneArgs = {
  input: ReissueEnvelopeWithCurrentPhoneInput;
};


export type MutationRejectScheduledReportExecutionArgs = {
  input: RejectScheduledReportExecutionInput;
};


export type MutationReleaseAdvisorOnboardingToSendArgs = {
  input: ReleaseOnboardingToSendInput;
};


export type MutationRelinkSignedEnvelopeArgs = {
  input: RelinkSignedEnvelopeInput;
};


export type MutationRemoveAdvisorFromAdvisorGroupArgs = {
  input: RemoveAdvisorFromAdvisorGroupInput;
};


export type MutationRemoveAdvisorOnboardingStagedCoClientArgs = {
  input: RemoveStagedCoClientInput;
};


export type MutationRemoveAdvisorOnboardingStagedHouseholdArgs = {
  input: RemoveStagedHouseholdInput;
};


export type MutationRemoveAdvisorsFromOrganizationArgs = {
  input: RemoveAdvisorsFromOrganizationInput;
};


export type MutationRemoveHouseholdMemberArgs = {
  input: RemoveHouseholdMemberInput;
};


export type MutationRemoveNotificationAlertMuteArgs = {
  input: RemoveNotificationAlertMuteInput;
};


export type MutationRemoveOnboardingHouseholdArgs = {
  input: RemoveOnboardingHouseholdInput;
};


export type MutationRemovePlanInputArgs = {
  input: RemovePlanInputInput;
};


export type MutationRemoveProfessionalDetailsArgs = {
  input: RemoveProfessionalDetailsInput;
};


export type MutationRemoveSecondaryPortfolioArgs = {
  input: RemoveSecondaryPortfolioInput;
};


export type MutationRemoveServiceCatalogItemFromGroupArgs = {
  input: RemoveServiceCatalogItemFromGroupInput;
};


export type MutationRemoveTaskRecurrenceArgs = {
  input: RemoveTaskRecurrenceInput;
};


export type MutationRenewInviteArgs = {
  input: RenewInviteInput;
};


export type MutationReorderServiceCatalogItemHouseholdsArgs = {
  input: ReorderServiceCatalogItemHouseholdsInput;
};


export type MutationReorderSubtaskArgs = {
  input: ReorderSubtaskInput;
};


export type MutationRequestMeetingRecordingPartUploadArgs = {
  input: RequestMeetingRecordingPartUploadInput;
};


export type MutationRequestMeetingRecordingUploadArgs = {
  input: RequestMeetingRecordingUploadInput;
};


export type MutationRequestPastTranscriptsFromAprilArgs = {
  input: RequestPastTranscriptsFromAprilInput;
};


export type MutationRequestReadOnlyAdminAccountArgs = {
  input: RequestReadOnlyAdminAccountInput;
};


export type MutationRequestRepaperPdfUploadUrlsArgs = {
  input: RequestRepaperPdfUploadUrlsInput;
};


export type MutationRescheduleServiceOccurrenceArgs = {
  input: RescheduleServiceOccurrenceInput;
};


export type MutationReseedDemoEnvironmentArgs = {
  input: ReseedDemoEnvironmentInput;
};


export type MutationResendAdvisorOnboardingArgs = {
  input: ResendOnboardingInviteInput;
};


export type MutationResendDocusignEnvelopeArgs = {
  input: ResendDocusignEnvelopeInput;
};


export type MutationResendEciOnboardingLinkArgs = {
  input: ResendEciOnboardingLinkInput;
};


export type MutationResendEmailArgs = {
  input: ResendEmailInput;
};


export type MutationResendOtpArgs = {
  input: ResendOtpInput;
};


export type MutationResendServiceCatalogReminderArgs = {
  input: ResendServiceCatalogReminderInput;
};


export type MutationResendServiceOccurrenceReminderArgs = {
  input: ResendServiceOccurrenceReminderInput;
};


export type MutationResetClientIntakeDataArgs = {
  input: ResetClientIntakeDataInput;
};


export type MutationResetDemoHouseholdArgs = {
  input: ResetDemoHouseholdInput;
};


export type MutationResetNotificationRoutingArgs = {
  input: ResetNotificationRoutingInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetServiceCalendarArgs = {
  input: ResetServiceCalendarInput;
};


export type MutationResetServiceOccurrenceEmailArgs = {
  input: ResetServiceOccurrenceEmailInput;
};


export type MutationResetTaskNotificationRoutingArgs = {
  input: ResetTaskNotificationRoutingInput;
};


export type MutationResolveContributionAlertArgs = {
  input: ResolveContributionAlertInput;
};


export type MutationRespondToSurveyArgs = {
  input: RespondToSurveyInput;
};


export type MutationResubmitEciRemediationArgs = {
  input: ResubmitEciRemediationInput;
};


export type MutationRetryPlanImportArgs = {
  input: RetryPlanImportInput;
};


export type MutationRunAdminServiceObjectArgs = {
  input: RunAdminServiceObjectInput;
};


export type MutationRunInternalAdminActionArgs = {
  input: RunInternalAdminActionInput;
};


export type MutationSaveEciAccountPurposeAndSourceOfFundsArgs = {
  input: SaveEciAccountPurposeAndSourceOfFundsInput;
};


export type MutationSaveEciBeneficiariesArgs = {
  input: SaveEciBeneficiariesInput;
};


export type MutationSaveEciDecedentDetailsArgs = {
  input: SaveEciDecedentDetailsInput;
};


export type MutationSaveEciEmployerDetailsArgs = {
  input: SaveEciEmployerDetailsInput;
};


export type MutationSaveEciJointOwnerDetailsArgs = {
  input: SaveEciJointOwnerDetailsInput;
};


export type MutationSaveEciManualDeliveringCustodianArgs = {
  input: SaveEciManualDeliveringCustodianInput;
};


export type MutationSaveEciTrustDetailsArgs = {
  input: SaveEciTrustDetailsInput;
};


export type MutationSaveEciTrustedContactsArgs = {
  input: SaveEciTrustedContactsInput;
};


export type MutationSaveEciTrustedContactsForHolderArgs = {
  input: SaveEciTrustedContactsForHolderInput;
};


export type MutationSaveHouseholdKeepInMindVoteArgs = {
  input: SaveHouseholdKeepInMindVoteInput;
};


export type MutationSaveMeetingSummaryVoteArgs = {
  input: SaveMeetingSummaryVoteInput;
};


export type MutationSaveReportTemplateArgs = {
  input: SaveReportTemplateInput;
};


export type MutationSaveRetirementPlanProjectAsTemplateArgs = {
  input: SaveRetirementPlanProjectAsTemplateInput;
};


export type MutationSaveServiceCatalogItemGroupArgs = {
  input: SaveServiceCatalogItemGroupInput;
};


export type MutationScheduleNativeReportArgs = {
  input: ScheduleNativeReportInput;
};


export type MutationSelectEciDeliveringCustodianArgs = {
  input: SelectEciDeliveringCustodianInput;
};


export type MutationSendAdvisorOnboardingArgs = {
  input: SendOnboardingInput;
};


export type MutationSendAdvisorOnboardingInviteToOpsArgs = {
  input: SendOnboardingInviteToOpsInput;
};


export type MutationSendClientBookingEmailArgs = {
  input: SendClientBookingEmailInput;
};


export type MutationSendClientWelcomeEmailArgs = {
  input: SendClientWelcomeEmailInput;
};


export type MutationSendCreatePasswordEmailArgs = {
  input: SendCreatePasswordEmailInput;
};


export type MutationSendEmailMessageArgs = {
  input: SendEmailMessageInput;
};


export type MutationSendFileShareEmailArgs = {
  input: SendFileShareEmailInput;
};


export type MutationSendOnboardingToClientArgs = {
  input: SendOnboardingToClientInput;
};


export type MutationSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};


export type MutationSendRepaperEnvelopeArgs = {
  input: SendRepaperEnvelopeInput;
};


export type MutationSendSignOnboardingDocumentsReminderArgs = {
  input: SendSignOnboardingDocumentsReminderInput;
};


export type MutationSendTaskEmailArgs = {
  input: SendTaskEmailInput;
};


export type MutationSetAccountConnectionReminderPreferenceArgs = {
  input: SetAccountConnectionReminderPreferenceInput;
};


export type MutationSetActivityEntryPinnedArgs = {
  input: SetActivityEntryPinnedInput;
};


export type MutationSetAdvisorTierLevelArgs = {
  input: SetAdvisorTierLevelInput;
};


export type MutationSetAdvisorTierLevelByIdentityArgs = {
  input: SetAdvisorTierLevelByIdentityInput;
};


export type MutationSetClientIncomeSourcesArgs = {
  input: SetClientIncomeSourcesInput;
};


export type MutationSetContactAccountRelationArgs = {
  input: SetContactAccountRelationInput;
};


export type MutationSetContactHouseholdConnectionArgs = {
  input: SetContactHouseholdConnectionInput;
};


export type MutationSetGovernmentIdArgs = {
  input: SetGovernmentIdInput;
};


export type MutationSetHouseholdBenchmarkArgs = {
  input: SetHouseholdBenchmarkInput;
};


export type MutationSetHouseholdScheduleOffsetArgs = {
  input: SetHouseholdScheduleOffsetInput;
};


export type MutationSetServiceCatalogItemHouseholdNextOccurrenceArgs = {
  input: SetServiceCatalogItemHouseholdNextOccurrenceInput;
};


export type MutationSetServiceOccurrenceEmailArgs = {
  input: SetServiceOccurrenceEmailInput;
};


export type MutationSetSwimLoanLengthOptionsArgs = {
  input: SetSwimLoanLengthOptionsInput;
};


export type MutationSetSwimStrategiesArgs = {
  input: SetSwimStrategiesInput;
};


export type MutationSetTaskRecurrenceArgs = {
  input: SetTaskRecurrenceInput;
};


export type MutationSetUpAdvisorOrganizationArgs = {
  input: SetUpAdvisorOrganizationInput;
};


export type MutationSetupTaskRemindersArgs = {
  input: SetupTaskRemindersInput;
};


export type MutationShareHouseholdWithAdvisorGroupArgs = {
  input: ShareHouseholdWithAdvisorGroupInput;
};


export type MutationSharePublishedReportArgs = {
  input: SharePublishedReportInput;
};


export type MutationShareRetirementPlanWithOrganizationArgs = {
  input: ShareRetirementPlanWithOrganizationInput;
};


export type MutationSignTaxAddendumArgs = {
  input: SignTaxAddendumInput;
};


export type MutationSignUpForSavvyArgs = {
  input: SignUpForSavvyInput;
};


export type MutationSkipServiceOccurrenceArgs = {
  input: SkipServiceOccurrenceInput;
};


export type MutationSplitHouseholdArgs = {
  input: SplitHouseholdInput;
};


export type MutationStartBenchmarkDataGenerationArgs = {
  input: StartBenchmarkDataGenerationInput;
};


export type MutationStartEciClientOnboardingArgs = {
  input: StartEciClientOnboardingInput;
};


export type MutationStartPlanImportArgs = {
  input: StartPlanImportInput;
};


export type MutationStartSchwabApiImportArgs = {
  input: StartSchwabApiImportInput;
};


export type MutationStopImpersonatingUserArgs = {
  input: StopImpersonatingUserInput;
};


export type MutationStopSharingRetirementPlanOrganizationsArgs = {
  input: StopSharingRetirementPlanOrganizationsInput;
};


export type MutationSubmitEciAccountOnboardingArgs = {
  input: SubmitEciAccountOnboardingInput;
};


export type MutationSubmitEciClientOnboardingArgs = {
  input: SubmitEciClientOnboardingInput;
};


export type MutationSubmitNewEciAccountsArgs = {
  input: SubmitNewEciAccountsInput;
};


export type MutationSwitchActiveHouseholdArgs = {
  input: SwitchActiveHouseholdInput;
};


export type MutationSyncEciAccountOnboardingRequestSelectionArgs = {
  input: SyncEciAccountOnboardingRequestSelectionInput;
};


export type MutationSyncOrionDataArgs = {
  input: SyncOrionDataInput;
};


export type MutationSyncOrionDataByPublicIdArgs = {
  input: SyncOrionDataByPublicIdInput;
};


export type MutationSyncStandingInstructionSelectionsArgs = {
  input: SyncStandingInstructionSelectionsInput;
};


export type MutationToggleCommentReactionArgs = {
  input: ToggleCommentReactionInput;
};


export type MutationTrackEventArgs = {
  input: TrackEventInput;
};


export type MutationUnarchiveHouseholdArgs = {
  input: UnarchiveHouseholdInput;
};


export type MutationUnarchiveServiceCatalogItemGroupArgs = {
  input: UnarchiveServiceCatalogItemGroupInput;
};


export type MutationUnassignServiceCatalogItemFromHouseholdArgs = {
  input: UnassignServiceCatalogItemFromHouseholdInput;
};


export type MutationUnenrollHouseholdsFromServiceCatalogItemGroupArgs = {
  input: UnenrollHouseholdsFromServiceCatalogItemGroupInput;
};


export type MutationUnlinkHouseholdCoClientArgs = {
  input: UnlinkHouseholdCoClientInput;
};


export type MutationUnlinkInteractionFromServiceOccurrenceArgs = {
  input: UnlinkInteractionFromServiceOccurrenceInput;
};


export type MutationUnlinkOrionHouseholdArgs = {
  input: UnlinkOrionHouseholdInput;
};


export type MutationUnlinkTaskArgs = {
  input: UnlinkTaskInput;
};


export type MutationUnlinkTimelineItemFromContactArgs = {
  input: UnlinkTimelineItemFromContactInput;
};


export type MutationUnregisterPushTokenArgs = {
  input: UnregisterPushTokenInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateAccountSleeveArgs = {
  input: UpdateAccountSleeveInput;
};


export type MutationUpdateAccountTransferDatumArgs = {
  input: UpdateAccountTransferDatumInput;
};


export type MutationUpdateActionCenterVisitedArgs = {
  input: UpdateActionCenterVisitedInput;
};


export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateAdvisorAiDisclosureAcceptanceArgs = {
  input: UpdateAdvisorAiDisclosureAcceptanceInput;
};


export type MutationUpdateAdvisorAlertSettingsArgs = {
  input: UpdateAdvisorAlertSettingsInput;
};


export type MutationUpdateAdvisorCaptiveStatusArgs = {
  input: UpdateAdvisorCaptiveStatusInput;
};


export type MutationUpdateAdvisorCsaArgs = {
  input: UpdateAdvisorCsaInput;
};


export type MutationUpdateAdvisorDirectoryProfileArgs = {
  input: UpdateAdvisorDirectoryProfileInput;
};


export type MutationUpdateAdvisorGroupSettingsArgs = {
  input: UpdateAdvisorGroupSettingsInput;
};


export type MutationUpdateAdvisorOnboardingCohortArgs = {
  input: UpdateAdvisorOnboardingCohortInput;
};


export type MutationUpdateAdvisorOnboardingEnrollmentArgs = {
  input: UpdateEnrollmentInput;
};


export type MutationUpdateAdvisorOnboardingStagedAccountDestinationArgs = {
  input: UpdateStagedAccountDestinationInput;
};


export type MutationUpdateAdvisorOnboardingStagedClientArgs = {
  input: UpdateStagedClientInput;
};


export type MutationUpdateAdvisorOnboardingStagedHouseholdArgs = {
  input: UpdateStagedHouseholdInput;
};


export type MutationUpdateAdvisorProfileArgs = {
  input: UpdateAdvisorProfileInput;
};


export type MutationUpdateAdvisorSettingsArgs = {
  input: UpdateAdvisorSettingsInput;
};


export type MutationUpdateAlertArgs = {
  input: UpdateAlertInput;
};


export type MutationUpdateAssetArgs = {
  input: UpdateAssetInput;
};


export type MutationUpdateClientDetailsArgs = {
  input: UpdateClientDetailsInput;
};


export type MutationUpdateClientEmploymentDetailsArgs = {
  input: UpdateClientEmploymentDetailsInput;
};


export type MutationUpdateClientIntakeDataArgs = {
  input: UpdateClientIntakeDataInput;
};


export type MutationUpdateClientPortalMessageArgs = {
  input: UpdateClientPortalMessageInput;
};


export type MutationUpdateClientProfileArgs = {
  input: UpdateClientProfileInput;
};


export type MutationUpdateClientsArgs = {
  input: UpdateClientsInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateCommentAttachmentSyncArgs = {
  input: UpdateCommentAttachmentSyncInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateDialpadCallNotesArgs = {
  input: UpdateDialpadCallNotesInput;
};


export type MutationUpdateDialpadEventContentArgs = {
  input: UpdateDialpadEventContentInput;
};


export type MutationUpdateEciCitizenshipTaxStatusArgs = {
  input: UpdateEciCitizenshipTaxStatusInput;
};


export type MutationUpdateEciCurrentStepArgs = {
  input: UpdateEciCurrentStepInput;
};


export type MutationUpdateEciFinancialProfileArgs = {
  input: UpdateEciFinancialProfileInput;
};


export type MutationUpdateEciPersonalInformationArgs = {
  input: UpdateEciPersonalInformationInput;
};


export type MutationUpdateEciRegulatoryDisclosureArgs = {
  input: UpdateEciRegulatoryDisclosureInput;
};


export type MutationUpdateFamilyMemberArgs = {
  input: UpdateFamilyMemberInput;
};


export type MutationUpdateFeeScheduleArgs = {
  input: UpdateFeeScheduleInput;
};


export type MutationUpdateFinancialOfferingArgs = {
  input: UpdateFinancialOfferingInput;
};


export type MutationUpdateGoalArgs = {
  input: UpdateGoalInput;
};


export type MutationUpdateHouseholdArgs = {
  input: UpdateHouseholdInput;
};


export type MutationUpdateHouseholdAccessArgs = {
  input: UpdateHouseholdAccessInput;
};


export type MutationUpdateHouseholdMemberArgs = {
  input: UpdateHouseholdMemberInput;
};


export type MutationUpdateHouseholdReferralArgs = {
  input: UpdateHouseholdReferralInput;
};


export type MutationUpdateHouseholdTagsArgs = {
  input: UpdateHouseholdTagsInput;
};


export type MutationUpdateLiabilityArgs = {
  input: UpdateLiabilityInput;
};


export type MutationUpdateMeetingAgendaTemplateArgs = {
  input: UpdateMeetingAgendaTemplateInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateNotificationRouteArgs = {
  input: UpdateNotificationRouteInput;
};


export type MutationUpdateOnboardingPersonalizationArgs = {
  input: UpdateOnboardingPersonalizationInput;
};


export type MutationUpdateOnboardingTaskDataArgs = {
  input: UpdateOnboardingTaskDataInput;
};


export type MutationUpdateOpportunityArgs = {
  input: UpdateOpportunityInput;
};


export type MutationUpdateOrganizationBrandingArgs = {
  input: UpdateOrganizationBrandingInput;
};


export type MutationUpdateOrganizationHouseholdCategoryArgs = {
  input: UpdateOrganizationHouseholdCategoryInput;
};


export type MutationUpdateOrganizationHouseholdTagArgs = {
  input: UpdateOrganizationHouseholdTagInput;
};


export type MutationUpdateOrganizationHouseholdTagHouseholdsArgs = {
  input: UpdateOrganizationHouseholdTagHouseholdsInput;
};


export type MutationUpdateOrganizationSettingsArgs = {
  input: UpdateOrganizationSettingsInput;
};


export type MutationUpdateOrganizationTaskInstructionsArgs = {
  input: UpdateOrganizationTaskInstructionsInput;
};


export type MutationUpdateOrionReportEnrollmentsArgs = {
  input: UpdateOrionReportEnrollmentsInput;
};


export type MutationUpdatePlanArgs = {
  input: UpdatePlanInput;
};


export type MutationUpdatePlanFinancialSnapshotArgs = {
  input: UpdatePlanFinancialSnapshotInput;
};


export type MutationUpdatePortfolioArgs = {
  input: UpdatePortfolioInput;
};


export type MutationUpdatePortfolioStrategyArgs = {
  input: UpdatePortfolioStrategyInput;
};


export type MutationUpdateProfessionalServiceArgs = {
  input: UpdateProfessionalServiceInput;
};


export type MutationUpdateProspectOpportunityArgs = {
  input: UpdateProspectOpportunityInput;
};


export type MutationUpdateProviderAccountArgs = {
  input: UpdateProviderAccountInput;
};


export type MutationUpdateReferralArgs = {
  input: UpdateReferralInput;
};


export type MutationUpdateReportScheduleArgs = {
  input: UpdateReportScheduleInput;
};


export type MutationUpdateReportTemplateArgs = {
  input: UpdateReportTemplateInput;
};


export type MutationUpdateRetirementPlanArgs = {
  input: UpdateRetirementPlanInput;
};


export type MutationUpdateRetirementPlanDesignArgs = {
  input: UpdateRetirementPlanDesignInput;
};


export type MutationUpdateRetirementPlanMilestoneArgs = {
  input: UpdateRetirementPlanMilestoneInput;
};


export type MutationUpdateRetirementPlanNoteArgs = {
  input: UpdateRetirementPlanNoteInput;
};


export type MutationUpdateRetirementPlanParticipantLogArgs = {
  input: UpdateRetirementPlanParticipantLogInput;
};


export type MutationUpdateRetirementPlanProjectArgs = {
  input: UpdateRetirementPlanProjectInput;
};


export type MutationUpdateRetirementPlanProjectRowArgs = {
  input: UpdateRetirementPlanProjectRowInput;
};


export type MutationUpdateRetirementPlanProjectTemplateArgs = {
  input: UpdateRetirementPlanProjectTemplateInput;
};


export type MutationUpdateRetirementPlanProjectTemplateFromProjectArgs = {
  input: UpdateRetirementPlanProjectTemplateFromProjectInput;
};


export type MutationUpdateRmdArgs = {
  input: UpdateRmdInput;
};


export type MutationUpdateServiceCalendarItemArgs = {
  input: UpdateServiceCalendarItemInput;
};


export type MutationUpdateServiceCalendarMeetingArgs = {
  input: UpdateServiceCalendarMeetingInput;
};


export type MutationUpdateServiceCalendarSettingTemplatesArgs = {
  input: UpdateServiceCalendarSettingTemplatesInput;
};


export type MutationUpdateServiceCalendarSettingsArgs = {
  input: UpdateServiceCalendarSettingsInput;
};


export type MutationUpdateServiceCatalogItemArgs = {
  input: UpdateServiceCatalogItemInput;
};


export type MutationUpdateServiceCatalogItemGroupArgs = {
  input: UpdateServiceCatalogItemGroupInput;
};


export type MutationUpdateServiceCatalogItemHouseholdOverrideArgs = {
  input: UpdateServiceCatalogItemHouseholdOverrideInput;
};


export type MutationUpdateSimpleTaskArgs = {
  input: UpdateSimpleTaskInput;
};


export type MutationUpdateSubtaskArgs = {
  input: UpdateSubtaskInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTaskCommentArgs = {
  input: UpdateTaskCommentInput;
};


export type MutationUpdateTaskNotificationRouteArgs = {
  input: UpdateTaskNotificationRouteInput;
};


export type MutationUpdateTaskSuggestionArgs = {
  input: UpdateTaskSuggestionInput;
};


export type MutationUpdateTaskWorkItemArgs = {
  input: UpdateTaskWorkItemInput;
};


export type MutationUpdateTaskWorkflowTemplateArgs = {
  input: UpdateTaskWorkflowTemplateInput;
};


export type MutationUpdateTaxEnrollmentArgs = {
  input: UpdateTaxEnrollmentInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserContactArgs = {
  input: UpdateUserContactInput;
};


export type MutationUpdateUserDataInAprilFilingArgs = {
  input: UpdateUserDataInAprilFilingInput;
};


export type MutationUpdateUserSecurityAttributeArgs = {
  input: UpdateUserSecurityAttributeInput;
};


export type MutationUploadEciFormTemplateArgs = {
  input: UploadEciFormTemplateInput;
};


export type MutationUploadFileToBoxArgs = {
  input: UploadFileToBoxInput;
};


export type MutationUploadLinkedBankAccountImportArgs = {
  input: UploadLinkedBankAccountImportInput;
};


export type MutationUpsertUserSavedViewsArgs = {
  input: UpsertUserSavedViewsInput;
};


export type MutationValidateInvestmentProposalTickersArgs = {
  input: ValidateInvestmentProposalTickersInput;
};


export type MutationVerifyEciOnboardingIdentityArgs = {
  input: VerifyEciOnboardingIdentityInput;
};


export type MutationVoiceProfileCommitArgs = {
  input: VoiceProfileCommitInput;
};


export type MutationVoiceProfileRemoveExampleArgs = {
  input: VoiceProfileRemoveExampleInput;
};


export type MutationVoiceProfileRerunCaptureArgs = {
  input: VoiceProfileRerunCaptureInput;
};


export type MutationVoiceProfileSetSampleArgs = {
  input: VoiceProfileSetSampleInput;
};


export type MutationVoidDocusignEnvelopeArgs = {
  input: VoidDocusignEnvelopeInput;
};


export type MutationWealthboxImportPreviewArgs = {
  input: WealthboxImportPreviewMutationInput;
};

/** Error type for mutations */
export type MutationError = {
  readonly __typename?: 'MutationError';
  /** The field where the error occurred */
  readonly field?: Maybe<Scalars['String']['output']>;
  /** Error message */
  readonly message: Scalars['String']['output'];
};

/** An async native PDF report record — tracks scheduling → generation → completion. */
export type NativeReport = {
  readonly __typename?: 'NativeReport';
  /** When the report completed or failed. */
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the report was scheduled. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * JSON-serialised report data. Non-null only when status = completed AND the
   * Redis TTL (1 h) has not expired. A null value with status = completed means
   * the data expired — re-schedule the report. Pass to the Next.js download
   * endpoint to render the PDF.
   */
  readonly dataJson?: Maybe<Scalars['String']['output']>;
  /** Error detail when status is failed. */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** The record ID. */
  readonly id: Scalars['ID']['output'];
  /** Current status: pending | processing | completed | failed. */
  readonly status: Scalars['String']['output'];
};

/** A user's entire financial portfolio. */
export type NetWorthPortfolioData = {
  readonly __typename?: 'NetWorthPortfolioData';
  /** An array of accounts, contains liability accounts from Plaid */
  readonly accounts: ReadonlyArray<Account>;
  /** An array of assets */
  readonly assets: ReadonlyArray<Asset>;
  /** The client profile of the who owns this portfolio */
  readonly clientProfile?: Maybe<Client>;
  /** Id of either the account or the portfolio that this object is representing */
  readonly id?: Maybe<Scalars['ID']['output']>;
  /** An array of liabilities */
  readonly liabilities: ReadonlyArray<Liability>;
  /** A user's total net worth. */
  readonly netWorth: Value;
  /**
   * Portfolio items groups that make up the net worth.
   * @deprecated Use the accounts, liabilities, and assets fields instead
   */
  readonly portfolioItemGroups: ReadonlyArray<PortfolioItemGroup>;
  /** A user's total net worth that is managed by Savvy */
  readonly savvyAccounts: Value;
};

/** New Financial Planning Client variant: set up flat-fee billing for a new planning client */
export type NewFinancialPlanningClientInput = {
  /** Account number to deduct from, free text (required when payment_method is deduct) */
  readonly deductAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Effective date; omitted when the timing is future */
  readonly effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Whether billing starts immediately or on a future date described in the notes */
  readonly effectiveDateTiming?: InputMaybe<ClientBillingDateTimingName>;
  /** Annual fee amount */
  readonly feeAmount: Scalars['Float']['input'];
  /** Notes for Ops */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** Payment cadence — monthly, quarterly, semi_annual, annual, or one_time */
  readonly paymentCadence: ClientBillingPaymentCadenceName;
  /** Payment method — advicepay or deduct */
  readonly paymentMethod: ClientBillingPaymentMethodName;
};

export type NewsArticle = {
  readonly __typename?: 'NewsArticle';
  readonly publishedDate: Scalars['ISO8601DateTime']['output'];
  readonly sentiment: NewsSentimentName;
  readonly sourceName: Scalars['String']['output'];
  readonly text: Scalars['String']['output'];
  readonly tickers: ReadonlyArray<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

export const NewsSentimentName = {
  Negative: 'Negative',
  Neutral: 'Neutral',
  Positive: 'Positive'
} as const;

export type NewsSentimentName = typeof NewsSentimentName[keyof typeof NewsSentimentName];
/** "request" or "response" */
export const NfsAuditDirection = {
  Request: 'request',
  Response: 'response'
} as const;

export type NfsAuditDirection = typeof NfsAuditDirection[keyof typeof NfsAuditDirection];
/** A single Fidelity NFS request/response leg captured for compliance retention. */
export type NfsAuditEntry = {
  readonly __typename?: 'NfsAuditEntry';
  /** UTC timestamp of confirmed S3 write */
  readonly archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Redacted body. Served from Postgres until archival; after archival the
   * Postgres copy is scrubbed (claim check) and the body is fetched from the WORM
   * S3 object. Null when the payload could not be parsed, the S3 read failed, or
   * the reader IAM user is not yet provisioned. Expensive on list queries: each
   * archived node issues one synchronous S3 GET — omit this field on connection selections.
   */
  readonly body?: Maybe<Scalars['String']['output']>;
  /** "application/json", "text/xml", or "text/plain" (WORM response text or fingerprints) */
  readonly contentType: Scalars['String']['output'];
  /** When the row was captured. ReconcileNfsAuditArchivalWorker alerts on unarchived rows past 6h old by this timestamp. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** "request" or "response" */
  readonly direction: NfsAuditDirection;
  /** "eap" or "esg" */
  readonly gateway: NfsAuditGateway;
  /** HTTP response status; absent on request legs */
  readonly httpStatus?: Maybe<Scalars['Int']['output']>;
  /** UUID primary key */
  readonly id: Scalars['ID']['output'];
  /** When the ship worker last attempted this leg */
  readonly lastAttemptedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last S3 ship error message if archival failed */
  readonly lastErrorMessage?: Maybe<Scalars['String']['output']>;
  /** Fidelity operation name (e.g. AccountSetup) */
  readonly operation: NfsAuditOperation;
  /** UTC timestamp when the leg was captured */
  readonly recordedAt: Scalars['ISO8601DateTime']['output'];
  /** S3 object key after successful archival */
  readonly s3Key?: Maybe<Scalars['String']['output']>;
  /** OutboxEvent archival status */
  readonly status: NfsAuditStatus;
  /** Fidelity FID-LOG-TRACKING-ID correlation ID */
  readonly trackingId: Scalars['String']['output'];
  /** Number of S3 ship attempts made */
  readonly tryCount: Scalars['Int']['output'];
};

/** The connection type for NfsAuditEntry. */
export type NfsAuditEntryConnection = {
  readonly __typename?: 'NfsAuditEntryConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<NfsAuditEntryEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<NfsAuditEntry>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NfsAuditEntryEdge = {
  readonly __typename?: 'NfsAuditEntryEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<NfsAuditEntry>;
};

/** "eap" or "esg" */
export const NfsAuditGateway = {
  Eap: 'eap',
  Esg: 'esg'
} as const;

export type NfsAuditGateway = typeof NfsAuditGateway[keyof typeof NfsAuditGateway];
/** Fidelity NFS operation name */
export const NfsAuditOperation = {
  AccountProfileInquire: 'AccountProfileInquire',
  AccountProfileMaintain: 'AccountProfileMaintain',
  AccountSetup: 'AccountSetup',
  AccountValidate: 'AccountValidate',
  AggregateStandingInstructionInquire: 'AggregateStandingInstructionInquire',
  AggregateTransactionInquire: 'AggregateTransactionInquire',
  CaptureServicesUpload: 'CaptureServicesUpload',
  DetermineTransferability: 'DetermineTransferability',
  EftStandingInstructionCreate: 'EftStandingInstructionCreate',
  EftStandingInstructionDelete: 'EftStandingInstructionDelete',
  EftStandingInstructionInquire: 'EftStandingInstructionInquire',
  GetCompatibleRegistrations: 'GetCompatibleRegistrations',
  GetCusipInfo: 'GetCusipInfo',
  GetCustodianData: 'GetCustodianData',
  PregenAccount: 'PregenAccount',
  SearchCustodian: 'SearchCustodian',
  ToaInitiate: 'TOAInitiate',
  ToaValidate: 'TOAValidate',
  WormArchiveRetrieve: 'WormArchiveRetrieve',
  WormArchiveSearch: 'WormArchiveSearch'
} as const;

export type NfsAuditOperation = typeof NfsAuditOperation[keyof typeof NfsAuditOperation];
/** A Fidelity NFS audit leg matched by the search index. */
export type NfsAuditSearchHit = {
  readonly __typename?: 'NfsAuditSearchHit';
  /** Indexed body copy (redacted at capture). Authoritative bytes live in the WORM object. */
  readonly bodyText: Scalars['String']['output'];
  /** "application/json", "text/xml", or "text/plain" (WORM response text or fingerprints) */
  readonly contentType: Scalars['String']['output'];
  /** "request" or "response" */
  readonly direction: NfsAuditDirection;
  /** Base64 SHA-256 of the archived envelope (integrity anchor) */
  readonly envelopeSha256: Scalars['String']['output'];
  /** "eap" or "esg" */
  readonly gateway: NfsAuditGateway;
  /** HTTP response status; absent on request legs */
  readonly httpStatus?: Maybe<Scalars['Int']['output']>;
  /** Fidelity operation name (e.g. AccountSetup) */
  readonly operation: NfsAuditOperation;
  /** OutboxEvent id of the archived leg — join key into nfsAuditEntries */
  readonly outboxEventId: Scalars['ID']['output'];
  /** UTC timestamp when the leg was captured */
  readonly recordedAt: Scalars['ISO8601DateTime']['output'];
  /** WORM S3 object key; doubles as the search document id */
  readonly s3Key: Scalars['String']['output'];
  /** Fidelity FID-LOG-TRACKING-ID correlation ID */
  readonly trackingId: Scalars['String']['output'];
};

/** A page of NFS audit search hits plus the total match count. */
export type NfsAuditSearchResults = {
  readonly __typename?: 'NfsAuditSearchResults';
  /** Matches for the requested page, newest first */
  readonly hits: ReadonlyArray<NfsAuditSearchHit>;
  /** Total matches across all pages */
  readonly total: Scalars['Int']['output'];
};

/** OutboxEvent archival status */
export const NfsAuditStatus = {
  Completed: 'completed',
  Failed: 'failed',
  Pending: 'pending',
  Processing: 'processing'
} as const;

export type NfsAuditStatus = typeof NfsAuditStatus[keyof typeof NfsAuditStatus];
/** Note related to a Savvy object */
export type Note = {
  readonly __typename?: 'Note';
  /** The HTML content of the note */
  readonly content: Scalars['String']['output'];
  /** When the note was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The name of the user who created the note */
  readonly createdByName?: Maybe<Scalars['String']['output']>;
  /** Users in the household this note belongs to */
  readonly householdUsers?: Maybe<ReadonlyArray<User>>;
  /** Households this note belongs to */
  readonly households?: Maybe<ReadonlyArray<Household>>;
  /** The Savvy ID of the note. */
  readonly id: Scalars['ID']['output'];
  /** Whether the note is pinned in the Advisor Dashboard. */
  readonly isPinned: Scalars['Boolean']['output'];
  /** The Dialpad transcript backing this Note, when one exists. */
  readonly linkedDialpadCallTranscript?: Maybe<DialpadCallTranscript>;
  /** The in-person recording backing this Note, when one exists and the viewer recorded it. */
  readonly linkedMeetingRecording?: Maybe<MeetingRecording>;
  /** The Zoom transcript backing this Note, when one exists. */
  readonly linkedZoomMeetingTranscript?: Maybe<ZoomMeetingTranscript>;
  /** ID of the recap template the backing summary was generated from. Null when none was used. */
  readonly meetingAgendaTemplateId?: Maybe<Scalars['ID']['output']>;
  /** Title of that recap template, including one since deleted, so the source stays displayable. */
  readonly meetingAgendaTemplateTitle?: Maybe<Scalars['String']['output']>;
  /** End time */
  readonly meetingEndTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The source of the meeting summary (e.g. "zoom", "dialpad"). Null when the note is not backed by a MeetingSummary. */
  readonly meetingSource?: Maybe<Scalars['String']['output']>;
  /** Start time */
  readonly meetingStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Whether the recap in this note has been hand-edited since it was generated, so
   * regenerating would discard that work. Null when there is nothing to compare against.
   */
  readonly meetingSummaryEditedSinceGeneration?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Identifies the backing Savvy summary text on screen; echoed back when voting
   * so a vote on since-regenerated text is rejected. Null when the note is not
   * backed by a Savvy summary.
   */
  readonly meetingSummaryGeneration?: Maybe<Scalars['String']['output']>;
  /** ID of the backing MeetingSummary, for mutations that act on it. Null when the note is not summary-backed. */
  readonly meetingSummaryId?: Maybe<Scalars['ID']['output']>;
  /**
   * The current user's thumb on the backing Savvy summary's current text, so a
   * pinned thumb survives a reload. Null when they have not rated it.
   */
  readonly meetingSummaryMyVote?: Maybe<MeetingSummaryVoteEnum>;
  /**
   * The transcript of the in-person meeting this note recaps, in speaking order.
   * Empty for every other note — a typed note, a Zoom recap, a call summary — so a
   * client can render the tab only when there is something in it.
   */
  readonly meetingTranscript: ReadonlyArray<MeetingTranscriptLine>;
  /** URL of the owner's profile picture, to render beside owner_name. Null when they have none. */
  readonly ownerAvatarUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the owner of the note */
  readonly ownerName: Scalars['String']['output'];
  /** Where the last requested regeneration of the backing summary got to; null when none has been requested. */
  readonly regenerationStatus?: Maybe<MeetingSummaryRegenerationStatus>;
  /** Relation Type */
  readonly relationType: Scalars['String']['output'];
  readonly taskSuggestions?: Maybe<ReadonlyArray<TaskSuggestion>>;
  readonly tasks?: Maybe<ReadonlyArray<Task>>;
  /** The title of the note */
  readonly title: Scalars['String']['output'];
  readonly topics: ReadonlyArray<Scalars['String']['output']>;
  /** The timestamp the note was last updated. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The name of the user who last updated the note */
  readonly updatedByName?: Maybe<Scalars['String']['output']>;
  readonly userCanUpdateAndDelete: Scalars['Boolean']['output'];
};

export type NoteDetailOpen = {
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source of the backing meeting summary — "savvy", "zoom", or "dialpad". Absent for advisor-authored notes. */
  readonly meetingSource?: InputMaybe<Scalars['String']['input']>;
  /** Id of the opened note. */
  readonly noteId: Scalars['String']['input'];
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export type NoteDetailViewDuration = {
  /** How long the note detail view stayed open, in milliseconds. */
  readonly duration: Scalars['Int']['input'];
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source of the backing meeting summary — "savvy", "zoom", or "dialpad". Absent for advisor-authored notes. */
  readonly meetingSource?: InputMaybe<Scalars['String']['input']>;
  /** Id of the note that was open. */
  readonly noteId: Scalars['String']['input'];
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export type NotificationAlertMute = {
  readonly __typename?: 'NotificationAlertMute';
  /** Masked account number, when account-scoped. */
  readonly accountMask?: Maybe<Scalars['String']['output']>;
  /** Display label of the muted account, when account-scoped. */
  readonly accountName?: Maybe<Scalars['String']['output']>;
  /** The muted alert type (cash_variance or allocation_variance). */
  readonly alertType: Scalars['String']['output'];
  /** Display name of the muted household. */
  readonly householdName: Scalars['String']['output'];
  /** Public identifier of the muted household. */
  readonly householdPublicId?: Maybe<Scalars['String']['output']>;
  /** The mute id. */
  readonly id: Scalars['ID']['output'];
  /** The mute scope: "account" or "household". */
  readonly scope: Scalars['String']['output'];
};

export type NotificationFlyoutOpened = {
  /** Inbox badge count at the moment the fly-out opened. */
  readonly activeCount: Scalars['Int']['input'];
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export type NotificationFlyoutShowAllClicked = {
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export type NotificationPreferenceChanged = {
  /** Catalog alert type the change applies to. Omitted for a reset or a task-routing change. */
  readonly alertType?: InputMaybe<Scalars['String']['input']>;
  /** New destination — "inbox", "activity" or "off". Omitted for a mute or a reset. */
  readonly destination?: InputMaybe<Scalars['String']['input']>;
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  /** True when the advisor reset a whole section back to defaults rather than changing one row. */
  readonly isReset?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /** Which control changed — "catalog_route", "task_route", "task_timing", "mute" or "legacy_alert_toggle". */
  readonly setting: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

/** Catalog alert types with configurable notification routes */
export const NotificationRouteAlert = {
  AccountConfirmationComplete: 'account_confirmation_complete',
  AccountLinkedOrAggregationAdded: 'account_linked_or_aggregation_added',
  AccountOpenedOrFunded: 'account_opened_or_funded',
  AccountSetupConfirmationSent: 'account_setup_confirmation_sent',
  AdvisorRequirementsNeeded: 'advisor_requirements_needed',
  AllocationVariance: 'allocation_variance',
  AutoAdvanceBlockedMissingAum: 'auto_advance_blocked_missing_aum',
  BeneficiaryOrOwnershipChange: 'beneficiary_or_ownership_change',
  Birthdays: 'birthdays',
  CallStepRequired: 'call_step_required',
  CashVariance: 'cash_variance',
  CenterOfInfluenceRepCommentMention: 'center_of_influence_rep_comment_mention',
  ClientCompletedTask: 'client_completed_task',
  ClientCompletedTaxEnrollment: 'client_completed_tax_enrollment',
  ClientEngagement: 'client_engagement',
  ClientLogins: 'client_logins',
  ClientPortalMessageReceived: 'client_portal_message_received',
  ClientSignedDocuments: 'client_signed_documents',
  ClientSubmittedRiskQuestionnaire: 'client_submitted_risk_questionnaire',
  ClientUploadedRequestedFile: 'client_uploaded_requested_file',
  CompanyCommentMention: 'company_comment_mention',
  ContactCommentMention: 'contact_comment_mention',
  ContributionReceived: 'contribution_received',
  DocusignOutstanding: 'docusign_outstanding',
  EmailFromLead: 'email_from_lead',
  FederalReturnAccepted: 'federal_return_accepted',
  FederalReturnReceived: 'federal_return_received',
  FederalReturnRejected: 'federal_return_rejected',
  FileUploadRequestSent: 'file_upload_request_sent',
  HouseholdCommentMention: 'household_comment_mention',
  HubspotLeadCreated: 'hubspot_lead_created',
  InboundMissedCall: 'inbound_missed_call',
  IntakeInviteReminderSent: 'intake_invite_reminder_sent',
  IntakeInviteSent: 'intake_invite_sent',
  LargeWithdrawalDetected: 'large_withdrawal_detected',
  MeetingBookedByClient: 'meeting_booked_by_client',
  MeetingCanceledOrRescheduledByClient: 'meeting_canceled_or_rescheduled_by_client',
  MeetingPrepReady: 'meeting_prep_ready',
  MeetingRecapReady: 'meeting_recap_ready',
  MeetingTranscriptNeedsHousehold: 'meeting_transcript_needs_household',
  NewLeadCampaignStarted: 'new_lead_campaign_started',
  NewLeadCreated: 'new_lead_created',
  OnboardingComplete: 'onboarding_complete',
  OnboardingInviteReminderSent: 'onboarding_invite_reminder_sent',
  OnboardingInviteSent: 'onboarding_invite_sent',
  OutboundMissedCallReminder: 'outbound_missed_call_reminder',
  OutstandingClientTask: 'outstanding_client_task',
  PreReviewCheckInSent: 'pre_review_check_in_sent',
  ProspectConverted: 'prospect_converted',
  QuarterlyReportFailed: 'quarterly_report_failed',
  QuarterlyReportGenerated: 'quarterly_report_generated',
  RecurringInvestmentReminder: 'recurring_investment_reminder',
  RiskQuestionnaireSent: 'risk_questionnaire_sent',
  Rmds: 'rmds',
  ServiceCalendarBookingReminderSent: 'service_calendar_booking_reminder_sent',
  ServiceCalendarDueDate: 'service_calendar_due_date',
  ServiceCalendarInviteSent: 'service_calendar_invite_sent',
  ServiceCalendarSetup: 'service_calendar_setup',
  ServiceCalendarTaskAssigned: 'service_calendar_task_assigned',
  SmsFromLead: 'sms_from_lead',
  StagnantProspect: 'stagnant_prospect',
  StateReturnAccepted: 'state_return_accepted',
  StateReturnReceived: 'state_return_received',
  StateReturnRejected: 'state_return_rejected',
  TaskCreated: 'task_created',
  TaskDueDateChanged: 'task_due_date_changed',
  TaskReassignedNotification: 'task_reassigned_notification',
  TaxFilingLateOrMissedDeadline: 'tax_filing_late_or_missed_deadline',
  TaxFilingReady: 'tax_filing_ready',
  TaxFilingReadySentToClient: 'tax_filing_ready_sent_to_client',
  TaxFilingReminderToClient: 'tax_filing_reminder_to_client',
  TransferIn: 'transfer_in'
} as const;

export type NotificationRouteAlert = typeof NotificationRouteAlert[keyof typeof NotificationRouteAlert];
/** A notification route destination */
export const NotificationRouteDestination = {
  /** activity */
  Activity: 'activity',
  /** inbox */
  Inbox: 'inbox',
  /** off */
  Off: 'off'
} as const;

export type NotificationRouteDestination = typeof NotificationRouteDestination[keyof typeof NotificationRouteDestination];
export type NotificationRoutePreference = {
  readonly __typename?: 'NotificationRoutePreference';
  /** The catalog alert type. */
  readonly alertType: NotificationRouteAlert;
  /** The effective notification destination. */
  readonly destination: NotificationRouteDestination;
  /** Whether the effective destination is the server-owned default. */
  readonly isDefault: Scalars['Boolean']['output'];
};

export type NotificationTaskRoutingCell = {
  readonly __typename?: 'NotificationTaskRoutingCell';
  /** The effective destination: inbox, activity, or off. */
  readonly destination: Scalars['String']['output'];
  /** The task event: tasks_due, comments, or status. */
  readonly event: Scalars['String']['output'];
  /** Whether the destination matches the default. */
  readonly isDefault: Scalars['Boolean']['output'];
  /** The viewer relationship: assignee, creator, primary, or all_other. */
  readonly relationship: Scalars['String']['output'];
};

/** Number/currency filter with operator and value(s) */
export type NumberFilterInput = {
  /** Maximum value for between operator */
  readonly max?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum value for between operator */
  readonly min?: InputMaybe<Scalars['Float']['input']>;
  /** Number filter operator */
  readonly operator: NumberFilterOperatorEnum;
  /** Filter value (not required for isEmpty operator) */
  readonly value?: InputMaybe<Scalars['Float']['input']>;
};

/** Number/currency filter operators */
export const NumberFilterOperatorEnum = {
  /** Between min and max values */
  Between: 'BETWEEN',
  /** Equal to */
  Eq: 'EQ',
  /** Greater than */
  Gt: 'GT',
  /** Greater than or equal */
  Gte: 'GTE',
  /** Field is empty or null */
  IsEmpty: 'IS_EMPTY',
  /** Less than */
  Lt: 'LT',
  /** Less than or equal */
  Lte: 'LTE'
} as const;

export type NumberFilterOperatorEnum = typeof NumberFilterOperatorEnum[keyof typeof NumberFilterOperatorEnum];
export const OccurrenceStatus = {
  /** booked */
  Booked: 'booked',
  /** booking_canceled */
  BookingCanceled: 'booking_canceled',
  /** completed */
  Completed: 'completed',
  /** invited */
  Invited: 'invited',
  /** missed */
  Missed: 'missed',
  /** scheduled */
  Scheduled: 'scheduled',
  /** send_failed */
  SendFailed: 'send_failed',
  /** skipped */
  Skipped: 'skipped'
} as const;

export type OccurrenceStatus = typeof OccurrenceStatus[keyof typeof OccurrenceStatus];
/** A book-transfer household row for the onboarding cockpit table. */
export type OnboardingCockpitRow = {
  readonly __typename?: 'OnboardingCockpitRow';
  /**
   * Accounts this household has actually opened at its destination custodian.
   * Fidelity NFS reports this per account at the moment it opens; every other
   * custodian is observed through the daily Orion sync, so it can lag a day. A
   * same-custodian transfer opens nothing and counts as opened on arrival.
   */
  readonly accountsOpened: Scalars['Int']['output'];
  /**
   * Accounts this household is expected to bring over: the advisor's confirmed
   * selection once confirm has run, otherwise the imported candidate set, plus any
   * same-custodian transfers and confirmation leftovers that never enter the ECI graph.
   */
  readonly accountsTotal: Scalars['Int']['output'];
  /**
   * Accounts whose assets have arrived at Savvy. Always 0 until Step 8 resolves
   * the custodian feed — no signal today distinguishes a settled account from a confirmed one.
   */
  readonly accountsTransferred: Scalars['Int']['output'];
  /**
   * Accounts of the total that are part of the transfer, and the denominator
   * accountsTransferred is read against. An open-only account is opened at its
   * destination custodian and moves nothing, so it counts in accountsTotal and not
   * here. A same-custodian transfer counts here even though its assets never move,
   * mirroring how accountsOpened counts it as opened on arrival.
   */
  readonly accountsTransferringTotal: Scalars['Int']['output'];
  /**
   * Stable id of the advisor who owns this household. Distinguishes advisors a
   * display name cannot, so the client can refuse a bulk action spanning advisors.
   */
  readonly advisorId?: Maybe<Scalars['ID']['output']>;
  /** Full name of the advisor who owns this household. */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /** Prefilled advisory agreement for this household, for the advisor to review before the client is invited. */
  readonly advisoryAgreementDraft: AdvisoryAgreementDraft;
  /** Clients who have signed the household advisory contract (MSA or IAA). */
  readonly agreementSigned: Scalars['Int']['output'];
  /** Clients expected to sign (signer count). */
  readonly agreementTotal: Scalars['Int']['output'];
  /** The household's advisory contract (MSA or IAA). Nil column stamps as the MSA default. */
  readonly agreementType: EciAgreement;
  /**
   * Whether the household's active fee schedule carries rates. False when none is
   * assigned or when it is a name-only copy from the book import; sending such a
   * household would print an empty fee table.
   */
  readonly assignedFeeScheduleHasRates: Scalars['Boolean']['output'];
  /** Name of the household's active fee schedule. Null before promotion or when none is assigned. */
  readonly assignedFeeScheduleName?: Maybe<Scalars['String']['output']>;
  /** Why the household is blocked, when status is blocked. */
  readonly blockedReason?: Maybe<Scalars['String']['output']>;
  /** Whether the current user can open the correction editor for this book. */
  readonly correctionEnabled: Scalars['Boolean']['output'];
  /** Estimated AUM captured at import. */
  readonly estAum?: Maybe<Scalars['Float']['output']>;
  /** External identifier from the imported book. */
  readonly externalKey?: Maybe<Scalars['String']['output']>;
  /** Whether any client ECI request still has day 3/7/14 auto-reminders outstanding. */
  readonly hasActiveReminders: Scalars['Boolean']['output'];
  /**
   * Display name for the household: the name off the transition spreadsheet, else
   * the promoted household, the primary client, or the external key.
   */
  readonly householdName: Scalars['String']['output'];
  /**
   * Canonical household public id (uuid) after promotion, for Overview deeplinks.
   * Null until StagingPromoter links a household.
   */
  readonly householdUuid?: Maybe<Scalars['ID']['output']>;
  /** Household onboarding request id. */
  readonly id: Scalars['ID']['output'];
  /**
   * Every household member the onboarding invite is addressed to, primary first.
   * The resend panel selects from these; a resend hits exactly who is selected.
   */
  readonly inviteRecipients: ReadonlyArray<InviteRecipient>;
  /** Most recent client contact (ECI intake send or reminder). Null until sent. */
  readonly lastContactedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The same-custodian LPOA transfers among the accounts: they stay with their custodian and open no new account. */
  readonly lpoaTransfers: ReadonlyArray<AdvisorOnboardingCockpitAccount>;
  /**
   * Clients who have signed the household advisory contract (MSA or IAA).
   * @deprecated Use agreementSigned
   */
  readonly msaSigned: Scalars['Int']['output'];
  /**
   * Clients expected to sign (signer count).
   * @deprecated Use agreementTotal
   */
  readonly msaTotal: Scalars['Int']['output'];
  /** Primary client email. */
  readonly primaryClientEmail?: Maybe<Scalars['String']['output']>;
  /** Primary client full name. */
  readonly primaryClientName?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the household's clients sign their custodian forms, LPOA included, in
   * DocuSign after the IAA. Read for the household's advisor.
   */
  readonly signsCustodianFormsInDocusign: Scalars['Boolean']['output'];
  /**
   * Whether the household's custodian forms, LPOA included, are stamped with the
   * clients' IAA signature instead of a separate DocuSign signing. Read for the
   * household's advisor.
   */
  readonly stampsCustodianForms: Scalars['Boolean']['output'];
  /** When the household entered the book. */
  readonly startDate: Scalars['ISO8601DateTime']['output'];
  /** Advisor onboarding phase. */
  readonly status: OnboardingCockpitStatus;
  /** Dollars transferred. Null until Step 8 resolves the custodian feed. */
  readonly transferredAmount?: Maybe<Scalars['Float']['output']>;
  /** Immutable public handle for confirm/send deeplinks. */
  readonly uuid: Scalars['ID']['output'];
};

/** The connection type for OnboardingCockpitRow. */
export type OnboardingCockpitRowConnection = {
  readonly __typename?: 'OnboardingCockpitRowConnection';
  /** Sum of estimated AUM for the status-scoped book (All = every in-flight household). Ignores search and pagination. */
  readonly aumInFlight?: Maybe<Scalars['Float']['output']>;
  /** Household count on the same status-scoped book as aumInFlight. Ignores search and pagination. */
  readonly aumInFlightHouseholdCount: Scalars['Int']['output'];
  /** Households completed during the previous calendar month. Ignores search and status filter. */
  readonly completeLastMonth: Scalars['Int']['output'];
  /**
   * Households whose cockpit status transitioned to complete during the current
   * calendar month. Ignores search and status filter.
   */
  readonly completeThisMonth: Scalars['Int']['output'];
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<OnboardingCockpitRowEdge>>>;
  /**
   * Median days from first awaiting_client to complete across finished households.
   * Null when none qualify. Ignores search and status filter.
   */
  readonly medianOnboardingDays?: Maybe<Scalars['Float']['output']>;
  /** Median onboarding days for households completed in the previous calendar month. Null when none qualify. */
  readonly medianOnboardingDaysLastMonth?: Maybe<Scalars['Float']['output']>;
  /**
   * Bucketed median onboarding days over a lookback window. Empty buckets return
   * null medianDays so the x-axis stays continuous.
   */
  readonly medianOnboardingDaysSeries: ReadonlyArray<OnboardingTimeSeriesPoint>;
  /** Median onboarding days for households completed in the current calendar month. Null when none qualify. */
  readonly medianOnboardingDaysThisMonth?: Maybe<Scalars['Float']['output']>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<OnboardingCockpitRow>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Row count per status across the full filtered set; powers the "All · N" filter chips. */
  readonly statusCounts: ReadonlyArray<OnboardingStatusCount>;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};


/** The connection type for OnboardingCockpitRow. */
export type OnboardingCockpitRowConnectionMedianOnboardingDaysSeriesArgs = {
  range: OnboardingTimeSeriesRange;
};

/** An edge in a connection. */
export type OnboardingCockpitRowEdge = {
  readonly __typename?: 'OnboardingCockpitRowEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<OnboardingCockpitRow>;
};

/** Sortable fields for the onboarding cockpit table */
export const OnboardingCockpitSortField = {
  /** EST_AUM */
  EstAum: 'EST_AUM',
  /** HOUSEHOLD_NAME */
  HouseholdName: 'HOUSEHOLD_NAME',
  /** LAST_CONTACTED_AT */
  LastContactedAt: 'LAST_CONTACTED_AT',
  /** START_DATE */
  StartDate: 'START_DATE',
  /** STATUS */
  Status: 'STATUS'
} as const;

export type OnboardingCockpitSortField = typeof OnboardingCockpitSortField[keyof typeof OnboardingCockpitSortField];
export const OnboardingCockpitStatus = {
  /** awaiting_client */
  AwaitingClient: 'awaiting_client',
  /** awaiting_ops */
  AwaitingOps: 'awaiting_ops',
  /** blocked */
  Blocked: 'blocked',
  /** complete */
  Complete: 'complete',
  /** confirm_account */
  ConfirmAccount: 'confirm_account',
  /** in_progress */
  InProgress: 'in_progress',
  /** ready_to_send */
  ReadyToSend: 'ready_to_send'
} as const;

export type OnboardingCockpitStatus = typeof OnboardingCockpitStatus[keyof typeof OnboardingCockpitStatus];
export const OnboardingDocument = {
  /** custodial */
  Custodial: 'custodial',
  /** investment */
  Investment: 'investment'
} as const;

export type OnboardingDocument = typeof OnboardingDocument[keyof typeof OnboardingDocument];
/** Number of cockpit rows in a given status, for the filter chips. */
export type OnboardingStatusCount = {
  readonly __typename?: 'OnboardingStatusCount';
  /** Rows in this status across the full filtered set. */
  readonly count: Scalars['Int']['output'];
  /** The staged household status. */
  readonly status: OnboardingCockpitStatus;
};

export type OnboardingTaskDatum = {
  readonly __typename?: 'OnboardingTaskDatum';
  /** Status of transferring the client accounts to custodian */
  readonly accountTransferStatus?: Maybe<AccountTransferStatus>;
  /** When the co-client signed via DocuSign. */
  readonly coClientDocusignSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the co-client signed the IAA. */
  readonly coClientIaaSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the onboarding task datum was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The custodian for the client. */
  readonly custodian?: Maybe<Scalars['String']['output']>;
  /** Why the latest custodian forms build failed; null unless it failed. */
  readonly custodianFormsError?: Maybe<Scalars['String']['output']>;
  /** When the DocuSign envelope was delivered to the custodian. */
  readonly docusignEnvelopeCustodianDeliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The DocuSign environment used for the envelope. */
  readonly docusignEnvelopeEnvironment?: Maybe<Scalars['String']['output']>;
  /** DocuSign envelope ID associated with the task. */
  readonly docusignEnvelopeId?: Maybe<Scalars['String']['output']>;
  /** Whether the DocuSign envelope has been shared with the custodian. */
  readonly docusignEnvelopeSharedWithCustodian?: Maybe<Scalars['Boolean']['output']>;
  /** DocuSign envelope status. */
  readonly docusignEnvelopeStatus?: Maybe<Scalars['String']['output']>;
  /** Whether this onboarding includes a co-client. */
  readonly hasCoClient?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  /** When the last IAA email was sent to the co-client. */
  readonly lastCoClientIaaEmailSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the last LPOA email was sent to the co-client. */
  readonly lastCoClientLpoaEmailSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the last IAA email was sent to the primary client. */
  readonly lastPrimaryClientIaaEmailSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the last LPOA email was sent to the primary client. */
  readonly lastPrimaryClientLpoaEmailSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Previous wealth management firm for a transferring client */
  readonly previousWmFirm?: Maybe<Scalars['String']['output']>;
  /** When the primary client signed via DocuSign. */
  readonly primaryClientDocusignSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the primary client signed the IAA. */
  readonly primaryClientIaaSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the onboarding task is ready to be sent to the client. */
  readonly readyToSendToClient: Scalars['Boolean']['output'];
  /** Why this task cannot be released to the client, or null when not blocked. */
  readonly releaseBlockReason?: Maybe<ReleaseBlockReason>;
  /** Box File ID for IAA */
  readonly signableDocumentBoxFileId?: Maybe<Scalars['String']['output']>;
  /** Download link for a natively signable document. */
  readonly signableDocumentDownloadLink?: Maybe<Scalars['String']['output']>;
  /** View link for a natively signable document. */
  readonly signableDocumentLink?: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the signature for the signable document. */
  readonly signatureId?: Maybe<Scalars['ID']['output']>;
  /** The associated task. */
  readonly task: Task;
  /** The Savvy ID of the associated task. */
  readonly taskId: Scalars['ID']['output'];
  /** When the onboarding task datum was last updated. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** One bucket on the cockpit median-onboarding-time chart. */
export type OnboardingTimeSeriesPoint = {
  readonly __typename?: 'OnboardingTimeSeriesPoint';
  /** ISO date of the bucket start (day, week, or month). */
  readonly date: Scalars['String']['output'];
  /** Median onboarding days for completions in this bucket. Null when none. */
  readonly medianDays?: Maybe<Scalars['Float']['output']>;
};

/** Lookback window for the cockpit median-onboarding-time chart. */
export const OnboardingTimeSeriesRange = {
  /** Monthly buckets over the trailing 12 months */
  OneYear: 'ONE_YEAR',
  /** Monthly buckets over the trailing 6 months */
  SixMonths: 'SIX_MONTHS',
  /** Daily buckets over the trailing 30 days */
  ThirtyDays: 'THIRTY_DAYS',
  /** Weekly buckets over the trailing 3 months */
  ThreeMonths: 'THREE_MONTHS'
} as const;

export type OnboardingTimeSeriesRange = typeof OnboardingTimeSeriesRange[keyof typeof OnboardingTimeSeriesRange];
/** A beneficiary recorded on an open new account request */
export type OpenNewAccountBeneficiary = {
  readonly __typename?: 'OpenNewAccountBeneficiary';
  /** Whether this is a primary or contingent beneficiary. */
  readonly beneficiaryType: Scalars['String']['output'];
  /** Phone number of the beneficiary. */
  readonly cellPhone?: Maybe<Scalars['String']['output']>;
  /** Savvy id of the contact this beneficiary is. */
  readonly contactId: Scalars['ID']['output'];
  /** Date of birth of the beneficiary (ISO-8601: YYYY-MM-DD). */
  readonly dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** Email address of the beneficiary. */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** Name of the beneficiary. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Whether per stirpes distribution applies. */
  readonly perStirpes?: Maybe<Scalars['Boolean']['output']>;
  /** Percentage of the account allocated to this beneficiary. */
  readonly percentage?: Maybe<Scalars['String']['output']>;
  /** Relationship of the beneficiary to the account holder. */
  readonly relationship?: Maybe<Scalars['String']['output']>;
  /** Masked SSN of the beneficiary (***-**-XXXX). */
  readonly ssn?: Maybe<Scalars['String']['output']>;
};

/** Input for a beneficiary of an open new account request */
export type OpenNewAccountBeneficiaryInput = {
  /** Type of beneficiary (primary, contingent) */
  readonly beneficiaryType: Scalars['String']['input'];
  /** Cell phone number */
  readonly cellPhone?: InputMaybe<Scalars['String']['input']>;
  /** ID of an existing contact to associate as beneficiary */
  readonly contactId?: InputMaybe<Scalars['ID']['input']>;
  /** Date of birth (YYYY-MM-DD) */
  readonly dob?: InputMaybe<Scalars['String']['input']>;
  /** Email address */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the beneficiary */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Whether the share passes per stirpes */
  readonly perStirpes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Percentage allocated to this beneficiary */
  readonly percentage?: InputMaybe<Scalars['String']['input']>;
  /** Relationship to the account holder */
  readonly relationship?: InputMaybe<Scalars['String']['input']>;
  /** Social security number */
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
};

/** Open new account request data associated with a task */
export type OpenNewAccountRequest = {
  readonly __typename?: 'OpenNewAccountRequest';
  /** The account holder type (e.g. Individual, Joint). */
  readonly accountHolder?: Maybe<Scalars['String']['output']>;
  /** The bank account mode (e.g. checking, savings). */
  readonly accountMode?: Maybe<Scalars['String']['output']>;
  /** The account name at the contra custodian. */
  readonly accountName?: Maybe<Scalars['String']['output']>;
  /** The legal registration of the account. */
  readonly accountRegistration?: Maybe<Scalars['String']['output']>;
  /** The type of account to open. */
  readonly accountType?: Maybe<Scalars['String']['output']>;
  /** Additional information about the request. */
  readonly additionalInfo?: Maybe<Scalars['String']['output']>;
  /** Annual income of the account holder. */
  readonly annualIncome?: Maybe<Scalars['Float']['output']>;
  /** The bank account number. */
  readonly bankAccountNumber?: Maybe<Scalars['String']['output']>;
  /** The bank name for MoneyLink. */
  readonly bankName?: Maybe<Scalars['String']['output']>;
  /** The bank account owners. */
  readonly bankOwners?: Maybe<Scalars['String']['output']>;
  /** Primary and contingent beneficiaries. */
  readonly beneficiaries?: Maybe<ReadonlyArray<OpenNewAccountBeneficiary>>;
  /** The sending institution for transfer. */
  readonly contraCustodian?: Maybe<Scalars['String']['output']>;
  /** The custodian (e.g. Schwab, Fidelity). */
  readonly custodian?: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the request. */
  readonly id: Scalars['ID']['output'];
  /** Trading experience grid recorded with the request (options accounts). */
  readonly investmentExperience?: Maybe<InvestmentExperience>;
  /** The investment objective (e.g. growth, income). */
  readonly investmentObjective?: Maybe<Scalars['String']['output']>;
  /** The options trading level. */
  readonly level?: Maybe<Scalars['String']['output']>;
  /** Liquid net worth of the account holder. */
  readonly liquidNetWorth?: Maybe<Scalars['Float']['output']>;
  /** Whether this is a managed account. */
  readonly managedAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Whether margin trading is requested. */
  readonly margin?: Maybe<Scalars['Boolean']['output']>;
  /** The marital status of the account holder. */
  readonly maritalStatus?: Maybe<Scalars['String']['output']>;
  /** Whether MoneyLink is requested. */
  readonly moneyLink?: Maybe<Scalars['Boolean']['output']>;
  /** The money manager name. */
  readonly moneyManager?: Maybe<Scalars['String']['output']>;
  /** The number of dependents. */
  readonly numberOfDependents?: Maybe<Scalars['Int']['output']>;
  /** Whether options trading is requested. */
  readonly options?: Maybe<Scalars['Boolean']['output']>;
  /** Details for a partial transfer. */
  readonly partialTransferDetails?: Maybe<Scalars['String']['output']>;
  /** The bank routing number. */
  readonly routingNumber?: Maybe<Scalars['String']['output']>;
  /** The investment strategy. */
  readonly strategy?: Maybe<Scalars['String']['output']>;
  /** Total net worth of the account holder. */
  readonly totalNetWorth?: Maybe<Scalars['Float']['output']>;
  /** Whether a transfer in is requested. */
  readonly transfer?: Maybe<Scalars['Boolean']['output']>;
  /** The account number at the contra custodian. */
  readonly transferAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the transfer is full or partial. */
  readonly transferType?: Maybe<Scalars['String']['output']>;
  /** The mailing address of the trusted contact. */
  readonly trustedContactMailingAddress?: Maybe<Scalars['String']['output']>;
  /** The name of the trusted contact. */
  readonly trustedContactName?: Maybe<Scalars['String']['output']>;
  /** The phone number of the trusted contact. */
  readonly trustedContactPhone?: Maybe<Scalars['String']['output']>;
  /** The relationship of the trusted contact. */
  readonly trustedContactRelationship?: Maybe<Scalars['String']['output']>;
};

/** Input for open new account request task specific data */
export type OpenNewAccountRequestInput = {
  /** Name of the account holder */
  readonly accountHolder?: InputMaybe<Scalars['String']['input']>;
  /** Account mode */
  readonly accountMode?: InputMaybe<Scalars['String']['input']>;
  /** Account name for transfer */
  readonly accountName?: InputMaybe<Scalars['String']['input']>;
  /** Bank account number for money link */
  readonly accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Account registration for transfer */
  readonly accountRegistration?: InputMaybe<Scalars['String']['input']>;
  /** Type of account to open */
  readonly accountType: Scalars['String']['input'];
  /** Additional notes or instructions */
  readonly additionalInfo?: InputMaybe<Scalars['String']['input']>;
  /** Annual income */
  readonly annualIncome?: InputMaybe<Scalars['Float']['input']>;
  /** Bank name */
  readonly bankName?: InputMaybe<Scalars['String']['input']>;
  /** Bank account owners */
  readonly bankOwners?: InputMaybe<Scalars['String']['input']>;
  /** List of beneficiaries */
  readonly beneficiaries?: InputMaybe<ReadonlyArray<OpenNewAccountBeneficiaryInput>>;
  /** Contra custodian for transfer */
  readonly contraCustodian?: InputMaybe<Scalars['String']['input']>;
  /** Account custodian */
  readonly custodian?: InputMaybe<Scalars['String']['input']>;
  /** Custom fee percentage when not using the household fee */
  readonly customFee?: InputMaybe<Scalars['Float']['input']>;
  /** Fee schedule ID */
  readonly feeScheduleId?: InputMaybe<Scalars['ID']['input']>;
  /** Investment experience grid across all instrument categories */
  readonly investmentExperienceGrid?: InputMaybe<InvestmentExperienceGridInput>;
  /** Investment objective */
  readonly investmentObjective?: InputMaybe<Scalars['String']['input']>;
  /** Options level */
  readonly level?: InputMaybe<Scalars['String']['input']>;
  /** Liquid net worth */
  readonly liquidNetWorth?: InputMaybe<Scalars['Float']['input']>;
  /** Whether this is a managed account */
  readonly managedAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether margin trading is enabled */
  readonly margin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Marital status */
  readonly maritalStatus?: InputMaybe<Scalars['String']['input']>;
  /** Whether MoneyLink is enabled */
  readonly moneyLink?: InputMaybe<Scalars['Boolean']['input']>;
  /** Money manager */
  readonly moneyManager?: InputMaybe<Scalars['String']['input']>;
  /** Number of dependents */
  readonly numberOfDependents?: InputMaybe<Scalars['Int']['input']>;
  /** Whether options trading is enabled */
  readonly options?: InputMaybe<Scalars['Boolean']['input']>;
  /** Details for a partial transfer */
  readonly partialTransferDetails?: InputMaybe<Scalars['String']['input']>;
  /** Bank routing number */
  readonly routingNumber?: InputMaybe<Scalars['String']['input']>;
  /** Whether the request should use the household fee */
  readonly sameAsHouseholdFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** Investment strategy */
  readonly strategy?: InputMaybe<Scalars['String']['input']>;
  /** Total net worth */
  readonly totalNetWorth?: InputMaybe<Scalars['Float']['input']>;
  /** Whether this involves a transfer */
  readonly transfer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Account number for transfer in */
  readonly transferAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Type of transfer (full, partial) */
  readonly transferType?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact mailing address */
  readonly trustedContactMailingAddress?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact full name */
  readonly trustedContactName?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact phone number */
  readonly trustedContactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Trusted contact relationship to account holder */
  readonly trustedContactRelationship?: InputMaybe<Scalars['String']['input']>;
};

export type OpportunitiesTableHeader = {
  readonly __typename?: 'OpportunitiesTableHeader';
  /** Aggregate # of new leads */
  readonly newLeadCount?: Maybe<Scalars['Int']['output']>;
  /** Aggregate # of onboarding opportunities */
  readonly onboardingCount?: Maybe<Scalars['Int']['output']>;
  /** Aggregate # of to_dos */
  readonly toDoCount?: Maybe<Scalars['Int']['output']>;
  /** Aggregate estimated ARR */
  readonly totalArr?: Maybe<Scalars['BigInt']['output']>;
  /** Aggregate estimated AUM */
  readonly totalAum?: Maybe<Scalars['BigInt']['output']>;
  /** Aggregate # of clients */
  readonly totalClients?: Maybe<Scalars['Int']['output']>;
  /** Aggregate # of prospects */
  readonly totalProspects?: Maybe<Scalars['Int']['output']>;
};

export type OpportunitiesTableRow = {
  readonly __typename?: 'OpportunitiesTableRow';
  /** The lead source of the opportunity */
  readonly advisorLeadSource?: Maybe<Scalars['String']['output']>;
  /** The short name of the alert */
  readonly alertShortName?: Maybe<AlertShortName>;
  /** The ARR of the opportunity */
  readonly arr?: Maybe<Scalars['Int']['output']>;
  /** The AUM of the opportunity */
  readonly aum?: Maybe<Scalars['Int']['output']>;
  /** The client profile id of the opportunity */
  readonly clientProfileId: Scalars['ID']['output'];
  /** The co-client of the opportunity */
  readonly coClient?: Maybe<OpportunitiesTableRowContact>;
  /** The created_at timestamp of the opportunity */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of the opportunity */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The expected close date of the opportunity */
  readonly expectedCloseDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The household associated with the opportunity */
  readonly household: Household;
  /** The household_id associated with the opportunity */
  readonly householdId: Scalars['ID']['output'];
  /** The name of the household */
  readonly householdName: Scalars['String']['output'];
  /** The stage of the household */
  readonly householdStage: HouseholdStage;
  /** The id associated with the opportunity */
  readonly id: Scalars['ID']['output'];
  /** Whether the opportunity is a prospect */
  readonly isProspect: Scalars['Boolean']['output'];
  /** The next steps of the opportunity */
  readonly nextSteps?: Maybe<Scalars['String']['output']>;
  /** The next steps due date of the opportunity */
  readonly nextStepsDueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Organization household categories for this opportunity */
  readonly organizationHouseholdCategories?: Maybe<ReadonlyArray<OrganizationHouseholdCategory>>;
  /** Organization household tags for this opportunity */
  readonly organizationHouseholdTags?: Maybe<ReadonlyArray<OrganizationHouseholdTag>>;
  /** The primary advisor for this prospect */
  readonly primaryAdvisor?: Maybe<PrimaryAdvisor>;
  /** The primary client of the opportunity */
  readonly primaryClient: OpportunitiesTableRowContact;
  /** The probability of closing of the opportunity */
  readonly probabilityOfClosing?: Maybe<ProbabilityOfClosing>;
  /** The salesforce account id of the household */
  readonly salesforceAccountId?: Maybe<Scalars['String']['output']>;
  /** The status of the opportunity */
  readonly status: OpportunityStatus;
  /** The updated_at timestamp of the opportunity */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for OpportunitiesTableRow. */
export type OpportunitiesTableRowConnection = {
  readonly __typename?: 'OpportunitiesTableRowConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<OpportunitiesTableRowEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<OpportunitiesTableRow>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of opportunities */
  readonly totalCount: Scalars['Int']['output'];
};

export type OpportunitiesTableRowContact = {
  readonly __typename?: 'OpportunitiesTableRowContact';
  /** The user email */
  readonly email: Scalars['String']['output'];
  /** The user first name */
  readonly firstName: Scalars['String']['output'];
  /** The user ID */
  readonly id: Scalars['ID']['output'];
  /** The user last name */
  readonly lastName: Scalars['String']['output'];
  /** The user phone number */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Edge type that transforms Opportunity records into OpportunitiesTableRow structs */
export type OpportunitiesTableRowEdge = {
  readonly __typename?: 'OpportunitiesTableRowEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<OpportunitiesTableRow>;
};

export type Opportunity = {
  readonly __typename?: 'Opportunity';
  /** The estimated ARR of the opportunity */
  readonly arr?: Maybe<Scalars['Int']['output']>;
  /** The estimated AUM of the opportunity */
  readonly aum?: Maybe<Scalars['Int']['output']>;
  /** Access client information related to opportunity */
  readonly client?: Maybe<Client>;
  /** The ID of the client profile */
  readonly clientProfileId: Scalars['ID']['output'];
  /** The date the opportunity was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of the opportunity */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The expected close date of the opportunity */
  readonly expectedCloseDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The ID of the opportunity */
  readonly id: Scalars['ID']['output'];
  /** Whether this opportunity is a prospect */
  readonly isProspect: Scalars['Boolean']['output'];
  /** The next steps for the opportunity */
  readonly nextSteps?: Maybe<Scalars['String']['output']>;
  /** The due date of the next steps for the opportunity */
  readonly nextStepsDueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The date the opportunity was won */
  readonly onboardDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The probability of closing the opportunity */
  readonly probabilityOfClosing?: Maybe<ProbabilityOfClosing>;
  /** The ID of the prospect datum */
  readonly prospectDatumId?: Maybe<Scalars['ID']['output']>;
  /** The current status of the opportunity */
  readonly status: OpportunityStatus;
  /** The date the opportunity was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Sort values for opportunities table */
export const OpportunitySortValues = {
  /** CREATED_AT */
  CreatedAt: 'CREATED_AT',
  /** DUE_DATE */
  DueDate: 'DUE_DATE',
  /** ESTIMATED_AUM */
  EstimatedAum: 'ESTIMATED_AUM',
  /** ESTIMATED_CLOSE_DATE */
  EstimatedCloseDate: 'ESTIMATED_CLOSE_DATE',
  /** HOUSEHOLD_NAME */
  HouseholdName: 'HOUSEHOLD_NAME',
  /** PRIMARY_ADVISOR */
  PrimaryAdvisor: 'PRIMARY_ADVISOR',
  /** PRIMARY_LAST_NAME */
  PrimaryLastName: 'PRIMARY_LAST_NAME',
  /** STAGE_STEP */
  StageStep: 'STAGE_STEP',
  /** STATUS */
  Status: 'STATUS'
} as const;

export type OpportunitySortValues = typeof OpportunitySortValues[keyof typeof OpportunitySortValues];
export const OpportunityStatus = {
  Commitment: 'commitment',
  Discovery: 'discovery',
  Disqualified: 'disqualified',
  Lost: 'lost',
  OnHold: 'on_hold',
  Onboarding: 'onboarding',
  Proposal: 'proposal',
  Won: 'won'
} as const;

export type OpportunityStatus = typeof OpportunityStatus[keyof typeof OpportunityStatus];
/** Filter opportunities by type */
export const OpportunityTypeFilter = {
  /** Show all opportunities */
  All: 'ALL',
  /** Show only client opportunities */
  Client: 'CLIENT',
  /** Show only prospect opportunities */
  Prospect: 'PROSPECT'
} as const;

export type OpportunityTypeFilter = typeof OpportunityTypeFilter[keyof typeof OpportunityTypeFilter];
/** Autogenerated input type of OptOutOfChimneyPropertyLink */
export type OptOutOfChimneyPropertyLinkInput = {
  /** The ID of the asset to opt out of Chimney */
  readonly assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OptOutOfChimneyPropertyLink. */
export type OptOutOfChimneyPropertyLinkPayload = {
  readonly __typename?: 'OptOutOfChimneyPropertyLinkPayload';
  /** The updated asset */
  readonly asset: Asset;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type Organization = {
  readonly __typename?: 'Organization';
  readonly advisorGroups?: Maybe<ReadonlyArray<AdvisorGroup>>;
  readonly advisorProfiles?: Maybe<ReadonlyArray<Advisor>>;
  /**
   * Whether Organization Branding is available to this organization. Null defers
   * to the legacy advisorGroupBranding LaunchDarkly gate.
   */
  readonly brandingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this organization shows advisory fees to its clients in the client
   * portal transactions view (line items, the advisory-fees total, and the
   * advisory-fee filter option). Defaults to false.
   * @deprecated Use clientPreferences.advisoryFeesEnabled
   */
  readonly clientAdvisoryFeesEnabled: Scalars['Boolean']['output'];
  /**
   * Whether this organization shows its clients the benchmark comparison on the
   * client portal. Null means nobody in the firm has chosen — read
   * clientBenchmarkComparisonVisible for the resolved answer rather than treating null as off.
   * @deprecated Use clientPreferences.benchmarkComparisonEnabled
   */
  readonly clientBenchmarkComparisonEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The resolved answer to whether this organization's clients see the benchmark
   * comparison: the firm's own choice when it has made one, otherwise the default.
   * This is the value the client portal gate reads.
   * @deprecated Use clientPreferences.benchmarkComparisonVisible
   */
  readonly clientBenchmarkComparisonVisible: Scalars['Boolean']['output'];
  readonly clientHouseholds?: Maybe<ReadonlyArray<Household>>;
  /** Firm-wide settings that control what this organization's clients see in the client portal. */
  readonly clientPreferences: OrganizationClientPreferences;
  readonly householdTags?: Maybe<ReadonlyArray<HouseholdTag>>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly organizationBranding?: Maybe<OrganizationBranding>;
  readonly organizationHouseholdCategories?: Maybe<ReadonlyArray<OrganizationHouseholdCategory>>;
  readonly organizationHouseholdTags?: Maybe<ReadonlyArray<OrganizationHouseholdTag>>;
  /** Whether completing a client's task emails the account holders */
  readonly sendEmailWhenTaskCompleted: Scalars['Boolean']['output'];
  /** Ops paperwork reminder shown to CSAs on completed client-services tasks for this organization */
  readonly taskInstructionsForOps?: Maybe<Scalars['String']['output']>;
  readonly users?: Maybe<ReadonlyArray<User>>;
};

/** Organization Branding information */
export type OrganizationBranding = {
  readonly __typename?: 'OrganizationBranding';
  /** Hex accent color for report dividers, section headers, and rule lines */
  readonly accentColor?: Maybe<Scalars['String']['output']>;
  /** When the branding was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Custom intro for onboarding emails */
  readonly customOnboardingEmailIntro?: Maybe<Scalars['String']['output']>;
  /** Compliance/disclosure text appended to generated report footers */
  readonly disclosureText?: Maybe<Scalars['String']['output']>;
  /** Display name for the organization */
  readonly displayName?: Maybe<Scalars['String']['output']>;
  /** Email for the organization */
  readonly email?: Maybe<Scalars['String']['output']>;
  /** Curated font family applied across generated advisor reports */
  readonly fontFamily?: Maybe<ReportFontFamilyEnum>;
  /** Font size scale preset applied across generated advisor reports and proposals */
  readonly fontSizeScale: ReportFontSizeScaleEnum;
  /** The ID of the organization branding */
  readonly id: Scalars['ID']['output'];
  /** URL of the logo image */
  readonly logoUrl?: Maybe<Scalars['String']['output']>;
  /** The associated organization */
  readonly organization: Organization;
  /** The ID of the associated organization */
  readonly organizationId: Scalars['ID']['output'];
  /** Phone number for the organization */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The From address client emails actually send from, when the organization is provisioned to send as itself. Read-only. */
  readonly sendingFromEmail?: Maybe<Scalars['String']['output']>;
  /** Short display name for the organization */
  readonly shortDisplayName?: Maybe<Scalars['String']['output']>;
  /** Whether to show Calendly link in emails */
  readonly showCalendlyLinkInEmails?: Maybe<Scalars['Boolean']['output']>;
  /** When the branding was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The organization's own authenticated email sending domain. Read-only; null means mail sends on Savvy's shared domain. */
  readonly verifiedSendingDomain?: Maybe<Scalars['String']['output']>;
};

export type OrganizationBrandingInput = {
  /** Hex accent color for report dividers, section headers, and rule lines */
  readonly accentColor?: InputMaybe<Scalars['String']['input']>;
  /** Custom intro onboarding emails */
  readonly customOnboardingEmailIntro?: InputMaybe<Scalars['String']['input']>;
  /** Compliance/disclosure text appended to generated report footers */
  readonly disclosureText?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the organization */
  readonly displayName?: InputMaybe<Scalars['String']['input']>;
  /** Curated font family applied across generated advisor reports */
  readonly fontFamily?: InputMaybe<ReportFontFamilyEnum>;
  /** Font size scale preset applied across generated advisor reports and proposals */
  readonly fontSizeScale?: InputMaybe<ReportFontSizeScaleEnum>;
  /** Base64 encoded logo image for Cloudinary upload */
  readonly logoBase64?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization */
  readonly organizationId: Scalars['ID']['input'];
  /** Short display name for the organization */
  readonly shortDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Whether to delete the logo */
  readonly shouldDeleteLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether client emails include a 'Schedule a call' link to the advisor's Calendly */
  readonly showCalendlyLinkInEmails?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Firm-wide settings that control what this organization's clients see in the
 * client portal. Resolved from organization_client_preferences when a row exists
 * and agrees with the legacy organizations columns; when the row is missing or a
 * mirrored boolean disagrees, the column wins.
 */
export type OrganizationClientPreferences = {
  readonly __typename?: 'OrganizationClientPreferences';
  /** Whether this organization shows advisory fees to its clients in the client portal transactions view. Defaults to false. */
  readonly advisoryFeesEnabled: Scalars['Boolean']['output'];
  /**
   * Whether this organization orders the client-portal allocation by asset-class
   * ratio (equities first, then fixed income, alternatives, and cash) rather than
   * largest holding first. Defaults to false.
   */
  readonly allocationSortByRatioEnabled: Scalars['Boolean']['output'];
  /**
   * Whether this organization shows its clients the benchmark comparison. Null
   * means nobody in the firm has chosen — read benchmarkComparisonVisible for the
   * resolved answer rather than treating null as off.
   */
  readonly benchmarkComparisonEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Orion product key this organization has chosen for the client-facing benchmark
   * comparison. Null means nobody in the firm has chosen — read
   * benchmarkComparisonProductKeyInUse for the key the portal actually uses. When
   * the firm has chosen a list, this is the first key.
   */
  readonly benchmarkComparisonProductKey?: Maybe<Scalars['String']['output']>;
  /**
   * The Orion product key the client portal compares against for this
   * organization: the firm's own first choice when it has made one, otherwise the
   * central default. This is the value the portal fetch and the settings picker
   * read for a single-index client.
   */
  readonly benchmarkComparisonProductKeyInUse: Scalars['String']['output'];
  /**
   * Ordered Orion product keys this organization has chosen for client-facing
   * benchmark comparisons. Empty means nobody in the firm has chosen — read
   * benchmarkComparisonProductKeysInUse for the keys the portal actually uses.
   */
  readonly benchmarkComparisonProductKeys: ReadonlyArray<Scalars['String']['output']>;
  /**
   * The ordered Orion product keys the client portal compares against for this
   * organization: the firm's own choices when it has made them, otherwise a
   * one-element list with the central default. This is the value the portal fetch
   * and the settings picker read.
   */
  readonly benchmarkComparisonProductKeysInUse: ReadonlyArray<Scalars['String']['output']>;
  /**
   * The resolved answer to whether this organization's clients see the benchmark
   * comparison: the firm's own choice when it has made one, otherwise the default.
   * This is the value the client portal gate reads.
   */
  readonly benchmarkComparisonVisible: Scalars['Boolean']['output'];
  /**
   * Whether this organization's clients see positions they closed, with their
   * return for the selected range, in client-portal Positions. Defaults to true.
   */
  readonly closedPositionsVisible: Scalars['Boolean']['output'];
  /**
   * Optional client-portal nav surfaces this organization has hidden from its
   * clients. Empty means every optional surface is shown (the default). Hiding is opt-in.
   */
  readonly hiddenPortalSurfaces: ReadonlyArray<ClientPortalHideableSurface>;
};

export type OrganizationClientPreferencesInput = {
  /**
   * Whether this organization's clients see advisory fees in the client portal
   * transactions view. Omit to leave the firm's existing choice untouched.
   */
  readonly advisoryFeesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether this organization orders the client-portal allocation by asset-class
   * ratio (equities, then fixed income, alternatives, and cash) rather than
   * largest holding first. Omit to leave the firm's existing choice untouched.
   */
  readonly allocationSortByRatioEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether this organization's clients see the benchmark comparison on the client
   * portal. Omit to leave the firm's existing choice untouched.
   */
  readonly benchmarkComparisonEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Orion product key (`*_P`) this organization's clients are compared against.
   * Must be one of the allowlisted indices from the report-builder catalog. Omit
   * to leave the firm's existing choice untouched. Does not turn the comparison
   * on. Do not also pass benchmarkComparisonProductKeys.
   */
  readonly benchmarkComparisonProductKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * Ordered Orion product keys (`*_P`) this organization's clients are compared
   * against, up to three. Must each be one of the allowlisted indices from the
   * report-builder catalog. Pass an empty list to clear the firm's choice (clients
   * fall back to the default index). Omit to leave the firm's existing set
   * untouched. Does not turn the comparison on. Do not also pass
   * benchmarkComparisonProductKey.
   */
  readonly benchmarkComparisonProductKeys?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /**
   * Whether this organization's clients see positions they closed in client-portal
   * Positions. Omit to leave the firm's existing choice untouched.
   */
  readonly closedPositionsVisible?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional client-portal nav surfaces to hide from this organization's clients.
   * Pass an empty list to show every optional surface again. Omit to leave the
   * list untouched.
   */
  readonly hiddenPortalSurfaces?: InputMaybe<ReadonlyArray<ClientPortalHideableSurface>>;
};

/** The connection type for Organization. */
export type OrganizationConnection = {
  readonly __typename?: 'OrganizationConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<OrganizationEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationEdge = {
  readonly __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Organization>;
};

export type OrganizationHouseholdCategory = {
  readonly __typename?: 'OrganizationHouseholdCategory';
  readonly emoji?: Maybe<Scalars['String']['output']>;
  readonly hexColorCode?: Maybe<Scalars['String']['output']>;
  readonly householdTags?: Maybe<ReadonlyArray<HouseholdTag>>;
  readonly households?: Maybe<ReadonlyArray<Household>>;
  readonly householdsCount?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly organizationHouseholdTags?: Maybe<ReadonlyArray<OrganizationHouseholdTag>>;
};

/** Input for updating an organization household category in a bulk operation */
export type OrganizationHouseholdCategoryUpdateInput = {
  /** The ID of the category to update */
  readonly id: Scalars['ID']['input'];
  /** The new name for the category */
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationHouseholdTag = {
  readonly __typename?: 'OrganizationHouseholdTag';
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly householdCount: Scalars['Int']['output'];
  readonly householdTags?: Maybe<ReadonlyArray<HouseholdTag>>;
  readonly households?: Maybe<ReadonlyArray<Household>>;
  readonly id: Scalars['ID']['output'];
  readonly isSmart: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly organization: Organization;
  readonly organizationHouseholdCategory: OrganizationHouseholdCategory;
  readonly ruleJson?: Maybe<Scalars['JSON']['output']>;
};

export type OrganizationSettingsInput = {
  /** Whether the Organization Branding feature is available to this organization */
  readonly brandingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether this organization's clients see advisory fees in the client portal
   * transactions view. Omit to leave the firm's existing choice untouched.
   * @deprecated Use clientPreferences.advisoryFeesEnabled
   */
  readonly clientAdvisoryFeesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether this organization's clients see the benchmark comparison on the client
   * portal. Omit to leave the firm's existing choice untouched.
   * @deprecated Use clientPreferences.benchmarkComparisonEnabled
   */
  readonly clientBenchmarkComparisonEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Firm-wide client-portal visibility settings. Omitted keys are left unchanged.
   * Do not also pass the deprecated top-level clientBenchmarkComparisonEnabled or
   * clientAdvisoryFeesEnabled for the same key.
   */
  readonly clientPreferences?: InputMaybe<OrganizationClientPreferencesInput>;
  /** Whether completing a client's task emails the account holders, across the whole organization */
  readonly sendEmailWhenTaskCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Original email addresses for each participant role in an email message */
export type OriginalEmailAddresses = {
  readonly __typename?: 'OriginalEmailAddresses';
  /** The original BCC email address */
  readonly bcc?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The original CC email address */
  readonly cc?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The original sender email address */
  readonly from?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The original reply-to email address */
  readonly replyTo?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The original recipient email address */
  readonly to?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

/** Orion reports that can be generated ad-hoc in the Generate Orion Report mutation */
export type OrionAdHocReport = {
  readonly __typename?: 'OrionAdHocReport';
  /** The description of the report */
  readonly desc: Scalars['String']['output'];
  /** The ID of the report */
  readonly id: Scalars['String']['output'];
  /** The name of the report */
  readonly name: Scalars['String']['output'];
  /** The slug of the report */
  readonly slug: Scalars['String']['output'];
};

/** How many accounts Orion bills on one fee schedule */
export type OrionBillingScheduleUsage = {
  readonly __typename?: 'OrionBillingScheduleUsage';
  /** Accounts Orion bills on this schedule */
  readonly accountCount: Scalars['Int']['output'];
  /** Households with at least one account on this schedule */
  readonly householdCount: Scalars['Int']['output'];
  /** The Orion fee schedule name. Null groups the accounts Orion has no schedule for. */
  readonly name?: Maybe<Scalars['String']['output']>;
};

/** Read-only Orion Eclipse per-account diagnostic for a household, for grounding trading support handoffs. */
export type OrionEclipseAccountDiagnostic = {
  readonly __typename?: 'OrionEclipseAccountDiagnostic';
  /** Live Eclipse state for each Eclipse-linked account on the household. Empty unless read_status is ok. */
  readonly accounts: ReadonlyArray<OrionEclipseAccountInfo>;
  /** ok, no_eclipse_accounts, or orion_unreachable. Branch on this before reading accounts. */
  readonly readStatus: Scalars['String']['output'];
};

/** One Eclipse-linked account's live Orion Eclipse cash and portfolio state. */
export type OrionEclipseAccountInfo = {
  readonly __typename?: 'OrionEclipseAccountInfo';
  /** Cash available on the account per Orion Eclipse. */
  readonly cashAvailable?: Maybe<Scalars['Float']['output']>;
  /** Free (unencumbered) cash available per Orion Eclipse. */
  readonly freeCashAvailable?: Maybe<Scalars['Float']['output']>;
  /** The account id from Orion Eclipse. */
  readonly orionCustodialAccountId: Scalars['String']['output'];
  /** The Orion Eclipse portfolio id the account belongs to. */
  readonly portfolioId?: Maybe<Scalars['Int']['output']>;
  /** The Savvy account primary key. */
  readonly savvyAccountId: Scalars['Int']['output'];
};

/**
 * A read-only comparison of Orion vs Savvy-stored data for a household. Covers id
 * resolution, client name, and account counts only — never values, holdings,
 * performance, or strategy. Never a claim that Orion and Savvy fully agree.
 */
export type OrionHouseholdDiagnostic = {
  readonly __typename?: 'OrionHouseholdDiagnostic';
  /** Whether Orion and Savvy account counts are equal */
  readonly accountCountsAgree?: Maybe<Scalars['Boolean']['output']>;
  /** Whether another household or portfolio claims the stored Orion id */
  readonly candidateClaimedByAnotherHousehold?: Maybe<Scalars['Boolean']['output']>;
  /** The household personal portfolio's missing_from_orion flag */
  readonly missingFromOrion?: Maybe<Scalars['Boolean']['output']>;
  /** Number of accounts Orion returns for the household */
  readonly orionAccountCount?: Maybe<Scalars['Int']['output']>;
  /** Client name Orion returns for the stored id */
  readonly orionClientName?: Maybe<Scalars['String']['output']>;
  /** Whether the Orion client name matches the household by last-name token */
  readonly orionClientNameMatchesHousehold?: Maybe<Scalars['Boolean']['output']>;
  /** The Orion household id stored on the household (raw column) */
  readonly orionHouseholdIdOnFile?: Maybe<Scalars['Int']['output']>;
  /** Whether the stored Orion id resolves in Orion */
  readonly orionIdResolves?: Maybe<Scalars['Boolean']['output']>;
  /** Load-bearing status: ok, no_orion_link, not_found_in_orion, mock_orion_id_configured, or orion_unreachable */
  readonly readStatus: Scalars['String']['output'];
  /** Machine-readable next step: none, resync_recommended, or orion_side_action */
  readonly remediation: Scalars['String']['output'];
  /** Number of ORION-source accounts Savvy has stored for the household */
  readonly savvyAccountCount: Scalars['Int']['output'];
  /** as_of_date of the newest Orion performance snapshot Savvy holds */
  readonly savvyLastSnapshotAt?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Orion Portfolio Document */
export type OrionPortfolioDocument = {
  readonly __typename?: 'OrionPortfolioDocument';
  /** The category of the document */
  readonly category: Scalars['String']['output'];
  /** The description of the document */
  readonly description: Scalars['String']['output'];
  /** The URL to download the document */
  readonly downloadUrl: Scalars['String']['output'];
  /** The user who edited the document */
  readonly editedBy: Scalars['String']['output'];
  /** The date the document was edited */
  readonly editedDate: Scalars['String']['output'];
  /** The ID of the document */
  readonly id: Scalars['String']['output'];
  /** Whether the document was generated by the system */
  readonly systemGenerated: Scalars['Boolean']['output'];
};

/** Orion quarterly reports available for generation in the current environment */
export type OrionQuarterlyReport = {
  readonly __typename?: 'OrionQuarterlyReport';
  /** Optional description of the report type */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The Orion report ID for this report type in the current environment */
  readonly id: Scalars['String']['output'];
  /** Human-readable name for the report type */
  readonly name: Scalars['String']['output'];
  /** The slug/type of the quarterly report (e.g., performance-simplified) */
  readonly slug: Scalars['String']['output'];
};

/** Orion quarterly report generation record tracking the status of report generation. */
export type OrionQuarterlyReportGeneration = {
  readonly __typename?: 'OrionQuarterlyReportGeneration';
  /** Box file ID of the uploaded report if successful. */
  readonly boxFileId?: Maybe<Scalars['String']['output']>;
  /** When the report generation completed (or failed). */
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When this record was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Error message if the report generation failed. */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** Name of the generated file if successful. */
  readonly fileName?: Maybe<Scalars['String']['output']>;
  /** The ID of the household this report is for. */
  readonly householdId: Scalars['ID']['output'];
  /** The ID of the report generation record. */
  readonly id: Scalars['ID']['output'];
  /** The type of report (e.g., performance-detailed, performance-simplified). */
  readonly reportType: Scalars['String']['output'];
  /** When the report generation started. */
  readonly startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The current status of the report generation (pending, processing, completed, failed). */
  readonly status: Scalars['String']['output'];
  /** When this record was last updated. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Orion report types that households can be enrolled in */
export const OrionReport = {
  /** custodial1099 */
  Custodial1099: 'custodial1099',
  /** custom_indexing_report */
  CustomIndexingReport: 'custom_indexing_report',
  /** income_reports */
  IncomeReports: 'income_reports',
  /** invoices */
  Invoices: 'invoices',
  /** performance_report_allocations */
  PerformanceReportAllocations: 'performance_report_allocations',
  /** performance_report_consolidated */
  PerformanceReportConsolidated: 'performance_report_consolidated',
  /** performance_report_integrated */
  PerformanceReportIntegrated: 'performance_report_integrated',
  /** performance_report_sectors */
  PerformanceReportSectors: 'performance_report_sectors',
  /** performance_report_unified */
  PerformanceReportUnified: 'performance_report_unified',
  /** portfolio_review_portfolio_group */
  PortfolioReviewPortfolioGroup: 'portfolio_review_portfolio_group',
  /** portfolio_summary_cash_flows */
  PortfolioSummaryCashFlows: 'portfolio_summary_cash_flows',
  /** portfolio_summary_comprehensive */
  PortfolioSummaryComprehensive: 'portfolio_summary_comprehensive',
  /** quarterly_reports_long */
  QuarterlyReportsLong: 'quarterly_reports_long',
  /** quarterly_reports_short */
  QuarterlyReportsShort: 'quarterly_reports_short'
} as const;

export type OrionReport = typeof OrionReport[keyof typeof OrionReport];
/** Orion report generation record tracking the status of report generation. */
export type OrionReportGeneration = {
  readonly __typename?: 'OrionReportGeneration';
  /** When the report generation completed (or failed). */
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When this record was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** URL to download the generated PDF report. */
  readonly downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Error message if the report generation failed. */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** The ID of the report generation record. */
  readonly id: Scalars['ID']['output'];
  /** The current status of the report generation (pending, processing, completed, failed). */
  readonly status: Scalars['String']['output'];
};

/** Orion Report Template */
export type OrionReportTemplate = {
  readonly __typename?: 'OrionReportTemplate';
  /** Category of the report */
  readonly category: Scalars['String']['output'];
  /** Defaults type of the report template */
  readonly defaultsType?: Maybe<Scalars['String']['output']>;
  /** Disclaimer text for the report template */
  readonly disclaimer?: Maybe<Scalars['String']['output']>;
  /** Entities applicable */
  readonly entities?: Maybe<Scalars['String']['output']>;
  /** Whether the template has entity defaults */
  readonly hasEntityDefaults?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the template has report defaults */
  readonly hasReportDefaults?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the template supports storable parameters */
  readonly hasStorableParameters?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the template has user defaults */
  readonly hasUserDefaults?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the report template */
  readonly id: Scalars['String']['output'];
  /** Last run date of the report */
  readonly lastRunDate?: Maybe<Scalars['String']['output']>;
  /** Layout type of the report template */
  readonly layoutType?: Maybe<Scalars['String']['output']>;
  /** Parent category of the report */
  readonly parentCategory: Scalars['String']['output'];
  /** Description of the report */
  readonly reportDescription: Scalars['String']['output'];
  /** Name of the report */
  readonly reportName: Scalars['String']['output'];
  /** Whether to run assigned version */
  readonly runAssignedVersion?: Maybe<Scalars['Boolean']['output']>;
  /** Run to target */
  readonly runTo?: Maybe<Scalars['String']['output']>;
  /** Whether to show internal only warning */
  readonly showInternalOnlyWarning?: Maybe<Scalars['Boolean']['output']>;
  /** Storable parameters definition */
  readonly storable?: Maybe<Scalars['String']['output']>;
  /** Unstorable parameters definition */
  readonly unstorable?: Maybe<Scalars['String']['output']>;
};

/** Product search data from Orion Eclipse */
export type OrionSearch = {
  readonly __typename?: 'OrionSearch';
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly price: Scalars['Float']['output'];
  readonly ticker: Scalars['String']['output'];
};

/** Security data from Orion Eclipse */
export type OrionSecurity = {
  readonly __typename?: 'OrionSecurity';
  readonly id: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly price: Scalars['Float']['output'];
  readonly ticker: Scalars['String']['output'];
};

/** Orion data sync status for a user */
export type OrionSyncStatus = {
  readonly __typename?: 'OrionSyncStatus';
  /** When the sync completed */
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the sync was started */
  readonly startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current sync status: idle, pending, or complete */
  readonly status: Scalars['String']['output'];
};

/** An Orion Eclipse trade-order error code paired with its human-readable message template. */
export type OrionTradeOrderMessage = {
  readonly __typename?: 'OrionTradeOrderMessage';
  /** The trade-order error code as a string, e.g. "94". */
  readonly id: Scalars['String']['output'];
  /**
   * The message template. May contain {0}/{1} placeholder tokens filled from the
   * error arguments; Orion's text may prefix a token with a literal $ (e.g.
   * "...negative ${0}.").
   */
  readonly message: Scalars['String']['output'];
};

/** Input for other-investment task specific data */
export type OtherInvestmentTaskInput = {
  /** Managed accounts this task applies to */
  readonly accountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** What the investment ops team needs to do */
  readonly taskType: OtherInvestmentTaskTypeName;
};

/** Structured data for an other-investment task */
export type OtherInvestmentTaskRequest = {
  readonly __typename?: 'OtherInvestmentTaskRequest';
  /** The Savvy ID of the request. */
  readonly id: Scalars['ID']['output'];
  /** Managed accounts this task applies to. */
  readonly requestAccounts: ReadonlyArray<OtherInvestmentTaskRequestAccount>;
  /** What the investment ops team needs to do. */
  readonly taskType: OtherInvestmentTaskTypeName;
};

/** An account linked to an other-investment task request */
export type OtherInvestmentTaskRequestAccount = {
  readonly __typename?: 'OtherInvestmentTaskRequestAccount';
  /** The associated account. */
  readonly account: Account;
  /** The Savvy ID of the join record. */
  readonly id: Scalars['ID']['output'];
};

/** The variant of an other-investment task request */
export const OtherInvestmentTaskTypeName = {
  /** invest_cash */
  InvestCash: 'invest_cash',
  /** other */
  Other: 'other',
  /** raise_cash */
  RaiseCash: 'raise_cash',
  /** rebalance_account */
  RebalanceAccount: 'rebalance_account'
} as const;

export type OtherInvestmentTaskTypeName = typeof OtherInvestmentTaskTypeName[keyof typeof OtherInvestmentTaskTypeName];
export type PageImpression = {
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageViewDuration = {
  /** The duration of the page view in milliseconds */
  readonly duration: Scalars['Int']['input'];
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

/** A participant in a calendar event, identified by email address */
export type Participant = {
  readonly __typename?: 'Participant';
  /** Timestamp when the participant was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The email address of the participant. */
  readonly email: Scalars['String']['output'];
  /** The Savvy ID of the participant. */
  readonly id: Scalars['ID']['output'];
  /** The name of the participant. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the participant was last updated. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/**
 * Per-account block of the report (mirrors the household-level Composition,
 * Activity Summary, and Market Value chart, scoped to one account).
 */
export type PerAccountSection = {
  readonly __typename?: 'PerAccountSection';
  /** Savvy account ID this block describes. */
  readonly accountId: Scalars['ID']['output'];
  /** Display name for the account, shown as the section header. */
  readonly accountName: Scalars['String']['output'];
  /** Activity Summary rows (MTD, QTD, YTD, Inception) scoped to this account. */
  readonly activitySummaryRows: ReadonlyArray<ActivitySummaryRow>;
  /** Daily points for the per-account 'Invested Value Comparison' chart, filtered to the report date range. */
  readonly marketValueSeries: ReadonlyArray<MarketValuePoint>;
  /** Asset-category pie slices for this account (sums to 100%). */
  readonly portfolioAllocation: ReadonlyArray<AllocationSlice>;
};

/** Performance of a particular entity over a specified amount of time. */
export type Performance = {
  readonly __typename?: 'Performance';
  /** Total contributions during this time period. */
  readonly contributions?: Maybe<Scalars['BigDecimal']['output']>;
  /** Total distributions during this time period. */
  readonly distributions?: Maybe<Scalars['BigDecimal']['output']>;
  readonly endDate: Scalars['ISO8601Date']['output'];
  readonly endPrice?: Maybe<Scalars['BigDecimal']['output']>;
  readonly endUnits?: Maybe<Scalars['BigDecimal']['output']>;
  readonly endValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Internal rate of return */
  readonly irr?: Maybe<Scalars['BigDecimal']['output']>;
  /** Total merge-in transfers during this time period. */
  readonly mergeIn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Total merge-out transfers during this time period. */
  readonly mergeOut?: Maybe<Scalars['BigDecimal']['output']>;
  /** Percent allocation of total portfolio value at the end of the time period. */
  readonly percent?: Maybe<Scalars['BigDecimal']['output']>;
  /** Realized gain/loss during this time period. */
  readonly realizedGainLoss?: Maybe<Scalars['BigDecimal']['output']>;
  /** Long-term realized gain/loss during this time period. */
  readonly realizedGainLossLongTerm?: Maybe<Scalars['BigDecimal']['output']>;
  /** Short-term realized gain/loss during this time period. */
  readonly realizedGainLossShortTerm?: Maybe<Scalars['BigDecimal']['output']>;
  readonly startDate: Scalars['ISO8601Date']['output'];
  readonly startValue?: Maybe<Scalars['BigDecimal']['output']>;
  readonly timePeriod?: Maybe<PerformanceTimePeriodName>;
  /** Time weighted rate of return */
  readonly twr?: Maybe<Scalars['BigDecimal']['output']>;
  readonly usdReturn?: Maybe<Scalars['BigDecimal']['output']>;
};

/**
 * Native rebuild of the Orion "Performance by Account" PDF. Provides all data
 * needed to render the three-page report: cover page (accounts list), Activity
 * Summary (per-account time-weighted returns across the date range / QTD / YTD /
 * Since Inception, plus a household total row), and Appendix – Summary of Accounts
 * (Relationship Summary by Account Type). Replaces the Orion path when
 * feature-flagged on (HAWK-77).
 */
export type PerformanceByAccount = {
  readonly __typename?: 'PerformanceByAccount';
  /** Activity Summary: one per-account time-weighted-return row, sorted by account name. */
  readonly accountRows: ReadonlyArray<PerformanceByAccountRow>;
  /** Per-account rows for the Appendix – Summary of Accounts page (name, type, masked number, management style, market value). */
  readonly accountSummaries: ReadonlyArray<AccountEntry>;
  /** Primary advisor's display name shown on the cover. */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /** Accounts listed on the cover page (name + masked number, sorted by account name). */
  readonly coverAccounts: ReadonlyArray<AccountEntry>;
  /** When the underlying performance snapshot was last refreshed. */
  readonly dataLastUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User-selected end date (as-of date for QTD / YTD / Since Inception). */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Branded firm name. Falls back to "Savvy" when the household's advisor has no organization branding. */
  readonly firmDisplayName: Scalars['String']['output'];
  /** Branded firm logo URL. Falls back to the Savvy logo when no organization branding is set. */
  readonly firmLogoUrl: Scalars['String']['output'];
  /** Household display name shown on the cover and page headers. */
  readonly householdName: Scalars['String']['output'];
  /** Activity Summary household total row (bold), with is_household: true. */
  readonly householdReturn: PerformanceByAccountRow;
  /** Stable identifier for this report scope (household + date range). */
  readonly id: Scalars['ID']['output'];
  /** Earliest funded date across all accounts; labels the 'Since' Activity Summary column. Null when unknown. */
  readonly inceptionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** User-selected start date (first column of the Activity Summary). */
  readonly startDate: Scalars['ISO8601Date']['output'];
};

/**
 * A row in the 'Activity Summary' table — one account, or the bold household total
 * row. Each row carries the four time-weighted-return columns: the user-selected
 * date range, Quarter to Date, Year to Date, and Since Inception. The household
 * total row sets is_household: true with a null account_id / masked_number.
 */
export type PerformanceByAccountRow = {
  readonly __typename?: 'PerformanceByAccountRow';
  /** Internal Savvy account ID. Null on the household total row. */
  readonly accountId?: Maybe<Scalars['ID']['output']>;
  /** True for the household total row; false for per-account rows. */
  readonly isHousehold: Scalars['Boolean']['output'];
  /** Masked account number (XXX-XX####). Null on the household total row. */
  readonly maskedNumber?: Maybe<Scalars['String']['output']>;
  /** Account display name, or the household name on the total row. */
  readonly name: Scalars['String']['output'];
  /** Time-weighted return over the user-selected date range (fraction, e.g. 0.012 = 1.2%). */
  readonly periodReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Quarter-to-date time-weighted return (fraction). */
  readonly qtdReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Since-inception (all-time) time-weighted return (fraction). */
  readonly sinceInceptionReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date time-weighted return (fraction). */
  readonly ytdReturn?: Maybe<Scalars['BigDecimal']['output']>;
};

/**
 * Native rebuild of the Orion "Performance Report – Allocations". Provides the
 * full data payload for the multi-page PDF over a user-selected date range.
 * Sections: cover, relationship summary, activity summary, MV chart, allocation
 * pies, portfolio performance by asset class, holdings report, transactions, and
 * appendix. Replaces the Orion path when feature-flagged on.
 */
export type PerformanceReportAllocations = {
  readonly __typename?: 'PerformanceReportAllocations';
  /** Accounts included in the report (relationship summary). */
  readonly accounts: ReadonlyArray<PerformanceReportAllocationsAccountSummaryRow>;
  /** Activity summary rows — QTD, YTD, and Inception periods. */
  readonly activitySummary: ReadonlyArray<ActivitySummaryRow>;
  /** Primary advisor's display name. */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /** Slices of the Asset Category pie (Equity / Fixed Income / Cash / Alternatives). */
  readonly allocationByCategory: ReadonlyArray<AllocationSlice>;
  /** Slices of the Asset Class pie (US Equity / Intl Developed / Cash / …). */
  readonly allocationByClass: ReadonlyArray<AllocationSlice>;
  /** Per-day per-asset-class allocation time series derived from Orion PortfolioDaily factors. */
  readonly allocationOverTime: ReadonlyArray<PerformanceReportAllocationsAllocationOverTimePoint>;
  /** Portfolio performance by asset class with TWR, yield, projected income, and benchmarks. */
  readonly assetClassPerformance: ReadonlyArray<PerformanceReportAllocationsAssetClassPerformanceRow>;
  /** When the underlying snapshot was last refreshed. */
  readonly dataLastUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User-selected end of the report period. */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Branded firm name; falls back to "Savvy". */
  readonly firmDisplayName: Scalars['String']['output'];
  /** Branded firm logo URL; falls back to the Savvy logo. */
  readonly firmLogoUrl: Scalars['String']['output'];
  /** Per-holding rows for the Holdings Report, grouped by asset class on the frontend. */
  readonly holdings: ReadonlyArray<HoldingsSummaryRow>;
  /** Household display name. */
  readonly householdName: Scalars['String']['output'];
  /** Stable identifier for this report scope (household + date range). */
  readonly id: Scalars['ID']['output'];
  /** Earliest funded date across the household's accounts. */
  readonly inceptionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Daily portfolio-level market value + net invested from inception through end_date. */
  readonly marketValueSeries: ReadonlyArray<MarketValuePoint>;
  /** Holdings grouped per account (one Orion "Holdings Report (Managed)" block per account). */
  readonly perAccountSections: ReadonlyArray<PerformanceReportIntegratedPerAccountHoldingsSection>;
  /** Beginning of quarter for end_date (QTD period start). */
  readonly quarterStartDate: Scalars['ISO8601Date']['output'];
  /** Market-value summary for the user-selected date range (first activity-summary column). */
  readonly selectedPeriodSummary?: Maybe<PerformanceReportAllocationsSelectedPeriodSummary>;
  /** User-selected start of the report period. */
  readonly startDate: Scalars['ISO8601Date']['output'];
  /** Taxable income line items (dividends, interest) for YTD and since-inception; taxable accounts only. */
  readonly taxableIncomeSummary?: Maybe<PerformanceReportAllocationsTaxableIncomeSummary>;
  /** Realized short/long-term gain & loss for YTD and since-inception; taxable accounts only. */
  readonly taxableRealizedGainLoss?: Maybe<PerformanceReportAllocationsTaxableRealizedGainLoss>;
  /** Purchases, sales, and advisory fees within the selected date range. */
  readonly transactions: ReadonlyArray<PerformanceReportAllocationsTransactionRow>;
  /** Jan 1 of end_date year (YTD period start). */
  readonly yearStartDate: Scalars['ISO8601Date']['output'];
};

/** One account row in the Relationship Summary section. */
export type PerformanceReportAllocationsAccountSummaryRow = {
  readonly __typename?: 'PerformanceReportAllocationsAccountSummaryRow';
  /** Savvy account ID. */
  readonly accountId: Scalars['ID']['output'];
  /** Display name of the account. */
  readonly accountName: Scalars['String']['output'];
  /** Masked account number (e.g. "XXX-XX4792"). */
  readonly accountNumberMasked?: Maybe<Scalars['String']['output']>;
  /** Display account type (e.g. "Roth IRA"); null for Orion accounts without a Savvy enum. */
  readonly accountType?: Maybe<Scalars['String']['output']>;
  /** Custodian name. */
  readonly custodian?: Maybe<Scalars['String']['output']>;
  /** Appendix grouping: "Managed" (Orion-tracked) or "Unmanaged". */
  readonly managementStyle: Scalars['String']['output'];
  /** Ending market value in USD; null until per-account snapshots land. */
  readonly marketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * Tax-treatment bucket for the Relationship Summary: "Taxable Accounts",
   * "Retirement Accounts - Tax Deferred", or "Retirement Accounts - Tax Exempt".
   */
  readonly taxCategory: Scalars['String']['output'];
};

/** Per-asset-class allocation snapshot for one day (stacked area chart data). */
export type PerformanceReportAllocationsAllocationOverTimePoint = {
  readonly __typename?: 'PerformanceReportAllocationsAllocationOverTimePoint';
  /** Date of this snapshot. */
  readonly date: Scalars['ISO8601Date']['output'];
  /**
   * Per-asset-class slice. percent = fraction (0.55 = 55%), value =
   * back-calculated MV in USD. NOTE: back-calculation uses the TWR factor chain
   * and does not account for intra-period cash flows — the allocation percentages
   * are approximations when positions were significantly changed mid-period.
   */
  readonly slices: ReadonlyArray<AllocationSlice>;
};

/** Per-asset-class performance row with TWR, yield, projected income, and benchmark comparison. */
export type PerformanceReportAllocationsAssetClassPerformanceRow = {
  readonly __typename?: 'PerformanceReportAllocationsAssetClassPerformanceRow';
  /** Portfolio allocation as a fraction (0.55 = 55%). */
  readonly allocation?: Maybe<Scalars['BigDecimal']['output']>;
  /** Asset class name (e.g. "US Equity"), category name, or household name. */
  readonly assetClass: Scalars['String']['output'];
  /** Since-inception TWR for the benchmark as a fraction. */
  readonly benchmarkInceptionReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Display name of the firm-configured benchmark; null when none. */
  readonly benchmarkName?: Maybe<Scalars['String']['output']>;
  /** QTD TWR for the benchmark as a fraction. */
  readonly benchmarkQtdReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** YTD TWR for the benchmark as a fraction. */
  readonly benchmarkYtdReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Ending market value in USD. */
  readonly endingValue: Scalars['BigDecimal']['output'];
  /** Since-inception TWR as a fraction. */
  readonly inceptionReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Hierarchy level: "household", "category", or "class" (drives indentation + bolding). */
  readonly level: Scalars['String']['output'];
  /** Estimated annual income in USD. */
  readonly projectedIncome?: Maybe<Scalars['BigDecimal']['output']>;
  /** Quarter-to-date TWR as a fraction. */
  readonly qtdReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Earliest funded date for this asset class. */
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Current yield as a fraction (0.022 = 2.2%). */
  readonly yieldPct?: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date TWR as a fraction. */
  readonly ytdReturn?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Market-value summary for the user-selected date range (first activity-summary column). */
export type PerformanceReportAllocationsSelectedPeriodSummary = {
  readonly __typename?: 'PerformanceReportAllocationsSelectedPeriodSummary';
  /** Portfolio market value at start_date. */
  readonly beginningValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive end of the selected range. */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Portfolio market value at end_date. */
  readonly endingValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Net cash flows during the selected range. */
  readonly netAdditions?: Maybe<Scalars['BigDecimal']['output']>;
  /** Market value increase minus net additions. */
  readonly netGains?: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive start of the selected range. */
  readonly startDate: Scalars['ISO8601Date']['output'];
};

/** Taxable income line items for the YTD and since-inception periods. */
export type PerformanceReportAllocationsTaxableIncomeSummary = {
  readonly __typename?: 'PerformanceReportAllocationsTaxableIncomeSummary';
  /** Since-inception column. */
  readonly inception?: Maybe<PerformanceReportIntegratedTaxableIncomeColumn>;
  /** Year-to-date column. */
  readonly ytd?: Maybe<PerformanceReportIntegratedTaxableIncomeColumn>;
};

/** Realized short/long-term gain & loss for the YTD and since-inception periods. */
export type PerformanceReportAllocationsTaxableRealizedGainLoss = {
  readonly __typename?: 'PerformanceReportAllocationsTaxableRealizedGainLoss';
  /** Since-inception column. */
  readonly inception?: Maybe<PerformanceReportIntegratedRealizedGainLossColumn>;
  /** Year-to-date column. */
  readonly ytd?: Maybe<PerformanceReportIntegratedRealizedGainLossColumn>;
};

/** One transaction within the selected date range. */
export type PerformanceReportAllocationsTransactionRow = {
  readonly __typename?: 'PerformanceReportAllocationsTransactionRow';
  /** Masked account number (e.g. "XXX-XX4792"). */
  readonly accountNumberMasked?: Maybe<Scalars['String']['output']>;
  /** Per-unit price in USD; null for fee transactions. */
  readonly price?: Maybe<Scalars['BigDecimal']['output']>;
  /** Security / fund display name. */
  readonly securityName?: Maybe<Scalars['String']['output']>;
  /** Ticker symbol. */
  readonly ticker?: Maybe<Scalars['String']['output']>;
  /** Total transaction amount in USD (negative = outflow). */
  readonly total: Scalars['BigDecimal']['output'];
  /** Date the transaction was executed. */
  readonly transactionDate: Scalars['ISO8601Date']['output'];
  /** "purchase", "sale", or "advisory_fee". */
  readonly transactionType: Scalars['String']['output'];
  /** Number of units transacted; null for fee transactions. */
  readonly units?: Maybe<Scalars['BigDecimal']['output']>;
};

/**
 * Native rebuild of the Orion "Client Portfolio Review Report" (Consolidated).
 * Provides the full data payload needed to render the multi-page PDF — Accounts
 * Included, two Portfolio Valuation Composition pies (Asset Category + Asset
 * Class), QTD/YTD/Inception Activity Summary, Invested Value Comparison chart,
 * Account Performance table, Estimated Income, per-asset-class returns,
 * per-account sub-reports, and the full Portfolio Appraisal holdings table.
 * Replaces the Orion path when feature-flagged on (HAWK-29).
 */
export type PerformanceReportConsolidated = {
  readonly __typename?: 'PerformanceReportConsolidated';
  /** Rows of the 'Account Performance' table — per-account market value plus YTD / Rolling 1-Year / Inception returns. */
  readonly accountPerformance: ReadonlyArray<AccountPerformanceRow>;
  /** Rows of the 'Accounts Included in this Report' table on page 1. */
  readonly accounts: ReadonlyArray<AccountSummaryRow>;
  /** Rows of the 'Activity Summary' table — one per reporting period (QTD, YTD, Inception). */
  readonly activitySummary: ReadonlyArray<ActivitySummaryRow>;
  /** Primary advisor's display name shown on the cover. */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /** Slices of the Asset Category pie (Equity / Cash & Cash Equivalents / …). Sums to 100%. */
  readonly allocationByCategory: ReadonlyArray<AllocationSlice>;
  /** Slices of the Asset Class pie (US Equity / International Developed / Cash / …). Sums to 100%. */
  readonly allocationByClass: ReadonlyArray<AllocationSlice>;
  /**
   * Per-asset-class returns (Ending Value + QTD/YTD/Inception %) rendered as a
   * section between the household summary and per-account blocks.
   */
  readonly assetClassReturns: ReadonlyArray<AssetClassReturn>;
  /** When the underlying performance snapshot was last refreshed. */
  readonly dataLastUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Inclusive end date of the report (the user-selected as-of date). */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Rows of the 'Estimated Income' table — one per asset class plus a derived total handled client-side. */
  readonly estimatedIncome: ReadonlyArray<EstimatedIncomeRow>;
  /** Branded firm name shown on the cover. Falls back to "Savvy" when the household's advisor has no organization branding. */
  readonly firmDisplayName: Scalars['String']['output'];
  /**
   * Branded firm logo URL shown on the cover. Falls back to the Savvy logo when
   * the household's advisor has no organization branding.
   */
  readonly firmLogoUrl: Scalars['String']['output'];
  /** Household display name shown on the cover and section headers. */
  readonly householdName: Scalars['String']['output'];
  /** Household-level trailing one-year TWR (fraction) for the Account Performance 'Total' row; null when unavailable. */
  readonly householdRollingOneYearReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Stable identifier for this report scope (household + date range). */
  readonly id: Scalars['ID']['output'];
  /** Earliest funded date across the report's accounts; used for the 'Since Inception' column. */
  readonly inceptionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Daily points for the household-level 'Invested Value Comparison' chart (Market Value vs Net Amount Invested). */
  readonly marketValueSeries: ReadonlyArray<MarketValuePoint>;
  /** Per-account sub-reports (mini composition + activity + market value chart for each account). */
  readonly perAccountSections: ReadonlyArray<PerAccountSection>;
  /** Per-holding rows for the 'Portfolio Appraisal' table (pages 5+ of the PDF), grouped by asset class on the frontend. */
  readonly portfolioAppraisal: ReadonlyArray<HoldingsSummaryRow>;
  /** Inclusive start of the QTD period (resolved from end_date — the user only picks an as-of date). */
  readonly startDate: Scalars['ISO8601Date']['output'];
  /** Inclusive start of the YTD period (Jan 1 of the end-date year). */
  readonly yearStartDate: Scalars['ISO8601Date']['output'];
};

/**
 * Reporting periods covered by the Performance Report (Consolidated) summary
 * tables — month-to-date, quarter-to-date, year-to-date, and since-inception.
 */
export const PerformanceReportConsolidatedPeriod = {
  /** inception */
  Inception: 'inception',
  /** month_to_date */
  MonthToDate: 'month_to_date',
  /** quarter_to_date */
  QuarterToDate: 'quarter_to_date',
  /** year_to_date */
  YearToDate: 'year_to_date'
} as const;

export type PerformanceReportConsolidatedPeriod = typeof PerformanceReportConsolidatedPeriod[keyof typeof PerformanceReportConsolidatedPeriod];
/**
 * Native rebuild of the Orion "Performance Report – Integrated". Full data payload
 * for the multi-page PDF: activity summary (QTD/YTD/Previous Year/Rolling
 * 3-Year/Inception), portfolio value over time, allocation pie + allocation over
 * time, household holdings report, per-account holdings, YTD fees by account,
 * taxable income summary, taxable realized gain/loss, and return by account.
 * Replaces the Orion path when feature-flagged on.
 */
export type PerformanceReportIntegrated = {
  readonly __typename?: 'PerformanceReportIntegrated';
  /** Activity summary rows — QTD, YTD, Previous Year, Rolling 3-Year, Inception. */
  readonly activitySummary: ReadonlyArray<PerformanceReportIntegratedActivitySummaryRow>;
  /** Primary advisor's display name. */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /** Slices of the Asset Category pie (Equity / Fixed Income / Cash / Alternatives). */
  readonly allocationByCategory: ReadonlyArray<AllocationSlice>;
  /** Per-day per-asset-class allocation time series (stacked-area chart). */
  readonly allocationOverTime: ReadonlyArray<PerformanceReportAllocationsAllocationOverTimePoint>;
  /** When the underlying snapshot was last refreshed. */
  readonly dataLastUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User-selected end of the report period (as-of date). */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Branded firm name; falls back to "Savvy". */
  readonly firmDisplayName: Scalars['String']['output'];
  /** Branded firm logo URL; falls back to the Savvy logo. */
  readonly firmLogoUrl: Scalars['String']['output'];
  /** Household-level holdings (one row per security, aggregated across accounts). */
  readonly holdings: ReadonlyArray<HoldingsSummaryRow>;
  /** Household display name. */
  readonly householdName: Scalars['String']['output'];
  /** Stable identifier for this report scope (household + date range). */
  readonly id: Scalars['ID']['output'];
  /** Earliest funded date across the household's accounts. */
  readonly inceptionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Daily portfolio-level market value + net invested from inception through end_date. */
  readonly marketValueSeries: ReadonlyArray<MarketValuePoint>;
  /** Per-account holdings report blocks. */
  readonly perAccountSections: ReadonlyArray<PerformanceReportIntegratedPerAccountHoldingsSection>;
  /** Dec 31 of the prior calendar year (tax column header). */
  readonly previousYearEndDate: Scalars['ISO8601Date']['output'];
  /** Beginning of quarter for end_date (QTD period start). */
  readonly quarterStartDate: Scalars['ISO8601Date']['output'];
  /** Per-account ending value, net additions, and period returns (household total first). */
  readonly returnByAccount: ReadonlyArray<PerformanceReportIntegratedReturnByAccountRow>;
  /** User-selected start of the report period (header). */
  readonly startDate: Scalars['ISO8601Date']['output'];
  /** Taxable income line items (prior calendar year + YTD). */
  readonly taxableIncomeSummary?: Maybe<PerformanceReportIntegratedTaxableIncomeSummary>;
  /** Taxable realized gain/loss (prior calendar year + YTD). */
  readonly taxableRealizedGainLoss?: Maybe<PerformanceReportIntegratedTaxableRealizedGainLoss>;
  /** Jan 1 of end_date year (YTD period start). */
  readonly yearStartDate: Scalars['ISO8601Date']['output'];
  /** YTD advisory fees per account. */
  readonly ytdFeesByAccount: ReadonlyArray<PerformanceReportIntegratedYtdFeeRow>;
};

/** Beginning/Ending value, net additions, net gains and TWR for one period. */
export type PerformanceReportIntegratedActivitySummaryRow = {
  readonly __typename?: 'PerformanceReportIntegratedActivitySummaryRow';
  /** Beginning market value incl. accrued interest. */
  readonly beginningValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive period end. */
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Ending market value incl. accrued interest. */
  readonly endingValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Human label shown as the column header. */
  readonly label: Scalars['String']['output'];
  /** Net cash flows (contributions − distributions). */
  readonly netAdditions?: Maybe<Scalars['BigDecimal']['output']>;
  /** Net gains: ending − beginning market value − net additions. */
  readonly netGains?: Maybe<Scalars['BigDecimal']['output']>;
  /** Period key (quarter_to_date / year_to_date / previous_year / rolling_3_year / inception). */
  readonly period: Scalars['String']['output'];
  /** Inclusive period start. */
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Time-weighted return as a fraction (annualized for >1yr). */
  readonly timeWeightedReturn?: Maybe<Scalars['BigDecimal']['output']>;
};

/** A single account's holdings, grouped by asset class on the frontend. */
export type PerformanceReportIntegratedPerAccountHoldingsSection = {
  readonly __typename?: 'PerformanceReportIntegratedPerAccountHoldingsSection';
  /** Savvy account id. */
  readonly accountId: Scalars['ID']['output'];
  /** Account display name. */
  readonly accountName: Scalars['String']['output'];
  /** Masked account number. */
  readonly accountNumberMasked?: Maybe<Scalars['String']['output']>;
  /** This account's holdings. */
  readonly holdings: ReadonlyArray<HoldingsSummaryRow>;
  /** Account-level YTD time-weighted return fraction. */
  readonly totalYtdReturn?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Realized gain/loss line items for one period column. */
export type PerformanceReportIntegratedRealizedGainLossColumn = {
  readonly __typename?: 'PerformanceReportIntegratedRealizedGainLossColumn';
  /** Gross long-term realized gain. */
  readonly longTermGain?: Maybe<Scalars['BigDecimal']['output']>;
  /** Gross long-term realized loss (negative). */
  readonly longTermLoss?: Maybe<Scalars['BigDecimal']['output']>;
  /** Net long-term realized gain/loss. */
  readonly longTermNet?: Maybe<Scalars['BigDecimal']['output']>;
  /** Gross short-term realized gain. */
  readonly shortTermGain?: Maybe<Scalars['BigDecimal']['output']>;
  /** Gross short-term realized loss (negative). */
  readonly shortTermLoss?: Maybe<Scalars['BigDecimal']['output']>;
  /** Net short-term realized gain/loss. */
  readonly shortTermNet?: Maybe<Scalars['BigDecimal']['output']>;
  /** Total realized gain/loss. */
  readonly total?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Ending value, net additions and period returns for one account (or the household total). */
export type PerformanceReportIntegratedReturnByAccountRow = {
  readonly __typename?: 'PerformanceReportIntegratedReturnByAccountRow';
  /** Savvy account id, or "total" for the household roll-up. */
  readonly accountId: Scalars['ID']['output'];
  /** Account display name (or household name for the total row). */
  readonly accountName: Scalars['String']['output'];
  /** Masked account number. */
  readonly accountNumberMasked?: Maybe<Scalars['String']['output']>;
  /** Ending market value in USD. */
  readonly endingValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Annualized since-inception TWR fraction. */
  readonly inceptionReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Prior calendar year TWR fraction. */
  readonly lastYearReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** YTD net additions in USD. */
  readonly netAdditions?: Maybe<Scalars['BigDecimal']['output']>;
  /** Annualized rolling 3-year TWR fraction. */
  readonly rollingThreeYearReturn?: Maybe<Scalars['BigDecimal']['output']>;
  /** Year-to-date TWR fraction. */
  readonly ytdReturn?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Taxable income line items for one period column. */
export type PerformanceReportIntegratedTaxableIncomeColumn = {
  readonly __typename?: 'PerformanceReportIntegratedTaxableIncomeColumn';
  /** Ordinary dividends in USD. */
  readonly dividends?: Maybe<Scalars['BigDecimal']['output']>;
  /** Interest income in USD. */
  readonly interest?: Maybe<Scalars['BigDecimal']['output']>;
  /** Long-term capital gain distributions in USD. */
  readonly longTermGains?: Maybe<Scalars['BigDecimal']['output']>;
  /** Sum of non-qualified income line items. */
  readonly nonQualified?: Maybe<Scalars['BigDecimal']['output']>;
  /** Qualified dividends in USD. */
  readonly qualifiedDividends?: Maybe<Scalars['BigDecimal']['output']>;
  /** Return of capital in USD. */
  readonly returnOfCapital?: Maybe<Scalars['BigDecimal']['output']>;
  /** Short-term capital gain distributions in USD. */
  readonly shortTermGains?: Maybe<Scalars['BigDecimal']['output']>;
  /** Taxes withheld in USD. */
  readonly taxesWithheld?: Maybe<Scalars['BigDecimal']['output']>;
  /** Total taxable income in USD. */
  readonly total?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Taxable income line items for the prior calendar year and YTD. */
export type PerformanceReportIntegratedTaxableIncomeSummary = {
  readonly __typename?: 'PerformanceReportIntegratedTaxableIncomeSummary';
  /** Prior full-calendar-year column. */
  readonly priorYear?: Maybe<PerformanceReportIntegratedTaxableIncomeColumn>;
  /** Dec 31 of the prior calendar year (column header). */
  readonly priorYearEndDate: Scalars['ISO8601Date']['output'];
  /** Year-to-date column. */
  readonly ytd?: Maybe<PerformanceReportIntegratedTaxableIncomeColumn>;
};

/** Realized gain/loss for the prior calendar year and YTD. */
export type PerformanceReportIntegratedTaxableRealizedGainLoss = {
  readonly __typename?: 'PerformanceReportIntegratedTaxableRealizedGainLoss';
  /** Prior full-calendar-year column. */
  readonly priorYear?: Maybe<PerformanceReportIntegratedRealizedGainLossColumn>;
  /** Dec 31 of the prior calendar year (column header). */
  readonly priorYearEndDate: Scalars['ISO8601Date']['output'];
  /** Year-to-date column. */
  readonly ytd?: Maybe<PerformanceReportIntegratedRealizedGainLossColumn>;
};

/** YTD advisory fees for a single account. */
export type PerformanceReportIntegratedYtdFeeRow = {
  readonly __typename?: 'PerformanceReportIntegratedYtdFeeRow';
  /** Savvy account id. */
  readonly accountId: Scalars['ID']['output'];
  /** Account display name. */
  readonly accountName: Scalars['String']['output'];
  /** Masked account number. */
  readonly accountNumberMasked?: Maybe<Scalars['String']['output']>;
  /** YTD advisory fees in USD (negative). */
  readonly fees?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Represents an activity summary for an Orion portfolio. */
export type PerformanceSummary = {
  readonly __typename?: 'PerformanceSummary';
  readonly advisoryFeesPaid?: Maybe<Value>;
  readonly beginningMarketValue?: Maybe<Value>;
  readonly contributions?: Maybe<Value>;
  readonly distributions?: Maybe<Value>;
  readonly dividendsAndInterest?: Maybe<Value>;
  readonly endDate: Scalars['ISO8601Date']['output'];
  readonly endingMarketValue?: Maybe<Value>;
  /** Market value increase/decrease for the window — the residual that reconciles the summary to ending market value. */
  readonly marketValueChange?: Maybe<Value>;
  readonly netAdditions?: Maybe<Value>;
  readonly netGains?: Maybe<Value>;
  readonly startDate: Scalars['ISO8601Date']['output'];
  readonly timePeriod: PerformanceTimePeriodName;
  /** Inbound account transfers (Merge In + Journal In) folded into contributions, signed positive. Null when unavailable. */
  readonly transfersIn?: Maybe<Value>;
  /** Outbound account transfers (Merge Out + Journal Out) folded into distributions, signed negative. Null when unavailable. */
  readonly transfersOut?: Maybe<Value>;
  readonly twr?: Maybe<Scalars['Float']['output']>;
};

export const PerformanceTimePeriodName = {
  AllTime: 'all_time',
  LastQuarter: 'last_quarter',
  PastMonth: 'past_month',
  PastThreeMonths: 'past_three_months',
  PastYear: 'past_year',
  YearToDate: 'year_to_date'
} as const;

export type PerformanceTimePeriodName = typeof PerformanceTimePeriodName[keyof typeof PerformanceTimePeriodName];
/** Reporting periods covered by the Performance Report (Unified) summary table. */
export const PeriodEnum = {
  /** all_time */
  AllTime: 'all_time',
  /** last_three_years */
  LastThreeYears: 'last_three_years',
  /** past_five_years */
  PastFiveYears: 'past_five_years',
  /** past_ten_years */
  PastTenYears: 'past_ten_years',
  /** past_year */
  PastYear: 'past_year',
  /** quarter_to_date */
  QuarterToDate: 'quarter_to_date',
  /** report_window */
  ReportWindow: 'report_window',
  /** year_to_date */
  YearToDate: 'year_to_date'
} as const;

export type PeriodEnum = typeof PeriodEnum[keyof typeof PeriodEnum];
/** Per-period total return for one series — used by both Account Performance and Performance vs Benchmark tables. */
export type PeriodReturnRow = {
  readonly __typename?: 'PeriodReturnRow';
  /** Reporting period. */
  readonly period: PeriodEnum;
  /**
   * Annualized time-weighted return over the period, expressed as a fraction (0.05
   * = 5%); equals the cumulative return for periods of one year or less. This is
   * the figure Orion shows in the Account Performance and Performance vs Benchmark
   * tables. Null when data is unavailable.
   */
  readonly returnAnnualized?: Maybe<Scalars['BigDecimal']['output']>;
  /** Cumulative time-weighted return over the period, expressed as a fraction (0.05 = 5%); null when data is unavailable. */
  readonly returnCumulative?: Maybe<Scalars['BigDecimal']['output']>;
};

export type Permission = {
  readonly __typename?: 'Permission';
  readonly action: Scalars['String']['output'];
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly resourceId: Scalars['ID']['output'];
  readonly resourceType: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly user: User;
};

/** Type of personal account */
export const PersonalAccountTypeName = {
  /** _529 */
  '529': '_529',
  /** brokerage */
  Brokerage: 'brokerage',
  /** brokerage_with_margin */
  BrokerageWithMargin: 'brokerage_with_margin',
  /** schwab_one */
  SchwabOne: 'schwab_one',
  /** schwab_one_with_margin */
  SchwabOneWithMargin: 'schwab_one_with_margin',
  /** trust */
  Trust: 'trust'
} as const;

export type PersonalAccountTypeName = typeof PersonalAccountTypeName[keyof typeof PersonalAccountTypeName];
export const PlaidProduct = {
  /** Retrieve and verify bank account information. */
  Auth: 'auth',
  /** View holding and transactions from investment accounts. */
  Investments: 'investments',
  /** Retrieve up to 24 months of transaction data from accounts. */
  Transactions: 'transactions'
} as const;

export type PlaidProduct = typeof PlaidProduct[keyof typeof PlaidProduct];
export type PlanFinancialSnapshot = {
  readonly __typename?: 'PlanFinancialSnapshot';
  /** Snapshot as-of date */
  readonly asOfDate: Scalars['ISO8601Date']['output'];
  /** Plan assets in dollars */
  readonly assets?: Maybe<Scalars['Float']['output']>;
  /** Plan assets stored as integer cents */
  readonly assetsCents?: Maybe<Scalars['BigInt']['output']>;
  /** When the snapshot was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /** Number of participants */
  readonly participantCount?: Maybe<Scalars['Int']['output']>;
  /** Quarter period (e.g. 2026-Q1) */
  readonly period: Scalars['String']['output'];
  /** Entry source: manual | import */
  readonly source: Scalars['String']['output'];
  /** When the snapshot was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Plan Review (Investments, Fees, Plan Health) variant */
export type PlanReviewInput = {
  /** Plan name (household name when a household is selected, else free text) */
  readonly planName?: InputMaybe<Scalars['String']['input']>;
  /** Plan sponsor meeting date */
  readonly planSponsorMeetingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Recordkeeper */
  readonly recordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Review kinds — at least one required */
  readonly reviewTypes: ReadonlyArray<CorporateRetirementPlanReviewTypeName>;
  /** Specific focus areas */
  readonly specificFocusAreas?: InputMaybe<Scalars['String']['input']>;
  /** Target delivery date */
  readonly targetDeliveryDate: Scalars['ISO8601Date']['input'];
};

/**
 * An account held as an asset. A row whose kind is credit or loan becomes a
 * liability instead: every account kind here is an asset.
 */
export type PlanningAccount = {
  readonly __typename?: 'PlanningAccount';
  /** The Savvy record this came from. */
  readonly accountId: Scalars['String']['output'];
  /** Who inherits it. */
  readonly beneficiaries?: Maybe<PlanningBeneficiaries>;
  /** The current balance in dollars. */
  readonly currentBalance: Scalars['BigDecimal']['output'];
  /** A free-text label. */
  readonly description: Scalars['String']['output'];
  /** The fields specific to this kind of account. */
  readonly details: PlanningAccountDetails;
  /** The engine's identifier for this account. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** The income contributions are taken from, when they are linked to one. */
  readonly linkToIncome?: Maybe<PlanningLinkToIncome>;
  /** Who owns it. */
  readonly owners: PlanningOwners;
  /** The account_type stored on the Savvy account, separate from the planning type derived from details. */
  readonly savvyAccountType?: Maybe<Scalars['String']['output']>;
  /** The provider this account is synced from. Null when we own the row. */
  readonly source?: Maybe<PlanningAccountSource>;
  /** What kind of account it is. Derived from the details, so a kind and the fields it implies cannot disagree. */
  readonly type: PlanningAccountType;
  /** When the Savvy account row was last modified, not when its balance was valued. */
  readonly updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When `currentBalance` was true. */
  readonly valuationDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** The fields only one kind of account has. The account kind is derived from this rather than stored beside it. */
export type PlanningAccountDetails = PlanningAccountDetailsBank | PlanningAccountDetailsEmployerRetirement | PlanningAccountDetailsHsa | PlanningAccountDetailsIra | PlanningAccountDetailsNonQualified | PlanningAccountDetailsPlan529 | PlanningAccountDetailsRoth;

/** A cash account. The only variant with an interest rate rather than an asset allocation. */
export type PlanningAccountDetailsBank = {
  readonly __typename?: 'PlanningAccountDetailsBank';
  /** Recurring contributions in. */
  readonly contributions?: Maybe<ReadonlyArray<PlanningScheduledContribution>>;
  /** Annual interest, as a whole-number percentage. */
  readonly interestRate?: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether this account is drawn on first to cover a shortfall. */
  readonly prioritizeDeficitCoverage?: Maybe<Scalars['Boolean']['output']>;
  /** Which kind of cash account. */
  readonly type: PlanningBankType;
};

/** A cash account. The only variant with an interest rate rather than an asset allocation. */
export type PlanningAccountDetailsBankInput = {
  /** Recurring contributions in. */
  readonly contributions?: InputMaybe<ReadonlyArray<PlanningScheduledContributionInput>>;
  /** Annual interest, as a whole-number percentage. */
  readonly interestRate?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Whether this account is drawn on first to cover a shortfall. */
  readonly prioritizeDeficitCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Which kind of cash account. */
  readonly type: PlanningBankType;
};

/** An employer-sponsored plan: a 401(k) or a 403(b). */
export type PlanningAccountDetailsEmployerRetirement = {
  readonly __typename?: 'PlanningAccountDetailsEmployerRetirement';
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: Maybe<Scalars['Boolean']['output']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  readonly applyTenYearRule?: Maybe<Scalars['Boolean']['output']>;
  /** Contributions in, when any are made. */
  readonly contributions?: Maybe<ReadonlyArray<PlanningEmployerPlanContributions>>;
  /** The basis in dollars, when known. */
  readonly costBasis?: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether required minimum distributions are delayed. */
  readonly delayRmds?: Maybe<Scalars['Boolean']['output']>;
  /** External fees, when any are charged. */
  readonly fees?: Maybe<PlanningAccountFees>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: Maybe<Scalars['String']['output']>;
  /** Last year's closing value, which RMDs are calculated from. */
  readonly previousEoyMarketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** The calendar year of the closing value. */
  readonly previousEoyMarketValueYear?: Maybe<Scalars['Int']['output']>;
  /** Which kind of employer plan. */
  readonly type: PlanningEmployerRetirementType;
};

/** An employer-sponsored plan: a 401(k) or a 403(b). */
export type PlanningAccountDetailsEmployerRetirementInput = {
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  readonly applyTenYearRule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contributions in, when any are made. */
  readonly contributions?: InputMaybe<ReadonlyArray<PlanningEmployerPlanContributionsInput>>;
  /** The basis in dollars, when known. */
  readonly costBasis?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Whether required minimum distributions are delayed. */
  readonly delayRmds?: InputMaybe<Scalars['Boolean']['input']>;
  /** External fees, when any are charged. */
  readonly fees?: InputMaybe<PlanningAccountFeesInput>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: InputMaybe<Scalars['String']['input']>;
  /** Last year's closing value, which RMDs are calculated from. */
  readonly previousEoyMarketValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The calendar year of the closing value. */
  readonly previousEoyMarketValueYear?: InputMaybe<Scalars['Int']['input']>;
  /** Which kind of employer plan. */
  readonly type: PlanningEmployerRetirementType;
};

/** A health savings account. No cost basis, for the same reason as a Roth. */
export type PlanningAccountDetailsHsa = {
  readonly __typename?: 'PlanningAccountDetailsHsa';
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: Maybe<Scalars['Boolean']['output']>;
  /** Contributions in, when any are made. */
  readonly contributions?: Maybe<ReadonlyArray<PlanningHsaContributions>>;
  /** Whether the employer sponsors the account. */
  readonly employerSponsored?: Maybe<Scalars['Boolean']['output']>;
  /** Whether coverage is family rather than single, which sets the contribution limit. */
  readonly familyCoverage?: Maybe<Scalars['Boolean']['output']>;
  /** External fees, when any are charged. */
  readonly fees?: Maybe<PlanningAccountFees>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: Maybe<Scalars['String']['output']>;
};

/** A health savings account. No cost basis, for the same reason as a Roth. */
export type PlanningAccountDetailsHsaInput = {
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contributions in, when any are made. */
  readonly contributions?: InputMaybe<ReadonlyArray<PlanningHsaContributionsInput>>;
  /** Whether the employer sponsors the account. */
  readonly employerSponsored?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether coverage is family rather than single, which sets the contribution limit. */
  readonly familyCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  /** External fees, when any are charged. */
  readonly fees?: InputMaybe<PlanningAccountFeesInput>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: InputMaybe<Scalars['String']['input']>;
};

/** The fields only one kind of account has. The account kind is derived from this rather than stored beside it. */
export type PlanningAccountDetailsInput =
  /** A cash account. */
  { readonly bank: PlanningAccountDetailsBankInput; readonly employerRetirement?: never; readonly hsa?: never; readonly ira?: never; readonly nonQualified?: never; readonly plan529?: never; readonly roth?: never; }
  |  /** An employer-sponsored plan: a 401(k) or a 403(b). */
  { readonly bank?: never; readonly employerRetirement: PlanningAccountDetailsEmployerRetirementInput; readonly hsa?: never; readonly ira?: never; readonly nonQualified?: never; readonly plan529?: never; readonly roth?: never; }
  |  /** A health savings account. */
  { readonly bank?: never; readonly employerRetirement?: never; readonly hsa: PlanningAccountDetailsHsaInput; readonly ira?: never; readonly nonQualified?: never; readonly plan529?: never; readonly roth?: never; }
  |  /** A traditional IRA. */
  { readonly bank?: never; readonly employerRetirement?: never; readonly hsa?: never; readonly ira: PlanningAccountDetailsIraInput; readonly nonQualified?: never; readonly plan529?: never; readonly roth?: never; }
  |  /** A taxable brokerage account. */
  { readonly bank?: never; readonly employerRetirement?: never; readonly hsa?: never; readonly ira?: never; readonly nonQualified: PlanningAccountDetailsNonQualifiedInput; readonly plan529?: never; readonly roth?: never; }
  |  /** A 529 education savings account. */
  { readonly bank?: never; readonly employerRetirement?: never; readonly hsa?: never; readonly ira?: never; readonly nonQualified?: never; readonly plan529: PlanningAccountDetailsPlan529Input; readonly roth?: never; }
  |  /** A Roth IRA. */
  { readonly bank?: never; readonly employerRetirement?: never; readonly hsa?: never; readonly ira?: never; readonly nonQualified?: never; readonly plan529?: never; readonly roth: PlanningAccountDetailsRothInput; };

/** A traditional IRA. Alone among the retirement shapes it asks about work-plan coverage, which is what decides deductibility. */
export type PlanningAccountDetailsIra = {
  readonly __typename?: 'PlanningAccountDetailsIra';
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: Maybe<Scalars['Boolean']['output']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  readonly applyTenYearRule?: Maybe<Scalars['Boolean']['output']>;
  /** Contributions in, when any are made. */
  readonly contributions?: Maybe<ReadonlyArray<PlanningTaxAdvantagedContributions>>;
  /** The basis in dollars, when known. */
  readonly costBasis?: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether required minimum distributions are delayed. */
  readonly delayRmds?: Maybe<Scalars['Boolean']['output']>;
  /** External fees, when any are charged. */
  readonly fees?: Maybe<PlanningAccountFees>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: Maybe<Scalars['String']['output']>;
  /** Last year's closing value, which RMDs are calculated from. */
  readonly previousEoyMarketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Who is covered by a work-based plan, when either is. */
  readonly workPlanCoverage?: Maybe<PlanningWorkPlanCoverage>;
};

/** A traditional IRA. Alone among the retirement shapes it asks about work-plan coverage, which is what decides deductibility. */
export type PlanningAccountDetailsIraInput = {
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  readonly applyTenYearRule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contributions in, when any are made. */
  readonly contributions?: InputMaybe<ReadonlyArray<PlanningTaxAdvantagedContributionsInput>>;
  /** The basis in dollars, when known. */
  readonly costBasis?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Whether required minimum distributions are delayed. */
  readonly delayRmds?: InputMaybe<Scalars['Boolean']['input']>;
  /** External fees, when any are charged. */
  readonly fees?: InputMaybe<PlanningAccountFeesInput>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: InputMaybe<Scalars['String']['input']>;
  /** Last year's closing value, which RMDs are calculated from. */
  readonly previousEoyMarketValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Who is covered by a work-based plan, when either is. */
  readonly workPlanCoverage?: InputMaybe<PlanningWorkPlanCoverage>;
};

/** A taxable brokerage account. The only variant that asks where interest and dividends go. */
export type PlanningAccountDetailsNonQualified = {
  readonly __typename?: 'PlanningAccountDetailsNonQualified';
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: Maybe<Scalars['Boolean']['output']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  readonly applyTenYearRule?: Maybe<Scalars['Boolean']['output']>;
  /** Recurring contributions in. */
  readonly contributions?: Maybe<ReadonlyArray<PlanningScheduledContribution>>;
  /** The basis in dollars, when known. */
  readonly costBasis?: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether interest and dividends are paid out to cashflow rather than reinvested. */
  readonly distributeToCashflow?: Maybe<Scalars['Boolean']['output']>;
  /** External fees, when any are charged. */
  readonly fees?: Maybe<PlanningAccountFees>;
  /** Whether the balance is held back from covering a shortfall. */
  readonly holdBackFromDeficitCoverage?: Maybe<Scalars['Boolean']['output']>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: Maybe<Scalars['String']['output']>;
};

/** A taxable brokerage account. The only variant that asks where interest and dividends go. */
export type PlanningAccountDetailsNonQualifiedInput = {
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  readonly applyTenYearRule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Recurring contributions in. */
  readonly contributions?: InputMaybe<ReadonlyArray<PlanningScheduledContributionInput>>;
  /** The basis in dollars, when known. */
  readonly costBasis?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Whether interest and dividends are paid out to cashflow rather than reinvested. */
  readonly distributeToCashflow?: InputMaybe<Scalars['Boolean']['input']>;
  /** External fees, when any are charged. */
  readonly fees?: InputMaybe<PlanningAccountFeesInput>;
  /** Whether the balance is held back from covering a shortfall. */
  readonly holdBackFromDeficitCoverage?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: InputMaybe<Scalars['String']['input']>;
};

/** A 529 education savings account. */
export type PlanningAccountDetailsPlan529 = {
  readonly __typename?: 'PlanningAccountDetailsPlan529';
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: Maybe<Scalars['Boolean']['output']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  readonly applyTenYearRule?: Maybe<Scalars['Boolean']['output']>;
  /** Contributions in, when any are made. */
  readonly contributions?: Maybe<ReadonlyArray<PlanningTaxAdvantagedContributions>>;
  /** The basis in dollars, when known. */
  readonly costBasis?: Maybe<Scalars['BigDecimal']['output']>;
  /** External fees, when any are charged. */
  readonly fees?: Maybe<PlanningAccountFees>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: Maybe<Scalars['String']['output']>;
};

/** A 529 education savings account. */
export type PlanningAccountDetailsPlan529Input = {
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  readonly applyTenYearRule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contributions in, when any are made. */
  readonly contributions?: InputMaybe<ReadonlyArray<PlanningTaxAdvantagedContributionsInput>>;
  /** The basis in dollars, when known. */
  readonly costBasis?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** External fees, when any are charged. */
  readonly fees?: InputMaybe<PlanningAccountFeesInput>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: InputMaybe<Scalars['String']['input']>;
};

/** A Roth IRA. No cost basis: the balance is already after tax. */
export type PlanningAccountDetailsRoth = {
  readonly __typename?: 'PlanningAccountDetailsRoth';
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: Maybe<Scalars['Boolean']['output']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  readonly applyTenYearRule?: Maybe<Scalars['Boolean']['output']>;
  /** Contributions in, when any are made. */
  readonly contributions?: Maybe<ReadonlyArray<PlanningTaxAdvantagedContributions>>;
  /** External fees, when any are charged. */
  readonly fees?: Maybe<PlanningAccountFees>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: Maybe<Scalars['String']['output']>;
};

/** A Roth IRA. No cost basis: the balance is already after tax. */
export type PlanningAccountDetailsRothInput = {
  /** Whether the plan may reallocate it. */
  readonly allowReallocation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether an inherited balance must be drawn down within ten years. */
  readonly applyTenYearRule?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contributions in, when any are made. */
  readonly contributions?: InputMaybe<ReadonlyArray<PlanningTaxAdvantagedContributionsInput>>;
  /** External fees, when any are charged. */
  readonly fees?: InputMaybe<PlanningAccountFeesInput>;
  /**
   * An asset allocation id from `planningPortfolioOptions`. Named `portfolio` for
   * compatibility; the domain calls it `asset_allocation_id`.
   */
  readonly portfolio?: InputMaybe<Scalars['String']['input']>;
};

/** External account fees. The rate is a percentage, not a cash amount. */
export type PlanningAccountFees = {
  readonly __typename?: 'PlanningAccountFees';
  /** The annual fee rate, as a whole-number percentage. */
  readonly annualPercentage?: Maybe<Scalars['BigDecimal']['output']>;
  /** How often the fee is charged. */
  readonly frequency?: Maybe<PlanningFeeFrequency>;
};

/** External account fees. The rate is a percentage, not a cash amount. */
export type PlanningAccountFeesInput = {
  /** The annual fee rate, as a whole-number percentage. */
  readonly annualPercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** How often the fee is charged. */
  readonly frequency?: InputMaybe<PlanningFeeFrequency>;
};

/**
 * An account held as an asset. A row whose kind is credit or loan becomes a
 * liability instead: every account kind here is an asset.
 */
export type PlanningAccountInput = {
  /** The Savvy record this came from. Left out for an account added in the plan, which has no Savvy row yet. */
  readonly accountId?: InputMaybe<Scalars['String']['input']>;
  /** Who inherits it. */
  readonly beneficiaries?: InputMaybe<PlanningBeneficiariesInput>;
  /** The current balance in dollars. */
  readonly currentBalance: Scalars['BigDecimal']['input'];
  /** A free-text label. */
  readonly description: Scalars['String']['input'];
  /** The fields specific to this kind of account. */
  readonly details: PlanningAccountDetailsInput;
  /** The engine's identifier for this account. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** The income contributions are taken from, when they are linked to one. */
  readonly linkToIncome?: InputMaybe<PlanningLinkToIncome>;
  /** Who owns it. */
  readonly owners: PlanningOwnersInput;
  /** When `currentBalance` was true. Left out, the engine re-dates it to the day it reads it. */
  readonly valuationDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Which external provider a row is synced from. Absent when the row is ours. */
export const PlanningAccountSource = {
  /** MONEYKIT */
  Moneykit: 'MONEYKIT',
  /** ORION */
  Orion: 'ORION',
  /** PLAID */
  Plaid: 'PLAID'
} as const;

export type PlanningAccountSource = typeof PlanningAccountSource[keyof typeof PlanningAccountSource];
/** What kind of account this is. Derived from the details rather than stored beside them, so the two cannot disagree. */
export const PlanningAccountType = {
  /** brokerage */
  Brokerage: 'brokerage',
  /** certificate_of_deposit */
  CertificateOfDeposit: 'certificate_of_deposit',
  /** checking */
  Checking: 'checking',
  /** hsa */
  Hsa: 'hsa',
  /** ira */
  Ira: 'ira',
  /** money_market */
  MoneyMarket: 'money_market',
  /** other_bank */
  OtherBank: 'other_bank',
  /** plan_529 */
  Plan_529: 'plan_529',
  /** retirement_401k */
  Retirement_401k: 'retirement_401k',
  /** retirement_403b */
  Retirement_403b: 'retirement_403b',
  /** roth_ira */
  RothIra: 'roth_ira',
  /** savings */
  Savings: 'savings'
} as const;

export type PlanningAccountType = typeof PlanningAccountType[keyof typeof PlanningAccountType];
/** The person is already retired, so there is no future retirement date. */
export type PlanningAlreadyRetired = {
  readonly __typename?: 'PlanningAlreadyRetired';
  /** Always true. Present because GraphQL object types cannot be empty. */
  readonly isAlreadyRetired: Scalars['Boolean']['output'];
};

/** Already retired. Carries no data of its own. */
export type PlanningAlreadyRetiredInput = {
  /** Must be true. Present because the variant carries no data. */
  readonly selected: Scalars['Boolean']['input'];
};

/** Whether a money figure was entered per period or as an annual total */
export const PlanningAmountBasis = {
  /** annual */
  Annual: 'annual',
  /** per_period */
  PerPeriod: 'per_period'
} as const;

export type PlanningAmountBasis = typeof PlanningAmountBasis[keyof typeof PlanningAmountBasis];
/** Anything the household owns: an account, a lifestyle asset, an equity incentive, or a rental property. */
export type PlanningAsset = PlanningAccount | PlanningEquityIncentive | PlanningLifestyleAsset | PlanningRentalProperty;

/** Anything the household owns: an account, a lifestyle asset, an equity incentive, or a rental property. */
export type PlanningAssetInput =
  /** Account. */
  { readonly account: PlanningAccountInput; readonly equityIncentive?: never; readonly lifestyleAsset?: never; readonly rentalProperty?: never; }
  |  /** Equity incentive. */
  { readonly account?: never; readonly equityIncentive: PlanningEquityIncentiveInput; readonly lifestyleAsset?: never; readonly rentalProperty?: never; }
  |  /** Lifestyle asset. */
  { readonly account?: never; readonly equityIncentive?: never; readonly lifestyleAsset: PlanningLifestyleAssetInput; readonly rentalProperty?: never; }
  |  /** Rental property. */
  { readonly account?: never; readonly equityIncentive?: never; readonly lifestyleAsset?: never; readonly rentalProperty: PlanningRentalPropertyInput; };

/** The kind of cash account: checking, savings, money market, CD, or other. */
export const PlanningBankType = {
  /** certificate_of_deposit */
  CertificateOfDeposit: 'certificate_of_deposit',
  /** checking */
  Checking: 'checking',
  /** money_market */
  MoneyMarket: 'money_market',
  /** other_bank */
  OtherBank: 'other_bank',
  /** savings */
  Savings: 'savings'
} as const;

export type PlanningBankType = typeof PlanningBankType[keyof typeof PlanningBankType];
/** How an account names its beneficiaries. */
export type PlanningBeneficiaries = PlanningBeneficiariesMultiple | PlanningBeneficiariesPrimaryAndContingent;

/** How an account names its beneficiaries — exactly one variant must be set (oneOf). */
export type PlanningBeneficiariesInput =
  /** A list of named beneficiaries. */
  { readonly multiple: PlanningBeneficiariesMultipleInput; readonly primaryAndContingent?: never; }
  |  /** A primary and contingent pair. */
  { readonly multiple?: never; readonly primaryAndContingent: PlanningBeneficiariesPrimaryAndContingentInput; };

/** A list of named beneficiaries with no designation, the shape a 529 uses. */
export type PlanningBeneficiariesMultiple = {
  readonly __typename?: 'PlanningBeneficiariesMultiple';
  /** The named beneficiaries. */
  readonly members?: Maybe<ReadonlyArray<PlanningNamedBeneficiary>>;
};

/** A list of named beneficiaries with no designation, the shape a 529 uses. */
export type PlanningBeneficiariesMultipleInput = {
  /** The named beneficiaries. */
  readonly members?: InputMaybe<ReadonlyArray<PlanningNamedBeneficiaryInput>>;
};

/** A primary and a contingent designation, the shape most account types use. */
export type PlanningBeneficiariesPrimaryAndContingent = {
  readonly __typename?: 'PlanningBeneficiariesPrimaryAndContingent';
  /** The contingent beneficiary, which defaults to the estate. */
  readonly contingent?: Maybe<PlanningBeneficiaryPerson>;
  /** The primary beneficiary. */
  readonly primary?: Maybe<PlanningBeneficiaryPerson>;
};

/** A primary and a contingent designation. */
export type PlanningBeneficiariesPrimaryAndContingentInput = {
  /** The contingent beneficiary. */
  readonly contingent?: InputMaybe<PlanningBeneficiaryPersonInput>;
  /** The primary beneficiary. */
  readonly primary?: InputMaybe<PlanningBeneficiaryPersonInput>;
};

/** A household member. */
export type PlanningBeneficiaryClient = {
  readonly __typename?: 'PlanningBeneficiaryClient';
  /** The household member named as beneficiary. */
  readonly clientProfileId?: Maybe<Scalars['String']['output']>;
};

/** A household member. */
export type PlanningBeneficiaryClientInput = {
  /** The household member named as beneficiary. */
  readonly clientProfileId?: InputMaybe<Scalars['String']['input']>;
};

/** A dependant. */
export type PlanningBeneficiaryDependant = {
  readonly __typename?: 'PlanningBeneficiaryDependant';
  /** The Savvy contact named as beneficiary. */
  readonly contactId?: Maybe<Scalars['String']['output']>;
};

/** A dependant. */
export type PlanningBeneficiaryDependantInput = {
  /** The Savvy contact named as beneficiary. */
  readonly contactId?: InputMaybe<Scalars['String']['input']>;
};

/** The client's estate rather than a person. */
export type PlanningBeneficiaryEstate = {
  readonly __typename?: 'PlanningBeneficiaryEstate';
  /** Always true. Present because GraphQL object types cannot be empty. */
  readonly isEstate: Scalars['Boolean']['output'];
};

/** The client's estate rather than a person. Carries no data of its own. */
export type PlanningBeneficiaryEstateInput = {
  /** Must be true. Present because the variant carries no data. */
  readonly selected: Scalars['Boolean']['input'];
};

/** Who a beneficiary designation names. */
export type PlanningBeneficiaryPerson = PlanningBeneficiaryClient | PlanningBeneficiaryDependant | PlanningBeneficiaryEstate;

/** Who a beneficiary designation names — exactly one variant must be set (oneOf). */
export type PlanningBeneficiaryPersonInput =
  /** A household member. */
  { readonly client: PlanningBeneficiaryClientInput; readonly dependant?: never; readonly estate?: never; }
  |  /** A dependant. */
  { readonly client?: never; readonly dependant: PlanningBeneficiaryDependantInput; readonly estate?: never; }
  |  /** The estate. */
  { readonly client?: never; readonly dependant?: never; readonly estate: PlanningBeneficiaryEstateInput; };

/** What a cash-reserve target is measured against. */
export const PlanningCashReserveBasis = {
  /** custom_amount */
  CustomAmount: 'custom_amount',
  /** monthly_expenses */
  MonthlyExpenses: 'monthly_expenses',
  /** monthly_salary */
  MonthlySalary: 'monthly_salary'
} as const;

export type PlanningCashReserveBasis = typeof PlanningCashReserveBasis[keyof typeof PlanningCashReserveBasis];
/** Whether contributions are a percentage of salary or fixed dollar amounts. */
export type PlanningContributionBasis = PlanningContributionBasisAmount | PlanningContributionBasisPercent;

/** Contributions as fixed dollar amounts, each indexed separately. */
export type PlanningContributionBasisAmount = {
  readonly __typename?: 'PlanningContributionBasisAmount';
  /** Employee contribution in dollars. */
  readonly employeeDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** How the employee amount grows. */
  readonly employeeIndexation?: Maybe<PlanningIndexation>;
  /** Employer contribution in dollars. */
  readonly employerDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** How the employer amount grows. */
  readonly employerIndexation?: Maybe<PlanningIndexation>;
};

/** Contributions as fixed dollar amounts, each indexed separately. */
export type PlanningContributionBasisAmountInput = {
  /** Employee contribution in dollars. */
  readonly employeeDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** How the employee amount grows. */
  readonly employeeIndexation?: InputMaybe<PlanningIndexationInput>;
  /** Employer contribution in dollars. */
  readonly employerDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** How the employer amount grows. */
  readonly employerIndexation?: InputMaybe<PlanningIndexationInput>;
};

/** Percentage of salary or fixed dollar amounts — exactly one variant must be set (oneOf). */
export type PlanningContributionBasisInput =
  /** Fixed dollar amounts. */
  { readonly amount: PlanningContributionBasisAmountInput; readonly percent?: never; }
  |  /** A percentage of salary. */
  { readonly amount?: never; readonly percent: PlanningContributionBasisPercentInput; };

/** Contributions as a percentage of salary. A percentage of a growing salary re-bases itself, so there is no indexation here. */
export type PlanningContributionBasisPercent = {
  readonly __typename?: 'PlanningContributionBasisPercent';
  /** Employee contribution, as a whole-number percentage of salary. */
  readonly employeePercentage?: Maybe<Scalars['BigDecimal']['output']>;
  /** Employer contribution, as a whole-number percentage of salary. */
  readonly employerPercentage?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Contributions as a percentage of salary. No indexation: a percentage of a growing salary re-bases itself. */
export type PlanningContributionBasisPercentInput = {
  /** Employee contribution, as a whole-number percentage of salary. */
  readonly employeePercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Employer contribution, as a whole-number percentage of salary. */
  readonly employerPercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** How often a contribution is made */
export const PlanningContributionFrequency = {
  /** annually */
  Annually: 'annually',
  /** bimonthly */
  Bimonthly: 'bimonthly',
  /** monthly */
  Monthly: 'monthly',
  /** one_time */
  OneTime: 'one_time',
  /** quarterly */
  Quarterly: 'quarterly',
  /** semi_annually */
  SemiAnnually: 'semi_annually'
} as const;

export type PlanningContributionFrequency = typeof PlanningContributionFrequency[keyof typeof PlanningContributionFrequency];
/** A depreciation basis with no fixed period — land, building or qualified improvement property. */
export type PlanningCostPool = {
  readonly __typename?: 'PlanningCostPool';
  /** Depreciation already claimed, split by owner. */
  readonly accumulatedDepreciation?: Maybe<ReadonlyArray<PlanningPerOwnerAmount>>;
  /** The original cost in dollars. */
  readonly originalCost?: Maybe<Scalars['BigDecimal']['output']>;
};

/** A depreciation basis with no fixed period. */
export type PlanningCostPoolInput = {
  /** Depreciation already claimed, split by owner. */
  readonly accumulatedDepreciation?: InputMaybe<ReadonlyArray<PlanningPerOwnerAmountInput>>;
  /** The original cost in dollars. */
  readonly originalCost?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** When something starts or stops: a date, a plan event, or an age. */
export type PlanningDateBoundary = PlanningDateBoundaryAtAge | PlanningDateBoundaryAtEvent | PlanningDateBoundaryOnDate;

/** A boundary at a household member's age. */
export type PlanningDateBoundaryAtAge = {
  readonly __typename?: 'PlanningDateBoundaryAtAge';
  /** The age in years. */
  readonly age?: Maybe<Scalars['Int']['output']>;
};

/** A boundary at a household member's age. */
export type PlanningDateBoundaryAtAgeInput = {
  /** The age in years. */
  readonly age?: InputMaybe<Scalars['Int']['input']>;
};

/** A boundary that moves with a named plan event. */
export type PlanningDateBoundaryAtEvent = {
  readonly __typename?: 'PlanningDateBoundaryAtEvent';
  /** The event it hangs off. */
  readonly event?: Maybe<PlanningPlanEvent>;
};

/** A boundary that moves with a named plan event. */
export type PlanningDateBoundaryAtEventInput = {
  /** The event it hangs off. */
  readonly event?: InputMaybe<PlanningPlanEvent>;
};

/** When something starts or stops — exactly one variant must be set (oneOf). */
export type PlanningDateBoundaryInput =
  /** A household member age. */
  { readonly atAge: PlanningDateBoundaryAtAgeInput; readonly atEvent?: never; readonly onDate?: never; }
  |  /** A named plan event. */
  { readonly atAge?: never; readonly atEvent: PlanningDateBoundaryAtEventInput; readonly onDate?: never; }
  |  /** A calendar date. */
  { readonly atAge?: never; readonly atEvent?: never; readonly onDate: PlanningDateBoundaryOnDateInput; };

/** A boundary fixed to a calendar date. */
export type PlanningDateBoundaryOnDate = {
  readonly __typename?: 'PlanningDateBoundaryOnDate';
  /** The date. */
  readonly date?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** A boundary fixed to a calendar date. */
export type PlanningDateBoundaryOnDateInput = {
  /** The date. */
  readonly date?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** A dependant of the household. */
export type PlanningDependant = {
  readonly __typename?: 'PlanningDependant';
  /** Date of birth. */
  readonly birthDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The Savvy contact this came from. */
  readonly contactId: Scalars['String']['output'];
  /** Which household members the dependant belongs to. */
  readonly dependentOf?: Maybe<PlanningOwners>;
  /** The engine's identifier for this dependant. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** First name. */
  readonly firstName: Scalars['String']['output'];
  /** Last name. */
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** How they relate to the household. */
  readonly relationship?: Maybe<PlanningDependantRelationship>;
  /** State of residence. */
  readonly state?: Maybe<StateCode>;
};

/** A dependant of the household. */
export type PlanningDependantInput = {
  /** Date of birth. */
  readonly birthDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The Savvy contact this came from. Left out for a dependant added in the plan, which has no Savvy contact yet. */
  readonly contactId?: InputMaybe<Scalars['String']['input']>;
  /** Which household members the dependant belongs to. */
  readonly dependentOf?: InputMaybe<PlanningOwnersInput>;
  /** The engine's identifier for this dependant. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** First name. */
  readonly firstName: Scalars['String']['input'];
  /** Last name. */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** How they relate to the household. */
  readonly relationship?: InputMaybe<PlanningDependantRelationship>;
  /** State of residence. */
  readonly state?: InputMaybe<StateCode>;
};

/** How a dependant relates to the household */
export const PlanningDependantRelationship = {
  /** child */
  Child: 'child',
  /** extended_family_member */
  ExtendedFamilyMember: 'extended_family_member',
  /** grandchild */
  Grandchild: 'grandchild',
  /** grandparent */
  Grandparent: 'grandparent',
  /** other */
  Other: 'other',
  /** parent */
  Parent: 'parent'
} as const;

export type PlanningDependantRelationship = typeof PlanningDependantRelationship[keyof typeof PlanningDependantRelationship];
/** A depreciation basis that runs over a fixed number of years, such as appliances and furniture. */
export type PlanningDepreciablePool = {
  readonly __typename?: 'PlanningDepreciablePool';
  /** Depreciation already claimed, split by owner. */
  readonly accumulatedDepreciation?: Maybe<ReadonlyArray<PlanningPerOwnerAmount>>;
  /** How many years the basis depreciates over. */
  readonly depreciationPeriodYears?: Maybe<Scalars['Int']['output']>;
  /** The original cost in dollars. */
  readonly originalCost?: Maybe<Scalars['BigDecimal']['output']>;
};

/** A depreciation basis that runs over a fixed number of years. */
export type PlanningDepreciablePoolInput = {
  /** Depreciation already claimed, split by owner. */
  readonly accumulatedDepreciation?: InputMaybe<ReadonlyArray<PlanningPerOwnerAmountInput>>;
  /** How many years the basis depreciates over. */
  readonly depreciationPeriodYears?: InputMaybe<Scalars['Int']['input']>;
  /** The original cost in dollars. */
  readonly originalCost?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** How much goes into an employer plan: an elected level, or the maximum. */
export type PlanningEmployerPlanContributions = PlanningEmployerPlanContributionsElected | PlanningEmployerPlanContributionsMaxOut;

/** A chosen contribution level, as a percentage of salary or a dollar amount. */
export type PlanningEmployerPlanContributionsElected = {
  readonly __typename?: 'PlanningEmployerPlanContributionsElected';
  /** Whether the contribution is a percentage of salary or a dollar amount. */
  readonly contributionBasis?: Maybe<PlanningContributionBasis>;
  /** When contributions stop. */
  readonly endsOn?: Maybe<PlanningDateBoundary>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** When contributions start. */
  readonly startsOn?: Maybe<PlanningDateBoundary>;
};

/** A chosen contribution level, as a percentage of salary or a dollar amount. */
export type PlanningEmployerPlanContributionsElectedInput = {
  /** Whether the contribution is a percentage of salary or a dollar amount. */
  readonly contributionBasis?: InputMaybe<PlanningContributionBasisInput>;
  /** When contributions stop. */
  readonly endsOn?: InputMaybe<PlanningDateBoundaryInput>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** When contributions start. */
  readonly startsOn?: InputMaybe<PlanningDateBoundaryInput>;
};

/** How much goes into an employer plan: an elected level, or the maximum. */
export type PlanningEmployerPlanContributionsInput =
  /** A chosen contribution level, as a percentage of salary or a dollar amount. */
  { readonly elected: PlanningEmployerPlanContributionsElectedInput; readonly maxOut?: never; }
  |  /** Contribute the statutory maximum. */
  { readonly elected?: never; readonly maxOut: PlanningEmployerPlanContributionsMaxOutInput; };

/** Contribute the statutory maximum. */
export type PlanningEmployerPlanContributionsMaxOut = {
  readonly __typename?: 'PlanningEmployerPlanContributionsMaxOut';
  /** Last tax year to contribute in. */
  readonly endTaxYear?: Maybe<Scalars['Int']['output']>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** First tax year to contribute in. */
  readonly startTaxYear?: Maybe<Scalars['Int']['output']>;
};

/** Contribute the statutory maximum. */
export type PlanningEmployerPlanContributionsMaxOutInput = {
  /** Last tax year to contribute in. */
  readonly endTaxYear?: InputMaybe<Scalars['Int']['input']>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** First tax year to contribute in. */
  readonly startTaxYear?: InputMaybe<Scalars['Int']['input']>;
};

/** Which employer-sponsored retirement plan this is. */
export const PlanningEmployerRetirementType = {
  /** retirement_401k */
  Retirement_401k: 'retirement_401k',
  /** retirement_403b */
  Retirement_403b: 'retirement_403b'
} as const;

export type PlanningEmployerRetirementType = typeof PlanningEmployerRetirementType[keyof typeof PlanningEmployerRetirementType];
/** An equity grant, its vesting schedule, and any exercises and sales against it. */
export type PlanningEquityIncentive = {
  readonly __typename?: 'PlanningEquityIncentive';
  /** The primary and contingent designation. Equity never uses the multi-beneficiary shape. */
  readonly beneficiaries?: Maybe<PlanningBeneficiariesPrimaryAndContingent>;
  /** A free-text label. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Whether an 83(b) election was filed. Restricted stock only. */
  readonly election83b?: Maybe<Scalars['Boolean']['output']>;
  /** Exercises against the grant. */
  readonly exercises?: Maybe<ReadonlyArray<PlanningExercise>>;
  /** When the options expire. */
  readonly expiry?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The engine's identifier for this grant. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** When it was granted. */
  readonly grantDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** How many options the grant covers. */
  readonly options?: Maybe<Scalars['BigDecimal']['output']>;
  /** Who holds the grant. */
  readonly owners?: Maybe<PlanningOwners>;
  /** Assumed annual return, as a whole-number percentage. */
  readonly returnRate?: Maybe<Scalars['BigDecimal']['output']>;
  /** Sales of exercised shares. */
  readonly sales?: Maybe<ReadonlyArray<PlanningShareSale>>;
  /** The strike price. */
  readonly strikePrice?: Maybe<Scalars['BigDecimal']['output']>;
  /** The kind of grant. */
  readonly type: PlanningEquityIncentiveType;
  /** The current unit price. */
  readonly unitPrice?: Maybe<Scalars['BigDecimal']['output']>;
  /** The unit price when the grant was made. Restricted stock only. */
  readonly unitPriceAtGrant?: Maybe<Scalars['BigDecimal']['output']>;
  /** When the unit price was assessed. */
  readonly unitPriceValuation?: Maybe<Scalars['ISO8601Date']['output']>;
  /** How the grant vests. */
  readonly vesting?: Maybe<PlanningVesting>;
};

/** An equity grant, its vesting schedule, and any exercises and sales against it. */
export type PlanningEquityIncentiveInput = {
  /** The primary and contingent designation. Equity never uses the multi-beneficiary shape. */
  readonly beneficiaries?: InputMaybe<PlanningBeneficiariesPrimaryAndContingentInput>;
  /** A free-text label. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Whether an 83(b) election was filed. Restricted stock only. */
  readonly election83b?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exercises against the grant. */
  readonly exercises?: InputMaybe<ReadonlyArray<PlanningExerciseInput>>;
  /** When the options expire. */
  readonly expiry?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The engine's identifier for this grant. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** When it was granted. */
  readonly grantDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** How many options the grant covers. */
  readonly options?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Who holds the grant. */
  readonly owners?: InputMaybe<PlanningOwnersInput>;
  /** Assumed annual return, as a whole-number percentage. */
  readonly returnRate?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Sales of exercised shares. */
  readonly sales?: InputMaybe<ReadonlyArray<PlanningShareSaleInput>>;
  /** The strike price. */
  readonly strikePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The kind of grant. */
  readonly type: PlanningEquityIncentiveType;
  /** The current unit price. */
  readonly unitPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The unit price when the grant was made. Restricted stock only. */
  readonly unitPriceAtGrant?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** When the unit price was assessed. */
  readonly unitPriceValuation?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** How the grant vests. */
  readonly vesting?: InputMaybe<PlanningVestingInput>;
};

/** The kind of equity grant */
export const PlanningEquityIncentiveType = {
  /** incentive_stock_options */
  IncentiveStockOptions: 'incentive_stock_options',
  /** nonqualified_stock_options */
  NonqualifiedStockOptions: 'nonqualified_stock_options',
  /** restricted_stock */
  RestrictedStock: 'restricted_stock'
} as const;

export type PlanningEquityIncentiveType = typeof PlanningEquityIncentiveType[keyof typeof PlanningEquityIncentiveType];
/** An exercise of vested options. */
export type PlanningExercise = {
  readonly __typename?: 'PlanningExercise';
  /** Past or planned. */
  readonly detail?: Maybe<PlanningExerciseDetail>;
  /** Whether every vested option was exercised. */
  readonly exercisedAllVested?: Maybe<Scalars['Boolean']['output']>;
  /** How many shares were exercised. */
  readonly numberOfShares?: Maybe<Scalars['BigDecimal']['output']>;
};

/** A past or planned exercise. The two carry genuinely different fields. */
export type PlanningExerciseDetail = PlanningExerciseFuture | PlanningExercisePast;

/** Past or planned — exactly one variant must be set (oneOf). */
export type PlanningExerciseDetailInput =
  /** Planned. */
  { readonly future: PlanningExerciseFutureInput; readonly past?: never; }
  |  /** Already happened. */
  { readonly future?: never; readonly past: PlanningExercisePastInput; };

/** A planned exercise, which carries an intent and a schedule rather than a price. */
export type PlanningExerciseFuture = {
  readonly __typename?: 'PlanningExerciseFuture';
  /** Whether the shares are held or sold. */
  readonly intent?: Maybe<PlanningFutureExerciseIntent>;
  /** When it is planned for. */
  readonly schedule?: Maybe<PlanningOccurrence>;
};

/** A planned exercise. */
export type PlanningExerciseFutureInput = {
  /** Whether the shares are held or sold. */
  readonly intent?: InputMaybe<PlanningFutureExerciseIntent>;
  /** When it is planned for. */
  readonly schedule?: InputMaybe<PlanningOccurrenceInput>;
};

/** An exercise of vested options. */
export type PlanningExerciseInput = {
  /** Past or planned. */
  readonly detail?: InputMaybe<PlanningExerciseDetailInput>;
  /** Whether every vested option was exercised. */
  readonly exercisedAllVested?: InputMaybe<Scalars['Boolean']['input']>;
  /** How many shares were exercised. */
  readonly numberOfShares?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** An exercise that has already happened, so it carries what was paid rather than an intent. */
export type PlanningExercisePast = {
  readonly __typename?: 'PlanningExercisePast';
  /** When it was exercised. */
  readonly exercisedOn?: Maybe<PlanningDateBoundary>;
  /** Whether the resulting shares are still held. */
  readonly sharesStillHeld?: Maybe<Scalars['Boolean']['output']>;
  /** The unit price paid. */
  readonly unitPrice?: Maybe<Scalars['BigDecimal']['output']>;
};

/** An exercise that has already happened. */
export type PlanningExercisePastInput = {
  /** When it was exercised. */
  readonly exercisedOn?: InputMaybe<PlanningDateBoundaryInput>;
  /** Whether the resulting shares are still held. */
  readonly sharesStillHeld?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unit price paid. */
  readonly unitPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** A plan expense. */
export type PlanningExpense = {
  readonly __typename?: 'PlanningExpense';
  /** Whether it is deductible above the line. */
  readonly aboveTheLineDeduction?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the amount is per period or already annual. */
  readonly amountBasis?: Maybe<PlanningAmountBasis>;
  /** The amount restated annually. Null for a one-time expense, which has no annual rate. */
  readonly annualDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** A free-text label. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The amount in dollars, as entered. */
  readonly dollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** When it stops. */
  readonly endsOn?: Maybe<PlanningDateBoundary>;
  /** The engine's identifier for this expense. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** How often it recurs. */
  readonly frequency?: Maybe<PlanningExpenseFrequency>;
  /** How the amount grows. */
  readonly indexation?: Maybe<PlanningIndexation>;
  /** Who the expense belongs to. */
  readonly owners?: Maybe<PlanningOwners>;
  /** When it starts. */
  readonly startsOn?: Maybe<PlanningDateBoundary>;
  /** What kind of expense it is. */
  readonly type: PlanningExpenseType;
};

/** How often an expense recurs. */
export type PlanningExpenseFrequency = PlanningExpenseFrequencyEvery | PlanningExpenseFrequencyEveryNYears;

/** An expense on one of the standard cashflow periods. */
export type PlanningExpenseFrequencyEvery = {
  readonly __typename?: 'PlanningExpenseFrequencyEvery';
  /** The period. */
  readonly period?: Maybe<PlanningFrequency>;
};

/** An expense on one of the standard cashflow periods. */
export type PlanningExpenseFrequencyEveryInput = {
  /** The period. */
  readonly period?: InputMaybe<PlanningFrequency>;
};

/** An expense that recurs on a multi-year cycle, which the standard periods cannot express. */
export type PlanningExpenseFrequencyEveryNYears = {
  readonly __typename?: 'PlanningExpenseFrequencyEveryNYears';
  /** The number of years between occurrences. */
  readonly years?: Maybe<Scalars['Int']['output']>;
};

/** An expense on a multi-year cycle, which the standard periods cannot express. */
export type PlanningExpenseFrequencyEveryNYearsInput = {
  /** The number of years between occurrences. */
  readonly years?: InputMaybe<Scalars['Int']['input']>;
};

/** How often an expense recurs — exactly one variant must be set (oneOf). */
export type PlanningExpenseFrequencyInput =
  /** A standard cashflow period. */
  { readonly every: PlanningExpenseFrequencyEveryInput; readonly everyNYears?: never; }
  |  /** A multi-year cycle. */
  { readonly every?: never; readonly everyNYears: PlanningExpenseFrequencyEveryNYearsInput; };

/** A plan expense. `annualDollarAmount` is derived, so it is not an argument. */
export type PlanningExpenseInput = {
  /** Whether it is deductible above the line. */
  readonly aboveTheLineDeduction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the amount is per period or already annual. */
  readonly amountBasis?: InputMaybe<PlanningAmountBasis>;
  /** A free-text label. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The amount in dollars, as entered. */
  readonly dollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** When it stops. */
  readonly endsOn?: InputMaybe<PlanningDateBoundaryInput>;
  /** The engine's identifier for this expense. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** How often it recurs. */
  readonly frequency?: InputMaybe<PlanningExpenseFrequencyInput>;
  /** How the amount grows. */
  readonly indexation?: InputMaybe<PlanningIndexationInput>;
  /** Who the expense belongs to. */
  readonly owners?: InputMaybe<PlanningOwnersInput>;
  /** When it starts. */
  readonly startsOn?: InputMaybe<PlanningDateBoundaryInput>;
  /** What kind of expense it is. */
  readonly type: PlanningExpenseType;
};

/** What kind of expense this is */
export const PlanningExpenseType = {
  /** alimony */
  Alimony: 'alimony',
  /** carrying_charges_and_interest */
  CarryingChargesAndInterest: 'carrying_charges_and_interest',
  /** charitable_donation */
  CharitableDonation: 'charitable_donation',
  /** child_support */
  ChildSupport: 'child_support',
  /** discretionary */
  Discretionary: 'discretionary',
  /** medical */
  Medical: 'medical',
  /** necessity */
  Necessity: 'necessity',
  /** other_deductible_amounts */
  OtherDeductibleAmounts: 'other_deductible_amounts',
  /** self_employment_business */
  SelfEmploymentBusiness: 'self_employment_business'
} as const;

export type PlanningExpenseType = typeof PlanningExpenseType[keyof typeof PlanningExpenseType];
/** How often a fee is charged */
export const PlanningFeeFrequency = {
  /** annually */
  Annually: 'annually',
  /** bimonthly */
  Bimonthly: 'bimonthly',
  /** monthly */
  Monthly: 'monthly',
  /** quarterly */
  Quarterly: 'quarterly',
  /** semi_annually */
  SemiAnnually: 'semi_annually'
} as const;

export type PlanningFeeFrequency = typeof PlanningFeeFrequency[keyof typeof PlanningFeeFrequency];
/** How often a cashflow recurs */
export const PlanningFrequency = {
  /** annually */
  Annually: 'annually',
  /** bimonthly */
  Bimonthly: 'bimonthly',
  /** biweekly */
  Biweekly: 'biweekly',
  /** daily */
  Daily: 'daily',
  /** monthly */
  Monthly: 'monthly',
  /** one_time */
  OneTime: 'one_time',
  /** quarterly */
  Quarterly: 'quarterly',
  /** semi_annually */
  SemiAnnually: 'semi_annually',
  /** twice_monthly */
  TwiceMonthly: 'twice_monthly',
  /** weekly */
  Weekly: 'weekly'
} as const;

export type PlanningFrequency = typeof PlanningFrequency[keyof typeof PlanningFrequency];
/** Whether a planned exercise holds or sells the shares */
export const PlanningFutureExerciseIntent = {
  /** exercise_and_hold */
  ExerciseAndHold: 'exercise_and_hold',
  /** exercise_to_sell */
  ExerciseToSell: 'exercise_to_sell',
  /** sell_to_cover */
  SellToCover: 'sell_to_cover'
} as const;

export type PlanningFutureExerciseIntent = typeof PlanningFutureExerciseIntent[keyof typeof PlanningFutureExerciseIntent];
/** Something the household is saving for, and also the retirement and moves the plan is built around. */
export type PlanningGoal = {
  readonly __typename?: 'PlanningGoal';
  /** A free-text label. */
  readonly description: Scalars['String']['output'];
  /** The fields specific to what the goal is for. */
  readonly details?: Maybe<PlanningGoalDetails>;
  /** The engine's identifier for this goal. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** Whose goal it is. */
  readonly owners?: Maybe<PlanningOwners>;
  /** How it is tracking against its funding. */
  readonly status?: Maybe<PlanningGoalStatus>;
  /** What the goal is for. */
  readonly type: PlanningGoalType;
};

/** The fields specific to what a goal is for. */
export type PlanningGoalDetails = PlanningGoalDetailsCashReserve | PlanningGoalDetailsOneOffExpense | PlanningGoalDetailsRecurringExpense | PlanningGoalDetailsResidence | PlanningGoalDetailsRetirement;

/** An emergency fund, measured against salary, expenses, or a figure typed in. */
export type PlanningGoalDetailsCashReserve = {
  readonly __typename?: 'PlanningGoalDetailsCashReserve';
  /** What the target is measured against. */
  readonly basis?: Maybe<PlanningCashReserveBasis>;
  /** The plan-side accounts holding the reserve, so one spread over two names both. */
  readonly fundedByAccountRefs?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** How much of the reserve is a line of credit rather than cash. */
  readonly fundedByLineOfCreditDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** How the target grows. */
  readonly indexation?: Maybe<PlanningIndexation>;
  /** How many months of the basis to hold. It multiplies salary or expenses; the target stands alone on a custom amount. */
  readonly months?: Maybe<Scalars['Int']['output']>;
  /** The target in dollars. */
  readonly targetDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
};

/** An emergency fund, measured against salary, expenses, or a figure typed in. */
export type PlanningGoalDetailsCashReserveInput = {
  /** What the target is measured against. */
  readonly basis?: InputMaybe<PlanningCashReserveBasis>;
  /** The plan-side accounts holding the reserve, so one spread over two names both. */
  readonly fundedByAccountRefs?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** How much of the reserve is a line of credit rather than cash. */
  readonly fundedByLineOfCreditDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** How the target grows. */
  readonly indexation?: InputMaybe<PlanningIndexationInput>;
  /** How many months of the basis to hold. It multiplies salary or expenses; the target stands alone on a custom amount. */
  readonly months?: InputMaybe<Scalars['Int']['input']>;
  /** The target in dollars. */
  readonly targetDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** The fields specific to what a goal is for. */
export type PlanningGoalDetailsInput =
  /** An emergency fund, measured against salary, expenses, or a figure typed in. */
  { readonly cashReserve: PlanningGoalDetailsCashReserveInput; readonly oneOffExpense?: never; readonly recurringExpense?: never; readonly residence?: never; readonly retirement?: never; }
  |  /** A single cost at a point in time. */
  { readonly cashReserve?: never; readonly oneOffExpense: PlanningGoalDetailsOneOffExpenseInput; readonly recurringExpense?: never; readonly residence?: never; readonly retirement?: never; }
  |  /** A cost that repeats on a whole-year interval. */
  { readonly cashReserve?: never; readonly oneOffExpense?: never; readonly recurringExpense: PlanningGoalDetailsRecurringExpenseInput; readonly residence?: never; readonly retirement?: never; }
  |  /** Buying a home. */
  { readonly cashReserve?: never; readonly oneOffExpense?: never; readonly recurringExpense?: never; readonly residence: PlanningGoalDetailsResidenceInput; readonly retirement?: never; }
  |  /** One member retiring. */
  { readonly cashReserve?: never; readonly oneOffExpense?: never; readonly recurringExpense?: never; readonly residence?: never; readonly retirement: PlanningGoalDetailsRetirementInput; };

/** A single cost at a point in time. Several goal types share this shape, so the goal's type is what tells them apart. */
export type PlanningGoalDetailsOneOffExpense = {
  readonly __typename?: 'PlanningGoalDetailsOneOffExpense';
  /** What it costs, in dollars. */
  readonly costDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** How the cost grows before it is spent. */
  readonly indexation?: Maybe<PlanningIndexation>;
  /** When it happens. */
  readonly occursOn?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** A single cost at a point in time. Several goal types share this shape, so the goal's type is what tells them apart. */
export type PlanningGoalDetailsOneOffExpenseInput = {
  /** What it costs, in dollars. */
  readonly costDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** How the cost grows before it is spent. */
  readonly indexation?: InputMaybe<PlanningIndexationInput>;
  /** When it happens. */
  readonly occursOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/**
 * A cost that repeats on a whole-year interval until it ends. There is no
 * sub-annual frequency: Conquest holds only the number of years between occurrences.
 */
export type PlanningGoalDetailsRecurringExpense = {
  readonly __typename?: 'PlanningGoalDetailsRecurringExpense';
  /** What each occurrence costs, in dollars. */
  readonly costDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** When it stops recurring. */
  readonly endsOn?: Maybe<PlanningDateBoundary>;
  /** How the cost grows between occurrences. */
  readonly indexation?: Maybe<PlanningIndexation>;
  /** Whole years between occurrences. Conquest caps this at 50. */
  readonly repeatsEveryYears?: Maybe<Scalars['Int']['output']>;
  /** When the first occurrence happens. */
  readonly startsOn?: Maybe<PlanningDateBoundary>;
};

/**
 * A cost that repeats on a whole-year interval until it ends. There is no
 * sub-annual frequency: Conquest holds only the number of years between occurrences.
 */
export type PlanningGoalDetailsRecurringExpenseInput = {
  /** What each occurrence costs, in dollars. */
  readonly costDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** When it stops recurring. */
  readonly endsOn?: InputMaybe<PlanningDateBoundaryInput>;
  /** How the cost grows between occurrences. */
  readonly indexation?: InputMaybe<PlanningIndexationInput>;
  /** Whole years between occurrences. Conquest caps this at 50. */
  readonly repeatsEveryYears?: InputMaybe<Scalars['Int']['input']>;
  /** When the first occurrence happens. */
  readonly startsOn?: InputMaybe<PlanningDateBoundaryInput>;
};

/**
 * Buying a home. Repeats four of the one-off fields rather than extending them: a
 * sealed union cannot share a base, and only a residence appreciates.
 */
export type PlanningGoalDetailsResidence = {
  readonly __typename?: 'PlanningGoalDetailsResidence';
  /** What it costs, in dollars. */
  readonly costDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** How the property appreciates once owned, as a whole-number percentage. */
  readonly growthRate?: Maybe<Scalars['BigDecimal']['output']>;
  /** How the cost grows before it is spent. */
  readonly indexation?: Maybe<PlanningIndexation>;
  /** When it is bought. */
  readonly occursOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether it becomes the principal residence. */
  readonly principalResidence?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Buying a home. Repeats four of the one-off fields rather than extending them: a
 * sealed union cannot share a base, and only a residence appreciates.
 */
export type PlanningGoalDetailsResidenceInput = {
  /** What it costs, in dollars. */
  readonly costDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** How the property appreciates once owned, as a whole-number percentage. */
  readonly growthRate?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** How the cost grows before it is spent. */
  readonly indexation?: InputMaybe<PlanningIndexationInput>;
  /** When it is bought. */
  readonly occursOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Whether it becomes the principal residence. */
  readonly principalResidence?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * One goal per member: whose retirement this is comes from the goal's owners, so a
 * couple has two and neither is the other's co-client.
 */
export type PlanningGoalDetailsRetirement = {
  readonly __typename?: 'PlanningGoalDetailsRetirement';
  /** When the member retires. */
  readonly retires?: Maybe<PlanningMemberRetirement>;
};

/**
 * One goal per member: whose retirement this is comes from the goal's owners, so a
 * couple has two and neither is the other's co-client.
 */
export type PlanningGoalDetailsRetirementInput = {
  /** When the member retires. */
  readonly retires?: InputMaybe<PlanningMemberRetirementInput>;
};

/** Something the household is saving for, and also the retirement and moves the plan is built around. */
export type PlanningGoalInput = {
  /** A free-text label. */
  readonly description: Scalars['String']['input'];
  /** The fields specific to what the goal is for. */
  readonly details?: InputMaybe<PlanningGoalDetailsInput>;
  /** The engine's identifier for this goal. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** Whose goal it is. */
  readonly owners?: InputMaybe<PlanningOwnersInput>;
  /** How it is tracking against its funding. */
  readonly status?: InputMaybe<PlanningGoalStatus>;
  /** What the goal is for. */
  readonly type: PlanningGoalType;
};

/** How the goal is tracking against its funding. */
export const PlanningGoalStatus = {
  /** at_risk */
  AtRisk: 'at_risk',
  /** funded */
  Funded: 'funded',
  /** not_started */
  NotStarted: 'not_started',
  /** on_track */
  OnTrack: 'on_track'
} as const;

export type PlanningGoalStatus = typeof PlanningGoalStatus[keyof typeof PlanningGoalStatus];
/** What the goal is for. Several types share one details shape, so this is what tells them apart. */
export const PlanningGoalType = {
  /** cash_reserve */
  CashReserve: 'cash_reserve',
  /** major_expense */
  MajorExpense: 'major_expense',
  /** personal_property */
  PersonalProperty: 'personal_property',
  /** recurring_expense */
  RecurringExpense: 'recurring_expense',
  /** residence */
  Residence: 'residence',
  /** retirement */
  Retirement: 'retirement',
  /** vacation */
  Vacation: 'vacation',
  /** vehicle */
  Vehicle: 'vehicle',
  /** wedding */
  Wedding: 'wedding'
} as const;

export type PlanningGoalType = typeof PlanningGoalType[keyof typeof PlanningGoalType];
/** A person in the household — the client or the co-client. */
export type PlanningHouseholdMember = {
  readonly __typename?: 'PlanningHouseholdMember';
  /** Date of birth. */
  readonly birthDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The Savvy client profile this came from. */
  readonly clientProfileId: Scalars['String']['output'];
  /** Estimated age at death, when overridden. */
  readonly deathAgeEstimated?: Maybe<Scalars['Int']['output']>;
  /** The engine's identifier for this person. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** First name. */
  readonly firstName: Scalars['String']['output'];
  /** Whether the person has a disability. */
  readonly hasDisability?: Maybe<Scalars['Boolean']['output']>;
  /** Last name. */
  readonly lastName: Scalars['String']['output'];
  /** Sex at birth, which drives mortality assumptions. */
  readonly sexAtBirth?: Maybe<PlanningSexAtBirth>;
  /** State of residence. */
  readonly state?: Maybe<StateCode>;
  /** Filing status. */
  readonly taxStatus?: Maybe<PlanningTaxStatus>;
};

/** A person in the household. */
export type PlanningHouseholdMemberInput = {
  /** Date of birth. */
  readonly birthDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The Savvy client profile this came from. */
  readonly clientProfileId: Scalars['String']['input'];
  /** Estimated age at death, when overridden. */
  readonly deathAgeEstimated?: InputMaybe<Scalars['Int']['input']>;
  /** The engine's identifier for this person. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** First name. */
  readonly firstName: Scalars['String']['input'];
  /** Whether the person has a disability. */
  readonly hasDisability?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name. */
  readonly lastName: Scalars['String']['input'];
  /** Sex at birth, which drives mortality assumptions. */
  readonly sexAtBirth?: InputMaybe<PlanningSexAtBirth>;
  /** State of residence. */
  readonly state?: InputMaybe<StateCode>;
  /** Filing status. */
  readonly taxStatus?: InputMaybe<PlanningTaxStatus>;
};

/** How an HSA is funded: an elected level, or the annual limit. */
export type PlanningHsaContributions = PlanningHsaContributionsElected | PlanningHsaContributionsMaxOut;

/** A chosen contribution level, as a percentage of salary or a dollar amount. */
export type PlanningHsaContributionsElected = {
  readonly __typename?: 'PlanningHsaContributionsElected';
  /** Whether the contribution is a percentage of salary or a dollar amount. */
  readonly contributionBasis?: Maybe<PlanningContributionBasis>;
  /** When contributions stop. */
  readonly endsOn?: Maybe<PlanningDateBoundary>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** When contributions start. */
  readonly startsOn?: Maybe<PlanningDateBoundary>;
};

/** A chosen contribution level, as a percentage of salary or a dollar amount. */
export type PlanningHsaContributionsElectedInput = {
  /** Whether the contribution is a percentage of salary or a dollar amount. */
  readonly contributionBasis?: InputMaybe<PlanningContributionBasisInput>;
  /** When contributions stop. */
  readonly endsOn?: InputMaybe<PlanningDateBoundaryInput>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** When contributions start. */
  readonly startsOn?: InputMaybe<PlanningDateBoundaryInput>;
};

/** How an HSA is funded: an elected level, or the annual limit. */
export type PlanningHsaContributionsInput =
  /** A chosen contribution level, as a percentage of salary or a dollar amount. */
  { readonly elected: PlanningHsaContributionsElectedInput; readonly maxOut?: never; }
  |  /** Contribute the annual limit. */
  { readonly elected?: never; readonly maxOut: PlanningHsaContributionsMaxOutInput; };

/** Contribute the annual limit. Bounded by tax year rather than by date, because the limit is annual. */
export type PlanningHsaContributionsMaxOut = {
  readonly __typename?: 'PlanningHsaContributionsMaxOut';
  /** Last tax year to contribute in. */
  readonly endTaxYear?: Maybe<Scalars['Int']['output']>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** First tax year to contribute in. */
  readonly startTaxYear?: Maybe<Scalars['Int']['output']>;
};

/** Contribute the annual limit. Bounded by tax year rather than by date, because the limit is annual. */
export type PlanningHsaContributionsMaxOutInput = {
  /** Last tax year to contribute in. */
  readonly endTaxYear?: InputMaybe<Scalars['Int']['input']>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** First tax year to contribute in. */
  readonly startTaxYear?: InputMaybe<Scalars['Int']['input']>;
};

export type PlanningImportFileOutcome = {
  readonly __typename?: 'PlanningImportFileOutcome';
  /** The file name. */
  readonly displayName?: Maybe<Scalars['String']['output']>;
  /** Pages that were not read, in the original file numbering. */
  readonly gapPages: ReadonlyArray<Scalars['Int']['output']>;
  /** read, read_with_gaps, skipped, or failed. */
  readonly outcome: Scalars['String']['output'];
  /** Why the file was skipped or failed. */
  readonly reason?: Maybe<Scalars['String']['output']>;
  /** The Box file identifier. */
  readonly sourceId: Scalars['String']['output'];
};

export type PlanningImportStatus = {
  readonly __typename?: 'PlanningImportStatus';
  /** Proposals the import has emitted so far. */
  readonly admittedCount: Scalars['Int']['output'];
  /** Whether proposals the import accepted are still being written to the plan. */
  readonly applying: Scalars['Boolean']['output'];
  /** Records this import created, as `<entity>:<id>` keys, for a day after it finishes. */
  readonly createdRecordKeys: ReadonlyArray<Scalars['String']['output']>;
  /** How each selected file ended, once the import finishes. */
  readonly fileOutcomes: ReadonlyArray<PlanningImportFileOutcome>;
  /** The plan being enriched. */
  readonly financialPlanId: Scalars['ID']['output'];
  /** The import operation identifier. */
  readonly id: Scalars['ID']['output'];
  /** The durable import phase. */
  readonly phase: Scalars['String']['output'];
  /** The number of sources with an internal outcome. */
  readonly processedSourceCount: Scalars['Int']['output'];
  /** The number of selected sources. */
  readonly sourceCount: Scalars['Int']['output'];
};

/** A plan income. */
export type PlanningIncome = {
  readonly __typename?: 'PlanningIncome';
  /** A free-text label. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The kind-specific details. */
  readonly details?: Maybe<PlanningIncomeDetails>;
  /** The engine's identifier for this income. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /**
   * The Savvy record this income was seeded from. Null when authored in the plan.
   * Provenance only; not synchronized after creation.
   */
  readonly incomeSourceId?: Maybe<Scalars['String']['output']>;
  /** Who receives it. */
  readonly owners: PlanningOwners;
  /** What kind of income it is. */
  readonly type: PlanningIncomeType;
};

/** A defined benefit pension. */
export type PlanningIncomeDefinedBenefitPension = {
  readonly __typename?: 'PlanningIncomeDefinedBenefitPension';
  /** The IRC 7520 rate used for estate valuation, as a whole-number percentage. */
  readonly irc7520Rate?: Maybe<Scalars['BigDecimal']['output']>;
  /** The share payable to a survivor, as a whole-number percentage. */
  readonly payableToSurvivor?: Maybe<Scalars['BigDecimal']['output']>;
  /** When payments start. */
  readonly paymentStartsOn?: Maybe<PlanningDateBoundary>;
  /** Lifetime income or a lump sum. */
  readonly payout?: Maybe<PlanningPensionPayout>;
  /** Primary benefit indexation, as a whole-number percentage. */
  readonly primaryBenefitIndexation?: Maybe<Scalars['BigDecimal']['output']>;
  /** The monthly primary benefit in dollars. */
  readonly primaryBenefitMonthlyDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
};

/** A defined benefit pension. */
export type PlanningIncomeDefinedBenefitPensionInput = {
  /** The IRC 7520 rate, as a whole-number percentage. */
  readonly irc7520Rate?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The share payable to a survivor, as a whole-number percentage. */
  readonly payableToSurvivor?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** When payments start. */
  readonly paymentStartsOn?: InputMaybe<PlanningDateBoundaryInput>;
  /** Lifetime income or a lump sum. */
  readonly payout?: InputMaybe<PlanningPensionPayoutInput>;
  /** Primary benefit indexation, as a whole-number percentage. */
  readonly primaryBenefitIndexation?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The monthly primary benefit in dollars. */
  readonly primaryBenefitMonthlyDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/**
 * The details of an income. The three kinds carry genuinely different fields,
 * which is why this is a union rather than one flat type.
 */
export type PlanningIncomeDetails = PlanningIncomeDefinedBenefitPension | PlanningIncomeSocialSecurity | PlanningIncomeStandard;

/** The kind-specific details of an income — exactly one variant must be set (oneOf). */
export type PlanningIncomeDetailsInput =
  /** A defined benefit pension. */
  { readonly definedBenefitPension: PlanningIncomeDefinedBenefitPensionInput; readonly socialSecurity?: never; readonly standard?: never; }
  |  /** Social Security. */
  { readonly definedBenefitPension?: never; readonly socialSecurity: PlanningIncomeSocialSecurityInput; readonly standard?: never; }
  |  /** Ordinary income. */
  { readonly definedBenefitPension?: never; readonly socialSecurity?: never; readonly standard: PlanningIncomeStandardInput; };

/** A plan income. */
export type PlanningIncomeInput = {
  /** A free-text label. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The kind-specific details. */
  readonly details?: InputMaybe<PlanningIncomeDetailsInput>;
  /** The engine's identifier for this income. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy record this income was seeded from. Omit when authored in the plan. Provenance only; not synced after creation. */
  readonly incomeSourceId?: InputMaybe<Scalars['String']['input']>;
  /** Who receives it. */
  readonly owners: PlanningOwnersInput;
  /** What kind of income it is. */
  readonly type: PlanningIncomeType;
};

/** Social Security, which carries a retirement benefit and a survivor benefit rather than a plain amount. */
export type PlanningIncomeSocialSecurity = {
  readonly __typename?: 'PlanningIncomeSocialSecurity';
  /** The retirement benefit. */
  readonly retirement?: Maybe<PlanningSocialSecurityRetirement>;
  /** The survivor benefit. */
  readonly survivor?: Maybe<PlanningSurvivorBenefit>;
};

/** Social Security, which carries a retirement and a survivor benefit rather than a plain amount. */
export type PlanningIncomeSocialSecurityInput = {
  /** The retirement benefit. */
  readonly retirement?: InputMaybe<PlanningSocialSecurityRetirementInput>;
  /** The survivor benefit. */
  readonly survivor?: InputMaybe<PlanningSurvivorBenefitInput>;
};

/** Ordinary income: an amount on a schedule, with boundaries and indexation. */
export type PlanningIncomeStandard = {
  readonly __typename?: 'PlanningIncomeStandard';
  /** Whether the amount is per period or already annual. */
  readonly amountBasis?: Maybe<PlanningAmountBasis>;
  /** The amount restated annually. Null for one-time income, which has no annual rate. */
  readonly annualDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** The amount in dollars, as entered. */
  readonly dollarAmount: Scalars['BigDecimal']['output'];
  /** When it stops. */
  readonly endsOn?: Maybe<PlanningDateBoundary>;
  /** How often it is received. */
  readonly frequency: PlanningFrequency;
  /** How the amount grows. */
  readonly indexation?: Maybe<PlanningIndexation>;
  /** When it starts. */
  readonly startsOn?: Maybe<PlanningDateBoundary>;
};

/** Ordinary income. `annualDollarAmount` is derived, so it is not an argument. */
export type PlanningIncomeStandardInput = {
  /** Whether the amount is per period or already annual. */
  readonly amountBasis?: InputMaybe<PlanningAmountBasis>;
  /** The amount in dollars, as entered. */
  readonly dollarAmount: Scalars['BigDecimal']['input'];
  /** When it stops. */
  readonly endsOn?: InputMaybe<PlanningDateBoundaryInput>;
  /** How often it is received. */
  readonly frequency: PlanningFrequency;
  /** How the amount grows. */
  readonly indexation?: InputMaybe<PlanningIndexationInput>;
  /** When it starts. */
  readonly startsOn?: InputMaybe<PlanningDateBoundaryInput>;
};

/** What kind of income this is */
export const PlanningIncomeType = {
  /** bonus */
  Bonus: 'bonus',
  /** capital_gains */
  CapitalGains: 'capital_gains',
  /** defined_benefit_pension */
  DefinedBenefitPension: 'defined_benefit_pension',
  /** dividends */
  Dividends: 'dividends',
  /** gratuities */
  Gratuities: 'gratuities',
  /** interest */
  Interest: 'interest',
  /** other_taxable */
  OtherTaxable: 'other_taxable',
  /** salary */
  Salary: 'salary',
  /** self_employment */
  SelfEmployment: 'self_employment',
  /** social_security */
  SocialSecurity: 'social_security',
  /** tax_free */
  TaxFree: 'tax_free'
} as const;

export type PlanningIncomeType = typeof PlanningIncomeType[keyof typeof PlanningIncomeType];
/** Plan-wide index rates. Unrelated to the per-item additional index rate on incomes and expenses. */
export type PlanningIndexRates = {
  readonly __typename?: 'PlanningIndexRates';
  /** Federal indexation, as a whole-number percentage. */
  readonly federalIndexation?: Maybe<Scalars['BigDecimal']['output']>;
  /** Plan inflation, as a whole-number percentage. */
  readonly planInflation?: Maybe<Scalars['BigDecimal']['output']>;
  /** State indexation, as a whole-number percentage. */
  readonly stateIndexation?: Maybe<Scalars['BigDecimal']['output']>;
  /** Wage-related indexation, as a whole-number percentage. */
  readonly wageRelatedIndexation?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Plan-wide index rates. */
export type PlanningIndexRatesInput = {
  /** Federal indexation, as a whole-number percentage. */
  readonly federalIndexation?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Plan inflation, as a whole-number percentage. */
  readonly planInflation?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** State indexation, as a whole-number percentage. */
  readonly stateIndexation?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Wage-related indexation, as a whole-number percentage. */
  readonly wageRelatedIndexation?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** How a money figure grows over the life of the plan. */
export type PlanningIndexation = {
  readonly __typename?: 'PlanningIndexation';
  /** Growth on top of inflation, as a whole-number percentage. */
  readonly additionalRate?: Maybe<Scalars['BigDecimal']['output']>;
  /** Whether the figure tracks plan inflation. */
  readonly toInflation?: Maybe<Scalars['Boolean']['output']>;
};

/** How a money figure grows over the life of the plan. */
export type PlanningIndexationInput = {
  /** Growth on top of inflation, as a whole-number percentage. */
  readonly additionalRate?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Whether the figure tracks plan inflation. */
  readonly toInflation?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A debt. It can come from our liabilities table or from an accounts row whose
 * kind is credit or loan, which is why its reference names the table too.
 */
export type PlanningLiability = {
  readonly __typename?: 'PlanningLiability';
  /** When the debt was taken on. Savvy holds this; the engine never sees it. */
  readonly acquiredAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Annual interest, as a whole-number percentage. */
  readonly annualInterestPercentage?: Maybe<Scalars['BigDecimal']['output']>;
  /** When the balance was assessed. */
  readonly balanceAsOfDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The outstanding balance in dollars. */
  readonly balanceOwingDollarAmount: Scalars['BigDecimal']['output'];
  /** A free-text label. */
  readonly description: Scalars['String']['output'];
  /** The engine's identifier for this debt. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** Whether the interest is deductible. */
  readonly interestIsTaxDeductible?: Maybe<Scalars['Boolean']['output']>;
  /** What was borrowed, in dollars. Savvy holds this; the engine never sees it. */
  readonly originalBalance?: Maybe<Scalars['BigDecimal']['output']>;
  /** Who owes it. */
  readonly owners: PlanningOwners;
  /** How the debt is serviced. */
  readonly payment?: Maybe<PlanningLiabilityPayment>;
  /** Savvy account subtype, falling back to account kind, or liability type_of. Separate from the engine planning type. */
  readonly savvyLiabilityType?: Maybe<Scalars['String']['output']>;
  /** The Savvy row this came from. */
  readonly savvyRef: PlanningSavvyRef;
  /** The provider this debt is synced from, for the accounts rows. Null for a liabilities row, which only we write. */
  readonly source?: Maybe<PlanningAccountSource>;
  /** What kind of debt it is. */
  readonly type: PlanningLiabilityType;
};

/** Which side of the amortisation is given: the term or the payment. */
export type PlanningLiabilityAmortisation = PlanningLiabilityAmortisationPayment | PlanningLiabilityAmortisationTerm;

/** Which side of the amortisation is given: the term or the payment. */
export type PlanningLiabilityAmortisationInput =
  /** Amortised from a fixed payment, with the term falling out of it. */
  { readonly payment: PlanningLiabilityAmortisationPaymentInput; readonly term?: never; }
  |  /** Amortised over a fixed number of years, with the payment falling out of it. */
  { readonly payment?: never; readonly term: PlanningLiabilityAmortisationTermInput; };

/** Amortised from a fixed payment, with the term falling out of it. */
export type PlanningLiabilityAmortisationPayment = {
  readonly __typename?: 'PlanningLiabilityAmortisationPayment';
  /** The payment in dollars. */
  readonly dollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Amortised from a fixed payment, with the term falling out of it. */
export type PlanningLiabilityAmortisationPaymentInput = {
  /** The payment in dollars. */
  readonly dollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** Amortised over a fixed number of years, with the payment falling out of it. */
export type PlanningLiabilityAmortisationTerm = {
  readonly __typename?: 'PlanningLiabilityAmortisationTerm';
  /** The term in years. */
  readonly years?: Maybe<Scalars['Int']['output']>;
};

/** Amortised over a fixed number of years, with the payment falling out of it. */
export type PlanningLiabilityAmortisationTermInput = {
  /** The term in years. */
  readonly years?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A debt. It can come from our liabilities table or from an accounts row whose
 * kind is credit or loan, which is why its reference names the table too.
 */
export type PlanningLiabilityInput = {
  /** When the debt was taken on. Required to create a debt Savvy has no record of. */
  readonly acquiredAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Annual interest, as a whole-number percentage. */
  readonly annualInterestPercentage?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** When the balance was assessed. */
  readonly balanceAsOfDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The outstanding balance in dollars. */
  readonly balanceOwingDollarAmount: Scalars['BigDecimal']['input'];
  /** A free-text label. */
  readonly description: Scalars['String']['input'];
  /** The engine's identifier for this debt. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the interest is deductible. */
  readonly interestIsTaxDeductible?: InputMaybe<Scalars['Boolean']['input']>;
  /** What was borrowed, in dollars. Required to create a debt Savvy has no record of. */
  readonly originalBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Who owes it. */
  readonly owners: PlanningOwnersInput;
  /** How the debt is serviced. */
  readonly payment?: InputMaybe<PlanningLiabilityPaymentInput>;
  /** The Savvy row this came from. Empty — no table and no row — for a debt added in the plan. */
  readonly savvyRef: PlanningSavvyRefInput;
  /** What kind of debt it is. */
  readonly type: PlanningLiabilityType;
};

/** How the debt is serviced: interest only, or principal and interest. */
export type PlanningLiabilityPayment = PlanningLiabilityPaymentInterestOnly | PlanningLiabilityPaymentPrincipalAndInterest;

/** How the debt is serviced: interest only, or principal and interest. */
export type PlanningLiabilityPaymentInput =
  /** Interest is serviced and the principal is not repaid. */
  { readonly interestOnly: PlanningLiabilityPaymentInterestOnlyInput; readonly principalAndInterest?: never; }
  |  /** The debt amortises: each payment covers interest and reduces the principal. */
  { readonly interestOnly?: never; readonly principalAndInterest: PlanningLiabilityPaymentPrincipalAndInterestInput; };

/** Interest is serviced and the principal is not repaid. */
export type PlanningLiabilityPaymentInterestOnly = {
  readonly __typename?: 'PlanningLiabilityPaymentInterestOnly';
  /** A credit limit on a revolving debt, a payment on a loan. The liability type decides which. */
  readonly dollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** How often the payment is made. */
  readonly paymentFrequency?: Maybe<PlanningFrequency>;
};

/** Interest is serviced and the principal is not repaid. */
export type PlanningLiabilityPaymentInterestOnlyInput = {
  /** A credit limit on a revolving debt, a payment on a loan. The liability type decides which. */
  readonly dollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** How often the payment is made. */
  readonly paymentFrequency?: InputMaybe<PlanningFrequency>;
};

/** The debt amortises: each payment covers interest and reduces the principal. */
export type PlanningLiabilityPaymentPrincipalAndInterest = {
  readonly __typename?: 'PlanningLiabilityPaymentPrincipalAndInterest';
  /** Whether the term or the payment is the given side. */
  readonly calculateBy?: Maybe<PlanningLiabilityAmortisation>;
  /** How often interest compounds. */
  readonly compoundFrequency?: Maybe<PlanningFrequency>;
  /** How often the payment is made. */
  readonly paymentFrequency?: Maybe<PlanningFrequency>;
};

/** The debt amortises: each payment covers interest and reduces the principal. */
export type PlanningLiabilityPaymentPrincipalAndInterestInput = {
  /** Whether the term or the payment is the given side. */
  readonly calculateBy?: InputMaybe<PlanningLiabilityAmortisationInput>;
  /** How often interest compounds. */
  readonly compoundFrequency?: InputMaybe<PlanningFrequency>;
  /** How often the payment is made. */
  readonly paymentFrequency?: InputMaybe<PlanningFrequency>;
};

/** What kind of debt this is. It is also what decides whether the interest-only amount reads as a credit limit or as a payment. */
export const PlanningLiabilityType = {
  /** auto */
  Auto: 'auto',
  /** business_loan */
  BusinessLoan: 'business_loan',
  /** credit_card */
  CreditCard: 'credit_card',
  /** line_of_credit */
  LineOfCredit: 'line_of_credit',
  /** mortgage */
  Mortgage: 'mortgage',
  /** other */
  Other: 'other',
  /** personal_loan */
  PersonalLoan: 'personal_loan',
  /** student_loan */
  StudentLoan: 'student_loan'
} as const;

export type PlanningLiabilityType = typeof PlanningLiabilityType[keyof typeof PlanningLiabilityType];
/** How long the plan assumes each member lives. */
export type PlanningLifeExpectancy = {
  readonly __typename?: 'PlanningLifeExpectancy';
  /** The client's life expectancy in years. */
  readonly clientAge?: Maybe<Scalars['Int']['output']>;
  /** The co-client's life expectancy in years. */
  readonly coClientAge?: Maybe<Scalars['Int']['output']>;
};

/** How long the plan assumes each member lives. */
export type PlanningLifeExpectancyInput = {
  /** The client's life expectancy in years. */
  readonly clientAge?: InputMaybe<Scalars['Int']['input']>;
  /** The co-client's life expectancy in years. */
  readonly coClientAge?: InputMaybe<Scalars['Int']['input']>;
};

/** A real asset the household lives with rather than rents out. */
export type PlanningLifestyleAsset = PlanningRealAsset & {
  readonly __typename?: 'PlanningLifestyleAsset';
  /** The Savvy record this came from. */
  readonly assetId: Scalars['String']['output'];
  /** Whether it can be sold to cover estate costs. */
  readonly availableForEstateLiquidity?: Maybe<Scalars['Boolean']['output']>;
  /** A free-text label. */
  readonly description: Scalars['String']['output'];
  /** The engine's identifier for this asset. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** Annual growth, as a whole-number percentage. */
  readonly growthRate?: Maybe<Scalars['BigDecimal']['output']>;
  /** Current market value in dollars. */
  readonly marketValue: Scalars['BigDecimal']['output'];
  /** Who owns it. */
  readonly owners: PlanningOwners;
  /** Whether this is the principal residence. Nothing enforces at most one across a plan. */
  readonly principalResidence?: Maybe<Scalars['Boolean']['output']>;
  /** Property tax, as a rate or a dollar amount. Absent on an asset taxed as neither land nor a building. */
  readonly propertyTax?: Maybe<PlanningPropertyTax>;
  /** What was paid for it, in dollars. */
  readonly purchaseDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** Savvy asset subclass where the class defines one, otherwise the asset class. Separate from the engine planning type. */
  readonly savvyAssetType?: Maybe<Scalars['String']['output']>;
  /** What kind of asset it is. */
  readonly type: PlanningLifestyleAssetType;
  /** When the market value was assessed. */
  readonly valuationDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** A real asset the household lives with rather than rents out. */
export type PlanningLifestyleAssetInput = {
  /** The Savvy record this came from. Left out for an asset added in the plan, which has no Savvy row yet. */
  readonly assetId?: InputMaybe<Scalars['String']['input']>;
  /** Whether it can be sold to cover estate costs. */
  readonly availableForEstateLiquidity?: InputMaybe<Scalars['Boolean']['input']>;
  /** A free-text label. */
  readonly description: Scalars['String']['input'];
  /** The engine's identifier for this asset. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** Annual growth, as a whole-number percentage. */
  readonly growthRate?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Current market value in dollars. */
  readonly marketValue: Scalars['BigDecimal']['input'];
  /** Who owns it. */
  readonly owners: PlanningOwnersInput;
  /** Whether this is the principal residence. Nothing enforces at most one across a plan. */
  readonly principalResidence?: InputMaybe<Scalars['Boolean']['input']>;
  /** Property tax, as a rate or a dollar amount. Absent on an asset taxed as neither land nor a building. */
  readonly propertyTax?: InputMaybe<PlanningPropertyTaxInput>;
  /** What was paid for it, in dollars. */
  readonly purchaseDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** What kind of asset it is. */
  readonly type: PlanningLifestyleAssetType;
  /** When the market value was assessed. */
  readonly valuationDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** What kind of lifestyle asset this is. */
export const PlanningLifestyleAssetType = {
  /** collectible */
  Collectible: 'collectible',
  /** insurance_policy */
  InsurancePolicy: 'insurance_policy',
  /** other_asset */
  OtherAsset: 'other_asset',
  /** personal_property */
  PersonalProperty: 'personal_property',
  /** residence */
  Residence: 'residence',
  /** vehicle */
  Vehicle: 'vehicle'
} as const;

export type PlanningLifestyleAssetType = typeof PlanningLifestyleAssetType[keyof typeof PlanningLifestyleAssetType];
/** The income an account contribution is taken from. */
export const PlanningLinkToIncome = {
  /** employer_income */
  EmployerIncome: 'employer_income',
  /** self_employment */
  SelfEmployment: 'self_employment'
} as const;

export type PlanningLinkToIncome = typeof PlanningLinkToIncome[keyof typeof PlanningLinkToIncome];
/** When a household member retires. */
export type PlanningMemberRetirement = PlanningAlreadyRetired | PlanningRetireAtAge | PlanningRetireOnDate;

/** When a household member retires — exactly one variant must be set (oneOf). */
export type PlanningMemberRetirementInput =
  /** Already retired. */
  { readonly alreadyRetired: PlanningAlreadyRetiredInput; readonly atAge?: never; readonly onDate?: never; }
  |  /** At a given age. */
  { readonly alreadyRetired?: never; readonly atAge: PlanningRetireAtAgeInput; readonly onDate?: never; }
  |  /** On a fixed date. */
  { readonly alreadyRetired?: never; readonly atAge?: never; readonly onDate: PlanningRetireOnDateInput; };

/** A named beneficiary. Excludes the estate, which cannot appear in a multi-beneficiary list. */
export type PlanningNamedBeneficiary = PlanningBeneficiaryClient | PlanningBeneficiaryDependant;

/** A named beneficiary, excluding the estate — exactly one variant must be set (oneOf). */
export type PlanningNamedBeneficiaryInput =
  /** A household member. */
  { readonly client: PlanningBeneficiaryClientInput; readonly dependant?: never; }
  |  /** A dependant. */
  { readonly client?: never; readonly dependant: PlanningBeneficiaryDependantInput; };

/** A one-time or repeating occurrence. A one-time occurrence has no end date and a repeating one always does. */
export type PlanningOccurrence = PlanningOccurrenceOnce | PlanningOccurrenceRepeating;

/** A one-time or repeating occurrence — exactly one variant must be set (oneOf). */
export type PlanningOccurrenceInput =
  /** Happens on a single date. */
  { readonly once: PlanningOccurrenceOnceInput; readonly repeating?: never; }
  |  /** Happens on a repeating schedule. */
  { readonly once?: never; readonly repeating: PlanningOccurrenceRepeatingInput; };

/** Something that happens on a single date. */
export type PlanningOccurrenceOnce = {
  readonly __typename?: 'PlanningOccurrenceOnce';
  /** The date it happens. */
  readonly on?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Something that happens on a single date. */
export type PlanningOccurrenceOnceInput = {
  /** The date it happens. */
  readonly on?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Something that happens on a repeating schedule, which therefore has both boundaries. */
export type PlanningOccurrenceRepeating = {
  readonly __typename?: 'PlanningOccurrenceRepeating';
  /** When it stops. */
  readonly endsOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** How often it repeats. */
  readonly frequency?: Maybe<PlanningFrequency>;
  /** When it starts. */
  readonly startsOn?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Something that happens on a repeating schedule. */
export type PlanningOccurrenceRepeatingInput = {
  /** When it stops. */
  readonly endsOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** How often it repeats. */
  readonly frequency?: InputMaybe<PlanningFrequency>;
  /** When it starts. */
  readonly startsOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Who owns an item. Named profiles rather than a client/co-client pair, so a jointly owned item says which two people own it. */
export type PlanningOwners = {
  readonly __typename?: 'PlanningOwners';
  /** The household members who own this item. */
  readonly clientProfileIds: ReadonlyArray<Scalars['String']['output']>;
  /** Individual or joint. */
  readonly ownershipType?: Maybe<PlanningOwnershipType>;
};

/** Who owns an item. */
export type PlanningOwnersInput = {
  /** The household members who own this item. */
  readonly clientProfileIds: ReadonlyArray<Scalars['String']['input']>;
  /** Individual or joint. */
  readonly ownershipType?: InputMaybe<PlanningOwnershipType>;
};

/** Whether an item is owned individually or jointly */
export const PlanningOwnershipType = {
  /** individual */
  Individual: 'individual',
  /** joint */
  Joint: 'joint'
} as const;

export type PlanningOwnershipType = typeof PlanningOwnershipType[keyof typeof PlanningOwnershipType];
/** A pension paid as income for life. */
export type PlanningPensionLifetimeIncome = {
  readonly __typename?: 'PlanningPensionLifetimeIncome';
  /** The Social Security offset, as a whole-number percentage, when the pension integrates with it. */
  readonly socialSecurityOffset?: Maybe<Scalars['BigDecimal']['output']>;
};

/** A pension paid as income for life. */
export type PlanningPensionLifetimeIncomeInput = {
  /** The Social Security offset, as a whole-number percentage. */
  readonly socialSecurityOffset?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** A pension taken as a single payment. */
export type PlanningPensionLumpSum = {
  readonly __typename?: 'PlanningPensionLumpSum';
  /** The lump sum in dollars. */
  readonly payoutDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** Where the lump sum is transferred. */
  readonly transferTo?: Maybe<PlanningPensionTransferTarget>;
};

/** A pension taken as a single payment. */
export type PlanningPensionLumpSumInput = {
  /** The lump sum in dollars. */
  readonly payoutDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Where the lump sum is transferred. */
  readonly transferTo?: InputMaybe<PlanningPensionTransferTarget>;
};

/** How a defined benefit pension pays out. */
export type PlanningPensionPayout = PlanningPensionLifetimeIncome | PlanningPensionLumpSum;

/** Lifetime income or a lump sum — exactly one variant must be set (oneOf). */
export type PlanningPensionPayoutInput =
  /** Income for life. */
  { readonly lifetimeIncome: PlanningPensionLifetimeIncomeInput; readonly lumpSum?: never; }
  |  /** A single payment. */
  { readonly lifetimeIncome?: never; readonly lumpSum: PlanningPensionLumpSumInput; };

/** Where a pension lump sum is transferred to */
export const PlanningPensionTransferTarget = {
  /** new_ira */
  NewIra: 'new_ira',
  /** not_applicable */
  NotApplicable: 'not_applicable'
} as const;

export type PlanningPensionTransferTarget = typeof PlanningPensionTransferTarget[keyof typeof PlanningPensionTransferTarget];
/** A dollar amount attributed to one owner, for where a jointly held item splits a figure between the people who own it. */
export type PlanningPerOwnerAmount = {
  readonly __typename?: 'PlanningPerOwnerAmount';
  /** The amount in dollars. */
  readonly dollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** The owner the amount belongs to. */
  readonly owner?: Maybe<Scalars['String']['output']>;
};

/** A dollar amount attributed to one owner. */
export type PlanningPerOwnerAmountInput = {
  /** The amount in dollars. */
  readonly dollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The owner the amount belongs to. */
  readonly owner?: InputMaybe<Scalars['String']['input']>;
};

/** A financial plan: our identifier for it, and the inputs the projection was built from. */
export type PlanningPlan = {
  readonly __typename?: 'PlanningPlan';
  /** Our `financial_plans` identifier. Not the engine's: the engine id stays inside the adapter. */
  readonly id: Scalars['String']['output'];
  /** Counts saved input changes. Send it back with `updatePlan`; a save carrying an older revision is refused. */
  readonly inputsRevision: Scalars['Int']['output'];
  /** The inputs the plan was built from. */
  readonly planData: PlanningPlanData;
};

/**
 * The inputs a plan is built from: the household, what it owns and owes, what
 * comes in and goes out, and what it is saving for.
 */
export type PlanningPlanData = {
  readonly __typename?: 'PlanningPlanData';
  /** What the household owns. */
  readonly assets?: Maybe<ReadonlyArray<PlanningAsset>>;
  /** The client. */
  readonly client: PlanningHouseholdMember;
  /** The co-client, on a couple. */
  readonly coClient?: Maybe<PlanningHouseholdMember>;
  /** Who depends on the household. */
  readonly dependants?: Maybe<ReadonlyArray<PlanningDependant>>;
  /** What goes out. */
  readonly expenses?: Maybe<ReadonlyArray<PlanningExpense>>;
  /** What it is saving for. */
  readonly goals?: Maybe<ReadonlyArray<PlanningGoal>>;
  /** What comes in. */
  readonly incomes?: Maybe<ReadonlyArray<PlanningIncome>>;
  /** What it owes. */
  readonly liabilities?: Maybe<ReadonlyArray<PlanningLiability>>;
  /** The assumptions the projection runs on. */
  readonly planSettings?: Maybe<PlanningPlanSettings>;
};

/**
 * The inputs a plan is built from: the household, what it owns and owes, what
 * comes in and goes out, and what it is saving for.
 */
export type PlanningPlanDataInput = {
  /** What the household owns. */
  readonly assets?: InputMaybe<ReadonlyArray<PlanningAssetInput>>;
  /** The client. */
  readonly client: PlanningHouseholdMemberInput;
  /** The co-client, on a couple. */
  readonly coClient?: InputMaybe<PlanningHouseholdMemberInput>;
  /** Who depends on the household. */
  readonly dependants?: InputMaybe<ReadonlyArray<PlanningDependantInput>>;
  /** What goes out. */
  readonly expenses?: InputMaybe<ReadonlyArray<PlanningExpenseInput>>;
  /** What it is saving for. */
  readonly goals?: InputMaybe<ReadonlyArray<PlanningGoalInput>>;
  /** What comes in. */
  readonly incomes?: InputMaybe<ReadonlyArray<PlanningIncomeInput>>;
  /** What it owes. */
  readonly liabilities?: InputMaybe<ReadonlyArray<PlanningLiabilityInput>>;
  /** The assumptions the projection runs on. */
  readonly planSettings?: InputMaybe<PlanningPlanSettingsInput>;
};

/** A named point in the plan that a boundary can hang off */
export const PlanningPlanEvent = {
  /** death */
  Death: 'death',
  /** first_to_die */
  FirstToDie: 'first_to_die',
  /** first_to_retire */
  FirstToRetire: 'first_to_retire',
  /** last_to_die */
  LastToDie: 'last_to_die',
  /** last_to_retire */
  LastToRetire: 'last_to_retire',
  /** plan_date */
  PlanDate: 'plan_date',
  /** retirement */
  Retirement: 'retirement',
  /** start_of_plan_year */
  StartOfPlanYear: 'start_of_plan_year'
} as const;

export type PlanningPlanEvent = typeof PlanningPlanEvent[keyof typeof PlanningPlanEvent];
/** Plan-wide assumptions. */
export type PlanningPlanSettings = {
  readonly __typename?: 'PlanningPlanSettings';
  /** The default external account fee, which an account can override. */
  readonly defaultAccountFees?: Maybe<PlanningAccountFees>;
  /** Whether tax provisions expire as currently legislated. */
  readonly expireAsLegislated?: Maybe<Scalars['Boolean']['output']>;
  /** Plan-wide index rates. */
  readonly indexRates?: Maybe<PlanningIndexRates>;
  /** How long each member lives. */
  readonly lifeExpectancy?: Maybe<PlanningLifeExpectancy>;
};

/** Plan-wide assumptions. */
export type PlanningPlanSettingsInput = {
  /** The default external account fee. */
  readonly defaultAccountFees?: InputMaybe<PlanningAccountFeesInput>;
  /** Whether tax provisions expire as currently legislated. */
  readonly expireAsLegislated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Plan-wide index rates. */
  readonly indexRates?: InputMaybe<PlanningIndexRatesInput>;
  /** How long each member lives. */
  readonly lifeExpectancy?: InputMaybe<PlanningLifeExpectancyInput>;
};

/**
 * One choice of asset allocation for an account, as defined in the planning
 * engine. Named `Portfolio` rather than `AssetAllocation` so consumers did not
 * have to change.
 */
export type PlanningPortfolioOption = {
  readonly __typename?: 'PlanningPortfolioOption';
  /** The value to send back as an account's `portfolio`, which is an asset allocation id. */
  readonly id: Scalars['String']['output'];
  /** How to name this asset allocation to an advisor. */
  readonly label: Scalars['String']['output'];
};

/** Property tax stated as a rate or as a dollar amount. */
export type PlanningPropertyTax = PlanningPropertyTaxAmount | PlanningPropertyTaxRate;

/** Property tax as a fixed dollar amount, which does need indexation. */
export type PlanningPropertyTaxAmount = {
  readonly __typename?: 'PlanningPropertyTaxAmount';
  /** The amount in dollars. */
  readonly dollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** How the amount grows. */
  readonly indexation?: Maybe<PlanningIndexation>;
};

/** Property tax as a fixed dollar amount, which does need indexation. */
export type PlanningPropertyTaxAmountInput = {
  /** The amount in dollars. */
  readonly dollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** How the amount grows. */
  readonly indexation?: InputMaybe<PlanningIndexationInput>;
};

/** Property tax as a rate or a dollar amount — exactly one variant must be set (oneOf). */
export type PlanningPropertyTaxInput =
  /** A fixed dollar amount. */
  { readonly amount: PlanningPropertyTaxAmountInput; readonly rate?: never; }
  |  /** A percentage of market value. */
  { readonly amount?: never; readonly rate: PlanningPropertyTaxRateInput; };

/** Property tax as a percentage of market value. It re-bases on the growing value each year, so it needs no indexation. */
export type PlanningPropertyTaxRate = {
  readonly __typename?: 'PlanningPropertyTaxRate';
  /** The rate, as a whole-number percentage. */
  readonly percentage?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Property tax as a percentage of market value. No indexation: it re-bases on the growing value each year. */
export type PlanningPropertyTaxRateInput = {
  /** The rate, as a whole-number percentage. */
  readonly percentage?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** An asset held for its own sake rather than for a return. */
export type PlanningRealAsset = {
  /** The Savvy record this came from. */
  readonly assetId: Scalars['String']['output'];
  /** Whether it can be sold to cover estate costs. */
  readonly availableForEstateLiquidity?: Maybe<Scalars['Boolean']['output']>;
  /** A free-text label. */
  readonly description: Scalars['String']['output'];
  /** The engine's identifier for this asset. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** Annual growth, as a whole-number percentage. */
  readonly growthRate?: Maybe<Scalars['BigDecimal']['output']>;
  /** Current market value in dollars. */
  readonly marketValue: Scalars['BigDecimal']['output'];
  /** Who owns it. */
  readonly owners: PlanningOwners;
  /** Property tax, as a rate or a dollar amount. Absent on an asset taxed as neither land nor a building. */
  readonly propertyTax?: Maybe<PlanningPropertyTax>;
  /** What was paid for it, in dollars. */
  readonly purchaseDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** Savvy asset subclass where the class defines one, otherwise the asset class. Separate from the engine planning type. */
  readonly savvyAssetType?: Maybe<Scalars['String']['output']>;
  /** When the market value was assessed. */
  readonly valuationDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** How a rental property depreciates. The pools differ between residential and commercial. */
export type PlanningRentalDepreciation = PlanningRentalDepreciationCommercial | PlanningRentalDepreciationResidential;

/** Commercial rental depreciation, which has qualified improvement property in place of appliances and furniture. */
export type PlanningRentalDepreciationCommercial = {
  readonly __typename?: 'PlanningRentalDepreciationCommercial';
  /** The building basis. */
  readonly building?: Maybe<PlanningCostPool>;
  /** The land basis. */
  readonly land?: Maybe<PlanningCostPool>;
  /** The qualified improvement property basis. */
  readonly qualifiedImprovementProperty?: Maybe<PlanningCostPool>;
};

/** Commercial rental depreciation. */
export type PlanningRentalDepreciationCommercialInput = {
  /** The building basis. */
  readonly building?: InputMaybe<PlanningCostPoolInput>;
  /** The land basis. */
  readonly land?: InputMaybe<PlanningCostPoolInput>;
  /** The qualified improvement property basis. */
  readonly qualifiedImprovementProperty?: InputMaybe<PlanningCostPoolInput>;
};

/** Residential or commercial depreciation — exactly one variant must be set (oneOf). */
export type PlanningRentalDepreciationInput =
  /** Commercial. */
  { readonly commercial: PlanningRentalDepreciationCommercialInput; readonly residential?: never; }
  |  /** Residential. */
  { readonly commercial?: never; readonly residential: PlanningRentalDepreciationResidentialInput; };

/** Residential rental depreciation. Appliances and furniture depreciate over a fixed period, so they are a separate pool. */
export type PlanningRentalDepreciationResidential = {
  readonly __typename?: 'PlanningRentalDepreciationResidential';
  /** The appliances and furniture basis. */
  readonly appliancesAndFurniture?: Maybe<PlanningDepreciablePool>;
  /** The building basis. */
  readonly building?: Maybe<PlanningCostPool>;
  /** The land basis. */
  readonly land?: Maybe<PlanningCostPool>;
};

/** Residential rental depreciation. */
export type PlanningRentalDepreciationResidentialInput = {
  /** The appliances and furniture basis. */
  readonly appliancesAndFurniture?: InputMaybe<PlanningDepreciablePoolInput>;
  /** The building basis. */
  readonly building?: InputMaybe<PlanningCostPoolInput>;
  /** The land basis. */
  readonly land?: InputMaybe<PlanningCostPoolInput>;
};

/** A real asset that earns rent and can therefore claim depreciation. */
export type PlanningRentalProperty = PlanningRealAsset & {
  readonly __typename?: 'PlanningRentalProperty';
  /** The Savvy record this came from. */
  readonly assetId: Scalars['String']['output'];
  /** Whether it can be sold to cover estate costs. */
  readonly availableForEstateLiquidity?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the plan claims depreciation on this property. */
  readonly claimDepreciation?: Maybe<Scalars['Boolean']['output']>;
  /** The depreciation basis, residential or commercial. */
  readonly depreciation?: Maybe<PlanningRentalDepreciation>;
  /** A free-text label. */
  readonly description: Scalars['String']['output'];
  /** The engine's identifier for this asset. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** Annual growth, as a whole-number percentage. */
  readonly growthRate?: Maybe<Scalars['BigDecimal']['output']>;
  /** Current market value in dollars. */
  readonly marketValue: Scalars['BigDecimal']['output'];
  /** Who owns it. */
  readonly owners: PlanningOwners;
  /** Property tax, as a rate or a dollar amount. Absent on an asset taxed as neither land nor a building. */
  readonly propertyTax?: Maybe<PlanningPropertyTax>;
  /** What was paid for it, in dollars. */
  readonly purchaseDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** Savvy asset subclass where the class defines one, otherwise the asset class. Separate from the engine planning type. */
  readonly savvyAssetType?: Maybe<Scalars['String']['output']>;
  /** When the market value was assessed. */
  readonly valuationDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** A real asset that earns rent and can therefore claim depreciation. */
export type PlanningRentalPropertyInput = {
  /** The Savvy record this came from. Left out for a property added in the plan, which has no Savvy row yet. */
  readonly assetId?: InputMaybe<Scalars['String']['input']>;
  /** Whether it can be sold to cover estate costs. */
  readonly availableForEstateLiquidity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the plan claims depreciation. */
  readonly claimDepreciation?: InputMaybe<Scalars['Boolean']['input']>;
  /** The depreciation basis. */
  readonly depreciation?: InputMaybe<PlanningRentalDepreciationInput>;
  /** A free-text label. */
  readonly description: Scalars['String']['input'];
  /** The engine's identifier for this asset. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** Annual growth, as a whole-number percentage. */
  readonly growthRate?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Current market value in dollars. */
  readonly marketValue: Scalars['BigDecimal']['input'];
  /** Who owns it. */
  readonly owners: PlanningOwnersInput;
  /** Property tax, as a rate or a dollar amount. Absent on an asset taxed as neither land nor a building. */
  readonly propertyTax?: InputMaybe<PlanningPropertyTaxInput>;
  /** What was paid for it, in dollars. */
  readonly purchaseDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** When the market value was assessed. */
  readonly valuationDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Retirement at a given age. */
export type PlanningRetireAtAge = {
  readonly __typename?: 'PlanningRetireAtAge';
  /** The retirement age. */
  readonly age?: Maybe<Scalars['Int']['output']>;
};

/** Retirement at a given age. */
export type PlanningRetireAtAgeInput = {
  /** The retirement age. */
  readonly age?: InputMaybe<Scalars['Int']['input']>;
};

/** Retirement on a fixed date. */
export type PlanningRetireOnDate = {
  readonly __typename?: 'PlanningRetireOnDate';
  /** The retirement date. */
  readonly date?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Retirement on a fixed date. */
export type PlanningRetireOnDateInput = {
  /** The retirement date. */
  readonly date?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Retired. Always null. */
export type PlanningSaleDestination = PlanningSaleToExistingAccount | PlanningSaleToNewNonQualified;

/** Retired. Ignored. */
export type PlanningSaleDestinationInput =
  /** Retired. Ignored. */
  { readonly existingAccount: PlanningSaleToExistingAccountInput; readonly newNonQualified?: never; }
  |  /** Retired. Ignored. */
  { readonly existingAccount?: never; readonly newNonQualified: PlanningSaleToNewNonQualifiedInput; };

/** Retired. Never returned. */
export type PlanningSaleToExistingAccount = {
  readonly __typename?: 'PlanningSaleToExistingAccount';
  /** Retired. Never returned. */
  readonly accountRef?: Maybe<Scalars['String']['output']>;
};

/** Retired. Ignored. */
export type PlanningSaleToExistingAccountInput = {
  /** Retired. Ignored. */
  readonly accountRef?: InputMaybe<Scalars['String']['input']>;
};

/** Retired. Never returned. */
export type PlanningSaleToNewNonQualified = {
  readonly __typename?: 'PlanningSaleToNewNonQualified';
  /** Retired. Never returned. */
  readonly isNewNonQualified: Scalars['Boolean']['output'];
};

/** Retired. Ignored. */
export type PlanningSaleToNewNonQualifiedInput = {
  /** Retired. Ignored. */
  readonly selected: Scalars['Boolean']['input'];
};

/** A reference to one of our rows for an item that can come from more than one table, so the table is named alongside the id. */
export type PlanningSavvyRef = {
  readonly __typename?: 'PlanningSavvyRef';
  /** The row id. */
  readonly id?: Maybe<Scalars['String']['output']>;
  /** Which table the row is in. */
  readonly objectType?: Maybe<PlanningSavvyRefObjectType>;
};

/** A reference to one of our rows for an item that can come from more than one table, so the table is named alongside the id. */
export type PlanningSavvyRefInput = {
  /** The row id. */
  readonly id?: InputMaybe<Scalars['String']['input']>;
  /** Which table the row is in. */
  readonly objectType?: InputMaybe<PlanningSavvyRefObjectType>;
};

/** Which of our tables a plan item was read from. */
export const PlanningSavvyRefObjectType = {
  /** account */
  Account: 'account',
  /** liability */
  Liability: 'liability'
} as const;

export type PlanningSavvyRefObjectType = typeof PlanningSavvyRefObjectType[keyof typeof PlanningSavvyRefObjectType];
/** A recurring contribution into an account, bounded at both ends. */
export type PlanningScheduledContribution = {
  readonly __typename?: 'PlanningScheduledContribution';
  /** The amount in dollars. */
  readonly dollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** When it stops. */
  readonly endsOn?: Maybe<PlanningDateBoundary>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** How often it is paid in. */
  readonly frequency?: Maybe<PlanningContributionFrequency>;
  /** How the amount grows. */
  readonly indexation?: Maybe<PlanningIndexation>;
  /** When it starts. */
  readonly startsOn?: Maybe<PlanningDateBoundary>;
};

/** A recurring contribution into an account, bounded at both ends. */
export type PlanningScheduledContributionInput = {
  /** The amount in dollars. */
  readonly dollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** When it stops. */
  readonly endsOn?: InputMaybe<PlanningDateBoundaryInput>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** How often it is paid in. */
  readonly frequency?: InputMaybe<PlanningContributionFrequency>;
  /** How the amount grows. */
  readonly indexation?: InputMaybe<PlanningIndexationInput>;
  /** When it starts. */
  readonly startsOn?: InputMaybe<PlanningDateBoundaryInput>;
};

/** Sex at birth, which drives mortality assumptions */
export const PlanningSexAtBirth = {
  /** female */
  Female: 'female',
  /** male */
  Male: 'male',
  /** unspecified */
  Unspecified: 'unspecified'
} as const;

export type PlanningSexAtBirth = typeof PlanningSexAtBirth[keyof typeof PlanningSexAtBirth];
/** A sale of exercised shares. */
export type PlanningShareSale = {
  readonly __typename?: 'PlanningShareSale';
  /**
   * Retired. Always null.
   * @deprecated Conquest has no field for a sale destination.
   */
  readonly destination?: Maybe<PlanningSaleDestination>;
  /** A free-text note on why. */
  readonly purpose?: Maybe<Scalars['String']['output']>;
  /** When the sale happens. */
  readonly schedule?: Maybe<PlanningOccurrence>;
  /** Whether every exercised share is sold. */
  readonly sellAllExercised?: Maybe<Scalars['Boolean']['output']>;
};

/** A sale of exercised shares. */
export type PlanningShareSaleInput = {
  /**
   * Retired. Ignored.
   * @deprecated Conquest has no field for a sale destination.
   */
  readonly destination?: InputMaybe<PlanningSaleDestinationInput>;
  /** A free-text note on why. */
  readonly purpose?: InputMaybe<Scalars['String']['input']>;
  /** When the sale happens. */
  readonly schedule?: InputMaybe<PlanningOccurrenceInput>;
  /** Whether every exercised share is sold. */
  readonly sellAllExercised?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Social Security already being paid, so the monthly amount is known. */
export type PlanningSocialSecurityAlreadyReceiving = {
  readonly __typename?: 'PlanningSocialSecurityAlreadyReceiving';
  /** How the benefit grows. */
  readonly indexation?: Maybe<PlanningIndexation>;
  /** The monthly benefit in dollars. */
  readonly monthlyDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** Voluntary withholding, as a whole-number percentage — not a dollar amount. */
  readonly voluntaryWithholding?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Social Security already being paid. */
export type PlanningSocialSecurityAlreadyReceivingInput = {
  /** How the benefit grows. */
  readonly indexation?: InputMaybe<PlanningIndexationInput>;
  /** The monthly benefit in dollars. */
  readonly monthlyDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Voluntary withholding, as a whole-number percentage — not a dollar amount. */
  readonly voluntaryWithholding?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** Social Security not yet claimed, so the start and the benefit are both estimates. */
export type PlanningSocialSecurityNotYetReceiving = {
  readonly __typename?: 'PlanningSocialSecurityNotYetReceiving';
  /** Whether the spousal benefit calculation is included. */
  readonly includeSpousalBenefit?: Maybe<Scalars['Boolean']['output']>;
  /** How the benefit grows. */
  readonly indexation?: Maybe<PlanningIndexation>;
  /** The monthly benefit in dollars at full retirement age, when manually entered. */
  readonly monthlyDollarAmountAtFullRetirementAge?: Maybe<Scalars['BigDecimal']['output']>;
  /** When benefits are expected to start. */
  readonly startsOn?: Maybe<PlanningDateBoundary>;
  /** Voluntary withholding, as a whole-number percentage — not a dollar amount. */
  readonly voluntaryWithholding?: Maybe<Scalars['BigDecimal']['output']>;
};

/** Social Security not yet claimed. */
export type PlanningSocialSecurityNotYetReceivingInput = {
  /** Whether the spousal benefit calculation is included. */
  readonly includeSpousalBenefit?: InputMaybe<Scalars['Boolean']['input']>;
  /** How the benefit grows. */
  readonly indexation?: InputMaybe<PlanningIndexationInput>;
  /** The monthly benefit in dollars at full retirement age. */
  readonly monthlyDollarAmountAtFullRetirementAge?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** When benefits are expected to start. */
  readonly startsOn?: InputMaybe<PlanningDateBoundaryInput>;
  /** Voluntary withholding, as a whole-number percentage — not a dollar amount. */
  readonly voluntaryWithholding?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** Whether Social Security is already being received or not yet claimed. */
export type PlanningSocialSecurityRetirement = PlanningSocialSecurityAlreadyReceiving | PlanningSocialSecurityNotYetReceiving;

/** Already receiving or not yet claimed — exactly one variant must be set (oneOf). */
export type PlanningSocialSecurityRetirementInput =
  /** Already being paid. */
  { readonly alreadyReceiving: PlanningSocialSecurityAlreadyReceivingInput; readonly notYetReceiving?: never; }
  |  /** Not yet claimed. */
  { readonly alreadyReceiving?: never; readonly notYetReceiving: PlanningSocialSecurityNotYetReceivingInput; };

/**
 * The Social Security survivor benefit. Indexation and voluntary withholding are
 * held once per person on the retirement benefit and apply here too.
 */
export type PlanningSurvivorBenefit = {
  readonly __typename?: 'PlanningSurvivorBenefit';
  /** Whether future survivor benefits are included. */
  readonly includeFutureBenefits?: Maybe<Scalars['Boolean']['output']>;
  /** The monthly benefit in dollars. */
  readonly monthlyDollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
};

/**
 * The Social Security survivor benefit. Indexation and voluntary withholding are
 * held once per person on the retirement benefit and apply here too.
 */
export type PlanningSurvivorBenefitInput = {
  /** Whether future survivor benefits are included. */
  readonly includeFutureBenefits?: InputMaybe<Scalars['Boolean']['input']>;
  /** The monthly benefit in dollars. */
  readonly monthlyDollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
};

/** How much goes into a tax-advantaged account: an elected amount, or the maximum. */
export type PlanningTaxAdvantagedContributions = PlanningTaxAdvantagedContributionsElected | PlanningTaxAdvantagedContributionsMaxOut;

/** A chosen contribution amount on a schedule. */
export type PlanningTaxAdvantagedContributionsElected = {
  readonly __typename?: 'PlanningTaxAdvantagedContributionsElected';
  /** The amount in dollars. */
  readonly dollarAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** When contributions stop. */
  readonly endsOn?: Maybe<PlanningDateBoundary>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** How often it is paid in. */
  readonly frequency?: Maybe<PlanningContributionFrequency>;
  /** How the amount grows. */
  readonly indexation?: Maybe<PlanningIndexation>;
  /** When contributions start. */
  readonly startsOn?: Maybe<PlanningDateBoundary>;
};

/** A chosen contribution amount on a schedule. */
export type PlanningTaxAdvantagedContributionsElectedInput = {
  /** The amount in dollars. */
  readonly dollarAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** When contributions stop. */
  readonly endsOn?: InputMaybe<PlanningDateBoundaryInput>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** How often it is paid in. */
  readonly frequency?: InputMaybe<PlanningContributionFrequency>;
  /** How the amount grows. */
  readonly indexation?: InputMaybe<PlanningIndexationInput>;
  /** When contributions start. */
  readonly startsOn?: InputMaybe<PlanningDateBoundaryInput>;
};

/** How much goes into a tax-advantaged account: an elected amount, or the maximum. */
export type PlanningTaxAdvantagedContributionsInput =
  /** A chosen contribution amount on a schedule. */
  { readonly elected: PlanningTaxAdvantagedContributionsElectedInput; readonly maxOut?: never; }
  |  /** Contribute the statutory maximum. */
  { readonly elected?: never; readonly maxOut: PlanningTaxAdvantagedContributionsMaxOutInput; };

/** Contribute the statutory maximum. */
export type PlanningTaxAdvantagedContributionsMaxOut = {
  readonly __typename?: 'PlanningTaxAdvantagedContributionsMaxOut';
  /** Last tax year to contribute in. */
  readonly endTaxYear?: Maybe<Scalars['Int']['output']>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: Maybe<Scalars['String']['output']>;
  /** First tax year to contribute in. */
  readonly startTaxYear?: Maybe<Scalars['Int']['output']>;
};

/** Contribute the statutory maximum. */
export type PlanningTaxAdvantagedContributionsMaxOutInput = {
  /** Last tax year to contribute in. */
  readonly endTaxYear?: InputMaybe<Scalars['Int']['input']>;
  /** The engine's identifier for this contribution. */
  readonly externalId?: InputMaybe<Scalars['String']['input']>;
  /** First tax year to contribute in. */
  readonly startTaxYear?: InputMaybe<Scalars['Int']['input']>;
};

/** Filing status for tax projections */
export const PlanningTaxStatus = {
  /** head_of_household */
  HeadOfHousehold: 'head_of_household',
  /** married_filing_jointly */
  MarriedFilingJointly: 'married_filing_jointly',
  /** married_filing_separately */
  MarriedFilingSeparately: 'married_filing_separately',
  /** single */
  Single: 'single'
} as const;

export type PlanningTaxStatus = typeof PlanningTaxStatus[keyof typeof PlanningTaxStatus];
/**
 * How a grant vests. Retirement and death are booleans on the grant rather than
 * schedule entries, matching how the engine models them.
 */
export type PlanningVesting = {
  readonly __typename?: 'PlanningVesting';
  /** The vesting tranches. */
  readonly activity?: Maybe<ReadonlyArray<PlanningVestingActivity>>;
  /** Whether the grant vests fully at death. */
  readonly atDeath?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the grant vests fully at retirement. */
  readonly atRetirement?: Maybe<Scalars['Boolean']['output']>;
};

/** A tranche of shares vesting on a schedule. */
export type PlanningVestingActivity = {
  readonly __typename?: 'PlanningVestingActivity';
  /** The share of the grant that vests, as a whole-number percentage. */
  readonly percentOfShares?: Maybe<Scalars['BigDecimal']['output']>;
  /** When it vests. */
  readonly schedule?: Maybe<PlanningOccurrence>;
};

/** A tranche of shares vesting on a schedule. */
export type PlanningVestingActivityInput = {
  /** The share of the grant that vests, as a whole-number percentage. */
  readonly percentOfShares?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** When it vests. */
  readonly schedule?: InputMaybe<PlanningOccurrenceInput>;
};

/** How a grant vests. */
export type PlanningVestingInput = {
  /** The vesting tranches. */
  readonly activity?: InputMaybe<ReadonlyArray<PlanningVestingActivityInput>>;
  /** Whether the grant vests fully at death. */
  readonly atDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the grant vests fully at retirement. */
  readonly atRetirement?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Who is covered by a work-based retirement plan, which is what decides whether IRA contributions are deductible. */
export const PlanningWorkPlanCoverage = {
  /** both */
  Both: 'both',
  /** owner */
  Owner: 'owner',
  /** spouse */
  Spouse: 'spouse'
} as const;

export type PlanningWorkPlanCoverage = typeof PlanningWorkPlanCoverage[keyof typeof PlanningWorkPlanCoverage];
/** A portfolio under a household. */
export type Portfolio = {
  readonly __typename?: 'Portfolio';
  readonly accounts?: Maybe<ReadonlyArray<Account>>;
  /** When the investment policy was last confirmed */
  readonly confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly displayName?: Maybe<Scalars['String']['output']>;
  /** The household that the portfolio belongs to. */
  readonly household: Household;
  /** @deprecated Use household instead */
  readonly householdId: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly investmentObjective?: Maybe<InvestmentObjectiveName>;
  readonly isPersonal: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly orionHouseholdId: Scalars['Int']['output'];
  readonly portfolioStrategies?: Maybe<ReadonlyArray<PortfolioStrategy>>;
  readonly riskAssessment?: Maybe<RiskAssessmentName>;
  readonly taxSensitivity?: Maybe<PortfolioTaxSensitivityName>;
  readonly timeHorizon?: Maybe<TimeHorizonName>;
  readonly userId: Scalars['ID']['output'];
};

/** Portfolio graph value used for time series graph display */
export type PortfolioGraphValue = {
  readonly __typename?: 'PortfolioGraphValue';
  readonly date: Scalars['ISO8601Date']['output'];
  /**
   * Whether or not to include this data point in an all time graph. We need this
   * to graph all time data properly because data returned from our data provider
   * has different frequency intervals depending on how far back it goes.
   */
  readonly includeInAllTime: Scalars['Boolean']['output'];
  readonly netInvestedUsd?: Maybe<Scalars['BigDecimal']['output']>;
  readonly valueUsd: Scalars['BigDecimal']['output'];
};

/** Accounts, assets and liabilities classified together into an PortfolioItemGroup. */
export type PortfolioItem = Account | Asset | Liability;

/** A group of PortfolioItem objects. */
export type PortfolioItemGroup = {
  readonly __typename?: 'PortfolioItemGroup';
  /** An array of accounts */
  readonly accounts: ReadonlyArray<Account>;
  /** An array of assets */
  readonly assets: ReadonlyArray<Asset>;
  /** Historical values for hidden items in the group */
  readonly hiddenFromClientHistoricalValues: ReadonlyArray<HistoricalValue>;
  /** The total value of all hidden items in the group. */
  readonly hiddenFromClientTotalValue: Value;
  /** Historical values for the group */
  readonly historicalValues: ReadonlyArray<HistoricalValue>;
  /**
   * An array of portfolio items
   * @deprecated Use the accounts, assets, and liabilities fields instead.
   */
  readonly items: ReadonlyArray<PortfolioItem>;
  /** An array of liabilities */
  readonly liabilities: ReadonlyArray<Liability>;
  /** The name of the group. */
  readonly name: PortfolioItemGroupName;
  /** The total value of all items in the group. */
  readonly totalValue: Value;
};

export const PortfolioItemGroupName = {
  BankAccounts: 'BANK_ACCOUNTS',
  CompanyEquity: 'COMPANY_EQUITY',
  OtherAssets: 'OTHER_ASSETS',
  OtherInvestments: 'OTHER_INVESTMENTS',
  OtherLiabilities: 'OTHER_LIABILITIES',
  RealEstate: 'REAL_ESTATE',
  SavvyAccounts: 'SAVVY_ACCOUNTS'
} as const;

export type PortfolioItemGroupName = typeof PortfolioItemGroupName[keyof typeof PortfolioItemGroupName];
/** Which table a portfolio item id names. Ids are not unique across assets and liabilities. */
export const PortfolioItemKind = {
  /** asset */
  Asset: 'asset',
  /** liability */
  Liability: 'liability'
} as const;

export type PortfolioItemKind = typeof PortfolioItemKind[keyof typeof PortfolioItemKind];
export const PortfolioItemTypeName = {
  Auto: 'auto',
  Commercial: 'commercial',
  Consumer: 'consumer',
  Credit: 'credit',
  Cryptocurrency: 'cryptocurrency',
  Depository: 'depository',
  EmployerEquity: 'employer_equity',
  FundInvestment: 'fund_investment',
  General: 'general',
  HomeEquity: 'home_equity',
  Insurance: 'insurance',
  Investment: 'investment',
  LineOfCredit: 'line_of_credit',
  Loan: 'loan',
  Mortgage: 'mortgage',
  Other: 'other',
  PrivateInvestment: 'private_investment',
  Student: 'student'
} as const;

export type PortfolioItemTypeName = typeof PortfolioItemTypeName[keyof typeof PortfolioItemTypeName];
/** Data used for client performance reporting. */
export type PortfolioPerformanceReport = {
  readonly __typename?: 'PortfolioPerformanceReport';
  /** Per-account dividends & interest and tax-withholding totals, one entry per (account, time period) */
  readonly accountActivityBreakdowns?: Maybe<ReadonlyArray<AccountActivityBreakdown>>;
  /** Per-account performance breakdowns for multi-account and portfolio queries */
  readonly accountPerformanceBreakdowns?: Maybe<ReadonlyArray<AccountPerformanceBreakdown>>;
  readonly assetCategoryGrouping: ReadonlyArray<AssetGrouping>;
  readonly assetClassGrouping: ReadonlyArray<AssetGrouping>;
  /** Backend-computed performance for the comparison window. Null when no comparison was requested. */
  readonly comparisonSummary?: Maybe<ComparisonPerformanceSummary>;
  /** Per-account performance for the custom Range A window. Null unless range_a_date_range is set. */
  readonly customRangeAAccountPerformance?: Maybe<ReadonlyArray<AccountWindowPerformance>>;
  /** Backend-computed performance for the primary window when an arbitrary range was supplied. Null otherwise. */
  readonly customRangeASummary?: Maybe<ComparisonPerformanceSummary>;
  /** When Orion last updated the underlying performance snapshot data */
  readonly dataLastUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly holdings: ReadonlyArray<ReportedHolding>;
  /** A unique identifier for Apollo to use for caching */
  readonly id: Scalars['String']['output'];
  readonly performanceOverTime: ReadonlyArray<Performance>;
  readonly performanceSummaries?: Maybe<ReadonlyArray<PerformanceSummary>>;
  readonly portfolioGraphValues: ReadonlyArray<PortfolioGraphValue>;
  /** Per-quarter performance columns for the Summary section. Null unless quarterly_breakdown is requested. */
  readonly quarterlySummaries?: Maybe<ReadonlyArray<QuarterlyPerformanceSummary>>;
  /** @deprecated Use tax_groups_by_period instead */
  readonly taxTypeGrouping?: Maybe<ReadonlyArray<TaxTypeGrouping>>;
  readonly taxTypeGroupingsByPeriod?: Maybe<ReadonlyArray<TaxTypeGroupingsByPeriod>>;
};

/**
 * Risk and benchmark-relative statistics for a household portfolio over a report
 * date range - backs the report-builder Statistical Summary section. A household
 * with more than one configured benchmark uses only the first valid one (CSV
 * order) for the 7 benchmark-relative fields below - unlike the
 * cumulative-benchmark chart, which plots every configured leg.
 */
export type PortfolioStatisticalSummary = {
  readonly __typename?: 'PortfolioStatisticalSummary';
  /**
   * True when the 7 benchmark-relative fields below are populated. False both when
   * the household has no configured Orion benchmark, and when one is configured
   * but its daily data does not sufficiently overlap the report window (e.g. a
   * newly-configured benchmark or a very short window).
   */
  readonly benchmarkConfigured: Scalars['Boolean']['output'];
  /** Beta vs the benchmark; null unless benchmarkConfigured, or when benchmark variance is zero. */
  readonly betaCoefficient?: Maybe<Scalars['Float']['output']>;
  /** Covariance of portfolio and benchmark daily returns; null unless benchmarkConfigured. */
  readonly covariance?: Maybe<Scalars['Float']['output']>;
  /** Downside capture ratio; null unless benchmarkConfigured, or when there are no negative-benchmark-return days. */
  readonly downsideCaptureRatio?: Maybe<Scalars['Float']['output']>;
  /** Maximum peak-to-trough drawdown over the window, as a fraction. */
  readonly drawdown: Scalars['Float']['output'];
  /** Jensen's alpha; null unless benchmarkConfigured, or when beta is unavailable. */
  readonly jensensAlpha?: Maybe<Scalars['Float']['output']>;
  /** Mean periodic return, as a fraction. */
  readonly meanReturn: Scalars['Float']['output'];
  /** Squared correlation with the benchmark; null unless benchmarkConfigured. */
  readonly rSquared?: Maybe<Scalars['Float']['output']>;
  /** Annualized Sharpe ratio (unitless). */
  readonly sharpeRatio: Scalars['Float']['output'];
  /** Annualized Sortino ratio (unitless). */
  readonly sortinoRatio: Scalars['Float']['output'];
  /** Annualized standard deviation of periodic returns, as a fraction (0.12 = 12%). */
  readonly standardDeviation: Scalars['Float']['output'];
  /** Treynor ratio; null unless benchmarkConfigured, or when beta is zero/unavailable. */
  readonly treynorRatio?: Maybe<Scalars['Float']['output']>;
  /** Upside capture ratio; null unless benchmarkConfigured, or when there are no positive-benchmark-return days. */
  readonly upsideCaptureRatio?: Maybe<Scalars['Float']['output']>;
  /** Annualized variance of returns (standardDeviation squared), fraction-scale. */
  readonly variance: Scalars['Float']['output'];
};

export type PortfolioStrategy = {
  readonly __typename?: 'PortfolioStrategy';
  readonly accountSleeve?: Maybe<AccountSleeve>;
  readonly accounts?: Maybe<ReadonlyArray<Account>>;
  readonly cashRequirements?: Maybe<Scalars['String']['output']>;
  /**
   * True when this strategy is Direct Indexing: its name says so, Orion
   * sub-advises it through Direct Indexing, or the owning account is the Savvy
   * Direct Indexing product.
   */
  readonly directIndexing: Scalars['Boolean']['output'];
  readonly doNotSellHoldings?: Maybe<ReadonlyArray<Holding>>;
  readonly excludedHoldings?: Maybe<ReadonlyArray<Holding>>;
  readonly feeInBasisPoints?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly nonTradedAccounts?: Maybe<ReadonlyArray<Account>>;
  readonly overlayIncluded?: Maybe<Scalars['Boolean']['output']>;
  readonly portfolioId: Scalars['ID']['output'];
  readonly reallocationFrequency?: Maybe<Scalars['String']['output']>;
  readonly reallocationType?: Maybe<Scalars['String']['output']>;
  readonly strategyName: Scalars['String']['output'];
  readonly strategyType?: Maybe<StrategyTypeName>;
  readonly taxSensitivity?: Maybe<Scalars['String']['output']>;
};

/**
 * Native rebuild of the Orion "Portfolio Summary - Comprehensive" PDF. Superset of
 * the Simple report: cover + Appendix Summary of Accounts, Performance Report
 * (Relationship Summary + Activity Summary + Portfolio Value Over Time),
 * Allocation Over Time, Group Performance (per-holding returns by asset category),
 * and the full Holdings detail. Replaces the Orion path when feature-flagged on (HAWK-73).
 */
export type PortfolioSummaryComprehensive = {
  readonly __typename?: 'PortfolioSummaryComprehensive';
  /** Per-account rows for the Appendix – Summary of Accounts page. */
  readonly accountSummaries: ReadonlyArray<AccountEntry>;
  /** Relationship Summary by Account Type: household total followed by Taxable / Tax Deferred / Tax Exempt sub-totals. */
  readonly accountTypeGroups: ReadonlyArray<AccountTypeGroup>;
  /** Four-column Activity Summary table: custom date range, QTD, YTD, Since Inception. */
  readonly activityPeriods: ReadonlyArray<ActivityPeriod>;
  /** Primary advisor's display name shown on the cover. */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /**
   * Long-format allocation series (one point per date per asset category) for the
   * stacked-area Allocation Over Time chart. Empty when the live Orion lookup is
   * unavailable — the chart is then omitted.
   */
  readonly allocationOverTime: ReadonlyArray<AllocationOverTimePoint>;
  /** Accounts listed on the cover page (name + masked number). */
  readonly coverAccounts: ReadonlyArray<AccountEntry>;
  /** When the underlying performance snapshot was last refreshed. */
  readonly dataLastUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User-selected end date (as-of date for QTD / YTD / Since Inception). */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Branded firm name. Falls back to "Savvy" when the household's advisor has no organization branding. */
  readonly firmDisplayName: Scalars['String']['output'];
  /** Branded firm logo URL. Falls back to the Savvy logo when no organization branding is set. */
  readonly firmLogoUrl: Scalars['String']['output'];
  /** Per-holding returns grouped by asset category (Group Performance table, pages 4–6). */
  readonly groupPerformance: ReadonlyArray<GroupPerformanceRow>;
  /** Asset-category subtotal rows for the Group Performance table. */
  readonly groupPerformanceTotals: ReadonlyArray<GroupPerformanceTotal>;
  /** Full holdings detail (one row per position), grouped on the template by asset category → sub-asset class. */
  readonly holdings: ReadonlyArray<HoldingsSummaryRow>;
  /** Total cost basis across all holdings. */
  readonly holdingsTotalCostBasis: HoldingsSummaryMoney;
  /** Total market value across all holdings. */
  readonly holdingsTotalMarketValue: HoldingsSummaryMoney;
  /** Total unrealized gain/loss across all holdings. */
  readonly holdingsTotalUnrealizedGainLoss: HoldingsSummaryMoney;
  /** Household display name shown on the cover and page headers. */
  readonly householdName: Scalars['String']['output'];
  /** Stable identifier for this report scope (household + date range). */
  readonly id: Scalars['ID']['output'];
  /** Earliest funded date across all accounts; used as the 'Since Inception' period start. Null when unknown. */
  readonly inceptionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Managed Assets Total inception-to-date TWR as a fraction. Null when unavailable. */
  readonly managedTotalInceptionToDateReturn?: Maybe<Scalars['Float']['output']>;
  /** Managed Assets Total market value, in USD. Null when unavailable. */
  readonly managedTotalMarketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Managed Assets Total trailing one-year TWR as a fraction. Null when unavailable. */
  readonly managedTotalOneYearReturn?: Maybe<Scalars['Float']['output']>;
  /** Managed Assets Total year-to-date TWR as a fraction. Null when unavailable. */
  readonly managedTotalYearToDateReturn?: Maybe<Scalars['Float']['output']>;
  /** Daily points for the 'Portfolio Value Over Time' chart, spanning the custom date range. */
  readonly marketValueSeries: ReadonlyArray<MarketValuePoint>;
  /** User-selected start date (first column of the Activity Summary). */
  readonly startDate: Scalars['ISO8601Date']['output'];
};

/**
 * Reporting periods covered by the Portfolio Summary (Simple) activity table —
 * custom date range, quarter-to-date, year-to-date, and since inception.
 */
export const PortfolioSummarySimplePeriod = {
  /** custom_range */
  CustomRange: 'custom_range',
  /** quarter_to_date */
  QuarterToDate: 'quarter_to_date',
  /** since_inception */
  SinceInception: 'since_inception',
  /** year_to_date */
  YearToDate: 'year_to_date'
} as const;

export type PortfolioSummarySimplePeriod = typeof PortfolioSummarySimplePeriod[keyof typeof PortfolioSummarySimplePeriod];
export const PortfolioTaxSensitivityName = {
  High: 'high',
  Low: 'low',
  Moderate: 'moderate'
} as const;

export type PortfolioTaxSensitivityName = typeof PortfolioTaxSensitivityName[keyof typeof PortfolioTaxSensitivityName];
/** Autogenerated input type of PreviewCorrection */
export type PreviewCorrectionInput = {
  /** Selected imported client for a legal name. */
  readonly clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** legal_name or household_name. */
  readonly field: Scalars['String']['input'];
  /** Reviewed first name. */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** Reviewed household label. */
  readonly householdName?: InputMaybe<Scalars['String']['input']>;
  /** Imported household public handle. */
  readonly householdRequestUuid: Scalars['ID']['input'];
  /** Reviewed last name. */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** Selected sidecar record within this household. */
  readonly recordId?: InputMaybe<Scalars['ID']['input']>;
  /** Selected field values as text. */
  readonly values?: InputMaybe<Scalars['JsonHash']['input']>;
};

/** Autogenerated return type of PreviewCorrection. */
export type PreviewCorrectionPayload = {
  readonly __typename?: 'PreviewCorrectionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Review required before saving. */
  readonly preview: AdvisorOnboardingCorrectionPreview;
};

/** The primary advisor for a prospect or client. */
export type PrimaryAdvisor = {
  readonly __typename?: 'PrimaryAdvisor';
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
};

export const ProbabilityOfClosing = {
  High: 'high',
  Low: 'low',
  Medium: 'medium'
} as const;

export type ProbabilityOfClosing = typeof ProbabilityOfClosing[keyof typeof ProbabilityOfClosing];
/** Autogenerated input type of ProcessOnboardedClient */
export type ProcessOnboardedClientInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly orionHouseholdId?: InputMaybe<Scalars['ID']['input']>;
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ProcessOnboardedClient. */
export type ProcessOnboardedClientPayload = {
  readonly __typename?: 'ProcessOnboardedClientPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

export type ProfessionalRelationship = {
  readonly __typename?: 'ProfessionalRelationship';
  /** When the relationship was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The relationship edge id */
  readonly id: Scalars['ID']['output'];
  /** Optional per-relationship notes */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /** The month/year the referral happened (referred relationships only) */
  readonly referredOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The nature of the relationship (serves, referred) */
  readonly relationshipType: ProfessionalRelationshipType;
  /** Category of contact for a RetirementPlan target */
  readonly retirementPlanContactGroup?: Maybe<ProfessionalRelationshipContactGroup>;
  /** Active/inactive status of a contact for a RetirementPlan target */
  readonly retirementPlanContactStatus?: Maybe<ProfessionalRelationshipContactStatus>;
  /** The professional's role toward the household (serves relationships) */
  readonly role?: Maybe<ProfessionalRelationshipRole>;
  /** The acting end (User or CenterOfInfluenceRep) */
  readonly source: ProfessionalRelationshipSource;
  /** The month/year the professional started working with the household (serves relationships only) */
  readonly startedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The receiving end (Household, CenterOfInfluenceRep, or RetirementPlan) */
  readonly target: ProfessionalRelationshipTarget;
  /** When the relationship was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for ProfessionalRelationship. */
export type ProfessionalRelationshipConnection = {
  readonly __typename?: 'ProfessionalRelationshipConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ProfessionalRelationshipEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ProfessionalRelationship>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

export const ProfessionalRelationshipContactGroup = {
  /** internal_team */
  InternalTeam: 'internal_team',
  /** other */
  Other: 'other',
  /** plan_sponsor */
  PlanSponsor: 'plan_sponsor',
  /** service_provider */
  ServiceProvider: 'service_provider'
} as const;

export type ProfessionalRelationshipContactGroup = typeof ProfessionalRelationshipContactGroup[keyof typeof ProfessionalRelationshipContactGroup];
export const ProfessionalRelationshipContactStatus = {
  /** active */
  Active: 'active',
  /** inactive */
  Inactive: 'inactive'
} as const;

export type ProfessionalRelationshipContactStatus = typeof ProfessionalRelationshipContactStatus[keyof typeof ProfessionalRelationshipContactStatus];
/** An edge in a connection. */
export type ProfessionalRelationshipEdge = {
  readonly __typename?: 'ProfessionalRelationshipEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ProfessionalRelationship>;
};

export const ProfessionalRelationshipRole = {
  /** accountant */
  Accountant: 'accountant',
  /** attorney */
  Attorney: 'attorney',
  /** cpa */
  Cpa: 'cpa',
  /** estate_planner */
  EstatePlanner: 'estate_planner',
  /** financial_planner */
  FinancialPlanner: 'financial_planner',
  /** insurance_agent */
  InsuranceAgent: 'insurance_agent',
  /** other */
  Other: 'other'
} as const;

export type ProfessionalRelationshipRole = typeof ProfessionalRelationshipRole[keyof typeof ProfessionalRelationshipRole];
/**
 * The source end of a professional relationship: a CenterOfInfluenceRep, a
 * MovedProfessionalContact (the same contact after 4C1T-725), a household contact,
 * a Household (a client referred out to a contact), or a User (reference-only
 * referral source)
 */
export type ProfessionalRelationshipSource = CenterOfInfluenceRep | Household | HouseholdContactReferralParticipant | MovedProfessionalContact | PublicParticipantUser;

/**
 * The receiving end of a professional relationship: a Household,
 * CenterOfInfluenceRep, MovedProfessionalContact, or RetirementPlan
 */
export type ProfessionalRelationshipTarget = CenterOfInfluenceRep | Household | MovedProfessionalContact | RetirementPlan;

export const ProfessionalRelationshipType = {
  /** referred */
  Referred: 'referred',
  /** referred_out */
  ReferredOut: 'referred_out',
  /** serves */
  Serves: 'serves'
} as const;

export type ProfessionalRelationshipType = typeof ProfessionalRelationshipType[keyof typeof ProfessionalRelationshipType];
/** A professional contact serving a household or a retirement plan, read from `contact_relations` */
export type ProfessionalService = {
  readonly __typename?: 'ProfessionalService';
  /** The professional contact, when the viewer can read them */
  readonly contact?: Maybe<MovedProfessionalContact>;
  /** When the service was recorded */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The household or retirement plan served, when the viewer can read it */
  readonly entity?: Maybe<ProfessionalServiceEntity>;
  /** The professional service id */
  readonly id: Scalars['ID']['output'];
  /** Category of contact, for a retirement plan */
  readonly retirementPlanContactGroup?: Maybe<ProfessionalRelationshipContactGroup>;
  /** Whether the contact is active, for a retirement plan */
  readonly retirementPlanContactStatus?: Maybe<ProfessionalRelationshipContactStatus>;
  /** The professional's role toward what they serve, e.g. CPA */
  readonly role?: Maybe<Scalars['String']['output']>;
  /** The month the professional started serving it, when known */
  readonly startedOn?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** What a professional contact serves: a household or a retirement plan */
export type ProfessionalServiceEntity = Household | RetirementPlan;

/** Autogenerated input type of PromoteEnrollment */
export type PromoteEnrollmentInput = {
  /** When set, only promote households named in this bulk import. Omit to promote every staged household on the enrollment. */
  readonly bulkImportId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The enrollment's uuid. */
  readonly uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of PromoteEnrollment. */
export type PromoteEnrollmentPayload = {
  readonly __typename?: 'PromoteEnrollmentPayload';
  /** Households linked to a canonical household that already existed on this advisor's book. */
  readonly adoptedCount: Scalars['Int']['output'];
  /** Households blocked during this run. */
  readonly blockedCount: Scalars['Int']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enrollment after promotion. */
  readonly enrollment?: Maybe<AdvisorOnboardingEnrollment>;
  /** Any errors that occurred. */
  readonly errors?: Maybe<ReadonlyArray<MutationError>>;
  /** Households newly promoted in this run. */
  readonly promotedCount: Scalars['Int']['output'];
  /** Households already promoted and skipped in this run. */
  readonly skippedCount: Scalars['Int']['output'];
  /** Households left unlinked in this run, with the reason. */
  readonly skippedHouseholds: ReadonlyArray<PromoteSkippedHousehold>;
  /** Whether the operation succeeded. */
  readonly success: Scalars['Boolean']['output'];
};

/** A staged household a promote run left unlinked, and why. */
export type PromoteSkippedHousehold = {
  readonly __typename?: 'PromoteSkippedHousehold';
  /** Operator-facing detail behind the reason. */
  readonly detail: Scalars['String']['output'];
  /** Household name from the imported book. */
  readonly householdName?: Maybe<Scalars['String']['output']>;
  /** Household onboarding request id. */
  readonly id: Scalars['ID']['output'];
  /**
   * Why it was skipped: client_on_another_book, ambiguous_household,
   * household_not_onboardable, already_in_cockpit, seat_mismatch, or
   * duplicate_on_create.
   */
  readonly reason: Scalars['String']['output'];
};

/** Autogenerated input type of PromoteToSavvyServiceTemplate */
export type PromoteToSavvyServiceTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The service to promote */
  readonly serviceCatalogItemGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of PromoteToSavvyServiceTemplate. */
export type PromoteToSavvyServiceTemplatePayload = {
  readonly __typename?: 'PromoteToSavvyServiceTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The service, now readable as a Savvy service template by every advisor */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
};

/** Autogenerated input type of PromoteToSavvyTemplate */
export type PromoteToSavvyTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The workflow template to promote */
  readonly taskWorkflowTemplateId: Scalars['ID']['input'];
};

/** Autogenerated return type of PromoteToSavvyTemplate. */
export type PromoteToSavvyTemplatePayload = {
  readonly __typename?: 'PromoteToSavvyTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new Savvy template created from the source */
  readonly taskWorkflowTemplate?: Maybe<TaskWorkflowTemplate>;
};

export const ProposalDecisionAction = {
  /** accept */
  Accept: 'accept',
  /** correct */
  Correct: 'correct',
  /** reject */
  Reject: 'reject',
  /** retarget */
  Retarget: 'retarget'
} as const;

export type ProposalDecisionAction = typeof ProposalDecisionAction[keyof typeof ProposalDecisionAction];
/** One advisor decision on one proposal. */
export type ProposalDecisionInput = {
  /** Accept, correct, reject, or point the proposal at a listed record. */
  readonly action: ProposalDecisionAction;
  /** The proposal being decided. */
  readonly proposalId: Scalars['ID']['input'];
  /** For retarget: one of the candidate records the proposal lists. */
  readonly targetRecordId?: InputMaybe<Scalars['ID']['input']>;
  /** For correct: the corrected value, in the field type. */
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

export type ProspectDatum = {
  readonly __typename?: 'ProspectDatum';
  readonly advisorProfile: Advisor;
  readonly advisorUser: User;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly estimatedAum?: Maybe<Scalars['Int']['output']>;
  readonly household?: Maybe<Household>;
  readonly id: Scalars['ID']['output'];
  readonly probabilityOfClosing?: Maybe<ProbabilityOfClosing>;
  readonly salesforceId?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Prospecting Trend Analysis variant */
export type ProspectingTrendAnalysisInput = {
  /** Analysis period */
  readonly analysisPeriod: CorporateRetirementPlanAnalysisPeriodName;
  /** Custom period end (required when analysis_period is custom) */
  readonly customPeriodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Custom period start (required when analysis_period is custom) */
  readonly customPeriodStart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Metrics to highlight */
  readonly metricsToHighlight?: InputMaybe<Scalars['String']['input']>;
  /** Plan name */
  readonly planName?: InputMaybe<Scalars['String']['input']>;
  /** Recordkeeper */
  readonly recordkeeper?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAccount = {
  readonly __typename?: 'ProviderAccount';
  readonly accessToken?: Maybe<Scalars['String']['output']>;
  readonly accounts?: Maybe<ReadonlyArray<Account>>;
  /**
   * Whether this connection is keeping up and whether the client can repair it.
   * Always resolves, including for connections with no accounts and for Orion,
   * Plaid, and Chimney sources
   */
  readonly freshness: ProviderAccountFreshness;
  readonly id: Scalars['ID']['output'];
  readonly providerName?: Maybe<Scalars['String']['output']>;
  readonly scope?: Maybe<Scalars['String']['output']>;
  readonly source: ProviderAccountSource;
  readonly sourceProviderAccountId?: Maybe<Scalars['String']['output']>;
  readonly sourceStatus?: Maybe<Scalars['String']['output']>;
};

/**
 * Whether a linked connection is keeping up, and whether the client has to do
 * anything about it. Every field is non-null except lastSyncedAt, which is null
 * only when the connection has never synced.
 */
export type ProviderAccountFreshness = {
  readonly __typename?: 'ProviderAccountFreshness';
  /**
   * The link needs the client to act — ITEM_LOGIN_REQUIRED, FAILED, NO_ACCOUNTS,
   * or PASSWORD_RESET_REQUIRED. Matches the set the live net-worth banner already
   * treats as actionable, so the two surfaces agree; read linkStatus for which of the four it is
   */
  readonly disconnected: Scalars['Boolean']['output'];
  /** When the freshest account under this connection last changed. Null when syncStatus is NEVER_SYNCED, and only then */
  readonly lastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Link health, independent of freshness. STALE with an ACTIVE link is a slow
   * feed; STALE with ITEM_LOGIN_REQUIRED is a broken one
   */
  readonly linkStatus: ProviderAccountLinkStatus;
  /**
   * Whether the client can repair this connection themselves. False only for Orion
   * — MoneyKit and Plaid links both have a client-facing reconnect
   */
  readonly reconnectSupported: Scalars['Boolean']['output'];
  /** Time-based freshness: FRESH, STALE, or NEVER_SYNCED */
  readonly syncStatus: ProviderAccountSyncStatus;
};

/** The health of the link itself, mirroring ProviderAccount#source_status with UNKNOWN standing in for the nullable column */
export const ProviderAccountLinkStatus = {
  /** The link is working */
  Active: 'ACTIVE',
  /** The provider reported a failure the client cannot fix by re-authenticating */
  Failed: 'FAILED',
  /** The institution needs the client to re-authenticate */
  ItemLoginRequired: 'ITEM_LOGIN_REQUIRED',
  /** The link is mid-sync */
  Loading: 'LOADING',
  /** The link succeeded but exposes no accounts */
  NoAccounts: 'NO_ACCOUNTS',
  /** The institution needs the client to reset their password */
  PasswordResetRequired: 'PASSWORD_RESET_REQUIRED',
  /** The connection has never reported a status */
  Unknown: 'UNKNOWN'
} as const;

export type ProviderAccountLinkStatus = typeof ProviderAccountLinkStatus[keyof typeof ProviderAccountLinkStatus];
export const ProviderAccountSource = {
  Chimney: 'CHIMNEY',
  Moneykit: 'MONEYKIT',
  Orion: 'ORION',
  Plaid: 'PLAID'
} as const;

export type ProviderAccountSource = typeof ProviderAccountSource[keyof typeof ProviderAccountSource];
/**
 * How recently a linked connection last sent balances, on the 48-hour bar owned by
 * ProviderAccounts::Moneykit::StalenessEvaluator
 */
export const ProviderAccountSyncStatus = {
  /** The connection sent balances inside the staleness threshold */
  Fresh: 'FRESH',
  /**
   * The connection has no accounts to date, so there is no sync for it to be
   * behind on. Distinct from STALE: a client who has just linked belongs here, not in a warning
   */
  NeverSynced: 'NEVER_SYNCED',
  /**
   * The connection last sent balances before the staleness threshold — it may be a
   * slow feed rather than a broken link, so read linkStatus before asking the client to act
   */
  Stale: 'STALE'
} as const;

export type ProviderAccountSyncStatus = typeof ProviderAccountSyncStatus[keyof typeof ProviderAccountSyncStatus];
/** Autogenerated input type of ProvisionConquestUser */
export type ProvisionConquestUserInput = {
  /** Expected full name of the advisor to provision */
  readonly advisorName: Scalars['String']['input'];
  /** Savvy user id of the advisor to provision in Conquest */
  readonly advisorUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Expected email of the advisor to provision */
  readonly email: Scalars['String']['input'];
};

/** Autogenerated return type of ProvisionConquestUser. */
export type ProvisionConquestUserPayload = {
  readonly __typename?: 'ProvisionConquestUserPayload';
  /** Verified advisor name */
  readonly advisorName: Scalars['String']['output'];
  /** Verified advisor user id */
  readonly advisorUserId: Scalars['ID']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The advisor’s Conquest user id after the call */
  readonly conquestUserId?: Maybe<Scalars['Int']['output']>;
  /** Verified advisor email */
  readonly email: Scalars['String']['output'];
  /** Reason the write did not take effect */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the intended write took effect on this call */
  readonly success: Scalars['Boolean']['output'];
};

export type PublicAdvisor = {
  readonly __typename?: 'PublicAdvisor';
  readonly bio: Scalars['String']['output'];
  readonly calendlyLink?: Maybe<Scalars['String']['output']>;
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
};

/** A User participating in a calendar event (limited public view) */
export type PublicParticipantUser = {
  readonly __typename?: 'PublicParticipantUser';
  /** Email address */
  readonly email: Scalars['String']['output'];
  /** User ID */
  readonly id: Scalars['ID']['output'];
  /** Full name */
  readonly name: Scalars['String']['output'];
};

/** Autogenerated input type of PublishDraftTask */
export type PublishDraftTaskInput = {
  /** Whether the published client task should include Calendly scheduling. */
  readonly addCalendlyScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  /** Current task assignee ID to apply before publishing. */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** Box folder ID to attach before publishing. */
  readonly boxFolderId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Current human task description or instructions to apply before publishing. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Current task due date to apply before publishing. */
  readonly dueDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Whether the client should be notified when the draft is published. */
  readonly notifyClientUponCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Current task priority to apply before publishing. */
  readonly priority?: InputMaybe<TaskPriority>;
  /** Whether the published client task should send email reminders. */
  readonly sendClientEmailReminders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the client should receive an SMS when the draft is published. */
  readonly smsClientUponCreation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Active status to publish the draft as. Defaults to TODO. */
  readonly status?: InputMaybe<TaskStatus>;
  /** The ID of the draft task to publish */
  readonly taskId: Scalars['ID']['input'];
  /** Current task title to apply before publishing. */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PublishDraftTask. */
export type PublishDraftTaskPayload = {
  readonly __typename?: 'PublishDraftTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The published task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of PublishFinancialPlan */
export type PublishFinancialPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Conquest story ID to publish/unpublish. Null to unlink a deleted story. */
  readonly conquestStoryId?: InputMaybe<Scalars['String']['input']>;
  /** Financial plan ID to update */
  readonly financialPlanId: Scalars['ID']['input'];
  /** Target status (DRAFT or PUBLISHED) */
  readonly status: DigitalStoryStatus;
};

/** Autogenerated return type of PublishFinancialPlan. */
export type PublishFinancialPlanPayload = {
  readonly __typename?: 'PublishFinancialPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated financial plan */
  readonly financialPlan?: Maybe<FinancialPlan>;
};

/** Backend-authoritative forecast of what publishing a service catalog template will send */
export type PublishForecast = {
  readonly __typename?: 'PublishForecast';
  /** Soonest automated-email send time across all items (null when nothing would send) */
  readonly firstSendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The service catalog item group being forecast */
  readonly groupId: Scalars['ID']['output'];
  /** Per-item send forecast */
  readonly items: ReadonlyArray<PublishForecastItem>;
  /** Number of automated emails whose send date is already past. SendDueEmailsJob holds these rather than sending them */
  readonly totalImmediateSends: Scalars['Int']['output'];
};

/** Per-item send forecast for publishing a service catalog template */
export type PublishForecastItem = {
  readonly __typename?: 'PublishForecastItem';
  /** The service catalog item ID */
  readonly itemId: Scalars['ID']['output'];
  /** The item name */
  readonly itemName: Scalars['String']['output'];
  /** Soonest automated-email send time across enrollments (null when the item sends no email) */
  readonly nextSendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Enrolled households that will receive this item on publish */
  readonly recipientCount: Scalars['Int']['output'];
  /** Enrolled recipient households (name + email) that will receive this item on publish */
  readonly recipients: ReadonlyArray<PublishForecastRecipient>;
  /** Whether at least one email for this item already has a past send date, so it will be held rather than sent */
  readonly sendsImmediately: Scalars['Boolean']['output'];
};

/** A household that will receive a service catalog item on publish, and the email(s) it would be delivered to */
export type PublishForecastRecipient = {
  readonly __typename?: 'PublishForecastRecipient';
  /** Comma-joined client email(s) the invite would be delivered to (blank when no client email exists) */
  readonly email: Scalars['String']['output'];
  /** The recipient household name */
  readonly householdName: Scalars['String']['output'];
};

/** Autogenerated input type of PublishMeetingPrepOperation */
export type PublishMeetingPrepOperationInput = {
  /** Scheduled occurrence selected for create-or-reuse */
  readonly calendarEventOccurrenceId?: InputMaybe<Scalars['ID']['input']>;
  /** Existing meeting-prep document selected for refresh */
  readonly canvasDocumentId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Validated canonical meeting-prep content */
  readonly content: Scalars['JSON']['input'];
  /** Advisor-owned conversation for unscheduled creation */
  readonly conversationId?: InputMaybe<Scalars['ID']['input']>;
  /** Optimistic generated-content revision */
  readonly expectedRevision?: InputMaybe<Scalars['Int']['input']>;
  /** Meeting-prep operation intent discriminator */
  readonly intentKind: Scalars['String']['input'];
  /** Generated section selected for scoped replacement */
  readonly section?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-provided tentative date for unscheduled creation */
  readonly tentativeDate?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-provided meeting title for unscheduled creation */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PublishMeetingPrepOperation. */
export type PublishMeetingPrepOperationPayload = {
  readonly __typename?: 'PublishMeetingPrepOperationPayload';
  /** Published or preserved meeting-prep document */
  readonly canvasDocumentId?: Maybe<Scalars['ID']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Publication outcome */
  readonly outcome: Scalars['String']['output'];
  /** Current generated-content revision */
  readonly revision?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of PublishReport */
export type PublishReportInput = {
  /** When to surface the report in the client portal. Defaults to nil (not yet visible). */
  readonly addedToPortalAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional expiry datetime after which the report is no longer accessible. */
  readonly expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Household receiving the published report. */
  readonly householdId: Scalars['ID']['input'];
  /** Serialized ReportViewPayload, enriched by the FE with advisorName/logoUrl. */
  readonly snapshot: Scalars['JsonHash']['input'];
  /** Display title for the published report. */
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of PublishReport. */
export type PublishReportPayload = {
  readonly __typename?: 'PublishReportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly published report. */
  readonly publishedReport: PublishedReport;
};

/** Autogenerated input type of PublishServiceCatalogItemGroup */
export type PublishServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishServiceCatalogItemGroup. */
export type PublishServiceCatalogItemGroupPayload = {
  readonly __typename?: 'PublishServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The published service catalog item group */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
};

/**
 * A read-only snapshot of a Report Builder configuration, published by an advisor
 * for a household to view in the client portal.
 */
export type PublishedReport = {
  readonly __typename?: 'PublishedReport';
  /** When this report was surfaced in the client portal. Null until the advisor adds it. */
  readonly addedToPortalAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the report was published. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** When this report expires and is no longer accessible. Null means it never expires. */
  readonly expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The household this report was published to. */
  readonly household: Household;
  /** The unique identifier for the published report. */
  readonly id: Scalars['ID']['output'];
  /** The advisor who published the report. */
  readonly publishedBy: User;
  /** Serialized ReportViewPayload captured at publish time. */
  readonly snapshot: Scalars['JSON']['output'];
  /** Display title shown to the client. */
  readonly title: Scalars['String']['output'];
  /** Which renderer the snapshot belongs to. */
  readonly type: PublishedReportType;
};

/** Summary of a published report for client portal list views (no snapshot payload). */
export type PublishedReportSummary = {
  readonly __typename?: 'PublishedReportSummary';
  /** When surfaced in the client portal. Null until shared — lets the advisor UI tell "Prepared" from "Live". */
  readonly addedToPortalAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Client-facing attribution: the publisher if an advisor, else the household
   * advisor, else null. Never a CSA or assistant, unlike published_by_name.
   */
  readonly attributedAdvisorName?: Maybe<Scalars['String']['output']>;
  /** Profile picture URL of the advisor named by attributed_advisor_name. */
  readonly attributedAdvisorProfilePicUrl?: Maybe<Scalars['String']['output']>;
  /** Canvas document this report was published from, for deep-linking back into the canvas. Null for Report Builder reports. */
  readonly canvasDocumentId?: Maybe<Scalars['ID']['output']>;
  /** When the report was published. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** When this report expires. Null means it never expires. */
  readonly expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The unique identifier for the published report. */
  readonly id: Scalars['ID']['output'];
  /**
   * Raw publisher, which may be a CSA or an assistant. Advisor-facing only: null
   * for client viewers, who get attributed_advisor_name instead.
   */
  readonly publishedByName?: Maybe<Scalars['String']['output']>;
  /** Profile picture URL of the raw publisher. Advisor-facing only: null for client viewers. */
  readonly publishedByProfilePicUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the report link is live or expired, derived from expires_at. */
  readonly status: Scalars['String']['output'];
  /** Display title shown to the client. */
  readonly title: Scalars['String']['output'];
  /** Which renderer the snapshot belongs to. */
  readonly type: PublishedReportType;
  /** When the report was last modified. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Which renderer a published report snapshot belongs to */
export const PublishedReportType = {
  /** canvas */
  Canvas: 'canvas',
  /** report_builder */
  ReportBuilder: 'report_builder'
} as const;

export type PublishedReportType = typeof PublishedReportType[keyof typeof PublishedReportType];
export type PushNotificationOpened = {
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of the opened notification. Paired with the sent count to compute per-notification engagement. */
  readonly notificationId: Scalars['String']['input'];
  /** Type/category of the opened notification. */
  readonly notificationType?: InputMaybe<Scalars['String']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export type PushNotificationsToggled = {
  /** Whether the user turned the device push-notification preference on (true) or off (false). */
  readonly enabled: Scalars['Boolean']['input'];
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

/** One period column of the Report Builder Summary quarterly breakdown. */
export type QuarterlyPerformanceSummary = {
  readonly __typename?: 'QuarterlyPerformanceSummary';
  /** Portfolio market value at window start. */
  readonly beginningMarketValue?: Maybe<Value>;
  /** Total contributions in the window. */
  readonly contributions?: Maybe<Value>;
  /** Total distributions in the window. */
  readonly distributions?: Maybe<Value>;
  /** Total dividends and interest received in the window. */
  readonly dividendsAndInterest?: Maybe<Value>;
  /** The window end. */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /** Portfolio market value at window end. */
  readonly endingMarketValue?: Maybe<Value>;
  /** Column header: Q1/Q2/Q3, QTD, YTD, or Inception. */
  readonly label: Scalars['String']['output'];
  /** Net gains in the window (end - start - net flows). */
  readonly netGains?: Maybe<Value>;
  /** The window start. */
  readonly startDate: Scalars['ISO8601Date']['output'];
  /**
   * Inbound account transfers (Merge In + Journal In), signed positive. Null on
   * the snapshot path where merge/journal are unavailable.
   */
  readonly transfersIn?: Maybe<Value>;
  /**
   * Outbound account transfers (Merge Out + Journal Out), signed negative. Null on
   * the snapshot path where merge/journal are unavailable.
   */
  readonly transfersOut?: Maybe<Value>;
  /** Time-weighted return for the window, as a decimal fraction (0.12 = 12%). */
  readonly twr?: Maybe<Scalars['Float']['output']>;
};

/** A single quarter's time-weighted return, used by the Quarterly Returns bar chart. */
export type QuarterlyReturn = {
  readonly __typename?: 'QuarterlyReturn';
  /** Last calendar day of the quarter. */
  readonly quarterEnd: Scalars['ISO8601Date']['output'];
  /** Time-weighted return for the quarter, expressed as a fraction (0.05 = 5%). */
  readonly twr: Scalars['BigDecimal']['output'];
};

export type Query = {
  readonly __typename?: 'Query';
  readonly account: Account;
  readonly accountNewsArticles: ReadonlyArray<NewsArticle>;
  readonly accountSleeve: AccountSleeve;
  /**
   * One account's cash as of its latest Orion Connect snapshot, for the money
   * movement form. Null when Orion has no snapshot for it.
   */
  readonly accountSnapshotCash?: Maybe<AccountSnapshotCash>;
  readonly accountTrendingHeadlines: ReadonlyArray<TrendingHeadline>;
  /** Touchpoint totals, recency and channel mix for a household window */
  readonly activityTimelineContactSummary: ActivityTimelineContactSummary;
  /** Fetches activity entry items for a household */
  readonly activityTimelineEntryItems: Entries;
  /** Distinct months with activity for a household timeline (powers the month rail) */
  readonly activityTimelineMonths: ReadonlyArray<Month>;
  readonly adminServiceObjects: ReadonlyArray<AdminServiceObject>;
  readonly advisor: Advisor;
  /**
   * Returns a list of accounts accessible to the current user
   * @deprecated Use advisor.accounts instead
   */
  readonly advisorAccounts: AccountConnection;
  /** Read-only global Activities feed for the current advisor */
  readonly advisorActivities: AdvisorActivityConnection;
  /** Per-day activity counts for the current advisor; drives the Activity feed timeline minimap. */
  readonly advisorActivityDailyCounts: ReadonlyArray<AdvisorActivityDailyCount>;
  /** A single event from any of the advisor's calendars by id, with household + meeting prep */
  readonly advisorCalendarEvent?: Maybe<AdvisorCalendarEvent>;
  /** Advisor calendar events across all of their calendars between two dates (advisor tz), with household + prep doc id */
  readonly advisorCalendarEvents: ReadonlyArray<AdvisorCalendarEvent>;
  /** Admin query to get all clients for a specific advisor with their associated data */
  readonly advisorClients: ReadonlyArray<AdvisorClient>;
  /** Get paginated client households for the advisor dashboard with filtering and sorting */
  readonly advisorDashboardClients: HouseholdConnection;
  /** Admin: advisor-led onboarding LD status + provenance for an advisor */
  readonly advisorDirectedOnboardingStatus: AdvisorDirectedOnboardingStatus;
  /** Firm-wide advisor directory with server-side search + facets (advisor or admin) */
  readonly advisorDirectory: AdvisorDirectoryEntryConnection;
  /** Returns a list of fee schedules created for an advisor */
  readonly advisorFeeSchedules: ReadonlyArray<FeeSchedule>;
  /** The fee schedules on an advisor group's households */
  readonly advisorGroupFeeSchedules: AdvisorGroupFeeSchedules;
  /** Advisor groups (teams) the caller may see, optionally filtered by name */
  readonly advisorGroups: AdvisorGroupConnection;
  /** Distinct US state codes across primary clients in the advisor's accessible households, for populating the state filter */
  readonly advisorHouseholdStates: ReadonlyArray<Scalars['String']['output']>;
  /** Fetch an advisor identity profile (voice DNA + future kinds). */
  readonly advisorIdentityProfile?: Maybe<AdvisorIdentityProfile>;
  /** Every in-person meeting recording the current advisor has made, newest first */
  readonly advisorMeetingRecordings: ReadonlyArray<MeetingRecording>;
  /** Pre-flight for the admin book upload page: whether an advisor can receive a book and what is already staged. */
  readonly advisorOnboardingBookUploadReadiness?: Maybe<BookUploadReadiness>;
  /** Whether the current advisor is enrolled in the onboarding revamp and eligible for the intake wizard. */
  readonly advisorOnboardingEligible: Scalars['Boolean']['output'];
  /** Look up an advisor onboarding enrollment by uuid for the intake wizard gate + resume. */
  readonly advisorOnboardingEnrollment?: Maybe<AdvisorOnboardingEnrollment>;
  /** The advisor's most recent onboarding book import, for surfacing skipped-row import errors in the cockpit. */
  readonly advisorOnboardingLatestBookImport?: Maybe<BulkImport>;
  /** The current advisor's saved onboarding personalization for the intake wizard personalize step. */
  readonly advisorOnboardingPersonalization?: Maybe<AdvisorOnboardingPersonalization>;
  /** Look up one staged household by id for the confirm-accounts screen. */
  readonly advisorOnboardingStagedHousehold?: Maybe<AdvisorOnboardingStagedHousehold>;
  /** The current advisor's Ops contact (CSA) for the onboarding welcome screen */
  readonly advisorOpsContact?: Maybe<AdvisorOpsContact>;
  /** List all published reports for a household (live and expired) for advisor-side management */
  readonly advisorPublishedReports: ReadonlyArray<PublishedReportSummary>;
  /**
   * Paginated referral edges backing the referral ledger
   * @deprecated Use advisorReferrals, which reads the referrals table
   */
  readonly advisorReferralLedger: ProfessionalRelationshipConnection;
  /** Book-wide referral analytics and per-source totals for the acting advisor */
  readonly advisorReferralMetrics: ReferralMetricsSummary;
  /** Paginated referrals backing the Referrals page ledger */
  readonly advisorReferrals: ReferralConnection;
  /** All report schedules visible to the current advisor, with household reach and latest execution status */
  readonly advisorReportSchedules: ReadonlyArray<AdvisorReportSchedule>;
  /** Internal-admin query: advisor-tier team members whose level can be managed */
  readonly advisorTierTeamMembers: ReadonlyArray<User>;
  /**
   * Size of the advisor's grouped Inbox, for the notification badge. Exact below
   * 100; otherwise 100, meaning "100 or more" — the badge renders that as "99+",
   * so the read stops instead of counting on.
   */
  readonly alertBadgeCount: Scalars['Int']['output'];
  /** Action Center filter-chip counts grouped by alert type. */
  readonly alertCountsByType: AlertCountsBy;
  readonly alerts: AlertConnection;
  /** Admin query for internal tools to fetch advisors */
  readonly allAdvisors: ReadonlyArray<Advisor>;
  readonly alternativeFunds: ReadonlyArray<AlternativeFund>;
  /** One announcement for the CMS editor */
  readonly announcementConfig: EditorAnnouncement;
  /** Announcements for the CMS editor */
  readonly announcementConfigs: ReadonlyArray<EditorAnnouncement>;
  /** Per-asset-class returns with benchmark comparisons (HAWK-112). */
  readonly assetClassReturns: ReadonlyArray<AssetClassReturn>;
  /** Advisors in the plan's organization, selectable as a project row assignee */
  readonly assignableAdvisorsForRetirementPlan: ReadonlyArray<AssignableAdvisor>;
  readonly auditHouseholdAccess: ReadonlyArray<HouseholdAccessAuditResult>;
  /** Distinct event keys the advisor has activities for; drives the Activity Type filter. */
  readonly availableActivityEventKeys: ReadonlyArray<Scalars['String']['output']>;
  /** Distinct alert types the advisor has active inbox alerts for; drives the Inbox Type filter. */
  readonly availableInboxAlertTypes: ReadonlyArray<Scalars['String']['output']>;
  /** Look up the canonical bank name for an ABA routing number (UNO-206 suggestion chip) */
  readonly bankNameForRoutingNumber?: Maybe<Scalars['String']['output']>;
  /** Compact household or selected-account TWR comparison against Report Builder benchmarks. */
  readonly benchmarkComparison: BenchmarkComparisonResult;
  /** Poll the status of an async benchmark-data generation job. */
  readonly benchmarkDataGeneration?: Maybe<BenchmarkDataGeneration>;
  /** List a household's live Box Client Uploads files with extraction status */
  readonly boxClientUploadStatements: ReadonlyArray<BoxClientUploadStatement>;
  readonly boxConfiguration: BoxConfiguration;
  readonly boxMarketingConfiguration: BoxMarketingConfiguration;
  readonly boxThumbnails: ReadonlyArray<BoxFileThumbnail>;
  /** Get a list of brokerage account statements */
  readonly brokerageAccountStatements: ReadonlyArray<BrokerageAccountStatement>;
  /** Get a bulk import by ID */
  readonly bulkImport?: Maybe<BulkImport>;
  /** Get the most recent bulk imports */
  readonly bulkImports: ReadonlyArray<BulkImport>;
  /** Get the status of a bulk report generation job */
  readonly bulkReportGenerationJob?: Maybe<BulkReportGenerationJob>;
  /** Status of a bulk upload-to-Box job (poll after bulkUploadFilesToBox) */
  readonly bulkUploadFilesToBoxStatus?: Maybe<BulkUploadFilesToBoxStatus>;
  /** Work items for the advisor calendar (tasks with due dates and events) in a time range */
  readonly calendarWorkItems: CalendarWorkItemConnection;
  /**
   * Folder-downscoped Box token (read-level file access + Box AI) for the Savvy
   * Intelligence canvas agent harness to read a household's Box documents
   * server-side, gated by household access. Agent-harness use only — not a
   * general-purpose Box token.
   */
  readonly canvasHouseholdBoxToken?: Maybe<CanvasBoxToken>;
  readonly centerOfInfluenceReps: ReadonlyArray<CenterOfInfluenceRep>;
  /** A Chimney valuation for an address, looked up before the asset is saved */
  readonly chimneyPropertyEstimate?: Maybe<ChimneyPropertyEstimate>;
  readonly client: Client;
  /** Client endpoint for whether the viewer's firm shows advisory fees in the client portal transactions view. */
  readonly clientPortalAdvisoryFeesVisible?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Client endpoint for whether the viewer's firm orders the allocation by
   * asset-class ratio rather than largest holding first.
   */
  readonly clientPortalAllocationSortByRatio?: Maybe<Scalars['Boolean']['output']>;
  /** Client endpoint for the comparison index a client-portal return figure is measured against. */
  readonly clientPortalBenchmarkComparison?: Maybe<ClientPortalBenchmarkComparison>;
  /** Client endpoint for the ordered comparison indexes a client-portal return figure is measured against. */
  readonly clientPortalBenchmarkComparisons: ReadonlyArray<ClientPortalBenchmarkComparison>;
  /** Client endpoint for whether the viewer's firm shows closed positions in client-portal Positions. */
  readonly clientPortalClosedPositionsVisible?: Maybe<Scalars['Boolean']['output']>;
  /** Client endpoint for the household's own return series, charted against the comparison index. */
  readonly clientPortalPortfolioReturnSeries?: Maybe<ReadonlyArray<ClientPortalReturnSeriesPoint>>;
  /** Search for client profiles by name & associated info */
  readonly clientProfiles: ClientConnection;
  /** Users a comment on this subject can @-mention. */
  readonly commentMentionCandidates: ReadonlyArray<CommentMentionCandidate>;
  /** A subject's internal comment thread for the current user, newest first. */
  readonly comments: CommentFeed;
  /** Companies accessible to the current advisor */
  readonly companies: ReadonlyArray<Company>;
  /** A company by ID */
  readonly company: Company;
  /** Conquest-computed calc results (projection + net-worth breakdown) for a household's plan (calls Conquest) */
  readonly conquestPlanCalcs?: Maybe<Scalars['JSON']['output']>;
  /** The raw IntegrationPlanData body of a household's Conquest plan, returned as-is for the frontend to map (calls Conquest) */
  readonly conquestPlanRawData?: Maybe<Scalars['JSON']['output']>;
  /**
   * Per-year percentiles of a household plan's investable portfolio across
   * Conquest volatility trials, widening as chunks are requested (calls Conquest)
   */
  readonly conquestPlanVolatilityTrials?: Maybe<Scalars['JSON']['output']>;
  /** A single contact the caller may read, by ID */
  readonly contact?: Maybe<ContactRecord>;
  /** The company and advisor choices for the contacts directory filters */
  readonly contactFilterOptions: ContactFilterOptions;
  /** Every relationship written on a household the caller may read */
  readonly contactRelationshipOptions: ReadonlyArray<Scalars['String']['output']>;
  /** Every referral on the advisor's book, for the contact web */
  readonly contactWebReferrals: ReadonlyArray<Referral>;
  /** One page of the contacts the caller may read, with the households each one is linked to */
  readonly contacts: ContactRecordPage;
  readonly currentUser: CurrentUser;
  /** Get the status of a data export */
  readonly dataExport?: Maybe<DataExport>;
  /** Progress of a demo environment reseed. */
  readonly demoReseedRun?: Maybe<DemoReseedRun>;
  readonly dialpadCall: DialpadCallApi;
  readonly dialpadTranscript: DialpadTranscript;
  /** Direct Indexing-eligible accounts the current user can access (used by the Direct Index Report account picker). */
  readonly directIndexingEligibleAccounts: ReadonlyArray<Account>;
  /** Canonical advisor spoken-language taxonomy for directory facets + picker */
  readonly directoryLanguages: ReadonlyArray<DirectoryLanguage>;
  /** Distinct advisor states for the directory location facet */
  readonly directoryLocations: ReadonlyArray<Scalars['String']['output']>;
  /** Canonical advisor specialty taxonomy for directory facets + picker */
  readonly directorySpecialties: ReadonlyArray<DirectorySpecialty>;
  /** Organizations with at least one listed directory advisor, for the directory Organization facet */
  readonly directoryTeams: ReadonlyArray<DirectoryTeam>;
  /** Available disqualified reason options */
  readonly disqualifiedReasonOptions: ReadonlyArray<Scalars['String']['output']>;
  readonly docusignEnvelopeLink?: Maybe<Scalars['String']['output']>;
  readonly docusignRecipientLink: Scalars['String']['output'];
  /** DocuSign tracker envelope rows for the current advisor (or org-wide if can_edit_organization) */
  readonly docusignTrackerEnvelopes: ReadonlyArray<DocusignTrackerEnvelope>;
  /** Supported Fidelity NFS account registrations */
  readonly eciAccountRegistrationOptions: ReadonlyArray<EciAccountRegistrationOption>;
  /** Admin: renders the MSA-change notice for one household without sending it. */
  readonly eciAgreementUpdatedEmailPreview: EmailPreview;
  /** ECI custodian-transfer onboarding request + sidecars for the magic-link holder or the owning signed-in client */
  readonly eciClientOnboarding: EciClientOnboarding;
  /** Renders the ECI client-onboarding email to inlined HTML for a live preview. */
  readonly eciClientOnboardingEmailPreview: EmailPreview;
  /** Search usable local delivering custodians. */
  readonly eciCustodianDetails: ReadonlyArray<EciCustodianDetail>;
  /** Admin: one ECI template, with its live Box file, fields and version history. */
  readonly eciFormTemplateDetail?: Maybe<FormTemplateDetail>;
  /** Admin: every document template the ECI Form Center can manage. */
  readonly eciFormTemplates: ReadonlyArray<FormTemplate>;
  /** Admin: households that signed an earlier MSA version, with their eligible recipients. */
  readonly eciMsaNoticeAudience: MsaNoticeAudience;
  /** Eligible household account owners and whether each has already signed an MSA. */
  readonly eciNewAccountOwners: ReadonlyArray<EciNewAccountOwner>;
  /** Admin: check a candidate ECI template against what the code requires, writing nothing. */
  readonly eciTemplateUploadPrecheck?: Maybe<TemplateUploadPrecheck>;
  /** Fetch a single email message, scoped to a household or contact, for the activity-timeline email detail view. */
  readonly emailMessage?: Maybe<EmailMessage>;
  /** Semantic (vector) nearest-neighbor search over a household's email threads for the Savvy Intelligence canvas agent. */
  readonly emailThreadSemanticSearch?: Maybe<ReadonlyArray<EmailThreadSemanticSearchHit>>;
  /** Native Estimated Cash Flow report — replaces the Orion-generated Estimated Income PDF (HAWK-34). */
  readonly estimatedCashFlow: EstimatedCashFlowReport;
  /** Get Extend-extracted document data for a household */
  readonly extendExtractedDatum: ReadonlyArray<ExtendExtractedDatum>;
  /** Returns a list of family members for a specific household */
  readonly familyMembers: ReadonlyArray<FamilyMember>;
  readonly financialOfferings: ReadonlyArray<FinancialOffering>;
  /** Returns a financial plan for a household (WIP) */
  readonly financialPlan?: Maybe<FinancialPlan>;
  readonly financialPlanReportFile: FinancialPlanningBoxFolderData;
  readonly financialRecommendations: ReadonlyArray<FinancialRecommendation>;
  /** Advisor-only lookup of a user by email for the Add Household Member dialog (4C1T-42). */
  readonly findUserByEmail?: Maybe<UserLookupResult>;
  /**
   * Won households the viewer can access, rolled up per household across their
   * enrolled services, for the firm service calendar
   */
  readonly firmServiceCalendarRows: ReadonlyArray<FirmServiceCalendarRow>;
  /** Advisors in the current firm admin's organization eligible to seed a new team */
  readonly firmTeamCandidates: ReadonlyArray<FirmTeamCandidate>;
  readonly goals: ReadonlyArray<Goal>;
  readonly googleCloudOAuthUrl: Scalars['String']['output'];
  /** True when the client has an unsubmitted ECI custodian-transfer onboarding that was sent with a magic link */
  readonly hasActiveEciClientOnboarding: Scalars['Boolean']['output'];
  /** Native holdings summary report — replaces the Orion-generated PDF (HAWK-23). */
  readonly holdingsSummary: HoldingsSummary;
  readonly household: Household;
  /** Read a household's agent proposals and the count waiting for a decision. Never reads the plan from the planning engine. */
  readonly householdAgentProposals: HouseholdAgentProposals;
  /** Household-level cash available to invest, summed across the household's Eclipse-linked (managed) accounts */
  readonly householdAvailableToInvest: HouseholdAvailableToInvest;
  /** Current Orion benchmark value for a household (e.g. "191531_P"). */
  readonly householdBenchmark?: Maybe<Scalars['String']['output']>;
  /** Human-created blended benchmarks an advisor can pick for a household. */
  readonly householdBenchmarkBlends: ReadonlyArray<HouseholdBenchmarkBlend>;
  /** A single calendar event scoped to a household, so its note + transcript resolve under that household context */
  readonly householdCalendarEvent?: Maybe<CalendarEvent>;
  /** Cumulative return vs benchmark series for a household. */
  readonly householdCumulativeBenchmarkReport: ReadonlyArray<BenchmarkSeries>;
  /** Read a locally persisted Dialpad transcript through an exact household boundary. */
  readonly householdDialpadTranscript: DialpadTranscriptReadResult;
  /** Returns non-canceled source-backed ECI account onboarding tasks for a household's custodian transfer flow */
  readonly householdEciAccountOnboardingTasks: ReadonlyArray<Task>;
  /** Advisor-facing: a household ECI onboarding's account holders and the trusted contacts recorded for each. */
  readonly householdEciTrustedContactHolders: ReadonlyArray<EciTrustedContactHolder>;
  /** The services one household is enrolled in, from the enrollment's service foreign key */
  readonly householdEnrolledServices: ReadonlyArray<HouseholdEnrolledService>;
  /** Returns the last used fee schedule for a household */
  readonly householdFeeSchedule?: Maybe<HouseholdFeeSchedule>;
  /** Whether a household is still opening and funding its managed accounts, per account and rolled up. */
  readonly householdFundingState: HouseholdFundingState;
  /** The "Keep in mind" section for a household; null when the section should not appear at all */
  readonly householdKeepInMind?: Maybe<HouseholdKeepInMind>;
  /** Returns the household's managed accounts whose registration subtype is currently supported for eci transfer */
  readonly householdManagedAccounts: ReadonlyArray<Account>;
  /** The current advisor's in-person meeting recordings for one household */
  readonly householdMeetingRecordings: ReadonlyArray<MeetingRecording>;
  /** Returns the CenterOfInfluenceReps with a serves relationship to a household */
  readonly householdServedCenterOfInfluenceReps: ReadonlyArray<CenterOfInfluenceRep>;
  /** One household's service occurrences, oldest first, both shapes */
  readonly householdServiceOccurrences: ReadonlyArray<HouseholdServiceOccurrence>;
  readonly householdTasks: ReadonlyArray<Task>;
  /** Tax info for household */
  readonly householdTaxPage: TaxPage;
  /** Search for households by name and associated client information */
  readonly households: HouseholdSearchConnection;
  /** Get Orion Connect models explicitly enabled for the current advisor groups */
  readonly investmentProposalOrionModels: ReadonlyArray<InvestmentProposalOrionModel>;
  /** Native Invoice (Fee Review) report — replaces the Orion-generated Client Invoice PDF (HAWK-32). */
  readonly invoiceFeeReview: InvoiceFeeReview;
  /** A household's selectable Orion bills for the Invoice (Fee Review) invoice/quarter picker. */
  readonly invoiceFeeReviewBills: ReadonlyArray<InvoiceFeeReviewBillOption>;
  /** Checks if the provided password is the current user's password */
  readonly isValidPassword: Scalars['Boolean']['output'];
  /**
   * Available lead source options
   * @deprecated Flat list of categories only. Use leadSources, which carries the dependent detail options too.
   */
  readonly leadSourceOptions: ReadonlyArray<Scalars['String']['output']>;
  /** The lead source taxonomy: every category with the detail options that depend on it */
  readonly leadSources: ReadonlyArray<LeadSourceOption>;
  /** Candidate tasks for the task-link picker. Not named `tasks`, which is already the client-facing ClientTasksResolver. */
  readonly linkableTasks: ReadonlyArray<Task>;
  /** Admin: poll a Linked Bank Accounts import by ID */
  readonly linkedBankAccountImport?: Maybe<LinkedBankAccountImport>;
  /** Available loss reason options */
  readonly lossReasonOptions: ReadonlyArray<Scalars['String']['output']>;
  /** Returns a single meeting agenda template by ID, if visible to the current advisor */
  readonly meetingAgendaTemplate?: Maybe<MeetingAgendaTemplate>;
  /** Returns the meeting agenda templates visible to the current advisor */
  readonly meetingAgendaTemplates: MeetingAgendaTemplateConnection;
  /** Returns canonical meeting-prep context for an authorized scheduled or unscheduled target */
  readonly meetingPrepOperationContext: Scalars['JSON']['output'];
  /** Returns a bounded outline for a currently visible meeting agenda template */
  readonly meetingPrepTemplateOutline?: Maybe<Scalars['JSON']['output']>;
  /** The recap note for an in-person meeting, which has no calendar event to read it through */
  readonly meetingRecapNote?: Maybe<Note>;
  /** Poll one of the current advisor's in-person meeting recordings for its pipeline state */
  readonly meetingRecording?: Maybe<MeetingRecording>;
  /** Client endpoint for the beneficiary designations on one of the viewer's accounts */
  readonly myAccountBeneficiaries: ReadonlyArray<ClientAccountBeneficiary>;
  /** Client endpoint for the outside specialists who serve the viewer's household */
  readonly myProfessionalContacts: ReadonlyArray<ClientProfessionalContact>;
  /** Client endpoint for tax info */
  readonly myTaxPage: TaxPage;
  /** Get the status of a native async report generation job */
  readonly nativeReport?: Maybe<NativeReport>;
  /** Paginated Fidelity NFS audit log. Admin-only. */
  readonly nfsAuditEntries: NfsAuditEntryConnection;
  /** Full-text search over the NFS audit index. Admin-only. */
  readonly nfsAuditSearch: NfsAuditSearchResults;
  readonly notes: ReadonlyArray<Note>;
  /** Per-account / per-household alert mutes for a user. */
  readonly notificationAlertMutes: ReadonlyArray<NotificationAlertMute>;
  /** Effective catalog notification routing for a user. */
  readonly notificationRouting: ReadonlyArray<NotificationRoutePreference>;
  /** The email one occurrence would send, built by the mailer that sends it */
  readonly occurrenceEmailPreview?: Maybe<EmailTemplatePreview>;
  /** The advisor's in-flight book transfer households for the onboarding cockpit table. */
  readonly onboardingCockpit: OnboardingCockpitRowConnection;
  readonly onboardingTasks: ReadonlyArray<Task>;
  /** Returns aggregate information about opportunities */
  readonly opportunitiesTableHeaders: OpportunitiesTableHeader;
  /** Returns data needed for the Opportunities view */
  readonly opportunitiesTableRows: OpportunitiesTableRowConnection;
  /** Distinct primary advisors across opportunities accessible to the current user. */
  readonly opportunityPrimaryAdvisors: ReadonlyArray<PrimaryAdvisor>;
  readonly opsTasks?: Maybe<ReadonlyArray<Task>>;
  /** Get an organization by ID */
  readonly organization: Organization;
  /** Admin query to fetch all organizations */
  readonly organizations: OrganizationConnection;
  /** Allowed Orion ad-hoc reports for this environment */
  readonly orionAdHocReports: ReadonlyArray<OrionAdHocReport>;
  /** Read-only Orion Eclipse per-account diagnostic for a household */
  readonly orionEclipseAccountDiagnostic: OrionEclipseAccountDiagnostic;
  /** Read-only Orion vs Savvy diagnostic for a household */
  readonly orionHouseholdDiagnostic: OrionHouseholdDiagnostic;
  /** Get Orion portfolio documents */
  readonly orionPortfolioDocuments: ReadonlyArray<OrionPortfolioDocument>;
  /** Orion quarterly reports available for generation in this environment */
  readonly orionQuarterlyReports: ReadonlyArray<OrionQuarterlyReport>;
  /** Get the status of an Orion report generation */
  readonly orionReportGeneration?: Maybe<OrionReportGeneration>;
  /** Returns a list of Orion report templates */
  readonly orionReportTemplates: ReadonlyArray<OrionReportTemplate>;
  readonly orionSearch: ReadonlyArray<OrionSearch>;
  readonly orionSecurity: OrionSecurity;
  readonly orionSsoUrl: Scalars['String']['output'];
  /** Get the current Orion data sync status for a user */
  readonly orionSyncStatus: OrionSyncStatus;
  /** Orion Eclipse trade-order error-message catalog (code -> human text). */
  readonly orionTradeOrderMessages: ReadonlyArray<OrionTradeOrderMessage>;
  /** How many per-occurrence email copies a candidate recurrence would strand */
  readonly orphanedOccurrenceEmailCopies: Scalars['Int']['output'];
  /** Scheduled report executions awaiting the current advisor's review */
  readonly pendingReviewExecutions: ReadonlyArray<ReportScheduleExecution>;
  /** Native Performance by Account report — replaces the Orion-generated "Performance by Account" PDF (HAWK-77). */
  readonly performanceByAccount: PerformanceByAccount;
  /** Native Performance Report (Allocations) — replaces the Orion-generated "Performance Report – Allocations" PDF. */
  readonly performanceReportAllocations: PerformanceReportAllocations;
  /** Native Performance Report (Consolidated) — replaces the Orion-generated "Client Portfolio Review Report" PDF (HAWK-29). */
  readonly performanceReportConsolidated: PerformanceReportConsolidated;
  /** Native Performance Report (Integrated) — replaces the Orion-generated "Performance Report – Integrated" PDF (HAWK-27). */
  readonly performanceReportIntegrated: PerformanceReportIntegrated;
  /** Native Performance Report (Portfolio Group) — replaces the Orion-generated PDF (HAWK-30). */
  readonly performanceReportPortfolioGroup: Report;
  /** Native Performance Report (Unified) — replaces the Orion-generated PDF (HAWK-25). */
  readonly performanceReportUnified: Report;
  /**
   * Refresh a household's saved plan with current Savvy facts, push to the
   * planning engine, and return stored inputs. Requires write access. Null when
   * the household has no plan.
   */
  readonly plan?: Maybe<PlanningPlan>;
  /** Read-only Box Picker configuration scoped to one household. */
  readonly planningBoxPickerConfiguration: BoxPickerConfiguration;
  /** Read passive progress for a plan document import */
  readonly planningImportStatus?: Maybe<PlanningImportStatus>;
  /**
   * The asset allocations an account can be assigned to, read from the planning
   * engine. Defined once for the firm, so this takes no household.
   */
  readonly planningPortfolioOptions?: Maybe<ReadonlyArray<PlanningPortfolioOption>>;
  readonly portfolio: NetWorthPortfolioData;
  /** One manually valued portfolio item (asset or liability) by id and kind, for a per-item detail surface. */
  readonly portfolioItem: PortfolioItem;
  readonly portfolioPerformanceReport: PortfolioPerformanceReport;
  /** Statistical Summary report-builder section - portfolio risk stats plus benchmark-relative stats. */
  readonly portfolioStatisticalSummary: PortfolioStatisticalSummary;
  readonly portfolioStrategy: PortfolioStrategy;
  /**
   * Native Portfolio Summary (Comprehensive) report — replaces the Orion-generated
   * "Portfolio Summary - Comprehensive" PDF (HAWK-73).
   */
  readonly portfolioSummaryComprehensive: PortfolioSummaryComprehensive;
  /** For tag-create flows: matching households (smart) or all advisor households (manual). */
  readonly previewTagApplicationCandidates: ReadonlyArray<Household>;
  readonly prospectData: ProspectDatum;
  readonly publicAdvisor: PublicAdvisor;
  /** Fetch a published report by ID (for the client portal /dashboard/reports/:id) */
  readonly publishedReport?: Maybe<PublishedReport>;
  /** List portal-visible published reports for a household (client portal Reports tab) */
  readonly publishedReports: ReadonlyArray<PublishedReportSummary>;
  readonly quickTradeAccountInformation?: Maybe<QuickTradeAccountInformation>;
  readonly quickTradeEligibility: Scalars['Boolean']['output'];
  readonly quickTradeValidation: ReadonlyArray<QuickTradeValidationResponse>;
  /** Raw Savvy plan data for a household, read-only (does not call Conquest); the frontend maps it to the Conquest shape */
  readonly rawSavvyPlanData?: Maybe<RawSavvyPlanData>;
  /** Real-time (or delayed, per entitlement) market quotes from Orion Eclipse for the given tickers. */
  readonly realTimePrices: ReadonlyArray<RealTimePrice>;
  /** CSA-facing: the editable canonical field set + current values for a remediation subtask, keyed by remediation type. */
  readonly remediationEditableFields?: Maybe<EciRemediationEditableFields>;
  /** Look up the DocuSign link for a repaper envelope by trackingId */
  readonly repaperEnvelopeStatus?: Maybe<Scalars['String']['output']>;
  /** Batched: look up DocuSign links for multiple repaper envelopes by trackingId */
  readonly repaperEnvelopeStatuses: ReadonlyArray<RepaperEnvelopeStatus>;
  /** Recent scheduled report execution history for a household */
  readonly reportScheduleExecutionsForHousehold: ReadonlyArray<ReportScheduleExecution>;
  /** Active report schedules targeting a household with latest execution status */
  readonly reportSchedulesForHousehold: ReadonlyArray<HouseholdReportSchedule>;
  /** Fetch a single retirement plan by ID (gated behind retirementPlans flag) */
  readonly retirementPlan?: Maybe<RetirementPlan>;
  /** Fetch a single retirement plan project row (step) by ID (gated behind retirementPlans flag) */
  readonly retirementPlanProjectRow?: Maybe<RetirementPlanProjectRow>;
  /** Fetch a single retirement plan project template by ID (gated behind retirementPlans flag) */
  readonly retirementPlanProjectTemplate?: Maybe<RetirementPlanProjectTemplate>;
  /** Retirement plan project templates for the current advisor's organization (gated behind retirementPlans flag) */
  readonly retirementPlanProjectTemplates: ReadonlyArray<RetirementPlanProjectTemplate>;
  /** List retirement plans for the current advisor (gated behind retirementPlans flag) */
  readonly retirementPlans: ReadonlyArray<RetirementPlan>;
  readonly riskQuestionnaires: ReadonlyArray<RiskQuestionnaire>;
  readonly rmds: ReadonlyArray<Rmd>;
  readonly sandbox: Scalars['String']['output'];
  /** Saved report builder configurations for the current advisor */
  readonly savedReportTemplates: ReadonlyArray<SavedReportTemplate>;
  /**
   * The Savvy-owned advisor group an admin authors Savvy service templates in, so
   * the service editor has a create scope for an actor who belongs to no
   * organization and no advisor group. Admin-only; null for everyone else, while
   * flag-sc-v3 is off, and when the Savvy organization has no advisor group yet.
   */
  readonly savvyServiceCatalogScope?: Maybe<SavvyServiceCatalogScope>;
  /**
   * The Savvy-maintained service templates every advisor can browse and clone into
   * their own Resources, ordered by name. An advisor is served only the templates
   * that have a published version to clone; an admin, for whom this catalog is the
   * management view, is also served the never-published ones. Empty while
   * flag-sc-v3 is off.
   */
  readonly savvyServiceTemplates: ReadonlyArray<SavvyServiceTemplate>;
  /** Get all Savvy strategies in the catalog (raw holdings excluded) */
  readonly savvyStrategies: ReadonlyArray<SavvyStrategy>;
  /** Get a single Savvy strategy by Orion Connect model id (supports performanceSeries) */
  readonly savvyStrategy?: Maybe<SavvyStrategy>;
  /** Returns the globally-available Savvy workflow templates */
  readonly savvyWorkflowTemplates: TaskConnection;
  /** Schwab OAuth authorize URL for connecting Savvy as a Schwab API client (admin only) */
  readonly schwabAuthorizeUrl: Scalars['String']['output'];
  /** Admin: outcome of the newest firm-wide Schwab standing-authorizations sync, or of a specific run. */
  readonly schwabImportRunSummary?: Maybe<SchwabImportRunSummary>;
  /** Admin-only: search all active users by name for @mention autocomplete in task comments */
  readonly searchMentionableUsers: ReadonlyArray<TaskCommentMentionCandidate>;
  readonly serviceCalendarHouseholdOptions: ReadonlyArray<ServiceCalendarSettingTemplate>;
  /** Pull service calendar items by user hosuehold */
  readonly serviceCalendarItems: ReadonlyArray<ServiceCalendarItem>;
  /** Returns all of the service calendar meetings for a household */
  readonly serviceCalendarMeetings: ReadonlyArray<ServiceCalendarMeeting>;
  /** Resolver to pull calendar settings for a user household */
  readonly serviceCalendarSettings: ReadonlyArray<ServiceCalendarSetting>;
  /** Admin query to export service calendar v1 data for a specific advisor */
  readonly serviceCalendarV1Export: ExportPayload;
  /** Render a SC v2 catalog email template into HTML for the in-app preview dialog */
  readonly serviceCatalogEmailTemplatePreview: EmailTemplatePreview;
  /** Fetch a single service catalog item by ID */
  readonly serviceCatalogItem?: Maybe<ServiceCatalogItem>;
  /** Fetch a single service catalog item group by ID */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
  /** Forecast what publishing a service catalog item group will send */
  readonly serviceCatalogItemGroupPublishForecast?: Maybe<PublishForecast>;
  /** List service catalog item groups */
  readonly serviceCatalogItemGroups: ReadonlyArray<ServiceCatalogItemGroup>;
  /** List per-assignment overrides */
  readonly serviceCatalogItemHouseholdOverrides: ReadonlyArray<ServiceCatalogItemHouseholdOverride>;
  /** List service catalog item household assignments */
  readonly serviceCatalogItemHouseholds: ReadonlyArray<ServiceCatalogItemHousehold>;
  /** List service catalog items for an advisor group */
  readonly serviceCatalogItems: ReadonlyArray<ServiceCatalogItem>;
  /** SC v2 task display items: server-grouped multi-household occurrences + flat tasks */
  readonly serviceItemOccurrences: ServiceItemOccurrenceConnection;
  /** Won households the advisor can access, with advisor + tags, for the Service schedules tab */
  readonly serviceScheduleRows: ReadonlyArray<ServiceScheduleRow>;
  /** Organizations a retirement plan can be shared with (excludes its own organization) */
  readonly shareableOrganizationsForRetirementPlan: ReadonlyArray<ShareableOrganization>;
  /** Admin/CSA query for every survey round, newest first */
  readonly surveyRounds: ReadonlyArray<SurveyRoundReport>;
  /** Savvy Portfolio Finance loan-length + estimated-rate options; readable by internal staff (advisors/CSAs/admins) */
  readonly swimLoanLengthOptions: ReadonlyArray<SwimLoanLengthOption>;
  /** SWIM enrollment strategies and their fees (basis points); readable by internal staff (advisors/CSAs/admins) */
  readonly swimStrategies: ReadonlyArray<SwimStrategy>;
  readonly task?: Maybe<Task>;
  /** Resolve task activities by task ID */
  readonly taskActivities: ReadonlyArray<TaskActivity>;
  /** Fetch a task by its UUID (used for draft pre-filling) */
  readonly taskByUuid?: Maybe<Task>;
  /** Contact-card details for a task comment author, scoped to the household task context */
  readonly taskCommentAuthor?: Maybe<TaskCommentAuthor>;
  /** Eligible users for @mention autocomplete in task comments */
  readonly taskCommentMentionCandidates: ReadonlyArray<TaskCommentMentionCandidate>;
  /** Renders a client task email to inlined HTML for the task-creation preview, one entry per recipient. */
  readonly taskEmailPreview: ReadonlyArray<TaskEmailPreviewCopy>;
  /** Effective v6 task notification routing cells for a user. */
  readonly taskNotificationRouting: ReadonlyArray<NotificationTaskRoutingCell>;
  /** Returns paginated workflow task templates with filtering and sorting */
  readonly taskWorkflowTemplates: TaskConnection;
  readonly tasks: ReadonlyArray<Task>;
  /** Returns paginated tasks with filtering and sorting */
  readonly tasksTable: TaskConnection;
  /** Returns aggregated data for the task table */
  readonly tasksTableAggregatedData: TasksTableAggregatedData;
  /** Returns aggregate information about tax enrollments */
  readonly taxEnrollmentsTableHeaders: TaxEnrollmentsTableHeader;
  /** Returns tax enrollment data organized by household */
  readonly taxEnrollmentsTableRows: TaxEnrollmentsTableRowConnection;
  /** Today's calendar events across all of the current user's calendars */
  readonly todaysCalendarEvents: ReadonlyArray<CalendarEvent>;
  /**
   * Count and summed value of one account's or sleeve's transactions by type, over
   * an inclusive date range. It counts the rows the transactions list keeps: no
   * pending rows, and no reversed row that a completed twin replaces
   */
  readonly transactionTotals: ReadonlyArray<TransactionTypeTotal>;
  readonly transactions: ReadonlyArray<Transaction>;
  /** Get transcript consent form information for clients */
  readonly transcriptConsentForm: TranscriptConsentFormResponse;
  /** KYC readiness status and computed errors for a user */
  readonly userKycStatus: UserKycStatus;
  /** Saved view/preferences for the current user scoped by provided keys */
  readonly userSavedViews: ReadonlyArray<UserSavedView>;
  /** Transient voice prompt fragment from an in-progress capture session (step-4 preview; not persisted). */
  readonly voiceProfilePreviewFragment?: Maybe<Scalars['String']['output']>;
  /** Paginated households for a specific stat card drill-down */
  readonly workbenchStatHouseholds: WorkbenchStatHouseholdConnection;
  /** Summary values for all workbench stat cards */
  readonly workbenchStatsSummary: WorkbenchStatSummary;
  /** Returns Wrike marketing requests and if the current user is in an advisor group */
  readonly wrikeMarketingRequests?: Maybe<WrikeMarketingRequests>;
  readonly zoomMeetingTranscript: ZoomMeetingTranscript;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountNewsArticlesArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryAccountSleeveArgs = {
  accountSleeveId: Scalars['ID']['input'];
};


export type QueryAccountSnapshotCashArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryAccountTrendingHeadlinesArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryActivityTimelineContactSummaryArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  householdId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type QueryActivityTimelineEntryItemsArgs = {
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactHistoryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  linkedHouseholdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  newerThan?: InputMaybe<EntryPositionInput>;
  olderThan?: InputMaybe<EntryPositionInput>;
  onlyOpenTasks?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  pinnedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  topics?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  types?: InputMaybe<ReadonlyArray<ItemTypeEnum>>;
};


export type QueryActivityTimelineMonthsArgs = {
  centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactHistoryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  linkedHouseholdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  topics?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  types?: InputMaybe<ReadonlyArray<ItemTypeEnum>>;
};


export type QueryAdvisorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdvisorAccountsArgs = {
  advisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  balanceRange?: InputMaybe<BalanceRangeInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  feeSchedules?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  includeUnassignedAdvisor?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  portfolioMustBePresent?: InputMaybe<Scalars['Boolean']['input']>;
  providerNames?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<AccountSortValues>;
  strategyFilter?: InputMaybe<StrategyFilterInput>;
};


export type QueryAdvisorActivitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  eventKeys?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdContactId?: InputMaybe<Scalars['ID']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  occurredBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  primaryAdvisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorActivityDailyCountsArgs = {
  categories?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  eventKeys?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  householdContactId?: InputMaybe<Scalars['ID']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  primaryAdvisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorCalendarEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdvisorCalendarEventsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryAdvisorClientsArgs = {
  advisorId: Scalars['ID']['input'];
  pullProspects: Scalars['Boolean']['input'];
};


export type QueryAdvisorDashboardClientsArgs = {
  advisorId?: InputMaybe<Scalars['ID']['input']>;
  advisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludedAdvisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  excludedHouseholdTagCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  excludedHouseholdTags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  excludedLastContactDaysSince?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  excludedPrimaryAddressStates?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdTagCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  householdTags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  inactiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeProspectStages?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastContactDaysSince?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  myClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAddressStates?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  reviewDue?: InputMaybe<Scalars['Boolean']['input']>;
  servicesDue?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryAdvisorDirectedOnboardingStatusArgs = {
  advisorUserId: Scalars['ID']['input'];
};


export type QueryAdvisorDirectoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  languages?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AdvisorDirectorySortEnum>;
  specialties?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  teamIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  tenure?: InputMaybe<ReadonlyArray<AdvisorTenureBucketEnum>>;
};


export type QueryAdvisorFeeSchedulesArgs = {
  householdId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorGroupFeeSchedulesArgs = {
  advisorGroupId: Scalars['ID']['input'];
};


export type QueryAdvisorGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorIdentityProfileArgs = {
  advisorId: Scalars['ID']['input'];
  kind?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorMeetingRecordingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  unattachedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAdvisorOnboardingBookUploadReadinessArgs = {
  advisorId: Scalars['ID']['input'];
};


export type QueryAdvisorOnboardingEnrollmentArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryAdvisorOnboardingLatestBookImportArgs = {
  advisorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdvisorOnboardingStagedHouseholdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdvisorPublishedReportsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryAdvisorReferralLedgerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  direction?: InputMaybe<ReferralDirectionEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<ReferralOutcomeEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvisorReferralMetricsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdvisorReferralsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  direction?: InputMaybe<ReferralDirectionEnum>;
  directions?: InputMaybe<ReadonlyArray<ReferralDirectionEnum>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<ReferralOutcomeEnum>;
  outcomes?: InputMaybe<ReadonlyArray<ReferralOutcomeEnum>>;
  partnerKinds?: InputMaybe<ReadonlyArray<ReferralPartnerKindEnum>>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAlertBadgeCountArgs = {
  alertTypes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  primaryAdvisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};


export type QueryAlertCountsByTypeArgs = {
  primaryAdvisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};


export type QueryAlertsArgs = {
  acknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  alertTypes?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  applyRouting?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBulk?: InputMaybe<Scalars['Boolean']['input']>;
  householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  primaryAdvisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  requireHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  status?: InputMaybe<AlertStatusName>;
  userId: Scalars['ID']['input'];
};


export type QueryAnnouncementConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnnouncementConfigsArgs = {
  kinds?: InputMaybe<ReadonlyArray<AnnouncementKind>>;
  statuses?: InputMaybe<ReadonlyArray<AnnouncementStatus>>;
};


export type QueryAssetClassReturnsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
};


export type QueryAssignableAdvisorsForRetirementPlanArgs = {
  retirementPlanId: Scalars['ID']['input'];
};


export type QueryAuditHouseholdAccessArgs = {
  advisorUserId?: InputMaybe<Scalars['ID']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAvailableActivityEventKeysArgs = {
  primaryAdvisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


export type QueryAvailableInboxAlertTypesArgs = {
  primaryAdvisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};


export type QueryBankNameForRoutingNumberArgs = {
  routingNumber: Scalars['String']['input'];
};


export type QueryBenchmarkComparisonArgs = {
  accountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryBenchmarkDataGenerationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBoxClientUploadStatementsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryBoxConfigurationArgs = {
  actAsUserId?: InputMaybe<Scalars['ID']['input']>;
  includeDeleteInScope?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBoxMarketingConfigurationArgs = {
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QueryBoxThumbnailsArgs = {
  boxFileIds: ReadonlyArray<Scalars['ID']['input']>;
};


export type QueryBrokerageAccountStatementsArgs = {
  householdId: Scalars['ID']['input'];
  statementIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


export type QueryBulkImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBulkImportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBulkReportGenerationJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBulkUploadFilesToBoxStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryCalendarWorkItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeEvents?: InputMaybe<Scalars['Boolean']['input']>;
  itemType?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limitPerDay?: InputMaybe<Scalars['Int']['input']>;
  onlyTasksWithDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  taskFilters?: InputMaybe<TasksTableFilterInput>;
  timeMax: Scalars['ISO8601DateTime']['input'];
  timeMin: Scalars['ISO8601DateTime']['input'];
};


export type QueryCanvasHouseholdBoxTokenArgs = {
  boxFolderId: Scalars['String']['input'];
};


export type QueryChimneyPropertyEstimateArgs = {
  city: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};


export type QueryClientArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientPortalAdvisoryFeesVisibleArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClientPortalAllocationSortByRatioArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClientPortalBenchmarkComparisonArgs = {
  dateRange: DateRangeInput;
  householdId: Scalars['ID']['input'];
};


export type QueryClientPortalBenchmarkComparisonsArgs = {
  dateRange: DateRangeInput;
  householdId: Scalars['ID']['input'];
};


export type QueryClientPortalClosedPositionsVisibleArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClientPortalPortfolioReturnSeriesArgs = {
  dateRange: DateRangeInput;
  householdId: Scalars['ID']['input'];
  portfolioId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryClientProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isProspect?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryCommentMentionCandidatesArgs = {
  relationId: Scalars['ID']['input'];
  relationType: Scalars['String']['input'];
};


export type QueryCommentsArgs = {
  relationId: Scalars['ID']['input'];
  relationType: Scalars['String']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConquestPlanCalcsArgs = {
  householdId: Scalars['ID']['input'];
  overrides?: InputMaybe<PlanningPlanDataInput>;
};


export type QueryConquestPlanRawDataArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryConquestPlanVolatilityTrialsArgs = {
  count: Scalars['Int']['input'];
  householdId: Scalars['ID']['input'];
  offset: Scalars['Int']['input'];
  overrides?: InputMaybe<PlanningPlanDataInput>;
};


export type QueryContactArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  professionalPublicId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContactsArgs = {
  categories?: InputMaybe<ReadonlyArray<ContactCategory>>;
  companyIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerAdvisorProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  relationships?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  roles?: InputMaybe<ReadonlyArray<ContactRole>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<ContactSortField>;
  specialties?: InputMaybe<ReadonlyArray<CenterOfInfluenceRepSpecialty>>;
};


export type QueryDataExportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDemoReseedRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDialpadCallArgs = {
  dialpadCallId: Scalars['String']['input'];
};


export type QueryDialpadTranscriptArgs = {
  dialpadCallId: Scalars['String']['input'];
};


export type QueryDocusignEnvelopeLinkArgs = {
  trackingId: Scalars['String']['input'];
};


export type QueryDocusignRecipientLinkArgs = {
  envelopeId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};


export type QueryDocusignTrackerEnvelopesArgs = {
  daysBack?: InputMaybe<Scalars['Int']['input']>;
  envelopeId?: InputMaybe<Scalars['String']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  scope: DocusignTrackerScope;
  statusFilter?: InputMaybe<DocusignEnvelopeStatusFilter>;
};


export type QueryEciAgreementUpdatedEmailPreviewArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  householdId: Scalars['ID']['input'];
};


export type QueryEciClientOnboardingArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEciClientOnboardingEmailPreviewArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryEciCustodianDetailsArgs = {
  search: Scalars['String']['input'];
};


export type QueryEciFormTemplateDetailArgs = {
  templateKey: Scalars['String']['input'];
};


export type QueryEciNewAccountOwnersArgs = {
  householdPublicId: Scalars['ID']['input'];
};


export type QueryEciTemplateUploadPrecheckArgs = {
  contentBase64: Scalars['String']['input'];
  templateKey: Scalars['String']['input'];
};


export type QueryEmailMessageArgs = {
  centerOfInfluenceRepId?: InputMaybe<Scalars['ID']['input']>;
  contactId?: InputMaybe<Scalars['ID']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryEmailThreadSemanticSearchArgs = {
  householdId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryEstimatedCashFlowArgs = {
  accountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  endDate: Scalars['ISO8601Date']['input'];
  householdId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryExtendExtractedDatumArgs = {
  datumIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  householdId: Scalars['ID']['input'];
};


export type QueryFamilyMembersArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFinancialPlanArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFinancialPlanReportFileArgs = {
  actAsUserId?: InputMaybe<Scalars['ID']['input']>;
  includeDeleteInScope?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFinancialRecommendationsArgs = {
  categories?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  userId: Scalars['ID']['input'];
};


export type QueryFindUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGoalsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHasActiveEciClientOnboardingArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHoldingsSummaryArgs = {
  accountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  endDate: Scalars['ISO8601Date']['input'];
  householdId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryHouseholdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHouseholdAgentProposalsArgs = {
  householdId: Scalars['ID']['input'];
  statuses?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};


export type QueryHouseholdAvailableToInvestArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdBenchmarkArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdBenchmarkBlendsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdCalendarEventArgs = {
  calendarEventId: Scalars['ID']['input'];
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdCumulativeBenchmarkReportArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  dateRangeId?: InputMaybe<Scalars['String']['input']>;
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdDialpadTranscriptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  dialpadCallId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdEciAccountOnboardingTasksArgs = {
  householdPublicId: Scalars['ID']['input'];
};


export type QueryHouseholdEciTrustedContactHoldersArgs = {
  householdPublicId: Scalars['ID']['input'];
};


export type QueryHouseholdEnrolledServicesArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdFeeScheduleArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdFundingStateArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHouseholdKeepInMindArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdManagedAccountsArgs = {
  householdPublicId: Scalars['ID']['input'];
};


export type QueryHouseholdMeetingRecordingsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdServedCenterOfInfluenceRepsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdServiceOccurrencesArgs = {
  householdId: Scalars['ID']['input'];
  lookbackMonths?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHouseholdTasksArgs = {
  householdId: Scalars['ID']['input'];
  showHiddenTasks?: InputMaybe<Scalars['Boolean']['input']>;
  taskType?: InputMaybe<TaskTypeName>;
};


export type QueryHouseholdTaxPageArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryHouseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdStage?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoiceFeeReviewArgs = {
  accountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  asOfDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  billId?: InputMaybe<Scalars['ID']['input']>;
  householdId: Scalars['ID']['input'];
};


export type QueryInvoiceFeeReviewBillsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryIsValidPasswordArgs = {
  password: Scalars['String']['input'];
};


export type QueryLinkableTasksArgs = {
  excludeTaskUuid?: InputMaybe<Scalars['String']['input']>;
  householdUuid?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLinkedBankAccountImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMeetingAgendaTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMeetingAgendaTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  templateTypes?: InputMaybe<ReadonlyArray<MeetingAgendaTemplateType>>;
};


export type QueryMeetingPrepOperationContextArgs = {
  calendarEventOccurrenceId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  tentativeDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMeetingPrepTemplateOutlineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMeetingRecapNoteArgs = {
  householdId: Scalars['ID']['input'];
  meetingId: Scalars['ID']['input'];
};


export type QueryMeetingRecordingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMyAccountBeneficiariesArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryMyProfessionalContactsArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMyTaxPageArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNativeReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNfsAuditEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<NfsAuditDirection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gateway?: InputMaybe<NfsAuditGateway>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  operation?: InputMaybe<NfsAuditOperation>;
  recordedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  recordedBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  status?: InputMaybe<NfsAuditStatus>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNfsAuditSearchArgs = {
  direction?: InputMaybe<NfsAuditDirection>;
  from?: InputMaybe<Scalars['Int']['input']>;
  gateway?: InputMaybe<NfsAuditGateway>;
  operation?: InputMaybe<NfsAuditOperation>;
  recordedAfter?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  recordedBefore?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationAlertMutesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryNotificationRoutingArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryOccurrenceEmailPreviewArgs = {
  occurrenceId: Scalars['ID']['input'];
};


export type QueryOnboardingCockpitArgs = {
  advisorId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<OnboardingCockpitSortField>;
  status?: InputMaybe<OnboardingCockpitStatus>;
};


export type QueryOnboardingTasksArgs = {
  statuses?: InputMaybe<ReadonlyArray<TaskStatus>>;
};


export type QueryOpportunitiesTableHeadersArgs = {
  advisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  householdTagCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  householdTags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  leadSources?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  opportunityType?: InputMaybe<OpportunityTypeFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  statuses?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};


export type QueryOpportunitiesTableRowsArgs = {
  advisorIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  householdTagCategories?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  householdTags?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  leadSources?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  opportunityType?: InputMaybe<OpportunityTypeFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<OpportunitySortValues>;
  stages?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  statuses?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};


export type QueryOpsTasksArgs = {
  type?: InputMaybe<TaskTypeName>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrionEclipseAccountDiagnosticArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryOrionHouseholdDiagnosticArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryOrionPortfolioDocumentsArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryOrionReportGenerationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrionSearchArgs = {
  searchInput: Scalars['String']['input'];
};


export type QueryOrionSecurityArgs = {
  ticker: Scalars['String']['input'];
};


export type QueryOrionSyncStatusArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryOrphanedOccurrenceEmailCopiesArgs = {
  dtstart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  rrule?: InputMaybe<Scalars['String']['input']>;
  serviceCatalogItemId: Scalars['ID']['input'];
};


export type QueryPerformanceByAccountArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryPerformanceReportAllocationsArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryPerformanceReportConsolidatedArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
};


export type QueryPerformanceReportIntegratedArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryPerformanceReportPortfolioGroupArgs = {
  accountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startFromInception?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPerformanceReportUnifiedArgs = {
  accountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startFromInception?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlanArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryPlanningBoxPickerConfigurationArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryPlanningImportStatusArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryPortfolioArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  portfolioId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPortfolioItemArgs = {
  id: Scalars['ID']['input'];
  kind: PortfolioItemKind;
};


export type QueryPortfolioPerformanceReportArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  accountSleeveId?: InputMaybe<Scalars['ID']['input']>;
  allocationAsOfDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  allocationPeriod?: InputMaybe<PerformanceTimePeriodName>;
  clientUserId?: InputMaybe<Scalars['ID']['input']>;
  compareDateRange?: InputMaybe<DateRangeInput>;
  compareQuickDate?: InputMaybe<Scalars['String']['input']>;
  historicalHoldingsPeriod?: InputMaybe<PerformanceTimePeriodName>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  includeHistoricalHoldings?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioId?: InputMaybe<Scalars['ID']['input']>;
  quarterlyBreakdown?: InputMaybe<Scalars['Boolean']['input']>;
  rangeADateRange?: InputMaybe<DateRangeInput>;
};


export type QueryPortfolioStatisticalSummaryArgs = {
  dateRange: DateRangeInput;
  householdId: Scalars['ID']['input'];
};


export type QueryPortfolioStrategyArgs = {
  portfolioStrategyId: Scalars['ID']['input'];
};


export type QueryPortfolioSummaryComprehensiveArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryPreviewTagApplicationCandidatesArgs = {
  isSmart: Scalars['Boolean']['input'];
  organizationHouseholdCategoryId?: InputMaybe<Scalars['ID']['input']>;
  ruleJson?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryProspectDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicAdvisorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublishedReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublishedReportsArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryQuickTradeAccountInformationArgs = {
  accountId: Scalars['Int']['input'];
};


export type QueryQuickTradeEligibilityArgs = {
  trades: ReadonlyArray<QuickTradeEligibilityInput>;
};


export type QueryQuickTradeValidationArgs = {
  trades: ReadonlyArray<QuickTradeValidationInput>;
};


export type QueryRawSavvyPlanDataArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryRealTimePricesArgs = {
  tickers: ReadonlyArray<Scalars['String']['input']>;
};


export type QueryRemediationEditableFieldsArgs = {
  subtaskId: Scalars['ID']['input'];
};


export type QueryRepaperEnvelopeStatusArgs = {
  trackingId: Scalars['ID']['input'];
};


export type QueryRepaperEnvelopeStatusesArgs = {
  trackingIds: ReadonlyArray<Scalars['ID']['input']>;
};


export type QueryReportScheduleExecutionsForHouseholdArgs = {
  householdId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportSchedulesForHouseholdArgs = {
  householdId: Scalars['ID']['input'];
};


export type QueryRetirementPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRetirementPlanProjectRowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRetirementPlanProjectTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRiskQuestionnairesArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryRmdsArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type QuerySavvyStrategyArgs = {
  orionConnectModelId: Scalars['String']['input'];
};


export type QuerySavvyWorkflowTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySchwabAuthorizeUrlArgs = {
  app: SchwabOauthApp;
};


export type QuerySchwabImportRunSummaryArgs = {
  runId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchMentionableUsersArgs = {
  query: Scalars['String']['input'];
  salesforceAccountId: Scalars['String']['input'];
};


export type QueryServiceCalendarHouseholdOptionsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryServiceCalendarItemsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryServiceCalendarMeetingsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryServiceCalendarSettingsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryServiceCalendarV1ExportArgs = {
  advisorId: Scalars['ID']['input'];
  pullProspects: Scalars['Boolean']['input'];
};


export type QueryServiceCatalogEmailTemplatePreviewArgs = {
  body: Scalars['String']['input'];
  calendlyLink?: InputMaybe<Scalars['String']['input']>;
  emailCcUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  emailLeadTimeDays: Scalars['Int']['input'];
  emailSenderId?: InputMaybe<Scalars['ID']['input']>;
  meetingDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  serviceCatalogItemHouseholdId?: InputMaybe<Scalars['ID']['input']>;
  subject: Scalars['String']['input'];
};


export type QueryServiceCatalogItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceCatalogItemGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceCatalogItemGroupPublishForecastArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceCatalogItemGroupsArgs = {
  advisorGroupId?: InputMaybe<Scalars['ID']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryServiceCatalogItemHouseholdOverridesArgs = {
  serviceCatalogItemHouseholdId: Scalars['ID']['input'];
};


export type QueryServiceCatalogItemHouseholdsArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
  serviceCatalogItemId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryServiceCatalogItemsArgs = {
  advisorGroupId?: InputMaybe<Scalars['ID']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryServiceItemOccurrencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<TasksTableFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<TaskSortValues>;
  tz?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShareableOrganizationsForRetirementPlanArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
  retirementPlanId: Scalars['ID']['input'];
};


export type QueryTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  salesforceTaskId: Scalars['String']['input'];
};


export type QueryTaskActivitiesArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
  salesforceTaskId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTaskByUuidArgs = {
  taskId?: InputMaybe<Scalars['ID']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskCommentAuthorArgs = {
  householdPublicId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryTaskCommentMentionCandidatesArgs = {
  salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTaskEmailPreviewArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  householdId: Scalars['ID']['input'];
  kind: ClientTaskEmailKind;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskNotificationRoutingArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryTaskWorkflowTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WorkflowTemplatesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<WorkflowTemplateSortValues>;
};


export type QueryTasksArgs = {
  household?: InputMaybe<Scalars['Boolean']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
  showHiddenTasks?: InputMaybe<Scalars['Boolean']['input']>;
  taskType?: InputMaybe<TaskTypeName>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTasksTableArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<TasksTableFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<TaskSortValues>;
  taskOwnerHouseholdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTasksTableAggregatedDataArgs = {
  filters?: InputMaybe<TasksTableFilterInput>;
};


export type QueryTaxEnrollmentsTableRowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enrollmentTypeFilter?: InputMaybe<ReadonlyArray<TaxEnrollmentTypeName>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  requireAdvisorActionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  requireClientActionFilter?: InputMaybe<Scalars['Boolean']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<TaxEnrollmentSortValues>;
  statusFilter?: InputMaybe<ReadonlyArray<TaxEnrollmentStatus>>;
  taxYearFilter?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  waitingOnThirdPartyFilter?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTransactionTotalsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountSleeveId?: InputMaybe<Scalars['ID']['input']>;
  endDate: Scalars['ISO8601Date']['input'];
  householdId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};


export type QueryTransactionsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  accountSleeveId?: InputMaybe<Scalars['ID']['input']>;
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTranscriptConsentFormArgs = {
  isPrimaryClient: Scalars['Boolean']['input'];
};


export type QueryUserKycStatusArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUserSavedViewsArgs = {
  keys: ReadonlyArray<Scalars['String']['input']>;
};


export type QueryVoiceProfilePreviewFragmentArgs = {
  advisorId: Scalars['ID']['input'];
  calibrationDerivedTraits?: InputMaybe<ReadonlyArray<CalibrationDerivedTraitInput>>;
  scenarioReplies?: InputMaybe<ReadonlyArray<ScenarioReplyInput>>;
  source: Scalars['String']['input'];
};


export type QueryWorkbenchStatHouseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  myClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  statKey: WorkbenchStatKey;
};


export type QueryWorkbenchStatsSummaryArgs = {
  myClientsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryZoomMeetingTranscriptArgs = {
  id: Scalars['ID']['input'];
};

/**
 * Orion Eclipse account information for quick trade operations. ECI accounts read
 * live balances from Account.eciBalances instead.
 */
export type QuickTradeAccountInformation = {
  readonly __typename?: 'QuickTradeAccountInformation';
  readonly accountId?: Maybe<Scalars['String']['output']>;
  readonly buyingPower?: Maybe<Scalars['Float']['output']>;
  readonly cashAvailable?: Maybe<Scalars['Float']['output']>;
  /** Available cash (buying power minus pending trade amounts in Created or Processed status). */
  readonly freeCashAvailable?: Maybe<Scalars['Float']['output']>;
  readonly id?: Maybe<Scalars['Int']['output']>;
  readonly portfolioId?: Maybe<Scalars['Int']['output']>;
};

export type QuickTradeEligibilityInput = {
  readonly accountId: Scalars['Int']['input'];
  readonly additionalDetails: Scalars['String']['input'];
  readonly securityId: Scalars['Int']['input'];
  readonly validationState: Scalars['String']['input'];
};

export type QuickTradeValidationInput = {
  readonly accountId: Scalars['Int']['input'];
  readonly action: Scalars['Int']['input'];
  readonly securityId: Scalars['Int']['input'];
  readonly tradeAmount?: InputMaybe<Scalars['Float']['input']>;
  readonly tradePercent?: InputMaybe<Scalars['Float']['input']>;
  readonly tradeShares?: InputMaybe<Scalars['Int']['input']>;
};

export type QuickTradeValidationResponse = {
  readonly __typename?: 'QuickTradeValidationResponse';
  /** The account ID for the trade */
  readonly accountId?: Maybe<Scalars['Int']['output']>;
  /** Each validation error as prose, resolved against Eclipse's trade order message dictionary */
  readonly errorMessages?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Any validation errors, as Eclipse returns them */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The portfolio ID for the trade */
  readonly portfolioId?: Maybe<Scalars['Int']['output']>;
  /** The validated price for the trade */
  readonly price?: Maybe<Scalars['Float']['output']>;
  /** The security ID for the trade */
  readonly securityId?: Maybe<Scalars['Int']['output']>;
};

/** An account in the raw Savvy plan data — unmapped Savvy fields for the frontend to map */
export type RawSavvyAccount = {
  readonly __typename?: 'RawSavvyAccount';
  readonly accountType?: Maybe<Scalars['String']['output']>;
  readonly coManagerIsAccountHolder?: Maybe<Scalars['Boolean']['output']>;
  readonly currentBalance?: Maybe<Scalars['Float']['output']>;
  /** Sum of holdings cost basis (null if no holdings) */
  readonly holdingsCostBasis?: Maybe<Scalars['Float']['output']>;
  /** Sum of holdings market value (null if no holdings) */
  readonly holdingsMarketValue?: Maybe<Scalars['Float']['output']>;
  readonly iraType?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly primaryClientIsAccountHolder?: Maybe<Scalars['Boolean']['output']>;
  readonly registrationType?: Maybe<Scalars['String']['output']>;
  readonly subtype?: Maybe<Scalars['String']['output']>;
  /** Savvy account type_of enum (e.g. investment, credit, loan) */
  readonly typeOf?: Maybe<Scalars['String']['output']>;
  /** Owner user id, so the frontend can bucket by member */
  readonly userId?: Maybe<Scalars['ID']['output']>;
};

/** A lifestyle asset or rental property in the raw Savvy plan data */
export type RawSavvyAsset = {
  readonly __typename?: 'RawSavvyAsset';
  /** Raw Savvy asset_class — the FE maps it to the Conquest lifestyle-asset type */
  readonly assetClass?: Maybe<Scalars['String']['output']>;
  readonly costBasis?: Maybe<Scalars['Float']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly marketValue?: Maybe<Scalars['Float']['output']>;
  /** The owning member — the FE buckets assets per member (Conquest nests them under members) */
  readonly userId?: Maybe<Scalars['ID']['output']>;
};

/** A dependant in the raw Savvy plan data */
export type RawSavvyDependant = {
  readonly __typename?: 'RawSavvyDependant';
  readonly birthDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  /** Raw Savvy relation string (unmapped) */
  readonly relationship?: Maybe<Scalars['String']['output']>;
};

/** An income in the raw Savvy plan data, owner-tagged via userId */
export type RawSavvyIncome = {
  readonly __typename?: 'RawSavvyIncome';
  readonly annualAmount?: Maybe<Scalars['Float']['output']>;
  readonly employer?: Maybe<Scalars['String']['output']>;
  readonly incomeType?: Maybe<Scalars['String']['output']>;
  /** Owner user id, so the frontend can bucket by member */
  readonly userId?: Maybe<Scalars['ID']['output']>;
};

/** A liability record in the raw Savvy plan data */
export type RawSavvyLiability = {
  readonly __typename?: 'RawSavvyLiability';
  /** Annual interest as a percent (5.0 = 5%) */
  readonly annualInterestPercent?: Maybe<Scalars['Float']['output']>;
  readonly currentBalance?: Maybe<Scalars['Float']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly originalBalance?: Maybe<Scalars['Float']['output']>;
  /** Savvy liability type_of enum (e.g. mortgage, line_of_credit) */
  readonly typeOf?: Maybe<Scalars['String']['output']>;
};

/** A client or co-client in the raw Savvy plan data */
export type RawSavvyMember = {
  readonly __typename?: 'RawSavvyMember';
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly birthDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly employer?: Maybe<Scalars['String']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly homePhone?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly maritalStatus?: Maybe<Scalars['String']['output']>;
  readonly mobilePhone?: Maybe<Scalars['String']['output']>;
  readonly postalCode?: Maybe<Scalars['String']['output']>;
  readonly retirementDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly state?: Maybe<Scalars['String']['output']>;
  /** Savvy user id, so the frontend can bucket owned items by member */
  readonly userId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Raw Savvy plan data for a household — unmapped source fields the frontend maps
 * into the Conquest shape. Read-only; does not call Conquest.
 */
export type RawSavvyPlanData = {
  readonly __typename?: 'RawSavvyPlanData';
  /** All accounts across both members (including credit/loan; the frontend filters) */
  readonly accounts: ReadonlyArray<RawSavvyAccount>;
  /** The primary client */
  readonly client?: Maybe<RawSavvyMember>;
  /** The co-client, if the household has one */
  readonly coClient?: Maybe<RawSavvyMember>;
  /** Household dependants */
  readonly dependants: ReadonlyArray<RawSavvyDependant>;
  /** The household the data was sourced for */
  readonly householdId: Scalars['ID']['output'];
  /** Incomes across both members, owner-tagged via userId */
  readonly incomes: ReadonlyArray<RawSavvyIncome>;
  /** Liability records across both members */
  readonly liabilities: ReadonlyArray<RawSavvyLiability>;
  /** Non-rental assets across both members */
  readonly lifestyleAssets: ReadonlyArray<RawSavvyAsset>;
  /** Rental real-estate assets across both members */
  readonly rentalProperties: ReadonlyArray<RawSavvyAsset>;
};

/** A real-time (or delayed, per entitlement) market quote from Orion Eclipse. */
export type RealTimePrice = {
  readonly __typename?: 'RealTimePrice';
  /** Current ask price. */
  readonly ask: Scalars['Float']['output'];
  /** Ask size. */
  readonly askQuantity: Scalars['Float']['output'];
  /** Average 30-day volume. */
  readonly averageThirtyDayVolume?: Maybe<Scalars['String']['output']>;
  /** Current bid price. */
  readonly bid: Scalars['Float']['output'];
  /** Bid size. */
  readonly bidQuantity: Scalars['Float']['output'];
  /** CUSIP identifier. */
  readonly cusip?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the quote (ISO-8601). */
  readonly date?: Maybe<Scalars['String']['output']>;
  /** Quote delay in seconds. */
  readonly delay: Scalars['Float']['output'];
  /** Orion price source label (e.g. "Delayed"). */
  readonly eclipsePriceSource?: Maybe<Scalars['String']['output']>;
  /** Session high price. */
  readonly high: Scalars['Float']['output'];
  /** True when the quote is delayed (no real-time entitlement). */
  readonly isDelayedQuote: Scalars['Boolean']['output'];
  /** True when the quote is real-time. */
  readonly isRealTimeQuote: Scalars['Boolean']['output'];
  /** Last traded price. */
  readonly last: Scalars['Float']['output'];
  /** Previous session's closing price; reference for the day change. */
  readonly lastClosePrice: Scalars['Float']['output'];
  /** Session low price. */
  readonly low: Scalars['Float']['output'];
  /** Security name. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** Session opening price. */
  readonly open: Scalars['Float']['output'];
  /** Market-data registration/entitlement message. */
  readonly registrationStatusMessage?: Maybe<Scalars['String']['output']>;
  /** Ticker symbol. */
  readonly symbol?: Maybe<Scalars['String']['output']>;
  /** Session volume. */
  readonly volume: Scalars['Float']['output'];
};

/** Autogenerated input type of ReassignHouseholdAdvisor */
export type ReassignHouseholdAdvisorInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Expected current advisor name */
  readonly currentAdvisorName?: InputMaybe<Scalars['String']['input']>;
  /** Expected household name */
  readonly householdName: Scalars['String']['input'];
  /** Household UUID */
  readonly householdPublicId: Scalars['ID']['input'];
  /** Expected destination advisor name */
  readonly newAdvisorName: Scalars['String']['input'];
  /** Destination advisor user ID */
  readonly newAdvisorUserId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReassignHouseholdAdvisor. */
export type ReassignHouseholdAdvisorPayload = {
  readonly __typename?: 'ReassignHouseholdAdvisorPayload';
  /** Whether this call changed the assignment */
  readonly changed: Scalars['Boolean']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether downstream propagation started successfully in this call */
  readonly downstreamPropagationStarted?: Maybe<Scalars['Boolean']['output']>;
  /** Verified household name */
  readonly householdName: Scalars['String']['output'];
  /** Verified household UUID */
  readonly householdPublicId: Scalars['ID']['output'];
  /** Verified destination advisor name */
  readonly newAdvisorName: Scalars['String']['output'];
  /** Verified destination advisor user ID */
  readonly newAdvisorUserId: Scalars['ID']['output'];
  /** Advisor name before reassignment */
  readonly previousAdvisorName?: Maybe<Scalars['String']['output']>;
  /** Advisor user ID before reassignment */
  readonly previousAdvisorUserId?: Maybe<Scalars['ID']['output']>;
  /** Whether the requested assignment is in effect */
  readonly success: Scalars['Boolean']['output'];
  /** Partial completion warning */
  readonly warning?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ReconcileClientProfileStage */
export type ReconcileClientProfileStageInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ReconcileClientProfileStage. */
export type ReconcileClientProfileStagePayload = {
  readonly __typename?: 'ReconcileClientProfileStagePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The client_profile.stage after reconciliation */
  readonly clientStage: Scalars['String']['output'];
};

/** End condition for recurring tasks */
export const RecurrenceEndCondition = {
  /** by_count */
  ByCount: 'by_count',
  /** by_date */
  ByDate: 'by_date',
  /** indefinite */
  Indefinite: 'indefinite'
} as const;

export type RecurrenceEndCondition = typeof RecurrenceEndCondition[keyof typeof RecurrenceEndCondition];
/** Recurrence frequency for recurring tasks */
export const RecurrenceFrequency = {
  /** annually */
  Annually: 'annually',
  /** biweekly */
  Biweekly: 'biweekly',
  /** daily */
  Daily: 'daily',
  /** monthly */
  Monthly: 'monthly',
  /** quarterly */
  Quarterly: 'quarterly',
  /** semi_annual */
  SemiAnnual: 'semi_annual',
  /** weekly */
  Weekly: 'weekly'
} as const;

export type RecurrenceFrequency = typeof RecurrenceFrequency[keyof typeof RecurrenceFrequency];
/** Input for configuring task recurrence */
export type RecurrenceInput = {
  /** Month of year (1..12) for annual recurrences. */
  readonly byMonth?: InputMaybe<Scalars['Int']['input']>;
  /** Day of month (1..31) for monthly/quarterly/annual recurrences anchored to a specific date. */
  readonly byMonthDay?: InputMaybe<Scalars['Int']['input']>;
  /** Ordinal occurrence within month for monthly recurrences (1..5, or -1 for last). Requires a single byday code. */
  readonly bySetPos?: InputMaybe<Scalars['Int']['input']>;
  /** Comma-separated RFC 5545 BYDAY codes (e.g. "FR" or "MO,TU,WE,TH,FR"). */
  readonly byday?: InputMaybe<Scalars['String']['input']>;
  /** When the recurrence ends (defaults to indefinite on create) */
  readonly endCondition?: InputMaybe<RecurrenceEndCondition>;
  /** Number of occurrences (required when end_condition is by_count) */
  readonly endCount?: InputMaybe<Scalars['Int']['input']>;
  /** End date (required when end_condition is by_date) */
  readonly endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Recurrence frequency (daily, weekly, monthly, quarterly, annually) */
  readonly frequency: RecurrenceFrequency;
  /** Interval between occurrences (e.g., every 2 weeks) */
  readonly interval?: InputMaybe<Scalars['Int']['input']>;
  /** IANA timezone for scheduling (defaults to America/New_York) */
  readonly timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for creating or replacing a RecurrencePattern on a catalog item */
export type RecurrencePatternAttributesInput = {
  /** ISO 8601 date string for the recurrence start (YYYY-MM-DD) */
  readonly dtstart: Scalars['String']['input'];
  /** iCalendar RRULE string (e.g. FREQ=WEEKLY;INTERVAL=1) */
  readonly rrule: Scalars['String']['input'];
};

/** Who introduced whom, read from `referrals`. Direction is which side a household is on. */
export type Referral = {
  readonly __typename?: 'Referral';
  /** When the referral was recorded */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The referral id */
  readonly id: Scalars['ID']['output'];
  /** Notes on the referral */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /**
   * The frozen professional relationship this referral was copied from, if any
   * @deprecated Edit a referral by its own id with updateReferral and deleteReferral.
   */
  readonly professionalRelationshipId?: Maybe<Scalars['ID']['output']>;
  /** Who was referred, when the viewer can read them */
  readonly referred?: Maybe<ReferralParticipant>;
  /** The month the referral happened, when known */
  readonly referredOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Who made the referral, when the viewer can read them */
  readonly referrer?: Maybe<ReferralParticipant>;
};

/** The connection type for Referral. */
export type ReferralConnection = {
  readonly __typename?: 'ReferralConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ReferralEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Referral>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** Which way a referral points relative to the acting advisor. */
export const ReferralDirectionEnum = {
  /** Clients the advisor referred out to a contact. */
  Given: 'GIVEN',
  /** Referrals sent to the advisor. */
  Received: 'RECEIVED'
} as const;

export type ReferralDirectionEnum = typeof ReferralDirectionEnum[keyof typeof ReferralDirectionEnum];
/** An edge in a connection. */
export type ReferralEdge = {
  readonly __typename?: 'ReferralEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Referral>;
};

/** Book-wide referral analytics for the acting advisor */
export type ReferralMetricsSummary = {
  readonly __typename?: 'ReferralMetricsSummary';
  /** Total savvy AUM across converted referrals */
  readonly aumInfluenced: Scalars['BigInt']['output'];
  /** converted / (converted + inFollowUp + lost), or null when no referral carries a bucketed stage */
  readonly conversionRate?: Maybe<Scalars['Float']['output']>;
  /** Referred households now at the won stage */
  readonly converted: Scalars['Int']['output'];
  /** Referred households still in an open stage */
  readonly inFollowUp: Scalars['Int']['output'];
  /** Referred households at a lost or disqualified stage */
  readonly lost: Scalars['Int']['output'];
  /** Every referral received, including households in stages that fall into no outcome bucket */
  readonly referralsIn: Scalars['Int']['output'];
  /** Per-source totals, ordered by referral count descending */
  readonly topSources: ReadonlyArray<ReferralSourceStat>;
};

/** An outcome bucket for a referred household, matching the At-a-glance totals. */
export const ReferralOutcomeEnum = {
  Converted: 'CONVERTED',
  InFollowUp: 'IN_FOLLOW_UP',
  Lost: 'LOST'
} as const;

export type ReferralOutcomeEnum = typeof ReferralOutcomeEnum[keyof typeof ReferralOutcomeEnum];
/** One side of a referral: a professional contact, a household contact or a household */
export type ReferralParticipant = Household | HouseholdContactReferralParticipant | MovedProfessionalContact;

/** What is on the other end of a referral from the advisor's household. */
export const ReferralPartnerKindEnum = {
  /** Another household, or a member of one. */
  Household: 'HOUSEHOLD',
  /** A professional contact. */
  Professional: 'PROFESSIONAL'
} as const;

export type ReferralPartnerKindEnum = typeof ReferralPartnerKindEnum[keyof typeof ReferralPartnerKindEnum];
/** Referral totals for a single referral source in the advisor's book */
export type ReferralSourceStat = {
  readonly __typename?: 'ReferralSourceStat';
  /** Total savvy AUM across this source's converted referrals */
  readonly aumInfluenced: Scalars['BigInt']['output'];
  /** Referrals from this source now at the won stage */
  readonly converted: Scalars['Int']['output'];
  /** Stable key for the source, formatted "<SourceType>:<id>" */
  readonly id: Scalars['ID']['output'];
  /** Referrals from this source still in an open stage */
  readonly inFollowUp: Scalars['Int']['output'];
  /** Referrals from this source at a lost or disqualified stage */
  readonly lost: Scalars['Int']['output'];
  /** Referrals received from this source */
  readonly referrals: Scalars['Int']['output'];
  /** The referring party — a professional contact or a household */
  readonly source: ProfessionalRelationshipSource;
};

/** Autogenerated input type of RefreshProviderAccount */
export type RefreshProviderAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ProviderAccount to refresh. */
  readonly providerAccountId: Scalars['ID']['input'];
};

/** Autogenerated return type of RefreshProviderAccount. */
export type RefreshProviderAccountPayload = {
  readonly __typename?: 'RefreshProviderAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Short-lived token for the appropriate Connect SDK (Plaid Link or @moneykit/connect). */
  readonly linkToken: Scalars['String']['output'];
};

/** Autogenerated input type of RegenerateAccountConfirmationDocuments */
export type RegenerateAccountConfirmationDocumentsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Public id of the Account Confirmation task. */
  readonly taskPublicId: Scalars['String']['input'];
};

/** Autogenerated return type of RegenerateAccountConfirmationDocuments. */
export type RegenerateAccountConfirmationDocumentsPayload = {
  readonly __typename?: 'RegenerateAccountConfirmationDocumentsPayload';
  /** rebuilt, already_signed, no_fee_schedule or failed; null when the household has no agreement draft. */
  readonly agreementOutcome?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** False when the custodian has no automated paperwork, so no envelope is coming. */
  readonly custodianFormsQueued: Scalars['Boolean']['output'];
  /** The task data after the rebuild. The DocuSign envelope id lands a few seconds later. */
  readonly onboardingTask: OnboardingTaskDatum;
};

/** Autogenerated input type of RegenerateAgreementDraft */
export type RegenerateAgreementDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household whose agreement draft to rebuild. */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegenerateAgreementDraft. */
export type RegenerateAgreementDraftPayload = {
  readonly __typename?: 'RegenerateAgreementDraftPayload';
  /** The agreement draft after the rebuild. */
  readonly advisoryAgreementDraft: AdvisoryAgreementDraft;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RegenerateMeetingSummary */
export type RegenerateMeetingSummaryInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The recap template to regenerate from; omit for the built-in outline */
  readonly meetingAgendaTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** The Savvy meeting summary to regenerate */
  readonly meetingSummaryId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegenerateMeetingSummary. */
export type RegenerateMeetingSummaryPayload = {
  readonly __typename?: 'RegenerateMeetingSummaryPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The summary being regenerated, unchanged until the job lands */
  readonly meetingSummary: MeetingSummary;
  /** The status of the queued regeneration */
  readonly status: MeetingSummaryRegenerationStatus;
};

/** Autogenerated input type of RegenerateOnboardingDocusignEnvelope */
export type RegenerateOnboardingDocusignEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Public id (UUID) of the Account Confirmation task whose envelope needs rebuilding. */
  readonly taskPublicId: Scalars['String']['input'];
};

/** Autogenerated return type of RegenerateOnboardingDocusignEnvelope. */
export type RegenerateOnboardingDocusignEnvelopePayload = {
  readonly __typename?: 'RegenerateOnboardingDocusignEnvelopePayload';
  /** rebuilt, already_signed, no_fee_schedule, or failed. Null when the household has no agreement draft. */
  readonly agreementOutcome?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** False when the custodian has no automated paperwork — no envelope will land in that case. */
  readonly custodianFormsQueued: Scalars['Boolean']['output'];
  /** Refusal reasons (envelope_held, build_running, build_failed) when success is false. */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** True when the rebuild ran to completion. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RegenerateStaleServiceCatalogTasks */
export type RegenerateStaleServiceCatalogTasksInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Service catalog item id */
  readonly serviceCatalogItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegenerateStaleServiceCatalogTasks. */
export type RegenerateStaleServiceCatalogTasksPayload = {
  readonly __typename?: 'RegenerateStaleServiceCatalogTasksPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Number of pending tasks refreshed */
  readonly refreshedCount?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of RegisterPushToken */
export type RegisterPushTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Device platform: ios or android */
  readonly platform: Scalars['String']['input'];
  /** Expo push token for this device */
  readonly token: Scalars['String']['input'];
};

/** Autogenerated return type of RegisterPushToken. */
export type RegisterPushTokenPayload = {
  readonly __typename?: 'RegisterPushTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the registration succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Type of account registration */
export const RegistrationTypeName = {
  /** individual */
  Individual: 'individual',
  /** joint_tenants_with_rights_of_survivorship */
  JointTenantsWithRightsOfSurvivorship: 'joint_tenants_with_rights_of_survivorship'
} as const;

export type RegistrationTypeName = typeof RegistrationTypeName[keyof typeof RegistrationTypeName];
/** Autogenerated input type of ReissueEnvelopeWithCurrentPhone */
export type ReissueEnvelopeWithCurrentPhoneInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The blocked staged household to repair. */
  readonly stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReissueEnvelopeWithCurrentPhone. */
export type ReissueEnvelopeWithCurrentPhonePayload = {
  readonly __typename?: 'ReissueEnvelopeWithCurrentPhonePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The staged household after the repair. */
  readonly stagedHousehold: AdvisorOnboardingStagedHousehold;
};

/** Autogenerated input type of RejectScheduledReportExecution */
export type RejectScheduledReportExecutionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ReportScheduleExecution IDs to reject */
  readonly ids: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of RejectScheduledReportExecution. */
export type RejectScheduledReportExecutionPayload = {
  readonly __typename?: 'RejectScheduledReportExecutionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** One error message per failed id, in the same order as failed_ids */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** IDs that were no longer pending review */
  readonly failedIds: ReadonlyArray<Scalars['ID']['output']>;
  /** IDs that were rejected */
  readonly rejectedIds: ReadonlyArray<Scalars['ID']['output']>;
};

/** Why an onboarding / account-confirmation task cannot be released to the client. Null when not blocked. */
export type ReleaseBlockReason = {
  readonly __typename?: 'ReleaseBlockReason';
  /** Human-readable explanation of why the task is blocked. */
  readonly message: Scalars['String']['output'];
  /** The machine-readable block reason. */
  readonly reason: BlockedReason;
  /** Suggested way to unblock the task. */
  readonly remediation: ReleaseBlockRemediation;
};

export const ReleaseBlockRemediation = {
  /** contact_ops */
  ContactOps: 'contact_ops',
  /** reissue */
  Reissue: 'reissue'
} as const;

export type ReleaseBlockRemediation = typeof ReleaseBlockRemediation[keyof typeof ReleaseBlockRemediation];
/** Autogenerated input type of ReleaseOnboardingToSend */
export type ReleaseOnboardingToSendInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The awaiting-ops household to release. */
  readonly stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReleaseOnboardingToSend. */
export type ReleaseOnboardingToSendPayload = {
  readonly __typename?: 'ReleaseOnboardingToSendPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The household after the release. */
  readonly stagedHousehold: AdvisorOnboardingStagedHousehold;
};

/** Autogenerated input type of RelinkSignedEnvelope */
export type RelinkSignedEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The correct signed DocuSign envelope ID to link. */
  readonly envelopeId: Scalars['String']['input'];
  /** The blocked staged household to repair. */
  readonly stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of RelinkSignedEnvelope. */
export type RelinkSignedEnvelopePayload = {
  readonly __typename?: 'RelinkSignedEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The staged household after the repair. */
  readonly stagedHousehold: AdvisorOnboardingStagedHousehold;
};

/** Autogenerated input type of RemoveAdvisorFromAdvisorGroup */
export type RemoveAdvisorFromAdvisorGroupInput = {
  /** ID of the advisor group to remove the advisor from */
  readonly advisorGroupId: Scalars['ID']['input'];
  /** User ID of the advisor to remove */
  readonly advisorUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveAdvisorFromAdvisorGroup. */
export type RemoveAdvisorFromAdvisorGroupPayload = {
  readonly __typename?: 'RemoveAdvisorFromAdvisorGroupPayload';
  /** The advisor group the advisor was removed from */
  readonly advisorGroup?: Maybe<AdvisorGroup>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveAdvisorsFromOrganization */
export type RemoveAdvisorsFromOrganizationInput = {
  /** User IDs of the advisors to remove from the organization */
  readonly advisorUserIds: ReadonlyArray<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Legacy identifier for admin/Retool callers. Omit for new callers and MCP; when
   * present alongside organizationName, both must agree or the write is refused.
   */
  readonly organizationId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The organization's current name. Required for MCP callers, where it also
   * serves as the identifier. For legacy callers passing organizationId, verified
   * against the record before the write.
   */
  readonly organizationName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveAdvisorsFromOrganization. */
export type RemoveAdvisorsFromOrganizationPayload = {
  readonly __typename?: 'RemoveAdvisorsFromOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors?: Maybe<Scalars['String']['output']>;
  /** The organization the advisors were removed from */
  readonly organization?: Maybe<Organization>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveHouseholdMember */
export type RemoveHouseholdMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The household membership to remove. */
  readonly membershipId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveHouseholdMember. */
export type RemoveHouseholdMemberPayload = {
  readonly __typename?: 'RemoveHouseholdMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the membership was destroyed. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveNotificationAlertMute */
export type RemoveNotificationAlertMuteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The mute to remove. */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveNotificationAlertMute. */
export type RemoveNotificationAlertMutePayload = {
  readonly __typename?: 'RemoveNotificationAlertMutePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the mute was removed. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveOnboardingHousehold */
export type RemoveOnboardingHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The staged household to remove. */
  readonly stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveOnboardingHousehold. */
export type RemoveOnboardingHouseholdPayload = {
  readonly __typename?: 'RemoveOnboardingHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the household was removed from the cockpit. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemovePlanInput */
export type RemovePlanInputInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The input externalId returned by the plan query. An absent input is already removed. */
  readonly externalId: Scalars['ID']['input'];
  /** Omit to remove the whole input. Account contributions or fees removes only those planning settings. */
  readonly field?: InputMaybe<Scalars['String']['input']>;
  /** The plan containing the input. */
  readonly planId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemovePlanInput. */
export type RemovePlanInputPayload = {
  readonly __typename?: 'RemovePlanInputPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated plan read back from Conquest. */
  readonly plan: PlanningPlan;
};

/** Errors for removing the professional details from a contact */
export const RemoveProfessionalDetailsError = {
  /** not_moved */
  NotMoved: 'not_moved',
  /** recording_in_progress */
  RecordingInProgress: 'recording_in_progress'
} as const;

export type RemoveProfessionalDetailsError = typeof RemoveProfessionalDetailsError[keyof typeof RemoveProfessionalDetailsError];
/** Autogenerated input type of RemoveProfessionalDetails */
export type RemoveProfessionalDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The professional public id of the contact */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveProfessionalDetails. */
export type RemoveProfessionalDetailsPayload = {
  readonly __typename?: 'RemoveProfessionalDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The contact, which now opens as a household contact */
  readonly contactId?: Maybe<Scalars['ID']['output']>;
  /** Why the details could not be removed */
  readonly softError?: Maybe<RemoveProfessionalDetailsError>;
};

/** Autogenerated input type of RemoveSecondaryPortfolio */
export type RemoveSecondaryPortfolioInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the household that owns the portfolio */
  readonly householdId: Scalars['ID']['input'];
  /** ID of the secondary portfolio to remove */
  readonly portfolioId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveSecondaryPortfolio. */
export type RemoveSecondaryPortfolioPayload = {
  readonly __typename?: 'RemoveSecondaryPortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the secondary portfolio was removed */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveServiceCatalogItemFromGroup */
export type RemoveServiceCatalogItemFromGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Service catalog item group id */
  readonly serviceCatalogItemGroupId: Scalars['ID']['input'];
  /** Service catalog item id */
  readonly serviceCatalogItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveServiceCatalogItemFromGroup. */
export type RemoveServiceCatalogItemFromGroupPayload = {
  readonly __typename?: 'RemoveServiceCatalogItemFromGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** ID of the deleted membership, if one existed */
  readonly deletedMembershipId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of RemoveStagedCoClient */
export type RemoveStagedCoClientInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The staged co-client to remove. */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveStagedCoClient. */
export type RemoveStagedCoClientPayload = {
  readonly __typename?: 'RemoveStagedCoClientPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The id of the removed staged co-client. */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** Whether the staged co-client was removed. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveStagedHousehold */
export type RemoveStagedHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The staged household to remove. */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveStagedHousehold. */
export type RemoveStagedHouseholdPayload = {
  readonly __typename?: 'RemoveStagedHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The id of the removed staged household. */
  readonly deletedId?: Maybe<Scalars['ID']['output']>;
  /** Whether the staged household was removed. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveTaskRecurrence */
export type RemoveTaskRecurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * When true, also delete the open occurrences in the series with instance_date
   * after the acted-on task. The acted-on occurrence and every earlier one (past,
   * today, completed) are kept, as is the series template. When false/omitted, the
   * recurrence is ended but existing occurrences are left in place.
   */
  readonly removeUpcomingOccurrences?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Savvy task ID (UUID) */
  readonly taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveTaskRecurrence. */
export type RemoveTaskRecurrencePayload = {
  readonly __typename?: 'RemoveTaskRecurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The updated task. Null if the acted-on task was itself a removed future occurrence. */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of RenewInvite */
export type RenewInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly inviteToken: Scalars['String']['input'];
  readonly taskType: TaskTypeName;
};

/** Autogenerated return type of RenewInvite. */
export type RenewInvitePayload = {
  readonly __typename?: 'RenewInvitePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ReorderServiceCatalogItemHouseholds */
export type ReorderServiceCatalogItemHouseholdsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household id */
  readonly householdId: Scalars['ID']['input'];
  /** Assignment IDs in the desired display order */
  readonly orderedIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of ReorderServiceCatalogItemHouseholds. */
export type ReorderServiceCatalogItemHouseholdsPayload = {
  readonly __typename?: 'ReorderServiceCatalogItemHouseholdsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Assignments in their new order */
  readonly serviceCatalogItemHouseholds: ReadonlyArray<ServiceCatalogItemHousehold>;
};

/** Autogenerated input type of ReorderSubtask */
export type ReorderSubtaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy ID of the sub-task to reorder. */
  readonly id: Scalars['ID']['input'];
  /** The 1-indexed position the sub-task should occupy among its siblings. Clamped to [1, sibling_count]. */
  readonly newPosition: Scalars['Int']['input'];
};

/** Autogenerated return type of ReorderSubtask. */
export type ReorderSubtaskPayload = {
  readonly __typename?: 'ReorderSubtaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The reordered sub-task with its updated position. */
  readonly subtask?: Maybe<Subtask>;
  /** The parent task. Returned so clients can refresh the sub-task list. Its status is NOT mutated by this mutation. */
  readonly task?: Maybe<Task>;
};

/**
 * Status of a single repaper envelope. docusignLink is nil while the
 * CreateDocusignEnvelopeWorker is still creating the envelope.
 */
export type RepaperEnvelopeStatus = {
  readonly __typename?: 'RepaperEnvelopeStatus';
  /** DocuSign URL for the envelope, or nil while the worker is still processing */
  readonly docusignLink?: Maybe<Scalars['String']['output']>;
  /** Failure detail when failed is true; nil otherwise. */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /**
   * True when orchestration failed for this tracking ID — the client should stop
   * polling and surface the error instead of waiting out the timeout.
   */
  readonly failed: Scalars['Boolean']['output'];
  /** Tracking ID returned from createRepaperEnvelope */
  readonly trackingId: Scalars['ID']['output'];
};

/** Presigned S3 PUT URL grant for uploading a single repaper PDF (HAWK-70). */
export type RepaperPdfUploadGrant = {
  readonly __typename?: 'RepaperPdfUploadGrant';
  /** When this presigned URL stops accepting uploads. */
  readonly expiresAt: Scalars['ISO8601DateTime']['output'];
  /** S3 object key the FE passes to createRepaperEnvelope as formDocuments[].s3Key. */
  readonly s3Key: Scalars['String']['output'];
  /** Presigned S3 PUT URL the FE uses to upload PDF bytes directly (15 min TTL). */
  readonly uploadUrl: Scalars['String']['output'];
};

/**
 * Native rebuild of the Orion-generated Performance Report (Unified). Provides all
 * data needed to render the multi-page PDF — replaces the Orion path when
 * feature-flagged on (HAWK-25).
 */
export type Report = {
  readonly __typename?: 'Report';
  /** Per-account blocks for the 'Account Performance' section. */
  readonly accountPerformance: ReadonlyArray<AccountPerformance>;
  /** Primary advisor's display name shown on the cover. */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /**
   * Series for the 'Performance vs Benchmark' chart and table — household plus
   * Morningstar Target Risk benchmarks. Empty when benchmark data is unavailable
   * for this household.
   */
  readonly benchmarkSeries: ReadonlyArray<BenchmarkSeries>;
  /** When the underlying performance snapshot was last refreshed. */
  readonly dataLastUpdated?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Inclusive end date of the report. */
  readonly endDate: Scalars['ISO8601Date']['output'];
  /**
   * Branded firm name shown on the cover (e.g. "Colorado Wealth Group"). Falls
   * back to "Savvy" when the household's advisor has no organization branding.
   */
  readonly firmDisplayName: Scalars['String']['output'];
  /**
   * Branded firm logo URL shown on the cover. Falls back to the Savvy logo when
   * the household's advisor has no organization branding.
   */
  readonly firmLogoUrl: Scalars['String']['output'];
  /** Household display name shown on the cover and section headers. */
  readonly householdName: Scalars['String']['output'];
  /** Stable identifier for this report scope (household + accounts + date range). */
  readonly id: Scalars['ID']['output'];
  /** Earliest funded date across the report's accounts; used for the 'Since Inception' column header. */
  readonly inceptionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Daily points for the 'Market Value and Net Additions' chart, filtered to the report date range. */
  readonly marketValueSeries: ReadonlyArray<MarketValuePoint>;
  /** Slices of the household portfolio allocation pie, summing to 100%. */
  readonly portfolioAllocation: ReadonlyArray<AllocationSlice>;
  /** Quarter-by-quarter time-weighted returns for the 'Cumulative Performance and Quarterly Returns' bar chart. */
  readonly quarterlyReturns: ReadonlyArray<QuarterlyReturn>;
  /** Inclusive start date of the report. */
  readonly startDate: Scalars['ISO8601Date']['output'];
  /** Rows of the Portfolio Value Summary table — one per period (YTD, last 12 months, last 3 years, since inception). */
  readonly valueSummaryRows: ReadonlyArray<ValueSummaryRow>;
};

/** Curated font families available for advisor report branding */
export const ReportFontFamilyEnum = {
  /** Georgia */
  Georgia: 'GEORGIA',
  /** Inter */
  Inter: 'INTER',
  /** Merriweather */
  Merriweather: 'MERRIWEATHER',
  /** Playfair Display */
  PlayfairDisplay: 'PLAYFAIR_DISPLAY'
} as const;

export type ReportFontFamilyEnum = typeof ReportFontFamilyEnum[keyof typeof ReportFontFamilyEnum];
/** Font size scale presets applied across generated advisor reports and proposals */
export const ReportFontSizeScaleEnum = {
  /** Standard font sizes across generated reports and proposals */
  Default: 'DEFAULT',
  /** Larger font sizes across generated reports and proposals */
  Large: 'LARGE',
  /** Smaller font sizes across generated reports and proposals */
  Small: 'SMALL'
} as const;

export type ReportFontSizeScaleEnum = typeof ReportFontSizeScaleEnum[keyof typeof ReportFontSizeScaleEnum];
/** Automated delivery schedule for a saved report template. */
export type ReportSchedule = {
  readonly __typename?: 'ReportSchedule';
  /** Whether the schedule is currently enabled */
  readonly active: Scalars['Boolean']['output'];
  /** When the schedule was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The advisor who created this schedule */
  readonly createdByUserId: Scalars['ID']['output'];
  /** Whether to upload generated PDFs to Box */
  readonly deliverToBox: Scalars['Boolean']['output'];
  /** Whether to publish generated reports to the client portal */
  readonly deliverToPortal: Scalars['Boolean']['output'];
  /** Day of month (1-28) when the schedule fires */
  readonly deliveryDay: Scalars['Int']['output'];
  /** Month (1-12) an annual schedule fires; null means January */
  readonly deliveryMonth?: Maybe<Scalars['Int']['output']>;
  /** Cadence: monthly, quarterly, or annually */
  readonly frequency: Scalars['String']['output'];
  /** The unique identifier for the report schedule */
  readonly id: Scalars['ID']['output'];
  /** When the schedule last fired */
  readonly lastRunAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Next scheduled execution time */
  readonly nextDueAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Custom PDF filename pattern; null uses the default pattern */
  readonly pdfFilenamePattern?: Maybe<Scalars['String']['output']>;
  /** Whether generated reports need advisor approval before delivery */
  readonly requireReview: Scalars['Boolean']['output'];
  /** The saved template this schedule automates */
  readonly savedReportTemplateId: Scalars['ID']['output'];
  /** When the schedule was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Audit record for a single scheduled report generation run. */
export type ReportScheduleExecution = {
  readonly __typename?: 'ReportScheduleExecution';
  /** Box file ID once delivered to the household's own Box folder */
  readonly boxFileId?: Maybe<Scalars['String']['output']>;
  /** When execution completed or failed */
  readonly completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the execution record was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Error detail when status is failed */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** The household the report was generated for */
  readonly householdId: Scalars['ID']['output'];
  /** The household's display name, for the Pending Reviews table. */
  readonly householdName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the execution record */
  readonly id: Scalars['ID']['output'];
  /** Authenticated URL to preview/download the generated PDF; present once attached. */
  readonly pdfDownloadUrl?: Maybe<Scalars['String']['output']>;
  /** Published report ID if portal delivery succeeded */
  readonly publishedReportId?: Maybe<Scalars['ID']['output']>;
  /** The parent schedule that triggered this run */
  readonly reportScheduleId: Scalars['ID']['output'];
  /** Box file ID of the advisor's private review-folder copy, present while pending_review; distinct from box_file_id. */
  readonly reviewBoxFileId?: Maybe<Scalars['String']['output']>;
  /** The advisor's Box review folder, for the Pending Reviews table header link. */
  readonly reviewBoxFolderUrl?: Maybe<Scalars['String']['output']>;
  /** Template name for display in advisor client reports tab. */
  readonly savedReportTemplateName?: Maybe<Scalars['String']['output']>;
  /** When execution started */
  readonly startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Execution status: pending, processing, pending_review, completed, rejected, or failed */
  readonly status: Scalars['String']['output'];
};

/** Product holding reported by performance reporting software - (Orion). */
export type ReportedHolding = {
  readonly __typename?: 'ReportedHolding';
  /** The Savvy account ID this holding belongs to */
  readonly accountId?: Maybe<Scalars['ID']['output']>;
  /** The Savvy account sleeve ID this holding belongs to */
  readonly accountSleeveId?: Maybe<Scalars['ID']['output']>;
  readonly assetCategory?: Maybe<Scalars['String']['output']>;
  readonly assetClass?: Maybe<Scalars['String']['output']>;
  readonly costBasis?: Maybe<Scalars['BigDecimal']['output']>;
  readonly costBasisLots?: Maybe<ReadonlyArray<CostBasisLot>>;
  readonly inceptionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  readonly name: Scalars['String']['output'];
  /** Percent allocation of total parent entity value. */
  readonly percent?: Maybe<Scalars['BigDecimal']['output']>;
  readonly performanceOverTime: ReadonlyArray<Performance>;
  /** Current price for the units in this holding. Usually from last market close. */
  readonly priceUsd?: Maybe<Scalars['BigDecimal']['output']>;
  /** Current quantity of this holding. */
  readonly quantity?: Maybe<Scalars['BigDecimal']['output']>;
  readonly riskCategory?: Maybe<Scalars['String']['output']>;
  readonly ticker: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
  /** Most recent value of this holding. Usually from last market close. */
  readonly value?: Maybe<ReportedHoldingValue>;
};

/** Monetary value. */
export type ReportedHoldingValue = {
  readonly __typename?: 'ReportedHoldingValue';
  /** The numerical amount of monetary value. */
  readonly amount?: Maybe<Scalars['BigDecimal']['output']>;
  /** ISO currency codes and unofficial currency codes. */
  readonly currencyCode: Scalars['String']['output'];
};

/** Autogenerated input type of RequestMeetingRecordingPartUpload */
export type RequestMeetingRecordingPartUploadInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Length of this segment alone */
  readonly durationSeconds: Scalars['Int']['input'];
  /** Size of this segment. When given, the presigned URL is signed for exactly this many bytes. */
  readonly fileSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  /** The recording returned by requestMeetingRecordingUpload */
  readonly meetingRecordingId: Scalars['ID']['input'];
  /**
   * Position of this segment in the meeting, from 0 up to partCount - 1. Part 0 is
   * also granted when the recording is opened; asking for it here is how a client
   * resumes an upload that died before finalize.
   */
  readonly partIndex: Scalars['Int']['input'];
};

/** Autogenerated return type of RequestMeetingRecordingPartUpload. */
export type RequestMeetingRecordingPartUploadPayload = {
  readonly __typename?: 'RequestMeetingRecordingPartUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The segment and its upload URL */
  readonly grant: MeetingRecordingUploadGrant;
};

/** Autogenerated input type of RequestMeetingRecordingUpload */
export type RequestMeetingRecordingUploadInput = {
  /**
   * Advisors from the recorder's group the advisor confirmed were in the room. A
   * reference clip is sent for each that enrolled, so their lines are attributed
   * to them rather than to the client. Capped by the provider's four-reference
   * ceiling, one of which the recorder always occupies.
   */
  readonly advisorProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The clients the advisor named as being in the room. Must belong to this
   * household. Empty or omitted when they named nobody, or when recording before a
   * household is chosen. Exactly one is the only case speech is attributed to a
   * person; with several, the transcript numbers the voices.
   */
  readonly clientProfileIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /**
   * Must be true: the advisor confirmed they informed the client and obtained
   * consent. The server timestamps it rather than trusting a device clock.
   */
  readonly consentConfirmed: Scalars['Boolean']['input'];
  /**
   * Captured audio length. Refused above the meeting cap; a recording longer than
   * one transcription request allows is segmented server-side rather than rejected.
   */
  readonly durationSeconds: Scalars['Int']['input'];
  /**
   * Size of the audio about to be uploaded. When given, the presigned URL is
   * signed for exactly this many bytes, so the grant cannot be used to write
   * anything else. Omitted by clients that predate it, which are signed without a bound.
   */
  readonly fileSizeBytes?: InputMaybe<Scalars['Int']['input']>;
  /** Household the meeting belongs to. Omitted to record now and link the recording to a household from the notification later. */
  readonly householdId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * An existing recording of this advisor's to re-sign rather than open a new one.
   * How a client resumes a single-file upload that died before finalize: without
   * it every retry opens a second recording, and the first is left in
   * pending_upload with no audio and nothing to finish it. The segmented path does
   * the same through requestMeetingRecordingPartUpload.
   */
  readonly meetingRecordingId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Total segments this meeting was captured in. Omitted by clients that record a
   * meeting as one file. When given, the grant returned is for part 0 and the rest
   * are requested with requestMeetingRecordingPartUpload.
   */
  readonly partCount?: InputMaybe<Scalars['Int']['input']>;
  /** Length of part 0 alone. Required with partCount, since durationSeconds describes the whole meeting. */
  readonly partDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** When capture stopped on the device */
  readonly recordingEndedAt: Scalars['ISO8601DateTime']['input'];
  /** When capture began on the device */
  readonly recordingStartedAt: Scalars['ISO8601DateTime']['input'];
  /**
   * True when the recording cap stopped the recording rather than the advisor.
   * Surfaced in the recap so a partial meeting is not read as a complete one.
   */
  readonly truncatedAtCap?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of RequestMeetingRecordingUpload. */
export type RequestMeetingRecordingUploadPayload = {
  readonly __typename?: 'RequestMeetingRecordingUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created recording and its upload URL */
  readonly grant: MeetingRecordingUploadGrant;
};

/** Autogenerated input type of RequestPastTranscriptsFromApril */
export type RequestPastTranscriptsFromAprilInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Transcript request input */
  readonly input: RequestTranscriptInput;
};

/** Autogenerated return type of RequestPastTranscriptsFromApril. */
export type RequestPastTranscriptsFromAprilPayload = {
  readonly __typename?: 'RequestPastTranscriptsFromAprilPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** URL to the consent form */
  readonly consentFormUrl?: Maybe<Scalars['String']['output']>;
  /** Errors */
  readonly errors?: Maybe<Scalars['String']['output']>;
  /** Success or not */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RequestReadOnlyAdminAccount */
export type RequestReadOnlyAdminAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A @savvywealth.com email address */
  readonly email: Scalars['String']['input'];
};

/** Autogenerated return type of RequestReadOnlyAdminAccount. */
export type RequestReadOnlyAdminAccountPayload = {
  readonly __typename?: 'RequestReadOnlyAdminAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** True for any @savvywealth.com address, whatever the outcome */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RequestRepaperPdfUploadUrls */
export type RequestRepaperPdfUploadUrlsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Number of upload URLs to issue (1-50). Matches the number of pre-filled PDFs the FE has for a single household. */
  readonly formCount: Scalars['Int']['input'];
};

/** Autogenerated return type of RequestRepaperPdfUploadUrls. */
export type RequestRepaperPdfUploadUrlsPayload = {
  readonly __typename?: 'RequestRepaperPdfUploadUrlsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Ordered list of upload grants. FE PUTs each PDF to the matching upload_url and sends s3_key as formDocuments[].s3Key. */
  readonly grants: ReadonlyArray<RepaperPdfUploadGrant>;
};

/** Input for requesting an IRS transcript via April */
export type RequestTranscriptInput = {
  /** Address line 1 */
  readonly addressLine1: Scalars['String']['input'];
  /** Address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** If client has accepted April's terms and conditions */
  readonly aprilTermsAccepted: Scalars['Boolean']['input'];
  /**
   * Base64-encoded wet signature image. WARNING: Only reuse a stored signature if
   * the transcript request data has not changed since it was captured. Any change
   * requires a new signature.
   */
  readonly base64ImageSignature?: InputMaybe<Scalars['String']['input']>;
  /** City */
  readonly city: Scalars['String']['input'];
  /** Country */
  readonly country: Scalars['String']['input'];
  /** date of birth */
  readonly dateOfBirth: Scalars['String']['input'];
  /** First name */
  readonly firstName: Scalars['String']['input'];
  /** Last name */
  readonly lastName: Scalars['String']['input'];
  /** Middle name */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** phone number */
  readonly phoneNumber: Scalars['String']['input'];
  /** Signature date (YYYY-MM-DD) */
  readonly signatureDate: Scalars['String']['input'];
  /** Social security number */
  readonly socialSecurityNumber: Scalars['String']['input'];
  /** State */
  readonly state: Scalars['String']['input'];
  /**
   * Typed full name as signature. WARNING: Only reuse a stored signature if the
   * transcript request data has not changed since it was captured. Any change
   * requires a new signature.
   */
  readonly textSignature?: InputMaybe<Scalars['String']['input']>;
  /** Transcript type (e.g., INDIVIDUAL) */
  readonly transcriptType: Scalars['String']['input'];
  /** User who's information we are editing */
  readonly userId: Scalars['ID']['input'];
  /** Zip code */
  readonly zipCode: Scalars['String']['input'];
};

/** The variant of an account maintenance request */
export const RequestTypeName = {
  /** account_consolidation */
  AccountConsolidation: 'account_consolidation',
  /** add_advisor_to_account */
  AddAdvisorToAccount: 'add_advisor_to_account',
  /** add_options_and_margin */
  AddOptionsAndMargin: 'add_options_and_margin',
  /** beneficiary_update */
  BeneficiaryUpdate: 'beneficiary_update',
  /** link_a_bank */
  LinkABank: 'link_a_bank'
} as const;

export type RequestTypeName = typeof RequestTypeName[keyof typeof RequestTypeName];
/** Autogenerated input type of RescheduleServiceOccurrence */
export type RescheduleServiceOccurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new occurrence date. Today or later */
  readonly date: Scalars['ISO8601Date']['input'];
  /** Typed occurrence id, as returned by householdServiceOccurrences */
  readonly id: Scalars['ID']['input'];
  /** The occurrence's `revision` as read. The write is refused when the row has changed since */
  readonly revision: Scalars['String']['input'];
};

/** Autogenerated return type of RescheduleServiceOccurrence. */
export type RescheduleServiceOccurrencePayload = {
  readonly __typename?: 'RescheduleServiceOccurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The occurrence at its new date, or null once it no longer belongs to the household stream */
  readonly occurrence?: Maybe<HouseholdServiceOccurrence>;
};

/** Autogenerated input type of ReseedDemoEnvironment */
export type ReseedDemoEnvironmentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Shape of the book to build. Omit for the defaults. */
  readonly options?: InputMaybe<DemoReseedOptions>;
};

/** Autogenerated return type of ReseedDemoEnvironment. */
export type ReseedDemoEnvironmentPayload = {
  readonly __typename?: 'ReseedDemoEnvironmentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The queued reseed. Poll demoReseedRun with its id. */
  readonly run: DemoReseedRun;
};

/** Autogenerated input type of ResendDocusignEnvelope */
export type ResendDocusignEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** DocuSign envelope ID to resend a reminder for */
  readonly envelopeId: Scalars['String']['input'];
};

/** Autogenerated return type of ResendDocusignEnvelope. */
export type ResendDocusignEnvelopePayload = {
  readonly __typename?: 'ResendDocusignEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** When the throttle window opens (set when the call was throttled) */
  readonly nextResendAvailableAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the reminder was queued */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResendEciOnboardingLink */
export type ResendEciOnboardingLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResendEciOnboardingLink. */
export type ResendEciOnboardingLinkPayload = {
  readonly __typename?: 'ResendEciOnboardingLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * Obfuscated address the link went to (e.g. ra***l@gmail.com), so the client can
   * tell which inbox to check without the full address being exposed to a shared
   * mailbox. Null when nothing was sent.
   */
  readonly maskedEmail?: Maybe<Scalars['String']['output']>;
  /** Whether the client on file has a working link on its way: this call emailed one, or a live one had already been emailed */
  readonly sent: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResendEmail */
export type ResendEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly emailType: Email;
};

/** Autogenerated return type of ResendEmail. */
export type ResendEmailPayload = {
  readonly __typename?: 'ResendEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly emailSent?: Maybe<Email>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResendOnboardingInvite */
export type ResendOnboardingInviteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Which clients to resend to, from OnboardingCockpitRow.inviteRecipients. Omit
   * to resend to every eligible client on the household.
   */
  readonly clientOnboardingRequestIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** The staged household to resend the invite for. */
  readonly stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResendOnboardingInvite. */
export type ResendOnboardingInvitePayload = {
  readonly __typename?: 'ResendOnboardingInvitePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred. */
  readonly errors?: Maybe<ReadonlyArray<MutationError>>;
  /** The clients that were emailed. */
  readonly resentTo?: Maybe<ReadonlyArray<InviteRecipient>>;
  /**
   * Selected clients that were not emailed — either they have no email on file, or
   * they already submitted. Their links are left untouched.
   */
  readonly skipped?: Maybe<ReadonlyArray<InviteRecipient>>;
  /** The staged household after resend. */
  readonly stagedHousehold?: Maybe<AdvisorOnboardingStagedHousehold>;
  /** Whether the resend succeeded. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResendOtp */
export type ResendOtpInput = {
  readonly channel?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly currentPassword: Scalars['String']['input'];
  readonly userEmail: Scalars['String']['input'];
};

/** Autogenerated return type of ResendOtp. */
export type ResendOtpPayload = {
  readonly __typename?: 'ResendOtpPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ResendServiceCatalogReminder */
export type ResendServiceCatalogReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ServiceCatalogItemHousehold id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of ResendServiceCatalogReminder. */
export type ResendServiceCatalogReminderPayload = {
  readonly __typename?: 'ResendServiceCatalogReminderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated assignment */
  readonly serviceCatalogItemHousehold: ServiceCatalogItemHousehold;
};

/** Autogenerated input type of ResendServiceOccurrenceReminder */
export type ResendServiceOccurrenceReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Typed occurrence id, as returned by householdServiceOccurrences */
  readonly id: Scalars['ID']['input'];
  /** The occurrence's `revision` as read. The write is refused when the row has changed since */
  readonly revision: Scalars['String']['input'];
};

/** Autogenerated return type of ResendServiceOccurrenceReminder. */
export type ResendServiceOccurrenceReminderPayload = {
  readonly __typename?: 'ResendServiceOccurrenceReminderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The occurrence after the send, or null once it no longer belongs to the household stream */
  readonly occurrence?: Maybe<HouseholdServiceOccurrence>;
};

/** Autogenerated input type of ResetClientIntakeData */
export type ResetClientIntakeDataInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly resetToInvited?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ResetClientIntakeData. */
export type ResetClientIntakeDataPayload = {
  readonly __typename?: 'ResetClientIntakeDataPayload';
  readonly clientIntakeData: ClientIntakeData;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ResetDemoHousehold */
export type ResetDemoHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResetDemoHousehold. */
export type ResetDemoHouseholdPayload = {
  readonly __typename?: 'ResetDemoHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly household?: Maybe<Household>;
  readonly softError?: Maybe<DemoProspectResetterError>;
};

/** Autogenerated input type of ResetNotificationRouting */
export type ResetNotificationRoutingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user whose catalog notification routing to reset. */
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResetNotificationRouting. */
export type ResetNotificationRoutingPayload = {
  readonly __typename?: 'ResetNotificationRoutingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Effective catalog notification routing after the reset. */
  readonly routing: ReadonlyArray<NotificationRoutePreference>;
  /** Whether the reset succeeded. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResetPassword */
export type ResetPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deepLink?: InputMaybe<Scalars['String']['input']>;
  /** email of user to reset */
  readonly email: Scalars['String']['input'];
};

/** Autogenerated return type of ResetPassword. */
export type ResetPasswordPayload = {
  readonly __typename?: 'ResetPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** errors */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** success */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResetServiceCalendar */
export type ResetServiceCalendarInput = {
  readonly advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly householdId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ResetServiceCalendar. */
export type ResetServiceCalendarPayload = {
  readonly __typename?: 'ResetServiceCalendarPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResetServiceOccurrenceEmail */
export type ResetServiceOccurrenceEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Typed occurrence id, as returned by householdServiceOccurrences */
  readonly id: Scalars['ID']['input'];
  /** The occurrence's `revision` as read. The write is refused when the row has changed since */
  readonly revision: Scalars['String']['input'];
};

/** Autogenerated return type of ResetServiceOccurrenceEmail. */
export type ResetServiceOccurrenceEmailPayload = {
  readonly __typename?: 'ResetServiceOccurrenceEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The occurrence after the write, or null once it no longer belongs to the household stream */
  readonly occurrence?: Maybe<HouseholdServiceOccurrence>;
};

/** Autogenerated input type of ResetTaskNotificationRouting */
export type ResetTaskNotificationRoutingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResetTaskNotificationRouting. */
export type ResetTaskNotificationRoutingPayload = {
  readonly __typename?: 'ResetTaskNotificationRoutingPayload';
  /** Effective task routing cells after the reset (all defaults). */
  readonly cells: ReadonlyArray<NotificationTaskRoutingCell>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the reset succeeded. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResolveContributionAlert */
export type ResolveContributionAlertInput = {
  /** The ContributionReceived alert the advisor acted on */
  readonly alertId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The task created from that action */
  readonly taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResolveContributionAlert. */
export type ResolveContributionAlertPayload = {
  readonly __typename?: 'ResolveContributionAlertPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** The most recent occurrence of an assignment that was completed or skipped, from any surface */
export type ResolvedOccurrence = {
  readonly __typename?: 'ResolvedOccurrence';
  /** The occurrence that was resolved */
  readonly occurrenceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Who resolved it. Null on the occurrence shape, which records no actor. */
  readonly resolvedByName?: Maybe<Scalars['String']['output']>;
  /** Which terminal state the occurrence was put into */
  readonly status: ResolvedOccurrenceStatus;
  /** When it was resolved; null on rows written before the column was stamped */
  readonly statusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export const ResolvedOccurrenceStatus = {
  /** completed */
  Completed: 'completed',
  /** skipped */
  Skipped: 'skipped'
} as const;

export type ResolvedOccurrenceStatus = typeof ResolvedOccurrenceStatus[keyof typeof ResolvedOccurrenceStatus];
/** Autogenerated input type of RespondToSurvey */
export type RespondToSurveyInput = {
  /** What the advisor did */
  readonly action: SurveyResponseAction;
  /** The survey alert */
  readonly alertId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RespondToSurvey. */
export type RespondToSurveyPayload = {
  readonly __typename?: 'RespondToSurveyPayload';
  /** The survey alert after the response */
  readonly alert: Alert;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ResubmitEciRemediation */
export type ResubmitEciRemediationInput = {
  /** Full beneficiary list to persist; replaces any existing beneficiaries */
  readonly beneficiaries?: InputMaybe<ReadonlyArray<EciBeneficiaryInput>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Original depositor details on an inherited IRA */
  readonly decedent?: InputMaybe<EciDecedentInput>;
  /** SIMPLE IRA employer information */
  readonly employer?: InputMaybe<EciEmployerInput>;
  /**
   * Joint/TIC ownership details. Also updates registrationType, which
   * jointAccountType derives — the one slice that writes a field the form
   * otherwise renders read-only.
   */
  readonly jointOwnership?: InputMaybe<EciJointOwnershipInput>;
  /** Per-owner personal information and/or citizenship & tax status edits */
  readonly owners?: InputMaybe<ReadonlyArray<EciRemediationOwnerInput>>;
  /** The remediation Subtask being resubmitted. The onboarding request is derived from it. */
  readonly subtaskId: Scalars['ID']['input'];
  /** Delivering-firm details for the TOA leg */
  readonly transferFundingSource?: InputMaybe<EciTransferFundingSourceInput>;
  /** Trust legal information */
  readonly trust?: InputMaybe<EciTrustDetailsInput>;
};

/** Autogenerated return type of ResubmitEciRemediation. */
export type ResubmitEciRemediationPayload = {
  readonly __typename?: 'ResubmitEciRemediationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** All validation errors across every slice, collected together */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether every slice persisted and the event was emitted */
  readonly success: Scalars['Boolean']['output'];
};

export type RetirementPlan = {
  readonly __typename?: 'RetirementPlan';
  /** Advisor-defined freeform notes about this plan */
  readonly additionalNotes?: Maybe<Scalars['String']['output']>;
  /** Sponsor address(es) */
  readonly address?: Maybe<Scalars['String']['output']>;
  /** Date the advisory relationship began */
  readonly advisoryEffectiveDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Advisory type (e.g. 3(38), 3(21)) */
  readonly advisoryType?: Maybe<Scalars['String']['output']>;
  /** Annual fee in dollars */
  readonly annualFee?: Maybe<Scalars['Float']['output']>;
  /** Annual fee as a percentage */
  readonly annualFeePercent?: Maybe<Scalars['Float']['output']>;
  /** Billing method (e.g. 'Sponsor pays fee directly to Advisor') */
  readonly billingMethod?: Maybe<Scalars['String']['output']>;
  /** Name of the person who signed the contract */
  readonly contractSignedBy?: Maybe<Scalars['String']['output']>;
  /** Date the contract was signed */
  readonly contractSignedDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Corporate structure (e.g. PLLC, LLC, S-Corp) */
  readonly corporateStructure?: Maybe<Scalars['String']['output']>;
  /** When the plan was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Latest plan assets from quarterly snapshot */
  readonly currentAssets?: Maybe<Scalars['Float']['output']>;
  /** Latest participant count from quarterly snapshot */
  readonly currentParticipantCount?: Maybe<Scalars['Int']['output']>;
  /** Plan design details (eligibility, payroll, testing, match/vesting). Null until first saved. */
  readonly design?: Maybe<RetirementPlanDesign>;
  /** Employer Identification Number */
  readonly ein?: Maybe<Scalars['String']['output']>;
  /** Source of fee payment */
  readonly feeSource?: Maybe<Scalars['String']['output']>;
  /** Fee structure description */
  readonly feeStructure?: Maybe<Scalars['String']['output']>;
  /** Fiduciary type (e.g. 3(21), 3(38)) */
  readonly fiduciaryType?: Maybe<Scalars['String']['output']>;
  /** Quarterly financial snapshots ordered by as_of_date DESC */
  readonly financialSnapshots: ReadonlyArray<PlanFinancialSnapshot>;
  /** Health band derived from risk_score: healthy (≥80), watch (50–79), at_risk (<50). Null when no milestones exist. */
  readonly healthBand?: Maybe<Scalars['String']['output']>;
  /** Linked household, if any */
  readonly household?: Maybe<Household>;
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /**
   * Professional relationship edges targeting this plan (e.g. Professional Contacts that serve it)
   * @deprecated Frozen. Use professionalServices.
   */
  readonly incomingProfessionalRelationships: ReadonlyArray<ProfessionalRelationship>;
  /**
   * Advisors selectable as "logged by" — the plan's own organization, or the
   * viewer's own organization when viewing via a share
   */
  readonly loggableAdvisors: ReadonlyArray<AssignableAdvisor>;
  /** Compliance milestones ordered by due_date ASC */
  readonly milestones: ReadonlyArray<RetirementPlanMilestone>;
  /** Plan name */
  readonly name: Scalars['String']['output'];
  /** Plan notes ordered by noted_on DESC */
  readonly notes: ReadonlyArray<RetirementPlanNote>;
  /** Plan owners/partners */
  readonly owners?: Maybe<Scalars['String']['output']>;
  /** Parent company name */
  readonly parentCompany?: Maybe<Scalars['String']['output']>;
  /** Participant interaction logs ordered by logged_on DESC */
  readonly participantLogs: ReadonlyArray<RetirementPlanParticipantLog>;
  /** Date the plan was established */
  readonly planInceptionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Human-readable plan identifier (e.g. PLAN-0421) */
  readonly planNumber: Scalars['String']['output'];
  /** Plan type (e.g. 401(k), 403(b)) */
  readonly planType?: Maybe<Scalars['String']['output']>;
  /** Plan year end date */
  readonly planYearEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Prior employers whose service counts toward eligibility */
  readonly predecessorService?: Maybe<Scalars['String']['output']>;
  /** The professional contacts serving this plan that the viewer can read, newest first */
  readonly professionalServices: ReadonlyArray<ProfessionalService>;
  /** Special projects, optionally instantiated from a project template */
  readonly projects: ReadonlyArray<RetirementPlanProject>;
  /** Recordkeeper name */
  readonly recordkeeper?: Maybe<Scalars['String']['output']>;
  /** Plan ID at the recordkeeper */
  readonly recordkeeperPlanId?: Maybe<Scalars['String']['output']>;
  /** Computed health score (0–100). Null when no milestones exist. */
  readonly riskScore?: Maybe<Scalars['Int']['output']>;
  /** Service type */
  readonly serviceType?: Maybe<Scalars['String']['output']>;
  /** The organization that shared this plan with the viewer's organization, if the viewer is accessing it via a share */
  readonly sharedByOrganization?: Maybe<ShareableOrganization>;
  /** Organizations this plan has been shared with */
  readonly sharedWithOrganizations: ReadonlyArray<ShareableOrganization>;
  /** Health status: on_track | at_risk | overdue */
  readonly status: Scalars['String']['output'];
  /** Third-party administrator name */
  readonly tpa?: Maybe<Scalars['String']['output']>;
  /** When the plan was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Sponsor's website */
  readonly website?: Maybe<Scalars['String']['output']>;
};

export type RetirementPlanDesign = {
  readonly __typename?: 'RetirementPlanDesign';
  /** ADP/ACP test method (current year / prior year) */
  readonly adpAcpTestMethod?: Maybe<Scalars['String']['output']>;
  /** Automatic enrollment terms, if any */
  readonly automaticEnrollment?: Maybe<Scalars['String']['output']>;
  /** Compensation definition (e.g. W-2, 415, 3401(a)) */
  readonly compensationDefinition?: Maybe<Scalars['String']['output']>;
  /** Compensation exclusions */
  readonly compensationExclusions?: Maybe<Scalars['String']['output']>;
  /** When the design was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Default deferral percentage under automatic enrollment */
  readonly defaultDeferralPercentage?: Maybe<Scalars['Float']['output']>;
  /** Deferral eligibility rule */
  readonly deferralEligibility?: Maybe<Scalars['String']['output']>;
  /** Deferral entry dates */
  readonly deferralEntryDates?: Maybe<Scalars['String']['output']>;
  /** Employee classes excluded from the plan */
  readonly excludedEmployeeClasses?: Maybe<Scalars['String']['output']>;
  /** HCE determination method */
  readonly hceDetermination?: Maybe<Scalars['String']['output']>;
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /** Match eligibility rule */
  readonly matchEligibility?: Maybe<Scalars['String']['output']>;
  /** Match entry dates */
  readonly matchEntryDates?: Maybe<Scalars['String']['output']>;
  /** Match formula */
  readonly matchFormula?: Maybe<Scalars['String']['output']>;
  /** Match vesting schedule */
  readonly matchVestingSchedule?: Maybe<Scalars['String']['output']>;
  /** Payroll frequency */
  readonly payrollFrequency?: Maybe<Scalars['String']['output']>;
  /** Payroll provider (e.g. Paycom, ADP) */
  readonly payrollProvider?: Maybe<Scalars['String']['output']>;
  /** Profit sharing eligibility rule */
  readonly profitSharingEligibility?: Maybe<Scalars['String']['output']>;
  /** Profit sharing entry dates */
  readonly profitSharingEntryDates?: Maybe<Scalars['String']['output']>;
  /** Profit sharing formula */
  readonly profitSharingFormula?: Maybe<Scalars['String']['output']>;
  /** Profit sharing vesting schedule */
  readonly profitSharingVestingSchedule?: Maybe<Scalars['String']['output']>;
  /** Safe harbor terms, if any */
  readonly safeHarbor?: Maybe<Scalars['String']['output']>;
  /** When the design was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanMilestone = {
  readonly __typename?: 'RetirementPlanMilestone';
  /** Category: regulatory | plan_change | committee_meeting | other | invoice | education | email */
  readonly category?: Maybe<Scalars['String']['output']>;
  /** When the milestone was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Due date */
  readonly dueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether this milestone was auto-generated from a template */
  readonly fromTemplate: Scalars['Boolean']['output'];
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /** Advisor team member who logged this entry */
  readonly loggedBy?: Maybe<AssignableAdvisor>;
  /** Milestone name */
  readonly name: Scalars['String']['output'];
  /** Free-text notes */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /** Status: on_track | due_soon | overdue | done */
  readonly status: Scalars['String']['output'];
  /** When the milestone was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanNote = {
  readonly __typename?: 'RetirementPlanNote';
  /** Note body text */
  readonly body: Scalars['String']['output'];
  /** When the note was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /** Date the note applies to */
  readonly notedOn: Scalars['ISO8601Date']['output'];
  /** Optional note title (e.g. meeting name) */
  readonly title?: Maybe<Scalars['String']['output']>;
  /** When the note was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Retirement Plan Onboarding variant */
export type RetirementPlanOnboardingInput = {
  /** Current recordkeeper (required when onboarding_type is recordkeeper_change) */
  readonly currentRecordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Estimated plan AUM */
  readonly estimatedPlanAum?: InputMaybe<Scalars['Float']['input']>;
  /** New recordkeeper */
  readonly newRecordkeeper: Scalars['String']['input'];
  /** Notes */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** Number of participants */
  readonly numberOfParticipants?: InputMaybe<Scalars['Int']['input']>;
  /** New plan or recordkeeper change */
  readonly onboardingType: CorporateRetirementPlanOnboardingTypeName;
  /** Plan effective date */
  readonly planEffectiveDate: Scalars['ISO8601Date']['input'];
  /** Plan name */
  readonly planName?: InputMaybe<Scalars['String']['input']>;
  /** Plan sponsor contact email */
  readonly planSponsorContactEmail: Scalars['String']['input'];
  /** Plan sponsor contact name */
  readonly planSponsorContactName: Scalars['String']['input'];
};

export type RetirementPlanParticipantLog = {
  readonly __typename?: 'RetirementPlanParticipantLog';
  /** Follow-up action item */
  readonly actionItem?: Maybe<Scalars['String']['output']>;
  /** When the log was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /** Type: education_meeting | enrollment_question | loan_question | distribution_request | follow_up | call | zoom | email */
  readonly interactionType: Scalars['String']['output'];
  /** Advisor team member who logged this entry */
  readonly loggedBy?: Maybe<AssignableAdvisor>;
  /** Date of the interaction */
  readonly loggedOn: Scalars['ISO8601Date']['output'];
  /** Free-text notes about the interaction */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /** Participant email address */
  readonly participantEmail?: Maybe<Scalars['String']['output']>;
  /** Participant full name */
  readonly participantName: Scalars['String']['output'];
  /** Participant phone number */
  readonly participantPhone?: Maybe<Scalars['String']['output']>;
  /** When the log was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanProject = {
  readonly __typename?: 'RetirementPlanProject';
  /** When the project was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Project description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /** Project name */
  readonly name: Scalars['String']['output'];
  /** The retirement plan this project belongs to */
  readonly retirementPlan: RetirementPlan;
  /** Ordered checklist rows for this project */
  readonly rows: ReadonlyArray<RetirementPlanProjectRow>;
  /** Anchor date row due dates were computed from, when created from a template */
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Project status */
  readonly status?: Maybe<Scalars['String']['output']>;
  /** The template this project was created from, if any */
  readonly template?: Maybe<RetirementPlanProjectTemplate>;
  /** When the project was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanProjectRow = {
  readonly __typename?: 'RetirementPlanProjectRow';
  /** Advisor from the plan organization assigned to this row */
  readonly assignee?: Maybe<AssignableAdvisor>;
  /** When the row was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** When this row is due */
  readonly dueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /** Row name (e.g. "Termination Notice") */
  readonly name: Scalars['String']['output'];
  /** Free-text notes for this row */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /** Zero-based ordering of this row within the project */
  readonly position: Scalars['Int']['output'];
  /** The organization responsible for this row (e.g. "Schwab", "Newport") */
  readonly responsibleOrg?: Maybe<Scalars['String']['output']>;
  /** The project this row belongs to */
  readonly retirementPlanProject: RetirementPlanProject;
  /** Status: todo | in_progress | done | cancelled */
  readonly status: Scalars['String']['output'];
  /** The task created from this row, if any */
  readonly task?: Maybe<Task>;
  /** When the row was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanProjectTemplate = {
  readonly __typename?: 'RetirementPlanProjectTemplate';
  /** When the template was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Template description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /** Template name */
  readonly name: Scalars['String']['output'];
  /** Organization this template belongs to */
  readonly organization: Organization;
  /** Ordered steps in this template */
  readonly steps: ReadonlyArray<RetirementPlanProjectTemplateStep>;
  /** When the template was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RetirementPlanProjectTemplateStep = {
  readonly __typename?: 'RetirementPlanProjectTemplateStep';
  /** Days relative to the project start date this step is due */
  readonly dueDateOffsetDays?: Maybe<Scalars['Int']['output']>;
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /** Step name (e.g. "Termination Notice") */
  readonly name: Scalars['String']['output'];
  /** Free-text notes for this step */
  readonly notes?: Maybe<Scalars['String']['output']>;
  /** Zero-based ordering of this step within the template */
  readonly position: Scalars['Int']['output'];
  /** The organization responsible for this step (e.g. "Schwab", "Newport") */
  readonly responsibleOrg?: Maybe<Scalars['String']['output']>;
};

/** Input for a single step within a retirement plan project template. */
export type RetirementPlanProjectTemplateStepInput = {
  /** Days relative to the project start date this step is due. */
  readonly dueDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  /** Step name (e.g. "Termination Notice"). */
  readonly name: Scalars['String']['input'];
  /** Free-text notes for this step. */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** Zero-based ordering of this step within the template. */
  readonly position: Scalars['Int']['input'];
  /** The organization responsible for this step (e.g. "Schwab", "Newport"). */
  readonly responsibleOrg?: InputMaybe<Scalars['String']['input']>;
};

/** Retirement Plan Proposal Generator variant */
export type RetirementPlanProposalInput = {
  /** Current fee structure */
  readonly currentFeeStructure?: InputMaybe<Scalars['String']['input']>;
  /** Current recordkeeper */
  readonly currentRecordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Estimated plan AUM */
  readonly estimatedPlanAum?: InputMaybe<Scalars['Float']['input']>;
  /** Number of participants */
  readonly numberOfParticipants?: InputMaybe<Scalars['Int']['input']>;
  /** Plan name (household name when a household is selected) */
  readonly planName?: InputMaybe<Scalars['String']['input']>;
  /** Prospect meeting date */
  readonly prospectMeetingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Prospect / plan name */
  readonly prospectName: Scalars['String']['input'];
  /** Specific angles to address */
  readonly specificAngles?: InputMaybe<Scalars['String']['input']>;
  /** Target delivery date */
  readonly targetDeliveryDate: Scalars['ISO8601Date']['input'];
};

/** Autogenerated input type of RetryPlanImport */
export type RetryPlanImportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The existing plan whose failed import can retry. */
  readonly planId: Scalars['ID']['input'];
};

/** Autogenerated return type of RetryPlanImport. */
export type RetryPlanImportPayload = {
  readonly __typename?: 'RetryPlanImportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The requeued import operation. */
  readonly importStatus: PlanningImportStatus;
};

/** A single point in a cumulative-return time series (used by Performance vs Benchmark and Account Performance charts). */
export type ReturnPoint = {
  readonly __typename?: 'ReturnPoint';
  /** Cumulative time-weighted return from the series start through this date, expressed as a fraction (0.05 = 5%). */
  readonly cumulativeReturn: Scalars['BigDecimal']['output'];
  /** As-of date for this point. */
  readonly date: Scalars['ISO8601Date']['output'];
};

export const RiskAssessmentName = {
  Aggressive: 'aggressive',
  Conservative: 'conservative',
  Moderate: 'moderate'
} as const;

export type RiskAssessmentName = typeof RiskAssessmentName[keyof typeof RiskAssessmentName];
export type RiskQuestionnaire = {
  readonly __typename?: 'RiskQuestionnaire';
  readonly answers: ReadonlyArray<RiskQuestionnaireAnswer>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  readonly household: Household;
  readonly id: Scalars['ID']['output'];
  readonly model: RiskQuestionnaireModel;
  readonly scoreLevel?: Maybe<SchwabRiskToleranceScoreLevel>;
  readonly submittedByUser?: Maybe<User>;
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly user: User;
};

export type RiskQuestionnaireAnswer = {
  readonly __typename?: 'RiskQuestionnaireAnswer';
  readonly answer: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly question: Scalars['String']['output'];
  readonly score: Scalars['Int']['output'];
};

/** Attributes for a single answer to a risk questionnaire */
export type RiskQuestionnaireAnswerInput = {
  readonly answer: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly question: Scalars['String']['input'];
  readonly questionType: RiskQuestionnaireQuestion;
  readonly score: Scalars['Int']['input'];
};

export const RiskQuestionnaireModel = {
  /** schwab */
  Schwab: 'schwab'
} as const;

export type RiskQuestionnaireModel = typeof RiskQuestionnaireModel[keyof typeof RiskQuestionnaireModel];
export const RiskQuestionnaireQuestion = {
  /** risk_tolerance */
  RiskTolerance: 'risk_tolerance',
  /** time_horizon */
  TimeHorizon: 'time_horizon'
} as const;

export type RiskQuestionnaireQuestion = typeof RiskQuestionnaireQuestion[keyof typeof RiskQuestionnaireQuestion];
/** Required Minimum Distribution (RMD) for an account */
export type Rmd = {
  readonly __typename?: 'Rmd';
  /** The account associated with this RMD. */
  readonly account: Account;
  /**
   * Whether the account was created this year.
   * @deprecated Calculate from account.createdAt instead
   */
  readonly accountCreatedThisYear: Scalars['Boolean']['output'];
  /**
   * The age of the account holder.
   * @deprecated Use account association to access holder information
   */
  readonly accountHolderAge?: Maybe<Scalars['Int']['output']>;
  /**
   * The date of birth of the account holder.
   * @deprecated Use account association to access holder information
   */
  readonly accountHolderDob?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * The name of the account holder.
   * @deprecated Use account association to access holder information
   */
  readonly accountHolderName: Scalars['String']['output'];
  /** The Savvy ID of the account. */
  readonly accountId: Scalars['ID']['output'];
  /**
   * The title of the note
   * @deprecated Use account.displayName instead
   */
  readonly accountName: Scalars['String']['output'];
  /**
   * The account number of the account.
   * @deprecated Use account.mask instead
   */
  readonly accountNumber: Scalars['String']['output'];
  /** The value of the account at the end of the year in question. */
  readonly accountYearEndValue?: Maybe<Scalars['Float']['output']>;
  /** The additional manual distributions for the year not tracked in Savvy. */
  readonly additionalDistributions?: Maybe<Scalars['Float']['output']>;
  /** The advisor of this client. */
  readonly advisor: Advisor;
  /** The Savvy ID of the advisor of this client. */
  readonly advisorId: Scalars['ID']['output'];
  /** The RMD amount. */
  readonly amount: Scalars['Float']['output'];
  /** When the RMD was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The amount distributed for the year so far. */
  readonly distributions: Scalars['Float']['output'];
  /** The Savvy ID of the RMD. */
  readonly id: Scalars['ID']['output'];
  /** The remaining amount that needs to be distributed still. */
  readonly remaining: Scalars['Float']['output'];
  /** The factor used to calculate the RMD. */
  readonly rmdFactor?: Maybe<Scalars['Float']['output']>;
  /** The status of the RMD. */
  readonly status: Scalars['String']['output'];
  /** The timestamp the RMD was last updated. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The year of the RMD. */
  readonly year: Scalars['Int']['output'];
};

/** Argument metadata for running an admin service object */
export type RunAdminServiceObjectArg = {
  /** Information about how to fetch the argument, such as a Household record, from the database */
  readonly argFromDb?: InputMaybe<RunAdminServiceObjectArgFromDb>;
  /** The name of the argument - use this ONLY if the argument is a keyword argument and not a positional arg */
  readonly argKey?: InputMaybe<Scalars['String']['input']>;
  /** The value of the argument - use this if the argument is a scalar */
  readonly argValue?: InputMaybe<Scalars['String']['input']>;
};

/** Information about how to fetch the argument, such as a Household record, from the database */
export type RunAdminServiceObjectArgFromDb = {
  /** A list of key value pairs to find a record by. Example: {id: 1} */
  readonly findBy: ReadonlyArray<RunAdminServiceObjectFindBy>;
  /** The class of the record to find by. Example: "User" */
  readonly klass: Scalars['String']['input'];
};

/** A key value pair to find a record by. */
export type RunAdminServiceObjectFindBy = {
  /** The key to find by */
  readonly key: Scalars['String']['input'];
  /** The value to find by */
  readonly value: Scalars['String']['input'];
};

/** Autogenerated input type of RunAdminServiceObject */
export type RunAdminServiceObjectInput = {
  /** The name of the service object to run */
  readonly adminServiceObject: Scalars['String']['input'];
  /** The arguments to pass to the service object */
  readonly args?: InputMaybe<ReadonlyArray<RunAdminServiceObjectArg>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RunAdminServiceObject. */
export type RunAdminServiceObjectPayload = {
  readonly __typename?: 'RunAdminServiceObjectPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RunInternalAdminAction */
export type RunInternalAdminActionInput = {
  /** The action to run */
  readonly action: InternalAdminAction;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Salesforce account ID to use for the action */
  readonly salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  /** The user ID (advisor) for BackfillConquestPlans action */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of RunInternalAdminAction. */
export type RunInternalAdminActionPayload = {
  readonly __typename?: 'RunInternalAdminActionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciAccountPurposeAndSourceOfFunds */
export type SaveEciAccountPurposeAndSourceOfFundsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Draft account-onboarding request ID. Mutually exclusive with taskId. */
  readonly eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Account purpose for the custodian opening envelope */
  readonly purpose: AccountPurposeName;
  /** Free-text purpose when purpose is other */
  readonly purposeOther?: InputMaybe<Scalars['String']['input']>;
  /** Source of funds for the custodian opening envelope */
  readonly sourceOfFunds: SourceOfFundsName;
  /** Free-text source of funds when source_of_funds is other */
  readonly sourceOfFundsOther?: InputMaybe<Scalars['String']['input']>;
  /** Account-onboarding task ID. Mutually exclusive with eciAccountOnboardingRequestId. */
  readonly taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SaveEciAccountPurposeAndSourceOfFunds. */
export type SaveEciAccountPurposeAndSourceOfFundsPayload = {
  readonly __typename?: 'SaveEciAccountPurposeAndSourceOfFundsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciBeneficiaries */
export type SaveEciBeneficiariesInput = {
  /** Full beneficiary list to persist; replaces any existing beneficiaries */
  readonly beneficiaries: ReadonlyArray<EciBeneficiaryInput>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Draft account-onboarding request ID (Advisor Onboarding Screen C). Mutually exclusive with taskId. */
  readonly eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Account-onboarding task ID (Upgrade Custodian). Mutually exclusive with eciAccountOnboardingRequestId. */
  readonly taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SaveEciBeneficiaries. */
export type SaveEciBeneficiariesPayload = {
  readonly __typename?: 'SaveEciBeneficiariesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the save succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciDecedentDetails */
export type SaveEciDecedentDetailsInput = {
  /** Inherited beneficiary or entity shape */
  readonly bdaBeneficiaryKind: EciBdaBeneficiaryKind;
  /** Original depositor's NFS account number */
  readonly bdaParentAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Original depositor citizenship country */
  readonly citizenshipCountryCode: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Original depositor date of birth */
  readonly dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Original depositor date of death */
  readonly dateOfDeath?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Draft account-onboarding request ID. Mutually exclusive with taskId. */
  readonly eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Original depositor first name */
  readonly firstName: Scalars['String']['input'];
  /** Inherited Traditional or Inherited Roth registration */
  readonly inheritedIraType: EciInheritedIraType;
  /** Original depositor last name */
  readonly lastName: Scalars['String']['input'];
  /** Original depositor middle name */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** Account-onboarding task ID. Mutually exclusive with eciAccountOnboardingRequestId. */
  readonly taskId?: InputMaybe<Scalars['ID']['input']>;
  /** Original depositor tax ID */
  readonly taxId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveEciDecedentDetails. */
export type SaveEciDecedentDetailsPayload = {
  readonly __typename?: 'SaveEciDecedentDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciEmployerDetails */
export type SaveEciEmployerDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Draft account-onboarding request ID. Mutually exclusive with taskId. */
  readonly eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Employer legal name */
  readonly entityName: Scalars['String']['input'];
  /** Account-onboarding task ID. Mutually exclusive with eciAccountOnboardingRequestId. */
  readonly taskId?: InputMaybe<Scalars['ID']['input']>;
  /** Employer EIN */
  readonly taxId: Scalars['String']['input'];
};

/** Autogenerated return type of SaveEciEmployerDetails. */
export type SaveEciEmployerDetailsPayload = {
  readonly __typename?: 'SaveEciEmployerDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciJointOwnerDetails */
export type SaveEciJointOwnerDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Draft account-onboarding request ID (Advisor Onboarding Screen C). Mutually exclusive with taskId. */
  readonly eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** JTWROS, TIC, TBE, or community property; sets the request registration type */
  readonly jointAccountType: EciJointAccountType;
  /** The complete owner set (exactly two), exactly one primary (`self`) */
  readonly owners: ReadonlyArray<EciOwnerInput>;
  /** Account-onboarding task ID (Upgrade Custodian). Mutually exclusive with eciAccountOnboardingRequestId. */
  readonly taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SaveEciJointOwnerDetails. */
export type SaveEciJointOwnerDetailsPayload = {
  readonly __typename?: 'SaveEciJointOwnerDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciManualDeliveringCustodian */
export type SaveEciManualDeliveringCustodianInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Four-digit DTC number, including leading zeros. */
  readonly firmDtcNumber: Scalars['String']['input'];
  /** Delivering firm name entered for this account. */
  readonly firmName: Scalars['String']['input'];
  /** Upgrade Custodian account-onboarding task ID. */
  readonly taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of SaveEciManualDeliveringCustodian. */
export type SaveEciManualDeliveringCustodianPayload = {
  readonly __typename?: 'SaveEciManualDeliveringCustodianPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The persisted funding source. */
  readonly fundingSource: EciAccountFundingSource;
};

/** Autogenerated input type of SaveEciTrustDetails */
export type SaveEciTrustDetailsInput = {
  /** Whether the entity is an accredited investor */
  readonly accreditedInvestor: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ISO country code where the trust was organized */
  readonly countryOfOrganizationCode: Scalars['String']['input'];
  /** Draft account-onboarding request ID (Advisor Onboarding Screen C). Mutually exclusive with taskId. */
  readonly eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Full legal name of the trust entity */
  readonly entityName: Scalars['String']['input'];
  /** Household users acting as grantors */
  readonly grantorUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Trust home address */
  readonly homeAddress: StrictAddressInput;
  /** Mailing address; required when mailing_address_same_as_home is false */
  readonly mailingAddress?: InputMaybe<StrictAddressInput>;
  /** Whether the mailing address is the same as home; when true, home is copied into mailing */
  readonly mailingAddressSameAsHome: Scalars['Boolean']['input'];
  /** Whether the entity is a registered broker-dealer */
  readonly registeredBrokerDealer: Scalars['Boolean']['input'];
  /** Whether the entity is a registered investment advisor */
  readonly registeredInvestmentAdvisor: Scalars['Boolean']['input'];
  /** Whether the entity is a registered investment company */
  readonly registeredInvestmentCompany: Scalars['Boolean']['input'];
  /** Account-onboarding task ID (Upgrade Custodian). Mutually exclusive with eciAccountOnboardingRequestId. */
  readonly taskId?: InputMaybe<Scalars['ID']['input']>;
  /** Tax ID number */
  readonly taxId: Scalars['String']['input'];
  /** Tax ID type */
  readonly taxIdType: EciTrustTaxIdType;
  /** Date the trust was established (ISO 8601) */
  readonly trustDate: Scalars['ISO8601Date']['input'];
  /** Trust revocability */
  readonly trustRevocability: EciTrustRevocability;
  /** Trust type */
  readonly trustType: EciTrustType;
  /** Household users acting as trustees */
  readonly trusteeUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** Autogenerated return type of SaveEciTrustDetails. */
export type SaveEciTrustDetailsPayload = {
  readonly __typename?: 'SaveEciTrustDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciTrustedContactsForHolder */
export type SaveEciTrustedContactsForHolderInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The account holder to write, from EciTrustedContactHolder.id */
  readonly eciClientOnboardingRequestId: Scalars['ID']['input'];
  /** Whether this holder declined to name a trusted contact */
  readonly optedOut: Scalars['Boolean']['input'];
  /** Full trusted-contact list to persist for this holder; replaces any existing contacts */
  readonly trustedContacts?: InputMaybe<ReadonlyArray<EciTrustedContactInput>>;
};

/** Autogenerated return type of SaveEciTrustedContactsForHolder. */
export type SaveEciTrustedContactsForHolderPayload = {
  readonly __typename?: 'SaveEciTrustedContactsForHolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the save succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveEciTrustedContacts */
export type SaveEciTrustedContactsInput = {
  /**
   * Write on behalf of this client. Ignored on the MagicLink path; on a session it
   * is only honoured for an advisor who could impersonate them.
   */
  readonly clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the client declined to provide a trusted contact */
  readonly optedOut: Scalars['Boolean']['input'];
  /** Full trusted-contact list to persist; replaces any existing contacts */
  readonly trustedContacts?: InputMaybe<ReadonlyArray<EciTrustedContactInput>>;
};

/** Autogenerated return type of SaveEciTrustedContacts. */
export type SaveEciTrustedContactsPayload = {
  readonly __typename?: 'SaveEciTrustedContactsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the save succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveHouseholdKeepInMindVote */
export type SaveHouseholdKeepInMindVoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional free text; omit it to leave any stored comment alone */
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  /** The `generatedAt` the item was rendered from; a vote against a superseded generation is rejected */
  readonly generatedAt: Scalars['ISO8601DateTime']['input'];
  /** Household whose section the item belongs to */
  readonly householdId: Scalars['ID']['input'];
  /** Optional reason; only meaningful alongside a DOWN vote */
  readonly issueType?: InputMaybe<HouseholdKeepInMindIssueTypeEnum>;
  /** Position of the item in the payload's `items` */
  readonly itemIndex: Scalars['Int']['input'];
  /** The thumb */
  readonly vote: HouseholdKeepInMindVoteEnum;
};

/** Autogenerated return type of SaveHouseholdKeepInMindVote. */
export type SaveHouseholdKeepInMindVotePayload = {
  readonly __typename?: 'SaveHouseholdKeepInMindVotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the vote was recorded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveMeetingSummaryVote */
export type SaveMeetingSummaryVoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional free text; omit it to leave any stored comment alone */
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  /** The `meetingSummaryGeneration` the summary was rendered from; a vote against text since regenerated is rejected */
  readonly generation: Scalars['String']['input'];
  /** Optional reason; only kept alongside a DOWN vote */
  readonly issueType?: InputMaybe<MeetingSummaryIssueTypeEnum>;
  /** The Savvy meeting summary being rated */
  readonly meetingSummaryId: Scalars['ID']['input'];
  /** The thumb */
  readonly vote: MeetingSummaryVoteEnum;
};

/** Autogenerated return type of SaveMeetingSummaryVote. */
export type SaveMeetingSummaryVotePayload = {
  readonly __typename?: 'SaveMeetingSummaryVotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The note the summary is shown in, carrying the updated vote */
  readonly note?: Maybe<Note>;
  /** Whether the vote was recorded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SaveReportTemplate */
export type SaveReportTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Serialized report builder configuration (must include dateRangeId and sections array) */
  readonly config: Scalars['JsonHash']['input'];
  /** Whether this template represents a report bundle */
  readonly isBundle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name for the template */
  readonly name: Scalars['String']['input'];
};

/** Autogenerated return type of SaveReportTemplate. */
export type SaveReportTemplatePayload = {
  readonly __typename?: 'SaveReportTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created template */
  readonly savedReportTemplate: SavedReportTemplate;
};

/** Autogenerated input type of SaveRetirementPlanProjectAsTemplate */
export type SaveRetirementPlanProjectAsTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Template description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Template name */
  readonly name: Scalars['String']['input'];
  /** The project to snapshot */
  readonly retirementPlanProjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of SaveRetirementPlanProjectAsTemplate. */
export type SaveRetirementPlanProjectAsTemplatePayload = {
  readonly __typename?: 'SaveRetirementPlanProjectAsTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created template */
  readonly retirementPlanProjectTemplate?: Maybe<RetirementPlanProjectTemplate>;
};

/** Autogenerated input type of SaveServiceCatalogItemGroup */
export type SaveServiceCatalogItemGroupInput = {
  /**
   * Editors of a team service, replacing the existing set. Omitted leaves the
   * existing editors untouched; an empty list means everyone in the owning scope can edit.
   */
  readonly acl?: InputMaybe<ReadonlyArray<ServiceCatalogItemGroupAclInput>>;
  /** Advisor group id (legacy scope); create only, exactly one of this and organizationId */
  readonly advisorGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Service attributes */
  readonly attributes: ServiceCatalogItemGroupAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The pendingChangesUpdatedAt this editor loaded. Send it to be told when
   * someone else changed the service first; null means "I expect nothing
   * unpublished". Omitted skips the check.
   */
  readonly expectedPendingChangesUpdatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Existing service id; null creates a new service */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  /** The service's complete item list, in display order */
  readonly items: ReadonlyArray<ServiceCatalogItemSaveInput>;
  /** Organization id (org scope); create only, exactly one of this and advisorGroupId */
  readonly organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Who can see and run this service. Omitted leaves it unchanged. */
  readonly visibility?: InputMaybe<ServiceCatalogItemGroupVisibility>;
};

/** Autogenerated return type of SaveServiceCatalogItemGroup. */
export type SaveServiceCatalogItemGroupPayload = {
  readonly __typename?: 'SaveServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Service catalog item group */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
};

/** A team-shared report builder configuration. Visible to every member of every AdvisorGroup the template fans out to. */
export type SavedReportTemplate = {
  readonly __typename?: 'SavedReportTemplate';
  /**
   * Advisor group IDs this template is shared with, filtered to the viewer's own
   * memberships so cross-team metadata isn't leaked to teammates outside those groups.
   */
  readonly advisorGroupIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Advisor groups this template is shared with (id + name), filtered to the viewer's own memberships. */
  readonly advisorGroups: ReadonlyArray<AdvisorGroup>;
  /** Serialized GeneratedConfig payload from the report builder */
  readonly config: Scalars['JSON']['output'];
  /** When the template was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The user who created this template */
  readonly createdByUserId: Scalars['ID']['output'];
  /** The unique identifier for the saved report template */
  readonly id: Scalars['ID']['output'];
  /** Whether this template is a report bundle */
  readonly isBundle: Scalars['Boolean']['output'];
  /** Whether this template is one of the system-seeded default templates */
  readonly isDefault: Scalars['Boolean']['output'];
  /** Stable key identifying which seeded default template this is (e.g. investment_proposal); null for user-created templates */
  readonly kind?: Maybe<Scalars['String']['output']>;
  /** Display name for the template */
  readonly name: Scalars['String']['output'];
  /** Automated delivery schedule for this template, if configured */
  readonly schedule?: Maybe<ReportSchedule>;
  /** When the template was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input for the Savvy Growth Opportunities Fund variant of the alternative investments purchase task */
export type SavvyAlternativesSubscription = {
  /** The Savvy account funding the commitment; it must have an account number */
  readonly accountId: Scalars['ID']['input'];
  /** Total commitment to the fund, at least 100,000 */
  readonly commitmentAmount: Scalars['Float']['input'];
  /** Legal name of the investing entity */
  readonly entityLegalName: Scalars['String']['input'];
  /** Investing entity sub type (natural_person, ira, revocable_trust, irrevocable_trust, llc, other) */
  readonly entitySubType: Scalars['String']['input'];
  /** Description when the sub type is other */
  readonly entitySubTypeOther?: InputMaybe<Scalars['String']['input']>;
  /** Investing entity type (individual_or_joint, trust, business) */
  readonly entityType: Scalars['String']['input'];
  /** Who pays the fund fees (pass_through, absorb) */
  readonly feeResponsibility: Scalars['String']['input'];
  /** Two-letter country code of the entity jurisdiction */
  readonly jurisdictionCountry: Scalars['String']['input'];
  /** State or province of the entity jurisdiction */
  readonly jurisdictionState: Scalars['String']['input'];
  /** Primary account holder email; required for individual_or_joint */
  readonly primaryHolderEmail?: InputMaybe<Scalars['String']['input']>;
  /** Primary account holder legal name; required for individual_or_joint */
  readonly primaryHolderName?: InputMaybe<Scalars['String']['input']>;
  /** Primary reporting contact */
  readonly primaryReportingContact: SavvyReportingContactInput;
  /** The advisor attests the household is a qualified purchaser; must be true */
  readonly qualifiedPurchaserAttested: Scalars['Boolean']['input'];
  /** Second account holder email */
  readonly secondHolderEmail?: InputMaybe<Scalars['String']['input']>;
  /** Second account holder legal name */
  readonly secondHolderName?: InputMaybe<Scalars['String']['input']>;
  /** Second reporting contact */
  readonly secondReportingContact?: InputMaybe<SavvyReportingContactInput>;
};

/** Savvy Growth Opportunities Fund enrollment data associated with an alternative investments purchase task */
export type SavvyAlternativesSubscriptionRequest = {
  readonly __typename?: 'SavvyAlternativesSubscriptionRequest';
  /** The Savvy account the commitment is funded from, if it still exists. */
  readonly accountId?: Maybe<Scalars['ID']['output']>;
  /** Total commitment to the fund. */
  readonly commitmentAmount: Scalars['Float']['output'];
  /** Legal name of the investing entity. */
  readonly entityLegalName: Scalars['String']['output'];
  /** Investing entity sub type (natural_person, ira, revocable_trust, irrevocable_trust, llc, other). */
  readonly entitySubType: Scalars['String']['output'];
  /** Description when the sub type is other. */
  readonly entitySubTypeOther?: Maybe<Scalars['String']['output']>;
  /** Investing entity type (individual_or_joint, trust, business). */
  readonly entityType: Scalars['String']['output'];
  /** Who pays the fund fees (pass_through, absorb). */
  readonly feeResponsibility: Scalars['String']['output'];
  /** The Savvy ID of the request. */
  readonly id: Scalars['ID']['output'];
  /** Two-letter country code of the entity jurisdiction. */
  readonly jurisdictionCountry: Scalars['String']['output'];
  /** State or province of the entity jurisdiction. */
  readonly jurisdictionState: Scalars['String']['output'];
  /** Primary account holder email. */
  readonly primaryHolderEmail?: Maybe<Scalars['String']['output']>;
  /** Primary account holder legal name. */
  readonly primaryHolderName?: Maybe<Scalars['String']['output']>;
  /** Primary reporting contact email, when not a Savvy user. */
  readonly primaryReportingContactEmail?: Maybe<Scalars['String']['output']>;
  /** Primary reporting contact name, when not a Savvy user. */
  readonly primaryReportingContactName?: Maybe<Scalars['String']['output']>;
  /** Savvy user picked as the primary reporting contact. */
  readonly primaryReportingContactUserId?: Maybe<Scalars['ID']['output']>;
  /** Allocate's intake questionnaire answers, in questionnaire order. */
  readonly rows: ReadonlyArray<IntakeRow>;
  /** Second account holder email. */
  readonly secondHolderEmail?: Maybe<Scalars['String']['output']>;
  /** Second account holder legal name. */
  readonly secondHolderName?: Maybe<Scalars['String']['output']>;
  /** Second reporting contact email, when not a Savvy user. */
  readonly secondReportingContactEmail?: Maybe<Scalars['String']['output']>;
  /** Second reporting contact name, when not a Savvy user. */
  readonly secondReportingContactName?: Maybe<Scalars['String']['output']>;
  /** Savvy user picked as the second reporting contact. */
  readonly secondReportingContactUserId?: Maybe<Scalars['ID']['output']>;
};

/** A reporting contact for a Savvy alternatives enrollment: either a Savvy team member, or a name and email */
export type SavvyReportingContactInput = {
  /** Contact email, when not a Savvy team member */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Contact name, when not a Savvy team member */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy team member to use as the contact */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Where an admin authors Savvy service templates: a Savvy-owned advisor group it
 * administers but never operates. Admins deliberately belong to no organization
 * and no advisor group, so the editor cannot derive a create scope from the actor
 * the way it does for an advisor.
 */
export type SavvyServiceCatalogScope = {
  readonly __typename?: 'SavvyServiceCatalogScope';
  /** Pass as saveServiceCatalogItemGroup's advisorGroupId to author in the catalog */
  readonly advisorGroupId: Scalars['ID']['output'];
  /** Name of the owning advisor group, which the editor rail shows as the audience */
  readonly advisorGroupName: Scalars['String']['output'];
};

/**
 * A Savvy-maintained service template, as the catalog modal renders it: identity,
 * its items, whether it has a published version to clone, and whether the viewer's
 * organization has already cloned it. A projection rather than
 * Models::ServiceCatalog::ServiceCatalogItemGroup so that browsing the catalog
 * does not depend on the group and item read policies, which authorize by advisor
 * group and organization and would deny — and, because a denied object raises,
 * fail the whole query for — every advisor outside the Savvy organization.
 * Widening those policies instead would hand advisors a readable, unenrollable
 * catalog row in the surfaces that gate on them.
 */
export type SavvyServiceTemplate = {
  readonly __typename?: 'SavvyServiceTemplate';
  /** Whether the viewer's organization already holds a clone of this template, which disables Add to Resources */
  readonly addedToResources: Scalars['Boolean']['output'];
  /** Colour key for the service identity chip */
  readonly color: Scalars['String']['output'];
  /** Long-form description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the template has a published version for an advisor to clone. A
   * never-published one cannot be cloned, so Add to Resources is withheld; only an
   * admin, whose catalog is the management view, is served one.
   */
  readonly everPublished: Scalars['Boolean']['output'];
  /** Icon key for the service identity chip */
  readonly icon: Scalars['String']['output'];
  /** The template id, which addSavvyServiceTemplateToResources clones */
  readonly id: Scalars['ID']['output'];
  /** The template's active items in the order the admin arranged them, which the preview pane lists */
  readonly items: ReadonlyArray<SavvyServiceTemplateItem>;
  /** Display name */
  readonly name: Scalars['String']['output'];
};

/**
 * One item of a Savvy service template, as the catalog modal's preview card
 * renders it. A projection rather than Models::ServiceCatalog::ServiceCatalogItem,
 * whose read policies admit only admins and advisors in the item's own advisor
 * group or organization — every catalog item lives in the Savvy organization, and
 * a denied object raises rather than nulling the field, so the model type would
 * fail the whole catalog query for exactly the advisors the catalog exists for.
 */
export type SavvyServiceTemplateItem = {
  readonly __typename?: 'SavvyServiceTemplateItem';
  /** AfterPrevious cadence in days, if set */
  readonly afterPreviousOffsetDays?: Maybe<Scalars['Int']['output']>;
  /** Cadence preset jsonb configuration, which the preview card labels */
  readonly cadencePreset?: Maybe<Scalars['JSON']['output']>;
  /** Long-form description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** The item id */
  readonly id: Scalars['ID']['output'];
  /** task or event */
  readonly itemType: Scalars['String']['output'];
  /** Display name */
  readonly name: Scalars['String']['output'];
  /** RRULE string from the associated recurrence pattern */
  readonly recurrencePatternRrule?: Maybe<Scalars['String']['output']>;
};

/** A Savvy investment strategy in the catalog (raw holdings excluded) */
export type SavvyStrategy = {
  readonly __typename?: 'SavvyStrategy';
  /** The allocation family the strategy belongs to */
  readonly allocation: Scalars['String']['output'];
  /** An optional human-friendly display name */
  readonly displayName?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the strategy */
  readonly id: Scalars['ID']['output'];
  /** The earliest known rebalance date for the strategy */
  readonly inceptionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether the strategy is archived */
  readonly isArchived: Scalars['Boolean']['output'];
  /** The Orion Connect model id for the strategy */
  readonly orionConnectModelId: Scalars['String']['output'];
  /**
   * Faithful, rebalance-aware performance value history as [timestampMs, value,
   * isoWeek] tuples (value normalized to ~1.0 at inception). Null until computed
   * from the uploaded holdings; consumers fall back to the current-weights
   * backtest while null. Heavy — request for a single selected strategy
   * (savvyStrategy query), not the full catalog list.
   */
  readonly performanceSeries?: Maybe<Scalars['JSON']['output']>;
  /** The name of the strategy */
  readonly strategyName: Scalars['String']['output'];
};

/** An advisor's reply to a capture-survey scenario. */
export type ScenarioReplyInput = {
  /** Canonical scenario id the reply answers (e.g. scenario_anxious_market). */
  readonly scenario: Scalars['String']['input'];
  /** The advisor's reply text. Max 2000 chars, enforced server-side. */
  readonly text: Scalars['String']['input'];
};

/** Autogenerated input type of ScheduleNativeReport */
export type ScheduleNativeReportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Report end date */
  readonly endDate: Scalars['ISO8601Date']['input'];
  /** Savvy household ID */
  readonly householdId: Scalars['ID']['input'];
  /**
   * The report type to generate. Valid values: performance_report_allocations,
   * performance_report_account, performance_report_household,
   * performance_report_security, performance_report_asset_class,
   * portfolio_summary_simple, portfolio_summary_cash_flows,
   * performance_report_consolidated, performance_report_holistic,
   * performance_report_portfolio_group, portfolio_summary_comprehensive,
   * performance_report_integrated
   */
  readonly reportType: Scalars['String']['input'];
  /** Report start date (required for date-range reports) */
  readonly startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of ScheduleNativeReport. */
export type ScheduleNativeReportPayload = {
  readonly __typename?: 'ScheduleNativeReportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The scheduled job. Poll nativeReport(id) { status, dataJson } for status and data. */
  readonly nativeReport: NativeReport;
};

/** One reason accounts could not be read during a Schwab sync, with how many accounts hit it. */
export type SchwabImportRunCause = {
  readonly __typename?: 'SchwabImportRunCause';
  /** Schwab's error code, e.g. SEC-0001 (dead firm token) or SEC-0100 (account not entitled). A 400 carries no code. */
  readonly code?: Maybe<Scalars['String']['output']>;
  /** How many accounts failed for this reason across the whole run */
  readonly count: Scalars['Int']['output'];
  /** HTTP status Schwab returned, or null when the call never reached Schwab (rate limiter, timeout) */
  readonly status?: Maybe<Scalars['Int']['output']>;
  /** Schwab's error title, e.g. Unauthorized */
  readonly title?: Maybe<Scalars['String']['output']>;
};

/** An advisor whose whole sync failed, as opposed to one that merely could not read some of its accounts. */
export type SchwabImportRunFailedAdvisor = {
  readonly __typename?: 'SchwabImportRunFailedAdvisor';
  /** The advisor this run was scoped to */
  readonly advisorId?: Maybe<Scalars['ID']['output']>;
  /** Advisor full name, null if the user no longer exists */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
};

export const SchwabImportRunState = {
  /** Every advisor read every account */
  Completed: 'completed',
  /** Some accounts could not be read; everything else was applied */
  CompletedWithGaps: 'completed_with_gaps',
  /** Every advisor failed and nothing was applied */
  Failed: 'failed',
  /** Advisors are still queued or running */
  InProgress: 'in_progress'
} as const;

export type SchwabImportRunState = typeof SchwabImportRunState[keyof typeof SchwabImportRunState];
/**
 * Outcome of one firm-wide Schwab standing-authorizations sync, grouped by cause
 * rather than by advisor. Derived from the run's import rows plus its Sidekiq
 * batch; there is no run table.
 */
export type SchwabImportRunSummary = {
  readonly __typename?: 'SchwabImportRunSummary';
  /** Client accounts Schwab did not answer successfully */
  readonly accountsFailed: Scalars['Int']['output'];
  /** Client accounts Schwab answered successfully */
  readonly accountsRead: Scalars['Int']['output'];
  /** Client accounts held at Schwab that this run attempted, across every advisor */
  readonly accountsTotal: Scalars['Int']['output'];
  /** Advisors whose sync finished */
  readonly advisorsCompleted: Scalars['Int']['output'];
  /** Advisors whose sync failed outright and applied nothing */
  readonly advisorsFailed: Scalars['Int']['output'];
  /** Advisors still queued or running, from the Sidekiq batch */
  readonly advisorsPending: Scalars['Int']['output'];
  /** Advisors enqueued for this run, from the Sidekiq batch, falling back to the row count once batch data expires */
  readonly advisorsTotal: Scalars['Int']['output'];
  /** Advisors that finished but could not read every account */
  readonly advisorsWithGaps: Scalars['Int']['output'];
  /** Bank links this run created */
  readonly banksAdded: Scalars['Int']['output'];
  /** Advisors whose sync failed outright, capped at 10 */
  readonly failedAdvisors: ReadonlyArray<SchwabImportRunFailedAdvisor>;
  /** Why accounts could not be read, most common first */
  readonly failuresByCause: ReadonlyArray<SchwabImportRunCause>;
  /** When the last advisor import last changed. Null while anything is still in flight. */
  readonly finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The Sidekiq batch id that identifies this run. Null for the window between a
   * start and its first advisor import landing, when the run exists but has no
   * batch id to report yet.
   */
  readonly runId?: Maybe<Scalars['String']['output']>;
  /** When the run's first advisor import was created */
  readonly startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether the run is still going, finished cleanly, finished with unread accounts, or failed outright */
  readonly state: SchwabImportRunState;
  /** Name of the admin who started the run, or null for the scheduled run */
  readonly triggeredBy?: Maybe<Scalars['String']['output']>;
};

export const SchwabOauthApp = {
  /** Savvy Wealth Money Movements */
  SchwabMoneyMovements: 'schwab_money_movements',
  /** AS Standing Authorizations */
  SchwabStandingAuthorizations: 'schwab_standing_authorizations'
} as const;

export type SchwabOauthApp = typeof SchwabOauthApp[keyof typeof SchwabOauthApp];
export const SchwabRiskToleranceScoreLevel = {
  /** aggressive */
  Aggressive: 'aggressive',
  /** conservative */
  Conservative: 'conservative',
  /** moderate */
  Moderate: 'moderate',
  /** moderately_aggressive */
  ModeratelyAggressive: 'moderately_aggressive',
  /** moderately_conservative */
  ModeratelyConservative: 'moderately_conservative'
} as const;

export type SchwabRiskToleranceScoreLevel = typeof SchwabRiskToleranceScoreLevel[keyof typeof SchwabRiskToleranceScoreLevel];
export type SecondaryEmail = {
  readonly __typename?: 'SecondaryEmail';
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly label?: Maybe<Scalars['String']['output']>;
  readonly user: User;
};

export type SecondaryEmailInput = {
  /** The email address */
  readonly email: Scalars['String']['input'];
  /** The label for this email (e.g., "Personal", "Work") */
  readonly label?: InputMaybe<Scalars['String']['input']>;
};

export type SecondaryPhone = {
  readonly __typename?: 'SecondaryPhone';
  readonly id: Scalars['ID']['output'];
  readonly label?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber: Scalars['String']['output'];
  readonly user: User;
};

export type SecondaryPhoneInput = {
  /** The label for this phone (e.g., "Mobile", "Work") */
  readonly label?: InputMaybe<Scalars['String']['input']>;
  /** The phone number */
  readonly phoneNumber: Scalars['String']['input'];
};

/** Security held by the user in an account. */
export type Security = {
  readonly __typename?: 'Security';
  /** The close price of the security from the source provider. */
  readonly closePrice?: Maybe<Value>;
  /** The timestamp that is associated with the close_price for the security */
  readonly closePriceAsOf?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The CUSIP identifier  of the security. */
  readonly cusip?: Maybe<Scalars['String']['output']>;
  /** The primary exchange that the security is traded on. */
  readonly exchange?: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the security. */
  readonly id: Scalars['ID']['output'];
  /** The ISIN identifier of the security. */
  readonly isin?: Maybe<Scalars['String']['output']>;
  /** The timestamp the security was last updated with information from the source provider. */
  readonly lastUpdatedAt: Scalars['ISO8601DateTime']['output'];
  /** Metadata about the security. */
  readonly metadata?: Maybe<Scalars['JSON']['output']>;
  /** The Savvy ID of the security. */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** The SEDOL identifier of the security. */
  readonly sedol?: Maybe<Scalars['String']['output']>;
  /** The subtype of the security */
  readonly subtype?: Maybe<Scalars['String']['output']>;
  /** The ticker symbol of the security. */
  readonly tickerSymbol?: Maybe<Scalars['String']['output']>;
  /** The type of the security */
  readonly type: SecurityTypeName;
};

export const SecurityTypeName = {
  Bond: 'bond',
  Cash: 'cash',
  Cryptocurrency: 'cryptocurrency',
  Derivative: 'derivative',
  Equity: 'equity',
  Etf: 'etf',
  FixedIncome: 'fixed_income',
  Loan: 'loan',
  MoneyMarket: 'money_market',
  MultiAssetStrategy: 'multi_asset_strategy',
  MutualFund: 'mutual_fund',
  Options: 'options',
  Other: 'other'
} as const;

export type SecurityTypeName = typeof SecurityTypeName[keyof typeof SecurityTypeName];
/** Autogenerated input type of SelectEciDeliveringCustodian */
export type SelectEciDeliveringCustodianInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Local directory ID of the delivering custodian. */
  readonly custodianDetailId: Scalars['ID']['input'];
  /** Upgrade Custodian account-onboarding task ID. */
  readonly taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of SelectEciDeliveringCustodian. */
export type SelectEciDeliveringCustodianPayload = {
  readonly __typename?: 'SelectEciDeliveringCustodianPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The persisted funding source. */
  readonly fundingSource: EciAccountFundingSource;
};

/** Select/tag filter with operator and values array */
export type SelectFilterInput = {
  /** Select filter operator */
  readonly operator: SelectFilterOperatorEnum;
  /** Filter values array (not required for isEmpty operator) */
  readonly values?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** Select/tag filter operators */
export const SelectFilterOperatorEnum = {
  /** Any of the selected values */
  AnyOf: 'ANY_OF',
  /** Field is empty or null */
  IsEmpty: 'IS_EMPTY',
  /** None of the selected values */
  NoneOf: 'NONE_OF'
} as const;

export type SelectFilterOperatorEnum = typeof SelectFilterOperatorEnum[keyof typeof SelectFilterOperatorEnum];
/** Autogenerated input type of SendClientBookingEmail */
export type SendClientBookingEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly isReminder?: InputMaybe<Scalars['Boolean']['input']>;
  readonly meetingId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendClientBookingEmail. */
export type SendClientBookingEmailPayload = {
  readonly __typename?: 'SendClientBookingEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly meeting?: Maybe<ServiceCalendarMeeting>;
  readonly primaryClientId?: Maybe<Scalars['ID']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendClientWelcomeEmail */
export type SendClientWelcomeEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
};

/** Autogenerated return type of SendClientWelcomeEmail. */
export type SendClientWelcomeEmailPayload = {
  readonly __typename?: 'SendClientWelcomeEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendCreatePasswordEmail */
export type SendCreatePasswordEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
};

/** Autogenerated return type of SendCreatePasswordEmail. */
export type SendCreatePasswordEmailPayload = {
  readonly __typename?: 'SendCreatePasswordEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly emailSent?: Maybe<Email>;
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendEmailMessage */
export type SendEmailMessageInput = {
  /** BCC email addresses */
  readonly bcc?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Email body as HTML */
  readonly body: Scalars['String']['input'];
  /** CC email addresses */
  readonly cc?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email subject */
  readonly subject: Scalars['String']['input'];
  /** Recipient email addresses */
  readonly to: ReadonlyArray<Scalars['String']['input']>;
};

/** Autogenerated return type of SendEmailMessage. */
export type SendEmailMessagePayload = {
  readonly __typename?: 'SendEmailMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error messages if the operation failed */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Whether the email was enqueued successfully */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendFileShareEmail */
export type SendFileShareEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly fileInstructions?: InputMaybe<Scalars['String']['input']>;
  readonly fileName: Scalars['String']['input'];
  readonly fileShareUrl: Scalars['String']['input'];
  readonly isFolder: Scalars['Boolean']['input'];
  readonly selectedClientIds: ReadonlyArray<Scalars['String']['input']>;
};

/** Autogenerated return type of SendFileShareEmail. */
export type SendFileShareEmailPayload = {
  readonly __typename?: 'SendFileShareEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendMsaNotice */
export type SendMsaNoticeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict the run to these households. Absent sends to the whole audience. */
  readonly householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** Autogenerated return type of SendMsaNotice. */
export type SendMsaNoticePayload = {
  readonly __typename?: 'SendMsaNoticePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Households enqueued */
  readonly queuedCount: Scalars['Int']['output'];
  /** Distinct clients those households resolve to */
  readonly recipientCount: Scalars['Int']['output'];
  /** Groups this run's log lines; query Datadog as @run_id */
  readonly runId: Scalars['String']['output'];
  /** The MSA template version they are being moved onto */
  readonly templateVersion: Scalars['String']['output'];
};

/** Autogenerated input type of SendOnboarding */
export type SendOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-composed message body sent to each client */
  readonly emailBody: Scalars['String']['input'];
  /** Whether to schedule day 3/7/14 reminder emails for unsubmitted clients */
  readonly sendReminders: Scalars['Boolean']['input'];
  /** The staged household to send onboarding for. */
  readonly stagedHouseholdId: Scalars['ID']['input'];
};

/** Autogenerated input type of SendOnboardingInviteToOps */
export type SendOnboardingInviteToOpsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household identifier — UUID (preferred) or legacy salesforce_account_id */
  readonly householdPublicId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendOnboardingInviteToOps. */
export type SendOnboardingInviteToOpsPayload = {
  readonly __typename?: 'SendOnboardingInviteToOpsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred. */
  readonly errors?: Maybe<ReadonlyArray<MutationError>>;
  /** Whether the send succeeded. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of SendOnboarding. */
export type SendOnboardingPayload = {
  readonly __typename?: 'SendOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred. */
  readonly errors?: Maybe<ReadonlyArray<MutationError>>;
  /** The staged household after send. */
  readonly stagedHousehold?: Maybe<AdvisorOnboardingStagedHousehold>;
  /** Whether the operation succeeded. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendOnboardingToClient */
export type SendOnboardingToClientInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Salesforce task ID */
  readonly salesforceTaskId: Scalars['String']['input'];
};

/** Autogenerated return type of SendOnboardingToClient. */
export type SendOnboardingToClientPayload = {
  readonly __typename?: 'SendOnboardingToClientPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the onboarding task was sent to the client */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendPasswordResetEmail */
export type SendPasswordResetEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the client user to send a password reset to */
  readonly email: Scalars['String']['input'];
};

/** Autogenerated return type of SendPasswordResetEmail. */
export type SendPasswordResetEmailPayload = {
  readonly __typename?: 'SendPasswordResetEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the reset was declined, when it was declined without failing */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the reset email was sent */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendRepaperEnvelope */
export type SendRepaperEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Tracking ID returned from createRepaperEnvelope */
  readonly trackingId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendRepaperEnvelope. */
export type SendRepaperEnvelopePayload = {
  readonly __typename?: 'SendRepaperEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if enqueue failed */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** Whether the send job was successfully enqueued */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendSignOnboardingDocumentsReminder */
export type SendSignOnboardingDocumentsReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documentType: OnboardingDocument;
  readonly taskId: Scalars['Int']['input'];
  readonly userId: Scalars['Int']['input'];
};

/** Autogenerated return type of SendSignOnboardingDocumentsReminder. */
export type SendSignOnboardingDocumentsReminderPayload = {
  readonly __typename?: 'SendSignOnboardingDocumentsReminderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendTaskEmail */
export type SendTaskEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the notification must be treated as a reminder */
  readonly isReminder?: InputMaybe<Scalars['Boolean']['input']>;
  readonly taskId: Scalars['String']['input'];
};

/** Autogenerated return type of SendTaskEmail. */
export type SendTaskEmailPayload = {
  readonly __typename?: 'SendTaskEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Detail for the senior-political-figure disclosure (required when the answer is yes). */
export type SeniorPoliticalFigureDetailInput = {
  /** ISO-3166-1 alpha-2 country code */
  readonly countryCode: Scalars['String']['input'];
  /** Family member name (optional; only when applicable) */
  readonly familyMemberName?: InputMaybe<Scalars['String']['input']>;
  /** Office / position held */
  readonly officePosition: Scalars['String']['input'];
  /** Relationship to the senior political figure (self, spouse, parent, child, sibling) */
  readonly relationship: Scalars['String']['input'];
};

/** A single service calendar item on a household's Service Calendar. */
export type ServiceCalendarItem = {
  readonly __typename?: 'ServiceCalendarItem';
  readonly completionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly dueDate: Scalars['ISO8601DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly serviceCalendarSettingId: Scalars['ID']['output'];
  readonly status: ServiceCalendarItemStatus;
  readonly title: Scalars['String']['output'];
};

export const ServiceCalendarItemStatus = {
  Complete: 'complete',
  Incomplete: 'incomplete',
  Skipped: 'skipped'
} as const;

export type ServiceCalendarItemStatus = typeof ServiceCalendarItemStatus[keyof typeof ServiceCalendarItemStatus];
/** A service calendar meeting */
export type ServiceCalendarMeeting = {
  readonly __typename?: 'ServiceCalendarMeeting';
  /** Calendly cancel URL */
  readonly calendlyCancelUrl?: Maybe<Scalars['String']['output']>;
  /** Calendly reschedule URL */
  readonly calendlyRescheduleUrl?: Maybe<Scalars['String']['output']>;
  /** Due date for the meeting */
  readonly dueDate: Scalars['ISO8601DateTime']['output'];
  /** Expected quarter of the meeting */
  readonly expectedQuarter: Scalars['String']['output'];
  /** Household ID */
  readonly householdId: Scalars['ID']['output'];
  readonly id: Scalars['ID']['output'];
  /** Date of the meeting */
  readonly meetingDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Meeting request dates */
  readonly meetingRequestDates: ReadonlyArray<Scalars['ISO8601Date']['output']>;
  /** Date of the automated meeting */
  readonly sendAutomatedMeetingDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Date of the automated meeting reminder */
  readonly sendAutomatedMeetingReminderDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Service calendar meeting type ID */
  readonly serviceCalendarMeetingTypeId: Scalars['ID']['output'];
  /** Meeting status (scheduled, completed, cancelled) */
  readonly status: ServiceCalendarMeetingStatus;
  /** Completion date of the meeting */
  readonly statusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Title of the meeting */
  readonly title: Scalars['String']['output'];
};

export const ServiceCalendarMeetingDateUnit = {
  /** days */
  Days: 'days',
  /** months */
  Months: 'months',
  /** weeks */
  Weeks: 'weeks'
} as const;

export type ServiceCalendarMeetingDateUnit = typeof ServiceCalendarMeetingDateUnit[keyof typeof ServiceCalendarMeetingDateUnit];
export const ServiceCalendarMeetingExpectedQuarter = {
  /** q1 */
  Q1: 'q1',
  /** q2 */
  Q2: 'q2',
  /** q3 */
  Q3: 'q3',
  /** q4 */
  Q4: 'q4'
} as const;

export type ServiceCalendarMeetingExpectedQuarter = typeof ServiceCalendarMeetingExpectedQuarter[keyof typeof ServiceCalendarMeetingExpectedQuarter];
export const ServiceCalendarMeetingStatus = {
  /** complete */
  Complete: 'complete',
  /** incomplete */
  Incomplete: 'incomplete',
  /** skipped */
  Skipped: 'skipped'
} as const;

export type ServiceCalendarMeetingStatus = typeof ServiceCalendarMeetingStatus[keyof typeof ServiceCalendarMeetingStatus];
/** A template for service calendar meeting types */
export type ServiceCalendarMeetingTypeTemplate = {
  readonly __typename?: 'ServiceCalendarMeetingTypeTemplate';
  /** Advisor profile ID */
  readonly advisorProfileId: Scalars['ID']['output'];
  /** Expected quarter for the meeting */
  readonly expectedQuarter: ServiceCalendarMeetingExpectedQuarter;
  readonly id: Scalars['ID']['output'];
  /** Unit for the automated meeting reminder */
  readonly sendAutomatedMeetingReminderUnit?: Maybe<ServiceCalendarMeetingDateUnit>;
  /** Value for the automated meeting reminder */
  readonly sendAutomatedMeetingReminderValue?: Maybe<Scalars['Int']['output']>;
  /** Unit for the automated meeting */
  readonly sendAutomatedMeetingUnit?: Maybe<ServiceCalendarMeetingDateUnit>;
  /** Value for the automated meeting */
  readonly sendAutomatedMeetingValue?: Maybe<Scalars['Int']['output']>;
  /** Template title */
  readonly title: Scalars['String']['output'];
};

/** Settings for a service on a client household Service Calendar. */
export type ServiceCalendarSetting = {
  readonly __typename?: 'ServiceCalendarSetting';
  readonly active: Scalars['Boolean']['output'];
  readonly byEndOfYear: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly q1: Scalars['Boolean']['output'];
  readonly q2: Scalars['Boolean']['output'];
  readonly q3: Scalars['Boolean']['output'];
  readonly q4: Scalars['Boolean']['output'];
  readonly required: Scalars['Boolean']['output'];
  readonly title: Scalars['String']['output'];
};

/** Settings for a service on a client household Service Calendar. */
export type ServiceCalendarSettingTemplate = {
  readonly __typename?: 'ServiceCalendarSettingTemplate';
  readonly active: Scalars['Boolean']['output'];
  readonly byEndOfYear: Scalars['Boolean']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly q1: Scalars['Boolean']['output'];
  readonly q2: Scalars['Boolean']['output'];
  readonly q3: Scalars['Boolean']['output'];
  readonly q4: Scalars['Boolean']['output'];
  readonly required?: Maybe<Scalars['Boolean']['output']>;
  readonly title: Scalars['String']['output'];
  readonly typeOf: Scalars['String']['output'];
};

/** Settings for a service on a client household Service Calendar. */
export type ServiceCalendarSettingTemplateInput = {
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly byEndOfYear?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly q1?: InputMaybe<Scalars['Boolean']['input']>;
  readonly q2?: InputMaybe<Scalars['Boolean']['input']>;
  readonly q3?: InputMaybe<Scalars['Boolean']['input']>;
  readonly q4?: InputMaybe<Scalars['Boolean']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Per-household outcome of enrolling a batch of households in one service */
export type ServiceCatalogEnrollmentResult = {
  readonly __typename?: 'ServiceCatalogEnrollmentResult';
  /**
   * The service already enrolling this household; null unless the status is
   * BLOCKED_BY_OTHER_SERVICE, and null on it too when the caller cannot read that
   * service — a blocking service can belong to another advisor group. Scalars
   * rather than the service object, which raises on a denied read instead of
   * nulling the field
   */
  readonly blockingServiceCatalogItemGroupId?: Maybe<Scalars['ID']['output']>;
  /**
   * Name of the service already enrolling this household, for the skip line; null
   * unless the status is BLOCKED_BY_OTHER_SERVICE, and null on it too when the
   * caller cannot read that service. Fall back to an unnamed 'another service'
   * line when it is null on a blocked result
   */
  readonly blockingServiceCatalogItemGroupName?: Maybe<Scalars['String']['output']>;
  /** Items of the service the household was newly activated on; 0 for every status other than ENROLLED */
  readonly enrolledItemCount: Scalars['Int']['output'];
  /** The household this outcome is for */
  readonly householdId: Scalars['ID']['output'];
  /**
   * Advisor-facing notice that this household failed; null unless the status is
   * FAILED. The underlying reason is logged, not returned
   */
  readonly message?: Maybe<Scalars['String']['output']>;
  /** Whether the household was enrolled, was already enrolled, was blocked by another service, or failed */
  readonly status: ServiceCatalogEnrollmentStatus;
};

/** Outcome of enrolling one household in one service */
export const ServiceCatalogEnrollmentStatus = {
  /** The household was already active on every item of the service; nothing changed */
  AlreadyEnrolled: 'ALREADY_ENROLLED',
  /**
   * The household is already enrolled in a different service and v3 allows only
   * one; nothing changed. The blocking service is named on the result
   */
  BlockedByOtherService: 'BLOCKED_BY_OTHER_SERVICE',
  /** The household landed on at least one item it was not already active on */
  Enrolled: 'ENROLLED',
  /** This attempt was rolled back for this household; whatever it was enrolled in before is unchanged */
  Failed: 'FAILED'
} as const;

export type ServiceCatalogEnrollmentStatus = typeof ServiceCatalogEnrollmentStatus[keyof typeof ServiceCatalogEnrollmentStatus];
/** A service catalog item — the template that generates recurring tasks/events for assigned households */
export type ServiceCatalogItem = {
  readonly __typename?: 'ServiceCatalogItem';
  /** Whether new tasks should be generated */
  readonly active: Scalars['Boolean']['output'];
  /** The advisor group that owns the item */
  readonly advisorGroup: AdvisorGroup;
  /** AfterPrevious cadence in days, if set */
  readonly afterPreviousOffsetDays?: Maybe<Scalars['Int']['output']>;
  /** When archived */
  readonly archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Cadence preset jsonb configuration */
  readonly cadencePreset?: Maybe<Scalars['JSON']['output']>;
  /** Optional calendly URL placeholder for email body */
  readonly calendlyLink?: Maybe<Scalars['String']['output']>;
  /** Created timestamp */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** User who created the item */
  readonly createdBy: User;
  /** User assigned by default */
  readonly defaultAssignee?: Maybe<User>;
  /** User ID assigned by default */
  readonly defaultAssigneeId?: Maybe<Scalars['ID']['output']>;
  /** Default priority 1-4 for generated tasks */
  readonly defaultPriority?: Maybe<Scalars['Int']['output']>;
  /** Long-form description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Email body template */
  readonly emailBody?: Maybe<Scalars['String']['output']>;
  /** Days before instance_date to dispatch email */
  readonly emailLeadTimeDays: Scalars['Int']['output'];
  /** HH:MM (24-hour) send time in advisor TZ; null = 9am default */
  readonly emailSendTimeOfDay?: Maybe<Scalars['String']['output']>;
  /** Email subject template */
  readonly emailSubject?: Maybe<Scalars['String']['output']>;
  /** ISO 8601 duration */
  readonly estimatedDuration?: Maybe<Scalars['String']['output']>;
  /** The item ID */
  readonly id: Scalars['ID']['output'];
  /** task or event */
  readonly itemType: Scalars['String']['output'];
  /** Display name */
  readonly name: Scalars['String']['output'];
  /** RRULE recurrence pattern ID, if set */
  readonly recurrencePatternId?: Maybe<Scalars['ID']['output']>;
  /** RRULE string from the associated recurrence pattern */
  readonly recurrencePatternRrule?: Maybe<Scalars['String']['output']>;
  /** Stop after this many forward reminders, when reminder_end_mode is count */
  readonly reminderEndCount: Scalars['Int']['output'];
  /** Stop this many days after the first email, when reminder_end_mode is days */
  readonly reminderEndDays: Scalars['Int']['output'];
  /** How the forward reminder schedule stops: count or days */
  readonly reminderEndMode: ServiceCatalogReminderEndMode;
  /** Days between forward reminders, counted from the first email; 0 = no reminders */
  readonly reminderIntervalDays: Scalars['Int']['output'];
  /** Days-before-occurrence offsets to send booking reminders (0 = day of) */
  readonly reminderOffsetsDays: ReadonlyArray<Scalars['Int']['output']>;
  /** Whether to dispatch email when due */
  readonly sendNotification: Scalars['Boolean']['output'];
  /** Whether to send booking reminders for unbooked Calendly events */
  readonly sendReminders: Scalars['Boolean']['output'];
  /** Whether the invite and booking reminders also go out as a text message */
  readonly sendTextNotification: Scalars['Boolean']['output'];
  /**
   * Services the item belongs to that the viewer can read, so a personal service
   * holding a shared item drops out of the list instead of failing the whole query
   * on the type-level deny.
   */
  readonly serviceCatalogItemGroups: ReadonlyArray<ServiceCatalogItemGroup>;
  /** Household assignments */
  readonly serviceCatalogItemHouseholds: ReadonlyArray<ServiceCatalogItemHousehold>;
  /** Updated timestamp */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Who can see generated items */
  readonly visibility: ServiceCatalogVisibility;
};

/** Attributes for creating or updating a ServiceCatalogItem */
export type ServiceCatalogItemAttributesInput = {
  /** Whether the item generates new tasks */
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  /** AfterPrevious cadence in days */
  readonly afterPreviousOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  /** Cadence preset jsonb configuration */
  readonly cadencePreset?: InputMaybe<Scalars['JSON']['input']>;
  /** Optional calendly URL */
  readonly calendlyLink?: InputMaybe<Scalars['String']['input']>;
  /** User assigned by default */
  readonly defaultAssigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** Default priority 1-4 */
  readonly defaultPriority?: InputMaybe<Scalars['Int']['input']>;
  /** Long-form description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Email body template */
  readonly emailBody?: InputMaybe<Scalars['String']['input']>;
  /** Days before due to dispatch email */
  readonly emailLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  /** HH:MM (24-hour) send time in advisor TZ; null = 9am default */
  readonly emailSendTimeOfDay?: InputMaybe<Scalars['String']['input']>;
  /** Email subject template */
  readonly emailSubject?: InputMaybe<Scalars['String']['input']>;
  /** ISO 8601 duration */
  readonly estimatedDuration?: InputMaybe<Scalars['String']['input']>;
  /** task or event */
  readonly itemType?: InputMaybe<Scalars['String']['input']>;
  /** Display name */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Attributes to create or replace the item's RecurrencePattern. Mutually exclusive with recurrence_pattern_id. */
  readonly recurrencePatternAttributes?: InputMaybe<RecurrencePatternAttributesInput>;
  /** Existing RRULE pattern ID */
  readonly recurrencePatternId?: InputMaybe<Scalars['ID']['input']>;
  /** Stop after this many forward reminders, when reminder_end_mode is count */
  readonly reminderEndCount?: InputMaybe<Scalars['Int']['input']>;
  /** Stop this many days after the first email, when reminder_end_mode is days */
  readonly reminderEndDays?: InputMaybe<Scalars['Int']['input']>;
  /** How the forward reminder schedule stops: count or days */
  readonly reminderEndMode?: InputMaybe<ServiceCatalogReminderEndMode>;
  /** Days between forward reminders, counted from the first email; 0 = no reminders */
  readonly reminderIntervalDays?: InputMaybe<Scalars['Int']['input']>;
  /** Days-before-occurrence offsets to send booking reminders (0 = day of) */
  readonly reminderOffsetsDays?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  /** Whether to send email when due */
  readonly sendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to send booking reminders for unbooked Calendly events */
  readonly sendReminders?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether to also text the invite and booking reminders. Only valid on an event
   * with a Calendly link and send_notification on.
   */
  readonly sendTextNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Visibility scope */
  readonly visibility?: InputMaybe<ServiceCatalogVisibility>;
};

/**
 * One item of a service as the editor should load it: the published row overlaid
 * with whatever unpublished edit is waiting in the buffer. Separate from
 * ServiceCatalogItem, whose fields keep meaning "live", so nothing that
 * materializes, sends or enrolls can read a draft value by accident
 */
export type ServiceCatalogItemDraftConfig = {
  readonly __typename?: 'ServiceCatalogItemDraftConfig';
  /** AfterPrevious cadence in days, if set */
  readonly afterPreviousOffsetDays?: Maybe<Scalars['Int']['output']>;
  /** Cadence preset jsonb configuration */
  readonly cadencePreset?: Maybe<Scalars['JSON']['output']>;
  /** Optional calendly URL placeholder for email body */
  readonly calendlyLink?: Maybe<Scalars['String']['output']>;
  /** User ID assigned by default */
  readonly defaultAssigneeId?: Maybe<Scalars['ID']['output']>;
  /** Long-form description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Email body template */
  readonly emailBody?: Maybe<Scalars['String']['output']>;
  /** Days before instance_date to dispatch email */
  readonly emailLeadTimeDays: Scalars['Int']['output'];
  /** HH:MM (24-hour) send time in advisor TZ; null = 9am default */
  readonly emailSendTimeOfDay?: Maybe<Scalars['String']['output']>;
  /** Email subject template */
  readonly emailSubject?: Maybe<Scalars['String']['output']>;
  /** The item ID. An item added but not yet published already has one */
  readonly id: Scalars['ID']['output'];
  /** task or event */
  readonly itemType: Scalars['String']['output'];
  /** Display name */
  readonly name: Scalars['String']['output'];
  /** RRULE string the draft cadence resolves to; null for an item with no recurrence pattern yet */
  readonly recurrencePatternRrule?: Maybe<Scalars['String']['output']>;
  /** Stop after this many forward reminders, when reminder_end_mode is count */
  readonly reminderEndCount: Scalars['Int']['output'];
  /** Stop this many days after the first email, when reminder_end_mode is days */
  readonly reminderEndDays: Scalars['Int']['output'];
  /** How the forward reminder schedule stops: count or days */
  readonly reminderEndMode: ServiceCatalogReminderEndMode;
  /** Days between forward reminders, counted from the first email; 0 = no reminders */
  readonly reminderIntervalDays: Scalars['Int']['output'];
  /** Days-before-occurrence offsets to send booking reminders (0 = day of) */
  readonly reminderOffsetsDays: ReadonlyArray<Scalars['Int']['output']>;
  /** Whether to dispatch email when due */
  readonly sendNotification: Scalars['Boolean']['output'];
  /** Whether to send booking reminders for unbooked Calendly events */
  readonly sendReminders: Scalars['Boolean']['output'];
  /** Whether the invite and booking reminders also go out as a text message */
  readonly sendTextNotification: Scalars['Boolean']['output'];
};

/** A named group of service catalog items */
export type ServiceCatalogItemGroup = {
  readonly __typename?: 'ServiceCatalogItemGroup';
  /** Owning advisor group */
  readonly advisorGroup: AdvisorGroup;
  /** Owning advisor group ID */
  readonly advisorGroupId: Scalars['ID']['output'];
  /** When archived */
  readonly archivedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Colour key for the service identity chip */
  readonly color: Scalars['String']['output'];
  /** Created timestamp */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** User who created the group */
  readonly createdBy: ServiceCreator;
  /** User who created the group */
  readonly createdById: Scalars['ID']['output'];
  /** Long-form description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /**
   * What the editor should load: the published rows overlaid with the waiting
   * edit. Equal to the live fields when nothing is waiting.
   */
  readonly draftConfig: ServiceCatalogItemGroupDraftConfig;
  /**
   * User IDs granted edit access on a team service; empty means everyone in the
   * owning scope can edit. Only editors still in the owning advisor group are
   * listed, so a deactivated member's row cannot come back on the next save as an
   * id the save itself refuses.
   */
  readonly editorIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Users CC'd on this template's automated emails */
  readonly emailCcUserIds: ReadonlyArray<Scalars['ID']['output']>;
  /** Users CC'd on this template's automated emails */
  readonly emailCcUsers: ReadonlyArray<User>;
  /**
   * Members of the advisor group that owns this service, selectable as its email
   * sender or CC. Resolved off the owning group rather than the viewer's, so an
   * org-wide service offers exactly the people the save accepts.
   */
  readonly emailIdentityCandidates: ReadonlyArray<ServiceEmailIdentity>;
  /** User whose name/email sends this template's automated emails */
  readonly emailSender?: Maybe<User>;
  /** User whose name/email sends this template's automated emails */
  readonly emailSenderId?: Maybe<Scalars['ID']['output']>;
  /**
   * Number of distinct households currently enrolled in this service — the
   * assignments unenrolling it would release: one naming this service, or one
   * naming none whose item only this live service still holds. Unlike
   * householdCount it is not derived from item overlap, so an item shared with
   * another live service does not inflate it, and it excludes paused assignments —
   * pausing is how unenrollment is recorded.
   */
  readonly enrolledHouseholdCount: Scalars['Int']['output'];
  /**
   * Households currently enrolled in this service, ordered by name. Scoped exactly
   * like enrolledHouseholdCount, so the editor's enrolled-households dialog and
   * its counter cannot disagree, which also means the list deliberately holds
   * households the viewer cannot read.
   */
  readonly enrolledHouseholds: ReadonlyArray<EnrolledHousehold>;
  /**
   * Whether an edit to this service is waiting to go live. While it is, the rows
   * every reader sees are still the published version, and nothing but publishing
   * applies the edit.
   */
  readonly hasUnpublishedChanges: Scalars['Boolean']['output'];
  /** Number of distinct households with at least one item from this group assigned */
  readonly householdCount: Scalars['Int']['output'];
  /** Icon key for the service identity chip */
  readonly icon: Scalars['String']['output'];
  /** The group ID */
  readonly id: Scalars['ID']['output'];
  /** Whether the group is the advisor group default */
  readonly isDefault: Scalars['Boolean']['output'];
  /**
   * When a household was most recently enrolled in this service, whether or not it
   * is still enrolled; null if never. Re-enrolling a household, or moving one here
   * from another service, counts as a new enrollment.
   */
  readonly lastEnrolledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * The largest offset setHouseholdScheduleOffset accepts on this service: one
   * month short of the shortest cadence among its active items, capped at 6. A
   * weekly or monthly item makes it 0, and an item without a recurrence rule does
   * not lower it. A service with no recurring item offers 0.
   */
  readonly maxScheduleOffsetMonths: Scalars['Int']['output'];
  /** Group name */
  readonly name: Scalars['String']['output'];
  /**
   * When the waiting edit was last written; null when none is waiting. Also the
   * value a save echoes back as expectedPendingChangesUpdatedAt to detect a
   * colliding edit.
   */
  readonly pendingChangesUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Who last wrote the waiting edit; null when none is waiting. */
  readonly pendingChangesUpdatedBy?: Maybe<User>;
  /**
   * Whether the viewer may promote this service into a globally-available Savvy
   * service template — admin-only, on an admin-authored service, and outside
   * development one that already lives in the Savvy organization. False for a
   * service that is already a Savvy template, for one that still holds an unpaused
   * enrollment — promotion is one-way and the source keeps materializing tasks and
   * email for those households — and on a read-only OAuth token.
   */
  readonly promotableToSavvy: Scalars['Boolean']['output'];
  /** When the group was last published */
  readonly publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Per-household count of the assignment rows unenrolling this service would
   * pause, for the households given. This is the unit
   * `UnenrollHouseholdsFromServiceCatalogItemGroup` budgets against, so a caller
   * batching a bulk unenroll can size its calls to the cap instead of guessing
   * from the items it can see — the owned set includes rows on items since removed
   * from the service and items since archived, which no client-visible field
   * exposes. Scoped to the households the unenroll mutation would accept from this
   * caller — the same AdvisorHouseholdPermissionChecker rule, inactive households
   * included — so the count never describes work the caller could not request; any
   * other household reports 0. Ids are returned in the order given, duplicates
   * collapsed, and an id that is not a number is refused rather than coerced into
   * a different household.
   */
  readonly removableAssignments: ReadonlyArray<HouseholdRemovableAssignments>;
  /** Membership rows */
  readonly serviceCatalogItemGroupMemberships: ReadonlyArray<ServiceCatalogItemGroupMembership>;
  /** Items in the group */
  readonly serviceCatalogItems: ReadonlyArray<ServiceCatalogItem>;
  /** When an advisor confirmed consent to text clients */
  readonly smsConsentAcknowledgedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Publish lifecycle status (draft or published) */
  readonly status: ServiceCatalogItemGroupStatus;
  /** Whether any advisor in the owning advisor group is set up to send texts */
  readonly textMessagingAvailable: Scalars['Boolean']['output'];
  /** Updated timestamp */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Whether the viewer may save changes to this service — the same decision
   * updateServiceCatalogItemGroup makes, so the editor renders read-only instead
   * of offering a save the server would refuse. False for advisors outside the
   * owning advisor group and organization, for read-only admins — including one
   * impersonating an owning advisor — and on a read-only OAuth token.
   */
  readonly viewerCanEdit: Scalars['Boolean']['output'];
  /** Who can see and run this service: private (its creator only) or firm (the owning advisor group or organization). */
  readonly visibility: ServiceCatalogItemGroupVisibility;
};


/** A named group of service catalog items */
export type ServiceCatalogItemGroupRemovableAssignmentsArgs = {
  householdIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Action an ACL entry grants on a service: edit */
export const ServiceCatalogItemGroupAclAction = {
  /** edit */
  Edit: 'edit'
} as const;

export type ServiceCatalogItemGroupAclAction = typeof ServiceCatalogItemGroupAclAction[keyof typeof ServiceCatalogItemGroupAclAction];
/** Grants a user an action (e.g. edit) on a service. */
export type ServiceCatalogItemGroupAclInput = {
  /** The action to grant. */
  readonly action: ServiceCatalogItemGroupAclAction;
  /** The user the action is granted to. */
  readonly userId: Scalars['ID']['input'];
};

/** Attributes for creating or updating a ServiceCatalogItemGroup */
export type ServiceCatalogItemGroupAttributesInput = {
  /** Colour key for the service identity chip */
  readonly color?: InputMaybe<Scalars['String']['input']>;
  /** Long-form description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Users (advisor-group members) CC'd on this template's automated emails */
  readonly emailCcUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** User (advisor-group member) whose name/email sends this template's automated emails */
  readonly emailSenderId?: InputMaybe<Scalars['ID']['input']>;
  /** Icon key for the service identity chip */
  readonly icon?: InputMaybe<Scalars['String']['input']>;
  /** Whether the group is the advisor group default */
  readonly isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Group name */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Set true to record that the acting user confirmed consent to text this template's enrolled clients */
  readonly smsConsentAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A service as the editor should load it: the published rows overlaid with
 * whatever unpublished edit is waiting in the buffer. Equal to the live values
 * when nothing is buffered. Access control, enrollment and the publish lifecycle
 * are not here — they are never buffered, so read them off the service
 */
export type ServiceCatalogItemGroupDraftConfig = {
  readonly __typename?: 'ServiceCatalogItemGroupDraftConfig';
  /** Colour key for the service identity chip */
  readonly color: Scalars['String']['output'];
  /** Long-form description */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Users CC'd on this service's automated emails */
  readonly emailCcUserIds: ReadonlyArray<Scalars['ID']['output']>;
  /** User whose name/email sends this service's automated emails */
  readonly emailSenderId?: Maybe<Scalars['ID']['output']>;
  /** Icon key for the service identity chip */
  readonly icon: Scalars['String']['output'];
  /**
   * The service's items in the order publishing would give them, including one
   * added but not yet published and excluding one removed but not yet published
   */
  readonly items: ReadonlyArray<ServiceCatalogItemDraftConfig>;
  /** Service name */
  readonly name: Scalars['String']['output'];
};

/** Join row associating a service catalog item with a group */
export type ServiceCatalogItemGroupMembership = {
  readonly __typename?: 'ServiceCatalogItemGroupMembership';
  /** Created timestamp */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The membership ID */
  readonly id: Scalars['ID']['output'];
  /** Member item */
  readonly serviceCatalogItem: ServiceCatalogItem;
  /** Parent group */
  readonly serviceCatalogItemGroup: ServiceCatalogItemGroup;
  /** Group ID */
  readonly serviceCatalogItemGroupId: Scalars['ID']['output'];
  /** Catalog item ID */
  readonly serviceCatalogItemId: Scalars['ID']['output'];
  /** Display order within the group */
  readonly sortOrder: Scalars['Int']['output'];
  /** Updated timestamp */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Publish lifecycle status of a service catalog item group */
export const ServiceCatalogItemGroupStatus = {
  Draft: 'draft',
  Published: 'published'
} as const;

export type ServiceCatalogItemGroupStatus = typeof ServiceCatalogItemGroupStatus[keyof typeof ServiceCatalogItemGroupStatus];
/** Who can see and run a service: private (its creator only) or firm (the owning advisor group or organization) */
export const ServiceCatalogItemGroupVisibility = {
  /** firm */
  Firm: 'firm',
  /** private */
  Private: 'private'
} as const;

export type ServiceCatalogItemGroupVisibility = typeof ServiceCatalogItemGroupVisibility[keyof typeof ServiceCatalogItemGroupVisibility];
/** Join between a service catalog item and a household it is assigned to */
export type ServiceCatalogItemHousehold = {
  readonly __typename?: 'ServiceCatalogItemHousehold';
  /** When the assignment was made */
  readonly assignedAt: Scalars['ISO8601DateTime']['output'];
  /** User who created the assignment */
  readonly assignedBy: User;
  /** User who created the assignment */
  readonly assignedById: Scalars['ID']['output'];
  /** Created timestamp */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Booking for the next upcoming meeting occurrence, else the most recent past occurrence. */
  readonly currentMeetingBooking?: Maybe<MeetingBooking>;
  /**
   * True when the next occurrence's first email has already gone out (forward
   * scheduling only), so its date can no longer be moved
   */
  readonly firstEmailSent: Scalars['Boolean']['output'];
  /** The assigned household */
  readonly household: Household;
  /** Assigned household ID */
  readonly householdId: Scalars['ID']['output'];
  /** The row ID */
  readonly id: Scalars['ID']['output'];
  /** When this assignment was last marked done */
  readonly lastCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the reminder email was last sent for this assignment */
  readonly lastReminderSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Most recent occurrence completed or skipped on this assignment, from any surface. */
  readonly lastResolvedOccurrence?: Maybe<ResolvedOccurrence>;
  /** Next scheduled occurrence after now, or nil when paused / no future occurrence is scheduled. */
  readonly nextOccurrence?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Per-assignment overrides */
  readonly overrides: ReadonlyArray<ServiceCatalogItemHouseholdOverride>;
  /** When true, assignment is soft-disabled */
  readonly paused: Scalars['Boolean']['output'];
  /** The parent catalog item */
  readonly serviceCatalogItem: ServiceCatalogItem;
  /** The service (template) this enrollment came from */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
  /** Service (template) this enrollment came from; null for rows the backfill could not resolve */
  readonly serviceCatalogItemGroupId?: Maybe<Scalars['ID']['output']>;
  /** Parent catalog item ID */
  readonly serviceCatalogItemId: Scalars['ID']['output'];
  /** Display order within a household's service list */
  readonly sortOrder: Scalars['Int']['output'];
  /** Updated timestamp */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Per-assignment override of a service catalog item for a household */
export type ServiceCatalogItemHouseholdOverride = {
  readonly __typename?: 'ServiceCatalogItemHouseholdOverride';
  /** Created timestamp */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Override ID */
  readonly id: Scalars['ID']['output'];
  /** Whether the occurrence should be skipped */
  readonly isSkipped: Scalars['Boolean']['output'];
  /** Override occurrence date */
  readonly overrideDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Override RRULE dtstart */
  readonly overrideDtstart?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Override email body for the occurrence */
  readonly overrideEmailBody?: Maybe<Scalars['String']['output']>;
  /** Override email subject for the occurrence */
  readonly overrideEmailSubject?: Maybe<Scalars['String']['output']>;
  /** Override RRULE string */
  readonly overrideRrule?: Maybe<Scalars['String']['output']>;
  /** Parent catalog item */
  readonly serviceCatalogItem: ServiceCatalogItem;
  /** Parent assignment */
  readonly serviceCatalogItemHousehold: ServiceCatalogItemHousehold;
  /** Parent assignment ID */
  readonly serviceCatalogItemHouseholdId: Scalars['ID']['output'];
  /** Parent catalog item ID */
  readonly serviceCatalogItemId: Scalars['ID']['output'];
  /** Updated timestamp */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** One item of a service save: an update when id is given, a create when it is null */
export type ServiceCatalogItemSaveInput = {
  /** Item attributes */
  readonly attributes: ServiceCatalogItemAttributesInput;
  /** Existing item id; null creates a new item */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
};

/** How a forward reminder schedule stops: after a number of reminders, or after a number of days */
export const ServiceCatalogReminderEndMode = {
  Count: 'count',
  Days: 'days'
} as const;

export type ServiceCatalogReminderEndMode = typeof ServiceCatalogReminderEndMode[keyof typeof ServiceCatalogReminderEndMode];
/** Per-household outcome of unenrolling a batch of households from one service */
export type ServiceCatalogUnenrollmentResult = {
  readonly __typename?: 'ServiceCatalogUnenrollmentResult';
  /** The household this outcome is for */
  readonly householdId: Scalars['ID']['output'];
  /**
   * Advisor-facing notice that this household failed; null unless the status is
   * FAILED. The underlying reason is logged, not returned
   */
  readonly message?: Maybe<Scalars['String']['output']>;
  /** Whether the household was unenrolled, was not enrolled, or failed */
  readonly status: ServiceCatalogUnenrollmentStatus;
  /** Enrollments in the service that were paused (0 when the household was not enrolled) */
  readonly unenrolledItemCount: Scalars['Int']['output'];
};

/** Outcome of unenrolling one household from one service */
export const ServiceCatalogUnenrollmentStatus = {
  /** Unenrollment was rolled back for this household; its enrollments are unchanged */
  Failed: 'FAILED',
  /** The household had no active enrollment in the service; nothing changed */
  NotEnrolled: 'NOT_ENROLLED',
  /** At least one active enrollment in the service was paused */
  Unenrolled: 'UNENROLLED'
} as const;

export type ServiceCatalogUnenrollmentStatus = typeof ServiceCatalogUnenrollmentStatus[keyof typeof ServiceCatalogUnenrollmentStatus];
/** Visibility level for a service catalog item */
export const ServiceCatalogVisibility = {
  Creator: 'creator',
  Firm: 'firm',
  Team: 'team'
} as const;

export type ServiceCatalogVisibility = typeof ServiceCatalogVisibility[keyof typeof ServiceCatalogVisibility];
/**
 * Name and photo of the user who created a service — what a created-by cell
 * renders. Readable by anyone who can read the service itself: unlike Models::User
 * it carries no AdvisorPolicy check, which authorizes by shared advisor group and
 * so would deny (and, because an unauthorized object raises, fail the whole query
 * for) an org-wide service created by an advisor in another group.
 */
export type ServiceCreator = {
  readonly __typename?: 'ServiceCreator';
  /** First name */
  readonly firstName: Scalars['String']['output'];
  /** Display name (first + last) */
  readonly fullName: Scalars['String']['output'];
  /** The creator's user id */
  readonly id: Scalars['ID']['output'];
  /** Last name */
  readonly lastName: Scalars['String']['output'];
  /** Photo URL; null falls back to initials */
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
};

/** AI-drafted email subject + body for a service calendar event. */
export type ServiceEmailDraft = {
  readonly __typename?: 'ServiceEmailDraft';
  /** Drafted email body; null on failure. */
  readonly body?: Maybe<Scalars['String']['output']>;
  /** False when generation failed; the FE shows a graceful error. */
  readonly generated: Scalars['Boolean']['output'];
  /** Drafted subject line; null on failure. */
  readonly subject?: Maybe<Scalars['String']['output']>;
};

/**
 * A person selectable as the sender of, or a CC on, a service's automated emails —
 * a member of the advisor group that owns the service, which is the set the save
 * validates against. Scalars rather than Models::User: an org-wide service can be
 * owned by another advisor group, whose members AdvisorPolicy denies, and a denied
 * object raises rather than nulls — that would fail the whole editor query.
 */
export type ServiceEmailIdentity = {
  readonly __typename?: 'ServiceEmailIdentity';
  /** First name */
  readonly firstName: Scalars['String']['output'];
  /** Display name (first + last) */
  readonly fullName: Scalars['String']['output'];
  /** The user id */
  readonly id: Scalars['ID']['output'];
  /** Last name */
  readonly lastName: Scalars['String']['output'];
  /** Photo URL; null falls back to initials */
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
};

/** A group of tasks sharing the same service catalog item and occurrence date (2+ households) */
export type ServiceItemGroupOccurrence = {
  readonly __typename?: 'ServiceItemGroupOccurrence';
  /** Distinct households across the group's tasks */
  readonly householdCount: Scalars['Int']['output'];
  /** Synthetic id: "sourceCatalogItemId|occurrenceDate" (ISO8601 date or "no-date") */
  readonly id: Scalars['ID']['output'];
  /** Earliest `due_at` across the group's tasks */
  readonly nextDueAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Bucket date in the viewer's timezone (null when none of the tasks have a due date) */
  readonly occurrenceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Most common assignee across the group, tie-broken by earliest due */
  readonly primaryAssignee?: Maybe<User>;
  /** The service catalog item all tasks in this group belong to */
  readonly sourceCatalogItem: ServiceCatalogItem;
  /** Counts of tasks by display status */
  readonly statusCounts: ServiceItemStatusCounts;
  /** The underlying task rows, in walk order */
  readonly tasks: ReadonlyArray<Task>;
};

/** Historical service calendar v1 item instance for export */
export type ServiceItemInstance = {
  readonly __typename?: 'ServiceItemInstance';
  readonly completionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly dueDate: Scalars['ISO8601DateTime']['output'];
  readonly status: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
};

/** A display item in the SC v2 tasks list: either a multi-household group or a single flat task */
export type ServiceItemOccurrence = FlatTaskOccurrence | ServiceItemGroupOccurrence;

/** The connection type for ServiceItemOccurrence. */
export type ServiceItemOccurrenceConnection = {
  readonly __typename?: 'ServiceItemOccurrenceConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ServiceItemOccurrenceEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<ServiceItemOccurrence>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ServiceItemOccurrenceEdge = {
  readonly __typename?: 'ServiceItemOccurrenceEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ServiceItemOccurrence>;
};

/** Counts of tasks by display status within a service-item occurrence group */
export type ServiceItemStatusCounts = {
  readonly __typename?: 'ServiceItemStatusCounts';
  /** Tasks with `cancelled` status */
  readonly cancelled: Scalars['Int']['output'];
  /** Tasks with `done` status */
  readonly done: Scalars['Int']['output'];
  /** Tasks with `in_progress` status */
  readonly inProgress: Scalars['Int']['output'];
  /** Open todo tasks whose `due_at` is in the past */
  readonly overdue: Scalars['Int']['output'];
  /** Tasks with `todo` status that are not overdue */
  readonly todo: Scalars['Int']['output'];
};

/** The timeline interaction an advisor recorded as having satisfied this occurrence */
export type ServiceOccurrenceInteractionLink = {
  readonly __typename?: 'ServiceOccurrenceInteractionLink';
  /** The linked interaction's id */
  readonly itemId: Scalars['ID']['output'];
  /** The linked interaction's type */
  readonly itemType: ItemTypeEnum;
  /** When the interaction happened — the date this occurrence is completed as of */
  readonly occurredAt: Scalars['ISO8601DateTime']['output'];
  /** Display label for the interaction */
  readonly title: Scalars['String']['output'];
};

/** A household row for the Service schedules tab, resolved in bulk without per-object authorization */
export type ServiceScheduleRow = {
  readonly __typename?: 'ServiceScheduleRow';
  /** Primary advisor first name */
  readonly advisorFirstName?: Maybe<Scalars['String']['output']>;
  /** Primary advisor last name */
  readonly advisorLastName?: Maybe<Scalars['String']['output']>;
  /** Primary advisor profile picture URL */
  readonly advisorProfilePicUrl?: Maybe<Scalars['String']['output']>;
  /** Household id */
  readonly id: Scalars['ID']['output'];
  /** Last contact timestamp */
  readonly lastContactAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Meeting follow-up status: 'not_scheduled' (passed meeting never
   * booked/canceled), 'scheduled' (has a booked meeting), or null
   */
  readonly meetingStatus?: Maybe<Scalars['String']['output']>;
  /** Name of the service item driving the meeting status */
  readonly meetingStatusItemName?: Maybe<Scalars['String']['output']>;
  /** Occurrence date driving the meeting status */
  readonly meetingStatusOccurrenceAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Household name */
  readonly name: Scalars['String']['output'];
  /** Display-only household tags */
  readonly tags: ReadonlyArray<ServiceScheduleTag>;
  /** Public-facing household UUID (route target) */
  readonly uuid: Scalars['String']['output'];
};

/** Display-only household tag (name + category color) for the Service schedules list */
export type ServiceScheduleTag = {
  readonly __typename?: 'ServiceScheduleTag';
  /** Category color */
  readonly hexColorCode?: Maybe<Scalars['String']['output']>;
  /** HouseholdTag id */
  readonly id: Scalars['ID']['output'];
  /** Organization household tag name */
  readonly name?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SetAccountConnectionReminderPreference */
export type SetAccountConnectionReminderPreferenceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the reminder should be disabled for this household. */
  readonly disabled: Scalars['Boolean']['input'];
  /** The ID of the household to update. */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of SetAccountConnectionReminderPreference. */
export type SetAccountConnectionReminderPreferencePayload = {
  readonly __typename?: 'SetAccountConnectionReminderPreferencePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new reminder-disabled state for the household. */
  readonly disabled: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetActivityEntryPinned */
export type SetActivityEntryPinnedInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the activity timeline entry to pin or unpin */
  readonly id: Scalars['ID']['input'];
  /** True to pin the entry, false to unpin it */
  readonly isPinned: Scalars['Boolean']['input'];
};

/** Autogenerated return type of SetActivityEntryPinned. */
export type SetActivityEntryPinnedPayload = {
  readonly __typename?: 'SetActivityEntryPinnedPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated activity timeline entry */
  readonly entry: Entry;
};

/** Autogenerated input type of SetAdvisorTierLevelByIdentity */
export type SetAdvisorTierLevelByIdentityInput = {
  /** Expected advisor name */
  readonly advisorName: Scalars['String']['input'];
  /** Advisor user ID */
  readonly advisorUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Expected advisor email */
  readonly email: Scalars['String']['input'];
  /** Advisor-tier level to set */
  readonly level: AdvisorTierLevel;
};

/** Autogenerated return type of SetAdvisorTierLevelByIdentity. */
export type SetAdvisorTierLevelByIdentityPayload = {
  readonly __typename?: 'SetAdvisorTierLevelByIdentityPayload';
  /** Verified advisor name */
  readonly advisorName: Scalars['String']['output'];
  /** Verified advisor user ID */
  readonly advisorUserId: Scalars['ID']['output'];
  /** Whether this call changed the level */
  readonly changed: Scalars['Boolean']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Verified advisor email */
  readonly email: Scalars['String']['output'];
  /** Resulting advisor-tier level */
  readonly level: AdvisorTierLevel;
  /** Whether the requested level is in effect */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetAdvisorTierLevel */
export type SetAdvisorTierLevelInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The advisor-tier level to set. */
  readonly level: AdvisorTierLevel;
  /** The advisor-tier team member whose level to set. */
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetAdvisorTierLevel. */
export type SetAdvisorTierLevelPayload = {
  readonly __typename?: 'SetAdvisorTierLevelPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The team member with the updated level. */
  readonly user: User;
};

/** Autogenerated input type of SetClientIncomeSources */
export type SetClientIncomeSourcesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Database ID of the client profile */
  readonly clientProfileId: Scalars['ID']['input'];
  /** The complete set of income sources, in display order. Rows absent from this list are soft-deleted. */
  readonly incomeSources: ReadonlyArray<ClientIncomeSourceInput>;
};

/** Autogenerated return type of SetClientIncomeSources. */
export type SetClientIncomeSourcesPayload = {
  readonly __typename?: 'SetClientIncomeSourcesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated client profile */
  readonly clientProfile: Client;
};

/** Autogenerated input type of SetContactAccountRelation */
export type SetContactAccountRelationInput = {
  readonly accountId: Scalars['ID']['input'];
  readonly beneficiaryPercentage?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contactId: Scalars['ID']['input'];
  readonly relationType: ContactRelationTypeName;
};

/** Autogenerated return type of SetContactAccountRelation. */
export type SetContactAccountRelationPayload = {
  readonly __typename?: 'SetContactAccountRelationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetContactHouseholdConnection */
export type SetContactHouseholdConnectionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the contact */
  readonly contactId: Scalars['ID']['input'];
  /** The household the contact depends on, when is_dependent is true */
  readonly dependentOfHouseholdId?: InputMaybe<Scalars['ID']['input']>;
  /** The client on this household the contact depends on, when is_dependent is true */
  readonly dependentOfUserId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the household */
  readonly householdId: Scalars['ID']['input'];
  /** Beneficiary of this household. Omit to leave it as stored */
  readonly isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Dependent in this household. Sending this makes dependentOfHouseholdId and
   * dependentOfUserId authoritative: a named target replaces the stored one and an
   * omitted pair clears it. Omit all three to leave the dependency untouched
   */
  readonly isDependent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Trusted contact of this household. Omit to leave it as stored */
  readonly isTrustedContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Leave the stored relationship as it is, for an older free-text one the relationship choices cannot show */
  readonly keepRelationship?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the contact is a member of the household */
  readonly member: Scalars['Boolean']['input'];
  /** Role toward the household when serves is true */
  readonly professionalRole?: InputMaybe<ProfessionalRelationshipRole>;
  /** Free-text role toward the household when serves is true. Takes the place of professionalRole; a blank one clears the role */
  readonly professionalRoleLabel?: InputMaybe<Scalars['String']['input']>;
  /** Relationship to the household when member is true */
  readonly relationship?: InputMaybe<BeneficiaryRelationship>;
  /** Whether the professional contact serves the household */
  readonly serves: Scalars['Boolean']['input'];
  /** The month the professional started working with the household, when serves is true. Omit to leave it as stored */
  readonly startedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of SetContactHouseholdConnection. */
export type SetContactHouseholdConnectionPayload = {
  readonly __typename?: 'SetContactHouseholdConnectionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** True once the connection is saved */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetGovernmentId */
export type SetGovernmentIdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly expirationDate: Scalars['String']['input'];
  /** Optional - The GovernmentId model id */
  readonly id?: InputMaybe<Scalars['String']['input']>;
  /** The number on the client's actual ID */
  readonly idNumber: Scalars['String']['input'];
  readonly issueDate: Scalars['String']['input'];
  readonly issuingAuthority?: InputMaybe<Scalars['String']['input']>;
  readonly type: Scalars['String']['input'];
};

/** Autogenerated return type of SetGovernmentId. */
export type SetGovernmentIdPayload = {
  readonly __typename?: 'SetGovernmentIdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly governmentId?: Maybe<GovernmentId>;
};

/** Autogenerated input type of SetHouseholdBenchmark */
export type SetHouseholdBenchmarkInput = {
  /** Orion benchmark key(s) to assign, e.g. "191531_P" or "489_B,202_B". */
  readonly benchmarkValue: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to update. */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetHouseholdBenchmark. */
export type SetHouseholdBenchmarkPayload = {
  readonly __typename?: 'SetHouseholdBenchmarkPayload';
  /** The benchmark value that was set. */
  readonly benchmarkValue: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SetHouseholdScheduleOffset */
export type SetHouseholdScheduleOffsetInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An enrolled household */
  readonly householdId: Scalars['ID']['input'];
  /** Months to push the household's dates out by; 0 puts it back on time. At most the service's maxScheduleOffsetMonths */
  readonly offsetMonths: Scalars['Int']['input'];
  /** The service whose schedule the household is offset on */
  readonly serviceCatalogItemGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetHouseholdScheduleOffset. */
export type SetHouseholdScheduleOffsetPayload = {
  readonly __typename?: 'SetHouseholdScheduleOffsetPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The household whose offset was set */
  readonly householdId: Scalars['ID']['output'];
  /** The household's offset on this service after the call */
  readonly offsetMonths: Scalars['Int']['output'];
};

/** Autogenerated input type of SetServiceCatalogItemHouseholdNextOccurrence */
export type SetServiceCatalogItemHouseholdNextOccurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Assignment id */
  readonly id: Scalars['ID']['input'];
  /** The new next-occurrence date */
  readonly nextOccurrence: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of SetServiceCatalogItemHouseholdNextOccurrence. */
export type SetServiceCatalogItemHouseholdNextOccurrencePayload = {
  readonly __typename?: 'SetServiceCatalogItemHouseholdNextOccurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created or updated override */
  readonly serviceCatalogItemHouseholdOverride: ServiceCatalogItemHouseholdOverride;
};

/** Autogenerated input type of SetServiceOccurrenceEmail */
export type SetServiceOccurrenceEmailInput = {
  /** The body for this occurrence only */
  readonly body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Typed occurrence id, as returned by householdServiceOccurrences */
  readonly id: Scalars['ID']['input'];
  /** The occurrence's `revision` as read. The write is refused when the row has changed since */
  readonly revision: Scalars['String']['input'];
  /** The subject line for this occurrence only */
  readonly subject: Scalars['String']['input'];
};

/** Autogenerated return type of SetServiceOccurrenceEmail. */
export type SetServiceOccurrenceEmailPayload = {
  readonly __typename?: 'SetServiceOccurrenceEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The occurrence after the write, or null once it no longer belongs to the household stream */
  readonly occurrence?: Maybe<HouseholdServiceOccurrence>;
};

/** Autogenerated input type of SetSwimLoanLengthOptions */
export type SetSwimLoanLengthOptionsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Full ordered set of options; replaces the stored list */
  readonly options: ReadonlyArray<SwimLoanLengthOptionInput>;
};

/** Autogenerated return type of SetSwimLoanLengthOptions. */
export type SetSwimLoanLengthOptionsPayload = {
  readonly __typename?: 'SetSwimLoanLengthOptionsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
  /** The stored options after the write, in order */
  readonly swimLoanLengthOptions: ReadonlyArray<SwimLoanLengthOption>;
};

/** Autogenerated input type of SetSwimStrategies */
export type SetSwimStrategiesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Full ordered set of strategies; replaces the stored list */
  readonly strategies: ReadonlyArray<SwimStrategyInput>;
};

/** Autogenerated return type of SetSwimStrategies. */
export type SetSwimStrategiesPayload = {
  readonly __typename?: 'SetSwimStrategiesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
  /** The stored strategies after the write, in order */
  readonly swimStrategies: ReadonlyArray<SwimStrategy>;
};

/** Autogenerated input type of SetTaskRecurrence */
export type SetTaskRecurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Recurrence configuration */
  readonly recurrence: RecurrenceInput;
  /** The Savvy task ID (UUID) */
  readonly taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetTaskRecurrence. */
export type SetTaskRecurrencePayload = {
  readonly __typename?: 'SetTaskRecurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The updated task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of SetUpAdvisorOrganization */
export type SetUpAdvisorOrganizationInput = {
  /** User IDs of advisors to add to the team */
  readonly advisorUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Turn org branding on (creates the branding row). Omit/null defers branding_enabled to the LD default (HAWK-819). */
  readonly enableBranding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Team / firm name, used for both the organization and the advisor group */
  readonly name: Scalars['String']['input'];
};

/** Autogenerated return type of SetUpAdvisorOrganization. */
export type SetUpAdvisorOrganizationPayload = {
  readonly __typename?: 'SetUpAdvisorOrganizationPayload';
  /** The created advisor group */
  readonly advisorGroup?: Maybe<AdvisorGroup>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** The created organization */
  readonly organization?: Maybe<Organization>;
  /** Whether the setup succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SetupTaskReminders */
export type SetupTaskRemindersInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly taskId: Scalars['ID']['input'];
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetupTaskReminders. */
export type SetupTaskRemindersPayload = {
  readonly __typename?: 'SetupTaskRemindersPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ShareHouseholdWithAdvisorGroup */
export type ShareHouseholdWithAdvisorGroupInput = {
  readonly advisorGroupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of ShareHouseholdWithAdvisorGroup. */
export type ShareHouseholdWithAdvisorGroupPayload = {
  readonly __typename?: 'ShareHouseholdWithAdvisorGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SharePublishedReport */
export type SharePublishedReportInput = {
  /** When true and not yet surfaced, stamps added_to_portal_at so the client can see it. */
  readonly addToPortal: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional expiry datetime. Null leaves the report without an expiration. */
  readonly expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** UUID of the published report to share. */
  readonly publishedReportId: Scalars['ID']['input'];
  /** Display title the client sees in their portal. */
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of SharePublishedReport. */
export type SharePublishedReportPayload = {
  readonly __typename?: 'SharePublishedReportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The report after sharing. */
  readonly publishedReport: PublishedReportSummary;
};

/** Autogenerated input type of ShareRetirementPlanWithOrganization */
export type ShareRetirementPlanWithOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The organization to share the plan with */
  readonly organizationId: Scalars['ID']['input'];
  /** The plan to share */
  readonly retirementPlanId: Scalars['ID']['input'];
  /** full (3(38), default) | simple */
  readonly sharingMode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ShareRetirementPlanWithOrganization. */
export type ShareRetirementPlanWithOrganizationPayload = {
  readonly __typename?: 'ShareRetirementPlanWithOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated plan */
  readonly retirementPlan?: Maybe<RetirementPlan>;
};

export type ShareableOrganization = {
  readonly __typename?: 'ShareableOrganization';
  /** Full names of this organization's advisors and assistants, shown when choosing who to share a plan with */
  readonly advisorNames: ReadonlyArray<Scalars['String']['output']>;
  /** Database ID */
  readonly id: Scalars['ID']['output'];
  /** Organization name */
  readonly name: Scalars['String']['output'];
  /**
   * full (3(38)) | simple — set only when this organization is returned from a
   * retirement plan share (null when browsing shareable organizations)
   */
  readonly sharingMode?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SignTaxAddendum */
export type SignTaxAddendumInput = {
  /** Attestations the user agreed to before signing */
  readonly attestations?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** True to sign as primary client, false to sign as co-client (of current user's household) */
  readonly isPrimaryClient: Scalars['Boolean']['input'];
  /** The signature value, usually the client's name */
  readonly value: Scalars['String']['input'];
};

/** Autogenerated return type of SignTaxAddendum. */
export type SignTaxAddendumPayload = {
  readonly __typename?: 'SignTaxAddendumPayload';
  /** The client agreement record */
  readonly clientAgreement?: Maybe<ClientAgreement>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the created signature */
  readonly signatureId: Scalars['ID']['output'];
};

export const SignUpError = {
  UnexpectedError: 'unexpected_error',
  UserMustAcceptTos: 'user_must_accept_tos'
} as const;

export type SignUpError = typeof SignUpError[keyof typeof SignUpError];
/** Autogenerated input type of SignUpForSavvy */
export type SignUpForSavvyInput = {
  readonly acceptedTos: Scalars['Boolean']['input'];
  /** The lead source category. Must be one of Query.leadSources */
  readonly advisorLeadSource?: InputMaybe<Scalars['String']['input']>;
  /** The dependent lead source detail. Must be one of the details the chosen category offers */
  readonly advisorLeadSourceDetail?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  /**
   * Unused: never reached the household.
   * @deprecated Never persisted. Lead source specifics now live in advisorLeadSourceDetail.
   */
  readonly otherLeadSource?: InputMaybe<Scalars['String']['input']>;
  readonly referralSourceEmail?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the center of influence rep that referred the user */
  readonly utmCampaign?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SignUpForSavvy. */
export type SignUpForSavvyPayload = {
  readonly __typename?: 'SignUpForSavvyPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly softError?: Maybe<SignUpError>;
};

/** A DocuSign anchor-bound signer tab on a pre-filled IWS/Schwab app PDF */
export type SignerTabInput = {
  /** Anchor string stamped into the filled PDF (e.g. \sig_personal_primary\) */
  readonly anchorString: Scalars['String']['input'];
  /** Pixel x-offset from the anchor when DocuSign places the tab */
  readonly anchorXOffset?: InputMaybe<Scalars['Int']['input']>;
  /** Pixel y-offset from the anchor when DocuSign places the tab */
  readonly anchorYOffset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Conditional flag: always | co_client_only | joint_only | trust_co_trustee_only
   * | trust_third_trustee_only | ach_present_only
   */
  readonly condition?: InputMaybe<Scalars['String']['input']>;
  /**
   * DocuSign 1-indexed page number that scopes the anchor search to a single page.
   * Optional during the HAWK-167 FE rollout; absent values fall back to the legacy
   * whole-document scan.
   */
  readonly pageNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Signer role: primary_client | co_client | trustee_primary | trustee_co | trustee_third | inheritor | advisor */
  readonly signerRole: Scalars['String']['input'];
  /** DocuSign tab type: signHere | dateSigned */
  readonly tabType: Scalars['String']['input'];
};

/** Tasks that only require the base set of fields. Not tasks that require complex data, e.g. onboarding tasks. */
export const SimpleTaskTypeName = {
  AccountMaintenance: 'account_maintenance',
  AccountSetup: 'account_setup',
  ClientInfoChange: 'client_info_change',
  ClientOther: 'client_other',
  FinancialPlanning: 'financial_planning',
  InitialIntakeForm: 'initial_intake_form',
  InvestmentManagementDirectIndexing: 'investment_management_direct_indexing',
  MoneyMovementRequest: 'money_movement_request',
  OnboardingFlow: 'onboarding_flow',
  Other: 'other',
  OtherInvestmentTask: 'other_investment_task',
  PreReviewCheckIn: 'pre_review_check_in',
  RejectedFee: 'rejected_fee',
  RiskQuestionnaire: 'risk_questionnaire',
  SelfReminder: 'self_reminder',
  TransitionAnalysis: 'transition_analysis'
} as const;

export type SimpleTaskTypeName = typeof SimpleTaskTypeName[keyof typeof SimpleTaskTypeName];
/** Autogenerated input type of SkipServiceOccurrence */
export type SkipServiceOccurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Typed occurrence id, as returned by householdServiceOccurrences */
  readonly id: Scalars['ID']['input'];
  /** The occurrence's `revision` as read. The write is refused when the row has changed since */
  readonly revision: Scalars['String']['input'];
};

/** Autogenerated return type of SkipServiceOccurrence. */
export type SkipServiceOccurrencePayload = {
  readonly __typename?: 'SkipServiceOccurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The occurrence after the write, or null once it no longer belongs to the household stream */
  readonly occurrence?: Maybe<HouseholdServiceOccurrence>;
};

/** Performance breakdown for a specific account sleeve within an account. */
export type SleevePerformanceBreakdown = {
  readonly __typename?: 'SleevePerformanceBreakdown';
  /** The custodial account number of the sleeve */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /** The Savvy account sleeve ID */
  readonly accountSleeveId: Scalars['ID']['output'];
  /** Sleeve-scoped holdings. Returns are since-sleeve-inception, not calendar-YTD. */
  readonly holdings?: Maybe<ReadonlyArray<ReportedHolding>>;
  /** Performance data for this sleeve across time periods */
  readonly performanceOverTime: ReadonlyArray<Performance>;
  /** The display name of the sleeve */
  readonly sleeveName?: Maybe<Scalars['String']['output']>;
  /** The name of the strategy the sleeve is enrolled in */
  readonly strategyName?: Maybe<Scalars['String']['output']>;
};

/** A text message log entry representing an SMS between an advisor and a client */
export type SmsLog = {
  readonly __typename?: 'SmsLog';
  /** The advisor profile associated with this SMS log. */
  readonly advisorProfile: Advisor;
  /** The client profile associated with this SMS log. */
  readonly clientProfile: Client;
  /** The client profile ID associated with this SMS log. */
  readonly clientProfileId: Scalars['ID']['output'];
  /** Content of the text message. */
  readonly content: Scalars['String']['output'];
  /** Timestamp when the SMS log was created in Savvy. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The date and time when the SMS was sent or received. */
  readonly date: Scalars['ISO8601DateTime']['output'];
  /** Direction of the message: inbound or outbound. */
  readonly direction?: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the SMS log. */
  readonly id: Scalars['ID']['output'];
  /** The phone number the message was sent to or received from. */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the SMS log was last updated in Savvy. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Sort direction */
export const SortDirection = {
  /** Ascending */
  Asc: 'ASC',
  /** Descending */
  Desc: 'DESC'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];
/** Information about the source account for account opening transfers */
export type SourceAccountInput = {
  /** Source account name */
  readonly accountName: Scalars['String']['input'];
  /** Source account number */
  readonly accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Source account type (optional) */
  readonly accountType?: InputMaybe<Scalars['String']['input']>;
  /** Name of the firm holding the source account */
  readonly firmName: Scalars['String']['input'];
  /** If the source account has multiple accounts */
  readonly hasMultipleSourceAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the source account has mutual funds */
  readonly hasMutualFunds?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source account registration type */
  readonly registrationType: SourceAccountRegistrationTypeName;
  /** Source account registration type when Other is selected */
  readonly registrationTypeOther?: InputMaybe<Scalars['String']['input']>;
};

/** Registration types for source accounts */
export const SourceAccountRegistrationTypeName = {
  /** individual */
  Individual: 'individual',
  /** inherited_ira */
  InheritedIra: 'inherited_ira',
  /** joint_tenants_with_rights_of_survivorship */
  JointTenantsWithRightsOfSurvivorship: 'joint_tenants_with_rights_of_survivorship',
  /** other */
  Other: 'other',
  /** roth_ira */
  RothIra: 'roth_ira',
  /** sep_ira */
  SepIra: 'sep_ira',
  /** simple_ira */
  SimpleIra: 'simple_ira',
  /** traditional_ira */
  TraditionalIra: 'traditional_ira',
  /** trust */
  Trust: 'trust'
} as const;

export type SourceAccountRegistrationTypeName = typeof SourceAccountRegistrationTypeName[keyof typeof SourceAccountRegistrationTypeName];
/** Source of funds for the account */
export const SourceOfFundsName = {
  /** family_relatives_inheritance */
  FamilyRelativesInheritance: 'family_relatives_inheritance',
  /** gambling_lottery */
  GamblingLottery: 'gambling_lottery',
  /** gifts */
  Gifts: 'gifts',
  /** investment_capital_gains */
  InvestmentCapitalGains: 'investment_capital_gains',
  /** other */
  Other: 'other',
  /** salary_wages_savings */
  SalaryWagesSavings: 'salary_wages_savings',
  /** sale_of_property_or_business */
  SaleOfPropertyOrBusiness: 'sale_of_property_or_business',
  /** social_security_benefits */
  SocialSecurityBenefits: 'social_security_benefits'
} as const;

export type SourceOfFundsName = typeof SourceOfFundsName[keyof typeof SourceOfFundsName];
export type SpecialAsset = {
  readonly __typename?: 'SpecialAsset';
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly ticker?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SplitHousehold */
export type SplitHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Expected email of the co-client to move, as returned by get_household_detail.
   * Verified under lock before writes; mismatch raises so the caller re-fetches.
   */
  readonly coClientCurrentEmail: Scalars['String']['input'];
  /** Optional name for the new household; defaults to the co-client's full name. */
  readonly newHouseholdName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Coordinated case only: the Orion household id ops just created and moved the
   * co-client's accounts to. Provide only when the co-client holds managed (Orion) accounts.
   */
  readonly newOrionHouseholdId?: InputMaybe<Scalars['Int']['input']>;
  /** Source household UUID. */
  readonly sourceHouseholdPublicId: Scalars['ID']['input'];
};

/** Autogenerated return type of SplitHousehold. */
export type SplitHouseholdPayload = {
  readonly __typename?: 'SplitHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Email of the co-client whose split ran. */
  readonly coClientEmail?: Maybe<Scalars['String']['output']>;
  /** UUID of the household the co-client currently resolves to. Sanity check: should equal newHouseholdPublicId on success. */
  readonly coClientNowInHouseholdPublicId?: Maybe<Scalars['ID']['output']>;
  /** Savvy user id of the moved co-client. */
  readonly coClientUserId?: Maybe<Scalars['ID']['output']>;
  /** True when the split ran with a new_orion_household_id. */
  readonly coordinatedOrion?: Maybe<Scalars['Boolean']['output']>;
  /** The co-client's managed (Orion) account count at preflight. Populated on all success: false payloads for context. */
  readonly managedAccountCount?: Maybe<Scalars['Int']['output']>;
  /** IDs of accounts on the new household. Empty in simple case; populated post async Orion fetch in coordinated case. */
  readonly newHouseholdAccountIds?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  /** Advisor id on the new household (same as source). */
  readonly newHouseholdAdvisorId?: Maybe<Scalars['ID']['output']>;
  /** Box folder id for the new household. Fire-and-forget async — callers may see null on immediate return. */
  readonly newHouseholdBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** ServiceCatalogItemGroup id the new household is enrolled in (auto-enrolled from source). */
  readonly newHouseholdEnrolledServiceGroupId?: Maybe<Scalars['ID']['output']>;
  /** Name of the newly-created household. */
  readonly newHouseholdName?: Maybe<Scalars['String']['output']>;
  /** Orion household id linked to the new HH. Populated after LinkOrionHousehold's sync phase (coordinated case only). */
  readonly newHouseholdOrionHouseholdId?: Maybe<Scalars['Int']['output']>;
  /** UUID of the newly-created household. Populated on success and on post-commit partial failures for recovery. */
  readonly newHouseholdPublicId?: Maybe<Scalars['ID']['output']>;
  /**
   * When success=false, names the specific step that refused or failed (e.g.
   * managed_accounts_present_need_ops_coordination, orion_link_failed).
   */
  readonly reason?: Maybe<Scalars['String']['output']>;
  /** Source household's Box folder id (unchanged by split). */
  readonly sourceHouseholdBoxFolderId?: Maybe<Scalars['String']['output']>;
  /** Conquest plan id on the source household's FinancialPlan, if present. */
  readonly sourceHouseholdConquestPlanId?: Maybe<Scalars['String']['output']>;
  /** ServiceCatalogItemGroup id the source household is enrolled in (unchanged by split). */
  readonly sourceHouseholdEnrolledServiceGroupId?: Maybe<Scalars['ID']['output']>;
  /** Verified source household name. */
  readonly sourceHouseholdName?: Maybe<Scalars['String']['output']>;
  /** Source household's Orion household id (unchanged by split). */
  readonly sourceHouseholdOrionHouseholdId?: Maybe<Scalars['Int']['output']>;
  /** Echoes back the source household UUID. */
  readonly sourceHouseholdPublicId: Scalars['ID']['output'];
  /** IDs of accounts remaining on the source household after the split (the primary and any other members). */
  readonly sourceHouseholdRemainingAccountIds?: Maybe<ReadonlyArray<Scalars['ID']['output']>>;
  /** True when the split ran end-to-end. False on a legitimate refusal or a post-commit partial failure — inspect reason. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of StartBenchmarkDataGeneration */
export type StartBenchmarkDataGenerationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Explicit window. Takes precedence over date_range_id. */
  readonly dateRange?: InputMaybe<DateRangeInput>;
  /** Named preset window (e.g. ytd, past-year, inception). Used when date_range is omitted. */
  readonly dateRangeId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household. */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartBenchmarkDataGeneration. */
export type StartBenchmarkDataGenerationPayload = {
  readonly __typename?: 'StartBenchmarkDataGenerationPayload';
  /** The newly created job record. Poll it for status. */
  readonly benchmarkDataGeneration: BenchmarkDataGeneration;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of StartEciClientOnboarding */
export type StartEciClientOnboardingInput = {
  /** Limit new-account client onboarding to these requests; omitted for the existing upgrade flow */
  readonly accountRequestIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-composed message body sent to each client */
  readonly emailBody: Scalars['String']['input'];
  /** Household identifier — UUID (preferred) or legacy salesforce_account_id */
  readonly householdPublicId: Scalars['ID']['input'];
  /** Whether to schedule day 3/7/14 reminder emails for unsubmitted clients */
  readonly sendReminders: Scalars['Boolean']['input'];
};

/** Autogenerated return type of StartEciClientOnboarding. */
export type StartEciClientOnboardingPayload = {
  readonly __typename?: 'StartEciClientOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the submit succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of StartPlanImport */
export type StartPlanImportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The selected Box file identifiers. */
  readonly fileIds: ReadonlyArray<Scalars['String']['input']>;
  /** The selected Box folders, including their nested files. */
  readonly folderIds?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** The existing plan to enrich. */
  readonly planId: Scalars['ID']['input'];
  /** The caller-generated idempotency key. */
  readonly requestId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartPlanImport. */
export type StartPlanImportPayload = {
  readonly __typename?: 'StartPlanImportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The queued import operation. */
  readonly importStatus: PlanningImportStatus;
};

/** Autogenerated input type of StartSchwabApiImport */
export type StartSchwabApiImportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StartSchwabApiImport. */
export type StartSchwabApiImportPayload = {
  readonly __typename?: 'StartSchwabApiImportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Always null: the firm-wide sync fans out per advisor with no single import to poll */
  readonly linkedBankAccountImport?: Maybe<LinkedBankAccountImport>;
  /** True when there is no usable Schwab token: nothing was enqueued and the admin must reconnect (OAuth) before a sync can run */
  readonly reconnectNeeded: Scalars['Boolean']['output'];
};

/** A US state or territory code. */
export const StateCode = {
  /** AK */
  Ak: 'AK',
  /** AL */
  Al: 'AL',
  /** AR */
  Ar: 'AR',
  /** AZ */
  Az: 'AZ',
  /** CA */
  Ca: 'CA',
  /** CO */
  Co: 'CO',
  /** CT */
  Ct: 'CT',
  /** DC */
  Dc: 'DC',
  /** DE */
  De: 'DE',
  /** FL */
  Fl: 'FL',
  /** GA */
  Ga: 'GA',
  /** HI */
  Hi: 'HI',
  /** IA */
  Ia: 'IA',
  /** ID */
  Id: 'ID',
  /** IL */
  Il: 'IL',
  /** IN */
  In: 'IN',
  /** KS */
  Ks: 'KS',
  /** KY */
  Ky: 'KY',
  /** LA */
  La: 'LA',
  /** MA */
  Ma: 'MA',
  /** MD */
  Md: 'MD',
  /** ME */
  Me: 'ME',
  /** MI */
  Mi: 'MI',
  /** MN */
  Mn: 'MN',
  /** MO */
  Mo: 'MO',
  /** MS */
  Ms: 'MS',
  /** MT */
  Mt: 'MT',
  /** NC */
  Nc: 'NC',
  /** ND */
  Nd: 'ND',
  /** NE */
  Ne: 'NE',
  /** NH */
  Nh: 'NH',
  /** NJ */
  Nj: 'NJ',
  /** NM */
  Nm: 'NM',
  /** NV */
  Nv: 'NV',
  /** NY */
  Ny: 'NY',
  /** OH */
  Oh: 'OH',
  /** OK */
  Ok: 'OK',
  /** OR */
  Or: 'OR',
  /** PA */
  Pa: 'PA',
  /** RI */
  Ri: 'RI',
  /** SC */
  Sc: 'SC',
  /** SD */
  Sd: 'SD',
  /** TN */
  Tn: 'TN',
  /** TX */
  Tx: 'TX',
  /** UT */
  Ut: 'UT',
  /** VA */
  Va: 'VA',
  /** VT */
  Vt: 'VT',
  /** WA */
  Wa: 'WA',
  /** WI */
  Wi: 'WI',
  /** WV */
  Wv: 'WV',
  /** WY */
  Wy: 'WY'
} as const;

export type StateCode = typeof StateCode[keyof typeof StateCode];
/** A state filing for a tax enrollment */
export type StateFiling = {
  readonly __typename?: 'StateFiling';
  /** The state code for this filing */
  readonly stateCode: Scalars['String']['output'];
  /** The status of the state filing */
  readonly status: TaxReturnStatus;
};

/** Autogenerated input type of StopImpersonatingUser */
export type StopImpersonatingUserInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StopImpersonatingUser. */
export type StopImpersonatingUserPayload = {
  readonly __typename?: 'StopImpersonatingUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User being impersonated */
  readonly currentUser: User;
  /** True user (admin / admin ID) */
  readonly trueUser: User;
};

/** Autogenerated input type of StopSharingRetirementPlanOrganizations */
export type StopSharingRetirementPlanOrganizationsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Organizations to remove from the share list */
  readonly organizationIds: ReadonlyArray<Scalars['ID']['input']>;
  /** The plan to stop sharing */
  readonly retirementPlanId: Scalars['ID']['input'];
};

/** Autogenerated return type of StopSharingRetirementPlanOrganizations. */
export type StopSharingRetirementPlanOrganizationsPayload = {
  readonly __typename?: 'StopSharingRetirementPlanOrganizationsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated plan */
  readonly retirementPlan?: Maybe<RetirementPlan>;
};

/** Input type for filtering accounts by strategy enrollment */
export type StrategyFilterInput = {
  /**
   * Include accounts that are not enrolled in any strategy
   * @deprecated Use strategy_types instead
   */
  readonly includeUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter accounts enrolled in these specific strategies */
  readonly strategyNames?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Filter accounts by strategy type: first_party, third_party, or unassigned */
  readonly strategyTypes?: InputMaybe<ReadonlyArray<StrategyTypeFilter>>;
};

/** Filter accounts by strategy type */
export const StrategyTypeFilter = {
  /** first_party */
  FirstParty: 'first_party',
  /** third_party */
  ThirdParty: 'third_party',
  /** unassigned */
  Unassigned: 'unassigned'
} as const;

export type StrategyTypeFilter = typeof StrategyTypeFilter[keyof typeof StrategyTypeFilter];
export const StrategyTypeName = {
  /** first_party */
  FirstParty: 'first_party',
  /** third_party */
  ThirdParty: 'third_party'
} as const;

export type StrategyTypeName = typeof StrategyTypeName[keyof typeof StrategyTypeName];
/** Strict address input */
export type StrictAddressInput = {
  /** Address line 1 */
  readonly addressLine1: Scalars['String']['input'];
  /** Optional address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  readonly city: Scalars['String']['input'];
  /** Country */
  readonly country: Scalars['String']['input'];
  /** State */
  readonly state: Scalars['String']['input'];
  /** Zip code */
  readonly zip: Scalars['String']['input'];
};

/** Autogenerated input type of SubmitEciAccountOnboarding */
export type SubmitEciAccountOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Advisor-composed message body sent to each client */
  readonly emailBody: Scalars['String']['input'];
  /** Household identifier — UUID (preferred) or legacy salesforce_account_id */
  readonly householdPublicId: Scalars['ID']['input'];
  /** Whether to schedule day 3/7/14 reminder emails for unsubmitted clients */
  readonly sendReminders: Scalars['Boolean']['input'];
};

/** Autogenerated return type of SubmitEciAccountOnboarding. */
export type SubmitEciAccountOnboardingPayload = {
  readonly __typename?: 'SubmitEciAccountOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the submit succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SubmitEciClientOnboarding */
export type SubmitEciClientOnboardingInput = {
  /** Attestations the client agreed to before signing */
  readonly attestations: ReadonlyArray<Scalars['String']['input']>;
  /**
   * Write on behalf of this client. Ignored on the MagicLink path; on a session it
   * is only honoured for an advisor who could impersonate them.
   */
  readonly clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The signature value, usually the client's typed legal name */
  readonly signature: Scalars['String']['input'];
};

/** Autogenerated return type of SubmitEciClientOnboarding. */
export type SubmitEciClientOnboardingPayload = {
  readonly __typename?: 'SubmitEciClientOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the submission was persisted */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SubmitNewEciAccounts */
export type SubmitNewEciAccountsInput = {
  /** Explicit selection of new draft account requests */
  readonly accountRequestIds: ReadonlyArray<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Public household identifier */
  readonly householdPublicId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitNewEciAccounts. */
export type SubmitNewEciAccountsPayload = {
  readonly __typename?: 'SubmitNewEciAccountsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The isolated new-account submission */
  readonly householdOnboardingRequestId: Scalars['ID']['output'];
};

/** A sub-task belonging to a parent task. */
export type Subtask = {
  readonly __typename?: 'Subtask';
  /**
   * The due date this sub-task resolves to from its anchor + offset business days
   * (the run's launch/due date for roots, or the dependency completion date once a
   * gated step is released). Null until it has both an anchor and an offset. The
   * date picker offers this as the relative option to return to after a fixed date is set.
   */
  readonly anchoredDueAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The user assigned to this sub-task. */
  readonly assignee?: Maybe<User>;
  /** The client profile this sub-task is associated with, if any. */
  readonly clientProfile?: Maybe<Client>;
  /** When the sub-task was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The sub-task this one is gated on, or null if it is a root. */
  readonly dependency?: Maybe<Subtask>;
  /**
   * The id of the sub-task this one is gated on (waits for), or null if it is a
   * root. Frontend builds the dependency forest from these ids.
   */
  readonly dependsOnSubtaskId?: Maybe<Scalars['ID']['output']>;
  /** The description of the sub-task. */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** When the sub-task is due. */
  readonly dueAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Calendar days before the parent due date. When the parent is recurring, each occurrence re-computes the sub-task due_at. */
  readonly dueDateOffsetDays?: Maybe<Scalars['Int']['output']>;
  /** Indicates which terminal Fidelity failure this sub-task addresses. */
  readonly eciRemediationType?: Maybe<EciRemediationType>;
  /**
   * True when this sub-task waits on a dependency that is not yet complete: its
   * status cannot change and its due date is unresolved until the dependency is
   * done or cancelled.
   */
  readonly gated: Scalars['Boolean']['output'];
  /** The household this sub-task is associated with, if any. */
  readonly household?: Maybe<Household>;
  /** The Savvy ID of the sub-task. */
  readonly id: Scalars['ID']['output'];
  /** True when this sub-task tracks a Footprint KYC failure. Requires manual intervention. */
  readonly isKycRemediation: Scalars['Boolean']['output'];
  /** The name of the sub-task. */
  readonly name: Scalars['String']['output'];
  /**
   * Fidelity LogTrackingId of the call whose failure opened this remediation
   * sub-task, for looking up the full request/response in the NFS audit log. Null
   * for non-remediation sub-tasks, for failures recorded before this was captured,
   * and for viewers who cannot read the audit log.
   */
  readonly nfsTrackingId?: Maybe<Scalars['String']['output']>;
  /**
   * The 1-indexed manual position of the sub-task among its siblings on the same
   * parent task. Set automatically on create and updated by reorderSubtask.
   */
  readonly position?: Maybe<Scalars['Int']['output']>;
  /** The status of the sub-task. */
  readonly status: SubtaskStatus;
  /** The parent task this sub-task belongs to. */
  readonly task: Task;
  /** When the sub-task was last updated. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The work item this sub-task is associated with, if any. */
  readonly workItem?: Maybe<WorkItem>;
};

/** Input for creating a subtask as part of a parent task creation request. */
export type SubtaskCreationInput = {
  /** The ID of the user to assign the subtask to. */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The key of another subtask in this same payload that must complete before this
   * one ungates. Forms the gating dependency edge.
   */
  readonly dependsOnKey?: InputMaybe<Scalars['String']['input']>;
  /** Optional description of the subtask. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** When the subtask is due. */
  readonly dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Calendar days before the parent task due date. Used when the parent is recurring. */
  readonly dueDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Client-supplied key identifying this subtask within the payload, referenced by
   * other subtasks' dependsOnKey. Required only when something depends on this subtask.
   */
  readonly key?: InputMaybe<Scalars['String']['input']>;
  /** The name of the subtask. */
  readonly name: Scalars['String']['input'];
};

export const SubtaskStatus = {
  /** cancelled */
  Cancelled: 'cancelled',
  /** done */
  Done: 'done',
  /** in_progress */
  InProgress: 'in_progress',
  /** todo */
  Todo: 'todo'
} as const;

export type SubtaskStatus = typeof SubtaskStatus[keyof typeof SubtaskStatus];
/** Where one recipient of a survey round stands */
export const SurveyRecipientOutcome = {
  /** Submitted the survey */
  Completed: 'COMPLETED',
  /** Declined, archived it, or chose "Do not show" */
  Declined: 'DECLINED',
  /** The round ended before they answered */
  Ended: 'ENDED',
  /** Has not answered yet, including a snooze */
  Pending: 'PENDING'
} as const;

export type SurveyRecipientOutcome = typeof SurveyRecipientOutcome[keyof typeof SurveyRecipientOutcome];
/** The outcome of sending a survey round to one email */
export type SurveyRecipientResult = {
  readonly __typename?: 'SurveyRecipientResult';
  /** The matched user, when there is one */
  readonly advisorName?: Maybe<Scalars['String']['output']>;
  /** The email as submitted, trimmed and lowercased */
  readonly email: Scalars['String']['output'];
  /** What happened for this email */
  readonly status: SurveyRecipientStatus;
};

/** What sending a survey round did, or would do, for one email */
export const SurveyRecipientStatus = {
  /** The advisor is already in this round */
  AlreadyRecipient: 'ALREADY_RECIPIENT',
  /** The advisor was sent the survey */
  Created: 'CREATED',
  /** The user is not an advisor */
  NotAdvisor: 'NOT_ADVISOR',
  /** No user has this email */
  Unmatched: 'UNMATCHED',
  /** Preview only: the advisor would be sent the survey */
  WouldCreate: 'WOULD_CREATE'
} as const;

export type SurveyRecipientStatus = typeof SurveyRecipientStatus[keyof typeof SurveyRecipientStatus];
/** How an advisor answered a survey notification */
export const SurveyResponseAction = {
  /** Submitted the survey */
  Complete: 'COMPLETE',
  /** Declined this round */
  Decline: 'DECLINE',
  /** Closed it for now; it returns three business days later */
  Dismiss: 'DISMISS'
} as const;

export type SurveyResponseAction = typeof SurveyResponseAction[keyof typeof SurveyResponseAction];
/** One send of a Typeform survey to a set of advisors. */
export type SurveyRound = {
  readonly __typename?: 'SurveyRound';
  /** When ops ended the round, if it has ended */
  readonly endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the survey round */
  readonly id: Scalars['ID']['output'];
  /** Ops-facing name of the round, e.g. "2026 Q4 – Group B" */
  readonly label: Scalars['String']['output'];
  /** The Typeform form this round delivers */
  readonly typeformFormId: Scalars['String']['output'];
};

/** One advisor a survey round was sent to, and their outcome */
export type SurveyRoundRecipient = {
  readonly __typename?: 'SurveyRoundRecipient';
  /** The advisor the survey was sent to */
  readonly advisorName: Scalars['String']['output'];
  /** The advisor's email */
  readonly email: Scalars['String']['output'];
  /** Where the advisor stands on this round */
  readonly outcome: SurveyRecipientOutcome;
  /** When the advisor completed or declined; null if they never answered */
  readonly respondedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** A survey round as ops sees it on the admin page */
export type SurveyRoundReport = {
  readonly __typename?: 'SurveyRoundReport';
  /** When the round was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** When ops ended the round, if it has ended */
  readonly endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ID of the survey round */
  readonly id: Scalars['ID']['output'];
  /** Ops-facing name of the round */
  readonly label: Scalars['String']['output'];
  /** Every advisor the round was sent to, with their outcome */
  readonly recipients: ReadonlyArray<SurveyRoundRecipient>;
  /** The Typeform form this round delivers */
  readonly typeformFormId: Scalars['String']['output'];
};

export type SwimLoanLengthOption = {
  readonly __typename?: 'SwimLoanLengthOption';
  /** Loan length in whole months; the tenor label is derived on the client */
  readonly months: Scalars['Int']['output'];
  /** Estimated rate range, high end (percent) */
  readonly rateHigh: Scalars['Float']['output'];
  /** Estimated rate range, low end (percent) */
  readonly rateLow: Scalars['Float']['output'];
};

export type SwimLoanLengthOptionInput = {
  /** Loan length in whole months (> 0) */
  readonly months: Scalars['Int']['input'];
  /** Estimated rate range, high end (percent); must be >= rateLow */
  readonly rateHigh: Scalars['Float']['input'];
  /** Estimated rate range, low end (percent) */
  readonly rateLow: Scalars['Float']['input'];
};

export type SwimRequest = {
  readonly __typename?: 'SwimRequest';
  readonly accountImplementationDetails?: Maybe<Scalars['String']['output']>;
  readonly accountManagementType?: Maybe<Scalars['String']['output']>;
  /**
   * Accounts linked via swim_request_accounts. Used to render account details when
   * the deprecated included_accounts string column is empty.
   */
  readonly accounts?: Maybe<ReadonlyArray<Account>>;
  readonly advisorCustomModelType?: Maybe<Scalars['String']['output']>;
  readonly aggregateCollateralValue?: Maybe<Scalars['String']['output']>;
  readonly allocationModel?: Maybe<Scalars['String']['output']>;
  readonly annualIncome?: Maybe<Scalars['String']['output']>;
  readonly bondTypeForTaxableAccount?: Maybe<Scalars['String']['output']>;
  readonly cashRequirementContext?: Maybe<Scalars['String']['output']>;
  readonly cashReservesPerAccount?: Maybe<ReadonlyArray<CashReservesPerAccount>>;
  readonly coveredCallsStocks?: Maybe<ReadonlyArray<SpecialAsset>>;
  readonly dcaConfigs?: Maybe<ReadonlyArray<DcaAccountConfig>>;
  readonly doNotSellAssets?: Maybe<ReadonlyArray<SpecialAsset>>;
  /** Client estimated federal tax rate as a percentage, collected for municipal fixed income strategies */
  readonly estimatedFederalTaxRate?: Maybe<Scalars['String']['output']>;
  readonly estimatedLiquidNetWorth?: Maybe<Scalars['String']['output']>;
  readonly estimatedNetWorth?: Maybe<Scalars['String']['output']>;
  /** Client estimated state and local tax rate as a percentage, collected for municipal fixed income strategies */
  readonly estimatedStateLocalTaxRate?: Maybe<Scalars['String']['output']>;
  /** Illustrative taxable equivalent yield shown to the advisor at submit; a snapshot, not recomputed */
  readonly estimatedTaxableEquivalentYield?: Maybe<Scalars['String']['output']>;
  readonly extraImplementationDetails?: Maybe<Scalars['String']['output']>;
  readonly feeAssumption?: Maybe<Scalars['String']['output']>;
  /**
   * Fixed income strategy applied as part of a Savvy Total Portfolios combination;
   * standalone enrollments carry it in strategyType instead
   */
  readonly fixedIncomeStrategy?: Maybe<Scalars['String']['output']>;
  /** How the fixed income strategy is funded: cash or existing_portfolio */
  readonly fundingSource?: Maybe<Scalars['String']['output']>;
  readonly heldAwayAccountsIncluded?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly implementationBudget?: Maybe<Scalars['String']['output']>;
  readonly includedAccounts?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly includedHeldAwayAccounts?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly indexToTrack?: Maybe<Scalars['String']['output']>;
  readonly isSleeved?: Maybe<Scalars['Boolean']['output']>;
  readonly isTaxAware?: Maybe<Scalars['Boolean']['output']>;
  readonly keepReserveCash?: Maybe<Scalars['Boolean']['output']>;
  readonly loanAmount?: Maybe<Scalars['String']['output']>;
  readonly loanLength?: Maybe<Scalars['String']['output']>;
  readonly maturityRange?: Maybe<Scalars['String']['output']>;
  readonly maxGainsPreference?: Maybe<Scalars['Float']['output']>;
  readonly nonDiscretionaryAccounts?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly optionsAndMarginEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly optionsApplicationForClient?: Maybe<Scalars['String']['output']>;
  readonly overlay?: Maybe<Scalars['String']['output']>;
  readonly requestDca?: Maybe<Scalars['Boolean']['output']>;
  readonly retainedAssets?: Maybe<ReadonlyArray<SpecialAsset>>;
  readonly selectedModelRationale?: Maybe<Scalars['String']['output']>;
  readonly sleeves?: Maybe<ReadonlyArray<SwimRequestSleeve>>;
  /** @deprecated No longer used by frontend */
  readonly spacing?: Maybe<Scalars['String']['output']>;
  /** Client state of residency, collected for municipal fixed income strategies */
  readonly stateOfResidency?: Maybe<Scalars['String']['output']>;
  readonly strategyDetails?: Maybe<Scalars['String']['output']>;
  readonly strategyType?: Maybe<Scalars['String']['output']>;
  readonly systematicWithdrawalsDetails?: Maybe<Scalars['String']['output']>;
  readonly taxSensitivity?: Maybe<Scalars['String']['output']>;
  readonly thirdPartyModelType?: Maybe<Scalars['String']['output']>;
  readonly thirdPartyStrategy?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer used by frontend */
  readonly tilt?: Maybe<Scalars['String']['output']>;
  readonly usEquityIndex?: Maybe<Scalars['String']['output']>;
  readonly utilizeDirectIndexing?: Maybe<Scalars['Boolean']['output']>;
  readonly utilizeOverlay?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated No longer used by frontend */
  readonly utilizeTilt?: Maybe<Scalars['Boolean']['output']>;
  readonly willHaveSystematicWithdrawals?: Maybe<Scalars['Boolean']['output']>;
  readonly yearlyGainsBudget?: Maybe<Scalars['String']['output']>;
};

export type SwimRequestSleeve = {
  readonly __typename?: 'SwimRequestSleeve';
  readonly allocation?: Maybe<Scalars['String']['output']>;
  readonly percent?: Maybe<Scalars['String']['output']>;
  readonly strategy?: Maybe<Scalars['String']['output']>;
};

/** Input for swim request task specific data */
export type SwimRequestTaskInput = {
  /** Account IDs to associate with the swim request */
  readonly accountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly accountImplementationDetails?: InputMaybe<Scalars['String']['input']>;
  readonly accountManagementType?: InputMaybe<Scalars['String']['input']>;
  readonly advisorCustomModelType?: InputMaybe<Scalars['String']['input']>;
  readonly aggregateCollateralValue?: InputMaybe<Scalars['String']['input']>;
  readonly allocationModel?: InputMaybe<Scalars['String']['input']>;
  readonly annualIncome?: InputMaybe<Scalars['String']['input']>;
  readonly bondTypeForTaxableAccount?: InputMaybe<Scalars['String']['input']>;
  readonly cashRequirementContext?: InputMaybe<Scalars['String']['input']>;
  readonly cashReservesPerAccount?: InputMaybe<ReadonlyArray<Scalars['JSON']['input']>>;
  readonly coveredCallsStocks?: InputMaybe<ReadonlyArray<Scalars['JSON']['input']>>;
  /** Per-account DCA configuration */
  readonly dcaConfigs?: InputMaybe<ReadonlyArray<DcaAccountConfigInput>>;
  readonly doNotSellAssets?: InputMaybe<ReadonlyArray<Scalars['JSON']['input']>>;
  /** Client estimated federal tax rate as a percentage, collected for municipal fixed income strategies */
  readonly estimatedFederalTaxRate?: InputMaybe<Scalars['String']['input']>;
  readonly estimatedLiquidNetWorth?: InputMaybe<Scalars['String']['input']>;
  readonly estimatedNetWorth?: InputMaybe<Scalars['String']['input']>;
  /** Client estimated state and local tax rate as a percentage, collected for municipal fixed income strategies */
  readonly estimatedStateLocalTaxRate?: InputMaybe<Scalars['String']['input']>;
  /** Illustrative taxable equivalent yield shown to the advisor at submit; a snapshot, not recomputed server-side */
  readonly estimatedTaxableEquivalentYield?: InputMaybe<Scalars['String']['input']>;
  readonly extraImplementationDetails?: InputMaybe<Scalars['String']['input']>;
  readonly feeAssumption?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fixed income strategy applied as part of a Savvy Total Portfolios combination;
   * standalone enrollments carry it in strategy_type instead
   */
  readonly fixedIncomeStrategy?: InputMaybe<Scalars['String']['input']>;
  /** How the fixed income strategy is funded: cash or existing_portfolio */
  readonly fundingSource?: InputMaybe<Scalars['String']['input']>;
  readonly heldAwayAccountsIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  readonly implementationBudget?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use account_ids instead */
  readonly includedAccounts?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly includedHeldAwayAccounts?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly indexToTrack?: InputMaybe<Scalars['String']['input']>;
  readonly isSleeved?: InputMaybe<Scalars['Boolean']['input']>;
  readonly isTaxAware?: InputMaybe<Scalars['Boolean']['input']>;
  readonly keepReserveCash?: InputMaybe<Scalars['Boolean']['input']>;
  readonly loanAmount?: InputMaybe<Scalars['String']['input']>;
  readonly loanLength?: InputMaybe<Scalars['String']['input']>;
  readonly maturityRange?: InputMaybe<Scalars['String']['input']>;
  readonly maxGainsPreference?: InputMaybe<Scalars['Float']['input']>;
  readonly nonDiscretionaryAccounts?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly optionsAndMarginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly optionsApplicationForClient?: InputMaybe<Scalars['String']['input']>;
  readonly overlay?: InputMaybe<Scalars['String']['input']>;
  readonly retainedAssets?: InputMaybe<ReadonlyArray<Scalars['JSON']['input']>>;
  readonly selectedModelRationale?: InputMaybe<Scalars['String']['input']>;
  readonly sleeves?: InputMaybe<ReadonlyArray<Scalars['JSON']['input']>>;
  readonly spacing?: InputMaybe<Scalars['String']['input']>;
  /** Client state of residency, collected for municipal fixed income strategies so Ops knows which state issuance applies */
  readonly stateOfResidency?: InputMaybe<Scalars['String']['input']>;
  readonly strategyDetails?: InputMaybe<Scalars['String']['input']>;
  readonly strategyType?: InputMaybe<Scalars['String']['input']>;
  readonly systematicWithdrawalsDetails?: InputMaybe<Scalars['String']['input']>;
  readonly taxSensitivity?: InputMaybe<Scalars['String']['input']>;
  readonly thirdPartyModelType?: InputMaybe<Scalars['String']['input']>;
  readonly thirdPartyStrategy?: InputMaybe<Scalars['String']['input']>;
  readonly tilt?: InputMaybe<Scalars['String']['input']>;
  readonly usEquityIndex?: InputMaybe<Scalars['String']['input']>;
  readonly utilizeDirectIndexing?: InputMaybe<Scalars['Boolean']['input']>;
  readonly utilizeOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  readonly utilizeTilt?: InputMaybe<Scalars['Boolean']['input']>;
  readonly willHaveSystematicWithdrawals?: InputMaybe<Scalars['Boolean']['input']>;
  readonly yearlyGainsBudget?: InputMaybe<Scalars['String']['input']>;
};

export type SwimStrategy = {
  readonly __typename?: 'SwimStrategy';
  /** Fee in basis points, high end */
  readonly feeBpsHigh: Scalars['Int']['output'];
  /** Fee in basis points, low end (equals feeBpsHigh for a fixed fee) */
  readonly feeBpsLow: Scalars['Int']['output'];
  /** Stable strategy identifier; enrollment field/step config is keyed by this. Not editable in the admin UI */
  readonly key: Scalars['String']['output'];
  /** Display label shown in enrollment and the admin list */
  readonly name: Scalars['String']['output'];
};

export type SwimStrategyInput = {
  /** Fee in basis points, high end; must be >= feeBpsLow */
  readonly feeBpsHigh: Scalars['Int']['input'];
  /** Fee in basis points, low end (equals feeBpsHigh for a fixed fee) */
  readonly feeBpsLow: Scalars['Int']['input'];
  /** Stable strategy identifier; must be unique within the set */
  readonly key: Scalars['String']['input'];
  /** Display label */
  readonly name: Scalars['String']['input'];
};

/** Autogenerated input type of SwitchActiveHousehold */
export type SwitchActiveHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The household to make active for the current user. */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of SwitchActiveHousehold. */
export type SwitchActiveHouseholdPayload = {
  readonly __typename?: 'SwitchActiveHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated viewer user. */
  readonly user: User;
};

/** Autogenerated input type of SyncEciAccountOnboardingRequestSelection */
export type SyncEciAccountOnboardingRequestSelectionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household identifier — UUID (preferred) or legacy salesforce_account_id */
  readonly householdPublicId: Scalars['ID']['input'];
  /** Set of selected savvy account ids to transfer */
  readonly sourceAccountIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of SyncEciAccountOnboardingRequestSelection. */
export type SyncEciAccountOnboardingRequestSelectionPayload = {
  readonly __typename?: 'SyncEciAccountOnboardingRequestSelectionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the sync succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SyncOrionDataByPublicId */
export type SyncOrionDataByPublicIdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Expected household name */
  readonly householdName: Scalars['String']['input'];
  /** Household UUID */
  readonly householdPublicId: Scalars['ID']['input'];
};

/** Autogenerated return type of SyncOrionDataByPublicId. */
export type SyncOrionDataByPublicIdPayload = {
  readonly __typename?: 'SyncOrionDataByPublicIdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Verified household name */
  readonly householdName: Scalars['String']['output'];
  /** Verified household UUID */
  readonly householdPublicId: Scalars['ID']['output'];
  /** Whether an Orion sync job was queued */
  readonly queued: Scalars['Boolean']['output'];
  /** Why no sync was queued */
  readonly reason?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SyncOrionData */
export type SyncOrionDataInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly householdId?: InputMaybe<Scalars['ID']['input']>;
  readonly salesforceAccountId?: InputMaybe<Scalars['String']['input']>;
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SyncOrionData. */
export type SyncOrionDataPayload = {
  readonly __typename?: 'SyncOrionDataPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly message: Scalars['String']['output'];
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SyncStandingInstructionSelections */
export type SyncStandingInstructionSelectionsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Draft account-onboarding request ID (Advisor Onboarding Screen C). Mutually exclusive with taskId. */
  readonly eciAccountOnboardingRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Carry-over selection updates to apply to recurring transfers */
  readonly recurringTransferSelectionUpdates?: InputMaybe<ReadonlyArray<CarryOverSelectionInput>>;
  /** Carry-over selection updates to apply to standing instructions */
  readonly standingInstructionSelectionUpdates?: InputMaybe<ReadonlyArray<CarryOverSelectionInput>>;
  /** Account onboarding task id (Upgrade Custodian). Mutually exclusive with eciAccountOnboardingRequestId. */
  readonly taskId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SyncStandingInstructionSelections. */
export type SyncStandingInstructionSelectionsPayload = {
  readonly __typename?: 'SyncStandingInstructionSelectionsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the update succeeded */
  readonly success: Scalars['Boolean']['output'];
};

export type Task = {
  readonly __typename?: 'Task';
  /** Accounts associated with the task. Only present for Account Confirmation tasks */
  readonly accountConfirmationAccounts: ReadonlyArray<Account>;
  /** Account maintenance request data. */
  readonly accountMaintenanceRequest?: Maybe<AccountMaintenanceRequest>;
  /** Setup type for Account Confirmation tasks. Could be: account transfer or account opening */
  readonly accountSetupType?: Maybe<Scalars['String']['output']>;
  /** Type of account transfer. Could be: Fidelity -> Fidelity or Schwab -> Schwab */
  readonly accountTransferType?: Maybe<Scalars['String']['output']>;
  /** Boolean to indicate if we should add Calendly scheduling to a task */
  readonly addCalendlyScheduling?: Maybe<Scalars['Boolean']['output']>;
  /** Alternative investments purchase request data. */
  readonly alternativeInvestmentsPurchaseRequest?: Maybe<AlternativeInvestmentsPurchaseRequest>;
  /** The user assigned to this task */
  readonly assignee?: Maybe<User>;
  /** Files attached to this task, in upload order. */
  readonly attachments: ReadonlyArray<TaskAttachment>;
  readonly boxFolderId?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the current viewer is allowed to write extended-palette statuses
   * (sub_status, reviewed_ready_for_work) on this task. Mirrors
   * TaskPolicy#can_change_extended_status?.
   */
  readonly canChangeExtendedStatus: Scalars['Boolean']['output'];
  /**
   * Whether this task type supports duplication. A type capability, not a viewer
   * permission — duplicating opens a prefilled creation form, which authorizes the
   * destination household on submit. Mirrors Tasks::Duplication.duplicable?, so a
   * type becomes duplicable everywhere once registered.
   */
  readonly canDuplicate: Scalars['Boolean']['output'];
  /**
   * Whether the current viewer can add, edit or remove this task's links. Mirrors
   * TaskPolicy#can_link?. Resolved synchronously and walks household memberships
   * per task, which preload_read_authorization does not cover — select it on the
   * detail query only, never in a list query.
   */
  readonly canLink: Scalars['Boolean']['output'];
  /**
   * Whether the current viewer can clear an advisor-blocked sub_status via the
   * banner Mark as done button. Mirrors
   * TaskPolicy#can_mark_advisor_requirements_done?.
   */
  readonly canMarkAdvisorRequirementsDone: Scalars['Boolean']['output'];
  /** The category of the task */
  readonly category?: Maybe<TaskCategory>;
  /** Client billing request data. */
  readonly clientBillingRequest?: Maybe<ClientBillingRequest>;
  /** Client info change request data. */
  readonly clientInfoChangeRequest?: Maybe<ClientInfoChangeRequest>;
  /** Client review presentation request data. */
  readonly clientReviewPresentationRequest?: Maybe<ClientReviewPresentationRequest>;
  /** Comment notification summary for this task */
  readonly commentSummary: TaskCommentSummary;
  /** Who receives the task-completed client email. Null falls back to every household account holder. */
  readonly completedEmailRecipients?: Maybe<TaskCompletedEmailRecipients>;
  /**
   * The advisor note held by the household's current account-confirmation task,
   * for task types that display it but must not own it. Null when the household
   * has no current confirmation.
   */
  readonly confirmationInstructions?: Maybe<ConfirmationInstructions>;
  /** Corporate retirement plan request data. */
  readonly corporateRetirementPlanRequest?: Maybe<CorporateRetirementPlanRequest>;
  /** When the task was created in Savvy. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The description of the task */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** Plain-text version of the description, HTML stripped. */
  readonly descriptionText?: Maybe<Scalars['String']['output']>;
  /** Destination custodian for account opening or transfer tasks. Could be: Schwab or Fidelity */
  readonly destinationCustodian?: Maybe<Scalars['String']['output']>;
  /** DocuSign envelope status. */
  readonly docusignEnvelopeStatus?: Maybe<Scalars['String']['output']>;
  /** DocuSign recipients for this task. */
  readonly docusignRecipients?: Maybe<ReadonlyArray<DocusignRecipient>>;
  /** Serialized form state for wizard-based draft tasks */
  readonly draftPayload?: Maybe<Scalars['String']['output']>;
  /** When the task is due */
  readonly dueAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The ECI account onboarding request associated with this task, if any */
  readonly eciAccountOnboardingRequest?: Maybe<EciAccountOnboarding>;
  /** The Savvy ID of the task. */
  readonly id: Scalars['ID']['output'];
  /** Investment proposal request data. */
  readonly investmentProposalRequest?: Maybe<InvestmentProposalRequest>;
  /**
   * Whether this task is the main/template task of a recurring series (the
   * schedule anchor). The FE branches the delete prompt on this.
   */
  readonly isRecurrenceTemplate: Scalars['Boolean']['output'];
  /** Whether this task is part of a recurrence series */
  readonly isRecurring: Scalars['Boolean']['output'];
  /** Indicates if a docusign has possibly been signed. Uses the "wrong way" mentioned here: https://tinyurl.com/yr8fcybh */
  readonly maybeDocusignSigned?: Maybe<Scalars['Boolean']['output']>;
  /** Metadata about the task. */
  readonly metadata?: Maybe<Scalars['JSON']['output']>;
  /** Money movement request data. */
  readonly moneyMovementRequest?: Maybe<MoneyMovementRequest>;
  /** The name of the task */
  readonly name: Scalars['String']['output'];
  /** The note associated with this task, if there is one */
  readonly note?: Maybe<Note>;
  /** Onboarding task data. */
  readonly onboardingTask?: Maybe<OnboardingTaskDatum>;
  /** Open new account request data. */
  readonly openNewAccountRequest?: Maybe<OpenNewAccountRequest>;
  /** Other-investment task structured data. */
  readonly otherInvestmentTaskRequest?: Maybe<OtherInvestmentTaskRequest>;
  /** The priority level of the task */
  readonly priority: TaskPriority;
  /** The retirement plan project step this task was created from, if any. */
  readonly retirementPlanProjectRow?: Maybe<RetirementPlanProjectRow>;
  readonly salesforceTaskId?: Maybe<Scalars['String']['output']>;
  /**
   * Savvy Growth Opportunities Fund enrollment data, set instead of
   * alternativeInvestmentsPurchaseRequest on the Savvy variant.
   */
  readonly savvyAlternativesSubscriptionRequest?: Maybe<SavvyAlternativesSubscriptionRequest>;
  /** Whether to email the client when the task completes. Null inherits the organization default. */
  readonly sendEmailWhenCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Calendly booking tracking for a Service Calendar v2 meeting occurrence. */
  readonly serviceCatalogMeetingBooking?: Maybe<MeetingBooking>;
  /** The SC v2 catalog item that materialized this task. Null for non-SC tasks. (4C1T-94) */
  readonly sourceCatalogItem?: Maybe<ServiceCatalogItem>;
  /** The status of the task */
  readonly status: TaskStatus;
  /**
   * In Progress sub-status for Client Services and Investment Ops tasks. Null for
   * other categories or when the task is not In Progress.
   */
  readonly subStatus?: Maybe<TaskSubStatus>;
  /** Sub-tasks belonging to this task, ordered by their manual position (id breaks ties; nil positions sort to the end). */
  readonly subtasks: ReadonlyArray<Subtask>;
  /** Swim request data. */
  readonly swimRequest?: Maybe<SwimRequest>;
  /** Accounts associated with this task via account confirmation or SWIM enrollment. */
  readonly taskAccounts: ReadonlyArray<Account>;
  /** The time the task email was sent as String */
  readonly taskEmailSentAt?: Maybe<Scalars['String']['output']>;
  /** Ops paperwork reminder from the organization of the task owner's household advisor. Shown on task details for CSAs. */
  readonly taskInstructionsForOps?: Maybe<Scalars['String']['output']>;
  /** Links to other tasks, from this task's side, oldest first. A link whose other task the viewer cannot read is dropped. */
  readonly taskLinks: ReadonlyArray<TaskLink>;
  /** The recurrence schedule for this task */
  readonly taskRecurrence?: Maybe<TaskRecurrence>;
  /** The URL for the task */
  readonly taskUrl?: Maybe<Scalars['String']['output']>;
  /** The launch details of this workflow run (present only for launched workflow tasks). */
  readonly taskWorkflow?: Maybe<TaskWorkflow>;
  /** The workflow template this task defines (present only for workflow_template tasks). */
  readonly taskWorkflowTemplate?: Maybe<TaskWorkflowTemplate>;
  /** Trading request data. */
  readonly tradingRequest?: Maybe<TradingRequest>;
  /** Transfer of assets request data. */
  readonly transferOfAssetsRequest?: Maybe<TransferOfAssetsRequest>;
  /** The type of task */
  readonly type: TaskTypeName;
  /** Sibling tasks in the same recurrence series with due_at strictly after this task, ordered by due_at and capped at 5. */
  readonly upcomingMaterializedOccurrences: ReadonlyArray<Task>;
  /** When the task was last updated in Savvy. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  readonly user: User;
  /**
   * Immutable public handle. What the link arguments take — `salesforceTaskId` is
   * not it, because that reader only falls back to the uuid behind a flag and
   * otherwise returns a Salesforce id no link lookup would match.
   */
  readonly uuid?: Maybe<Scalars['ID']['output']>;
  /** Client profiles associated with this task through its work item */
  readonly workItemClients: ReadonlyArray<Client>;
  /** Households associated with this task through its work item */
  readonly workItemHouseholds: ReadonlyArray<Household>;
};

export type TaskActivity = {
  readonly __typename?: 'TaskActivity';
  /** List of Box file IDs attached to a comment */
  readonly attachments?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Author that created the activity */
  readonly author: User;
  /** Content of Task Activity */
  readonly content?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** Task Activity ID */
  readonly id: Scalars['ID']['output'];
  /**
   * Users explicitly @-mentioned in this comment (the picker selections),
   * persisted so edits and highlights resolve the exact people instead of
   * re-deriving from free text.
   */
  readonly mentionedUsers: ReadonlyArray<TaskCommentMentionCandidate>;
  /**
   * The workflow this task was launched from, present only on the task-created
   * activity. Lets the timeline link the creation event back to its source workflow.
   */
  readonly sourceWorkflowTemplate?: Maybe<TaskWorkflowTemplate>;
  /** Activity/title of Task Activity */
  readonly title: Scalars['String']['output'];
  /** Type of Task Activity */
  readonly typeOf: Scalars['String']['output'];
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A file attached to a task, inside the task's own Box folder */
export type TaskAttachment = {
  readonly __typename?: 'TaskAttachment';
  /** The Box file id of the uploaded file. */
  readonly boxFileId: Scalars['String']['output'];
  /** File size in bytes, as reported by the browser at upload time. */
  readonly byteSize?: Maybe<Scalars['Int']['output']>;
  /** Display filename, as stored in Box. Differs from the name the advisor picked when Box renamed it on a conflict. */
  readonly filename: Scalars['String']['output'];
  /** The Savvy ID of the attachment. */
  readonly id: Scalars['ID']['output'];
};

/** A file already uploaded to the task's Box folder by the client, recorded so a reopened draft can list it. */
export type TaskAttachmentInput = {
  /** The Box file id of the already-uploaded file. */
  readonly boxFileId: Scalars['String']['input'];
  /** File size in bytes, for the size label on the attachment chip. */
  readonly byteSize?: InputMaybe<Scalars['Int']['input']>;
  /** Display filename, as stored in Box. */
  readonly filename: Scalars['String']['input'];
};

export type TaskCancellationTargetInput = {
  /** Task ID */
  readonly id: Scalars['ID']['input'];
  /** Expected task name */
  readonly name: Scalars['String']['input'];
};

/** Task category */
export const TaskCategory = {
  /** advisor */
  Advisor: 'advisor',
  /** client */
  Client: 'client',
  /** ops */
  Ops: 'ops'
} as const;

export type TaskCategory = typeof TaskCategory[keyof typeof TaskCategory];
/** Contact-card projection of a task comment author, used by the mobile profile sheet. */
export type TaskCommentAuthor = {
  readonly __typename?: 'TaskCommentAuthor';
  /** User email address */
  readonly email: Scalars['String']['output'];
  /** User full name */
  readonly fullName: Scalars['String']['output'];
  /** User id */
  readonly id: Scalars['ID']['output'];
  /** User phone number */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  /** User profile picture URL */
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
  /** User role, UPCASED at the GQL boundary */
  readonly role: UserRole;
  /** Configured IANA timezone; null until set */
  readonly timezone?: Maybe<Scalars['String']['output']>;
};

/** A task comment @mention candidate */
export type TaskCommentMentionCandidate = {
  readonly __typename?: 'TaskCommentMentionCandidate';
  /** User full name */
  readonly fullName: Scalars['String']['output'];
  /** User id */
  readonly id: Scalars['ID']['output'];
  /** Whether this candidate is from the Ops team */
  readonly opsTeam: Scalars['Boolean']['output'];
  /** User profile picture URL */
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
};

/** Comment notification summary for a task list row */
export type TaskCommentSummary = {
  readonly __typename?: 'TaskCommentSummary';
  /** One of none|inactive|active|active_mention */
  readonly state: Scalars['String']['output'];
  /** Total number of comments on the task */
  readonly totalCount: Scalars['Int']['output'];
  /** Unread comments since the user last opened task details */
  readonly unreadCount: Scalars['Int']['output'];
  /** Unread mentions of the current user on this task */
  readonly unreadMentionCount: Scalars['Int']['output'];
};

export type TaskCompleted = {
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  /** Status the task moved from, for funnel analysis. */
  readonly previousStatus?: InputMaybe<Scalars['String']['input']>;
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  /** Id of the task that was marked complete. */
  readonly taskId: Scalars['String']['input'];
  /** Type/category of the completed task, when known (the swipe/bulk paths operate on a narrowed task row without it). */
  readonly taskType?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

/** Who receives the task-completed client email */
export const TaskCompletedEmailRecipients = {
  /** both */
  Both: 'both',
  /** co_client */
  CoClient: 'co_client',
  /** primary_client */
  PrimaryClient: 'primary_client'
} as const;

export type TaskCompletedEmailRecipients = typeof TaskCompletedEmailRecipients[keyof typeof TaskCompletedEmailRecipients];
/** The connection type for Task. */
export type TaskConnection = {
  readonly __typename?: 'TaskConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TaskEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Task>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

export type TaskCreated = {
  /** Which flow built the task: "natural_language" or "standalone_form". Optional, so a client predating it omits it. */
  readonly creationMethod?: InputMaybe<Scalars['String']['input']>;
  /** Which entrypoint seeded the form: "new_task", "draft", "note" or "duplicate". Optional, so a client predating it omits it. */
  readonly creationSource?: InputMaybe<Scalars['String']['input']>;
  /** Public id of the household the task belongs to, when created in a household context. */
  readonly householdPublicId?: InputMaybe<Scalars['String']['input']>;
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * True when the task was saved as a draft rather than submitted. A draft and its
   * later publish share a task_id, so counting created tasks means excluding the
   * drafts. Filter on "is not true" rather than "false", because events predating
   * this argument carry no value at all.
   */
  readonly isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  /** Id of the created task. */
  readonly taskId: Scalars['String']['input'];
  /** Type/category of the created task. */
  readonly taskType: Scalars['String']['input'];
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export type TaskCreationStarted = {
  /**
   * Which flow the advisor started: "natural_language" or "standalone_form". Only
   * the natural-language flow reports a start today.
   */
  readonly creationMethod?: InputMaybe<Scalars['String']['input']>;
  /** Public id of the household the flow was started under, when started in a household context. */
  readonly householdPublicId?: InputMaybe<Scalars['String']['input']>;
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

/** An edge in a connection. */
export type TaskEdge = {
  readonly __typename?: 'TaskEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Task>;
};

/**
 * One recipient's copy of a client task email, named so the advisor knows whose it
 * is. Most task emails produce exactly one; account setup produces two.
 */
export type TaskEmailPreviewCopy = {
  readonly __typename?: 'TaskEmailPreviewCopy';
  /** The rendered email as this recipient receives it. */
  readonly preview: EmailPreview;
  /** Address this copy is delivered to. */
  readonly recipientEmail: Scalars['String']['output'];
  /** Full name of the person this copy is addressed to. */
  readonly recipientName: Scalars['String']['output'];
};

/**
 * Task count for a single group bucket; key is the serialized filter value
 * (status, sub_status, assignee id, "unassigned", or due bucket)
 */
export type TaskGroupCount = {
  readonly __typename?: 'TaskGroupCount';
  /** Number of tasks in this bucket */
  readonly count: Scalars['Int']['output'];
  /** Group key: the serialized filter value used to fetch this bucket */
  readonly key: Scalars['String']['output'];
};

/** A link from the task being read to another task, labelled from the reader's side. */
export type TaskLink = {
  readonly __typename?: 'TaskLink';
  /** The Savvy ID of the link. Pass it back as taskLinkId to rewrite this link. */
  readonly id: Scalars['ID']['output'];
  /** How the task being read relates to the other task. */
  readonly relationship: TaskLinkRelationship;
  /** The other task in the pair. */
  readonly task: Task;
};

/** Input for linking a task to another task. */
export type TaskLinkInput = {
  /** How this task relates to the other task. */
  readonly relationship: TaskLinkRelationship;
  /** Existing link to rewrite. Omit to create one. */
  readonly taskLinkId?: InputMaybe<Scalars['ID']['input']>;
  /** The public id of the other task. */
  readonly taskUuid: Scalars['String']['input'];
};

/** How one task relates to another: blocks, blocked by, relates to, duplicates, duplicated by */
export const TaskLinkRelationship = {
  /** blocked_by */
  BlockedBy: 'blocked_by',
  /** blocks */
  Blocks: 'blocks',
  /** duplicated_by */
  DuplicatedBy: 'duplicated_by',
  /** duplicates */
  Duplicates: 'duplicates',
  /** relates_to */
  RelatesTo: 'relates_to'
} as const;

export type TaskLinkRelationship = typeof TaskLinkRelationship[keyof typeof TaskLinkRelationship];
/** Task priority level */
export const TaskPriority = {
  /** high */
  High: 'high',
  /** low */
  Low: 'low',
  /** medium */
  Medium: 'medium',
  /** none */
  None: 'none'
} as const;

export type TaskPriority = typeof TaskPriority[keyof typeof TaskPriority];
/** A recurrence schedule attached to a task */
export type TaskRecurrence = {
  readonly __typename?: 'TaskRecurrence';
  /** Whether the recurrence is active */
  readonly active: Scalars['Boolean']['output'];
  /** Month of year (1..12) anchor. */
  readonly byMonth?: Maybe<Scalars['Int']['output']>;
  /** Day of month (1..31) anchor. */
  readonly byMonthDay?: Maybe<Scalars['Int']['output']>;
  /** Ordinal occurrence within month (1..5 or -1). */
  readonly bySetPos?: Maybe<Scalars['Int']['output']>;
  /** Comma-separated RFC 5545 BYDAY codes (e.g. "FR" or "MO,TU,WE,TH,FR"). */
  readonly byday?: Maybe<Scalars['String']['output']>;
  /** When the recurrence ends */
  readonly endCondition: RecurrenceEndCondition;
  /** Max occurrences for by_count end condition */
  readonly endCount?: Maybe<Scalars['Int']['output']>;
  /** End date for by_date end condition */
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** How often the task recurs */
  readonly frequency: RecurrenceFrequency;
  /** The ID of the recurrence */
  readonly id: Scalars['ID']['output'];
  /** Interval between occurrences */
  readonly interval: Scalars['Int']['output'];
  /** Number of occurrences generated so far */
  readonly occurrencesGenerated: Scalars['Int']['output'];
  /** IANA timezone for scheduling */
  readonly timezone: Scalars['String']['output'];
};

/** Sort values for tasks table */
export const TaskSortValues = {
  /** ASSIGNEE_NAME */
  AssigneeName: 'ASSIGNEE_NAME',
  /** CATEGORY */
  Category: 'CATEGORY',
  /** COMMENT_STATUS */
  CommentStatus: 'COMMENT_STATUS',
  /** CREATED_AT */
  CreatedAt: 'CREATED_AT',
  /** DESCRIPTION */
  Description: 'DESCRIPTION',
  /** DUE_AT */
  DueAt: 'DUE_AT',
  /** HOUSEHOLD_NAME */
  HouseholdName: 'HOUSEHOLD_NAME',
  /** NAME */
  Name: 'NAME',
  /** PRIORITY */
  Priority: 'PRIORITY',
  /** STATUS */
  Status: 'STATUS',
  /** TYPE */
  Type: 'TYPE',
  /** UPDATED_AT */
  UpdatedAt: 'UPDATED_AT'
} as const;

export type TaskSortValues = typeof TaskSortValues[keyof typeof TaskSortValues];
export const TaskStatus = {
  /** cancelled */
  Cancelled: 'cancelled',
  /** done */
  Done: 'done',
  /** draft */
  Draft: 'draft',
  /** failed */
  Failed: 'failed',
  /** hidden */
  Hidden: 'hidden',
  /** in_progress */
  InProgress: 'in_progress',
  /** pending */
  Pending: 'pending',
  /** sent */
  Sent: 'sent',
  /** todo */
  Todo: 'todo'
} as const;

export type TaskStatus = typeof TaskStatus[keyof typeof TaskStatus];
export type TaskStatusChanged = {
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  /** Status the task moved from, when known. */
  readonly previousStatus?: InputMaybe<Scalars['String']['input']>;
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  /** Status the task moved to. */
  readonly status: Scalars['String']['input'];
  /** Sub-status set alongside the new status, when one applies. */
  readonly subStatus?: InputMaybe<Scalars['String']['input']>;
  /** Id of the task whose status changed. */
  readonly taskId: Scalars['String']['input'];
  /** Type/category of the task, when known. */
  readonly taskType?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

export const TaskSubStatus = {
  /** active_working */
  ActiveWorking: 'active_working',
  /** paused_blocked */
  PausedBlocked: 'paused_blocked',
  /** pending_advisor */
  PendingAdvisor: 'pending_advisor',
  /** pending_client */
  PendingClient: 'pending_client',
  /** pending_custodian */
  PendingCustodian: 'pending_custodian',
  /** reviewed_ready_for_work */
  ReviewedReadyForWork: 'reviewed_ready_for_work'
} as const;

export type TaskSubStatus = typeof TaskSubStatus[keyof typeof TaskSubStatus];
export type TaskSuggestion = {
  readonly __typename?: 'TaskSuggestion';
  /** The description of the task suggestion */
  readonly description?: Maybe<Scalars['String']['output']>;
  /** When the task is due */
  readonly dueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The Savvy ID of the task suggestion */
  readonly id: Scalars['ID']['output'];
  /** Metadata about the task */
  readonly metadata?: Maybe<Scalars['JSON']['output']>;
  /** The name of the task suggestion */
  readonly name?: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the note this task suggestion is associated with */
  readonly noteId: Scalars['ID']['output'];
  /** The status of the task suggestion */
  readonly status: TaskSuggestionStatus;
  /** The Savvy ID of the task (if created) from this suggestion */
  readonly taskId?: Maybe<Scalars['ID']['output']>;
  /** Type of task suggested */
  readonly type: TaskTypeName;
};

export const TaskSuggestionStatus = {
  Accepted: 'accepted',
  Pending: 'pending',
  Rejected: 'rejected'
} as const;

export type TaskSuggestionStatus = typeof TaskSuggestionStatus[keyof typeof TaskSuggestionStatus];
export const TaskTypeName = {
  /** account_maintenance */
  AccountMaintenance: 'account_maintenance',
  /** account_onboarding */
  AccountOnboarding: 'account_onboarding',
  /** account_setup */
  AccountSetup: 'account_setup',
  /** alternative_investments_purchase */
  AlternativeInvestmentsPurchase: 'alternative_investments_purchase',
  /** birthday_reminder */
  BirthdayReminder: 'birthday_reminder',
  /** client_billing */
  ClientBilling: 'client_billing',
  /** client_info_change */
  ClientInfoChange: 'client_info_change',
  /** client_other */
  ClientOther: 'client_other',
  /** client_review */
  ClientReview: 'client_review',
  /** client_review_meeting */
  ClientReviewMeeting: 'client_review_meeting',
  /** client_review_meeting_material_request */
  ClientReviewMeetingMaterialRequest: 'client_review_meeting_material_request',
  /** client_review_presentation */
  ClientReviewPresentation: 'client_review_presentation',
  /** client_transition_flow */
  ClientTransitionFlow: 'client_transition_flow',
  /** contract */
  Contract: 'contract',
  /** contract_change */
  ContractChange: 'contract_change',
  /** corporate_retirement_plan */
  CorporateRetirementPlan: 'corporate_retirement_plan',
  /** data_info_maintenance */
  DataInfoMaintenance: 'data_info_maintenance',
  /** eci_household_onboarding */
  EciHouseholdOnboarding: 'eci_household_onboarding',
  /** emoney */
  Emoney: 'emoney',
  /** file_upload */
  FileUpload: 'file_upload',
  /** financial_planning */
  FinancialPlanning: 'financial_planning',
  /** general */
  General: 'general',
  /** initial_intake_form */
  InitialIntakeForm: 'initial_intake_form',
  /** investment_management */
  InvestmentManagement: 'investment_management',
  /** investment_management_direct_indexing */
  InvestmentManagementDirectIndexing: 'investment_management_direct_indexing',
  /** investment_management_wealthcare */
  InvestmentManagementWealthcare: 'investment_management_wealthcare',
  /** investment_proposal_generation */
  InvestmentProposalGeneration: 'investment_proposal_generation',
  /** investment_proposal_presentation */
  InvestmentProposalPresentation: 'investment_proposal_presentation',
  /** investment_proposal_request */
  InvestmentProposalRequest: 'investment_proposal_request',
  /** marketing */
  Marketing: 'marketing',
  /** money_movement_request */
  MoneyMovementRequest: 'money_movement_request',
  /** onboarding_flow */
  OnboardingFlow: 'onboarding_flow',
  /** open_new_account */
  OpenNewAccount: 'open_new_account',
  /** other */
  Other: 'other',
  /** other_investment_task */
  OtherInvestmentTask: 'other_investment_task',
  /** pre_review_check_in */
  PreReviewCheckIn: 'pre_review_check_in',
  /** rejected_fee */
  RejectedFee: 'rejected_fee',
  /** reporting */
  Reporting: 'reporting',
  /** risk_questionnaire */
  RiskQuestionnaire: 'risk_questionnaire',
  /** self_reminder */
  SelfReminder: 'self_reminder',
  /** swim_request */
  SwimRequest: 'swim_request',
  /** trades_cash_management */
  TradesCashManagement: 'trades_cash_management',
  /** trading_request */
  TradingRequest: 'trading_request',
  /** transfer */
  Transfer: 'transfer',
  /** transfer_of_assets */
  TransferOfAssets: 'transfer_of_assets',
  /** transition_analysis */
  TransitionAnalysis: 'transition_analysis',
  /** workflow */
  Workflow: 'workflow',
  /** workflow_template */
  WorkflowTemplate: 'workflow_template'
} as const;

export type TaskTypeName = typeof TaskTypeName[keyof typeof TaskTypeName];
export type TaskViewed = {
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  /** Id of the viewed task. */
  readonly taskId: Scalars['String']['input'];
  /** Type/category of the viewed task. */
  readonly taskType: Scalars['String']['input'];
  readonly urlQueryParams: Scalars['JSON']['input'];
};

/** The launch details of a workflow run — the sidecar of a task with type_of = workflow. */
export type TaskWorkflow = {
  readonly __typename?: 'TaskWorkflow';
  /** The Savvy ID of the workflow run. */
  readonly id: Scalars['ID']['output'];
  /** Schedule anchor chosen at launch: launch_date or due_date. */
  readonly schedule: TaskWorkflowTemplateSchedule;
  /**
   * Launch date (launch_date schedule) or target due date (due_date schedule)
   * chosen at launch; null when the workflow was launched with no date.
   */
  readonly targetDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** A reusable workflow template — the sidecar of a task with type_of = workflow. */
export type TaskWorkflowTemplate = {
  readonly __typename?: 'TaskWorkflowTemplate';
  /** Whether the current advisor's organization has already cloned this Savvy template into its Resources. */
  readonly addedToResources: Scalars['Boolean']['output'];
  /** Whether the current user can edit this workflow template. */
  readonly canEdit: Scalars['Boolean']['output'];
  /** User IDs granted edit access on a team template; empty means everyone in the group can edit. */
  readonly editorIds: ReadonlyArray<Scalars['ID']['output']>;
  /** The Savvy ID of the workflow. */
  readonly id: Scalars['ID']['output'];
  /** Count of active (not completed or cancelled) launches the current user can access. */
  readonly inProgressCount: Scalars['Int']['output'];
  /** When this workflow was last launched. */
  readonly lastUsedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Tasks launched from this workflow, newest first. */
  readonly launches: TaskConnection;
  /** Whether the current user can promote this template to a globally-available Savvy template. */
  readonly promotableToSavvy: Scalars['Boolean']['output'];
  /** Schedule anchor: launch_date or due_date. */
  readonly schedule: TaskWorkflowTemplateSchedule;
  /** The template task this workflow describes. */
  readonly task: Task;
  /** Who can see this workflow: private (owner only) or firm. */
  readonly visibility: TaskWorkflowTemplateVisibility;
};


/** A reusable workflow template — the sidecar of a task with type_of = workflow. */
export type TaskWorkflowTemplateLaunchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Action an ACL entry grants on a workflow template: edit */
export const TaskWorkflowTemplateAclAction = {
  /** edit */
  Edit: 'edit'
} as const;

export type TaskWorkflowTemplateAclAction = typeof TaskWorkflowTemplateAclAction[keyof typeof TaskWorkflowTemplateAclAction];
/** Schedule anchor for a task workflow: launch_date or due_date */
export const TaskWorkflowTemplateSchedule = {
  /** due_date */
  DueDate: 'due_date',
  /** launch_date */
  LaunchDate: 'launch_date'
} as const;

export type TaskWorkflowTemplateSchedule = typeof TaskWorkflowTemplateSchedule[keyof typeof TaskWorkflowTemplateSchedule];
/** Visibility of a task workflow: private (owner only) or firm */
export const TaskWorkflowTemplateVisibility = {
  /** firm */
  Firm: 'firm',
  /** private */
  Private: 'private'
} as const;

export type TaskWorkflowTemplateVisibility = typeof TaskWorkflowTemplateVisibility[keyof typeof TaskWorkflowTemplateVisibility];
/** Aggregated data for tasks table including counts before and after filtering */
export type TasksTableAggregatedData = {
  readonly __typename?: 'TasksTableAggregatedData';
  /** Filtered task counts grouped by assignee id; unassigned tasks use the key "unassigned" */
  readonly assigneeCounts: ReadonlyArray<TaskGroupCount>;
  /** Filtered task counts per mutually-exclusive due bucket; keys match the TasksTableDueFilter grouping ladder */
  readonly dueCounts: ReadonlyArray<TaskGroupCount>;
  /** Task counts after applying filters */
  readonly filteredCounts: TasksTableCategoryCounts;
  /** Counts of filtered tasks with status todo or in_progress */
  readonly filteredOpenCounts: TasksTableCategoryCounts;
  /** Filtered task counts grouped by status; key is a TaskStatus value */
  readonly statusCounts: ReadonlyArray<TaskGroupCount>;
  /** Filtered task counts grouped by sub_status (in_progress tasks only); key is a TaskSubStatus value */
  readonly subStatusCounts: ReadonlyArray<TaskGroupCount>;
  /** Task counts before applying filters */
  readonly unfilteredCounts: TasksTableCategoryCounts;
};

/** Filter tasks by assignment: me, team, or clients */
export const TasksTableAssignedToFilter = {
  /** all */
  All: 'all',
  /** clients */
  Clients: 'clients',
  /** me */
  Me: 'me',
  /** team */
  Team: 'team'
} as const;

export type TasksTableAssignedToFilter = typeof TasksTableAssignedToFilter[keyof typeof TasksTableAssignedToFilter];
/** Task counts by category */
export type TasksTableCategoryCounts = {
  readonly __typename?: 'TasksTableCategoryCounts';
  /** Count of advisor tasks */
  readonly advisor: Scalars['Int']['output'];
  /** Count of client tasks */
  readonly client: Scalars['Int']['output'];
  /** Count of ops tasks */
  readonly ops: Scalars['Int']['output'];
  /** Total count of all tasks */
  readonly total: Scalars['Int']['output'];
};

/** Filter tasks by comment notification state */
export const TasksTableCommentStatusFilter = {
  /** no_comments */
  NoComments: 'no_comments',
  /** unread_comments */
  UnreadComments: 'unread_comments',
  /** unread_mentions_to_me */
  UnreadMentionsToMe: 'unread_mentions_to_me',
  /** up_to_date */
  UpToDate: 'up_to_date'
} as const;

export type TasksTableCommentStatusFilter = typeof TasksTableCommentStatusFilter[keyof typeof TasksTableCommentStatusFilter];
/**
 * Filter tasks by a single due-at bucket (today, overdue, no_due_date, and the
 * exclusive grouping ladder next_7_days_excluding_today / next_30_days /
 * next_30_days_plus)
 */
export const TasksTableDueFilter = {
  /** next_7_days */
  Next_7Days: 'next_7_days',
  /** next_7_days_excluding_today */
  Next_7DaysExcludingToday: 'next_7_days_excluding_today',
  /** next_30_days */
  Next_30Days: 'next_30_days',
  /** next_30_days_plus */
  Next_30DaysPlus: 'next_30_days_plus',
  /** no_due_date */
  NoDueDate: 'no_due_date',
  /** overdue */
  Overdue: 'overdue',
  /** this_month */
  ThisMonth: 'this_month',
  /** today */
  Today: 'today',
  /** upcoming */
  Upcoming: 'upcoming'
} as const;

export type TasksTableDueFilter = typeof TasksTableDueFilter[keyof typeof TasksTableDueFilter];
/** Filter options for tasks table */
export type TasksTableFilterInput = {
  /** Filter assignment for me, team, or clients */
  readonly assignedTo?: InputMaybe<TasksTableAssignedToFilter>;
  /** Filter by assignee user IDs */
  readonly assigneeIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Filter by task category */
  readonly category?: InputMaybe<TaskCategory>;
  /** Filter by comment notification state */
  readonly commentStatus?: InputMaybe<ReadonlyArray<TasksTableCommentStatusFilter>>;
  /** Filter tasks by a single due-at bucket (e.g. today, next_7_days, overdue) */
  readonly due?: InputMaybe<TasksTableDueFilter>;
  /** Filter tasks by one or more due-at buckets, ORed together. Unioned with the singular `due`. */
  readonly dues?: InputMaybe<ReadonlyArray<TasksTableDueFilter>>;
  /** Filter by household IDs */
  readonly householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Filter by household tag IDs */
  readonly householdTagIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Include SC v2 automation tasks (pending/sent/failed). Default false preserves v1 semantics. */
  readonly includeCatalogAutomation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by one or more task priority levels */
  readonly priorities?: InputMaybe<ReadonlyArray<TaskPriority>>;
  /** Search query for task names and descriptions */
  readonly query?: InputMaybe<Scalars['String']['input']>;
  /** Filter by task statuses */
  readonly statuses?: InputMaybe<ReadonlyArray<TaskStatus>>;
  /**
   * When true, restrict to tasks with no sub_status (AND-combined). Pair with
   * statuses:[IN_PROGRESS] to fetch the bare in-progress group.
   */
  readonly subStatusNone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by task sub-statuses; narrows within status=in_progress per the DB CHECK constraint. */
  readonly subStatuses?: InputMaybe<ReadonlyArray<TaskSubStatus>>;
  /** Filter by the source workflow(s) a task was launched from. ORed together (a task has at most one source workflow). */
  readonly taskWorkflowIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** Filter by task types */
  readonly typesOf?: InputMaybe<ReadonlyArray<TaskTypeName>>;
  /** When true, also include tasks with no assignee (assignee_id IS NULL). Combines OR-style with assignee_ids. */
  readonly unassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Downscoped Box access token and file ID for previewing the tax addendum template */
export type TaxAddendumPreview = {
  readonly __typename?: 'TaxAddendumPreview';
  /** Downscoped Box access token with item_preview scope */
  readonly accessToken?: Maybe<Scalars['String']['output']>;
  /** Box file ID of the current tax addendum template */
  readonly fileId?: Maybe<Scalars['String']['output']>;
};

/** Tax enrollment for clients. */
export type TaxEnrollment = {
  readonly __typename?: 'TaxEnrollment';
  /** The billable client for this enrollment. */
  readonly billableClient: Client;
  /** When the tax enrollment was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The type of tax enrollment. */
  readonly enrollmentType: TaxEnrollmentTypeName;
  /** The status of the federal return. */
  readonly federalReturnStatus: TaxReturnStatus;
  /** The Savvy ID of the tax enrollment. */
  readonly id: Scalars['ID']['output'];
  /** The non-billable client for this enrollment. */
  readonly nonBillableClient?: Maybe<Client>;
  /** The price for this tax enrollment. */
  readonly price?: Maybe<Scalars['BigDecimal']['output']>;
  /** The state filings for this tax enrollment. */
  readonly stateFilings: ReadonlyArray<StateFiling>;
  /** The status of the state return. */
  readonly stateReturnStatus: TaxReturnStatus;
  /** The state return status data (JSONB - deprecated, use state_filings). */
  readonly stateReturnStatusData?: Maybe<Scalars['JSON']['output']>;
  /** The tax year for this enrollment. */
  readonly taxYear: Scalars['Int']['output'];
  /** When the tax enrollment was last updated. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The status of the filing process in April for a tax enrollment */
export const TaxEnrollmentAprilAppStatus = {
  /** cancelled */
  Cancelled: 'cancelled',
  /** exempt_from_filing */
  ExemptFromFiling: 'exempt_from_filing',
  /** not_started */
  NotStarted: 'not_started',
  /** questionnaire_completed */
  QuestionnaireCompleted: 'questionnaire_completed',
  /** questionnaire_in_progress */
  QuestionnaireInProgress: 'questionnaire_in_progress',
  /** ready_to_submit */
  ReadyToSubmit: 'ready_to_submit',
  /** submitted */
  Submitted: 'submitted'
} as const;

export type TaxEnrollmentAprilAppStatus = typeof TaxEnrollmentAprilAppStatus[keyof typeof TaxEnrollmentAprilAppStatus];
/** Which tax enrollment banner to display on the tax page */
export const TaxEnrollmentBannerStatus = {
  /** filing_needed */
  FilingNeeded: 'filing_needed',
  /** none */
  None: 'none',
  /** signature_needed */
  SignatureNeeded: 'signature_needed'
} as const;

export type TaxEnrollmentBannerStatus = typeof TaxEnrollmentBannerStatus[keyof typeof TaxEnrollmentBannerStatus];
/** Sort values for tax enrollments table row */
export const TaxEnrollmentSortValues = {
  /** client_name */
  ClientName: 'client_name',
  /** federal_return_status */
  FederalReturnStatus: 'federal_return_status',
  /** filing_type */
  FilingType: 'filing_type',
  /** price */
  Price: 'price',
  /** tax_status */
  TaxStatus: 'tax_status',
  /** tax_year */
  TaxYear: 'tax_year'
} as const;

export type TaxEnrollmentSortValues = typeof TaxEnrollmentSortValues[keyof typeof TaxEnrollmentSortValues];
export const TaxEnrollmentStatus = {
  /** federal_accepted */
  FederalAccepted: 'federal_accepted',
  /** federal_rejected */
  FederalRejected: 'federal_rejected',
  /** federal_submitted */
  FederalSubmitted: 'federal_submitted',
  /** in_progress */
  InProgress: 'in_progress',
  /** not_interested */
  NotInterested: 'not_interested',
  /** not_started */
  NotStarted: 'not_started',
  /** registered */
  Registered: 'registered',
  /** state_accepted */
  StateAccepted: 'state_accepted',
  /** state_rejected */
  StateRejected: 'state_rejected',
  /** state_submitted */
  StateSubmitted: 'state_submitted'
} as const;

export type TaxEnrollmentStatus = typeof TaxEnrollmentStatus[keyof typeof TaxEnrollmentStatus];
export const TaxEnrollmentTypeName = {
  /** external_cpa */
  ExternalCpa: 'external_cpa',
  /** other */
  Other: 'other',
  /** savvy_joint */
  SavvyJoint: 'savvy_joint',
  /** savvy_single */
  SavvySingle: 'savvy_single',
  /** transcript_services_only */
  TranscriptServicesOnly: 'transcript_services_only'
} as const;

export type TaxEnrollmentTypeName = typeof TaxEnrollmentTypeName[keyof typeof TaxEnrollmentTypeName];
export type TaxEnrollmentsTableHeader = {
  readonly __typename?: 'TaxEnrollmentsTableHeader';
  /** Number of clients with missing tax enrollments */
  readonly requireAdvisorActionCount: Scalars['Int']['output'];
  /** Number of clients with tax enrollments but no tax transcript requests */
  readonly requireClientActionCount: Scalars['Int']['output'];
  /** Number of clients with tax transcript requests with status "requested" */
  readonly waitingOnThirdPartyCount: Scalars['Int']['output'];
};

/** A row in the tax enrollments table representing a household's tax enrollment */
export type TaxEnrollmentsTableRow = {
  readonly __typename?: 'TaxEnrollmentsTableRow';
  /** The status of the filing process in April for this tax enrollment */
  readonly aprilAppStatus?: Maybe<TaxEnrollmentAprilAppStatus>;
  /** The client id */
  readonly clientId: Scalars['ID']['output'];
  /** The client associated with the tax enrollment */
  readonly clientName?: Maybe<Scalars['String']['output']>;
  /** When the enrollment was created */
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The status of the tax enrollment */
  readonly enrollmentStatus: TaxEnrollmentStatus;
  /** The type of tax enrollment (single, joint, etc.) */
  readonly enrollmentType?: Maybe<TaxEnrollmentTypeName>;
  /** The status of the federal return */
  readonly federalReturnStatus?: Maybe<TaxReturnStatus>;
  /** The name of the household */
  readonly householdName: Scalars['String']['output'];
  /** The price of the tax enrollment */
  readonly price?: Maybe<Scalars['BigDecimal']['output']>;
  /** The id of the row */
  readonly rowId: Scalars['ID']['output'];
  /** The salesforce id of the household */
  readonly salesforceId?: Maybe<Scalars['String']['output']>;
  /** The state filings for this tax enrollment */
  readonly stateFilings: ReadonlyArray<StateFiling>;
  /** The state return status data (JSONB - deprecated, use state_filings) */
  readonly stateReturnStatusData?: Maybe<Scalars['JSON']['output']>;
  /** The status of the tax enrollment - remove after updating FE to use enrollment_status */
  readonly status: TaxEnrollmentStatus;
  /** The id of the tax enrollment */
  readonly taxEnrollmentId?: Maybe<Scalars['ID']['output']>;
  /** The tax year for this enrollment */
  readonly taxYear?: Maybe<Scalars['Int']['output']>;
  /** The status of the transcript request */
  readonly transcriptStatus?: Maybe<TaxTranscriptRequestStatus>;
};

/** The connection type for TaxEnrollmentsTableRow. */
export type TaxEnrollmentsTableRowConnection = {
  readonly __typename?: 'TaxEnrollmentsTableRowConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<TaxEnrollmentsTableRowEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<TaxEnrollmentsTableRow>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of items in the collection without pagination */
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TaxEnrollmentsTableRowEdge = {
  readonly __typename?: 'TaxEnrollmentsTableRowEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<TaxEnrollmentsTableRow>;
};

export const TaxGroupTypeName = {
  /** Not Available */
  NotAvailable: 'NOT_AVAILABLE',
  /** taxable */
  Taxable: 'TAXABLE',
  /** tax deferred */
  TaxDeferred: 'TAX_DEFERRED',
  /** tax free */
  TaxFree: 'TAX_FREE'
} as const;

export type TaxGroupTypeName = typeof TaxGroupTypeName[keyof typeof TaxGroupTypeName];
/** Tax page data for a household */
export type TaxPage = {
  readonly __typename?: 'TaxPage';
  /** Co-client of the household */
  readonly coClient?: Maybe<TaxPageClient>;
  /** Primary client of the household */
  readonly primaryClient: TaxPageClient;
  /** Downscoped Box preview config for the tax addendum template */
  readonly taxAddendumPreview?: Maybe<TaxAddendumPreview>;
};

/** Client data for the tax page */
export type TaxPageClient = {
  readonly __typename?: 'TaxPageClient';
  /** The client agreements for the user */
  readonly clientAgreements?: Maybe<ReadonlyArray<ClientAgreement>>;
  /** The date and time the onboarding IAA was created for the user */
  readonly onboardingIaaCreatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Tax enrollments for this client */
  readonly taxEnrollments?: Maybe<ReadonlyArray<TaxEnrollment>>;
  /** Tax transcript requests for this client */
  readonly taxTranscriptRequests?: Maybe<ReadonlyArray<TaxTranscriptRequest>>;
  /** Tax transcript data */
  readonly taxTranscripts?: Maybe<ReadonlyArray<TaxTranscript>>;
  /** The full name of the user */
  readonly userFullName: Scalars['String']['output'];
  /** The ID of the user */
  readonly userId: Scalars['ID']['output'];
  /** The KYC status of the user */
  readonly userKycStatus: FootprintStatus;
};

export const TaxReturnStatus = {
  /** accepted */
  Accepted: 'accepted',
  /** filed_pending_response */
  FiledPendingResponse: 'filed_pending_response',
  /** none */
  None: 'none',
  /** not_filed */
  NotFiled: 'not_filed',
  /** rejected */
  Rejected: 'rejected'
} as const;

export type TaxReturnStatus = typeof TaxReturnStatus[keyof typeof TaxReturnStatus];
/** Tax transcript */
export type TaxTranscript = {
  readonly __typename?: 'TaxTranscript';
  /** adjusted gross income */
  readonly adjustedGrossIncome?: Maybe<Scalars['Int']['output']>;
  /** federal tax witheld */
  readonly federalIncomeTaxWitheld?: Maybe<Scalars['Int']['output']>;
  /** tax refund, positive = received from gov, negative = need to pay */
  readonly federalRefund?: Maybe<Scalars['Int']['output']>;
  /** taxes owed to federal gov */
  readonly federalTaxLiability?: Maybe<Scalars['Int']['output']>;
  /** record ID */
  readonly id: Scalars['ID']['output'];
  /** Standard or itemized deduction amount */
  readonly standardOrItemizedDeduction?: Maybe<Scalars['Int']['output']>;
  /** tax year */
  readonly taxYear: Scalars['Int']['output'];
  /** taxable income */
  readonly taxableIncome?: Maybe<Scalars['Int']['output']>;
  /** Total tax deductions */
  readonly totalDeductions?: Maybe<Scalars['Int']['output']>;
  /** total income */
  readonly totalIncome?: Maybe<Scalars['Int']['output']>;
  /** YoY comparisons */
  readonly yoyChange?: Maybe<TaxYoyChange>;
};

/** Tax transcript request for clients. */
export type TaxTranscriptRequest = {
  readonly __typename?: 'TaxTranscriptRequest';
  /** The client for this tax transcript request. */
  readonly client: Client;
  /** When the tax transcript request was created. */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The Savvy ID of the tax transcript request. */
  readonly id: Scalars['ID']['output'];
  /** The status of the tax transcript request. */
  readonly status: TaxTranscriptRequestStatus;
  /** When the tax transcript request was last updated. */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The status of a tax transcript request. */
export const TaxTranscriptRequestStatus = {
  /** completed */
  Completed: 'completed',
  /** requested */
  Requested: 'requested'
} as const;

export type TaxTranscriptRequestStatus = typeof TaxTranscriptRequestStatus[keyof typeof TaxTranscriptRequestStatus];
/** Grouping of portfolio by tax type. */
export type TaxTypeGrouping = {
  readonly __typename?: 'TaxTypeGrouping';
  readonly taxType: TaxGroupTypeName;
  readonly value?: Maybe<Value>;
};

/** Grouping of portfolio by tax type. */
export type TaxTypeGroupingsByPeriod = {
  readonly __typename?: 'TaxTypeGroupingsByPeriod';
  readonly taxTypeGroupings?: Maybe<ReadonlyArray<TaxTypeGrouping>>;
  readonly timePeriod?: Maybe<PerformanceTimePeriodName>;
};

/** YoY percentage changes for tax metrics */
export type TaxYoyChange = {
  readonly __typename?: 'TaxYoyChange';
  /** Year-over-year percentage change in federal refund */
  readonly federalRefundPct?: Maybe<Scalars['Float']['output']>;
  /** Year-over-year percentage change in federal tax liability */
  readonly federalTaxLiabilityPct?: Maybe<Scalars['Float']['output']>;
  /** Year-over-year percentage change in deductions */
  readonly totalDeductionsPct?: Maybe<Scalars['Float']['output']>;
  /** Year-over-year percentage change in total income */
  readonly totalIncomePct?: Maybe<Scalars['Float']['output']>;
};

/** What a candidate template would fail on, checked without writing anything */
export type TemplateUploadPrecheck = {
  readonly __typename?: 'TemplateUploadPrecheck';
  /** True when a finding would refuse the upload */
  readonly blocked: Scalars['Boolean']['output'];
  /** AcroForm fields on the live file */
  readonly currentFieldCount: Scalars['Int']['output'];
  /** What the check found */
  readonly findings: ReadonlyArray<TemplateValidationFinding>;
  /** AcroForm fields on the candidate */
  readonly uploadedFieldCount: Scalars['Int']['output'];
};

/** One result from validating a candidate template against the code that fills it */
export type TemplateValidationFinding = {
  readonly __typename?: 'TemplateValidationFinding';
  /** Machine-readable finding code */
  readonly code: Scalars['String']['output'];
  /** Field names the finding concerns */
  readonly fields: ReadonlyArray<Scalars['String']['output']>;
  /** What it means */
  readonly message: Scalars['String']['output'];
  /** block, warn or info */
  readonly severity: Scalars['String']['output'];
};

/** Text filter with operator and value */
export type TextFilterInput = {
  /** Text filter operator */
  readonly operator: TextFilterOperatorEnum;
  /** Filter value (not required for isEmpty operator) */
  readonly value?: InputMaybe<Scalars['String']['input']>;
};

/** Text filter operators */
export const TextFilterOperatorEnum = {
  /** Contains the value */
  Contains: 'CONTAINS',
  /** Ends with the value */
  EndsWith: 'ENDS_WITH',
  /** Equals the value exactly */
  Equals: 'EQUALS',
  /** Field is empty or null */
  IsEmpty: 'IS_EMPTY',
  /** Starts with the value */
  StartsWith: 'STARTS_WITH'
} as const;

export type TextFilterOperatorEnum = typeof TextFilterOperatorEnum[keyof typeof TextFilterOperatorEnum];
export type TextReplacement = {
  /** Text in the template that identifies the placeholder text to be replaced. */
  readonly placeholder: Scalars['String']['input'];
  /** The text to replace the placeholder with. */
  readonly replaceWithText: Scalars['String']['input'];
};

export const TimeHorizonName = {
  TenPlusYears: 'ten_plus_years',
  ThreeToTenYears: 'three_to_ten_years',
  ZeroToThreeYears: 'zero_to_three_years'
} as const;

export type TimeHorizonName = typeof TimeHorizonName[keyof typeof TimeHorizonName];
/** Autogenerated input type of ToggleCommentReaction */
export type ToggleCommentReactionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment to react to */
  readonly commentId: Scalars['ID']['input'];
  /** One of the fixed reaction emoji offered by the UI */
  readonly emoji: Scalars['String']['input'];
};

/** Autogenerated return type of ToggleCommentReaction. */
export type ToggleCommentReactionPayload = {
  readonly __typename?: 'ToggleCommentReactionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The comment with its updated reactions */
  readonly comment: Comment;
  /** True when the reaction was added, false when it was removed */
  readonly reacted: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TrackEvent */
export type TrackEventInput = {
  readonly alertArchived?: InputMaybe<AlertArchived>;
  readonly alertClicked?: InputMaybe<AlertClicked>;
  readonly alertSnoozed?: InputMaybe<AlertSnoozed>;
  readonly backgroundMeetingPrepDocumentOpen?: InputMaybe<BackgroundMeetingPrepDocumentOpen>;
  readonly backgroundMeetingPrepNotificationClick?: InputMaybe<BackgroundMeetingPrepNotificationClick>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly commentSent?: InputMaybe<CommentSent>;
  readonly elementImpression?: InputMaybe<ElementImpression>;
  readonly elementViewDuration?: InputMaybe<ElementViewDuration>;
  readonly noteDetailOpen?: InputMaybe<NoteDetailOpen>;
  readonly noteDetailViewDuration?: InputMaybe<NoteDetailViewDuration>;
  readonly notificationFlyoutOpened?: InputMaybe<NotificationFlyoutOpened>;
  readonly notificationFlyoutShowAllClicked?: InputMaybe<NotificationFlyoutShowAllClicked>;
  readonly notificationPreferenceChanged?: InputMaybe<NotificationPreferenceChanged>;
  readonly pageImpression?: InputMaybe<PageImpression>;
  readonly pageViewDuration?: InputMaybe<PageViewDuration>;
  readonly pushNotificationOpened?: InputMaybe<PushNotificationOpened>;
  readonly pushNotificationsToggled?: InputMaybe<PushNotificationsToggled>;
  readonly taskCompleted?: InputMaybe<TaskCompleted>;
  readonly taskCreated?: InputMaybe<TaskCreated>;
  readonly taskCreationStarted?: InputMaybe<TaskCreationStarted>;
  readonly taskStatusChanged?: InputMaybe<TaskStatusChanged>;
  readonly taskViewed?: InputMaybe<TaskViewed>;
  readonly userInteraction?: InputMaybe<UserInteraction>;
};

/** Autogenerated return type of TrackEvent. */
export type TrackEventPayload = {
  readonly __typename?: 'TrackEventPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

export type TradingRequest = {
  readonly __typename?: 'TradingRequest';
  readonly account: Scalars['String']['output'];
  readonly additionalDetails?: Maybe<Scalars['String']['output']>;
  readonly holdings: ReadonlyArray<TradingRequestHolding>;
  readonly id: Scalars['ID']['output'];
};

export type TradingRequestHolding = {
  readonly __typename?: 'TradingRequestHolding';
  /** Savvy id of the account the order trades in. */
  readonly accountId?: Maybe<Scalars['ID']['output']>;
  readonly action: Scalars['String']['output'];
  readonly amount: TradingRequestHoldingAmount;
  readonly holdingName: Scalars['String']['output'];
  readonly marketValue?: Maybe<Scalars['String']['output']>;
  /** Orion security id resolved when the order was placed. */
  readonly securityId?: Maybe<Scalars['ID']['output']>;
  /** Security name Orion resolved for the ticker. */
  readonly securityName?: Maybe<Scalars['String']['output']>;
  /** Ticker symbol the advisor entered. */
  readonly ticker?: Maybe<Scalars['String']['output']>;
};

export type TradingRequestHoldingAmount = {
  readonly __typename?: 'TradingRequestHoldingAmount';
  readonly type: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
};

/** Input for creating a trading request */
export type TradingRequestInput = {
  /** The account identifier for the trade */
  readonly account: Scalars['String']['input'];
  /** Additional details or notes about the trade */
  readonly additionalDetails?: InputMaybe<Scalars['String']['input']>;
  /** Array of holdings/securities to trade */
  readonly holdings: ReadonlyArray<Scalars['JSON']['input']>;
};

/** Transaction associated with an account */
export type Transaction = {
  readonly __typename?: 'Transaction';
  /** The Savvy ID of the account associated with the transaction */
  readonly accountId: Scalars['ID']['output'];
  /** The Savvy ID of the transaction. */
  readonly id: Scalars['ID']['output'];
  /** Number of units of the transacted security */
  readonly quantity: Scalars['BigDecimal']['output'];
  /** The Savvy ID of the security associated with the transaction */
  readonly securityId: Scalars['ID']['output'];
  /** Name of transacted security. */
  readonly securityName: Scalars['String']['output'];
  /** Type of transacted security. */
  readonly securityType: SecurityTypeName;
  readonly source: TransactionSourceName;
  /** The unique ID of the transaction given by the source */
  readonly sourceTransactionId: Scalars['ID']['output'];
  /** Status of transaction */
  readonly status: TransactionStatus;
  /** Ticker symbol of transacted security. */
  readonly tickerSymbol: Scalars['String']['output'];
  /** Timestamp for when the transaction occured */
  readonly transactedAt: Scalars['ISO8601DateTime']['output'];
  /** Type of transaction */
  readonly typeOf: TransactionTypeName;
  /** Average value of each security of the transacted asset */
  readonly unitPrice: Scalars['BigDecimal']['output'];
  /** The total value of the transaction */
  readonly value: Scalars['BigDecimal']['output'];
};

export const TransactionSourceName = {
  Moneykit: 'moneykit',
  Orion: 'orion',
  Plaid: 'plaid'
} as const;

export type TransactionSourceName = typeof TransactionSourceName[keyof typeof TransactionSourceName];
export const TransactionStatus = {
  Complete: 'complete',
  Inactive: 'inactive',
  Pending: 'pending',
  PendingCorporateAction: 'pending_corporate_action',
  Rejected: 'rejected',
  Reversed: 'reversed'
} as const;

export type TransactionStatus = typeof TransactionStatus[keyof typeof TransactionStatus];
export const TransactionTypeName = {
  AdministrativeFee: 'administrative_fee',
  AdministrativeFeeAdjustment: 'administrative_fee_adjustment',
  AdrFee: 'adr_fee',
  AdrFeeCredit: 'adr_fee_credit',
  AdvisoryFee: 'advisory_fee',
  AdvisoryFeeCredit: 'advisory_fee_credit',
  AnnuityBonus: 'annuity_bonus',
  BdFee: 'bd_fee',
  BenefitChangeTransferIn: 'benefit_change_transfer_in',
  BenefitChangeTransferOut: 'benefit_change_transfer_out',
  Buy: 'buy',
  BuyExchange: 'buy_exchange',
  BuyFromCustodialCash: 'buy_from_custodial_cash',
  CancelAccount: 'cancel_account',
  CapitalDistribution: 'capital_distribution',
  ClientContribution: 'client_contribution',
  ClientDeposit: 'client_deposit',
  ClientDistribution: 'client_distribution',
  ClientWithdrawal: 'client_withdrawal',
  DeathBenefit: 'death_benefit',
  DecreaseInValue: 'decrease_in_value',
  DividendOffset: 'dividend_offset',
  DividendPaidFromCash: 'dividend_paid_from_cash',
  DividendReinvested: 'dividend_reinvested',
  DividendTax: 'dividend_tax',
  DividendToCash: 'dividend_to_cash',
  EmployerContribution: 'employer_contribution',
  EmployerDistribution: 'employer_distribution',
  ExternalAccountActivityIn: 'external_account_activity_in',
  ExternalAccountActivityOut: 'external_account_activity_out',
  FederalTaxWithheld: 'federal_tax_withheld',
  FeeCredit: 'fee_credit',
  FolioBalanceAdjustment: 'folio_balance_adjustment',
  FolioContribution: 'folio_contribution',
  FolioDistribution: 'folio_distribution',
  ForeignDividendTax: 'foreign_dividend_tax',
  ForeignTaxPaid: 'foreign_tax_paid',
  ForeignTaxWithheld: 'foreign_tax_withheld',
  FundFee: 'fund_fee',
  FundFeeAdjustment: 'fund_fee_adjustment',
  IdleCashInterest: 'idle_cash_interest',
  IncomePaid: 'income_paid',
  IncomeReinvested: 'income_reinvested',
  IncreaseInValue: 'increase_in_value',
  InterestPaid: 'interest_paid',
  InterestPaidE: 'interest_paid_e',
  InterestPaidInCash: 'interest_paid_in_cash',
  InterestReceivable: 'interest_receivable',
  InterestReinvested: 'interest_reinvested',
  InternalAccountInNotBilled: 'internal_account_in_not_billed',
  InternalAccountOutNotBilled: 'internal_account_out_not_billed',
  JournalIn: 'journal_in',
  JournalOut: 'journal_out',
  LegalAndAccountingFees: 'legal_and_accounting_fees',
  LoanDefault: 'loan_default',
  LoanDistribution: 'loan_distribution',
  LoanInterestPaid: 'loan_interest_paid',
  LoanPayment: 'loan_payment',
  LoanRepayment: 'loan_repayment',
  LoanSetup: 'loan_setup',
  LongTermGainNegativeAdjustment: 'long_term_gain_negative_adjustment',
  LongTermGainReinvested: 'long_term_gain_reinvested',
  LongTermGainTax: 'long_term_gain_tax',
  LongTermGainToCash: 'long_term_gain_to_cash',
  MAndEBandTransferIn: 'm_and_e_band_transfer_in',
  MAndEBandTransferOut: 'm_and_e_band_transfer_out',
  ManagementFee: 'management_fee',
  ManagementStyleChangeIn: 'management_style_change_in',
  ManagementStyleChangeOut: 'management_style_change_out',
  MarginInterestCredit: 'margin_interest_credit',
  MergeInExchange: 'merge_in_exchange',
  MergeInFromOtherAccount: 'merge_in_from_other_account',
  MergeOutExchange: 'merge_out_exchange',
  MergeOutToOtherAccount: 'merge_out_to_other_account',
  OptionAssigned: 'option_assigned',
  OptionExercised: 'option_exercised',
  OptionExpired: 'option_expired',
  OrfFee: 'orf_fee',
  PriorReturnOfBondPrincipal: 'prior_return_of_bond_principal',
  QualifiedDividendReinvested: 'qualified_dividend_reinvested',
  QualifiedDividendToCash: 'qualified_dividend_to_cash',
  RedemptionFee: 'redemption_fee',
  Remark: 'remark',
  ReportableTransferIn: 'reportable_transfer_in',
  ReturnOfBondPrincipal: 'return_of_bond_principal',
  ReturnOfCapital: 'return_of_capital',
  Reversal: 'reversal',
  ReverseStockSplit: 'reverse_stock_split',
  RfsTransactionFee: 'rfs_transaction_fee',
  RolloverContribution: 'rollover_contribution',
  SecFee: 'sec_fee',
  Sell: 'sell',
  SellExchange: 'sell_exchange',
  SellToCustodialCash: 'sell_to_custodial_cash',
  ShortStartingValue: 'short_starting_value',
  ShortTermGainReinvested: 'short_term_gain_reinvested',
  ShortTermGainTax: 'short_term_gain_tax',
  ShortTermGainToCash: 'short_term_gain_to_cash',
  SpinOffIn: 'spin_off_in',
  SpinOffOut: 'spin_off_out',
  StartingValue: 'starting_value',
  StateTaxWithheld: 'state_tax_withheld',
  StepUpBuy: 'step_up_buy',
  StockSplit: 'stock_split',
  SystematicWithdrawal: 'systematic_withdrawal',
  TaxBasisNegativeAdjustment: 'tax_basis_negative_adjustment',
  TaxBasisPositiveAdjustment: 'tax_basis_positive_adjustment',
  TaxCredit: 'tax_credit',
  TaxFreeExchangeIn: 'tax_free_exchange_in',
  TaxFreeExchangeOut: 'tax_free_exchange_out',
  TaxesWithheld: 'taxes_withheld',
  TradingExpense: 'trading_expense',
  TransactionFee: 'transaction_fee',
  TransferInNonTaxable: 'transfer_in_non_taxable',
  TransferOutNonTaxable: 'transfer_out_non_taxable',
  UnknownContribution: 'unknown_contribution',
  UnknownCostBasis: 'unknown_cost_basis',
  UnknownDistribution: 'unknown_distribution',
  WireFee: 'wire_fee',
  WireFeeCredit: 'wire_fee_credit'
} as const;

export type TransactionTypeName = typeof TransactionTypeName[keyof typeof TransactionTypeName];
/** One transaction type's count and summed value over a date range */
export type TransactionTypeTotal = {
  readonly __typename?: 'TransactionTypeTotal';
  /** How many displayable transactions of this type fall in the range */
  readonly count: Scalars['Int']['output'];
  /** Sum of those transactions' value, each signed as recorded */
  readonly totalValue: Scalars['BigDecimal']['output'];
  /** Type of transaction */
  readonly typeOf: TransactionTypeName;
};

/** Response containing transcript consent text from April */
export type TranscriptConsentFormResponse = {
  readonly __typename?: 'TranscriptConsentFormResponse';
  /** The address line 1 of the client */
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  /** The address line 2 of the client */
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  /** The city of the client */
  readonly city?: Maybe<Scalars['String']['output']>;
  /** The consent text if successful */
  readonly consentText?: Maybe<Scalars['String']['output']>;
  /** Error message if consent textrequest failed */
  readonly consentTextError?: Maybe<Scalars['String']['output']>;
  /** The date of birth of the client */
  readonly dateOfBirth?: Maybe<Scalars['String']['output']>;
  /** The first name of the client */
  readonly firstName: Scalars['String']['output'];
  /** The ID of the client */
  readonly id: Scalars['ID']['output'];
  /** The last name of the client */
  readonly lastName: Scalars['String']['output'];
  /** The middle name of the client */
  readonly middleName?: Maybe<Scalars['String']['output']>;
  /** The phone number of the client */
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The social security number of the client */
  readonly socialSecurityNumber?: Maybe<Scalars['String']['output']>;
  /** The state of the client */
  readonly state?: Maybe<Scalars['String']['output']>;
  /** The zip code of the client */
  readonly zipCode?: Maybe<Scalars['String']['output']>;
};

export const TranscriptKind = {
  /** DialpadCallTranscript */
  DialpadCallTranscript: 'DialpadCallTranscript',
  /** MeetingRecording */
  MeetingRecording: 'MeetingRecording',
  /** ZoomMeetingTranscript */
  ZoomMeetingTranscript: 'ZoomMeetingTranscript'
} as const;

export type TranscriptKind = typeof TranscriptKind[keyof typeof TranscriptKind];
/** Input for transfer of assets task specific data */
export type TransferOfAssetsInput = {
  /** Savvy account IDs that will receive the transferred assets */
  readonly accountIds: ReadonlyArray<Scalars['String']['input']>;
  /** Name on the account at the contra custodian */
  readonly accountName: Scalars['String']['input'];
  /** Account number at the contra custodian */
  readonly accountNumber: Scalars['String']['input'];
  /** Legal registration type (e.g. Individual, Joint, Trust) */
  readonly accountRegistration: Scalars['String']['input'];
  /** The sending institution (e.g. Vanguard, Fidelity) */
  readonly contraCustodian: Scalars['String']['input'];
  /** Details of what to transfer when transfer_type is partial */
  readonly partialTransferDetails?: InputMaybe<Scalars['String']['input']>;
  /** Type of transfer: full or partial */
  readonly transferType: Scalars['String']['input'];
};

/** Transfer of assets request data associated with a task */
export type TransferOfAssetsRequest = {
  readonly __typename?: 'TransferOfAssetsRequest';
  /** IDs of the receiving Savvy accounts. */
  readonly accountIds: ReadonlyArray<Scalars['String']['output']>;
  /** Name on the account at the contra custodian. */
  readonly accountName: Scalars['String']['output'];
  /** Account number at the contra custodian. */
  readonly accountNumber: Scalars['String']['output'];
  /** Legal registration of the account (e.g. Individual, Joint). */
  readonly accountRegistration: Scalars['String']['output'];
  /** The sending institution (e.g. Vanguard, TD Ameritrade). */
  readonly contraCustodian: Scalars['String']['output'];
  /** The Savvy ID of the request. */
  readonly id: Scalars['ID']['output'];
  /** Details of what to transfer (only set when transfer_type is partial). */
  readonly partialTransferDetails?: Maybe<Scalars['String']['output']>;
  /** Whether the transfer is full or partial. */
  readonly transferType: Scalars['String']['output'];
};

export type TrendingHeadline = {
  readonly __typename?: 'TrendingHeadline';
  readonly headline: Scalars['String']['output'];
  readonly publishedDate: Scalars['ISO8601DateTime']['output'];
  readonly sentiment: NewsSentimentName;
  readonly text: Scalars['String']['output'];
  readonly tickers: ReadonlyArray<Scalars['String']['output']>;
};

/** Autogenerated input type of UnarchiveHousehold */
export type UnarchiveHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to unarchive */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnarchiveHousehold. */
export type UnarchiveHouseholdPayload = {
  readonly __typename?: 'UnarchiveHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the household stage was updated */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnarchiveServiceCatalogItemGroup */
export type UnarchiveServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnarchiveServiceCatalogItemGroup. */
export type UnarchiveServiceCatalogItemGroupPayload = {
  readonly __typename?: 'UnarchiveServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Service catalog item group */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
};

/** Autogenerated input type of UnassignServiceCatalogItemFromHousehold */
export type UnassignServiceCatalogItemFromHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Household id */
  readonly householdId: Scalars['ID']['input'];
  /** Service catalog item id */
  readonly serviceCatalogItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnassignServiceCatalogItemFromHousehold. */
export type UnassignServiceCatalogItemFromHouseholdPayload = {
  readonly __typename?: 'UnassignServiceCatalogItemFromHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Service catalog item household */
  readonly serviceCatalogItemHousehold?: Maybe<ServiceCatalogItemHousehold>;
};

/** Autogenerated input type of UnenrollHouseholdsFromServiceCatalogItemGroup */
export type UnenrollHouseholdsFromServiceCatalogItemGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Households to unenroll: at least one, at most 25 per call. Duplicates are
   * collapsed; every id must exist and be reachable, or the whole call is refused.
   * At most 200 enrollments to remove — the matching active assignment rows, which
   * include items since removed from the service and items now archived, not
   * households x active items
   */
  readonly householdIds: ReadonlyArray<Scalars['ID']['input']>;
  /** The service (template) to unenroll from; an archived service still accepts unenrollment */
  readonly serviceCatalogItemGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnenrollHouseholdsFromServiceCatalogItemGroup. */
export type UnenrollHouseholdsFromServiceCatalogItemGroupPayload = {
  readonly __typename?: 'UnenrollHouseholdsFromServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Households whose unenrollment rolled back; their enrollments are unchanged */
  readonly failedHouseholdCount: Scalars['Int']['output'];
  /** Per-household outcome, in the order the households were given */
  readonly results: ReadonlyArray<ServiceCatalogUnenrollmentResult>;
  /** Households with no active enrollment in this service; nothing changed for them */
  readonly skippedHouseholdCount: Scalars['Int']['output'];
  /** Households whose enrollments in this service were paused */
  readonly unenrolledHouseholdCount: Scalars['Int']['output'];
};

/** Autogenerated input type of UnlinkHouseholdCoClient */
export type UnlinkHouseholdCoClientInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Expected co-client email address, as returned by get_household_detail */
  readonly coClientEmail: Scalars['String']['input'];
  /** Household UUID */
  readonly householdPublicId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlinkHouseholdCoClient. */
export type UnlinkHouseholdCoClientPayload = {
  readonly __typename?: 'UnlinkHouseholdCoClientPayload';
  /** Whether the household stopped resolving the named co-client */
  readonly changed: Scalars['Boolean']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Email of the co-client this call detached */
  readonly coClientEmail?: Maybe<Scalars['String']['output']>;
  /** Why the household is still not clean, when it is not */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** Verified household UUID */
  readonly householdPublicId: Scalars['ID']['output'];
  /** Whether the household resolves no co-client after this call */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnlinkInteractionFromServiceOccurrence */
export type UnlinkInteractionFromServiceOccurrenceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Which household's link to remove. Required, not derived: one interaction can
   * satisfy an occurrence in every household whose client attended
   */
  readonly householdId: Scalars['ID']['input'];
  /** The interaction id */
  readonly timelineItemId: Scalars['ID']['input'];
  /** The interaction type */
  readonly timelineItemType: ItemTypeEnum;
};

/** Autogenerated return type of UnlinkInteractionFromServiceOccurrence. */
export type UnlinkInteractionFromServiceOccurrencePayload = {
  readonly __typename?: 'UnlinkInteractionFromServiceOccurrencePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** False when the occurrence row the link named is gone or has since moved off done, in which case only the link was removed */
  readonly statusRestored: Scalars['Boolean']['output'];
  /** True once the link is gone */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnlinkOrionHousehold */
export type UnlinkOrionHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the household to unlink from Orion */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlinkOrionHousehold. */
export type UnlinkOrionHouseholdPayload = {
  readonly __typename?: 'UnlinkOrionHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the household was unlinked from Orion */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnlinkTask */
export type UnlinkTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Savvy ID of the link to remove. */
  readonly taskLinkId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlinkTask. */
export type UnlinkTaskPayload = {
  readonly __typename?: 'UnlinkTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the removed link. */
  readonly deletedTaskLinkId: Scalars['ID']['output'];
};

/** Autogenerated input type of UnlinkTimelineItemFromContact */
export type UnlinkTimelineItemFromContactInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The contact id */
  readonly contactId: Scalars['ID']['input'];
  /** Polymorphic contact type: CenterOfInfluenceRep or Contact */
  readonly contactType: Scalars['String']['input'];
  /** The timeline item id */
  readonly timelineItemId: Scalars['ID']['input'];
  /** The timeline item type */
  readonly timelineItemType: ItemTypeEnum;
};

/** Autogenerated return type of UnlinkTimelineItemFromContact. */
export type UnlinkTimelineItemFromContactPayload = {
  readonly __typename?: 'UnlinkTimelineItemFromContactPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the pair is unlinked (true even if it was already unlinked) */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnregisterPushToken */
export type UnregisterPushTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Expo push token to remove */
  readonly token: Scalars['String']['input'];
};

/** Autogenerated return type of UnregisterPushToken. */
export type UnregisterPushTokenPayload = {
  readonly __typename?: 'UnregisterPushTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Always true; deletion is idempotent */
  readonly success: Scalars['Boolean']['output'];
};

/** Information about unsupported account types */
export type UnsupportedAccount = {
  readonly __typename?: 'UnsupportedAccount';
  /** Account number */
  readonly accountNumber?: Maybe<Scalars['String']['output']>;
  /** Account type (IRA or Personal) */
  readonly accountType: Scalars['String']['output'];
  /** Account ID */
  readonly id: Scalars['ID']['output'];
  /** Account name */
  readonly name: Scalars['String']['output'];
  /** Serialized ira_type or personal_account_type that triggered CSA review */
  readonly specificType: Scalars['String']['output'];
};

/** Autogenerated input type of UpdateAccount */
export type UpdateAccountInput = {
  readonly accountNumber?: InputMaybe<Scalars['String']['input']>;
  readonly beneficiaries?: InputMaybe<ReadonlyArray<BeneficiaryInput>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly currencyCode?: InputMaybe<Scalars['String']['input']>;
  readonly currentBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly custody?: InputMaybe<AccountCustodyName>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  readonly customNote?: InputMaybe<Scalars['String']['input']>;
  readonly deleteCustomName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deleteCustomNote?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hiddenFromNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Purpose of this account */
  readonly purpose?: InputMaybe<Scalars['String']['input']>;
  /** Custom purpose when purpose is set to other */
  readonly purposeOther?: InputMaybe<Scalars['String']['input']>;
  /** Source of the funds for this account */
  readonly sourceOfFunds?: InputMaybe<Scalars['String']['input']>;
  /** Custom source of funds when source_of_funds is set to other */
  readonly sourceOfFundsOther?: InputMaybe<Scalars['String']['input']>;
  readonly subtype?: InputMaybe<AccountSubtypeName>;
  readonly type?: InputMaybe<AccountTypeName>;
  readonly voidedCheckRequested?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateAccount. */
export type UpdateAccountPayload = {
  readonly __typename?: 'UpdateAccountPayload';
  readonly account: Account;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAccountSleeve */
export type UpdateAccountSleeveInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly customName?: InputMaybe<Scalars['String']['input']>;
  readonly customNote?: InputMaybe<Scalars['String']['input']>;
  readonly deleteCustomName?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deleteCustomNote?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateAccountSleeve. */
export type UpdateAccountSleevePayload = {
  readonly __typename?: 'UpdateAccountSleevePayload';
  readonly accountSleeve: AccountSleeve;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAccountTransferDatum */
export type UpdateAccountTransferDatumInput = {
  readonly accountName: Scalars['String']['input'];
  readonly accountNumber: Scalars['String']['input'];
  readonly accountOwner: AccountOwner;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateAccountTransferDatum. */
export type UpdateAccountTransferDatumPayload = {
  readonly __typename?: 'UpdateAccountTransferDatumPayload';
  readonly accountTransferDatum: AccountTransferDatum;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateActionCenterVisited */
export type UpdateActionCenterVisitedInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateActionCenterVisited. */
export type UpdateActionCenterVisitedPayload = {
  readonly __typename?: 'UpdateActionCenterVisitedPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAddress */
export type UpdateAddressInput = {
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly countryCode?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  readonly state?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAddress. */
export type UpdateAddressPayload = {
  readonly __typename?: 'UpdateAddressPayload';
  readonly address: Address;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAdvisorAiDisclosureAcceptance */
export type UpdateAdvisorAiDisclosureAcceptanceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAdvisorAiDisclosureAcceptance. */
export type UpdateAdvisorAiDisclosureAcceptancePayload = {
  readonly __typename?: 'UpdateAdvisorAiDisclosureAcceptancePayload';
  readonly advisorProfile: Advisor;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAdvisorAlertSettings */
export type UpdateAdvisorAlertSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly settings?: InputMaybe<AlertSettingsInput>;
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateAdvisorAlertSettings. */
export type UpdateAdvisorAlertSettingsPayload = {
  readonly __typename?: 'UpdateAdvisorAlertSettingsPayload';
  readonly advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAdvisorCaptiveStatus */
export type UpdateAdvisorCaptiveStatusInput = {
  /** User id of the advisor */
  readonly advisorId: Scalars['ID']['input'];
  /** Whether the advisor is employed under Savvy's RIA (captive) rather than running their own book (owned) */
  readonly captive: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAdvisorCaptiveStatus. */
export type UpdateAdvisorCaptiveStatusPayload = {
  readonly __typename?: 'UpdateAdvisorCaptiveStatusPayload';
  /** The updated advisor */
  readonly advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAdvisorCsa */
export type UpdateAdvisorCsaInput = {
  readonly advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly csaId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateAdvisorCsa. */
export type UpdateAdvisorCsaPayload = {
  readonly __typename?: 'UpdateAdvisorCsaPayload';
  readonly advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAdvisorDirectoryProfile */
export type UpdateAdvisorDirectoryProfileInput = {
  /** Whether to list the advisor in the directory. False deactivates their listing. */
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show the computed AUM band on the profile. */
  readonly aumShareOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Advisor bio. */
  readonly bio?: InputMaybe<Scalars['String']['input']>;
  /** City. */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Designations, e.g. ["CFP®"]. */
  readonly credentials?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** Client-facing DBA email address. Blank clears it (falls back to login email). */
  readonly dbaEmail?: InputMaybe<Scalars['String']['input']>;
  /** Raw intake question→answer pairs to persist, in order. */
  readonly intakeAnswers?: InputMaybe<ReadonlyArray<IntakeAnswerInput>>;
  /** Canonical spoken-language keys (from directoryLanguages). */
  readonly languageKeys?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** LinkedIn profile URL. */
  readonly linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /** Advisor phone number for client-facing reports. Blank clears it. */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Prior firm. */
  readonly priorFirm?: InputMaybe<Scalars['String']['input']>;
  /** Canonical specialty keys (from directorySpecialties). */
  readonly specialtyKeys?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** State. */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** Advisor title. */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** Years of experience. */
  readonly yearsExperience?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of UpdateAdvisorGroupSettings */
export type UpdateAdvisorGroupSettingsInput = {
  readonly advisorGroupId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly settings: AdvisorGroupSettingsInput;
};

/** Autogenerated return type of UpdateAdvisorGroupSettings. */
export type UpdateAdvisorGroupSettingsPayload = {
  readonly __typename?: 'UpdateAdvisorGroupSettingsPayload';
  readonly advisorGroup: AdvisorGroup;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAdvisorOnboardingCohort */
export type UpdateAdvisorOnboardingCohortInput = {
  /** User id of the advisor */
  readonly advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the advisor is a new advisor or an existing one. Null clears the classification back to unknown. */
  readonly onboardingCohort?: InputMaybe<AdvisorOnboardingCohort>;
};

/** Autogenerated return type of UpdateAdvisorOnboardingCohort. */
export type UpdateAdvisorOnboardingCohortPayload = {
  readonly __typename?: 'UpdateAdvisorOnboardingCohortPayload';
  /** The updated advisor */
  readonly advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAdvisorProfile */
export type UpdateAdvisorProfileInput = {
  readonly bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateAdvisorProfile. */
export type UpdateAdvisorProfilePayload = {
  readonly __typename?: 'UpdateAdvisorProfilePayload';
  readonly advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAdvisorSettings */
export type UpdateAdvisorSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly settings?: InputMaybe<AdvisorSettingsInput>;
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateAdvisorSettings. */
export type UpdateAdvisorSettingsPayload = {
  readonly __typename?: 'UpdateAdvisorSettingsPayload';
  readonly advisor: Advisor;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateAlert */
export type UpdateAlertInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly snoozedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly status?: InputMaybe<AlertStatusName>;
  readonly surfaceAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of UpdateAlert. */
export type UpdateAlertPayload = {
  readonly __typename?: 'UpdateAlertPayload';
  readonly alert: Alert;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAsset */
export type UpdateAssetInput = {
  readonly assetClass?: InputMaybe<AssetClassName>;
  readonly assetSubclass?: InputMaybe<AssetSubclassName>;
  readonly chimneyAddressCity?: InputMaybe<Scalars['String']['input']>;
  readonly chimneyAddressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly chimneyAddressState?: InputMaybe<Scalars['String']['input']>;
  readonly chimneyAddressZip?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyEquityCompanyName?: InputMaybe<Scalars['String']['input']>;
  readonly companyEquityCompanyTicker?: InputMaybe<Scalars['String']['input']>;
  readonly companyEquityCurrentPrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly companyEquityExercisePrice?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly companyEquityGrantType?: InputMaybe<Scalars['String']['input']>;
  readonly companyEquitySharesIssued?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly companyEquityVestingCliff?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly companyEquityVestingDuration?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly companyEquityVestingRate?: InputMaybe<Scalars['String']['input']>;
  readonly companyEquityVestingStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly costBasis?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly currencyCode?: InputMaybe<Scalars['String']['input']>;
  readonly currentValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hiddenFromNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly refreshChimneyData?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateAsset. */
export type UpdateAssetPayload = {
  readonly __typename?: 'UpdateAssetPayload';
  readonly asset: Asset;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateClientDetails */
export type UpdateClientDetailsInput = {
  /**
   * Deprecated: use addresses instead
   * @deprecated Use addresses
   */
  readonly address?: InputMaybe<AddressInput>;
  /** The addresses of the user */
  readonly addresses?: InputMaybe<ReadonlyArray<AddressInput>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The client profile of the user */
  readonly clientProfile?: InputMaybe<ClientProfileInput>;
  /** The email address of the user */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the user */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** The last name of the user */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** The (optional) legal middle name of the user */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the user */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The preferred name of the user */
  readonly preferredName?: InputMaybe<Scalars['String']['input']>;
  /** The secondary emails of the user */
  readonly secondaryEmails?: InputMaybe<ReadonlyArray<SecondaryEmailInput>>;
  /** The secondary phones of the user */
  readonly secondaryPhones?: InputMaybe<ReadonlyArray<SecondaryPhoneInput>>;
  /** The ID of the user */
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateClientDetails. */
export type UpdateClientDetailsPayload = {
  readonly __typename?: 'UpdateClientDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly success: Scalars['Boolean']['output'];
  /** The user */
  readonly user?: Maybe<User>;
};

/** Autogenerated input type of UpdateClientEmploymentDetails */
export type UpdateClientEmploymentDetailsInput = {
  /** The annual gross income of the user */
  readonly annualGrossIncome?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the employer */
  readonly employerName?: InputMaybe<Scalars['String']['input']>;
  /** The employment status of the user */
  readonly employmentStatus?: InputMaybe<EmploymentStatusName>;
  /** The job title of the user */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** The retirement date of the user */
  readonly retirementDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The university of the user */
  readonly university?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user */
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateClientEmploymentDetails. */
export type UpdateClientEmploymentDetailsPayload = {
  readonly __typename?: 'UpdateClientEmploymentDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Client Profile */
  readonly clientProfile?: Maybe<Client>;
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly success: Scalars['Boolean']['output'];
};

/** Input for updating a client profile and its associated user */
export type UpdateClientInput = {
  /** Address details */
  readonly address?: InputMaybe<AddressInput>;
  /** Client profile details including SSN and date of birth */
  readonly clientProfile?: InputMaybe<ClientProfileInput>;
  /** The ID of the client profile */
  readonly clientProfileId: Scalars['ID']['input'];
  /** Email address */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** Middle name */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Preferred name */
  readonly preferredName?: InputMaybe<Scalars['String']['input']>;
  /** The new role for the client (primary or member) */
  readonly role?: InputMaybe<ClientRole>;
  /** Secondary email addresses */
  readonly secondaryEmails?: InputMaybe<ReadonlyArray<SecondaryEmailInput>>;
  /** Secondary phone numbers */
  readonly secondaryPhones?: InputMaybe<ReadonlyArray<SecondaryPhoneInput>>;
};

/** Autogenerated input type of UpdateClientIntakeData */
export type UpdateClientIntakeDataInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dataKey: Scalars['String']['input'];
  readonly dataType?: InputMaybe<Scalars['String']['input']>;
  readonly dataValue: Scalars['JSON']['input'];
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateClientIntakeData. */
export type UpdateClientIntakeDataPayload = {
  readonly __typename?: 'UpdateClientIntakeDataPayload';
  readonly clientIntakeData: ClientIntakeData;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateClientPortalMessage */
export type UpdateClientPortalMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly coClientHasRead?: InputMaybe<Scalars['Boolean']['input']>;
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly primaryClientHasRead?: InputMaybe<Scalars['Boolean']['input']>;
  readonly salesforceAccountId: Scalars['String']['input'];
  readonly status?: InputMaybe<ClientPortalMessageStatusName>;
};

/** Autogenerated return type of UpdateClientPortalMessage. */
export type UpdateClientPortalMessagePayload = {
  readonly __typename?: 'UpdateClientPortalMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientPortalMessage?: Maybe<ClientPortalMessage>;
};

/** Autogenerated input type of UpdateClientProfile */
export type UpdateClientProfileInput = {
  readonly annualGrossIncome?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** 2 letter country code for client citizenship */
  readonly citizenship?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly coManagerSsn?: InputMaybe<Scalars['String']['input']>;
  readonly dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** The date the client passed away, if applicable. ISO8601 date string. */
  readonly dateOfDeath?: InputMaybe<Scalars['String']['input']>;
  readonly employerName?: InputMaybe<Scalars['String']['input']>;
  readonly employmentStatus?: InputMaybe<EmploymentStatusName>;
  readonly id: Scalars['ID']['input'];
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Client occupation */
  readonly occupation?: InputMaybe<Scalars['String']['input']>;
  readonly soloPropEntityName?: InputMaybe<Scalars['String']['input']>;
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
  readonly stage?: InputMaybe<ClientStage>;
};

/** Autogenerated return type of UpdateClientProfile. */
export type UpdateClientProfilePayload = {
  readonly __typename?: 'UpdateClientProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientProfile: Client;
};

/** Autogenerated input type of UpdateClients */
export type UpdateClientsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Array of client updates */
  readonly clientUpdates: ReadonlyArray<UpdateClientInput>;
  /** The ID of the household */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateClients. */
export type UpdateClientsPayload = {
  readonly __typename?: 'UpdateClientsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of error messages if the operation failed */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The updated household */
  readonly household?: Maybe<Household>;
  /** Whether the update was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateCommentAttachmentSync */
export type UpdateCommentAttachmentSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The attachment to update */
  readonly commentAttachmentId: Scalars['ID']['input'];
  /**
   * True files a copy of the attachment under the client-visible Additional
   * Materials folder; false deletes that copy. The Box work happens here, so the
   * id stored and the object it names are written by the same actor.
   */
  readonly syncedToBox: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateCommentAttachmentSync. */
export type UpdateCommentAttachmentSyncPayload = {
  readonly __typename?: 'UpdateCommentAttachmentSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated attachment */
  readonly commentAttachment: CommentAttachment;
};

/** Autogenerated input type of UpdateComment */
export type UpdateCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The comment to edit */
  readonly commentId: Scalars['ID']['input'];
  /** Replacement plain text, may contain @Full Name mentions */
  readonly content: Scalars['String']['input'];
  /**
   * Replacement thread header. Omit to leave it as it is; pass null or an empty
   * string to remove it. Only valid on a thread root.
   */
  readonly subject?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateComment. */
export type UpdateCommentPayload = {
  readonly __typename?: 'UpdateCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The comment after the edit */
  readonly comment: Comment;
};

/** Autogenerated input type of UpdateContact */
export type UpdateContactInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** Relation of the contact */
  readonly relation?: InputMaybe<BeneficiaryRelationship>;
};

/** Autogenerated return type of UpdateContact. */
export type UpdateContactPayload = {
  readonly __typename?: 'UpdateContactPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contact?: Maybe<Contact>;
};

/** Autogenerated input type of UpdateDialpadCallNotes */
export type UpdateDialpadCallNotesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the DialpadCall to update */
  readonly id: Scalars['ID']['input'];
  /** Notes to set on the DialpadCall */
  readonly notes: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateDialpadCallNotes. */
export type UpdateDialpadCallNotesPayload = {
  readonly __typename?: 'UpdateDialpadCallNotesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated DialpadCall */
  readonly dialpadCall?: Maybe<DialpadCall>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the update was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateDialpadEventContent */
export type UpdateDialpadEventContentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Content to update on the DialpadEvent */
  readonly content: Scalars['String']['input'];
  /** Dialpad ID to find the event (alternative to id) */
  readonly dialpadId?: InputMaybe<Scalars['BigInt']['input']>;
  /** ID of the DialpadEvent to update */
  readonly id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateDialpadEventContent. */
export type UpdateDialpadEventContentPayload = {
  readonly __typename?: 'UpdateDialpadEventContentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated DialpadEvent */
  readonly dialpadEvent?: Maybe<DialpadEvent>;
};

/** Autogenerated input type of UpdateEciCitizenshipTaxStatus */
export type UpdateEciCitizenshipTaxStatusInput = {
  /** Alien registration number (A-Number / USCIS number) for permanent residents and non-citizens */
  readonly alienId?: InputMaybe<Scalars['String']['input']>;
  /** Countries of citizenship (ISO-3166-1 alpha-2) */
  readonly citizenshipCodes: ReadonlyArray<Scalars['String']['input']>;
  /** Whether claiming tax treaty benefits (W-8BEN path) */
  readonly claimingTreatyBenefits: Scalars['Boolean']['input'];
  /**
   * Write on behalf of this client. Ignored on the MagicLink path; on a session it
   * is only honoured for an advisor who could impersonate them.
   */
  readonly clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Country of tax residence (ISO-3166-1 alpha-2, W-8BEN path) */
  readonly countryOfTaxResidence?: InputMaybe<Scalars['String']['input']>;
  /** Foreign tax identification number (W-8BEN path) */
  readonly foreignTaxId?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty article and paragraph */
  readonly treatyArticleParagraph?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty country (ISO-3166-1 alpha-2) */
  readonly treatyCountryCode?: InputMaybe<Scalars['String']['input']>;
  /** Tax treaty rate of withholding */
  readonly treatyWithholdingRate?: InputMaybe<Scalars['String']['input']>;
  /** US citizenship status: one of citizen, permanent_resident, non_citizen */
  readonly usCitizenshipStatus?: InputMaybe<Scalars['String']['input']>;
  /** Whether the applicant is a U.S. resident */
  readonly usTaxResident: Scalars['Boolean']['input'];
  /** Whether the W-9 certification was acknowledged (U.S. path) */
  readonly w9Certification: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateEciCitizenshipTaxStatus. */
export type UpdateEciCitizenshipTaxStatusPayload = {
  readonly __typename?: 'UpdateEciCitizenshipTaxStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateEciCurrentStep */
export type UpdateEciCurrentStepInput = {
  /**
   * Write on behalf of this client. Ignored on the MagicLink path; on a session it
   * is only honoured for an advisor who could impersonate them.
   */
  readonly clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The step the client has just completed */
  readonly currentStep: EciCurrentStep;
};

/** Autogenerated return type of UpdateEciCurrentStep. */
export type UpdateEciCurrentStepPayload = {
  readonly __typename?: 'UpdateEciCurrentStepPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the cursor write succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateEciFinancialProfile */
export type UpdateEciFinancialProfileInput = {
  /** Annual household income, in cents */
  readonly annualIncomeCents: Scalars['BigInt']['input'];
  /**
   * Write on behalf of this client. Ignored on the MagicLink path; on a session it
   * is only honoured for an advisor who could impersonate them.
   */
  readonly clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** One of: limited, good, extensive */
  readonly investingExperience: Scalars['String']['input'];
  /** One of: growth, income, preservation, speculation */
  readonly investmentObjective: Scalars['String']['input'];
  /** Liquid net worth, in cents */
  readonly liquidNetWorthCents: Scalars['BigInt']['input'];
  /** One of: conservative, moderate, aggressive */
  readonly riskTolerance: Scalars['String']['input'];
  /** One of: short_term, medium_term, long_term */
  readonly timeHorizon: Scalars['String']['input'];
  /** Total net worth, in cents */
  readonly totalNetWorthCents: Scalars['BigInt']['input'];
};

/** Autogenerated return type of UpdateEciFinancialProfile. */
export type UpdateEciFinancialProfilePayload = {
  readonly __typename?: 'UpdateEciFinancialProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateEciPersonalInformation */
export type UpdateEciPersonalInformationInput = {
  /**
   * Write on behalf of this client. Ignored on the MagicLink path; on a session it
   * is only honoured for an advisor who could impersonate them.
   */
  readonly clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth (ISO 8601) */
  readonly dateOfBirth: Scalars['ISO8601Date']['input'];
  /** Email address */
  readonly email: Scalars['String']['input'];
  /** Employer name (required by model when employment_status is employed or self_employed) */
  readonly employerName?: InputMaybe<Scalars['String']['input']>;
  /** One of: employed, self_employed, student, homemaker, retired, non_employed */
  readonly employmentStatus: Scalars['String']['input'];
  /** Legal first name */
  readonly firstName: Scalars['String']['input'];
  /** Home address */
  readonly homeAddress: StrictAddressInput;
  /** Job title (required by model when employment_status is employed or self_employed) */
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Legal last name */
  readonly lastName: Scalars['String']['input'];
  /** Additional legal residence when other than the United States */
  readonly legalResidence?: InputMaybe<Scalars['String']['input']>;
  /** Mailing address; required when mailing_address_same_as_home is false */
  readonly mailingAddress?: InputMaybe<StrictAddressInput>;
  /** Whether the mailing address is the same as home; when true, home is copied into mailing */
  readonly mailingAddressSameAsHome: Scalars['Boolean']['input'];
  /** Legal middle name */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** Occupation category for custodian opening envelopes */
  readonly occupation: ClientOccupation;
  /** Phone number; accepts formatted US input or E.164. Stored as E.164. */
  readonly phoneNumber: Scalars['String']['input'];
  /** SSN; XXX-XX-XXXX format */
  readonly ssn: Scalars['String']['input'];
  /** Suffix */
  readonly suffix?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateEciPersonalInformation. */
export type UpdateEciPersonalInformationPayload = {
  readonly __typename?: 'UpdateEciPersonalInformationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateEciRegulatoryDisclosure */
export type UpdateEciRegulatoryDisclosureInput = {
  /** Is an accredited investor */
  readonly accreditedInvestor: Scalars['Boolean']['input'];
  /** Associated with a US registered broker-dealer */
  readonly brokerDealerAssociated: Scalars['Boolean']['input'];
  /** Required when broker_dealer_associated is true */
  readonly brokerDealerDetail?: InputMaybe<BrokerDealerDetailInput>;
  /**
   * Write on behalf of this client. Ignored on the MagicLink path; on a session it
   * is only honoured for an advisor who could impersonate them.
   */
  readonly clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Self or household member is a director / 10%+ shareholder / executive officer of a public company */
  readonly directorOr10pctShareholder: Scalars['Boolean']['input'];
  /** Required when director_or_10pct_shareholder is true */
  readonly directorOrShareholderDetail?: InputMaybe<DirectorOrShareholderDetailInput>;
  /** Self or household member is registered with / employed by a FINRA member firm */
  readonly finraMemberFirmAssociated: Scalars['Boolean']['input'];
  /** Associated with a US registered investment advisor */
  readonly registeredInvestmentAdvisorAssociated: Scalars['Boolean']['input'];
  /** Self or immediate family is a senior political figure */
  readonly seniorPoliticalFigure: Scalars['Boolean']['input'];
  /** Required when senior_political_figure is true */
  readonly seniorPoliticalFigureDetail?: InputMaybe<SeniorPoliticalFigureDetailInput>;
};

/** Autogenerated return type of UpdateEciRegulatoryDisclosure. */
export type UpdateEciRegulatoryDisclosurePayload = {
  readonly __typename?: 'UpdateEciRegulatoryDisclosurePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the upsert succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateEnrollment */
export type UpdateEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Target wizard step (step1 through step5). */
  readonly currentStep: Scalars['String']['input'];
  /** The enrollment's uuid. */
  readonly uuid: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateEnrollment. */
export type UpdateEnrollmentPayload = {
  readonly __typename?: 'UpdateEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated enrollment. */
  readonly enrollment?: Maybe<AdvisorOnboardingEnrollment>;
  /** Any errors that occurred. */
  readonly errors?: Maybe<ReadonlyArray<MutationError>>;
  /** Whether the operation succeeded. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateFamilyMember */
export type UpdateFamilyMemberInput = {
  /** Street address line 1 */
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Street address line 2 */
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** City */
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth in ISO format */
  readonly dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /**
   * The household this contact depends on, when the dependency is on the household
   * rather than one client. Mutually exclusive with dependentOfUserId
   */
  readonly dependentOfHouseholdId?: InputMaybe<Scalars['ID']['input']>;
  /** The client this contact depends on. Mutually exclusive with dependentOfHouseholdId */
  readonly dependentOfUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Email address */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Entity date established in ISO format */
  readonly entityDateEstablished?: InputMaybe<Scalars['String']['input']>;
  /** Entity date of death in ISO format */
  readonly entityDateOfDeath?: InputMaybe<Scalars['String']['input']>;
  /** Entity EIN */
  readonly entityEin?: InputMaybe<Scalars['String']['input']>;
  /** Executor name for estate entities */
  readonly entityExecutorName?: InputMaybe<Scalars['String']['input']>;
  /** Entity display name */
  readonly entityName?: InputMaybe<Scalars['String']['input']>;
  /** Organization type for organization entities */
  readonly entityOrganizationType?: InputMaybe<Scalars['String']['input']>;
  /** Primary contact role for organization entities */
  readonly entityPrimaryContactRole?: InputMaybe<Scalars['String']['input']>;
  /** Trust type for trust entities */
  readonly entityTrustType?: InputMaybe<Scalars['String']['input']>;
  /** Trustee name for trust entities */
  readonly entityTrusteeName?: InputMaybe<Scalars['String']['input']>;
  /** Entity type for Trust, Organization, or Estate contacts */
  readonly entityType?: InputMaybe<Scalars['String']['input']>;
  /** Legal first name */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the household */
  readonly householdId: Scalars['ID']['input'];
  /** ID of the family member to update */
  readonly id: Scalars['ID']['input'];
  /** Whether this contact is a beneficiary */
  readonly isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether this contact is financially dependent on a client. Advisor context
   * only — it does not feed dependent counts on client intake, account-opening or
   * account-maintenance requests, and does not feed tax projection. Sending this
   * makes dependentOfHouseholdId and dependentOfUserId authoritative: a named
   * target replaces the stored one and an omitted pair clears it. Omit all three
   * to leave the dependency untouched
   */
  readonly isDependent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this contact is a trusted contact */
  readonly isTrustedContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Legal last name */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** Legal middle name */
  readonly middleName?: InputMaybe<Scalars['String']['input']>;
  /** Preferred nickname */
  readonly nickname?: InputMaybe<Scalars['String']['input']>;
  /** Freeform notes about the contact */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Relationship to the household */
  readonly relation?: InputMaybe<BeneficiaryRelationship>;
  /** Social Security Number */
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
  /** State */
  readonly state?: InputMaybe<Scalars['String']['input']>;
  /** ZIP / postal code */
  readonly zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateFamilyMember. */
export type UpdateFamilyMemberPayload = {
  readonly __typename?: 'UpdateFamilyMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated family member */
  readonly familyMember: FamilyMember;
};

/** Autogenerated input type of UpdateFeeSchedule */
export type UpdateFeeScheduleInput = {
  /** The type of amount for the fee schedule */
  readonly amountType?: InputMaybe<FeeScheduleAmountTypes>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the fee schedule */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The type of fee schedule */
  readonly feeType?: InputMaybe<FeeScheduleFeeTypes>;
  /** The flat fee amount for the fee schedule */
  readonly flatFeeAmount?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The ID of the fee schedule to update */
  readonly id: Scalars['ID']['input'];
  /** The minimum fee for the fee schedule */
  readonly minimumFee?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The name of the fee schedule */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The tiers for the fee schedule */
  readonly tiers?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of UpdateFeeSchedule. */
export type UpdateFeeSchedulePayload = {
  readonly __typename?: 'UpdateFeeSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if updating was not successful */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** The fee schedule that was updated */
  readonly feeSchedule?: Maybe<FeeSchedule>;
  /** Whether the fee schedule was updated */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateFinancialOffering */
export type UpdateFinancialOfferingInput = {
  /** Editable rich-text body (HTML); sanitized server-side before save */
  readonly bodyHtml?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Short card description (required, <= 150 chars) */
  readonly description: Scalars['String']['input'];
  /** Optional note shown beneath the Fee structure section */
  readonly feeStructureDescription?: InputMaybe<Scalars['String']['input']>;
  /** Full set of fee rows */
  readonly fees: ReadonlyArray<FinancialOfferingDetailInput>;
  /** Offering id */
  readonly id: Scalars['ID']['input'];
  /** Full set of key-fact rows */
  readonly keyFacts: ReadonlyArray<FinancialOfferingDetailInput>;
  /** Optional note shown beneath the Key facts section */
  readonly keyFactsDescription?: InputMaybe<Scalars['String']['input']>;
  /** Full set of link rows */
  readonly links: ReadonlyArray<FinancialOfferingLinkInput>;
  /** Optimistic-concurrency token from the offering as loaded */
  readonly lockVersion: Scalars['Int']['input'];
  /** Long description shown on the detail page */
  readonly longDescription?: InputMaybe<Scalars['String']['input']>;
  /** Offering name / card title (<= 100 chars); rejected on system-managed offerings */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Per-provider copy updates */
  readonly providers: ReadonlyArray<FinancialOfferingProviderInput>;
};

/** Autogenerated return type of UpdateFinancialOffering. */
export type UpdateFinancialOfferingPayload = {
  readonly __typename?: 'UpdateFinancialOfferingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated offering */
  readonly financialOffering?: Maybe<FinancialOffering>;
};

/** Autogenerated input type of UpdateGoal */
export type UpdateGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly percentFunded?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly status?: InputMaybe<GoalStatusName>;
  readonly targetUsd?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly type?: InputMaybe<GoalTypeName>;
};

/** Autogenerated return type of UpdateGoal. */
export type UpdateGoalPayload = {
  readonly __typename?: 'UpdateGoalPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly goal: Goal;
};

/** Autogenerated input type of UpdateHouseholdAccess */
export type UpdateHouseholdAccessInput = {
  /** edit or no access */
  readonly accessLevel: HouseholdAccessLevel;
  /** advisor we are updating access for */
  readonly advisorUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** household we are updating permissions of */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateHouseholdAccess. */
export type UpdateHouseholdAccessPayload = {
  readonly __typename?: 'UpdateHouseholdAccessPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** failures */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** successes */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateHousehold */
export type UpdateHouseholdInput = {
  /** Whether this household is an accredited investor */
  readonly accreditedInvestor?: InputMaybe<Scalars['Boolean']['input']>;
  /** The rationale for why this household is an accredited investor */
  readonly accreditedInvestorRationale?: InputMaybe<Scalars['String']['input']>;
  /** The lead source category for this household. Must be one of Query.leadSources */
  readonly advisorLeadSource?: InputMaybe<Scalars['String']['input']>;
  /** The dependent lead source detail. Must be one of the details the chosen category offers; cleared when it is not. */
  readonly advisorLeadSourceDetail?: InputMaybe<Scalars['String']['input']>;
  /** The bio/summary information for this household */
  readonly bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The date this household signed the contract */
  readonly contractSignatureDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The reason this household was disqualified */
  readonly disqualifiedReason?: InputMaybe<Scalars['String']['input']>;
  /** The estimated AUM for this household */
  readonly estimatedAum?: InputMaybe<Scalars['Int']['input']>;
  /** Family information for this household */
  readonly familyInfo?: InputMaybe<Scalars['String']['input']>;
  /** The fee schedule for this household */
  readonly feeSchedule?: InputMaybe<Scalars['String']['input']>;
  /** The lead funnel stage of this household */
  readonly householdStage?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the household to update */
  readonly id: Scalars['ID']['input'];
  /** The reason this household was lost */
  readonly lossReason?: InputMaybe<Scalars['String']['input']>;
  /** The name of the household */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** The probability of closing for this household */
  readonly probabilityOfClosing?: InputMaybe<Scalars['String']['input']>;
  /** Whether this household is a qualified client */
  readonly qualifiedClient?: InputMaybe<Scalars['Boolean']['input']>;
  /** The rationale for why this household is a qualified client */
  readonly qualifiedClientRationale?: InputMaybe<Scalars['String']['input']>;
  /** Whether this household is a qualified purchaser */
  readonly qualifiedPurchaser?: InputMaybe<Scalars['Boolean']['input']>;
  /** The rationale for why this household is a qualified purchaser */
  readonly qualifiedPurchaserRationale?: InputMaybe<Scalars['String']['input']>;
  /** The contact for the referral */
  readonly referralContact?: InputMaybe<Scalars['String']['input']>;
  /** The name of the referral contact */
  readonly referralContactName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the entity (User or CenterOfInfluenceRep) that referred this household */
  readonly referralEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** The type of the referral entity (User or CenterOfInfluenceRep) */
  readonly referralEntityType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateHouseholdMember */
export type UpdateHouseholdMemberInput = {
  /** Whether the member can sign client agreements for the household. */
  readonly canSignClientAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the member is an account holder on household accounts. */
  readonly isAccountHolder?: InputMaybe<Scalars['Boolean']['input']>;
  /** The household membership to update. */
  readonly membershipId: Scalars['ID']['input'];
  /** The member's role in the household. */
  readonly role?: InputMaybe<HouseholdMembershipRole>;
  /** Free-form description of the member's trustee capacity, if applicable. */
  readonly trusteeCapacity?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateHouseholdMember. */
export type UpdateHouseholdMemberPayload = {
  readonly __typename?: 'UpdateHouseholdMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated household membership. */
  readonly membership: HouseholdMembership;
};

/** Autogenerated return type of UpdateHousehold. */
export type UpdateHouseholdPayload = {
  readonly __typename?: 'UpdateHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The household that was updated */
  readonly household: Household;
};

/** Autogenerated input type of UpdateHouseholdReferral */
export type UpdateHouseholdReferralInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The referral id */
  readonly id: Scalars['ID']['input'];
  /** The month the referral happened (null clears it) */
  readonly referredOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of UpdateHouseholdReferral. */
export type UpdateHouseholdReferralPayload = {
  readonly __typename?: 'UpdateHouseholdReferralPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated referral */
  readonly referral?: Maybe<HouseholdReferral>;
};

/** Autogenerated input type of UpdateHouseholdTags */
export type UpdateHouseholdTagsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly householdId: Scalars['ID']['input'];
  readonly organizationHouseholdTagIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateHouseholdTags. */
export type UpdateHouseholdTagsPayload = {
  readonly __typename?: 'UpdateHouseholdTagsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly household: Household;
};

/** Autogenerated input type of UpdateLiability */
export type UpdateLiabilityInput = {
  readonly acquiredAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly annualInterestPercent?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly currencyCode?: InputMaybe<Scalars['String']['input']>;
  readonly currentBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly hiddenFromClient?: InputMaybe<Scalars['Boolean']['input']>;
  readonly hiddenFromNetWorth?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly originalBalance?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly providerName?: InputMaybe<Scalars['String']['input']>;
  readonly timeToMaturity?: InputMaybe<Scalars['Int']['input']>;
  readonly type?: InputMaybe<LiabilityTypeName>;
};

/** Autogenerated return type of UpdateLiability. */
export type UpdateLiabilityPayload = {
  readonly __typename?: 'UpdateLiabilityPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly liability: Liability;
};

/** Autogenerated input type of UpdateMeetingAgendaTemplate */
export type UpdateMeetingAgendaTemplateInput = {
  /** The agenda outline */
  readonly body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When to use this template */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The template ID */
  readonly id: Scalars['ID']['input'];
  /** The template title */
  readonly title?: InputMaybe<Scalars['String']['input']>;
  /** private (creator only) or firm-wide */
  readonly visibility?: InputMaybe<MeetingAgendaTemplateVisibility>;
};

/** Autogenerated return type of UpdateMeetingAgendaTemplate. */
export type UpdateMeetingAgendaTemplatePayload = {
  readonly __typename?: 'UpdateMeetingAgendaTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated template */
  readonly meetingAgendaTemplate?: Maybe<MeetingAgendaTemplate>;
};

/** Autogenerated input type of UpdateNote */
export type UpdateNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly content?: InputMaybe<Scalars['String']['input']>;
  readonly householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly id: Scalars['ID']['input'];
  readonly isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly topics?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
};

/** Autogenerated return type of UpdateNote. */
export type UpdateNotePayload = {
  readonly __typename?: 'UpdateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** Autogenerated input type of UpdateNotificationRoute */
export type UpdateNotificationRouteInput = {
  /** The catalog alert type to update. */
  readonly alertType: NotificationRouteAlert;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The destination: inbox, activity, or off. */
  readonly destination: NotificationRouteDestination;
  /** ID of the user whose route to update. */
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateNotificationRoute. */
export type UpdateNotificationRoutePayload = {
  readonly __typename?: 'UpdateNotificationRoutePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Effective catalog notification routing after the update. */
  readonly routing: ReadonlyArray<NotificationRoutePreference>;
  /** Whether the update succeeded. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateOnboardingPersonalization */
export type UpdateOnboardingPersonalizationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Base64-encoded firm logo (PNG or JPG, ≤2MB). Uploaded to Cloudinary; the returned URL is stored. */
  readonly firmLogoBase64?: InputMaybe<Scalars['String']['input']>;
  /** Advisor firm name used for onboarding email branding */
  readonly firmName?: InputMaybe<Scalars['String']['input']>;
  /** When true, clears the stored firm logo. Ignored when a new firm_logo_base64 is provided in the same call. */
  readonly shouldDeleteLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom welcome message shown to onboarding clients */
  readonly welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOnboardingPersonalization. */
export type UpdateOnboardingPersonalizationPayload = {
  readonly __typename?: 'UpdateOnboardingPersonalizationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors?: Maybe<ReadonlyArray<MutationError>>;
  /** The updated personalization record */
  readonly onboardingPersonalization?: Maybe<AdvisorOnboardingPersonalization>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateOnboardingTaskData */
export type UpdateOnboardingTaskDataInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The custodian associated with the onboarding task */
  readonly custodian?: InputMaybe<Scalars['String']['input']>;
  /** Docusign envelope ID. Pass empty string to clear. */
  readonly docusignEnvelopeId?: InputMaybe<Scalars['String']['input']>;
  /** Salesforce task ID */
  readonly salesforceTaskId: Scalars['String']['input'];
  /** Box file ID. Pass empty string to clear. */
  readonly signableDocumentBoxFileId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOnboardingTaskData. */
export type UpdateOnboardingTaskDataPayload = {
  readonly __typename?: 'UpdateOnboardingTaskDataPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * The custodian associated with the onboarding task
   * @deprecated Use onboardingTask.custodian instead
   */
  readonly custodian: Scalars['String']['output'];
  /**
   * Docusign envelope ID
   * @deprecated Use onboardingTask.docusignEnvelopeId instead
   */
  readonly docusignEnvelopeId?: Maybe<Scalars['String']['output']>;
  /** The updated onboarding task data */
  readonly onboardingTask: OnboardingTaskDatum;
  /**
   * Box file ID
   * @deprecated Use onboardingTask.signableDocumentBoxFileId instead
   */
  readonly signableDocumentBoxFileId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateOpportunity */
export type UpdateOpportunityInput = {
  readonly arr?: InputMaybe<Scalars['Int']['input']>;
  readonly aum?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Client Profile ID this opportunity this belongs to */
  readonly clientProfileId?: InputMaybe<Scalars['ID']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** expected close date */
  readonly expectedCloseDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Next steps to close client */
  readonly nextSteps?: InputMaybe<Scalars['String']['input']>;
  /** next steps due date */
  readonly nextStepsDueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** ID to edit */
  readonly opportunityId: Scalars['ID']['input'];
  /** Prob of closing */
  readonly probabilityOfClosing?: InputMaybe<ProbabilityOfClosing>;
  /** Status */
  readonly status?: InputMaybe<OpportunityStatus>;
};

/** Autogenerated return type of UpdateOpportunity. */
export type UpdateOpportunityPayload = {
  readonly __typename?: 'UpdateOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly opportunity?: Maybe<Opportunity>;
};

/** Autogenerated input type of UpdateOrganizationBranding */
export type UpdateOrganizationBrandingInput = {
  /** Branding configuration to update */
  readonly brandingInput: OrganizationBrandingInput;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOrganizationBranding. */
export type UpdateOrganizationBrandingPayload = {
  readonly __typename?: 'UpdateOrganizationBrandingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors?: Maybe<ReadonlyArray<MutationError>>;
  /** The updated organization branding */
  readonly organizationBranding?: Maybe<OrganizationBranding>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateOrganizationHouseholdCategory */
export type UpdateOrganizationHouseholdCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly emoji?: InputMaybe<Scalars['String']['input']>;
  readonly hexColorCode?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOrganizationHouseholdCategory. */
export type UpdateOrganizationHouseholdCategoryPayload = {
  readonly __typename?: 'UpdateOrganizationHouseholdCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly organizationHouseholdCategory?: Maybe<OrganizationHouseholdCategory>;
};

/** Autogenerated input type of UpdateOrganizationHouseholdTagHouseholds */
export type UpdateOrganizationHouseholdTagHouseholdsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The desired final set of advisor-managed household IDs that should carry this
   * tag. Existing applications not in this list will be removed.
   */
  readonly householdIds: ReadonlyArray<Scalars['ID']['input']>;
  /** The tag whose household applications are being synced. */
  readonly organizationHouseholdTagId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateOrganizationHouseholdTagHouseholds. */
export type UpdateOrganizationHouseholdTagHouseholdsPayload = {
  readonly __typename?: 'UpdateOrganizationHouseholdTagHouseholdsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated tag, with refreshed household_count. */
  readonly organizationHouseholdTag?: Maybe<OrganizationHouseholdTag>;
};

/** Autogenerated input type of UpdateOrganizationHouseholdTag */
export type UpdateOrganizationHouseholdTagInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly isSmart?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly organizationHouseholdCategoryId?: InputMaybe<Scalars['ID']['input']>;
  readonly ruleJson?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of UpdateOrganizationHouseholdTag. */
export type UpdateOrganizationHouseholdTagPayload = {
  readonly __typename?: 'UpdateOrganizationHouseholdTagPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly organizationHouseholdTag?: Maybe<OrganizationHouseholdTag>;
};

/** Autogenerated input type of UpdateOrganizationSettings */
export type UpdateOrganizationSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Settings to update. Omitted fields are left unchanged. */
  readonly settings: OrganizationSettingsInput;
};

/** Autogenerated return type of UpdateOrganizationSettings. */
export type UpdateOrganizationSettingsPayload = {
  readonly __typename?: 'UpdateOrganizationSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated organization */
  readonly organization: Organization;
  /** Whether the settings were saved */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateOrganizationTaskInstructions */
export type UpdateOrganizationTaskInstructionsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ops instructions message. Pass an empty string to clear it. */
  readonly taskInstructionsForOps: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateOrganizationTaskInstructions. */
export type UpdateOrganizationTaskInstructionsPayload = {
  readonly __typename?: 'UpdateOrganizationTaskInstructionsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated organization */
  readonly organization: Organization;
};

/** Autogenerated input type of UpdateOrionReportEnrollments */
export type UpdateOrionReportEnrollmentsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the households should be enrolled for the report type */
  readonly enrolled: Scalars['Boolean']['input'];
  /** IDs of accounts to exclude from the report (Savvy account IDs) */
  readonly excludedAccountIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** IDs of households to update */
  readonly householdIds: ReadonlyArray<Scalars['ID']['input']>;
  /** The Orion report type to update */
  readonly reportType: OrionReport;
};

/** Autogenerated return type of UpdateOrionReportEnrollments. */
export type UpdateOrionReportEnrollmentsPayload = {
  readonly __typename?: 'UpdateOrionReportEnrollmentsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** List of errors that occurred during the update */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the update was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdatePlanFinancialSnapshot */
export type UpdatePlanFinancialSnapshotInput = {
  /** Snapshot as-of date */
  readonly asOfDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Plan assets stored as integer cents */
  readonly assetsCents?: InputMaybe<Scalars['BigInt']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Snapshot ID */
  readonly id: Scalars['ID']['input'];
  /** Number of participants */
  readonly participantCount?: InputMaybe<Scalars['Int']['input']>;
  /** Quarter period (e.g. 2026-Q1) */
  readonly period?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdatePlanFinancialSnapshot. */
export type UpdatePlanFinancialSnapshotPayload = {
  readonly __typename?: 'UpdatePlanFinancialSnapshotPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated snapshot */
  readonly planFinancialSnapshot?: Maybe<PlanFinancialSnapshot>;
};

/** Autogenerated input type of UpdatePlan */
export type UpdatePlanInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `inputsRevision` the edited plan was loaded with. A save from an older revision is refused. */
  readonly inputsRevision: Scalars['Int']['input'];
  /** The whole plan: the household, what it owns and owes, what comes in and goes out, and what it is saving for. */
  readonly planData: PlanningPlanDataInput;
  /** The plan to replace, as returned by the `plan` query. */
  readonly planId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePlan. */
export type UpdatePlanPayload = {
  readonly __typename?: 'UpdatePlanPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The plan as it now stands. */
  readonly plan: PlanningPlan;
};

/** Autogenerated input type of UpdatePortfolio */
export type UpdatePortfolioInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly investmentObjective?: InputMaybe<InvestmentObjectiveName>;
  readonly riskAssessment?: InputMaybe<RiskAssessmentName>;
  readonly taxSensitivity?: InputMaybe<PortfolioTaxSensitivityName>;
  readonly timeHorizon?: InputMaybe<TimeHorizonName>;
};

/** Autogenerated return type of UpdatePortfolio. */
export type UpdatePortfolioPayload = {
  readonly __typename?: 'UpdatePortfolioPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  readonly portfolio?: Maybe<Portfolio>;
};

/** Autogenerated input type of UpdatePortfolioStrategy */
export type UpdatePortfolioStrategyInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Portfolio strategy ID */
  readonly id: Scalars['ID']['input'];
  /** New strategy name */
  readonly strategyName: Scalars['String']['input'];
};

/** Autogenerated return type of UpdatePortfolioStrategy. */
export type UpdatePortfolioStrategyPayload = {
  readonly __typename?: 'UpdatePortfolioStrategyPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Validation errors */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Updated portfolio strategy */
  readonly portfolioStrategy?: Maybe<PortfolioStrategy>;
};

/** Autogenerated input type of UpdateProfessionalService */
export type UpdateProfessionalServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The professional service id */
  readonly id: Scalars['ID']['input'];
  /** Category of contact, for a retirement plan */
  readonly retirementPlanContactGroup?: InputMaybe<ProfessionalRelationshipContactGroup>;
  /** Whether the contact is active, for a retirement plan */
  readonly retirementPlanContactStatus?: InputMaybe<ProfessionalRelationshipContactStatus>;
  /** The professional's role, e.g. CPA */
  readonly role?: InputMaybe<Scalars['String']['input']>;
  /** The month the professional started serving it */
  readonly startedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of UpdateProfessionalService. */
export type UpdateProfessionalServicePayload = {
  readonly __typename?: 'UpdateProfessionalServicePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The edited service */
  readonly professionalService?: Maybe<ProfessionalService>;
};

/** Autogenerated input type of UpdateProspectOpportunity */
export type UpdateProspectOpportunityInput = {
  readonly arr?: InputMaybe<Scalars['Int']['input']>;
  readonly aum?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly expectedCloseDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly householdStage?: InputMaybe<HouseholdStage>;
  readonly nextSteps?: InputMaybe<Scalars['String']['input']>;
  readonly nextStepsDueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  readonly opportunityId: Scalars['ID']['input'];
  readonly probabilityOfClosing?: InputMaybe<ProbabilityOfClosing>;
};

/** Autogenerated return type of UpdateProspectOpportunity. */
export type UpdateProspectOpportunityPayload = {
  readonly __typename?: 'UpdateProspectOpportunityPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly opportunity?: Maybe<Opportunity>;
};

/** Autogenerated input type of UpdateProviderAccount */
export type UpdateProviderAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly plaidPublicToken?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProviderAccount. */
export type UpdateProviderAccountPayload = {
  readonly __typename?: 'UpdateProviderAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly providerAccount: ProviderAccount;
};

/** Autogenerated input type of UpdateReferral */
export type UpdateReferralInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The referral id */
  readonly id: Scalars['ID']['input'];
  /** Notes on the referral */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** The month the referral happened */
  readonly referredOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of UpdateReferral. */
export type UpdateReferralPayload = {
  readonly __typename?: 'UpdateReferralPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The edited referral */
  readonly referral?: Maybe<Referral>;
};

/** Autogenerated input type of UpdateReportSchedule */
export type UpdateReportScheduleInput = {
  /** Enable or pause the schedule */
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Upload generated PDFs to Box */
  readonly deliverToBox?: InputMaybe<Scalars['Boolean']['input']>;
  /** Publish generated reports to the client portal */
  readonly deliverToPortal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Day of month (1-28) */
  readonly deliveryDay?: InputMaybe<Scalars['Int']['input']>;
  /** Month (1-12) for annual schedules; omit to preserve, or pass null to use January */
  readonly deliveryMonth?: InputMaybe<Scalars['Int']['input']>;
  /** monthly | quarterly | annually */
  readonly frequency?: InputMaybe<Scalars['String']['input']>;
  /** Schedule to update */
  readonly id: Scalars['ID']['input'];
  /**
   * Custom PDF filename pattern; supports {template_name}, {household_name},
   * {date}, {quarter}, {year}, {month}. Omit to preserve, or pass null to use the
   * default pattern
   */
  readonly pdfFilenamePattern?: InputMaybe<Scalars['String']['input']>;
  /** Require advisor approval before delivering generated reports */
  readonly requireReview?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateReportSchedule. */
export type UpdateReportSchedulePayload = {
  readonly __typename?: 'UpdateReportSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated schedule */
  readonly reportSchedule: ReportSchedule;
};

/** Autogenerated input type of UpdateReportTemplate */
export type UpdateReportTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New configuration payload */
  readonly config?: InputMaybe<Scalars['JsonHash']['input']>;
  /** ID of the template to update */
  readonly id: Scalars['ID']['input'];
  /** New display name */
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateReportTemplate. */
export type UpdateReportTemplatePayload = {
  readonly __typename?: 'UpdateReportTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated template */
  readonly savedReportTemplate: SavedReportTemplate;
};

/** Autogenerated input type of UpdateRetirementPlanDesign */
export type UpdateRetirementPlanDesignInput = {
  /** ADP/ACP test method (current year / prior year) */
  readonly adpAcpTestMethod?: InputMaybe<Scalars['String']['input']>;
  /** Automatic enrollment terms, if any */
  readonly automaticEnrollment?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Compensation definition (e.g. W-2, 415, 3401(a)) */
  readonly compensationDefinition?: InputMaybe<Scalars['String']['input']>;
  /** Compensation exclusions */
  readonly compensationExclusions?: InputMaybe<Scalars['String']['input']>;
  /** Default deferral percentage under automatic enrollment */
  readonly defaultDeferralPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** Deferral eligibility rule */
  readonly deferralEligibility?: InputMaybe<Scalars['String']['input']>;
  /** Deferral entry dates */
  readonly deferralEntryDates?: InputMaybe<Scalars['String']['input']>;
  /** Employee classes excluded from the plan */
  readonly excludedEmployeeClasses?: InputMaybe<Scalars['String']['input']>;
  /** HCE determination method */
  readonly hceDetermination?: InputMaybe<Scalars['String']['input']>;
  /** Match eligibility rule */
  readonly matchEligibility?: InputMaybe<Scalars['String']['input']>;
  /** Match entry dates */
  readonly matchEntryDates?: InputMaybe<Scalars['String']['input']>;
  /** Match formula */
  readonly matchFormula?: InputMaybe<Scalars['String']['input']>;
  /** Match vesting schedule */
  readonly matchVestingSchedule?: InputMaybe<Scalars['String']['input']>;
  /** Payroll frequency */
  readonly payrollFrequency?: InputMaybe<Scalars['String']['input']>;
  /** Payroll provider (e.g. Paycom, ADP) */
  readonly payrollProvider?: InputMaybe<Scalars['String']['input']>;
  /** Profit sharing eligibility rule */
  readonly profitSharingEligibility?: InputMaybe<Scalars['String']['input']>;
  /** Profit sharing entry dates */
  readonly profitSharingEntryDates?: InputMaybe<Scalars['String']['input']>;
  /** Profit sharing formula */
  readonly profitSharingFormula?: InputMaybe<Scalars['String']['input']>;
  /** Profit sharing vesting schedule */
  readonly profitSharingVestingSchedule?: InputMaybe<Scalars['String']['input']>;
  /** The plan this design belongs to */
  readonly retirementPlanId: Scalars['ID']['input'];
  /** Safe harbor terms, if any */
  readonly safeHarbor?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanDesign. */
export type UpdateRetirementPlanDesignPayload = {
  readonly __typename?: 'UpdateRetirementPlanDesignPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created or updated design */
  readonly retirementPlanDesign?: Maybe<RetirementPlanDesign>;
};

/** Autogenerated input type of UpdateRetirementPlan */
export type UpdateRetirementPlanInput = {
  /** Advisor-defined freeform notes about this plan */
  readonly additionalNotes?: InputMaybe<Scalars['String']['input']>;
  /** Sponsor address(es) */
  readonly address?: InputMaybe<Scalars['String']['input']>;
  /** Advisory effective date */
  readonly advisoryEffectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Advisory type */
  readonly advisoryType?: InputMaybe<Scalars['String']['input']>;
  /** Annual fee stored as integer cents */
  readonly annualFeeCents?: InputMaybe<Scalars['BigInt']['input']>;
  /** Annual fee as a percentage */
  readonly annualFeePercent?: InputMaybe<Scalars['Float']['input']>;
  /** Billing method */
  readonly billingMethod?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the person who signed the contract */
  readonly contractSignedBy?: InputMaybe<Scalars['String']['input']>;
  /** Date the contract was signed */
  readonly contractSignedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Corporate structure */
  readonly corporateStructure?: InputMaybe<Scalars['String']['input']>;
  /** Employer Identification Number */
  readonly ein?: InputMaybe<Scalars['String']['input']>;
  /** Fee source */
  readonly feeSource?: InputMaybe<Scalars['String']['input']>;
  /** Fee structure */
  readonly feeStructure?: InputMaybe<Scalars['String']['input']>;
  /** Fiduciary type */
  readonly fiduciaryType?: InputMaybe<Scalars['String']['input']>;
  /** Linked household (pass null to unlink) */
  readonly householdId?: InputMaybe<Scalars['ID']['input']>;
  /** Database ID of the retirement plan */
  readonly id: Scalars['ID']['input'];
  /** Plan name */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Plan owners/partners */
  readonly owners?: InputMaybe<Scalars['String']['input']>;
  /** Parent company */
  readonly parentCompany?: InputMaybe<Scalars['String']['input']>;
  /** Plan inception date */
  readonly planInceptionDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Plan type */
  readonly planType?: InputMaybe<Scalars['String']['input']>;
  /** Plan year end date */
  readonly planYearEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Prior employers whose service counts toward eligibility */
  readonly predecessorService?: InputMaybe<Scalars['String']['input']>;
  /** Recordkeeper name */
  readonly recordkeeper?: InputMaybe<Scalars['String']['input']>;
  /** Recordkeeper plan ID */
  readonly recordkeeperPlanId?: InputMaybe<Scalars['String']['input']>;
  /** Service type */
  readonly serviceType?: InputMaybe<Scalars['String']['input']>;
  /** Plan status: on_track | at_risk | overdue */
  readonly status?: InputMaybe<Scalars['String']['input']>;
  /** TPA name */
  readonly tpa?: InputMaybe<Scalars['String']['input']>;
  /** Sponsor's website */
  readonly website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateRetirementPlanMilestone */
export type UpdateRetirementPlanMilestoneInput = {
  /** Category: regulatory | plan_change | committee_meeting | other | invoice | education | email */
  readonly category?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Due date (pass null to clear) */
  readonly dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Milestone ID */
  readonly id: Scalars['ID']['input'];
  /** Advisor profile ID of the team member logging this (null to clear) */
  readonly loggedById?: InputMaybe<Scalars['ID']['input']>;
  /** Milestone name */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Free-text notes */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** Status: on_track | due_soon | overdue | done */
  readonly status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanMilestone. */
export type UpdateRetirementPlanMilestonePayload = {
  readonly __typename?: 'UpdateRetirementPlanMilestonePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated milestone */
  readonly retirementPlanMilestone?: Maybe<RetirementPlanMilestone>;
};

/** Autogenerated input type of UpdateRetirementPlanNote */
export type UpdateRetirementPlanNoteInput = {
  /** Note body text */
  readonly body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Note ID */
  readonly id: Scalars['ID']['input'];
  /** Date the note applies to */
  readonly notedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Note title (null to clear) */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanNote. */
export type UpdateRetirementPlanNotePayload = {
  readonly __typename?: 'UpdateRetirementPlanNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated note */
  readonly retirementPlanNote?: Maybe<RetirementPlanNote>;
};

/** Autogenerated input type of UpdateRetirementPlanParticipantLog */
export type UpdateRetirementPlanParticipantLogInput = {
  /** Follow-up action item */
  readonly actionItem?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Log entry ID */
  readonly id: Scalars['ID']['input'];
  /** Interaction type */
  readonly interactionType?: InputMaybe<Scalars['String']['input']>;
  /** Advisor profile ID of the team member logging this (null to clear) */
  readonly loggedById?: InputMaybe<Scalars['ID']['input']>;
  /** Date of the interaction */
  readonly loggedOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Free-text notes */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** Participant email address */
  readonly participantEmail?: InputMaybe<Scalars['String']['input']>;
  /** Participant full name */
  readonly participantName?: InputMaybe<Scalars['String']['input']>;
  /** Participant phone number */
  readonly participantPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanParticipantLog. */
export type UpdateRetirementPlanParticipantLogPayload = {
  readonly __typename?: 'UpdateRetirementPlanParticipantLogPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated log entry */
  readonly retirementPlanParticipantLog?: Maybe<RetirementPlanParticipantLog>;
};

/** Autogenerated return type of UpdateRetirementPlan. */
export type UpdateRetirementPlanPayload = {
  readonly __typename?: 'UpdateRetirementPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated retirement plan */
  readonly retirementPlan?: Maybe<RetirementPlan>;
};

/** Autogenerated input type of UpdateRetirementPlanProject */
export type UpdateRetirementPlanProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Project description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Project ID */
  readonly id: Scalars['ID']['input'];
  /** Project name */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Project start date */
  readonly startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Project status */
  readonly status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanProject. */
export type UpdateRetirementPlanProjectPayload = {
  readonly __typename?: 'UpdateRetirementPlanProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated project */
  readonly retirementPlanProject?: Maybe<RetirementPlanProject>;
};

/** Autogenerated input type of UpdateRetirementPlanProjectRow */
export type UpdateRetirementPlanProjectRowInput = {
  /** Advisor from the plan organization assigned to this row (null to clear) */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When this row is due (null to clear) */
  readonly dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Row ID */
  readonly id: Scalars['ID']['input'];
  /** Row name */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Free-text notes (null to clear) */
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  /** Zero-based ordering of this row within the project */
  readonly position?: InputMaybe<Scalars['Int']['input']>;
  /** The organization responsible for this row (null to clear) */
  readonly responsibleOrg?: InputMaybe<Scalars['String']['input']>;
  /** Status: todo | in_progress | done | cancelled */
  readonly status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRetirementPlanProjectRow. */
export type UpdateRetirementPlanProjectRowPayload = {
  readonly __typename?: 'UpdateRetirementPlanProjectRowPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated row */
  readonly retirementPlanProjectRow?: Maybe<RetirementPlanProjectRow>;
};

/** Autogenerated input type of UpdateRetirementPlanProjectTemplateFromProject */
export type UpdateRetirementPlanProjectTemplateFromProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The project whose source template should be updated */
  readonly retirementPlanProjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateRetirementPlanProjectTemplateFromProject. */
export type UpdateRetirementPlanProjectTemplateFromProjectPayload = {
  readonly __typename?: 'UpdateRetirementPlanProjectTemplateFromProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated template */
  readonly retirementPlanProjectTemplate?: Maybe<RetirementPlanProjectTemplate>;
};

/** Autogenerated input type of UpdateRetirementPlanProjectTemplate */
export type UpdateRetirementPlanProjectTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Template description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The template to update */
  readonly id: Scalars['ID']['input'];
  /** Template name */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** Ordered steps. When provided, replaces the existing steps. */
  readonly steps?: InputMaybe<ReadonlyArray<RetirementPlanProjectTemplateStepInput>>;
};

/** Autogenerated return type of UpdateRetirementPlanProjectTemplate. */
export type UpdateRetirementPlanProjectTemplatePayload = {
  readonly __typename?: 'UpdateRetirementPlanProjectTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated template */
  readonly retirementPlanProjectTemplate?: Maybe<RetirementPlanProjectTemplate>;
};

/** Autogenerated input type of UpdateRmd */
export type UpdateRmdInput = {
  readonly accountYearEndValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  readonly additionalDistributions?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRmd. */
export type UpdateRmdPayload = {
  readonly __typename?: 'UpdateRmdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly rmd: Rmd;
};

/** Autogenerated input type of UpdateServiceCalendarItem */
export type UpdateServiceCalendarItemInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly status: ServiceCalendarItemStatus;
};

/** Autogenerated return type of UpdateServiceCalendarItem. */
export type UpdateServiceCalendarItemPayload = {
  readonly __typename?: 'UpdateServiceCalendarItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly serviceCalendarItem: ServiceCalendarItem;
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateServiceCalendarMeeting */
export type UpdateServiceCalendarMeetingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly status: ServiceCalendarMeetingStatus;
};

/** Autogenerated return type of UpdateServiceCalendarMeeting. */
export type UpdateServiceCalendarMeetingPayload = {
  readonly __typename?: 'UpdateServiceCalendarMeetingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly serviceCalendarMeeting: ServiceCalendarMeeting;
};

/** Autogenerated input type of UpdateServiceCalendarSettingTemplates */
export type UpdateServiceCalendarSettingTemplatesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly serviceCalendarSettingTemplateInputs: ReadonlyArray<ServiceCalendarSettingTemplateInput>;
};

/** Autogenerated return type of UpdateServiceCalendarSettingTemplates. */
export type UpdateServiceCalendarSettingTemplatesPayload = {
  readonly __typename?: 'UpdateServiceCalendarSettingTemplatesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly serviceCalendarSettingTemplates: ReadonlyArray<ServiceCalendarSettingTemplate>;
};

/** Autogenerated input type of UpdateServiceCalendarSettings */
export type UpdateServiceCalendarSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly serviceCalendarSettingInputs: ReadonlyArray<ServiceCalendarSettingTemplateInput>;
};

/** Autogenerated return type of UpdateServiceCalendarSettings. */
export type UpdateServiceCalendarSettingsPayload = {
  readonly __typename?: 'UpdateServiceCalendarSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly serviceCalendarSettings: ReadonlyArray<ServiceCalendarSetting>;
};

/** Creating or updating settings for a service on a client household Service Calendar based on Advisor settings. */
export type UpdateServiceCalendarWithAdvisorSettingsInput = {
  readonly active: Scalars['Boolean']['input'];
  readonly byEndOfYear?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly q1?: InputMaybe<Scalars['Boolean']['input']>;
  readonly q2?: InputMaybe<Scalars['Boolean']['input']>;
  readonly q3?: InputMaybe<Scalars['Boolean']['input']>;
  readonly q4?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of UpdateServiceCatalogItemGroup */
export type UpdateServiceCatalogItemGroupInput = {
  /**
   * Editors of a team service, replacing the existing set. Omitted leaves the
   * existing editors untouched; an empty list means everyone in the owning scope can edit.
   */
  readonly acl?: InputMaybe<ReadonlyArray<ServiceCatalogItemGroupAclInput>>;
  /** Attributes */
  readonly attributes: ServiceCatalogItemGroupAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The pendingChangesUpdatedAt this editor loaded. Send it to be told when
   * someone else changed the service first; null means "I expect nothing
   * unpublished". Omitted skips the check.
   */
  readonly expectedPendingChangesUpdatedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Id */
  readonly id: Scalars['ID']['input'];
  /** Who can see and run this service. Omitted leaves it unchanged. */
  readonly visibility?: InputMaybe<ServiceCatalogItemGroupVisibility>;
};

/** Autogenerated return type of UpdateServiceCatalogItemGroup. */
export type UpdateServiceCatalogItemGroupPayload = {
  readonly __typename?: 'UpdateServiceCatalogItemGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Service catalog item group */
  readonly serviceCatalogItemGroup?: Maybe<ServiceCatalogItemGroup>;
};

/** Autogenerated input type of UpdateServiceCatalogItemHouseholdOverride */
export type UpdateServiceCatalogItemHouseholdOverrideInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  readonly id: Scalars['ID']['input'];
  /** Is skipped */
  readonly isSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Override date */
  readonly overrideDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Override dtstart */
  readonly overrideDtstart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Override email body */
  readonly overrideEmailBody?: InputMaybe<Scalars['String']['input']>;
  /** Override email subject */
  readonly overrideEmailSubject?: InputMaybe<Scalars['String']['input']>;
  /** Override rrule */
  readonly overrideRrule?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateServiceCatalogItemHouseholdOverride. */
export type UpdateServiceCatalogItemHouseholdOverridePayload = {
  readonly __typename?: 'UpdateServiceCatalogItemHouseholdOverridePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Service catalog item household override */
  readonly serviceCatalogItemHouseholdOverride?: Maybe<ServiceCatalogItemHouseholdOverride>;
};

/** Autogenerated input type of UpdateServiceCatalogItem */
export type UpdateServiceCatalogItemInput = {
  /** Attributes to merge */
  readonly attributes: ServiceCatalogItemAttributesInput;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Item ID */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateServiceCatalogItem. */
export type UpdateServiceCatalogItemPayload = {
  readonly __typename?: 'UpdateServiceCatalogItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated item */
  readonly serviceCatalogItem?: Maybe<ServiceCatalogItem>;
};

/** Autogenerated input type of UpdateSimpleTask */
export type UpdateSimpleTaskInput = {
  /**
   * When the task is a recurring occurrence and due_at is being changed, also
   * shift due_at on the template and every open future occurrence by the same
   * delta. Ignored when the task is not part of an active recurrence or due_at did not change.
   */
  readonly applyToFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Salesforce task ID */
  readonly salesforceTaskId: Scalars['String']['input'];
  /** The fields to update */
  readonly taskInput: UpdateTaskFields;
};

/** Autogenerated return type of UpdateSimpleTask. */
export type UpdateSimpleTaskPayload = {
  readonly __typename?: 'UpdateSimpleTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any errors that occurred */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the update was successful */
  readonly success: Scalars['Boolean']['output'];
  /** The updated task */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of UpdateStagedAccountDestination */
export type UpdateStagedAccountDestinationInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Custodian this account is headed to. */
  readonly destination: EciDestinationCustodian;
  /** The staged account to route. */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateStagedAccountDestination. */
export type UpdateStagedAccountDestinationPayload = {
  readonly __typename?: 'UpdateStagedAccountDestinationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated staged account. */
  readonly stagedAccount: AdvisorOnboardingStagedAccount;
};

/** Autogenerated input type of UpdateStagedClient */
export type UpdateStagedClientInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Client date of birth. */
  readonly dob?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Client email. */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** Client first name. */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** The staged client to edit. */
  readonly id: Scalars['ID']['input'];
  /** Client last name. */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** Client phone. */
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  /** Client SSN (write-only; stored encrypted). */
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateStagedClient. */
export type UpdateStagedClientPayload = {
  readonly __typename?: 'UpdateStagedClientPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated staged client. */
  readonly stagedClient: AdvisorOnboardingStagedClient;
};

/** Autogenerated input type of UpdateStagedHousehold */
export type UpdateStagedHouseholdInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Estimated assets under management. */
  readonly estAum?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Stable dedup key from the source book. */
  readonly externalKey?: InputMaybe<Scalars['String']['input']>;
  /** Household name from the transition spreadsheet. */
  readonly householdName?: InputMaybe<Scalars['String']['input']>;
  /** The staged household to edit. */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateStagedHousehold. */
export type UpdateStagedHouseholdPayload = {
  readonly __typename?: 'UpdateStagedHouseholdPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated staged household. */
  readonly stagedHousehold: AdvisorOnboardingStagedHousehold;
};

/**
 * Fields that can be updated on a sub-task. All optional for partial updates;
 * passing explicit null clears clearable fields (assignee, due date, description).
 */
export type UpdateSubtaskFields = {
  /** New assignee user ID. Pass null to clear. */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** New description. Pass null to clear. */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** New due date. Pass null to clear. */
  readonly dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Calendar days before the parent task's due date. Pass null to clear and fall back to absolute due_at. */
  readonly dueDateOffsetDays?: InputMaybe<Scalars['Int']['input']>;
  /** New name. */
  readonly name?: InputMaybe<Scalars['String']['input']>;
  /** New status. */
  readonly status?: InputMaybe<SubtaskStatus>;
};

/** Autogenerated input type of UpdateSubtask */
export type UpdateSubtaskInput = {
  /**
   * When the parent is a recurring task, also apply these field changes (excluding
   * status) to the template and every future occurrence.
   */
  readonly applyToFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The fields to update. Omitted keys are unchanged; explicit null clears clearable keys. */
  readonly fields: UpdateSubtaskFields;
  /** The Savvy ID of the sub-task to update. */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSubtask. */
export type UpdateSubtaskPayload = {
  readonly __typename?: 'UpdateSubtaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated sub-task. */
  readonly subtask?: Maybe<Subtask>;
  /**
   * The parent task. Returned so clients can refresh derived counts. Its status
   * may be reverted to in_progress when the subtask moves away from done.
   */
  readonly task?: Maybe<Task>;
};

/** Autogenerated input type of UpdateTaskComment */
export type UpdateTaskCommentInput = {
  /** Update the Box file IDs attached to this comment */
  readonly attachments?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly content: Scalars['String']['input'];
  readonly mentionedUserIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly taskActivityId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTaskComment. */
export type UpdateTaskCommentPayload = {
  readonly __typename?: 'UpdateTaskCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment: TaskActivity;
};

/** Fields that can be updated on a simple task (all fields optional for partial updates) */
export type UpdateTaskFields = {
  /** The account transfer status (for onboarding tasks) */
  readonly accountTransferStatus?: InputMaybe<Scalars['String']['input']>;
  /** The user that the task is assigned to */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the box folder that the task is associated with */
  readonly boxFolderId?: InputMaybe<Scalars['String']['input']>;
  /** Who receives the task-completed email; household-wide when unset. Pass null to clear. */
  readonly completedEmailRecipients?: InputMaybe<TaskCompletedEmailRecipients>;
  /** The custodian name (for onboarding tasks) */
  readonly custodian?: InputMaybe<Scalars['String']['input']>;
  /** The description of the task */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** The DocuSign envelope ID (for onboarding tasks) */
  readonly docusignEnvelopeId?: InputMaybe<Scalars['String']['input']>;
  /** When the task is due */
  readonly dueAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** The investment model recommendation (for investment proposal presentations) */
  readonly investmentModelRecommendation?: InputMaybe<Scalars['String']['input']>;
  /** Semicolon-separated list of presentation slides (for client review presentations) */
  readonly presentationSlides?: InputMaybe<Scalars['String']['input']>;
  /** The previous wealth management firm (for onboarding tasks) */
  readonly previousWmFirm?: InputMaybe<Scalars['String']['input']>;
  /** The priority level of the task */
  readonly priority?: InputMaybe<TaskPriority>;
  /** The request type (for investment proposal presentations) */
  readonly requestType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether to email the client when the task completes; falls back to the
   * organization default when unset. Pass null to clear.
   */
  readonly sendEmailWhenCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Box file ID for signable document (for onboarding tasks) */
  readonly signableDocumentBoxFileId?: InputMaybe<Scalars['String']['input']>;
  /** The status of the task */
  readonly status?: InputMaybe<TaskStatus>;
  /** In Progress sub-status for Client Services and Investment Ops tasks. Pass null to clear. */
  readonly subStatus?: InputMaybe<TaskSubStatus>;
  /** The title of the task */
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateTask */
export type UpdateTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly maybeDocusignSigned?: InputMaybe<Scalars['Boolean']['input']>;
  readonly status?: InputMaybe<TaskStatus>;
  readonly subStatus?: InputMaybe<TaskSubStatus>;
};

/** Autogenerated input type of UpdateTaskNotificationRoute */
export type UpdateTaskNotificationRouteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The destination: inbox, activity, or off. */
  readonly destination: Scalars['String']['input'];
  /** The task event: tasks_due, comments, or status. */
  readonly event: Scalars['String']['input'];
  /** The viewer relationship: assignee, creator, primary, or all_other. */
  readonly relationship: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTaskNotificationRoute. */
export type UpdateTaskNotificationRoutePayload = {
  readonly __typename?: 'UpdateTaskNotificationRoutePayload';
  /** Effective task routing cells after the update. */
  readonly cells: ReadonlyArray<NotificationTaskRoutingCell>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the update succeeded. */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of UpdateTask. */
export type UpdateTaskPayload = {
  readonly __typename?: 'UpdateTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task: Task;
};

/** Autogenerated input type of UpdateTaskSuggestion */
export type UpdateTaskSuggestionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly status?: InputMaybe<TaskSuggestionStatus>;
  readonly taskId?: InputMaybe<Scalars['ID']['input']>;
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateTaskSuggestion. */
export type UpdateTaskSuggestionPayload = {
  readonly __typename?: 'UpdateTaskSuggestionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly taskSuggestion: TaskSuggestion;
};

/** Autogenerated input type of UpdateTaskWorkItem */
export type UpdateTaskWorkItemInput = {
  /**
   * When this is a recurring task, also apply name/instructions/priority/assignee
   * (not due date) to the template and every future occurrence.
   */
  readonly applyToFuture?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user that the task is assigned to — pass null to unassign */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** Full intended set of client profile IDs. nil preserves existing; [] removes all */
  readonly clientIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When the task is due — pass null to clear */
  readonly dueDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Full intended set of household IDs. nil preserves existing; [] removes all */
  readonly householdIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** The ID of the task to update */
  readonly id: Scalars['ID']['input'];
  /** Additional instructions for the task — pass null to clear */
  readonly instructions?: InputMaybe<Scalars['String']['input']>;
  /** The name of the task */
  readonly name: Scalars['String']['input'];
  /** Task priority level — pass null to clear */
  readonly priority?: InputMaybe<TaskPriority>;
};

/** Autogenerated return type of UpdateTaskWorkItem. */
export type UpdateTaskWorkItemPayload = {
  readonly __typename?: 'UpdateTaskWorkItemPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors resolvable by the user */
  readonly errors?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Whether the operation was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateTaskWorkflowTemplate */
export type UpdateTaskWorkflowTemplateInput = {
  /** Editors for a team workflow, replacing the existing set. Empty means everyone in the group can edit. */
  readonly acl?: InputMaybe<ReadonlyArray<WorkflowTemplateAclInput>>;
  /** Advisor to assign the workflow to. Must be an advisor in your firm. */
  readonly assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Workflow description */
  readonly description?: InputMaybe<Scalars['String']['input']>;
  /** Workflow name */
  readonly name: Scalars['String']['input'];
  /** Reassign the workflow to a different advisor owner. Must be an advisor in your firm. */
  readonly ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Schedule anchor: launch_date or due_date */
  readonly schedule: TaskWorkflowTemplateSchedule;
  /** Subtasks. When provided, replaces the existing subtasks. */
  readonly subtasks?: InputMaybe<ReadonlyArray<SubtaskCreationInput>>;
  /** The workflow task to update */
  readonly taskId: Scalars['ID']['input'];
  /** Visibility: private or firm */
  readonly visibility: TaskWorkflowTemplateVisibility;
};

/** Autogenerated return type of UpdateTaskWorkflowTemplate. */
export type UpdateTaskWorkflowTemplatePayload = {
  readonly __typename?: 'UpdateTaskWorkflowTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated workflow */
  readonly taskWorkflowTemplate?: Maybe<TaskWorkflowTemplate>;
};

/** Autogenerated input type of UpdateTaxEnrollment */
export type UpdateTaxEnrollmentInput = {
  /** Client who will pay the price */
  readonly billableClientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Enum type about enrollment */
  readonly enrollmentType?: InputMaybe<TaxEnrollmentTypeName>;
  /** ID of Tax Enrollment */
  readonly id: Scalars['ID']['input'];
  /** Client who will be filed jointly, will not be charged */
  readonly nonBillableClientId?: InputMaybe<Scalars['ID']['input']>;
  /** Price to charge billable client */
  readonly price?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** Tax year for this enrollment */
  readonly taxYear?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateTaxEnrollment. */
export type UpdateTaxEnrollmentPayload = {
  readonly __typename?: 'UpdateTaxEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** errors */
  readonly error?: Maybe<Scalars['String']['output']>;
  /** success boolean */
  readonly success: Scalars['Boolean']['output'];
  /** object */
  readonly taxEnrollment?: Maybe<TaxEnrollment>;
};

/** Autogenerated input type of UpdateUserContact */
export type UpdateUserContactInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth of the contact */
  readonly dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Email of the contact */
  readonly email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the contact */
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the contact */
  readonly id: Scalars['ID']['input'];
  /** Whether the contact is a beneficiary */
  readonly isBeneficiary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Last name of the contact */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the contact */
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Relation of the contact */
  readonly relation?: InputMaybe<BeneficiaryRelationship>;
  /** SSN of the contact */
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user */
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserContact. */
export type UpdateUserContactPayload = {
  readonly __typename?: 'UpdateUserContactPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contact?: Maybe<Contact>;
};

/** Autogenerated input type of UpdateUserDataInAprilFiling */
export type UpdateUserDataInAprilFilingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Tax enrollment ID */
  readonly taxEnrollmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateUserDataInAprilFiling. */
export type UpdateUserDataInAprilFilingPayload = {
  readonly __typename?: 'UpdateUserDataInAprilFilingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Errors */
  readonly errors?: Maybe<Scalars['String']['output']>;
  /** Success or not */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The caller's existing password. Required to change a password from a session, but not from an invite or reset token. */
  readonly currentPassword?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['ID']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly password?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly preferredName?: InputMaybe<Scalars['String']['input']>;
  readonly profilePicUrl?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone id; when present, persists as the user's configured zone. */
  readonly timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  readonly __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user: User;
};

/** Autogenerated input type of UpdateUserSecurityAttribute */
export type UpdateUserSecurityAttributeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly currentPassword: Scalars['String']['input'];
  readonly otp?: InputMaybe<Scalars['String']['input']>;
  readonly otpRequiredForLogin?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateUserSecurityAttribute. */
export type UpdateUserSecurityAttributePayload = {
  readonly __typename?: 'UpdateUserSecurityAttributePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly otpError: Scalars['String']['output'];
  readonly user: User;
};

/** Autogenerated input type of UploadEciFormTemplate */
export type UploadEciFormTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Base64-encoded candidate PDF */
  readonly contentBase64: Scalars['String']['input'];
  /** DocumentTemplate value, e.g. eci_msa */
  readonly templateKey: Scalars['String']['input'];
};

/** Autogenerated return type of UploadEciFormTemplate. */
export type UploadEciFormTemplatePayload = {
  readonly __typename?: 'UploadEciFormTemplatePayload';
  /** Whether the field contract refused the upload */
  readonly blocked: Scalars['Boolean']['output'];
  /** Box version number after a successful upload */
  readonly boxVersion?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Why the upload was refused, if it was */
  readonly findings: ReadonlyArray<TemplateValidationFinding>;
  /** Whether a new version was written to Box */
  readonly uploaded: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UploadFileToBox */
export type UploadFileToBoxInput = {
  /** Type of Box folder */
  readonly boxFolderType: BoxFolderTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the document to upload */
  readonly documentName: Scalars['String']['input'];
  /** URL of the document to upload */
  readonly documentUrl: Scalars['String']['input'];
  /** ID of household */
  readonly householdId: Scalars['ID']['input'];
};

/** Autogenerated input type of UploadLinkedBankAccountImport */
export type UploadLinkedBankAccountImportInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The custodian: schwab or fidelity */
  readonly custodian: Scalars['String']['input'];
  /** Import kind: savvy_wide (default) or advisor */
  readonly docType?: InputMaybe<LinkedBankAccountImportDocType>;
  /** Base64-encoded file contents */
  readonly fileContent: Scalars['String']['input'];
  /** Original file name (used to derive content type) */
  readonly fileName: Scalars['String']['input'];
};

/** Autogenerated return type of UploadLinkedBankAccountImport. */
export type UploadLinkedBankAccountImportPayload = {
  readonly __typename?: 'UploadLinkedBankAccountImportPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** User-facing validation errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** The created import record (poll for diff readiness) */
  readonly linkedBankAccountImport?: Maybe<LinkedBankAccountImport>;
};

/** Result of uploading a file to Box */
export type UploadToBoxResult = {
  readonly __typename?: 'UploadToBoxResult';
  /** The ID of the file in Box */
  readonly boxFileId?: Maybe<Scalars['String']['output']>;
  /** The ID of the document that was uploaded */
  readonly documentId: Scalars['String']['output'];
  /** Error message if the upload failed */
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the upload was successful */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpsertUserSavedViews */
export type UpsertUserSavedViewsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Entries to upsert (value=null deletes the key) */
  readonly savedViews: ReadonlyArray<UserSavedViewInput>;
};

/** Autogenerated return type of UpsertUserSavedViews. */
export type UpsertUserSavedViewsPayload = {
  readonly __typename?: 'UpsertUserSavedViewsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation succeeded */
  readonly success: Scalars['Boolean']['output'];
  /** Current rows for touched keys after upsert/delete */
  readonly userSavedViews: ReadonlyArray<UserSavedView>;
};

export type User = {
  readonly __typename?: 'User';
  /** The household the user currently has selected (falls back to the highest-priority member household) */
  readonly activeHousehold?: Maybe<Household>;
  readonly addresses: ReadonlyArray<Address>;
  /** Advisor-tier level (assistant/advisor/admin) derived from role + can_edit_organization; null for non-advisor-tier users. */
  readonly advisorTierLevel?: Maybe<AdvisorTierLevel>;
  /** Feature flag for opt-in the AI experience. Cannot be handled with LaunchDarkly */
  readonly aiExperienceOptIn: Scalars['Boolean']['output'];
  /** @deprecated This field has been moved to client.rb */
  readonly assignedCampaigns: ReadonlyArray<AssignedCampaign>;
  /** Client stage of user to become fully onboarded */
  readonly clientStage?: Maybe<ClientStage>;
  /** Confirmation status of user for email confirmation */
  readonly confirmationStatus: UserConfirmationStatus;
  /** User creation timestamp */
  readonly createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly fullName: Scalars['String']['output'];
  /**
   * The household associated with this user. Pass id to scope to a specific
   * household the user is a member of; falls back to the ClientProfile-derived
   * household otherwise.
   */
  readonly household?: Maybe<Household>;
  readonly id: Scalars['ID']['output'];
  readonly isPrimaryClient: Scalars['Boolean']['output'];
  /** Footprint kyc status */
  readonly kycStatus: FootprintStatus;
  readonly lastName: Scalars['String']['output'];
  /** Timestamp of the user's last sign in */
  readonly lastSignInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  readonly mailgunMessages: ReadonlyArray<MailgunMessage>;
  /** Households this user is a member of via HouseholdMembership */
  readonly memberHouseholds: ReadonlyArray<Household>;
  readonly middleName?: Maybe<Scalars['String']['output']>;
  readonly otpRequiredForLogin?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This field is only used for mobile 1.1 launch and will be removed soon. */
  readonly personalPortfolioId?: Maybe<Scalars['ID']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly preferredName?: Maybe<Scalars['String']['output']>;
  readonly primaryAddress?: Maybe<Address>;
  /**
   * The email of this client's primary (household) advisor; null for non-clients.
   * Powers advisor-scoped LaunchDarkly targeting.
   */
  readonly primaryAdvisorEmail?: Maybe<Scalars['String']['output']>;
  readonly profileId: Scalars['ID']['output'];
  readonly profilePicUrl?: Maybe<Scalars['String']['output']>;
  readonly profileType: UserProfile;
  /** User roles, backend deals with lowercase, GQL deals with UPCASED */
  readonly role: UserRole;
  /** Salesforce contact ID (only present for clients) */
  readonly salesforceContactId?: Maybe<Scalars['String']['output']>;
  /** Salesforce user ID (only present for advisors) */
  readonly salesforceUserId?: Maybe<Scalars['String']['output']>;
  readonly secondaryEmails: ReadonlyArray<SecondaryEmail>;
  readonly secondaryPhones: ReadonlyArray<SecondaryPhone>;
  readonly status: UserStatus;
  /**
   * Configured IANA timezone; null until set via the account timezone picker. Null
   * = unset; reads fall back to Eastern via User#effective_timezone.
   */
  readonly timezone?: Maybe<Scalars['String']['output']>;
};


export type UserHouseholdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export const UserConfirmationStatus = {
  /** active user */
  Active: 'ACTIVE',
  /** user still needs to confirm their email address with savvy */
  PendingEmailConfirmation: 'PENDING_EMAIL_CONFIRMATION'
} as const;

export type UserConfirmationStatus = typeof UserConfirmationStatus[keyof typeof UserConfirmationStatus];
export type UserInteraction = {
  /** The name of the item that was clicked or touched - e.g. "create_prospect_button" */
  readonly elementName: Scalars['String']['input'];
  /** The HTML element that was clicked or touched - e.g. "div" */
  readonly htmlElement: Scalars['String']['input'];
  /** The type of interaction that occurred - e.g. "click" */
  readonly interactionType: Scalars['String']['input'];
  readonly isDemoHousehold?: InputMaybe<Scalars['Boolean']['input']>;
  readonly pageName: Scalars['String']['input'];
  /** The name of the parent element that the interaction occurred on - e.g. "create_prospect_dialog" */
  readonly parentElementName?: InputMaybe<Scalars['String']['input']>;
  /** The type of the parent element that the interaction occurred on - e.g. "dialog" */
  readonly parentElementType?: InputMaybe<Scalars['String']['input']>;
  readonly route: Scalars['String']['input'];
  /**
   * Client that emitted the event — "mobile" or "web". Segments events by platform
   * in Mixpanel. Optional; pre-existing web callers omit it.
   */
  readonly source?: InputMaybe<Scalars['String']['input']>;
  readonly urlQueryParams: Scalars['JSON']['input'];
};

/** KYC readiness status and computed errors for a user */
export type UserKycStatus = {
  readonly __typename?: 'UserKycStatus';
  /** Fields present but with bad data */
  readonly invalidFields: ReadonlyArray<KycField>;
  /** Required fields that are blank */
  readonly missingFields: ReadonlyArray<KycField>;
  /** ready or not_ready */
  readonly readinessStatus: Scalars['String']['output'];
};

/** Minimal user info returned to advisors for the Add Household Member lookup — only exposes fields needed to confirm identity. */
export type UserLookupResult = {
  readonly __typename?: 'UserLookupResult';
  /**
   * Whether the current advisor can add this user to a household they manage.
   * Returns false when the user is a client of another advisor outside the current
   * advisor's groups — the Add Household Member dialog uses this to render an
   * "advised by another advisor" message instead of proceeding.
   */
  readonly accessibleByCurrentAdvisor: Scalars['Boolean']['output'];
  /** The user's email address. */
  readonly email: Scalars['String']['output'];
  /** The user's first name. */
  readonly firstName: Scalars['String']['output'];
  /** The user's full name. */
  readonly fullName: Scalars['String']['output'];
  /** The user ID. */
  readonly id: Scalars['ID']['output'];
  /** The user's last name. */
  readonly lastName: Scalars['String']['output'];
  /**
   * Names of households this user is already a member of, scoped to the current
   * advisor's organization. Deliberately just names, not full Household objects —
   * this type stays minimal. Scoping by organization (rather than trusting
   * accessible_by_current_advisor) matters because that check authorizes writing
   * the user record, not reading every household they belong to — a user can be a
   * beneficiary or trustee of a household an unrelated advisor manages.
   */
  readonly memberHouseholdNames: ReadonlyArray<Scalars['String']['output']>;
};

export const UserProfile = {
  /** Savvy financial advisor */
  Advisor: 'ADVISOR',
  /** Savvy client */
  Client: 'CLIENT'
} as const;

export type UserProfile = typeof UserProfile[keyof typeof UserProfile];
/** User role enum, expected input and output are UPPERCASE */
export const UserRole = {
  Admin: 'ADMIN',
  AdminCsa: 'ADMIN_CSA',
  Advisor: 'ADVISOR',
  Assistant: 'ASSISTANT',
  Client: 'CLIENT',
  Csa: 'CSA',
  NonAdvisoryUser: 'NON_ADVISORY_USER',
  ReadOnlyAdmin: 'READ_ONLY_ADMIN'
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];
export type UserSavedView = {
  readonly __typename?: 'UserSavedView';
  /** Saved view row id */
  readonly id: Scalars['ID']['output'];
  /** Storage key name */
  readonly key: Scalars['String']['output'];
  /** Last write timestamp */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Stored JSON payload */
  readonly value?: Maybe<Scalars['JSON']['output']>;
};

export type UserSavedViewInput = {
  /** Storage key to upsert */
  readonly key: Scalars['String']['input'];
  /** JSON payload to persist; null deletes the key */
  readonly value?: InputMaybe<Scalars['JSON']['input']>;
};

export const UserStatus = {
  Active: 'active',
  Deleted: 'deleted',
  Invited: 'invited',
  Prospected: 'prospected'
} as const;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];
/** Autogenerated input type of ValidateInvestmentProposalTickers */
export type ValidateInvestmentProposalTickersInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Tickers to validate. Case-insensitive; trimmed and uppercased server-side. */
  readonly tickers: ReadonlyArray<Scalars['String']['input']>;
};

/** Autogenerated return type of ValidateInvestmentProposalTickers. */
export type ValidateInvestmentProposalTickersPayload = {
  readonly __typename?: 'ValidateInvestmentProposalTickersPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Input tickers Orion could not price at all. Normalized (uppercase, trimmed) from the request. */
  readonly invalidTickers: ReadonlyArray<Scalars['String']['output']>;
  /** Canonical form Orion returned for each valid input ticker (e.g. BRK-B -> BRK/B). */
  readonly validTickers: ReadonlyArray<Scalars['String']['output']>;
};

/** Monetary value. */
export type Value = {
  readonly __typename?: 'Value';
  /** The numerical amount of monetary value. */
  readonly amount: Scalars['BigDecimal']['output'];
  /** ISO currency codes and unofficial currency codes. */
  readonly currencyCode: Scalars['String']['output'];
};

/** One row of the Portfolio Value Summary table — a single reporting period. */
export type ValueSummaryRow = {
  readonly __typename?: 'ValueSummaryRow';
  /** Market value at the start of the period, in USD; null when data is unavailable. */
  readonly beginningMarketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive end date of this period as resolved against the snapshot. */
  readonly endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Market value at the end of the period, in USD; null when data is unavailable. */
  readonly endingMarketValue?: Maybe<Scalars['BigDecimal']['output']>;
  /** Net contributions over the period (deposits minus withdrawals minus fees), in USD; null when data is unavailable. */
  readonly netAdditions?: Maybe<Scalars['BigDecimal']['output']>;
  /**
   * Investment gains over the period (ending market value minus beginning market
   * value minus net additions), in USD; null when data is unavailable.
   */
  readonly netGains?: Maybe<Scalars['BigDecimal']['output']>;
  /** Which reporting period this row covers. */
  readonly period: PeriodEnum;
  /**
   * Annualized time-weighted return over the period as a fraction (0.05 = 5%);
   * null when the period is shorter than a year or data is unavailable.
   */
  readonly returnAnnualized?: Maybe<Scalars['BigDecimal']['output']>;
  /** Cumulative time-weighted return over the period as a fraction (0.05 = 5%); null when data is unavailable. */
  readonly returnCumulative?: Maybe<Scalars['BigDecimal']['output']>;
  /** Inclusive start date of this period as resolved against the snapshot. */
  readonly startDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Autogenerated input type of VerifyEciOnboardingIdentity */
export type VerifyEciOnboardingIdentityInput = {
  /**
   * Write on behalf of this client. Ignored on the MagicLink path; on a session it
   * is only honoured for an advisor who could impersonate them.
   */
  readonly clientId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth (ISO 8601) to verify */
  readonly dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Legal last name to verify */
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  /** SSN to verify; any format */
  readonly ssn?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of VerifyEciOnboardingIdentity. */
export type VerifyEciOnboardingIdentityPayload = {
  readonly __typename?: 'VerifyEciOnboardingIdentityPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Unexpected errors, if any */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Whether the client's identity was verified against the values on file */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of VoiceProfileCommit */
export type VoiceProfileCommitInput = {
  /** AdvisorProfile id whose voice profile to commit. */
  readonly advisorId: Scalars['ID']['input'];
  /** Wizard calibration picks mapped to trait values; folded into the payload. */
  readonly calibrationDerivedTraits?: InputMaybe<ReadonlyArray<CalibrationDerivedTraitInput>>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The advisor's capture-survey replies; folded into payload['examples'] tagged source:'survey'. */
  readonly scenarioReplies?: InputMaybe<ReadonlyArray<ScenarioReplyInput>>;
  /** scan | game | game_plus_scan | seeded */
  readonly source: Scalars['String']['input'];
};

/** Autogenerated return type of VoiceProfileCommit. */
export type VoiceProfileCommitPayload = {
  readonly __typename?: 'VoiceProfileCommitPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The committed voice profile. */
  readonly profile?: Maybe<AdvisorIdentityProfile>;
};

/** Voice DNA payload — what SAI drafts from. Stable contract for the consumer. */
export type VoiceProfilePayload = {
  readonly __typename?: 'VoiceProfilePayload';
  /**
   * Deprecated alias of voicePromptFragment.
   * @deprecated Renamed to voicePromptFragment. Falls back to the new field; will be removed after consumers migrate.
   */
  readonly draftPromptFragment?: Maybe<Scalars['String']['output']>;
  /** Number of outbound emails contributing to the staged re-run read. */
  readonly draftSourceMessageCount?: Maybe<Scalars['Int']['output']>;
  /** Status of a staged re-run extraction: extracting | ready | failed. Null when no re-run is staged. */
  readonly draftStatus?: Maybe<Scalars['String']['output']>;
  /** Trait hash from the staged re-run read (same shape and legacy fold as `traits`). Null when no re-run is staged. */
  readonly draftTraits?: Maybe<Scalars['JSON']['output']>;
  /** Curated anonymized example messages used as few-shot for SAI drafting. */
  readonly examples: ReadonlyArray<Scalars['JSON']['output']>;
  /** When extraction completed. */
  readonly extractedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 0.0–1.0 overall confidence the profile is grounded in examples. */
  readonly extractionConfidence?: Maybe<Scalars['Float']['output']>;
  /** Phrases the advisor consistently avoids. */
  readonly neverSay: ReadonlyArray<Scalars['String']['output']>;
  /** Number of outbound emails contributing to this profile. */
  readonly sourceMessageCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Short headline characterization of the voice (e.g., "Warm, direct, plain
   * English"). Null until tagline confidence threshold is met.
   */
  readonly tagline?: Maybe<Scalars['String']['output']>;
  /**
   * Hash of trait_name → VoiceTraitDescriptor. Canonical keys: warmth, jargon,
   * numbers, directness, sign_off. Legacy eight-key payloads (energy, greeting,
   * formality) fold into these five on read.
   */
  readonly traits: Scalars['JSON']['output'];
  /** Pre-built voice prompt fragment SAI drafting splices into its system prompt. Null until commit. */
  readonly voicePromptFragment?: Maybe<Scalars['String']['output']>;
  /**
   * Display-only generated "how SAI drafts in your voice" sample ({ scenario,
   * text, generatedAt }), null until generated. NEVER folded into the prompt
   * fragment — kept out of few-shot drafting.
   */
  readonly voiceSample?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of VoiceProfileRemoveExample */
export type VoiceProfileRemoveExampleInput = {
  /** AdvisorProfile id whose voice profile owns the example. */
  readonly advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Zero-based index into payload.examples */
  readonly exampleIndex: Scalars['Int']['input'];
};

/** Autogenerated return type of VoiceProfileRemoveExample. */
export type VoiceProfileRemoveExamplePayload = {
  readonly __typename?: 'VoiceProfileRemoveExamplePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated voice profile after removing the example. */
  readonly profile?: Maybe<AdvisorIdentityProfile>;
};

/** Autogenerated input type of VoiceProfileRerunCapture */
export type VoiceProfileRerunCaptureInput = {
  /** AdvisorProfile id to re-run voice extraction for. */
  readonly advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of VoiceProfileRerunCapture. */
export type VoiceProfileRerunCapturePayload = {
  readonly __typename?: 'VoiceProfileRerunCapturePayload';
  /** True when an existing run is still in flight; no new job was enqueued. */
  readonly alreadyInFlight: Scalars['Boolean']['output'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Sidekiq jid; null if a run was already in flight. */
  readonly jobId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of VoiceProfileSetSample */
export type VoiceProfileSetSampleInput = {
  /** AdvisorProfile id whose voice profile owns the sample. */
  readonly advisorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Canonical scenario id the sample answers. */
  readonly scenario: Scalars['String']['input'];
  /** The generated sample reply text. Capped server-side. */
  readonly text: Scalars['String']['input'];
};

/** Autogenerated return type of VoiceProfileSetSample. */
export type VoiceProfileSetSamplePayload = {
  readonly __typename?: 'VoiceProfileSetSamplePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated voice profile after caching the sample. */
  readonly profile?: Maybe<AdvisorIdentityProfile>;
};

/** Autogenerated input type of VoidDocusignEnvelope */
export type VoidDocusignEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** DocuSign envelope ID to void */
  readonly envelopeId: Scalars['String']['input'];
  /** Optional reason recorded on the envelope (defaults to a generic Pinetree string) */
  readonly reason?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of VoidDocusignEnvelope. */
export type VoidDocusignEnvelopePayload = {
  readonly __typename?: 'VoidDocusignEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the envelope was voided */
  readonly success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of WealthboxImportPreviewMutation */
export type WealthboxImportPreviewMutationInput = {
  /** Wealthbox personal access token. Validated via /v1/me. Never persisted. */
  readonly accessToken: Scalars['String']['input'];
  /** Advisor whose existing households we suggest matches against. */
  readonly advisorUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of WealthboxImportPreviewMutation. */
export type WealthboxImportPreviewMutationPayload = {
  readonly __typename?: 'WealthboxImportPreviewMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Surfaced errors (auth failure, workspace too large, etc.). */
  readonly errors: ReadonlyArray<Scalars['String']['output']>;
  /** Per-household summary. */
  readonly households: ReadonlyArray<ImportHouseholdSummary>;
  /** Wealthbox Organization contacts that will be skipped. */
  readonly skippedOrganizationCount: Scalars['Int']['output'];
  /** Names of the Wealthbox Organization contacts that will be skipped. */
  readonly skippedOrganizationNames: ReadonlyArray<Scalars['String']['output']>;
  /** Wealthbox Trust contacts that will be skipped (not yet supported). */
  readonly skippedTrustCount: Scalars['Int']['output'];
  /** Display name of the matched Wealthbox user for the selected advisor. Nil if no match found. */
  readonly wealthboxAdvisorName?: Maybe<Scalars['String']['output']>;
  /** Wealthbox user ID of the matched advisor. Passed back to the import submission for worker-side filtering. */
  readonly wealthboxAdvisorUserId?: Maybe<Scalars['Int']['output']>;
  /** Display name of the connected Wealthbox workspace. */
  readonly workspaceName?: Maybe<Scalars['String']['output']>;
};

/** A work item (task, event, or service) */
export type WorkItem = {
  readonly __typename?: 'WorkItem';
  /** When the work item was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The work item ID */
  readonly id: Scalars['ID']['output'];
  /** The task or calendar event represented by this work item */
  readonly item?: Maybe<WorkItemSource>;
  /** The type of the work item */
  readonly itemType: WorkItemTypeName;
  /** When the work item was last updated */
  readonly updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** An edge in a connection. */
export type WorkItemEdge = {
  readonly __typename?: 'WorkItemEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<WorkItem>;
};

/** Union of work item source types (Task, CalendarEvent, MeetingBooking) */
export type WorkItemSource = CalendarEvent | MeetingBooking | Task;

/** The type of a work item */
export const WorkItemTypeName = {
  /** event */
  Event: 'event',
  /** service */
  Service: 'service',
  /** task */
  Task: 'task'
} as const;

export type WorkItemTypeName = typeof WorkItemTypeName[keyof typeof WorkItemTypeName];
/** The connection type for Household. */
export type WorkbenchStatHouseholdConnection = {
  readonly __typename?: 'WorkbenchStatHouseholdConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<WorkbenchStatHouseholdEdge>>>;
  /** A list of nodes. */
  readonly nodes?: Maybe<ReadonlyArray<Maybe<Household>>>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  /** Total number of households in this stat */
  readonly totalCount: Scalars['Int']['output'];
};

/** Edge wrapping a Household with stat-specific detail text */
export type WorkbenchStatHouseholdEdge = {
  readonly __typename?: 'WorkbenchStatHouseholdEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Household>;
  /** Stat-specific detail for this household (e.g. meeting time, task count) */
  readonly statDetail?: Maybe<Scalars['String']['output']>;
};

/** Available stat card keys for the workbench landing page */
export const WorkbenchStatKey = {
  /** Households due for annual review */
  AnnualReviews: 'annualReviews',
  /** Total assets across your book */
  Aum: 'aum',
  /** Scheduled household meetings today */
  Meetings: 'meetings',
  /** Households being onboarded */
  Onboarding: 'onboarding',
  /** Prospect households in your funnel */
  Pipeline: 'pipeline',
  /** Open tasks tied to households */
  Tasks: 'tasks'
} as const;

export type WorkbenchStatKey = typeof WorkbenchStatKey[keyof typeof WorkbenchStatKey];
/** Summary values for all workbench stat cards */
export type WorkbenchStatSummary = {
  readonly __typename?: 'WorkbenchStatSummary';
  /** Number of households with reviews due this quarter */
  readonly annualReviewsCount: Scalars['Int']['output'];
  /** Number of households with overdue reviews */
  readonly annualReviewsOverdue: Scalars['Int']['output'];
  /** Total AUM across all client households */
  readonly aum: Scalars['BigInt']['output'];
  /** Number of households with meetings scheduled today */
  readonly meetingsCount: Scalars['Int']['output'];
  /** Number of client households added in the last 30 days */
  readonly newClientsCount: Scalars['Int']['output'];
  /** Formatted start time of the next meeting today (e.g. "11:00 AM") */
  readonly nextMeetingTime?: Maybe<Scalars['String']['output']>;
  /** Number of households in onboarding stage */
  readonly onboardingCount: Scalars['Int']['output'];
  /** Number of open tasks */
  readonly openTasksCount: Scalars['Int']['output'];
  /** Total estimated AUM across prospects */
  readonly pipelineAum: Scalars['BigInt']['output'];
  /** Number of prospect households */
  readonly pipelineCount: Scalars['Int']['output'];
  /** Number of prospect households added in the last 30 days */
  readonly pipelineNewCount: Scalars['Int']['output'];
  /** Number of tasks due today */
  readonly tasksDueToday: Scalars['Int']['output'];
};

/** Grants a user an action (e.g. edit) on a workflow template. */
export type WorkflowTemplateAclInput = {
  /** The action to grant. */
  readonly action: TaskWorkflowTemplateAclAction;
  /** The user the action is granted to. */
  readonly userId: Scalars['ID']['input'];
};

/** Sort values for the workflows table */
export const WorkflowTemplateSortValues = {
  /** IN_PROGRESS */
  InProgress: 'IN_PROGRESS',
  /** LAST_USED */
  LastUsed: 'LAST_USED',
  /** NAME */
  Name: 'NAME',
  /** OWNER */
  Owner: 'OWNER',
  /** SCHEDULE */
  Schedule: 'SCHEDULE',
  /** SUBTASKS_COUNT */
  SubtasksCount: 'SUBTASKS_COUNT',
  /** UPDATED_AT */
  UpdatedAt: 'UPDATED_AT',
  /** VISIBILITY */
  Visibility: 'VISIBILITY'
} as const;

export type WorkflowTemplateSortValues = typeof WorkflowTemplateSortValues[keyof typeof WorkflowTemplateSortValues];
export type WorkflowTemplatesFilterInput = {
  /** Filter by the workflow owner user id */
  readonly ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Search query for workflow names */
  readonly query?: InputMaybe<Scalars['String']['input']>;
  /** Filter by schedule type */
  readonly schedule?: InputMaybe<TaskWorkflowTemplateSchedule>;
  /** Filter by visibility. Private workflows are always restricted to the current advisor regardless of this filter. */
  readonly visibility?: InputMaybe<TaskWorkflowTemplateVisibility>;
};

/** Type definition for a Wrike marketing request */
export type WrikeMarketingRequest = {
  readonly __typename?: 'WrikeMarketingRequest';
  /** The advisor group label of the marketing request */
  readonly advisorGroupLabel?: Maybe<Scalars['String']['output']>;
  /** The advisor label of the marketing request */
  readonly advisorLabel?: Maybe<Scalars['String']['output']>;
  /** The first name of the assignee of the marketing request */
  readonly assigneeFirstName?: Maybe<Scalars['String']['output']>;
  /** The date and time the marketing request was created */
  readonly createdAt: Scalars['ISO8601DateTime']['output'];
  /** The date and time the marketing request is due */
  readonly dueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The issue ID of the marketing request */
  readonly issueId: Scalars['ID']['output'];
  /** The status of the marketing request */
  readonly status: Scalars['String']['output'];
  /** The title of the marketing request */
  readonly title: Scalars['String']['output'];
};

/** The response type for the Wrike marketing requests resolver */
export type WrikeMarketingRequests = {
  readonly __typename?: 'WrikeMarketingRequests';
  /** The marketing requests accessible to the current user */
  readonly requests: ReadonlyArray<WrikeMarketingRequest>;
  /** Whether the current user is in an advisor group */
  readonly userIsInAdvisorGroup: Scalars['Boolean']['output'];
};

/** Transcript of a Zoom meeting recording. */
export type ZoomMeetingTranscript = {
  readonly __typename?: 'ZoomMeetingTranscript';
  /** Recorded length in whole minutes, rounded up; null when either recording timestamp is missing. */
  readonly durationMinutes?: Maybe<Scalars['Int']['output']>;
  /** A bounded plain-text excerpt from the start of the transcript, skipping notetaker-bot lines. */
  readonly excerpt?: Maybe<Scalars['String']['output']>;
  /** When the transcript was fetched from Zoom. */
  readonly fetchedAt: Scalars['ISO8601DateTime']['output'];
  /** Name of the household this transcript belongs to. */
  readonly householdName?: Maybe<Scalars['String']['output']>;
  /** The Savvy ID of the transcript record. */
  readonly id: Scalars['ID']['output'];
  /** Transcript lines as { name, content }. */
  readonly lines?: Maybe<ReadonlyArray<ZoomMeetingTranscriptLine>>;
  /** The Zoom meeting topic. */
  readonly meetingTopic?: Maybe<Scalars['String']['output']>;
  /** Distinct speaker names in the order they first speak, excluding notetaker bots. */
  readonly participantNames: ReadonlyArray<Scalars['String']['output']>;
  /** When the recording started, falling back to when the row was created. */
  readonly startedAt: Scalars['ISO8601DateTime']['output'];
  /** Transcript ingestion status: available or unavailable. */
  readonly status: Scalars['String']['output'];
};

/** Transcript line of a Zoom meeting recording. */
export type ZoomMeetingTranscriptLine = {
  readonly __typename?: 'ZoomMeetingTranscriptLine';
  /** Content of the speech */
  readonly content?: Maybe<Scalars['String']['output']>;
  /** Name of the speaker */
  readonly name?: Maybe<Scalars['String']['output']>;
};
